
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("duFi2", function(module, exports) {

var $kRG5M = parcelRequire("kRG5M");


var $hgeg8 = parcelRequire("hgeg8");


var $adhil = parcelRequire("adhil");


var $e7tBw = parcelRequire("e7tBw");


var $dus6D = parcelRequire("dus6D");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

function $9c0a7f682ecda261$export$317bc7037b2c3692() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, $9c0a7f682ecda261$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.enter).common, $9c0a7f682ecda261$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, $9c0a7f682ecda261$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.enter).common, $9c0a7f682ecda261$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveUp).common, $9c0a7f682ecda261$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.shiftTab).common, $9c0a7f682ecda261$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.tab).common, $9c0a7f682ecda261$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveLeft).common, $9c0a7f682ecda261$var$gapCursorSelectLeftParentMediaSingle, list);
    return (0, $dus6D.keymap)(list);
}
const $9c0a7f682ecda261$var$createNewParagraphBelowCaption = (state, dispatch)=>{
    const caption = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) return (0, $e7tBw.createNewParagraphBelow)(state, dispatch);
    return false;
};
const $9c0a7f682ecda261$var$getOutOfCaption = (state, dispatch)=>{
    const caption = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        if (dispatch) {
            const tr = state.tr.setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(caption.pos + caption.node.nodeSize)));
            dispatch(tr);
        }
        return true;
    }
    return false;
};
const $9c0a7f682ecda261$var$selectParentMediaSingle = (state, dispatch)=>{
    if ((0, $8m4tT.findParentNodeOfType)(state.schema.nodes.caption)(state.selection)) {
        const mediaSingleParent = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent) {
            if (dispatch) {
                const tr = state.tr.setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(mediaSingleParent.pos)));
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
const $9c0a7f682ecda261$var$gapCursorSelectLeftParentMediaSingle = (state, dispatch)=>{
    const caption = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        const mediaSingleParent = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent && state.selection.empty && state.tr.doc.resolve(state.selection.from).parentOffset === 0) {
            const gapCursorSelection = (0, $adhil.GapCursorSelection).findFrom(state.tr.doc.resolve(mediaSingleParent.pos), 0, false);
            if (gapCursorSelection) {
                if (dispatch) {
                    const tr = state.tr.setSelection(gapCursorSelection);
                    dispatch(tr);
                }
                return true;
            }
        }
    }
    return false;
};



var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");





var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kUXwW = parcelRequire("kUXwW");


var $48Use = parcelRequire("48Use");

class $5e822cf7ac2fe956$export$77884ce9af78bb82 extends (0, $kUXwW.SelectionBasedNodeView) {
    createDomRef() {
        const domRef = document.createElement('figcaption');
        domRef.setAttribute('data-caption', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'caption-wrapper';
        dom.setAttribute('contenteditable', this.pluginInjectionApi?.editorDisabled?.sharedState.currentState()?.editorDisabled ? 'false' : 'true');
        return {
            dom: dom
        };
    }
    // ED-24114: We need to ignore mutations that are not related to the caption node
    // since these mutations can cause an infinite loop in React 18 when using createRoot
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    handleEditorDisabledChanged() {
        if (this.pluginInjectionApi?.editorDisabled) this.cleanupEditorDisabledListener = this.pluginInjectionApi.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    render(_props, forwardRef) {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $48Use.default), {
            selected: this.insideSelection(),
            hasContent: this.node.content.childCount > 0,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: forwardRef
            })
        });
    }
    viewShouldUpdate(nextNode) {
        if (this.node.childCount !== nextNode.childCount) return true;
        const newSelected = this.insideSelection();
        const selectedStateChange = this.selected !== newSelected;
        this.selected = newSelected;
        return selectedStateChange;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, pluginInjectionApi){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate);
        this.selected = this.insideSelection();
        this.cleanupEditorDisabledListener = void 0;
        this.pluginInjectionApi = void 0;
        this.pluginInjectionApi = pluginInjectionApi;
        this.handleEditorDisabledChanged();
    }
}
function $5e822cf7ac2fe956$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, pluginInjectionApi) {
    return (node, view, getPos)=>{
        return new $5e822cf7ac2fe956$export$77884ce9af78bb82(node, view, getPos, portalProviderAPI, eventDispatcher, {}, undefined, undefined, pluginInjectionApi).init();
    };
}





const $2777a54bc7a1f9fb$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('caption');


const $1047aced393a1fe4$var$fireAnalytics = (tr, action, analyticsApi)=>{
    analyticsApi?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CAPTION
    })(tr);
};
var $1047aced393a1fe4$export$2e2bcd8739ae039 = (portalProviderAPI, eventDispatcher, providerFactory, dispatch, pluginInjectionApi)=>{
    const analyticsApi = pluginInjectionApi?.analytics?.actions;
    return new (0, $1S4f7.SafePlugin)({
        appendTransaction (transactions, oldState, newState) {
            // only run for transactions that change selection
            if (!transactions.find((tr)=>tr.selectionSet)) return;
            const newSelection = !newState.selection.eq(oldState.selection);
            const findCaption = (0, $8m4tT.findParentNodeOfType)(oldState.schema.nodes.caption);
            const oldSelectionCaption = findCaption(oldState.selection);
            const { tr: tr } = newState;
            // if selecting away from caption, or selecting a different caption
            if (newSelection && oldSelectionCaption) {
                if (oldSelectionCaption.node.childCount === 0) {
                    tr.delete(oldSelectionCaption.start - 1, oldSelectionCaption.start);
                    tr.setMeta('scrollIntoView', false);
                    $1047aced393a1fe4$var$fireAnalytics(tr, (0, $d925B.ACTION).DELETED, analyticsApi);
                    return tr;
                } else {
                    $1047aced393a1fe4$var$fireAnalytics(tr, (0, $d925B.ACTION).EDITED, analyticsApi);
                    return tr;
                }
            }
        },
        key: (0, $2777a54bc7a1f9fb$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                caption: (0, $5e822cf7ac2fe956$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, pluginInjectionApi)
            }
        }
    });
};


const $8d10803202603f84$var$captionPlugin = ({ api: api })=>{
    return {
        name: 'caption',
        nodes () {
            return [
                {
                    name: 'caption',
                    node: (0, $kRG5M.caption)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'caption',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch })=>(0, $1047aced393a1fe4$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api)
                },
                {
                    name: 'captionKeymap',
                    plugin: (0, $9c0a7f682ecda261$export$317bc7037b2c3692)
                }
            ];
        }
    };
};
var $8d10803202603f84$export$2e2bcd8739ae039 = $8d10803202603f84$var$captionPlugin;
module.exports["default"] = $8d10803202603f84$export$2e2bcd8739ae039;

});

parcelRegister("kUXwW", function(module, exports) {

var $2gkmX = parcelRequire("2gkmX");

class $7142b1395791e3d8$export$9f83dc95adfbb293 extends (0, $2gkmX.default) {
    /**
   * Update current node's start and end positions.
   *
   * Prefer `this.pos` rather than getPos(), because calling getPos is
   * expensive, unless you know you're definitely going to render.
   */ updatePos() {
        if (typeof this.getPos === 'boolean') return;
        const pos = this.getPos();
        if (typeof pos === 'number') {
            this.pos = pos;
            this.posEnd = pos + this.node.nodeSize;
        }
    }
    getPositionsWithDefault(pos, posEnd) {
        return {
            pos: typeof pos !== 'number' ? this.pos : pos,
            posEnd: typeof posEnd !== 'number' ? this.posEnd : posEnd
        };
    }
    selectNode() {
        this.isSelectedNode = true;
        this.update(this.node, this.decorations);
    }
    deselectNode() {
        this.isSelectedNode = false;
        this.update(this.node, this.decorations);
    }
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal);
        this.isSelectedNode = false;
        this.pos = void 0;
        this.posEnd = void 0;
        this.isNodeInsideSelection = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return from <= pos && to >= posEnd;
        };
        this.isSelectionInsideNode = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return pos < from && to < posEnd;
        };
        this.insideSelection = ()=>{
            const { selection: { from: from, to: to } } = this.view.state;
            return this.isSelectedNode || this.isSelectionInsideNode(from, to);
        };
        this.nodeInsideSelection = ()=>{
            const { selection: selection } = this.view.state;
            const { from: from, to: to } = selection;
            return this.isSelectedNode || this.isNodeInsideSelection(from, to);
        };
        this.updatePos();
    }
}
module.exports["SelectionBasedNodeView"] = $7142b1395791e3d8$export$9f83dc95adfbb293;

});

parcelRegister("4iQt6", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cAWza = parcelRequire("cAWza");


var $d925B = parcelRequire("d925B");


var $1Oo9w = parcelRequire("1Oo9w");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $7bDsi = parcelRequire("7bDsi");


var $lNDSG = parcelRequire("lNDSG");


var $8m4tT = parcelRequire("8m4tT");


var $1yB28 = parcelRequire("1yB28");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");





var $bYZ53 = parcelRequire("bYZ53");

var $dIxHZ = parcelRequire("dIxHZ");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");





var $f0ycm = parcelRequire("f0ycm");




const $8049f1f3ed169739$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('datePlugin');


const $719e684e037f2067$export$e029667a62135fd0 = (isQuickInsertAction)=>(state)=>{
        const tr = state.tr;
        const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = state.schema.nodes.date.createChecked({
            timestamp: (0, $dIxHZ.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $5SAOw.Fragment).fromArray([
            dateNode,
            state.schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $8m4tT.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $ks2lK.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), newPluginState);
    };
const $719e684e037f2067$export$ba69c8aeb784b528 = ()=>(state, dispatch)=>{
        const pluginState = (0, $8049f1f3ed169739$export$18d4026d1ea86bb1).getState(state);
        if (!pluginState || pluginState.showDatePickerAt === null) return false;
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
            focusDateInput: true
        });
        dispatch(tr);
        return true;
    };
const $719e684e037f2067$export$70b286c4fa24838 = (showDatePickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
            showDatePickerAt: showDatePickerAt
        }));
        return true;
    };
const $719e684e037f2067$export$a903d799de0e4474 = ()=>(state, dispatch)=>{
        const { showDatePickerAt: showDatePickerAt } = (0, $8049f1f3ed169739$export$18d4026d1ea86bb1).getState(state) || {};
        if (!dispatch) return false;
        const tr = showDatePickerAt ? state.tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        }).setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(showDatePickerAt + 2))) : state.tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
            isNew: false
        });
        dispatch(tr);
        return false;
    };
const $719e684e037f2067$export$7c3e79dfb4962626 = ({ date: date, pluginInjectionApi: pluginInjectionApi })=>{
    pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: (0, $d925B.ACTION).COMMITTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DATE,
        attributes: {
            commitMethod: (0, $d925B.INPUT_METHOD).BLUR,
            isValid: date !== undefined,
            isToday: (0, $f0ycm.isToday)(date)
        }
    });
    return $719e684e037f2067$export$a903d799de0e4474();
};
const $719e684e037f2067$export$621a48d450e82cf = ()=>(state, dispatch)=>{
        const { $from: $from } = state.selection;
        const node = state.doc.nodeAt($from.pos);
        if (node && node.type.name === state.schema.nodes.date.name) {
            const showDatePickerAt = $from.pos;
            if (dispatch) dispatch(state.tr.setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
                showDatePickerAt: showDatePickerAt
            }).setSelection((0, $ks2lK.NodeSelection).create(state.doc, showDatePickerAt)));
        }
        return false;
    };





















const $ec2bf8fd94971aec$export$8993b403eaf979d2 = (pluginInjectionApi)=>({ tr: tr })=>{
        const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
        if (!showDatePickerAt) return tr;
        tr.delete(showDatePickerAt, showDatePickerAt + 1).setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        });
        return tr;
    };
const $ec2bf8fd94971aec$export$b606a931fa97541b = (pluginInjectionApi)=>({ date: date, inputMethod: inputMethod, commitMethod: commitMethod, enterPressed: enterPressed = true })=>({ tr: tr })=>{
            const { schema: schema } = tr.doc.type;
            let timestamp;
            if (date) timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
            else timestamp = (0, $dIxHZ.todayTimestampInUTC)();
            if (inputMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DATE,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            if (commitMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).COMMITTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DATE,
                attributes: {
                    commitMethod: commitMethod,
                    isValid: date !== undefined,
                    isToday: (0, $f0ycm.isToday)(date)
                }
            })(tr);
            const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
            if (!showDatePickerAt) {
                const dateNode = schema.nodes.date.createChecked({
                    timestamp: timestamp
                });
                const textNode = schema.text(' ');
                const fragment = (0, $5SAOw.Fragment).fromArray([
                    dateNode,
                    textNode
                ]);
                const { from: from, to: to } = tr.selection;
                const insertable = (0, $8m4tT.canInsert)(tr.selection.$from, fragment);
                if (!insertable) {
                    const parentSelection = (0, $ks2lK.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
                    tr.insert(parentSelection.to, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, parentSelection.to + 1));
                } else tr.replaceWith(from, to, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, from));
                if (tr.docChanged) tr.scrollIntoView().setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
                    isNew: true
                });
                return tr;
            }
            if (tr.doc.nodeAt(showDatePickerAt)) {
                if (enterPressed) // Setting selection to outside the date node causes showDatePickerAt
                // to be set to null by the PM plugin (onSelectionChanged), which will
                // immediately close the datepicker once a valid date is typed in.
                // Adding this check forces it to stay open until the user presses Enter.
                tr = tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(showDatePickerAt + 2)));
                tr = tr.setNodeMarkup(showDatePickerAt, schema.nodes.date, {
                    timestamp: timestamp
                }).setMeta((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), {
                    isNew: false
                }).scrollIntoView();
                if (!enterPressed) tr = tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, showDatePickerAt));
            }
            return tr;
        };





var $60bKU = parcelRequire("60bKU");






var $1S4f7 = parcelRequire("1S4f7");


var $lkJUe = parcelRequire("lkJUe");






var $1e2E5 = parcelRequire("1e2E5");


var $24P9d = parcelRequire("24P9d");


var $d7ZU3 = parcelRequire("d7ZU3");




var $TfRUG = parcelRequire("TfRUG");





var $6fnsQ = parcelRequire("6fnsQ");










const $61adaecd0a31f1ad$export$55a93796ef2674d = (timestamp, intl, state, pos)=>{
    if (!state) return {
        color: undefined,
        displayString: (0, $dIxHZ.timestampToString)(timestamp, intl)
    };
    const { doc: doc, selection: selection } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    // We fall back to selection.$from even though it does not cover all use cases
    // eg. upon Editor init, selection is at the start, not at the Date node
    const $nodePos = typeof pos === 'number' ? doc.resolve(pos) : selection.$from;
    const parent = $nodePos.parent;
    let withinIncompleteTask = parent.type === taskItem && parent.attrs.state !== 'DONE';
    // If there is blockTaskItem in the schema and it's not nested in an incomplete task item,
    // check if it's nested in an incomplete block task item
    if (blockTaskItem && !withinIncompleteTask) {
        const blockTaskItemParent = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($nodePos, blockTaskItem);
        // If nested in a blockTaskItem that is incomplete
        if (blockTaskItemParent) withinIncompleteTask = blockTaskItemParent.node.attrs.state !== 'DONE';
    }
    const color = withinIncompleteTask && (0, $dIxHZ.isPastDate)(timestamp) ? 'red' : undefined;
    const displayString = withinIncompleteTask ? (0, $dIxHZ.timestampToTaskContext)(timestamp, intl) : (0, $dIxHZ.timestampToString)(timestamp, intl);
    return {
        displayString: displayString,
        color: color
    };
};


let $c4d9e58dc1bce600$var$intlRef;
const $c4d9e58dc1bce600$export$dfa8d249b3ff4cf7 = (node)=>{
    $c4d9e58dc1bce600$var$intlRef = $c4d9e58dc1bce600$var$intlRef || (0, $1e2E5.createIntl)({
        locale: document.documentElement.lang || 'en-US'
    });
    const timestamp = node.attrs.timestamp;
    const displayString = (0, $dIxHZ.timestampToString)(timestamp, $c4d9e58dc1bce600$var$intlRef);
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        'aria-busy': 'true'
    };
    const attrs = {
        style: (0, $24P9d.convertToInlineCss)({
            // Taken from @atlaskit/date Component
            backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
            color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
            borderRadius: "var(--ds-radius-small, 4px)",
            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
            margin: '0 1px'
        })
    };
    return [
        'span',
        wrapperAttrs,
        [
            'span',
            attrs,
            displayString
        ]
    ];
};
const $c4d9e58dc1bce600$export$3bf4edf3398258cf = (node, state, getPos, intl)=>{
    const timestamp = node.attrs.timestamp;
    const pos = getPos?.();
    const { displayString: displayString, color: color } = (0, $61adaecd0a31f1ad$export$55a93796ef2674d)(timestamp, intl, state, pos);
    const nodeWrapperAttrs = {
        contenteditable: 'false',
        timestamp: timestamp,
        class: 'dateView-content-wrap inlineNodeView',
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-name': 'date',
        'data-prosemirror-node-inline': 'true',
        ...(0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? {
            'data-node-type': 'date',
            'data-timestamp': timestamp
        } : {},
        draggable: 'true'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) nodeWrapperAttrs['data-local-id'] = node.attrs.localId;
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp
    };
    const attrs = {
        class: !color ? '' : `date-node-color-${color}`,
        style: `white-space: unset`
    };
    return [
        'span',
        nodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            wrapperAttrs,
            [
                'span',
                attrs,
                displayString
            ]
        ],
        (0, $d7ZU3.browser).android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $bc21f74f35263bb6$export$9e959fa2f3aa27d3 {
    /**
   *
   * @param node
   * @param decorations
   * @example
   */ update(node, decorations) {
        // we're only interested in two scenarios to trigger a DOM update:
        // 		1. the date value (timestamp) has changed
        // 		2. A wrapping taskitem state (if present) has changed
        // in all other cases, we tell prosemirror to ignore DOM updates
        // if new changes are added to the DOM structure, they will need to be
        // coded here
        const hasDateChanged = node.attrs.timestamp !== this.node.attrs.timestamp;
        const parentTaskState = $bc21f74f35263bb6$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
        const parentTaskStateChanged = parentTaskState !== this.parentTaskState;
        // update local state after comparisons ...
        this.parentTaskState = parentTaskState;
        this.node = node;
        const skipProseMirrorDomUpdate = !hasDateChanged && !parentTaskStateChanged;
        return skipProseMirrorDomUpdate;
    }
    static getParentTaskState(decorations) {
        const parentTaskDecoration = decorations.find((d)=>{
            return d.spec.dataTaskNodeCheckState !== undefined;
        });
        return parentTaskDecoration?.spec?.dataTaskNodeCheckState ?? '';
    }
    /**
   *
   * @param node
   * @param view
   * @param getPos
   * @param intl
   * @param decorations
   * @example
   */ constructor(node, view, getPos, intl, decorations){
        this.dom = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.parentTaskState = '';
        this.node = node;
        this.intl = intl;
        this.view = view;
        this.getPos = getPos;
        const spec = (0, $c4d9e58dc1bce600$export$3bf4edf3398258cf)(node, this.view.state, this.getPos, this.intl);
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom.addEventListener('click', (event)=>{
            event.stopImmediatePropagation();
            const { state: state, dispatch: dispatch } = this.view;
            (0, $719e684e037f2067$export$70b286c4fa24838)(state.selection.from)(state, dispatch);
        });
        this.parentTaskState = $bc21f74f35263bb6$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
    }
}






function $edc1231690bcedc9$export$1650419e431d3ba3(pluginState, meta) {
    // If the same nodeview is clicked twice, calendar should close
    if (meta.showDatePickerAt === pluginState.showDatePickerAt) return {
        ...pluginState,
        showDatePickerAt: null
    };
    const { showDatePickerAt: showDatePickerAt, isNew: isNew } = pluginState;
    const { showDatePickerAt: showDatePickerAtMeta } = meta;
    // If date picker position has changed, it is no longer new
    if (showDatePickerAt && showDatePickerAtMeta && showDatePickerAt !== showDatePickerAtMeta && isNew) return {
        ...pluginState,
        ...meta,
        isNew: false
    };
    return {
        ...pluginState,
        ...meta
    };
}
function $edc1231690bcedc9$export$83e1f26587c4acd2(tr, pluginState) {
    if (!pluginState.showDatePickerAt) return pluginState;
    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.showDatePickerAt);
    return {
        showDatePickerAt: deleted ? null : pos,
        isNew: pluginState.isNew,
        isDateEmpty: pluginState.isDateEmpty,
        focusDateInput: pluginState.focusDateInput,
        isInitialised: pluginState.isInitialised
    };
}
function $edc1231690bcedc9$export$8a0edcfd4a8a0397(tr, pluginState) {
    if (tr.docChanged && $edc1231690bcedc9$var$isDateNodeSelection(tr.selection)) return {
        ...pluginState,
        isQuickInsertAction: false,
        showDatePickerAt: tr.selection.from
    };
    else if (!$edc1231690bcedc9$var$isDateNodeSelection(tr.selection) && !pluginState.isQuickInsertAction) {
        if (pluginState.showDatePickerAt) return {
            showDatePickerAt: null,
            isNew: false,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return pluginState;
    }
    return pluginState;
}
const $edc1231690bcedc9$var$isDateNodeSelection = (selection)=>{
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const nodeTypeName = selection.node.type.name;
        return nodeTypeName === 'date';
    }
    return false;
};


const { createPluginState: $c5476771daa2839d$var$createPluginState, getPluginState: $c5476771daa2839d$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $8049f1f3ed169739$export$18d4026d1ea86bb1), (0, $edc1231690bcedc9$export$1650419e431d3ba3), {
    mapping: $edc1231690bcedc9$export$83e1f26587c4acd2,
    onSelectionChanged: $edc1231690bcedc9$export$8a0edcfd4a8a0397
});
const $c5476771daa2839d$var$createPlugin = (pmPluginFactoryParams)=>{
    const { dispatch: dispatch } = pmPluginFactoryParams;
    const newPluginState = {
        showDatePickerAt: null,
        isNew: false,
        isDateEmpty: false,
        focusDateInput: false,
        isInitialised: true
    };
    return new (0, $1S4f7.SafePlugin)({
        state: $c5476771daa2839d$var$createPluginState(dispatch, newPluginState),
        key: (0, $8049f1f3ed169739$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                date: (node, view, getPos, decorations)=>{
                    return new (0, $bc21f74f35263bb6$export$9e959fa2f3aa27d3)(node, view, getPos, pmPluginFactoryParams.getIntl(), decorations);
                }
            }
        }
    });
};
var $c5476771daa2839d$export$2e2bcd8739ae039 = $c5476771daa2839d$var$createPlugin;


function $37f1307282b27ea0$export$e832373cff8dec22() {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.enter).common, (state, dispatch)=>{
        const datePlugin = (0, $c5476771daa2839d$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (!datePlugin.showDatePickerAt) {
            (0, $719e684e037f2067$export$621a48d450e82cf)()(state, dispatch);
            return true;
        }
        (0, $719e684e037f2067$export$a903d799de0e4474)()(state, dispatch);
        return true;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch)=>{
        const datePlugin = (0, $c5476771daa2839d$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (datePlugin.showDatePickerAt) {
            (0, $719e684e037f2067$export$ba69c8aeb784b528)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $60bKU.keymap)(list);
}
var $37f1307282b27ea0$export$2e2bcd8739ae039 = $37f1307282b27ea0$export$e832373cff8dec22;





const $3a43cebe0bd6a533$var$DatePicker = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "n4oKT",
    name: "DatePicker",
    loader: ()=>(parcelRequire("4m7Qw")).then((mod)=>mod.default),
    loading: ()=>null
});
function $3a43cebe0bd6a533$var$getDateNode(editorView, showDatePickerAt) {
    if (!editorView) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $8m4tT.findDomRefAtPos)(showDatePickerAt, domAtPos);
    // Resolves ED-23702 for when the date is wrapped in an inline comment
    const dateNode = element?.classList.contains((0, $7bDsi.DateSharedCssClassName).DATE_CONTAINER) ? element : element?.querySelector(`.${(0, $7bDsi.DateSharedCssClassName).DATE_CONTAINER}`);
    return dateNode || element;
}
function $3a43cebe0bd6a533$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi, weekStartDay: weekStartDay }) {
    const { editorDisabledState: editorDisabledState, dateState: dateState } = (0, $1Oo9w.useSharedPluginState)(dependencyApi, [
        'date',
        'editorDisabled'
    ]);
    if (!dateState?.showDatePickerAt || editorDisabledState?.editorDisabled) return null;
    const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = dateState;
    const dateNode = $3a43cebe0bd6a533$var$getDateNode(editorView, showDatePickerAt);
    return /*#__PURE__*/ (0, $l998X.jsx)($3a43cebe0bd6a533$var$DatePicker, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: dateNode,
        isNew: isNew,
        autoFocus: focusDateInput,
        onDelete: ()=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
            dependencyApi?.core?.actions.execute((0, $ec2bf8fd94971aec$export$8993b403eaf979d2)(dependencyApi));
            editorView?.focus();
        },
        onSelect: (date, commitMethod)=>{
            // Undefined means couldn't parse date, null means invalid (out of bounds) date
            if (date === undefined || date === null) return;
            if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
            dependencyApi?.core?.actions.execute((0, $ec2bf8fd94971aec$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                commitMethod: commitMethod
            }));
            editorView?.focus();
        },
        onTextChanged: (date)=>{
            dependencyApi?.core?.actions.execute((0, $ec2bf8fd94971aec$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                enterPressed: false
            }));
        },
        closeDatePicker: ()=>{
            if (!editorView) return;
            (0, $719e684e037f2067$export$a903d799de0e4474)()(editorView.state, editorView.dispatch);
            editorView?.focus();
        },
        closeDatePickerWithAnalytics: ({ date: date })=>{
            if (!editorView) return;
            (0, $719e684e037f2067$export$7c3e79dfb4962626)({
                date: date
            })(editorView.state, editorView.dispatch);
            editorView.focus();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        weekStartDay: weekStartDay
    }, showDatePickerAt);
}
const $3a43cebe0bd6a533$var$datePlugin = ({ config: config = {}, api: api })=>({
        name: 'date',
        getSharedState (editorState) {
            if (!editorState) return {
                showDatePickerAt: null,
                isNew: false,
                focusDateInput: false,
                isInitialised: true
            };
            const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput, isInitialised: isInitialised } = (0, $8049f1f3ed169739$export$18d4026d1ea86bb1).getState(editorState) || {};
            return {
                showDatePickerAt: showDatePickerAt,
                isNew: !!isNew,
                focusDateInput: !!focusDateInput,
                isInitialised: !!isInitialised
            };
        },
        commands: {
            insertDate: (0, $ec2bf8fd94971aec$export$b606a931fa97541b)(api),
            deleteDate: (0, $ec2bf8fd94971aec$export$8993b403eaf979d2)(api)
        },
        nodes () {
            return [
                {
                    name: 'date',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $cAWza.dateWithLocalId) : (0, $cAWza.date)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'date',
                    plugin: (pmPluginFactoryParams)=>{
                        $3a43cebe0bd6a533$var$DatePicker.preload();
                        return (0, $c5476771daa2839d$export$2e2bcd8739ae039)(pmPluginFactoryParams);
                    }
                },
                {
                    name: 'dateKeymap',
                    plugin: ()=>{
                        $3a43cebe0bd6a533$var$DatePicker.preload();
                        return (0, $37f1307282b27ea0$export$2e2bcd8739ae039)();
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($3a43cebe0bd6a533$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                weekStartDay: config.weekStartDay
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'date',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).date),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).dateDescription),
                        priority: 800,
                        keywords: [
                            'calendar',
                            'day',
                            'time',
                            'today',
                            '/'
                        ],
                        keyshortcut: '//',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDate), {}),
                        action (insert, state) {
                            const tr = (0, $719e684e037f2067$export$e029667a62135fd0)(true)(state);
                            api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DATE,
                                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'date'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Date floating toolbar',
                    nodeType: [
                        state.schema.nodes.date
                    ],
                    getDomRef: (editorView)=>{
                        const dateState = (0, $8049f1f3ed169739$export$18d4026d1ea86bb1).getState(state);
                        const datePosition = dateState?.showDatePickerAt;
                        if (!datePosition) return undefined;
                        const domAtPos = editorView.domAtPos.bind(editorView);
                        const domRef = (0, $8m4tT.findDomRefAtPos)(datePosition, domAtPos);
                        const isHTMLElement = (element)=>{
                            return element instanceof HTMLElement;
                        };
                        if (isHTMLElement(domRef)) return domRef;
                        return undefined;
                    },
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Date floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && isViewMode() && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark;
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-date-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    });
var $3a43cebe0bd6a533$export$2e2bcd8739ae039 = $3a43cebe0bd6a533$var$datePlugin;
module.exports["default"] = $3a43cebe0bd6a533$export$2e2bcd8739ae039;

});

parcelRegister("f0ycm", function(module, exports) {

var $922yL = parcelRequire("922yL");


var $4TIFs = parcelRequire("4TIFs");


var $2wblJ = parcelRequire("2wblJ");

var $03b90e40f2662c32$exports = {};
$parcel$export($03b90e40f2662c32$exports, "af", () => (parcelRequire("ccx2d")).default);
$parcel$export($03b90e40f2662c32$exports, "ar", () => (parcelRequire("cAsrS")).default);
$parcel$export($03b90e40f2662c32$exports, "arDZ", () => (parcelRequire("6wu0n")).default);
$parcel$export($03b90e40f2662c32$exports, "arEG", () => (parcelRequire("hWVUZ")).default);
$parcel$export($03b90e40f2662c32$exports, "arMA", () => (parcelRequire("7hwNo")).default);
$parcel$export($03b90e40f2662c32$exports, "arSA", () => (parcelRequire("hVIfN")).default);
$parcel$export($03b90e40f2662c32$exports, "arTN", () => (parcelRequire("ejvVa")).default);
$parcel$export($03b90e40f2662c32$exports, "az", () => (parcelRequire("gV1cj")).default);
$parcel$export($03b90e40f2662c32$exports, "be", () => (parcelRequire("kZaIb")).default);
$parcel$export($03b90e40f2662c32$exports, "beTarask", () => (parcelRequire("1IENB")).default);
$parcel$export($03b90e40f2662c32$exports, "bg", () => (parcelRequire("grFlY")).default);
$parcel$export($03b90e40f2662c32$exports, "bn", () => (parcelRequire("jTGMT")).default);
$parcel$export($03b90e40f2662c32$exports, "bs", () => (parcelRequire("lfdvS")).default);
$parcel$export($03b90e40f2662c32$exports, "ca", () => (parcelRequire("cYC81")).default);
$parcel$export($03b90e40f2662c32$exports, "cs", () => (parcelRequire("1BJPA")).default);
$parcel$export($03b90e40f2662c32$exports, "cy", () => (parcelRequire("4ATJv")).default);
$parcel$export($03b90e40f2662c32$exports, "da", () => (parcelRequire("dHsuJ")).default);
$parcel$export($03b90e40f2662c32$exports, "de", () => (parcelRequire("5cYlT")).default);
$parcel$export($03b90e40f2662c32$exports, "deAT", () => (parcelRequire("3evgL")).default);
$parcel$export($03b90e40f2662c32$exports, "el", () => (parcelRequire("h1o1V")).default);
$parcel$export($03b90e40f2662c32$exports, "enAU", () => (parcelRequire("eafy7")).default);
$parcel$export($03b90e40f2662c32$exports, "enCA", () => (parcelRequire("gYOIj")).default);
$parcel$export($03b90e40f2662c32$exports, "enGB", () => (parcelRequire("e6KrE")).default);
$parcel$export($03b90e40f2662c32$exports, "enIE", () => (parcelRequire("8hVqv")).default);
$parcel$export($03b90e40f2662c32$exports, "enIN", () => (parcelRequire("615gv")).default);
$parcel$export($03b90e40f2662c32$exports, "enNZ", () => (parcelRequire("2QFTn")).default);
$parcel$export($03b90e40f2662c32$exports, "enUS", () => (parcelRequire("9gbhg")).default);
$parcel$export($03b90e40f2662c32$exports, "enZA", () => (parcelRequire("1FiBY")).default);
$parcel$export($03b90e40f2662c32$exports, "eo", () => (parcelRequire("7jF1H")).default);
$parcel$export($03b90e40f2662c32$exports, "es", () => (parcelRequire("2rFSr")).default);
$parcel$export($03b90e40f2662c32$exports, "et", () => (parcelRequire("hDlC6")).default);
$parcel$export($03b90e40f2662c32$exports, "eu", () => (parcelRequire("lXpvm")).default);
$parcel$export($03b90e40f2662c32$exports, "faIR", () => (parcelRequire("dQ1Ff")).default);
$parcel$export($03b90e40f2662c32$exports, "fi", () => (parcelRequire("5NDCB")).default);
$parcel$export($03b90e40f2662c32$exports, "fr", () => (parcelRequire("dPWO1")).default);
$parcel$export($03b90e40f2662c32$exports, "frCA", () => (parcelRequire("7iC3U")).default);
$parcel$export($03b90e40f2662c32$exports, "frCH", () => (parcelRequire("8vHDr")).default);
$parcel$export($03b90e40f2662c32$exports, "fy", () => (parcelRequire("kTJct")).default);
$parcel$export($03b90e40f2662c32$exports, "gd", () => (parcelRequire("7sVju")).default);
$parcel$export($03b90e40f2662c32$exports, "gl", () => (parcelRequire("1JL6a")).default);
$parcel$export($03b90e40f2662c32$exports, "gu", () => (parcelRequire("8F1uG")).default);
$parcel$export($03b90e40f2662c32$exports, "he", () => (parcelRequire("f8KYU")).default);
$parcel$export($03b90e40f2662c32$exports, "hi", () => (parcelRequire("eIPle")).default);
$parcel$export($03b90e40f2662c32$exports, "hr", () => (parcelRequire("bXqD0")).default);
$parcel$export($03b90e40f2662c32$exports, "ht", () => (parcelRequire("l3nMN")).default);
$parcel$export($03b90e40f2662c32$exports, "hu", () => (parcelRequire("4ihaK")).default);
$parcel$export($03b90e40f2662c32$exports, "hy", () => (parcelRequire("9Oln7")).default);
$parcel$export($03b90e40f2662c32$exports, "id", () => (parcelRequire("595k0")).default);
$parcel$export($03b90e40f2662c32$exports, "is", () => (parcelRequire("79XIC")).default);
$parcel$export($03b90e40f2662c32$exports, "it", () => (parcelRequire("mn9Wr")).default);
$parcel$export($03b90e40f2662c32$exports, "itCH", () => (parcelRequire("ay3fF")).default);
$parcel$export($03b90e40f2662c32$exports, "ja", () => (parcelRequire("1bGRR")).default);
$parcel$export($03b90e40f2662c32$exports, "jaHira", () => (parcelRequire("kfY4v")).default);
$parcel$export($03b90e40f2662c32$exports, "ka", () => (parcelRequire("lv9bx")).default);
$parcel$export($03b90e40f2662c32$exports, "kk", () => (parcelRequire("eGEP6")).default);
$parcel$export($03b90e40f2662c32$exports, "km", () => (parcelRequire("hwTSQ")).default);
$parcel$export($03b90e40f2662c32$exports, "kn", () => (parcelRequire("kH49P")).default);
$parcel$export($03b90e40f2662c32$exports, "ko", () => (parcelRequire("lCGhI")).default);
$parcel$export($03b90e40f2662c32$exports, "lb", () => (parcelRequire("imqUz")).default);
$parcel$export($03b90e40f2662c32$exports, "lt", () => (parcelRequire("1iKSq")).default);
$parcel$export($03b90e40f2662c32$exports, "lv", () => (parcelRequire("jrpVX")).default);
$parcel$export($03b90e40f2662c32$exports, "mk", () => (parcelRequire("dS7Bb")).default);
$parcel$export($03b90e40f2662c32$exports, "mn", () => (parcelRequire("8paOO")).default);
$parcel$export($03b90e40f2662c32$exports, "ms", () => (parcelRequire("cW6rW")).default);
$parcel$export($03b90e40f2662c32$exports, "mt", () => (parcelRequire("biuzd")).default);
$parcel$export($03b90e40f2662c32$exports, "nb", () => (parcelRequire("bTX4C")).default);
$parcel$export($03b90e40f2662c32$exports, "nl", () => (parcelRequire("j02BH")).default);
$parcel$export($03b90e40f2662c32$exports, "nlBE", () => (parcelRequire("1WYEH")).default);
$parcel$export($03b90e40f2662c32$exports, "nn", () => (parcelRequire("dDyCC")).default);
$parcel$export($03b90e40f2662c32$exports, "oc", () => (parcelRequire("67k4F")).default);
$parcel$export($03b90e40f2662c32$exports, "pl", () => (parcelRequire("aJSKs")).default);
$parcel$export($03b90e40f2662c32$exports, "pt", () => (parcelRequire("WegEx")).default);
$parcel$export($03b90e40f2662c32$exports, "ptBR", () => (parcelRequire("fV2AU")).default);
$parcel$export($03b90e40f2662c32$exports, "ro", () => (parcelRequire("g39vH")).default);
$parcel$export($03b90e40f2662c32$exports, "ru", () => (parcelRequire("8DIej")).default);
$parcel$export($03b90e40f2662c32$exports, "sk", () => (parcelRequire("dsLkK")).default);
$parcel$export($03b90e40f2662c32$exports, "sl", () => (parcelRequire("4TLob")).default);
$parcel$export($03b90e40f2662c32$exports, "sq", () => (parcelRequire("5Jdcc")).default);
$parcel$export($03b90e40f2662c32$exports, "sr", () => (parcelRequire("gA4BZ")).default);
$parcel$export($03b90e40f2662c32$exports, "srLatn", () => (parcelRequire("bv7hX")).default);
$parcel$export($03b90e40f2662c32$exports, "sv", () => (parcelRequire("aJh34")).default);
$parcel$export($03b90e40f2662c32$exports, "ta", () => (parcelRequire("02PYW")).default);
$parcel$export($03b90e40f2662c32$exports, "te", () => (parcelRequire("gsoQC")).default);
$parcel$export($03b90e40f2662c32$exports, "th", () => (parcelRequire("eI3Et")).default);
$parcel$export($03b90e40f2662c32$exports, "tr", () => (parcelRequire("9bDNQ")).default);
$parcel$export($03b90e40f2662c32$exports, "ug", () => (parcelRequire("eYfUk")).default);
$parcel$export($03b90e40f2662c32$exports, "uk", () => (parcelRequire("aB16j")).default);
$parcel$export($03b90e40f2662c32$exports, "uz", () => (parcelRequire("cVPxO")).default);
$parcel$export($03b90e40f2662c32$exports, "uzCyrl", () => (parcelRequire("kHHuH")).default);
$parcel$export($03b90e40f2662c32$exports, "vi", () => (parcelRequire("aBdsV")).default);
$parcel$export($03b90e40f2662c32$exports, "zhCN", () => (parcelRequire("2y7u1")).default);
$parcel$export($03b90e40f2662c32$exports, "zhHK", () => (parcelRequire("aCOaX")).default);
$parcel$export($03b90e40f2662c32$exports, "zhTW", () => (parcelRequire("2LLdF")).default);
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

var $ccx2d = parcelRequire("ccx2d");


var $cAsrS = parcelRequire("cAsrS");


var $6wu0n = parcelRequire("6wu0n");


var $hWVUZ = parcelRequire("hWVUZ");


var $7hwNo = parcelRequire("7hwNo");


var $hVIfN = parcelRequire("hVIfN");


var $ejvVa = parcelRequire("ejvVa");


var $gV1cj = parcelRequire("gV1cj");


var $kZaIb = parcelRequire("kZaIb");


var $1IENB = parcelRequire("1IENB");


var $grFlY = parcelRequire("grFlY");


var $jTGMT = parcelRequire("jTGMT");


var $lfdvS = parcelRequire("lfdvS");


var $cYC81 = parcelRequire("cYC81");


var $1BJPA = parcelRequire("1BJPA");


var $4ATJv = parcelRequire("4ATJv");


var $dHsuJ = parcelRequire("dHsuJ");


var $5cYlT = parcelRequire("5cYlT");


var $3evgL = parcelRequire("3evgL");


var $h1o1V = parcelRequire("h1o1V");


var $eafy7 = parcelRequire("eafy7");


var $gYOIj = parcelRequire("gYOIj");


var $e6KrE = parcelRequire("e6KrE");


var $8hVqv = parcelRequire("8hVqv");


var $615gv = parcelRequire("615gv");


var $2QFTn = parcelRequire("2QFTn");


var $9gbhg = parcelRequire("9gbhg");


var $1FiBY = parcelRequire("1FiBY");


var $7jF1H = parcelRequire("7jF1H");


var $2rFSr = parcelRequire("2rFSr");


var $hDlC6 = parcelRequire("hDlC6");


var $lXpvm = parcelRequire("lXpvm");


var $dQ1Ff = parcelRequire("dQ1Ff");


var $5NDCB = parcelRequire("5NDCB");


var $dPWO1 = parcelRequire("dPWO1");


var $7iC3U = parcelRequire("7iC3U");


var $8vHDr = parcelRequire("8vHDr");


var $kTJct = parcelRequire("kTJct");


var $7sVju = parcelRequire("7sVju");


var $1JL6a = parcelRequire("1JL6a");


var $8F1uG = parcelRequire("8F1uG");


var $f8KYU = parcelRequire("f8KYU");


var $eIPle = parcelRequire("eIPle");


var $bXqD0 = parcelRequire("bXqD0");


var $l3nMN = parcelRequire("l3nMN");


var $4ihaK = parcelRequire("4ihaK");


var $9Oln7 = parcelRequire("9Oln7");


var $595k0 = parcelRequire("595k0");


var $79XIC = parcelRequire("79XIC");


var $mn9Wr = parcelRequire("mn9Wr");


var $ay3fF = parcelRequire("ay3fF");


var $1bGRR = parcelRequire("1bGRR");


var $kfY4v = parcelRequire("kfY4v");


var $lv9bx = parcelRequire("lv9bx");


var $eGEP6 = parcelRequire("eGEP6");


var $hwTSQ = parcelRequire("hwTSQ");


var $kH49P = parcelRequire("kH49P");


var $lCGhI = parcelRequire("lCGhI");


var $imqUz = parcelRequire("imqUz");


var $1iKSq = parcelRequire("1iKSq");


var $jrpVX = parcelRequire("jrpVX");


var $dS7Bb = parcelRequire("dS7Bb");


var $8paOO = parcelRequire("8paOO");


var $cW6rW = parcelRequire("cW6rW");


var $biuzd = parcelRequire("biuzd");


var $bTX4C = parcelRequire("bTX4C");


var $j02BH = parcelRequire("j02BH");


var $1WYEH = parcelRequire("1WYEH");


var $dDyCC = parcelRequire("dDyCC");


var $67k4F = parcelRequire("67k4F");


var $aJSKs = parcelRequire("aJSKs");


var $WegEx = parcelRequire("WegEx");


var $fV2AU = parcelRequire("fV2AU");


var $g39vH = parcelRequire("g39vH");


var $8DIej = parcelRequire("8DIej");


var $dsLkK = parcelRequire("dsLkK");


var $4TLob = parcelRequire("4TLob");


var $5Jdcc = parcelRequire("5Jdcc");


var $gA4BZ = parcelRequire("gA4BZ");


var $bv7hX = parcelRequire("bv7hX");


var $aJh34 = parcelRequire("aJh34");


var $02PYW = parcelRequire("02PYW");


var $gsoQC = parcelRequire("gsoQC");


var $eI3Et = parcelRequire("eI3Et");


var $9bDNQ = parcelRequire("9bDNQ");


var $eYfUk = parcelRequire("eYfUk");


var $aB16j = parcelRequire("aB16j");


var $cVPxO = parcelRequire("cVPxO");


var $kHHuH = parcelRequire("kHHuH");


var $aBdsV = parcelRequire("aBdsV");


var $2y7u1 = parcelRequire("2y7u1");


var $aCOaX = parcelRequire("aCOaX");


var $2LLdF = parcelRequire("2LLdF");




var $56QVA = parcelRequire("56QVA");

function $7656737e9f714e47$var$isDigit(c) {
    if (c === undefined) return false;
    return c >= '0' && c <= '9';
}
/**
 * Check if cursor is in first segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $7656737e9f714e47$var$isCursorInFirstDateSegment(cursorPos, date) {
    let posCounter = cursorPos - 1;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter >= 0 && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$7656737e9f714e47$var$isDigit(c)) isAdjacent = false;
        posCounter -= 1;
    }
    return isAdjacent;
}
/**
 * Check if cursor is in last segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $7656737e9f714e47$var$isCursorInLastDateSegment(cursorPos, date) {
    let posCounter = cursorPos;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter < strippedDate.length && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$7656737e9f714e47$var$isDigit(c)) isAdjacent = false;
        posCounter += 1;
    }
    return isAdjacent;
}
function $7656737e9f714e47$export$6e7fa6d67147cb9e(date) {
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
}
function $7656737e9f714e47$export$ff5a653e9ab9c0bc(position, date, locale) {
    if (position > date.length) return undefined;
    const placeholder = $7656737e9f714e47$export$a785060aa48542fa(locale);
    if (!placeholder) return undefined;
    // The placeholder without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPlaceholder = placeholder.replace(/[^ymd]+$/g, '');
    const keyToSegment = {
        d: 'day',
        m: 'month',
        y: 'year'
    };
    const firstSegment = keyToSegment[strippedPlaceholder[0]];
    const lastSegment = keyToSegment[strippedPlaceholder[strippedPlaceholder.length - 1]];
    const allPossibleSegments = [
        'day',
        'month',
        'year'
    ];
    const middleSegment = allPossibleSegments.filter((s)=>s !== firstSegment && s !== lastSegment)[0];
    if ($7656737e9f714e47$var$isCursorInFirstDateSegment(position, date)) return firstSegment;
    if ($7656737e9f714e47$var$isCursorInLastDateSegment(position, date)) return lastSegment;
    return middleSegment;
}
function $7656737e9f714e47$export$a785060aa48542fa(locale) {
    const uniqueDateType = {
        day: 7,
        month: 1,
        year: 1992
    };
    const localisedDateString = (0, $56QVA.formatDateType)(uniqueDateType, locale);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const shortDateFormat = localisedDateString.replace(/\d+/g, (str)=>{
        if (!str) return '';
        // Ignored via go/ees005
        // eslint-disable-next-line no-var
        var num = parseInt(str);
        switch(num % 100){
            case 92:
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                return str.replace(/.{1}/g, 'y');
            case 1:
                return str.length === 1 ? 'm' : 'mm';
            case 7:
                return str.length === 1 ? 'd' : 'dd';
        }
        return '';
    });
    return shortDateFormat;
}
function $7656737e9f714e47$export$6c4de3b0bb035f06(date, activeSegment, adjustment) {
    const originalDate = (0, $56QVA.dateTypeToDate)(date);
    const newDate = activeSegment === 'day' ? (0, $922yL.default)(originalDate, adjustment) : activeSegment === 'month' ? (0, $4TIFs.default)(originalDate, adjustment) : (0, $2wblJ.default)(originalDate, adjustment);
    return (0, $56QVA.dateToDateType)(newDate);
}
function $7656737e9f714e47$export$629b0a497aa65267(date) {
    const today = new Date();
    return date !== undefined && today.getDate() === date.day && date.month === today.getMonth() + 1 && date.year === today.getFullYear();
}
function $7656737e9f714e47$export$1f30ec7fd3ecab15(localeString) {
    let dfLocaleString = localeString;
    const [lang, region] = localeString.split('-');
    if (region) {
        if (lang.toLocaleLowerCase() === region.toLocaleLowerCase()) dfLocaleString = lang;
        else dfLocaleString = `${lang}${region}`;
    }
    return $03b90e40f2662c32$exports[dfLocaleString];
}
module.exports["isDatePossiblyValid"] = $7656737e9f714e47$export$6e7fa6d67147cb9e;
module.exports["findDateSegmentByPosition"] = $7656737e9f714e47$export$ff5a653e9ab9c0bc;
module.exports["adjustDate"] = $7656737e9f714e47$export$6c4de3b0bb035f06;
module.exports["isToday"] = $7656737e9f714e47$export$629b0a497aa65267;
module.exports["getDFLocale"] = $7656737e9f714e47$export$1f30ec7fd3ecab15;

});

parcelRegister("eafy7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hnQFw = parcelRequire("hnQFw");


var $ke66V = parcelRequire("ke66V");

var $26dcf52cd5fa2c45$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $26dcf52cd5fa2c45$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $26dcf52cd5fa2c45$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $26dcf52cd5fa2c45$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $26dcf52cd5fa2c45$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $26dcf52cd5fa2c45$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $26dcf52cd5fa2c45$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $26dcf52cd5fa2c45$export$2e2bcd8739ae039 = $26dcf52cd5fa2c45$var$formatLong;



var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $a4fe0f9e3c1c5e9d$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $26dcf52cd5fa2c45$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a4fe0f9e3c1c5e9d$export$2e2bcd8739ae039 = $a4fe0f9e3c1c5e9d$var$locale;
module.exports["default"] = $a4fe0f9e3c1c5e9d$export$2e2bcd8739ae039;

});

parcelRegister("WegEx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $d2249cbbd85d471e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $d2249cbbd85d471e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d2249cbbd85d471e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $d2249cbbd85d471e$export$2e2bcd8739ae039 = $d2249cbbd85d471e$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $e04e86f852f8d59b$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $e04e86f852f8d59b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e04e86f852f8d59b$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e04e86f852f8d59b$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $e04e86f852f8d59b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $e04e86f852f8d59b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $e04e86f852f8d59b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e04e86f852f8d59b$export$2e2bcd8739ae039 = $e04e86f852f8d59b$var$formatLong;


var $91b84ca6115ee529$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $91b84ca6115ee529$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $91b84ca6115ee529$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $91b84ca6115ee529$export$2e2bcd8739ae039 = $91b84ca6115ee529$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $e32caa8c6bb1d355$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $e32caa8c6bb1d355$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $e32caa8c6bb1d355$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $e32caa8c6bb1d355$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $e32caa8c6bb1d355$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $e32caa8c6bb1d355$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $e32caa8c6bb1d355$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $e32caa8c6bb1d355$var$localize = {
    ordinalNumber: $e32caa8c6bb1d355$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $e32caa8c6bb1d355$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $e32caa8c6bb1d355$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $e32caa8c6bb1d355$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $e32caa8c6bb1d355$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $e32caa8c6bb1d355$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e32caa8c6bb1d355$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e32caa8c6bb1d355$export$2e2bcd8739ae039 = $e32caa8c6bb1d355$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $1507d82edaccb279$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $1507d82edaccb279$var$parseOrdinalNumberPattern = /\d+/i;
var $1507d82edaccb279$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $1507d82edaccb279$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $1507d82edaccb279$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $1507d82edaccb279$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1507d82edaccb279$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $1507d82edaccb279$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $1507d82edaccb279$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $1507d82edaccb279$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $1507d82edaccb279$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $1507d82edaccb279$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $1507d82edaccb279$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $1507d82edaccb279$var$matchOrdinalNumberPattern,
        parsePattern: $1507d82edaccb279$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $1507d82edaccb279$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1507d82edaccb279$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $1507d82edaccb279$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1507d82edaccb279$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $1507d82edaccb279$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1507d82edaccb279$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $1507d82edaccb279$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1507d82edaccb279$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $1507d82edaccb279$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1507d82edaccb279$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1507d82edaccb279$export$2e2bcd8739ae039 = $1507d82edaccb279$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $0af07c243a62073e$var$locale = {
    code: 'pt',
    formatDistance: (0, $d2249cbbd85d471e$export$2e2bcd8739ae039),
    formatLong: (0, $e04e86f852f8d59b$export$2e2bcd8739ae039),
    formatRelative: (0, $91b84ca6115ee529$export$2e2bcd8739ae039),
    localize: (0, $e32caa8c6bb1d355$export$2e2bcd8739ae039),
    match: (0, $1507d82edaccb279$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0af07c243a62073e$export$2e2bcd8739ae039 = $0af07c243a62073e$var$locale;
module.exports["default"] = $0af07c243a62073e$export$2e2bcd8739ae039;

});

parcelRegister("56QVA", function(module, exports) {

var $5TGLQ = parcelRequire("5TGLQ");

function $d133a2b5e62b0335$export$9f54bd296c9b15c8(dateString, locale) {
    try {
        const l10n = (0, $5TGLQ.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
}
function $d133a2b5e62b0335$export$c1b0befbc45d5daf(date, locale) {
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $5TGLQ.createLocalizationProvider)(locale);
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
}
function $d133a2b5e62b0335$export$2071e1c033c380c7(date) {
    const { day: day, month: month, year: year } = date;
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return dateObj;
}
function $d133a2b5e62b0335$export$e657ff381fe1e42a(date) {
    const dateObj = {
        day: date.getDate(),
        // The JS Date api represents month as a number between 0-11 :)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return dateObj;
}
module.exports["parseDateType"] = $d133a2b5e62b0335$export$9f54bd296c9b15c8;
module.exports["formatDateType"] = $d133a2b5e62b0335$export$c1b0befbc45d5daf;
module.exports["dateTypeToDate"] = $d133a2b5e62b0335$export$2071e1c033c380c7;
module.exports["dateToDateType"] = $d133a2b5e62b0335$export$e657ff381fe1e42a;

});

parcelRegister("4m7Qw", function(module, exports) {

let $32bf4d99b927e0d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $32bf4d99b927e0d5$var$load("3w411"),
    $32bf4d99b927e0d5$var$load("6wr18"),
    $32bf4d99b927e0d5$var$load("ffEVr"),
    $32bf4d99b927e0d5$var$load("5doAZ")
]).then(()=>parcelRequire('h8ksv'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("g6sXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6724333aa005e095$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

const $6724333aa005e095$export$6a802fb2263552f1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(()=>{});
function $6724333aa005e095$export$2e2bcd8739ae039(Component) {
    return class WithOutsideClick extends (0, $42omo.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6724333aa005e095$export$6a802fb2263552f1.Provider, {
                value: this.setOutsideClickTargetRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, this.props));
        }
        constructor(...args){
            super(...args);
            this.outsideClickTargetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
            this.handleClick = (evt)=>{
                const domNode = this.outsideClickTargetRef.current?.deref();
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) this.props.handleClickOutside?.(evt);
            };
            this.handleKeydown = (evt)=>{
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) this.props.handleEscapeKeydown(evt);
            };
            this.setOutsideClickTargetRef = (el)=>{
                this.outsideClickTargetRef.current = el && new WeakRef(el);
            };
        }
    };
}
module.exports["PlainOutsideClickTargetRefContext"] = $6724333aa005e095$export$6a802fb2263552f1;

});

parcelRegister("fCLXZ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");







const $32e10bed266b8f10$export$a18117c61b4f3090 = '--guideline-offset-x';
const $32e10bed266b8f10$export$343adffee41775d9 = '--guideline-offset-y';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $4HPW1 = parcelRequire("4HPW1");


var $6fnsQ = parcelRequire("6fnsQ");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



const $86e9d23316b03e96$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $86e9d23316b03e96$var$getXPosition = (pixel)=>$86e9d23316b03e96$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $32e10bed266b8f10$export$a18117c61b4f3090}, '0px'))` : 'unset';
const $86e9d23316b03e96$var$getYPosition = (pixel)=>$86e9d23316b03e96$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $32e10bed266b8f10$export$343adffee41775d9}, '0px'))` : 'unset';
const $86e9d23316b03e96$export$a5b21f38d58b1de0 = (pos)=>{
    return (0, $4HPW1.isVerticalPosition)(pos) ? {
        left: $86e9d23316b03e96$var$getXPosition(pos.x),
        top: $86e9d23316b03e96$var$getYPosition(pos.y?.start),
        height: pos.y ? `${pos.y.end - pos.y.start}px` : '100%'
    } : {
        top: $86e9d23316b03e96$var$getYPosition(pos.y),
        left: $86e9d23316b03e96$var$getXPosition(pos.x?.start),
        width: pos.x ? `${pos.x.end - pos.x.start}px` : '100%'
    };
};


function $4abb4f7b80f1989e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4abb4f7b80f1989e$var$basicGuidelineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    zIndex: 0,
    opacity: 1,
    transition: 'border-color 0.15s linear, opacity 0.15s linear',
    borderColor: `${`var(--ds-border-disabled, ${(0, $6fnsQ.N30A)})`}`,
    borderStyle: 'solid'
});
const $4abb4f7b80f1989e$var$verticalStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    borderWidth: `0 0 0 ${"var(--ds-border-width, 1px)"}`,
    width: '1px',
    height: '100%'
});
const $4abb4f7b80f1989e$var$horizontalStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    borderWidth: `${"var(--ds-border-width, 1px)"} 0 0 0`,
    width: '100%',
    height: '1px'
});
const $4abb4f7b80f1989e$var$activeGuidelineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    borderColor: `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`
    }
});
const $4abb4f7b80f1989e$var$hiddenGuidelineStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $4abb4f7b80f1989e$var$dashedGuidelineStyles = {
    name: "10ikx64",
    styles: "border-style:dashed"
};
const $4abb4f7b80f1989e$var$verticalCapStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `var(--ds-border-disabled, ${(0, $6fnsQ.N30A)})`,
        content: '""',
        position: 'absolute',
        height: '5px',
        width: '1px',
        transform: 'translateY(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        right: 0
    }
});
const $4abb4f7b80f1989e$var$horizontalCapStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `${`var(--ds-border-disabled, ${(0, $6fnsQ.N30A)})`}`,
        content: '""',
        position: 'absolute',
        height: '1px',
        width: '5px',
        transform: 'translateX(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        bottom: 0
    }
});
const $4abb4f7b80f1989e$export$1f92f20006072ef = (props)=>{
    const { position: position, active: active, show: show = true, styles: styles = {} } = props;
    const isVerticalPos = (0, $4HPW1.isVerticalPosition)(position);
    const { lineStyle: lineStyle, color: color, capStyle: capStyle } = styles;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $4abb4f7b80f1989e$var$basicGuidelineStyles,
            isVerticalPos ? $4abb4f7b80f1989e$var$verticalStyles : $4abb4f7b80f1989e$var$horizontalStyles,
            capStyle === 'line' && (isVerticalPos ? $4abb4f7b80f1989e$var$horizontalCapStyles : $4abb4f7b80f1989e$var$verticalCapStyles),
            active && $4abb4f7b80f1989e$var$activeGuidelineStyles,
            !show && $4abb4f7b80f1989e$var$hiddenGuidelineStyles,
            lineStyle === 'dashed' && $4abb4f7b80f1989e$var$dashedGuidelineStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...color && {
                borderColor: `${color}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $86e9d23316b03e96$export$a5b21f38d58b1de0)(position)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "guideline"
    });
};


const $4249f5b187e4b7dc$var$guidelineContainerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'fixed',
    height: '100vh',
    width: '100%',
    display: 'grid',
    pointerEvents: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`
});
const $4249f5b187e4b7dc$export$e0b9e5fb6186afa = (props)=>{
    const { guidelines: guidelines, height: height, updateRect: updateRect } = props;
    const [offset, setOffset] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const rect = ref?.current?.getBoundingClientRect();
        if (rect) {
            const centerOffset = rect.width / 2 - 0.5;
            // X pixels from guideline container left to editor center.
            if (offset !== centerOffset) setOffset(centerOffset);
            updateRect({
                top: rect.top,
                left: rect.left
            });
        }
    }, [
        updateRect,
        offset
    ]);
    const style = {
        [(0, $32e10bed266b8f10$export$a18117c61b4f3090)]: `${offset}px`,
        [(0, $32e10bed266b8f10$export$343adffee41775d9)]: `0px`,
        height: height
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        css: $4249f5b187e4b7dc$var$guidelineContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "guidelineContainer"
    }, guidelines.map((guideline)=>{
        const { key: key, ...guidelineProps } = guideline;
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4abb4f7b80f1989e$export$1f92f20006072ef), {
            key: key,
            ...guidelineProps
        });
    }));
};


const $67e5eacce1baf18b$var$guidelineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    transform: `scale(1)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: `${(0, $aFUXX.akEditorGridLineZIndex)};`,
    display: 'flex',
    justifyContent: 'center'
});
const $67e5eacce1baf18b$var$key = new (0, $ks2lK.PluginKey)('guidelinePlugin');
const $67e5eacce1baf18b$var$displayGuideline = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($67e5eacce1baf18b$var$key, props);
        dispatch(tr);
        return true;
    };
const $67e5eacce1baf18b$export$f040258c471d4154 = {
    guidelines: []
};
const $67e5eacce1baf18b$var$guidelinePMPlugin = new (0, $1S4f7.SafePlugin)({
    key: $67e5eacce1baf18b$var$key,
    state: {
        init () {
            return $67e5eacce1baf18b$export$f040258c471d4154;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($67e5eacce1baf18b$var$key);
            if (nextPluginState) return {
                ...currentPluginState,
                ...nextPluginState
            };
            return currentPluginState;
        }
    }
});
const $67e5eacce1baf18b$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        lineLength: states.widthState?.lineLength,
        guidelines: states.guidelineState?.guidelines,
        rect: states.guidelineState?.rect
    };
};
const $67e5eacce1baf18b$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, lineLength: lineLength, guidelines: guidelines, rect: rect } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width',
        'guideline'
    ], $67e5eacce1baf18b$var$selector);
    if (!width || !lineLength || !guidelines || guidelines.length === 0) return null;
    const updateRect = ({ top: top, left: left })=>{
        const { dispatch: dispatch, state: state } = editorView;
        const { top: prevTop, left: prevLeft } = rect || {};
        if (prevTop !== top || prevLeft !== left) {
            const tr = state.tr.setMeta($67e5eacce1baf18b$var$key, {
                rect: {
                    top: top,
                    left: left
                }
            });
            dispatch(tr);
            return true;
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $67e5eacce1baf18b$var$guidelineStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4249f5b187e4b7dc$export$e0b9e5fb6186afa), {
        guidelines: guidelines,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        height: editorView.dom.scrollHeight,
        width: width,
        editorWidth: lineLength,
        updateRect: updateRect
    }));
};
const $67e5eacce1baf18b$export$63925ade01f824c4 = ({ config: options, api: api })=>({
        name: 'guideline',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $67e5eacce1baf18b$var$key.getState(editorState) || null;
        },
        actions: {
            displayGuideline: $67e5eacce1baf18b$var$displayGuideline
        },
        pmPlugins () {
            return [
                {
                    name: 'guideline',
                    plugin: ()=>$67e5eacce1baf18b$var$guidelinePMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $9K4OG.jsx)($67e5eacce1baf18b$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    });
module.exports["guidelinePlugin"] = $67e5eacce1baf18b$export$63925ade01f824c4;

});

parcelRegister("flknw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $hgeg8 = parcelRequire("hgeg8");


var $4HWgE = parcelRequire("4HWgE");


var $ci7Ox = parcelRequire("ci7Ox");


var $1oCLl = parcelRequire("1oCLl");


var $gahkt = parcelRequire("gahkt");

const $6a5a8122447a2b1d$export$2dac2f8389fd3a8c = (tr)=>{
    return tr.setMeta((0, $gahkt.pluginKey), true);
};
const $6a5a8122447a2b1d$export$c54ba5c26d7768da = (tr)=>{
    return tr.setMeta((0, $gahkt.pluginKey), false);
};



var $bQUgf = parcelRequire("bQUgf");








var $dus6D = parcelRequire("dus6D");







const $589bcaa98e35f270$export$e832373cff8dec22 = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.openHelp).common, (state, dispatch)=>{
        const { tr: tr } = state;
        const isVisible = tr.getMeta((0, $gahkt.pluginKey));
        if (!isVisible) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BUTTON_HELP,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            })(tr);
            (0, $bQUgf.openHelpCommand)(tr, dispatch);
        }
        return true;
    }, list);
    return (0, $dus6D.keymap)(list);
};



var $1S4f7 = parcelRequire("1S4f7");




function $5f08c681b4ce337a$export$ae829ec7b2625219(dispatch, imageEnabled, aiEnabled) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $gahkt.pluginKey),
        state: {
            init () {
                return {
                    isVisible: false,
                    imageEnabled: imageEnabled,
                    aiEnabled: aiEnabled
                };
            },
            apply (tr, _value, state) {
                const isVisible = tr.getMeta((0, $gahkt.pluginKey));
                const currentState = (0, $gahkt.pluginKey).getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    const newState = {
                        ...currentState,
                        isVisible: isVisible
                    };
                    dispatch((0, $gahkt.pluginKey), newState);
                    return newState;
                }
                return currentState;
            }
        }
    });
}






var $4wH3g = parcelRequire("4wH3g");


const $e7c3914720548bcc$export$e97fc21b7bb6adc7 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f2Q5_",
    name: "HelpDialogLoader",
    loader: ()=>(parcelRequire("lwSOw")).then((mod)=>mod.default),
    loading: ()=>null
});


/**
 * Normalise the caller-supplied config into a single, predictable shape.
 * – Boolean → "image uploads on/off", AI always off
 * – Object  → pick the two feature flags with sane defaults (both false)
 */ function $c9ac4952ee5dccb4$var$parseFeatureConfig(config) {
    if (typeof config === 'boolean') return {
        imageUploadProviderExists: config,
        aiEnabled: false
    };
    // Object path – ensure we never return undefined
    const { imageUploadProviderExists: imageUploadProviderExists = false, aiEnabled: aiEnabled = false } = config ?? {};
    return {
        imageUploadProviderExists: imageUploadProviderExists,
        aiEnabled: aiEnabled
    };
}
const $c9ac4952ee5dccb4$export$b3faa25d392107e4 = ({ config: config, api: api })=>{
    const { imageUploadProviderExists: imageUploadProviderExists, aiEnabled: aiEnabled } = $c9ac4952ee5dccb4$var$parseFeatureConfig(config);
    return {
        name: 'helpDialog',
        pmPlugins () {
            return [
                {
                    name: 'helpDialog',
                    plugin: ({ dispatch: dispatch })=>(0, $5f08c681b4ce337a$export$ae829ec7b2625219)(dispatch, imageUploadProviderExists, aiEnabled)
                },
                {
                    name: 'helpDialogKeymap',
                    plugin: ()=>(0, $589bcaa98e35f270$export$e832373cff8dec22)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'helpdialog',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).help),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).helpDescription),
                        keywords: [
                            '?'
                        ],
                        priority: 4000,
                        keyshortcut: (0, $hgeg8.tooltip)((0, $hgeg8.openHelp)),
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                label: "",
                                color: "currentColor",
                                spacing: "spacious"
                            }),
                        action (insert) {
                            const tr = insert('');
                            (0, $bQUgf.openHelpCommand)(tr);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).HELP_OPENED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).HELP,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HELP_QUICK_INSERT,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        },
        contentComponent ({ editorView: editorView }) {
            if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (!editorView || (0, $eTj7Y.isSSR)())) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $e7c3914720548bcc$export$e97fc21b7bb6adc7), {
                pluginInjectionApi: api,
                // temp non null assertion until platform_editor_hydratable_ui cleaned up
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                editorView: editorView,
                quickInsertEnabled: !!api?.quickInsert
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $gahkt.pluginKey).getState(editorState) || null;
        },
        actions: {
            openHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $6a5a8122447a2b1d$export$2dac2f8389fd3a8c)(tr));
            },
            closeHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $6a5a8122447a2b1d$export$c54ba5c26d7768da)(tr));
            }
        }
    };
};
module.exports["helpDialogPlugin"] = $c9ac4952ee5dccb4$export$b3faa25d392107e4;

});

parcelRegister("bQUgf", function(module, exports) {

var $gahkt = parcelRequire("gahkt");

const $63a600b01f270da8$export$e7832c5f11de3579 = (tr, dispatch)=>{
    tr = tr.setMeta((0, $gahkt.pluginKey), true);
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
const $63a600b01f270da8$export$fd5f4180482ea9ed = (tr, dispatch)=>{
    tr = tr.setMeta((0, $gahkt.pluginKey), false);
    dispatch(tr);
};
module.exports["openHelpCommand"] = $63a600b01f270da8$export$e7832c5f11de3579;
module.exports["closeHelpCommand"] = $63a600b01f270da8$export$fd5f4180482ea9ed;

});

parcelRegister("lwSOw", function(module, exports) {

let $fac71b016896ce7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fac71b016896ce7d$var$load("9p2N9").then(()=>parcelRequire('ldhE1'));

});

parcelRegister("cWFvG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $1S4f7 = parcelRequire("1S4f7");


var $iHzeA = parcelRequire("iHzeA");


var $ks2lK = parcelRequire("ks2lK");


var $8QL6C = parcelRequire("8QL6C");


var $dh538 = parcelRequire("dh538");


var $ftpVl = parcelRequire("ftpVl");


var $1oCLl = parcelRequire("1oCLl");


var $aPufn = parcelRequire("aPufn");


const $60012dd187d0d1ed$export$a1a01149851636f0 = (portalProviderAPI, eventDispatcher, providerFactory, options = {}, api)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return (0, $aPufn.ReactMediaGroupNode)(portalProviderAPI, eventDispatcher, providerFactory, options, api);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'mediaGroup',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("aPufn"))).then(({ ReactMediaGroupNode: ReactMediaGroupNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaGroupNode(portalProviderAPI, eventDispatcher, providerFactory, options, api)(node, view, getPos);
                };
            });
            return result;
        }
    });
};






const $aaffc5069c492c8e$export$c4ddfa4daf804695 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'mediaInline',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("bLrKs")).then(({ ReactMediaInlineNode: ReactMediaInlineNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)(node, view, getPos);
                };
            });
            return result;
        }
    });
};





parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");





var $gAARK = parcelRequire("gAARK");


var $dYBVS = parcelRequire("dYBVS");


var $kUXwW = parcelRequire("kUXwW");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $Girkv = parcelRequire("Girkv");





var $aRHMp = parcelRequire("aRHMp");


var $kjHnW = parcelRequire("kjHnW");


var $ljMUG = parcelRequire("ljMUG");

const $dadb75f02854ce81$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider
    };
};
const $dadb75f02854ce81$var$MediaNodeWithProviders = ({ pluginInjectionApi: pluginInjectionApi, innerComponent: innerComponent })=>{
    const { mediaProvider: mediaProvider } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $dadb75f02854ce81$var$selector);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    return innerComponent({
        mediaProvider: mediaProvider ? Promise.resolve(mediaProvider) : undefined,
        interactionState: interactionState
    });
};
function $dadb75f02854ce81$var$isMediaDecorationSpec(decoration) {
    return decoration.spec.type !== undefined && decoration.spec.selected !== undefined;
}
class $dadb75f02854ce81$var$MediaNodeView extends (0, $kUXwW.SelectionBasedNodeView) {
    getMediaSingleNode(getPos) {
        const pos = getPos();
        if (typeof pos !== 'number') return null;
        const $pos = this.view.state.doc.resolve(pos);
        // The parent of the media node should be mediaSingle
        if ($pos.parent && $pos.parent.type.name === 'mediaSingle') return $pos.parent;
        return null;
    }
    getMaxWidthFromMediaSingleNode(mediaSingleNode) {
        const { width: widthAttr, widthType: widthTypeAttr, layout: layoutAttr } = mediaSingleNode.attrs;
        // for extended mediaSingle nodes with width and widthType attributes ( default behaviour )
        if (widthAttr && widthTypeAttr === 'pixel') return widthAttr;
        // for legacy mediaSingle nodes without widthType attribute
        switch(layoutAttr){
            case 'full-width':
                return 0, $aFUXX.akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, $aFUXX.akEditorCalculatedWideLayoutWidth;
            default:
                return 0, $aFUXX.akEditorDefaultLayoutWidth;
        }
    }
    createDomRef() {
        const domRef = document.createElement('div');
        if (this.reactComponentProps.mediaOptions && this.reactComponentProps.mediaOptions.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
        if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) this.resizeListenerBinding = (0, $fFa3V.bind)(domRef, {
            type: 'resized',
            listener: this.hasResizedListener
        });
        return domRef;
    }
    viewShouldUpdate(nextNode, decorations) {
        const hasMediaNodeSelectedDecoration = decorations.some((decoration)=>$dadb75f02854ce81$var$isMediaDecorationSpec(decoration) && decoration.spec.type === 'media' && decoration.spec.selected);
        if (this.isSelected !== hasMediaNodeSelectedDecoration) {
            this.isSelected = hasMediaNodeSelectedDecoration;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode, decorations);
    }
    stopEvent(event) {
        // Don't trap right click events on media node
        if ([
            'mousedown',
            'contextmenu'
        ].indexOf(event.type) !== -1) {
            const mouseEvent = event;
            if (mouseEvent.button === 2) return true;
        }
        return false;
    }
    getAttrs() {
        const { attrs: attrs } = this.node;
        return attrs;
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return (0, $kjHnW.isMediaBlobUrlFromAttrs)(attrs);
    }
    render() {
        const { providerFactory: providerFactory } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dYBVS.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: this.renderMediaNodeWithProviders
        });
    }
    destroy() {
        if (this.resizeListenerBinding) this.resizeListenerBinding();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        this.isSelected = false;
        this.hasBeenResized = false;
        this.resizeListenerBinding = void 0;
        this.hasResizedListener = ()=>{
            if (!this.hasBeenResized) {
                this.hasBeenResized = true;
                this.update(this.node, this.decorations);
            }
        };
        this.onExternalImageLoaded = (dimensions)=>{
            const getPos = this.getPos;
            const { width: width, height: height, ...rest } = this.getAttrs();
            if (!width || !height) (0, $aRHMp.updateCurrentMediaNodeAttrs)({
                ...rest,
                width: width || dimensions.width,
                height: height || dimensions.height
            }, {
                node: this.node,
                getPos: getPos
            }, true)(this.view.state, this.view.dispatch);
        };
        this.getMaxCardDimensions = ()=>{
            const flexibleDimensions = {
                width: '100%',
                height: '100%'
            };
            if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
                const pos = this.getPos();
                if (typeof pos !== 'number') return flexibleDimensions;
                if (this.hasBeenResized) return flexibleDimensions;
                const mediaSingleNodeParent = this.getMediaSingleNode(this.getPos);
                // If media parent not found, return default
                if (!mediaSingleNodeParent) return flexibleDimensions;
                // Compute normal dimensions
                const maxWidth = this.getMaxWidthFromMediaSingleNode(mediaSingleNodeParent);
                return {
                    width: `${maxWidth}px`,
                    height: '100%'
                };
            }
            return flexibleDimensions;
        };
        this.getMediaProviderToUse = (mediaOptions, mediaProvider)=>{
            if (mediaProvider) return mediaProvider;
            if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return mediaOptions.provider;
            if ((0, $1oCLl.expValEquals)('platform_editor_ssr_renderer', 'isEnabled', true)) return mediaOptions.syncProvider ? Promise.resolve(mediaOptions.syncProvider) : mediaOptions.provider;
        };
        this.renderMediaNodeWithState = (contextIdentifierProvider)=>{
            return ({ mediaProvider: mediaProvider, interactionState: interactionState })=>{
                const getPos = this.getPos;
                const { mediaOptions: mediaOptions } = this.reactComponentProps;
                const attrs = this.getAttrs();
                const url = attrs.type === 'external' ? attrs.url : '';
                let { width: width, height: height } = attrs;
                if (this.isMediaBlobUrl()) {
                    const urlAttrs = (0, $Girkv.getAttrsFromUrl)(url);
                    if (urlAttrs) {
                        const { width: urlWidth, height: urlHeight } = urlAttrs;
                        width = width || urlWidth;
                        height = height || urlHeight;
                    }
                }
                width = width || (0, $gAARK.DEFAULT_IMAGE_WIDTH);
                height = height || (0, $gAARK.DEFAULT_IMAGE_HEIGHT);
                const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
                // mediaSingle defines the max dimensions, so we don't need to constrain twice.
                const maxDimensions = this.getMaxCardDimensions();
                const originalDimensions = {
                    width: width,
                    height: height
                };
                const isSelectedAndInteracted = this.nodeInsideSelection() && interactionState !== 'hasNotHadInteraction';
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ljMUG.default), {
                    api: pluginInjectionApi,
                    view: this.view,
                    node: this.node,
                    getPos: getPos,
                    selected: isSelectedAndInteracted,
                    originalDimensions: originalDimensions,
                    maxDimensions: maxDimensions,
                    url: url,
                    mediaProvider: this.getMediaProviderToUse(mediaOptions, mediaProvider),
                    syncProvider: mediaOptions.syncProvider,
                    contextIdentifierProvider: contextIdentifierProvider,
                    mediaOptions: mediaOptions,
                    onExternalImageLoaded: this.onExternalImageLoaded,
                    isViewOnly: this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view',
                    pluginInjectionApi: this.reactComponentProps.pluginInjectionApi
                });
            };
        };
        this.renderMediaNodeWithProviders = ({ contextIdentifierProvider: contextIdentifierProvider })=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
            return /*#__PURE__*/ (0, $l998X.jsx)($dadb75f02854ce81$var$MediaNodeWithProviders, {
                pluginInjectionApi: pluginInjectionApi,
                innerComponent: this.renderMediaNodeWithState(contextIdentifierProvider)
            });
        };
    }
}
const $dadb75f02854ce81$export$a8df8d02db5c2be0 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi)=>(node, view, getPos)=>{
        return new $dadb75f02854ce81$var$MediaNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi
        }).init();
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 



var $9K4OG = parcelRequire("9K4OG");








var $2gkmX = parcelRequire("2gkmX");





var $7iE7T = parcelRequire("7iE7T");





var $j5VfV = parcelRequire("j5VfV");

/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 






var $d7ZU3 = parcelRequire("d7ZU3");


var $7541v = parcelRequire("7541v");


var $cgtv4 = parcelRequire("cgtv4");

const $f3f1fa1eb42a1a56$export$6a0665148042092b = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    },
    placeholderWithDoubleClickPrompt: {
        id: "fabric.editor.captionPlaceholderWithDoubleClickPrompt",
        defaultMessage: "Add a caption - double-click to preview"
    }
});



var $kfJSC = parcelRequire("kfJSC");



var $4i54r = parcelRequire("4i54r");

var $1xbL9 = parcelRequire("1xbL9");


var $6CRn4 = parcelRequire("6CRn4");





var $8m4tT = parcelRequire("8m4tT");
















const $e9ac8e653661d18d$export$994ea9c3fa8e0b0c = (mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
        // node should have two children, media and caption
        if (mediaSingleNode.childCount !== 2) return false;
        if (dispatch) {
            const media = mediaSingleNode.child(0);
            const caption = mediaSingleNode.child(1);
            let tr = state.tr;
            tr = $e9ac8e653661d18d$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
const $e9ac8e653661d18d$export$a34e35a63d969ea1 = (editorAnalyticsAPI)=>(mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
            if (typeof mediaSingleNodePos !== 'number') return false;
            let tr = state.tr;
            // node should have one child, media
            if (mediaSingleNode.childCount !== 1) return false;
            if (dispatch) {
                const schema = state.schema;
                const media = mediaSingleNode.child(0);
                const caption = schema.nodes.caption.create();
                tr = state.tr.insert(mediaSingleNodePos + media.nodeSize + 1, caption);
                tr = $e9ac8e653661d18d$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
                tr.setMeta('scrollIntoView', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).ADDED,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CAPTION
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $e9ac8e653661d18d$var$setSelectionAtEndOfCaption = (tr, mediaSingleNodePos, mediaNodeSize, captionNodeSize)=>{
    return (0, $8m4tT.setTextSelection)(mediaSingleNodePos + mediaNodeSize + captionNodeSize)(tr);
};





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");









var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $6fnsQ = parcelRequire("6fnsQ");




function $7e89fb9539ad0768$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7e89fb9539ad0768$var$placeholder = /*#__PURE__*/ (0, $9K4OG.css)("color:", `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`, ";width:100%;text-align:center;margin-top:var(--ds-space-100, 8px)!important;display:block;");
const $7e89fb9539ad0768$var$placeholderText = {
    name: "o2x9s",
    styles: "color:var(--ds-text-subtlest, #6B6E76)"
};
const $7e89fb9539ad0768$var$placeholderButton = (0, $ecnYn.xcss)({
    width: '100%',
    marginTop: 'space.100'
});
const $7e89fb9539ad0768$export$283943db773aa526 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ onClick: onClick, placeholderMessage: placeholderMessage }, ref)=>{
    const handlePointerDown = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        onClick();
    }, [
        onClick
    ]);
    const computedPlaceholderMessage = placeholderMessage ? placeholderMessage : (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholder;
    // This issue is a temporary fix for users being able to edit captions on edge browsers. This will be removed
    // replaced with CaptionPlaceholderButton in the near future and this code can be removed.
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        css: $7e89fb9539ad0768$var$placeholder,
        onPointerDown: handlePointerDown,
        // This id is just used for setting styles at the moment, if it's needed for anything more specific
        // It may need to be generated to avoid overlap
        id: (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? (0, $gAARK.CAPTION_PLACEHOLDER_ID) : undefined,
        "data-id": (0, $gAARK.CAPTION_PLACEHOLDER_ID),
        "data-testid": "caption-placeholder"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), computedPlaceholderMessage)));
});
const $7e89fb9539ad0768$export$dfb3d25b53c36a0a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ onClick: onClick, placeholderMessage: placeholderMessage }, ref)=>{
    const intl = (0, $8C5kA.default)();
    const handleMouseDown = (0, $42omo.useCallback)((e)=>{
        // In firefox, button is focused when mouse down, which make editor lose focus
        // Hence we want to disabled it so that user can type in caption directly after click
        e.preventDefault();
    }, []);
    const computedPlaceholderMessage = placeholderMessage ? placeholderMessage : (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholder;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2W0qg.default), {
        ref: ref,
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onMouseDown: handleMouseDown,
        "data-id": (0, $gAARK.CAPTION_PLACEHOLDER_ID),
        testId: "caption-placeholder",
        padding: "space.0",
        xcss: $7e89fb9539ad0768$var$placeholderButton
    }, (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? // This id is just used for setting styles at the moment, if it's needed for anything more specific
    // It may need to be generated to avoid overlap
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $7e89fb9539ad0768$var$placeholderText,
        id: (0, $gAARK.CAPTION_PLACEHOLDER_ID)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), computedPlaceholderMessage)) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        color: "color.text.subtlest",
        size: "large"
    }, intl.formatMessage(computedPlaceholderMessage)));
});









var $55QXP = parcelRequire("55QXP");





var $fGYGE = parcelRequire("fGYGE");

const $21cddd0804e30885$var$selector = (states)=>{
    return {
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        annotations: states.annotationState?.annotations
    };
};
const $21cddd0804e30885$export$28b46719ed075ab4 = ({ api: api, mediaNode: mediaNode, view: view, getPos: getPos, isDrafting: isDrafting })=>{
    const [entered, setEntered] = (0, $42omo.useState)(false);
    const { selectedAnnotations: selectedAnnotations, isInlineCommentViewClosed: isInlineCommentViewClosed, annotations: annotations } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $21cddd0804e30885$var$selector);
    const { state: { schema: { nodes: { media: media }, marks: { annotation: annotation } } }, state: state, dispatch: dispatch } = view;
    const status = (0, $42omo.useMemo)(()=>{
        if (!selectedAnnotations || !mediaNode) return 'default';
        return selectedAnnotations.some((annotation)=>!!mediaNode.marks.find((mark)=>mark.attrs.id === annotation.id)) && !isInlineCommentViewClosed ? 'active' : 'default';
    }, [
        selectedAnnotations,
        isInlineCommentViewClosed,
        mediaNode
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (api?.annotation && mediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode } = api.annotation.actions;
            showCommentForBlockNode(mediaNode, (0, $55QXP.VIEW_METHOD).BADGE)(state, dispatch);
        }
    }, [
        api?.annotation,
        dispatch,
        mediaNode,
        state
    ]);
    const pos = getPos();
    const hasNoComments = !Number.isFinite(pos) || !annotations || !mediaNode || mediaNode.type !== media || mediaNode.marks.every((maybeAnnotation)=>maybeAnnotation.type !== annotation || !(maybeAnnotation.attrs.id in annotations) || annotations[maybeAnnotation.attrs.id]);
    if (!isDrafting && hasNoComments || !mediaNode) return null;
    const maybeMediaSingleElement = view.domAtPos(pos + 1).node;
    const mediaSingleElement = maybeMediaSingleElement instanceof HTMLElement ? maybeMediaSingleElement : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fGYGE.CommentBadgeNext), {
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        status: entered ? 'entered' : status,
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false)
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $3UbBx = parcelRequire("3UbBx");

var $7U0RE = parcelRequire("7U0RE");

var $5dl3F = parcelRequire("5dl3F");


var $lqWNh = parcelRequire("lqWNh");











var $grxv4 = parcelRequire("grxv4");

const $41126833ee1e2d2e$export$9573295345282b3b = async (mediaNode, mediaClientConfig)=>{
    if (mediaNode.attrs.type === 'external') return 'external';
    if (!mediaNode.attrs.id) return;
    try {
        const fileState = await (0, $grxv4.getMediaClient)(mediaClientConfig).file.getCurrentState(mediaNode.attrs.id, {
            collectionName: mediaNode.attrs.collection
        });
        if (fileState && fileState.status !== 'error') return fileState.mediaType;
    } catch (err) {
    // return undefined in case of media client error
    }
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $1OLls = parcelRequire("1OLls");

const $a74304b3b403353a$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("&>div{", (0, $1OLls.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;}");


class $7ce4a81fe848dded$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = (0, $kfJSC.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, this.wrapper);
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        // Handle undo, when the actual pctWidth changed,
        // we sync up with the internal state.
        if (prevProps.pctWidth !== this.props.pctWidth) this.setState({
            resizedPctWidth: this.props.pctWidth
        });
        return true;
    }
    get wrappedLayout() {
        return (0, $3UbBx.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    async componentDidMount() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.props;
        if (viewMediaClientConfig) await this.checkVideoFile(viewMediaClientConfig);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.viewMediaClientConfig !== nextProps.viewMediaClientConfig) this.checkVideoFile(nextProps.viewMediaClientConfig);
        if (this.props.layout !== nextProps.layout) this.checkLayout(this.props.layout, nextProps.layout);
    }
    async checkVideoFile(viewMediaClientConfig) {
        const $pos = this.$pos;
        if (!$pos || !viewMediaClientConfig) return;
        const mediaNode = this.props.view.state.doc.nodeAt($pos.pos + 1);
        const mediaType = mediaNode ? await (0, $41126833ee1e2d2e$export$9573295345282b3b)(mediaNode, viewMediaClientConfig) : undefined;
        const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
        if (this.state.isVideoFile !== isVideoFile) this.setState({
            isVideoFile: isVideoFile
        });
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    get insideLayout() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { layoutColumn: layoutColumn } = this.props.view.state.schema.nodes;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            layoutColumn
        ]);
    }
    render() {
        const { width: origWidth, height: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, selected: selected, children: children } = this.props;
        const initialWidth = this.calcPxWidth(); // width with padding
        let ratio;
        if (origWidth) ratio = (origHeight / origWidth * 100).toFixed(3);
        const enable = {};
        (0, $7U0RE.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
                if (this.props.disableHandles) {
                    enable[side] = false;
                    return;
                }
            }
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7U0RE.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const snapPointsProps = {
            $pos: this.$pos,
            akEditorWideLayoutWidth: (0, $aFUXX.akEditorWideLayoutWidth),
            allowBreakoutSnapPoints: this.props.allowBreakoutSnapPoints,
            containerWidth: this.props.containerWidth,
            gridSize: this.props.gridSize,
            gridWidth: this.gridWidth,
            insideInlineLike: this.insideInlineLike,
            insideLayout: this.insideLayout,
            isVideoFile: this.state.isVideoFile,
            lineLength: this.props.lineLength,
            offsetLeft: this.state.offsetLeft,
            wrappedLayout: this.wrappedLayout
        };
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-025, 0.125em)"} * -0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-025, 0.125em)"} * -0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: this.saveWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $a74304b3b403353a$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                containerWidth: containerWidth || origWidth,
                fullWidthMode: fullWidthMode,
                width: origWidth
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dl3F.default), {
            ...this.props,
            displayGrid: this.displayGrid,
            ratio: ratio,
            width: initialWidth,
            selected: selected,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: (0, $lqWNh.calculateSnapPoints)(snapPointsProps),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "media",
            dispatchAnalyticsEvent: this.props.dispatchAnalyticsEvent,
            // when cursor is located below a media with caption,
            // press “Up“ key will result cursor focus on an invalid position, (on the resize handler)
            // This workaround adds an empty div inside the resize handler to prevent the issue.
            handleComponentFunc: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    contentEditable: false
                }),
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable())
        }, children));
    }
    constructor(...args){
        super(...args);
        this.hasResized = false;
        this.state = {
            offsetLeft: (0, $kfJSC.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, undefined),
            isVideoFile: false
        };
        this.displayGrid = (visible, gridType, highlight)=>{
            const { pluginInjectionApi: pluginInjectionApi, view: view } = this.props;
            pluginInjectionApi?.grid?.actions?.displayGrid(view)({
                visible: visible,
                gridType: gridType,
                highlight: highlight
            });
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            if (!this.hasResized && (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
                const mediaDomEl = this.wrapper?.querySelector('div[data-prosemirror-node-name="media"]');
                if (mediaDomEl) {
                    const event = new CustomEvent('resized');
                    mediaDomEl?.dispatchEvent(event);
                }
                this.hasResized = true;
            }
            const newPct = (0, $3UbBx.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= (0, $aFUXX.akEditorWideLayoutWidth)) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $3UbBx.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { width: origWidth = 0, height: origHeight, layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $3UbBx.calcMediaPxWidth)({
                origWidth: origWidth,
                origHeight: origHeight,
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $7U0RE.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, panel: panel } = this.props.view.state.schema.nodes;
            if (this.$pos && !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel
            ].filter(Boolean))) return [];
            if (snapWidth > (0, $aFUXX.akEditorWideLayoutWidth)) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $3UbBx.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
        this.saveWrapper = (wrapper)=>this.wrapper = wrapper;
    }
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $2daQU = parcelRequire("2daQU");


var $8Yfbq = parcelRequire("8Yfbq");


var $2XqLN = parcelRequire("2XqLN");

const $24a81e51b8a90adc$export$4ff81dc131aec9c3 = 'media_';
const $24a81e51b8a90adc$export$74e673d6ab2f5668 = 'grid_';



var $4HPW1 = parcelRequire("4HPW1");

const $d15ef98cbe5c71b0$export$5ea7b9558ea477a = (mediaSingleWidth, snapArray, guidelineSnaps, snapGap = 0)=>{
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - mediaSingleWidth) < Math.abs(snapArray[prev] - mediaSingleWidth) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - mediaSingleWidth);
    if (gap < snapGap) {
        const snappingWidth = snapArray[closestGapIndex];
        const guidelineKeys = [];
        // find wich guideline have the matching snap width
        guidelineSnaps.forEach((gs)=>{
            if (gs.width === snappingWidth) guidelineKeys.push(gs.guidelineKey);
        });
        const defaultGuidelineKeys = guidelineKeys.filter((guidelineKey)=>!guidelineKey.startsWith((0, $24a81e51b8a90adc$export$4ff81dc131aec9c3)));
        return {
            gap: gap,
            // only highlight default guidelines
            // when there are both default and dynamic guidelines to be highlighted
            keys: defaultGuidelineKeys.length && defaultGuidelineKeys.length < guidelineKeys.length ? defaultGuidelineKeys : guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};
const $d15ef98cbe5c71b0$export$da9fa72115c158e6 = (0, $2XqLN.default)((guidelines, editorWidth, layout = 'center')=>{
    const offset = editorWidth / 2;
    const getPositionX = (position)=>{
        return (0, $4HPW1.isVerticalPosition)(position) ? position.x : 0;
    };
    const calcXSnaps = (guidelineReference)=>{
        const snapsWidth = guidelineReference.filter((g)=>g.width > 0).map((g)=>g.width);
        const uniqueSnapWidth = [
            ...new Set(snapsWidth)
        ];
        return snapsWidth.length ? uniqueSnapWidth : undefined;
    };
    const guidelinesSnapsReference = guidelines.map((guideline)=>{
        const positionX = getPositionX(guideline.position);
        if ([
            'align-end',
            'wrap-right'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: offset - positionX
        };
        else if ([
            'align-start',
            'wrap-left'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: positionX + offset
        };
        return {
            guidelineKey: guideline.key,
            width: Math.abs(positionX) * 2
        };
    });
    return {
        guidelineReference: guidelinesSnapsReference,
        snaps: {
            x: calcXSnaps(guidelinesSnapsReference)
        }
    };
});













const $f0fea36e9642cf24$var$getDefaultGuidelines = (0, $2XqLN.default)((editorWidth)=>{
    return [
        -6,
        -5,
        -4,
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((val, index)=>({
            key: `grid_${index}`,
            position: {
                x: (0, $kfJSC.roundToNearest)(val / 12 * editorWidth)
            }
        }));
});
const $f0fea36e9642cf24$var$getWideGuidelines = (0, $2XqLN.default)((editorWidth)=>{
    const wideSpacing = (0, $kfJSC.roundToNearest)(editorWidth * (0, $aFUXX.breakoutWideScaleRatio) / 2);
    return [
        {
            key: `wide_left`,
            position: {
                x: -wideSpacing
            }
        },
        {
            key: `wide_right`,
            position: {
                x: wideSpacing
            }
        }
    ];
});
const $f0fea36e9642cf24$var$getFullWidthGuidelines = (0, $2XqLN.default)((containerWidth)=>{
    const fullWidth = (0, $kfJSC.roundToNearest)((0, $4HPW1.getContainerWidthOrFullEditorWidth)(containerWidth));
    return [
        {
            key: `full_width_left`,
            position: {
                x: -fullWidth
            }
        },
        {
            key: `full_width_right`,
            position: {
                x: fullWidth
            }
        }
    ];
});
const $f0fea36e9642cf24$export$9e51f24cdc2ab89d = (editorWidth, containerWidth, isFullWidthMode = false)=>{
    const innerGrids = $f0fea36e9642cf24$var$getDefaultGuidelines(editorWidth);
    const wideGuidelines = !isFullWidthMode ? $f0fea36e9642cf24$var$getWideGuidelines(editorWidth) : [];
    const fullWidthGuidelines = !isFullWidthMode ? $f0fea36e9642cf24$var$getFullWidthGuidelines(containerWidth) : [];
    return [
        ...innerGrids,
        ...wideGuidelines,
        ...fullWidthGuidelines
    ];
};














const $8a1609210ad17657$export$54d414ee882d8753 = (state, editorWidth, styles = {})=>{
    const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
    const offset = editorWidth / 2;
    return (0, $8m4tT.findChildren)(state.tr.doc, (node)=>node.type === state.schema.nodes.mediaSingle).reduce((acc, nodeWithPos, index)=>{
        const { node: node, pos: pos } = nodeWithPos;
        // if the current node the selected node
        // or the node is not using pixel width,
        // We will skip the node.
        if (selectedNode === node || node.attrs.widthType !== 'pixel') return acc;
        const $pos = state.tr.doc.resolve(pos);
        if ($pos.parent.type !== state.schema.nodes.doc) return acc;
        const dimensions = (0, $4HPW1.getMediaSingleDimensions)(node, editorWidth);
        if (!dimensions) return acc;
        const { width: width, height: height } = dimensions;
        const dynamicGuides = [
            ...acc.dynamicGuides,
            ...$8a1609210ad17657$var$getDynamicGuides(node.attrs.layout, width, offset, `${(0, $24a81e51b8a90adc$export$4ff81dc131aec9c3)}${index}`, styles)
        ];
        const accRelativeGuidesWidth = acc.relativeGuides?.width || {};
        const accRelativeGuidesHeight = acc.relativeGuides?.height || {};
        const relativeGuidesWidth = {
            ...accRelativeGuidesWidth,
            [width]: [
                ...accRelativeGuidesWidth[width] || [],
                nodeWithPos
            ]
        };
        const relativeGuidesWidthHeight = {
            ...accRelativeGuidesHeight,
            [Math.round(height)]: [
                ...accRelativeGuidesHeight[height] || [],
                nodeWithPos
            ]
        };
        return {
            dynamicGuides: dynamicGuides,
            relativeGuides: {
                width: relativeGuidesWidth,
                height: relativeGuidesWidthHeight
            }
        };
    }, {
        relativeGuides: {
            width: {},
            height: {}
        },
        dynamicGuides: []
    });
};
const $8a1609210ad17657$var$getDynamicGuides = (layout, width, offset, key, styles)=>{
    switch(layout){
        case 'align-start':
        case 'wrap-left':
            return [
                {
                    position: {
                        x: (0, $kfJSC.roundToNearest)(width - offset)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'align-end':
        case 'wrap-right':
            return [
                {
                    position: {
                        x: (0, $kfJSC.roundToNearest)(offset - width)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'center':
            return [
                {
                    position: {
                        x: (0, $kfJSC.roundToNearest)(width / 2)
                    },
                    key: `${key}_right`,
                    ...styles
                },
                {
                    position: {
                        x: -(0, $kfJSC.roundToNearest)(width / 2)
                    },
                    key: `${key}_left`,
                    ...styles
                }
            ];
        default:
            return [];
    }
};


var $6MTPr = parcelRequire("6MTPr");








const $a86bed1504ad2cb8$var$RELATIVE_GUIDES_GAP = 6;
const $a86bed1504ad2cb8$var$getWidthRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $4HPW1.getMediaSingleDimensions)(node, editorWidth) || {};
    const y = top - topOffset - $a86bed1504ad2cb8$var$RELATIVE_GUIDES_GAP;
    if (!width || !height || y < 0 || y > viewHeight) return null;
    let start = 0;
    let end = 0;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            start = -editorWidth / 2;
            end = start + width;
            break;
        case 'align-end':
        case 'wrap-right':
            end = editorWidth / 2;
            start = end - width;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            end = width / 2;
            start = -end;
            break;
        default:
    }
    return {
        key: key,
        position: {
            y: y,
            x: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $a86bed1504ad2cb8$var$getHeightRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $4HPW1.getMediaSingleDimensions)(node, editorWidth) || {};
    if (!width || !height) return null;
    const start = top - topOffset;
    const end = start + height;
    if (end < 0 || start > viewHeight) return null;
    let x = 0;
    const halfWidth = editorWidth / 2;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            x = width - halfWidth;
            break;
        case 'align-end':
        case 'wrap-right':
            x = halfWidth;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            x = width / 2;
            break;
        default:
            x = 0;
    }
    return {
        key: key,
        position: {
            x: x + $a86bed1504ad2cb8$var$RELATIVE_GUIDES_GAP,
            y: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $a86bed1504ad2cb8$export$ec77024f2efeedc5 = (relativeGuides, aspectRatio)=>{
    const snapsWidthFromMatchingHeight = Object.keys(relativeGuides.height || {}).map((heightKey)=>{
        const height = Number.parseInt(heightKey);
        return (0, $kfJSC.roundToNearest)(height * aspectRatio);
    });
    const snapsWidthFromMatchingWidth = Object.keys(relativeGuides.width || {}).map((widthKey)=>{
        return Number.parseInt(widthKey);
    });
    return [
        ...snapsWidthFromMatchingWidth,
        ...snapsWidthFromMatchingHeight
    ];
};
const $a86bed1504ad2cb8$export$73b4064129fc756b = (relativeGuides, nodeWithPos, view, editorWidth, topOffset, size)=>{
    const matchWidth = relativeGuides.width ? relativeGuides.width[Math.round(size.width)] : [];
    const matchHeight = relativeGuides.height ? relativeGuides.height[Math.round(size.height)] : [];
    const matches = matchWidth || matchHeight;
    const getRelativeGuideline = matchWidth && $a86bed1504ad2cb8$var$getWidthRelativeGuideline || matchHeight && $a86bed1504ad2cb8$var$getHeightRelativeGuideline || null;
    if (matches && getRelativeGuideline) return [
        getRelativeGuideline('relative_guide_current', view, nodeWithPos, editorWidth, topOffset, size),
        ...matches.map((nodeWithPos, index)=>{
            return getRelativeGuideline(`relative_guide_${index}`, view, nodeWithPos, editorWidth, topOffset);
        })
    ].filter((config)=>!!config);
    return [];
};








var $8b5jG = parcelRequire("8b5jG");


var $7QdQz = parcelRequire("7QdQz");

var $gnMzP = parcelRequire("gnMzP");






















var $iu6m9 = parcelRequire("iu6m9");





var $7WMqe = parcelRequire("7WMqe");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $726c48e98d1420ae$var$NOTIFICATION_SIZE = 8;
const $726c48e98d1420ae$var$SPACE_FROM_EDGE = "var(--ds-space-100, 8px)";
const $726c48e98d1420ae$export$210d1a6e59f1b30e = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    top: $726c48e98d1420ae$var$SPACE_FROM_EDGE,
    right: `calc(${"var(--ds-space-150, 12px)"} + ${$726c48e98d1420ae$var$SPACE_FROM_EDGE})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-warning-bold, ${$6fnsQ.Y300})`,
    borderRadius: "var(--ds-radius-full, 50%)",
    width: `${$726c48e98d1420ae$var$NOTIFICATION_SIZE}px`,
    height: `${$726c48e98d1420ae$var$NOTIFICATION_SIZE}px`,
    pointerEvents: 'none'
});


const $2efaf76f8b80841b$export$239acce4d7b54ab1 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "resizable-media-migration-notification",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $726c48e98d1420ae$export$210d1a6e59f1b30e)
        ]
    });
};



const $ff4d3fbedfa1b27c$export$fe623d3106c02058 = 'mediaSingle.resizerNext.testid';
const $ff4d3fbedfa1b27c$var$getNodePosition = (getPos)=>{
    if (typeof getPos !== 'function') return null;
    const pos = getPos();
    if (Number.isNaN(pos) || typeof pos !== 'number') return null;
    return pos;
};
const $ff4d3fbedfa1b27c$var$calcPxHeight = (props)=>{
    const { newWidth: newWidth, previousWidth: previousWidth, previousHeight: previousHeight } = props;
    return Math.round(previousHeight / previousWidth * newWidth);
};
const $ff4d3fbedfa1b27c$var$calcMinWidth = ({ isVideoFile: isVideoFile, contentWidth: contentWidth })=>{
    return Math.min(contentWidth || (0, $aFUXX.akEditorDefaultLayoutWidth), isVideoFile ? (0, $gAARK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $ff4d3fbedfa1b27c$var$calcMaxWidth = ({ containerWidth: containerWidth, editorAppearance: editorAppearance })=>{
    return (0, $kfJSC.calcMediaSingleMaxWidth)(containerWidth, editorAppearance);
};
const $ff4d3fbedfa1b27c$var$setIsResizingPluginState = ({ isResizing: isResizing, nodePosition: nodePosition, initialWidth: initialWidth })=>(state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $j5VfV.MEDIA_PLUGIN_IS_RESIZING_KEY), isResizing);
        tr.setMeta('is-resizer-resizing', isResizing);
        if (isResizing && typeof nodePosition === 'number') tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, nodePosition));
        if (isResizing && typeof initialWidth === 'number') tr.setMeta((0, $j5VfV.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), initialWidth);
        if (dispatch) dispatch(tr);
        return true;
    };
const $ff4d3fbedfa1b27c$var$calcUnwrappedLayout = (width, containerWidth, contentWidth, fullWidthMode, isNestedNode)=>{
    if (isNestedNode) return 'center';
    if (fullWidthMode) {
        if (width < contentWidth) return 'center';
        return 'full-width';
    }
    // handle top-level node in fixed-width editor
    if (width <= contentWidth) return 'center';
    const padding = containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    if (width < Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth))) return 'wide';
    // set full width to be containerWidth - padding * 2
    // instead of containerWidth - akEditorBreakoutPadding,
    // so that we have image aligned with text
    return 'full-width';
};
const $ff4d3fbedfa1b27c$var$calcNewLayout = ({ layout: layout, containerWidth: containerWidth, lineLength: lineLength, fullWidthMode: fullWidthMode, isNestedNode: isNestedNode })=>(newWidth, stop)=>{
        const newPct = (0, $3UbBx.calcPctFromPx)(newWidth, lineLength) * 100;
        const wrappedLayout = (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1;
        if (newPct <= 100 && wrappedLayout) {
            if (!stop || newPct !== 100) return layout;
        }
        return $ff4d3fbedfa1b27c$var$calcUnwrappedLayout(newWidth, containerWidth, lineLength, fullWidthMode, isNestedNode);
    };
const $ff4d3fbedfa1b27c$var$calculateSizeState = (props)=>(size, delta, onResizeStop = false, aspectRatio)=>{
        const calculatedWidth = Math.round(size.width + delta.width);
        const calculatedWidthWithLayout = $ff4d3fbedfa1b27c$var$calcNewLayout(props)(calculatedWidth, onResizeStop);
        return {
            width: calculatedWidth,
            height: calculatedWidth / aspectRatio,
            layout: calculatedWidthWithLayout
        };
    };
const $ff4d3fbedfa1b27c$var$getAspectRatio = ({ width: width, height: height })=>{
    if (width && height > 0) return width / height;
    // TODO: ED-26962 - handle this case
    return 1;
};
const $ff4d3fbedfa1b27c$var$updateSizeInPluginState = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(({ width: width, view: view })=>{
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    tr.setMeta((0, $j5VfV.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), width);
    return dispatch(tr);
}, (0, $gAARK.MEDIA_SINGLE_RESIZE_THROTTLE_TIME));
const $ff4d3fbedfa1b27c$export$4198575e34ea4b65 = (props)=>{
    const { width: origWidth, children: children, containerWidth: containerWidth, fullWidthMode: fullWidthMode, layout: layout, selected: selected, showLegacyNotification: showLegacyNotification, className: className, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, getPos: getPos, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, height: height, nodeType: nodeType, pluginInjectionApi: pluginInjectionApi, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, forceHandlePositioning: forceHandlePositioning, disableHandles: disableHandles } = props;
    const initialWidth = (0, $42omo.useMemo)(()=>{
        return mediaSingleWidth || (0, $gAARK.DEFAULT_IMAGE_WIDTH);
    }, [
        mediaSingleWidth
    ]);
    const [dimensions, setDimensions] = (0, $42omo.useState)({
        width: initialWidth,
        height: $ff4d3fbedfa1b27c$var$calcPxHeight({
            newWidth: initialWidth,
            previousWidth: initialWidth,
            previousHeight: height
        })
    });
    const dimensionsRef = (0, $42omo.useRef)(dimensions);
    const lastSnappedGuidelineKeysRef = (0, $42omo.useRef)([]);
    const [snaps, setSnaps] = (0, $42omo.useState)({});
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const [isVideoFile, setIsVideoFile] = (0, $42omo.useState)(false);
    const [hasResized, setHasResized] = (0, $42omo.useState)(false);
    const nodePosition = (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? $ff4d3fbedfa1b27c$var$getNodePosition(getPos) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>$ff4d3fbedfa1b27c$var$getNodePosition(getPos), [
        getPos
    ]);
    const isNestedNode = (0, $42omo.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        return !!($pos && $pos.depth !== 0);
    }, [
        nodePosition,
        view
    ]);
    const isAdjacentMode = (0, $42omo.useMemo)(()=>{
        if (forceHandlePositioning === 'adjacent') return true;
        return isNestedNode;
    }, [
        isNestedNode,
        forceHandlePositioning
    ]);
    const maybeContainerWidth = containerWidth || origWidth;
    const memoizedCss = (0, $42omo.useMemo)(()=>{
        return (0, $a74304b3b403353a$export$c4d4f06a25de97f)({
            layout: layout,
            containerWidth: maybeContainerWidth,
            fullWidthMode: fullWidthMode,
            mediaSingleWidth: dimensions.width,
            isNestedNode: isAdjacentMode,
            isExtendedResizeExperienceOn: true
        });
    }, [
        layout,
        maybeContainerWidth,
        fullWidthMode,
        dimensions.width,
        isAdjacentMode
    ]);
    const maxWidth = (0, $42omo.useMemo)(()=>{
        if (editorAppearance === 'chromeless' && forceHandlePositioning === 'adjacent') return containerWidth - (0, $gAARK.MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN) * 2;
        if (!isResizing && isAdjacentMode) return undefined;
        if (isAdjacentMode || fullWidthMode) return lineLength;
        if (!isResizing && (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return `var(--ak-editor-max-container-width)`;
        return $ff4d3fbedfa1b27c$var$calcMaxWidth({
            containerWidth: containerWidth,
            editorAppearance: editorAppearance
        });
    }, [
        isAdjacentMode,
        fullWidthMode,
        lineLength,
        editorAppearance,
        containerWidth,
        isResizing,
        forceHandlePositioning
    ]);
    const minWidth = $ff4d3fbedfa1b27c$var$calcMinWidth({
        isVideoFile: isVideoFile,
        contentWidth: lineLength
    });
    // while is not resizing, we take 100% as min-width if the container width is less than the min-width
    const minViewWidth = isResizing ? minWidth : `min(${minWidth}px, 100%)`;
    const resizerNextClassName = (0, $42omo.useMemo)(()=>{
        const classNameNext = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $gnMzP.richMediaClassName), `image-${layout}`, isResizing ? 'is-resizing' : 'not-resizing', className, (0, $7QdQz.resizerItemClassName), {
            'display-handle': (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? selected && !disableHandles : selected,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        return classNameNext;
    }, [
        className,
        disableHandles,
        isResizing,
        layout,
        selected
    ]);
    const isInsideInlineLike = (0, $42omo.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        const { listItem: listItem } = view.state.schema.nodes;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }, [
        nodePosition,
        view
    ]);
    const enable = (0, $42omo.useMemo)(()=>{
        if (disableHandles && (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return {
            left: false,
            right: false
        };
        return (0, $7U0RE.handleSides).reduce((acc, side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            acc[side] = (0, $lqWNh.nonWrappedLayouts).concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7U0RE.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && isInsideInlineLike) acc[side] = false;
            return acc;
        }, {});
    }, [
        disableHandles,
        layout,
        isInsideInlineLike
    ]);
    const defaultGuidelines = (0, $42omo.useMemo)(()=>{
        if (isAdjacentMode) return [];
        return (0, $f0fea36e9642cf24$export$9e51f24cdc2ab89d)(lineLength, containerWidth, fullWidthMode);
    }, [
        isAdjacentMode,
        lineLength,
        containerWidth,
        fullWidthMode
    ]);
    const relativeGuidesRef = (0, $42omo.useRef)({});
    const guidelinesRef = (0, $42omo.useRef)([]);
    const updateGuidelines = (0, $42omo.useCallback)(()=>{
        const { relativeGuides: relativeGuides, dynamicGuides: dynamicGuides } = (0, $8a1609210ad17657$export$54d414ee882d8753)(view.state, lineLength, {
            styles: {
                lineStyle: 'dashed'
            },
            show: false
        });
        // disable guidelines for nested media single node
        const dynamicGuidelines = isAdjacentMode ? [] : dynamicGuides;
        relativeGuidesRef.current = relativeGuides;
        guidelinesRef.current = [
            ...defaultGuidelines,
            ...dynamicGuidelines
        ];
    }, [
        view,
        lineLength,
        defaultGuidelines,
        isAdjacentMode
    ]);
    const isGuidelineEnabled = (0, $42omo.useMemo)(()=>{
        return !!pluginInjectionApi?.guideline;
    }, [
        pluginInjectionApi
    ]);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        setIsResizing(true);
        $ff4d3fbedfa1b27c$var$setIsResizingPluginState({
            isResizing: true,
            nodePosition: nodePosition,
            initialWidth: dimensionsRef.current.width
        })(view.state, view.dispatch);
        if (isGuidelineEnabled) updateGuidelines();
    }, [
        view,
        nodePosition,
        updateGuidelines,
        isGuidelineEnabled
    ]);
    const getRelativeGuides = (0, $42omo.useCallback)(()=>{
        if (typeof nodePosition !== 'number') return [];
        const guidelinePluginState = pluginInjectionApi?.guideline?.sharedState?.currentState();
        const { top: topOffset } = guidelinePluginState?.rect || {
            top: 0,
            left: 0
        };
        const $pos = view.state.doc.resolve(nodePosition);
        const relativeGuides = $pos && $pos.nodeAfter && dimensionsRef.current.width ? (0, $a86bed1504ad2cb8$export$73b4064129fc756b)(relativeGuidesRef.current, {
            node: $pos.nodeAfter,
            pos: $pos.pos
        }, view, lineLength, topOffset, dimensionsRef.current) : [];
        return relativeGuides;
    }, [
        pluginInjectionApi,
        nodePosition,
        view,
        lineLength
    ]);
    const updateActiveGuidelines = (0, $42omo.useCallback)((width = 0, guidelines, guidelineSnapsReference)=>{
        if (!guidelineSnapsReference.snaps.x) return;
        const { gap: gap, keys: activeGuidelineKeys } = (0, $d15ef98cbe5c71b0$export$5ea7b9558ea477a)(width, guidelineSnapsReference.snaps.x, guidelineSnapsReference.guidelineReference, (0, $gAARK.MEDIA_SINGLE_SNAP_GAP));
        const relativeGuidelines = activeGuidelineKeys.length ? [] : getRelativeGuides();
        lastSnappedGuidelineKeysRef.current = activeGuidelineKeys.length ? activeGuidelineKeys : relativeGuidelines.map((rg)=>rg.key);
        const nextGuideLines = [
            ...(0, $6MTPr.getGuidelinesWithHighlights)(gap, (0, $gAARK.MEDIA_SINGLE_SNAP_GAP), activeGuidelineKeys, guidelines),
            ...relativeGuidelines
        ];
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: nextGuideLines
        });
    }, [
        getRelativeGuides,
        pluginInjectionApi,
        view
    ]);
    const aspectRatioRef = (0, $42omo.useRef)($ff4d3fbedfa1b27c$var$getAspectRatio({
        width: props.width,
        height: props.height
    }));
    const resizerContainerRef = (0, $42omo.useRef)(null);
    const handleResize = (0, $42omo.useCallback)((size, delta)=>{
        const { width: width, height: height, layout: newLayout } = $ff4d3fbedfa1b27c$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        const resizerDomEl = resizerContainerRef.current;
        if (resizerDomEl && !hasResized && (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
            // dispatch resize event to media node DOM element inside resizerDom
            const mediaDomEl = resizerDomEl.querySelector('div[data-prosemirror-node-name="media"]');
            const event = new CustomEvent('resized');
            mediaDomEl?.dispatchEvent(event);
            setHasResized(true);
        }
        if (isGuidelineEnabled) {
            const guidelineSnaps = (0, $d15ef98cbe5c71b0$export$da9fa72115c158e6)(guidelinesRef.current, lineLength, layout);
            updateActiveGuidelines(width, guidelinesRef.current, guidelineSnaps);
            const relativeSnaps = (0, $a86bed1504ad2cb8$export$ec77024f2efeedc5)(relativeGuidesRef.current, aspectRatioRef.current);
            setSnaps({
                x: [
                    ...guidelineSnaps.snaps.x || [],
                    ...relativeSnaps
                ]
            });
        }
        setDimensions({
            width: width,
            height: height
        });
        $ff4d3fbedfa1b27c$var$updateSizeInPluginState({
            width: width,
            view: view
        });
        if (newLayout !== layout) updateSize(width, newLayout);
    }, [
        layout,
        containerWidth,
        lineLength,
        fullWidthMode,
        isAdjacentMode,
        hasResized,
        isGuidelineEnabled,
        view,
        updateActiveGuidelines,
        updateSize
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((size, delta)=>{
        if (typeof nodePosition !== 'number') return;
        const { width: width, height: height, layout: newLayout } = $ff4d3fbedfa1b27c$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        if (dispatchAnalyticsEvent) {
            const $pos = view.state.doc.resolve(nodePosition);
            const event = (0, $7WMqe.getMediaResizeAnalyticsEvent)(nodeType || 'mediaSingle', {
                width: width,
                layout: newLayout,
                widthType: 'pixel',
                snapType: (0, $4HPW1.getGuidelineTypeFromKey)(lastSnappedGuidelineKeysRef.current, guidelinesRef.current),
                parentNode: $pos ? $pos.parent.type.name : undefined,
                inputMethod: 'mouse'
            });
            if (event) dispatchAnalyticsEvent(event);
        }
        setIsResizing(false);
        $ff4d3fbedfa1b27c$var$setIsResizingPluginState({
            isResizing: false
        })(view.state, view.dispatch);
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: []
        });
        let newWidth = width;
        if (newLayout === 'full-width') // When a node reaches full width in current viewport,
        // update its width with 1800 to align with pixel entry
        newWidth = (0, $aFUXX.akEditorFullWidthLayoutWidth);
        setDimensions({
            width: newWidth,
            height: height
        });
        updateSize(newWidth, newLayout);
    }, [
        nodeType,
        dispatchAnalyticsEvent,
        containerWidth,
        fullWidthMode,
        isAdjacentMode,
        layout,
        lineLength,
        view,
        nodePosition,
        pluginInjectionApi,
        updateSize
    ]);
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useLayoutEffect)(()=>{
        setDimensions({
            width: initialWidth,
            height: $ff4d3fbedfa1b27c$var$calcPxHeight({
                newWidth: initialWidth,
                previousWidth: initialWidth,
                previousHeight: height
            })
        });
    }, [
        initialWidth,
        height
    ]);
    (0, $42omo.useEffect)(()=>{
        dimensionsRef.current = dimensions;
    }, [
        dimensions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!viewMediaClientConfig || typeof nodePosition !== 'number') return;
        const mediaNode = view.state.doc.nodeAt(nodePosition + 1);
        if (!mediaNode) return;
        (0, $41126833ee1e2d2e$export$9573295345282b3b)(mediaNode, viewMediaClientConfig).then((mediaType)=>{
            if (mountedRef.current) {
                const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
                setIsVideoFile(isVideoFile);
            }
        });
    }, [
        view,
        viewMediaClientConfig,
        nodePosition
    ]);
    const handlePositioning = (0, $42omo.useMemo)(()=>{
        if (forceHandlePositioning) return forceHandlePositioning;
        return isAdjacentMode ? 'adjacent' : undefined;
    }, [
        forceHandlePositioning,
        isAdjacentMode
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: memoizedCss,
        ref: resizerContainerRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8b5jG.default), {
        minWidth: minViewWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerNextClassName,
        snapGap: (0, $gAARK.MEDIA_SINGLE_SNAP_GAP),
        enable: enable,
        width: dimensions.width,
        handleResizeStart: handleResizeStart,
        handleResize: handleResize,
        handleResizeStop: handleResizeStop,
        snap: snaps,
        resizeRatio: (0, $lqWNh.nonWrappedLayouts).includes(layout) ? 2 : 1,
        "data-testid": $ff4d3fbedfa1b27c$export$fe623d3106c02058,
        isHandleVisible: (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? selected && !disableHandles : selected,
        handlePositioning: handlePositioning,
        handleHighlight: "full-height"
    }, children, showLegacyNotification && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2efaf76f8b80841b$export$239acce4d7b54ab1), null)));
};
const $ff4d3fbedfa1b27c$var$ResizableMediaSingleToggle = ({ allowBreakoutSnapPoints: allowBreakoutSnapPoints, children: children, className: className, containerWidth: containerWidth, dataAttributes: dataAttributes, disableHandles: disableHandles, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, fullWidthMode: fullWidthMode, getPos: getPos, gridSize: gridSize, handleMediaSingleRef: handleMediaSingleRef, hasFallbackContainer: hasFallbackContainer, height: height, isInsideOfInlineExtension: isInsideOfInlineExtension, isLoading: isLoading, layout: layout, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, nodeType: nodeType, pctWidth: pctWidth, pluginInjectionApi: pluginInjectionApi, selected: selected, showLegacyNotification: showLegacyNotification, size: size, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, width: width, forceHandlePositioning: forceHandlePositioning })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($ff4d3fbedfa1b27c$export$4198575e34ea4b65, {
        allowBreakoutSnapPoints: allowBreakoutSnapPoints,
        // eslint-disable-next-line react/no-children-prop
        children: children,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        containerWidth: containerWidth,
        dataAttributes: dataAttributes,
        disableHandles: disableHandles,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAppearance: editorAppearance,
        fullWidthMode: fullWidthMode,
        getPos: getPos,
        gridSize: gridSize,
        handleMediaSingleRef: handleMediaSingleRef,
        hasFallbackContainer: hasFallbackContainer,
        height: height,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        isLoading: isLoading,
        layout: layout,
        lineLength: lineLength,
        mediaSingleWidth: mediaSingleWidth,
        nodeType: nodeType,
        pctWidth: pctWidth,
        pluginInjectionApi: pluginInjectionApi,
        selected: selected,
        showLegacyNotification: showLegacyNotification,
        size: size,
        updateSize: updateSize,
        view: view,
        viewMediaClientConfig: viewMediaClientConfig,
        width: width,
        forceHandlePositioning: forceHandlePositioning
    });
};
var $ff4d3fbedfa1b27c$export$2e2bcd8739ae039 = $ff4d3fbedfa1b27c$var$ResizableMediaSingleToggle;


const $07c27127ca815192$export$56340c4ef3ba9375 = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};



var $gEIpk = parcelRequire("gEIpk");


var $6ZrgC = parcelRequire("6ZrgC");

function $d8916929d7100ead$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8916929d7100ead$var$figureWrapperStyles = {
    name: "ti75j2",
    styles: "margin:0"
};
const $d8916929d7100ead$var$useMediaNodeUpdater = ({ mediaProvider: mediaProvider, mediaNode: mediaNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, mediaSingleNodeProps: mediaSingleNodeProps })=>{
    const previousMediaProvider = (0, $7541v.default)(mediaProvider);
    const previousMediaNode = (0, $7541v.default)(mediaNode);
    const mediaNodeUpdaterRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const createOrUpdateMediaNodeUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((props)=>{
        const mediaChildNode = mediaNode.firstChild;
        const updaterProps = {
            ...props,
            isMediaSingle: true,
            node: mediaChildNode ? mediaChildNode : mediaNode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        };
        if (!mediaNodeUpdaterRef.current) mediaNodeUpdaterRef.current = (0, $gEIpk.createMediaNodeUpdater)(updaterProps);
        else mediaNodeUpdaterRef.current.setProps(updaterProps);
    }, [
        mediaNode,
        dispatchAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Forced updates not required on mobile
        if (mediaSingleNodeProps.isCopyPasteEnabled === false) return;
        if (!mediaNodeUpdaterRef.current || previousMediaProvider !== mediaProvider) {
            createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
            mediaNodeUpdaterRef.current?.updateMediaSingleFileAttrs();
        } else if (mediaNode.firstChild && previousMediaNode?.firstChild && mediaNode.firstChild !== previousMediaNode?.firstChild) {
            const attrsChanged = (0, $07c27127ca815192$export$56340c4ef3ba9375)(previousMediaNode.firstChild.attrs, mediaNode.firstChild.attrs);
            if (attrsChanged) {
                createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
                // We need to call this method on any prop change since attrs can get removed with collab editing
                mediaNodeUpdaterRef.current?.updateMediaSingleFileAttrs();
            }
        }
    }, [
        createOrUpdateMediaNodeUpdater,
        mediaNode,
        mediaProvider,
        mediaSingleNodeProps,
        previousMediaNode,
        previousMediaProvider
    ]);
    return mediaNodeUpdaterRef.current;
};
const $d8916929d7100ead$var$mediaAsyncOperations = async (props)=>{
    const updatedDimensions = await props.updater.getRemoteDimensions();
    const currentAttrs = props.mediaChildNode.attrs;
    if (updatedDimensions && (currentAttrs?.width !== updatedDimensions.width || currentAttrs?.height !== updatedDimensions.height)) props.updater.updateDimensions(updatedDimensions);
    if (props.mediaChildNode.attrs.type === 'external' && props.mediaChildNode.attrs.__external) {
        const updatingNode = props.updater.handleExternalMedia(props.getPos);
        props.addPendingTask(updatingNode);
        await updatingNode;
        return;
    }
    const contextId = props.updater.getNodeContextId();
    if (!contextId) await props.updater.updateContextId();
    const shouldNodeBeDeepCopied = await props.updater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) try {
        const copyNode = props.updater.copyNode({
            traceId: props.mediaNode.attrs.__mediaTraceId
        });
        props.addPendingTask(copyNode);
        await copyNode;
    } catch  {}
};
const $d8916929d7100ead$var$useMediaAsyncOperations = ({ mediaNode: mediaNode, mediaNodeUpdater: mediaNodeUpdater, addPendingTask: addPendingTask, getPos: getPos })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!mediaNodeUpdater) return;
        // we want the first child of MediaSingle (type "media")
        const childNode = mediaNode.firstChild;
        if (!childNode) return;
        $d8916929d7100ead$var$mediaAsyncOperations({
            mediaChildNode: childNode,
            updater: mediaNodeUpdater,
            getPos: getPos,
            mediaNode: mediaNode,
            addPendingTask: addPendingTask
        });
    }, [
        mediaNode,
        addPendingTask,
        mediaNodeUpdater,
        getPos
    ]);
};
const $d8916929d7100ead$var$noop = ()=>{};
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $d8916929d7100ead$var$useLatestMediaNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $7541v.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!previousMediaNode || typeof previousMediaNode.eq !== 'function') return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $d8916929d7100ead$var$useMediaDimensionsLogic = ({ childMediaNodeAttrs: childMediaNodeAttrs })=>{
    const { width: originalWidth, height: originalHeight } = childMediaNodeAttrs;
    const isExternalMedia = childMediaNodeAttrs.type === 'external';
    const hasMediaUrlBlob = isExternalMedia && typeof childMediaNodeAttrs.url === 'string' && (0, $kjHnW.isMediaBlobUrlFromAttrs)(childMediaNodeAttrs);
    const urlBlobAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!hasMediaUrlBlob) return null;
        return (0, $Girkv.getAttrsFromUrl)(childMediaNodeAttrs.url);
    }, [
        hasMediaUrlBlob,
        childMediaNodeAttrs
    ]);
    const { width: width, height: height } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        // original width and height of child media node (scaled)
        let width = originalWidth;
        let height = originalHeight;
        if (isExternalMedia) {
            if (urlBlobAttrs) {
                if (urlBlobAttrs) {
                    const { width: urlWidth, height: urlHeight } = urlBlobAttrs;
                    width = width || urlWidth;
                    height = height || urlHeight;
                }
            }
            if (width === null) width = (0, $gAARK.DEFAULT_IMAGE_WIDTH);
            if (height === null) height = (0, $gAARK.DEFAULT_IMAGE_HEIGHT);
        }
        if (!width || !height) {
            width = (0, $gAARK.DEFAULT_IMAGE_WIDTH);
            height = (0, $gAARK.DEFAULT_IMAGE_HEIGHT);
        }
        return {
            width: width,
            height: height
        };
    }, [
        originalWidth,
        originalHeight,
        isExternalMedia,
        urlBlobAttrs
    ]);
    return {
        width: width,
        height: height
    };
};
const $d8916929d7100ead$var$useUpdateSizeCallback = ({ mediaNode: mediaNode, view: view, getPos: getPos })=>{
    const updateSize = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((width, layout)=>{
        const { state: state, dispatch: dispatch } = view;
        const pos = getPos();
        if (typeof pos === 'undefined') return;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...mediaNode.attrs,
            layout: layout,
            width: width,
            widthType: 'pixel'
        });
        tr.setMeta('scrollIntoView', false);
        /**
     * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
     * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
     * The recommended fix is to reset the selection.[2]
     *
     * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
     * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
     */ tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
        return dispatch(tr);
    }, [
        view,
        getPos,
        mediaNode
    ]);
    return updateSize;
};
/**
 * This value is used to fallback when widthState is undefined.
 *
 * Previously, the old MediaSingle was ignoring the undefined situation:
 *
 * <MediaSingleNode
 *	  width={widthState!.width}
 *	  lineLength={widthState!.lineLength}
 */ const $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH = 760;
const $d8916929d7100ead$export$4a00cdcfd685a172 = (mediaSingleNodeNextProps)=>{
    const { selected: selected, getPos: getPos, node: nextMediaNode, mediaOptions: mediaOptions, fullWidthMode: fullWidthMode, view: view, pluginInjectionApi: pluginInjectionApi, width: containerWidth, lineLength: lineLength, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorViewMode: editorViewMode, editorDisabled: editorDisabled, isDrafting: isDrafting, targetNodeId: targetNodeId, editorAppearance: editorAppearance, mediaProvider: mediaProviderPromise, forwardRef: forwardRef, contextIdentifierProvider: contextIdentifierProviderPromise, addPendingTask: addPendingTask } = mediaSingleNodeNextProps;
    const [mediaProvider, setMediaProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    const [_contextIdentifierProvider, setContextIdentifierProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const pos = getPos();
    const isSelected = selected();
    const contentWidthForLegacyExperience = (0, $kfJSC.getMaxWidthForNestedNode)(view, getPos()) || lineLength;
    const mediaNode = $d8916929d7100ead$var$useLatestMediaNode(nextMediaNode);
    const mediaNodeUpdater = $d8916929d7100ead$var$useMediaNodeUpdater({
        mediaNode: mediaNode,
        mediaSingleNodeProps: mediaSingleNodeNextProps,
        mediaProvider: mediaProvider,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent
    });
    $d8916929d7100ead$var$useMediaAsyncOperations({
        mediaNodeUpdater: mediaNodeUpdater,
        getPos: getPos,
        mediaNode: mediaNode,
        addPendingTask: addPendingTask || $d8916929d7100ead$var$noop
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        if (!mediaProviderPromise) return;
        mediaProviderPromise.then((resolvedProvider)=>{
            const { viewMediaClientConfig: viewMediaClientConfig } = resolvedProvider;
            if (mountedRef.current) {
                setViewMediaClientConfig(viewMediaClientConfig);
                setMediaProvider(resolvedProvider);
            }
        });
    }, [
        mediaProviderPromise
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!contextIdentifierProviderPromise) return;
        contextIdentifierProviderPromise.then((provider)=>{
            if (mountedRef.current) setContextIdentifierProvider(provider);
        });
    }, [
        contextIdentifierProviderPromise
    ]);
    const { layout: layout, widthType: widthType, width: mediaSingleWidthAttribute } = mediaNode.attrs;
    const childNode = mediaNode.firstChild;
    const childMediaNodeAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return childNode?.attrs || {};
    }, [
        childNode
    ]);
    const { width: width, height: height } = $d8916929d7100ead$var$useMediaDimensionsLogic({
        childMediaNodeAttrs: childMediaNodeAttrs
    });
    const updateSize = $d8916929d7100ead$var$useUpdateSizeCallback({
        view: view,
        getPos: getPos,
        mediaNode: mediaNode
    });
    const canResize = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        const result = Boolean(!!mediaOptions.allowResizing && !editorDisabled && !editorViewMode);
        if (mediaOptions.allowResizingInTables) return result;
        // If resizing not allowed in tables, check parents for tables
        const $pos = view.state.doc.resolve(pos);
        const { table: table } = view.state.schema.nodes;
        const disabledNode = !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            table
        ]);
        return Boolean(result && !disabledNode);
    }, [
        mediaOptions,
        pos,
        view,
        editorDisabled,
        editorViewMode
    ]);
    const shouldShowPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const result = mediaOptions.allowCaptions && mediaNode.childCount !== 2 && isSelected && view.state.selection instanceof (0, $ks2lK.NodeSelection);
        return !editorDisabled && result;
    }, [
        editorDisabled,
        mediaOptions.allowCaptions,
        mediaNode,
        view,
        isSelected
    ]);
    const isInsideTable = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        return (0, $8m4tT.findParentNodeOfTypeClosestToPos)(view.state.doc.resolve(pos), [
            view.state.schema.nodes.table
        ]);
    }, [
        pos,
        view
    ]);
    const currentMediaElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (typeof pos !== 'number') return null;
        const mediaNode = view.domAtPos(pos + 1).node;
        return mediaNode instanceof HTMLElement ? mediaNode : null;
    }, [
        view,
        pos
    ]);
    const mediaSingleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return (0, $kfJSC.calcMediaSinglePixelWidth)({
            width: mediaSingleWidthAttribute,
            widthType: widthType,
            origWidth: width,
            layout: layout,
            // This will only be used when calculating legacy media single width
            // thus we use the legacy value (exclude table as container node)
            contentWidth: contentWidthForLegacyExperience,
            containerWidth: containerWidth,
            gutterOffset: (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)
        });
    }, [
        mediaSingleWidthAttribute,
        widthType,
        width,
        layout,
        contentWidthForLegacyExperience,
        containerWidth
    ]);
    const currentMaxWidth = isSelected ? pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth : undefined;
    const contentWidth = currentMaxWidth || lineLength;
    const isCurrentNodeDrafting = Boolean(isDrafting && targetNodeId === mediaNode?.firstChild?.attrs.id);
    const mediaSingleWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    const captionPlaceHolderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    const onMediaSingleClicked = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        // Workaround for iOS 16 Caption selection issue
        // @see https://product-fabric.atlassian.net/browse/MEX-2012
        if (!browser.ios) return;
        if (mediaSingleWrapperRef.current !== event.target) return;
        captionPlaceHolderRef.current?.click();
    }, [
        mediaSingleWrapperRef,
        captionPlaceHolderRef
    ]);
    const clickPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (typeof getPos === 'boolean') return;
        (0, $e9ac8e653661d18d$export$a34e35a63d969ea1)(pluginInjectionApi?.analytics?.actions)(getPos(), mediaNode)(view.state, view.dispatch);
    }, [
        view,
        getPos,
        mediaNode,
        pluginInjectionApi
    ]);
    const legacySize = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            width: mediaSingleWidthAttribute,
            widthType: widthType
        };
    }, [
        widthType,
        mediaSingleWidthAttribute
    ]);
    const MediaChildren = // eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions, @atlassian/a11y/click-events-have-key-events
    /*#__PURE__*/ (0, $9K4OG.jsx)("figure", {
        ref: mediaSingleWrapperRef,
        css: $d8916929d7100ead$var$figureWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ZrgC.MediaSingleNodeSelector),
        onClick: onMediaSingleClicked
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1xbL9.MediaBadges), {
        mediaElement: currentMediaElement(),
        mediaHeight: height,
        mediaWidth: width,
        extendedResizeOffset: mediaOptions.allowPixelResizing && !isInsideTable
    }, ({ visible: visible })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, visible && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4i54r.ExternalImageBadge), {
            type: childMediaNodeAttrs.type,
            url: childMediaNodeAttrs.type === 'external' ? childMediaNodeAttrs.url : undefined
        }), mediaOptions.allowCommentsOnMedia && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $21cddd0804e30885$export$28b46719ed075ab4), {
            view: view,
            api: pluginInjectionApi,
            mediaNode: mediaNode?.firstChild,
            getPos: getPos,
            isDrafting: isCurrentNodeDrafting
        }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: forwardRef
    }), shouldShowPlaceholder && ((0, $dh538.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7e89fb9539ad0768$export$dfb3d25b53c36a0a), {
        // platform_editor_typography_ugc clean up
        // remove typecasting
        ref: captionPlaceHolderRef,
        onClick: clickPlaceholder,
        placeholderMessage: mediaOptions.allowImagePreview ? (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholderWithDoubleClickPrompt : (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholder
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7e89fb9539ad0768$export$283943db773aa526), {
        ref: captionPlaceHolderRef,
        onClick: clickPlaceholder,
        placeholderMessage: mediaOptions.allowImagePreview ? (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholderWithDoubleClickPrompt : (0, $f3f1fa1eb42a1a56$export$6a0665148042092b).placeholder
    })));
    if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ff4d3fbedfa1b27c$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: widthType !== 'pixel',
        forceHandlePositioning: mediaOptions?.forceHandlePositioning,
        disableHandles: !canResize
    }, MediaChildren) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7ce4a81fe848dded$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute,
        disableHandles: !canResize
    }, MediaChildren);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, canResize ? mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ff4d3fbedfa1b27c$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: widthType !== 'pixel',
        forceHandlePositioning: mediaOptions?.forceHandlePositioning
    }, MediaChildren) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7ce4a81fe848dded$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute
    }, MediaChildren) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6CRn4.default), {
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        editorAppearance: editorAppearance,
        pctWidth: mediaSingleWidthAttribute,
        lineLength: lineLength || $d8916929d7100ead$var$FALLBACK_MOST_COMMON_WIDTH,
        size: legacySize
    }, MediaChildren));
};


const $89a4e9b063bbde1b$var$selector = (states)=>{
    return {
        mediaProviderPromise: states.mediaState?.mediaProvider,
        addPendingTask: states.mediaState?.addPendingTask,
        isDrafting: states.annotationState?.isDrafting,
        targetNodeId: states.annotationState?.targetNodeId,
        width: states.widthState?.width,
        lineLength: states.widthState?.lineLength,
        editorDisabled: states.editorDisabledState?.editorDisabled,
        viewMode: states.editorViewModeState?.mode
    };
};
const $89a4e9b063bbde1b$var$MediaSingleNodeWrapper = ({ pluginInjectionApi: pluginInjectionApi, contextIdentifierProvider: contextIdentifierProvider, node: node, getPos: getPos, mediaOptions: mediaOptions, view: view, fullWidthMode: fullWidthMode, selected: selected, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, forwardRef: forwardRef, editorAppearance: editorAppearance })=>{
    const { mediaProviderPromise: mediaProviderPromise, addPendingTask: addPendingTask, isDrafting: isDrafting, targetNodeId: targetNodeId, width: width, lineLength: lineLength, editorDisabled: editorDisabled, viewMode: viewMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'media',
        'annotation',
        'editorDisabled',
        'editorViewMode'
    ], $89a4e9b063bbde1b$var$selector);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const mediaProvider = (0, $42omo.useMemo)(()=>mediaProviderPromise ? Promise.resolve(mediaProviderPromise) : undefined, [
        mediaProviderPromise
    ]);
    const isSelectedAndInteracted = (0, $42omo.useCallback)(()=>Boolean(selected() && interactionState !== 'hasNotHadInteraction'), [
        interactionState,
        selected
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d8916929d7100ead$export$4a00cdcfd685a172), {
        width: width || 0,
        lineLength: lineLength || 0,
        node: node,
        getPos: getPos,
        mediaProvider: mediaProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        mediaOptions: mediaOptions,
        view: view,
        fullWidthMode: fullWidthMode,
        selected: isSelectedAndInteracted,
        eventDispatcher: eventDispatcher,
        addPendingTask: addPendingTask,
        isDrafting: isDrafting,
        targetNodeId: targetNodeId,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        forwardRef: forwardRef,
        pluginInjectionApi: pluginInjectionApi,
        editorDisabled: editorDisabled,
        editorViewMode: viewMode === 'view',
        editorAppearance: editorAppearance
    });
};
class $89a4e9b063bbde1b$var$MediaSingleNodeView extends (0, $2gkmX.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // control the domRef contentEditable attribute based on the editor view mode
        this.unsubscribeToViewModeChange = this.subscribeToViewModeChange(domRef);
        const initialViewMode = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
        this.updateDomRefContentEditable(domRef, initialViewMode);
        if (this.reactComponentProps.mediaOptions?.allowPixelResizing) domRef.classList.add('media-extended-resize-experience');
        domRef.setAttribute('data-media-vc-wrapper', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        dom.classList.add((0, $j5VfV.MEDIA_CONTENT_WRAP_CLASS_NAME));
        return {
            dom: dom
        };
    }
    viewShouldUpdate(nextNode) {
        if (this.forceViewUpdate) {
            this.forceViewUpdate = false;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        if (this.selectionType !== this.checkAndUpdateSelectionType()) return true;
        if (this.node.childCount !== nextNode.childCount) return true;
        return super.viewShouldUpdate(nextNode);
    }
    subscribeToViewModeChange(domRef) {
        return this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange((viewModeState)=>{
            this.updateDomRefContentEditable(domRef, viewModeState.nextSharedState?.mode);
        });
    }
    updateDomRefContentEditable(domRef, editorViewMode) {
        // if the editor is in view mode, we should not allow editing
        if (editorViewMode === 'view') {
            domRef.contentEditable = 'false';
            return;
        }
        // if the editor is in edit mode, we should allow editing if the media options allow it
        if (this.reactComponentProps.mediaOptions?.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
    }
    getNodeMediaId(node) {
        if (node.firstChild) return node.firstChild.attrs.id;
        return undefined;
    }
    stopEvent(event) {
        if (this.isNodeSelected() && event instanceof KeyboardEvent && event?.target instanceof HTMLElement) {
            const targetType = event.target.type;
            if (event.key === 'Enter' && targetType === 'button') return true;
        }
        return false;
    }
    update(node, decorations, _innerDecorations, isValidUpdate) {
        if (!isValidUpdate) isValidUpdate = (currentNode, newNode)=>this.getNodeMediaId(currentNode) === this.getNodeMediaId(newNode);
        // Detect mediaSingle width attribute changes and signal child media node to update
        if (!this.hasResized && this.node.attrs.width !== node.attrs.width && (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
            const target = this.dom.querySelector('div[data-prosemirror-node-name="media"]');
            target?.dispatchEvent(new CustomEvent('resized'));
        }
        return super.update(node, decorations, _innerDecorations, isValidUpdate);
    }
    render(props, forwardRef) {
        const { eventDispatcher: eventDispatcher, fullWidthMode: fullWidthMode, providerFactory: providerFactory, mediaOptions: mediaOptions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, editorAppearance: editorAppearance } = this.reactComponentProps;
        // getPos is a boolean for marks, since this is a node we know it must be a function
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dYBVS.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                return /*#__PURE__*/ (0, $9K4OG.jsx)($89a4e9b063bbde1b$var$MediaSingleNodeWrapper, {
                    pluginInjectionApi: pluginInjectionApi,
                    contextIdentifierProvider: contextIdentifierProvider,
                    node: this.node,
                    getPos: getPos,
                    mediaOptions: mediaOptions,
                    view: this.view,
                    fullWidthMode: fullWidthMode,
                    selected: this.isNodeSelected,
                    eventDispatcher: eventDispatcher,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    forwardRef: forwardRef,
                    editorAppearance: editorAppearance
                });
            }
        });
    }
    ignoreMutation() {
        // DOM has changed; recalculate if we need to re-render
        if (this.dom) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const offsetLeft = this.dom.offsetLeft;
            if (offsetLeft !== this.lastOffsetLeft) {
                this.lastOffsetLeft = offsetLeft;
                this.forceViewUpdate = true;
                this.update(this.node, [], undefined, ()=>true);
            }
        }
        return true;
    }
    destroy() {
        this.unsubscribeToViewModeChange?.();
    }
    constructor(...args){
        super(...args);
        this.lastOffsetLeft = 0;
        this.forceViewUpdate = false;
        this.selectionType = null;
        this.unsubscribeToViewModeChange = void 0;
        this.hasResized = false;
        this.checkAndUpdateSelectionType = ()=>{
            const getPos = this.getPos;
            const { selection: selection } = this.view.state;
            /**
       *  ED-19831
       *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
       *  directly to confluence since this bug is now in production.
       */ let pos;
            try {
                pos = getPos ? getPos() : undefined;
            } catch  {
                pos = undefined;
            }
            const isNodeSelected = (0, $7iE7T.isNodeSelectedOrInRange)(selection.$anchor.pos, selection.$head.pos, pos, this.node.nodeSize);
            this.selectionType = isNodeSelected;
            return isNodeSelected;
        };
        this.isNodeSelected = ()=>{
            this.checkAndUpdateSelectionType();
            return this.selectionType !== null;
        };
    }
}
const $89a4e9b063bbde1b$export$fd09b1a92f5ce9f7 = (portalProviderAPI, eventDispatcher, providerFactory, pluginInjectionApi, dispatchAnalyticsEvent, mediaOptions = {})=>(node, view, getPos)=>{
        return new $89a4e9b063bbde1b$var$MediaSingleNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            fullWidthMode: mediaOptions.fullWidthEnabled,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
            pluginInjectionApi: pluginInjectionApi,
            editorAppearance: mediaOptions.editorAppearance
        }).init();
    };



var $kZ3vg = parcelRequire("kZ3vg");


var $24P9d = parcelRequire("24P9d");







const $b0afbc81de86ad75$export$daf6081925f8454b = (nodeName, node)=>{
    const copyPrivateAttributes = (// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    from, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    to, map)=>{
        if (node.attrs) Object.keys(node.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const attrs = {
        'data-id': node.attrs.id,
        'data-node-type': `${nodeName}`,
        'data-type': node.attrs.type,
        'data-collection': node.attrs.collection,
        'data-occurrence-key': node.attrs.occurrenceKey,
        'data-width': node.attrs.width,
        'data-height': node.attrs.height,
        'data-url': node.attrs.url,
        'data-alt': node.attrs.alt,
        // toDOM is used for static rendering as well as editor rendering. This comes into play for
        // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
        // node view being used for editing).
        title: 'Attachment',
        // Manually kept in sync with the style of media cards. The goal is to render a plain gray
        // rectangle that provides an affordance for media.
        style: `display: inline-block; border-radius: 3px; background: ${(0, $6fnsQ.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
    };
    copyPrivateAttributes(node.attrs, attrs, (key)=>`data-${$b0afbc81de86ad75$export$f84fdfb973c05bd8(key.slice(2))}`);
    return attrs;
};
const $b0afbc81de86ad75$export$f84fdfb973c05bd8 = (str)=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $b0afbc81de86ad75$export$6efdb466dbe90a4b = (withExtendedWidthTypes, node)=>{
    const { layout: layout, width: width } = node.attrs;
    const attrs = {
        'data-node-type': 'mediaSingle',
        'data-layout': layout
    };
    if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
    const { widthType: widthType } = node.attrs;
    return {
        ...attrs,
        'data-width-type': widthType || 'percentage',
        'data-media-vc-wrapper': 'true'
    };
};


const $57f5ea6c60a1dc14$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $57f5ea6c60a1dc14$export$9f8a4f04eb482f68 = ()=>{
    return {
        ...(0, $kZ3vg.media),
        toDOM: (node)=>{
            const attrs = (0, $b0afbc81de86ad75$export$daf6081925f8454b)('media', node);
            if (node.attrs.type === 'external') return [
                'img',
                {
                    ...attrs,
                    src: node.attrs.url,
                    style: (0, $24P9d.convertToInlineCss)({
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
                        outline: 'none',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 100%)`
                    })
                }
            ];
            if (node.attrs.type === 'file') {
                const dataUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                const width = $57f5ea6c60a1dc14$export$d87a47989c00f322.width;
                const height = $57f5ea6c60a1dc14$export$d87a47989c00f322.height;
                const sharedAttrs = {
                    width: width,
                    height: height,
                    ...attrs,
                    // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                    // rectangle that provides an affordance for media.
                    style: (0, $24P9d.convertToInlineCss)({
                        display: 'var(--ak-editor-media-card-display, inline-block)',
                        backgroundImage: `url("${dataUrl}")`,
                        marginLeft: '0',
                        marginRight: 'var(--ak-editor-media-margin-right, 4px)',
                        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
                        borderRadius: "var(--ds-radius-small, 3px)",
                        outline: 'none',
                        flexBasis: `${$57f5ea6c60a1dc14$export$d87a47989c00f322.width}px`,
                        backgroundColor: 'var(--ak-editor-media-card-background-color)',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 0)`,
                        paddingBottom: `var(--ak-editor-media-padding-bottom, 0)`
                    })
                };
                // Safari is stripping the dom if a child does not exist for the media nodes on safari.
                // Creating an empty child allows safari to pick up the media node within the clipboard.
                // https://product-fabric.atlassian.net/browse/ED-25841
                return (0, $dh538.fg)('platform_editor_safari_media_clipboard_fix') ? [
                    'div',
                    sharedAttrs,
                    [
                        'div',
                        {}
                    ]
                ] : [
                    'div',
                    sharedAttrs
                ];
            }
            return [
                'div',
                {
                    ...attrs,
                    styles: (0, $24P9d.convertToInlineCss)({
                        backgroundColor: `var(--ak-editor-media-card-background-color, ${"var(--ds-background-neutral, #0515240F)"})`,
                        outline: 'none'
                    })
                }
            ];
        }
    };
};



var $6xrFZ = parcelRequire("6xrFZ");

const $935bd411531f9b17$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $935bd411531f9b17$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $935bd411531f9b17$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $935bd411531f9b17$export$ed7b8a4728e9c63 = (appearance = 'auto')=>{
    if (appearance === 'image') return $935bd411531f9b17$export$d87a47989c00f322;
    if (appearance === 'square') return $935bd411531f9b17$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $935bd411531f9b17$export$aeb48196afcd236a;
    return $935bd411531f9b17$export$d87a47989c00f322;
};
const $935bd411531f9b17$export$927453cb1fcf720e = ()=>{
    return {
        ...(0, $6xrFZ.mediaGroup),
        toDOM: ()=>{
            // Margin margin that consolidates the margin in the
            return [
                'div',
                {
                    style: `
						margin: 3px 5px;
						display: flex;
						gap: 8px;
						--ak-editor-media-card-background-color: #EBECF0;
						--ak-editor-media-card-width: ${$935bd411531f9b17$export$d87a47989c00f322.width}px;
						--ak-editor-media-card-height: ${$935bd411531f9b17$export$d87a47989c00f322.height}px;
					`,
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    };
};



var $bTc4a = parcelRequire("bTc4a");


const $12c849f248a88385$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #0515240F)"};`;
// Matches media
const $12c849f248a88385$var$fallbackAspectRatio = 1.25;
const $12c849f248a88385$export$e71594f26ef09ec1 = ()=>{
    return {
        ...(0, $bTc4a.mediaInline),
        toDOM: (node)=>{
            const dataAttrs = (0, $b0afbc81de86ad75$export$daf6081925f8454b)('mediaInline', node);
            if (node.attrs.type === 'image') {
                const aspectRatio = node.attrs.width && node.attrs.height ? node.attrs.width / node.attrs.height : $12c849f248a88385$var$fallbackAspectRatio;
                return [
                    'span',
                    {
                        ...dataAttrs,
                        style: 'display: inline-block; transform: translateY(6px)',
                        class: 'media-inline-image-wrapper'
                    },
                    [
                        'span',
                        {
                            height: '100%',
                            width: '100%',
                            // Transparent image workaround to control styling
                            src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                            style: `display: inline-block; aspect-ratio: ${aspectRatio}; height: 100%; width: 100%; border-radius: ${"var(--ds-radius-small, 3px)"}; ${$12c849f248a88385$var$skeletonStyling}`
                        }
                    ]
                ];
            } else return [
                'span',
                {
                    ...dataAttrs,
                    style: `display: inline-block; transform: translateY(6px); ${$12c849f248a88385$var$skeletonStyling}`,
                    class: 'media-inline-image-wrapper'
                },
                [
                    'span',
                    {
                        style: `display: inline-block; height: 100%; width: 100%; aspect-ratio: ${$12c849f248a88385$var$fallbackAspectRatio};`
                    }
                ]
            ];
        }
    };
};



var $jblCI = parcelRequire("jblCI");











const $4f6a96073a9759d6$var$WRAPPED_LAYOUTS = [
    'wrap-left',
    'wrap-right'
];
const $4f6a96073a9759d6$var$ALIGNED_LAYOUTS = [
    'align-end',
    'align-start'
];
const $4f6a96073a9759d6$var$LEGACY_LAYOUTS = [
    'full-width',
    'wide'
];
const $4f6a96073a9759d6$var$DEFAULT_IMAGE_WIDTH = 250;
const $4f6a96073a9759d6$var$DEFAULT_IMAGE_HEIGHT = 200;
const $4f6a96073a9759d6$var$GUTTER_SIZE = '24px';
const $4f6a96073a9759d6$var$HALF_GUTTER_SIZE = '12px';
const $4f6a96073a9759d6$export$7d83792003901332 = ({ mediaSingleDimensionWidth: mediaSingleDimensionWidth, layout: layout, baseWidth: baseWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    const isMediaWrapped = $4f6a96073a9759d6$var$WRAPPED_LAYOUTS.includes(layout);
    const isMediaAligned = $4f6a96073a9759d6$var$ALIGNED_LAYOUTS.includes(layout);
    const isMediaLegacyLayout = $4f6a96073a9759d6$var$LEGACY_LAYOUTS.includes(layout);
    const shouldUseAlignedLayoutCalc = isMediaAligned && !hasMediaDimensionWidth;
    const shouldUseWrappedLayoutCalc = isMediaWrapped && !hasMediaDimensionWidth;
    const shouldUseBreakoutWideLogic = layout === 'wide';
    const shouldUseBreakoutFullWidthLogic = layout === 'full-width';
    const shouldUseProportionalCalc = !isExtendedResizeExperience && !isPixelWidth && hasMediaDimensionWidth && !isMediaLegacyLayout && !isMediaWrapped;
    const shouldUseHalfContainerCalc = shouldUseProportionalCalc && isMediaAligned && mediaSingleDimensionWidth >= 100;
    const shouldHardCodePixelWidth = isExtendedResizeExperience && isPixelWidth && hasMediaDimensionWidth;
    const containerWidthPlusGutter = `(min(100cqw, 100%) + ${$4f6a96073a9759d6$var$GUTTER_SIZE})`;
    const fullContainerWidth = 'var(--ak-editor-max-container-width, 100cqw)';
    const applyContainerWidthBoundaries = (calc)=>{
        // Safe measure to avoid bleeding
        return `min(${calc}, ${fullContainerWidth})`;
    };
    let cssCalc = '';
    if (shouldUseAlignedLayoutCalc) cssCalc = `min(calc(${containerWidthPlusGutter} * 0.5 - ${$4f6a96073a9759d6$var$GUTTER_SIZE}), ${baseWidth}px)`;
    else if (shouldUseWrappedLayoutCalc) cssCalc = `100%`;
    else if (shouldUseHalfContainerCalc) cssCalc = `min(min(${baseWidth}px, calc(50cqw - ${$4f6a96073a9759d6$var$HALF_GUTTER_SIZE})), 100%)`;
    else if (shouldUseProportionalCalc) cssCalc = `calc(${containerWidthPlusGutter} * var(--ak-editor-media-single--proportion, 1px) - ${$4f6a96073a9759d6$var$GUTTER_SIZE})`;
    else if (shouldHardCodePixelWidth) cssCalc = `min(${mediaSingleDimensionWidth}px, ${fullContainerWidth})`;
    else if (shouldUseBreakoutWideLogic) {
        if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width)))`;
        else cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
    } else if (shouldUseBreakoutFullWidthLogic) {
        if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width)))`;
        else cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
    } else cssCalc = `max(min(${baseWidth}px, min(100cqw, 100%)), ${$4f6a96073a9759d6$var$GUTTER_SIZE})`;
    return applyContainerWidthBoundaries(cssCalc);
};
const $4f6a96073a9759d6$export$f236e46eb0ba66bc = ({ isMediaWrapped: isMediaWrapped, isExternalMedia: isExternalMedia, isPixelWidth: isPixelWidth, childMediaWidth: childMediaWidth, mediaSingleDimensionWidth: mediaSingleDimensionWidth })=>{
    if (isExternalMedia || !isMediaWrapped) return 'unset';
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    if (!hasMediaDimensionWidth) return `calc((100% / 2) - ${$4f6a96073a9759d6$var$HALF_GUTTER_SIZE})`;
    if (isPixelWidth) return `min(calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$4f6a96073a9759d6$var$HALF_GUTTER_SIZE}), ${mediaSingleDimensionWidth}px)`;
    const hasChildMediaWidth = typeof childMediaWidth === 'number';
    if (hasChildMediaWidth) return `min(calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$4f6a96073a9759d6$var$HALF_GUTTER_SIZE}), ${childMediaWidth}px)`;
    return `calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$4f6a96073a9759d6$var$HALF_GUTTER_SIZE})`;
};
const $4f6a96073a9759d6$export$e6a8bed31e6b00e2 = ({ isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isMediaWrapped: isMediaWrapped })=>{
    const hasMediaWidth = typeof mediaSingleDimensionWidth === 'number';
    if (isPixelWidth || isExtendedResizeExperience || !hasMediaWidth) return 'unset';
    if (isMediaWrapped) return mediaSingleDimensionWidth >= 50 ? '1' : `${1 - mediaSingleDimensionWidth / 100}`;
    return `${mediaSingleDimensionWidth / 100}`;
};
const $4f6a96073a9759d6$export$899bc2e8a274123a = ({ layout: layout })=>{
    switch(layout){
        case 'align-end':
        case 'wrap-right':
            return 'end';
        case 'align-start':
        case 'wrap-left':
            return 'start';
        default:
            return 'center';
    }
};
const $4f6a96073a9759d6$export$e03be381a0c66cf5 = ({ layout: layout, dataAttrs: dataAttrs, childMediaWidth: childMediaWidth, childMediaHeight: childMediaHeight, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const layoutStyleJustifyContent = $4f6a96073a9759d6$export$899bc2e8a274123a({
        layout: layout
    });
    const mediaWidthCalc = $4f6a96073a9759d6$export$7d83792003901332({
        layout: layout,
        mediaSingleDimensionWidth: mediaSingleDimensionWidth,
        baseWidth: childMediaWidth,
        isPixelWidth: isPixelWidth,
        isExtendedResizeExperience: isExtendedResizeExperience
    });
    const paddingBottom = `calc((${childMediaHeight} / ${childMediaWidth}) * 100%)`;
    return [
        'div',
        {
            class: `rich-media-item mediaSingleView-content-wrap image-${layout}`,
            style: (0, $24P9d.convertToInlineCss)({
                display: 'flex',
                justifyContent: layoutStyleJustifyContent,
                transform: 'unset',
                marginLeft: '0'
            }),
            ...dataAttrs
        },
        [
            'div',
            {
                style: (0, $24P9d.convertToInlineCss)({
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: mediaWidthCalc,
                    minWidth: mediaWidthCalc,
                    color: `var(--ds-icon, ${(0, $6fnsQ.N50)})`
                })
            },
            [
                'figure',
                {
                    class: 'media-single-node',
                    style: (0, $24P9d.convertToInlineCss)({
                        '--ak-editor-media-padding-bottom': paddingBottom,
                        margin: '0px'
                    })
                },
                [
                    'div',
                    {},
                    [
                        'div',
                        {
                            class: 'media-content-wrap'
                        },
                        0
                    ]
                ]
            ]
        ]
    ];
};
const $4f6a96073a9759d6$export$e23517a19eb0e861 = (allowPixelResizing)=>(node)=>{
        const mediaSingleAttrs = node.attrs;
        const isPixelWidth = mediaSingleAttrs?.widthType === 'pixel';
        const layout = mediaSingleAttrs?.layout ?? 'center';
        const childNode = node.firstChild;
        const isExternalMedia = childNode?.attrs.type === 'external';
        const childMediaWidth = childNode?.attrs.width || $4f6a96073a9759d6$var$DEFAULT_IMAGE_WIDTH;
        const childMediaHeight = childNode?.attrs.height || $4f6a96073a9759d6$var$DEFAULT_IMAGE_HEIGHT;
        const dataAttrs = (0, $b0afbc81de86ad75$export$6efdb466dbe90a4b)(true, node);
        const content = $4f6a96073a9759d6$export$e03be381a0c66cf5({
            layout: layout,
            dataAttrs: dataAttrs,
            childMediaWidth: childMediaWidth,
            childMediaHeight: childMediaHeight,
            mediaSingleDimensionWidth: mediaSingleAttrs.width,
            isPixelWidth: isPixelWidth,
            isExtendedResizeExperience: allowPixelResizing
        });
        const isMediaWrapped = $4f6a96073a9759d6$var$WRAPPED_LAYOUTS.includes(layout);
        const proportionCalc = $4f6a96073a9759d6$export$e6a8bed31e6b00e2({
            isPixelWidth: isPixelWidth,
            isMediaWrapped: isMediaWrapped,
            mediaSingleDimensionWidth: mediaSingleAttrs?.width,
            isExtendedResizeExperience: allowPixelResizing
        });
        const contentWrapperWidth = $4f6a96073a9759d6$export$f236e46eb0ba66bc({
            isMediaWrapped: isMediaWrapped,
            isExternalMedia: isExternalMedia,
            isPixelWidth: isPixelWidth,
            childMediaWidth: childMediaWidth,
            mediaSingleDimensionWidth: mediaSingleAttrs?.width
        });
        return [
            'div',
            {
                class: 'mediaSingleView-content-wrap',
                layout: layout,
                'data-media-vc-wrapper': 'true',
                style: (0, $24P9d.convertToInlineCss)({
                    '--ak-editor-media-single--proportion': proportionCalc,
                    '--ak-editor-media-card-display': 'block',
                    '--ak-editor-media-single--gutter-size': $4f6a96073a9759d6$var$GUTTER_SIZE,
                    '--ak-editor-media-margin-right': '0',
                    '--ak-editor-media-card-background-color': `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
                    marginTop: isMediaWrapped ? $4f6a96073a9759d6$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginBottom: isMediaWrapped ? $4f6a96073a9759d6$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginRight: isMediaWrapped ? layout === 'wrap-right' ? 'auto' : $4f6a96073a9759d6$var$HALF_GUTTER_SIZE : 0,
                    marginLeft: isMediaWrapped ? layout === 'wrap-left' ? 'auto' : $4f6a96073a9759d6$var$HALF_GUTTER_SIZE : 0,
                    width: contentWrapperWidth
                })
            },
            content
        ];
    };
const $4f6a96073a9759d6$export$7540e2ccc4187dcf = (mediaSingleOption)=>{
    const mediaSingleNode = (0, $jblCI.mediaSingleSpec)(mediaSingleOption);
    const toDOM = $4f6a96073a9759d6$export$e23517a19eb0e861(mediaSingleOption.withExtendedWidthTypes);
    return {
        ...mediaSingleNode,
        toDOM: toDOM
    };
};






var $lkJUe = parcelRequire("lkJUe");

var $l9G9n = parcelRequire("l9G9n");




var $329b1ad37bfd5572$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'updateAltText':
            return {
                ...state
            };
        case 'openMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: true
            };
        case 'closeMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: false
            };
        default:
            return state;
    }
};


const $e285d524337ca108$var$pluginKey = new (0, $ks2lK.PluginKey)('mediaAltTextPlugin');
const { createPluginState: $e285d524337ca108$var$createPluginState, createCommand: $e285d524337ca108$export$8d4021544bdece00, getPluginState: $e285d524337ca108$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)($e285d524337ca108$var$pluginKey, (0, $329b1ad37bfd5572$export$2e2bcd8739ae039), {
    onSelectionChanged: (tr, newState)=>{
        // dont close alt text for undo/redo transactions (if it comes from prosemirror-history)
        if (tr.getMeta((0, $l9G9n.pmHistoryPluginKey))) return newState;
        return {
            isAltTextEditorOpen: false
        };
    }
});
const $e285d524337ca108$export$ae829ec7b2625219 = ({ dispatch: dispatch, providerFactory: providerFactory })=>{
    return new (0, $1S4f7.SafePlugin)({
        state: $e285d524337ca108$var$createPluginState(dispatch, {
            isAltTextEditorOpen: false
        }),
        key: $e285d524337ca108$var$pluginKey
    });
};



var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");





var $dAtrv = parcelRequire("dAtrv");








var $aR6HD = parcelRequire("aR6HD");


const $b5c14d60649e09b6$var$createCommandWithAnalytics = (actionType, action, transform)=>{
    return (editorAnalyticsAPI)=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, (state)=>{
            const mediaNode = (0, $kjHnW.getMediaSingleOrInlineNodeFromSelection)(state);
            const type = (0, $aR6HD.getNodeType)(state);
            return {
                action: actionType,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    mediaType: mediaNode.attrs.type
                }
            };
        })((0, $e285d524337ca108$export$8d4021544bdece00)(action, transform));
    };
};
const $b5c14d60649e09b6$export$e494ea08c5b8d2cd = (altText)=>{
    const commandTransform = typeof altText === 'string' ? $b5c14d60649e09b6$var$updateAltTextTransform(altText) : undefined;
    return (0, $e285d524337ca108$export$8d4021544bdece00)((state)=>{
        if ((0, $kjHnW.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'closeMediaAltTextMenu'
        };
        return false;
    }, commandTransform);
};
const $b5c14d60649e09b6$export$56a9d6e428ac89c9 = $b5c14d60649e09b6$export$e494ea08c5b8d2cd();
const $b5c14d60649e09b6$export$e5f8c6baa484e73d = $b5c14d60649e09b6$var$createCommandWithAnalytics((0, $d925B.ACTION).OPENED, (state)=>{
    if ((0, $kjHnW.isMediaSingleOrInlineNodeSelected)(state)) return {
        type: 'openMediaAltTextMenu'
    };
    return false;
}, (tr)=>tr.setMeta('scrollIntoView', false));
const $b5c14d60649e09b6$var$updateAltTextTransform = (newAltText)=>(tr, state)=>{
        const mediaNode = (0, $kjHnW.getMediaSingleOrInlineNodeFromSelection)(state);
        if (mediaNode) {
            // mediaSingle or mediaInline
            const originalSelectionPos = tr.selection.from;
            const mediaPos = mediaNode.type === state.schema.nodes.media ? originalSelectionPos + 1 // media inside mediaSingle
             : originalSelectionPos; // mediaInline
            /**
			 * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
			 * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
			 * The recommended fix is to reset the selection.[2]
			 *
			 * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
			 * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
			 */ tr.setMeta('scrollIntoView', false).setNodeMarkup(mediaPos, undefined, {
                ...mediaNode.attrs,
                alt: newAltText
            }).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, originalSelectionPos));
        }
        return tr;
    };
const $b5c14d60649e09b6$export$d4d994ee16c78b4b = (newAltText)=>(0, $e285d524337ca108$export$8d4021544bdece00)((state)=>{
        if ((0, $kjHnW.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'updateAltText'
        };
        return false;
    }, $b5c14d60649e09b6$var$updateAltTextTransform(newAltText));


function $6ad39c5d88144513$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.addAltText).common, (0, $b5c14d60649e09b6$export$e5f8c6baa484e73d)(editorAnalyticsAPI), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.escape).common, (0, $b5c14d60649e09b6$export$56a9d6e428ac89c9), list);
    return (0, $dus6D.keymap)(list);
}



var $8e2t2 = parcelRequire("8e2t2");


var $afaS6 = parcelRequire("afaS6");





var $7dSFG = parcelRequire("7dSFG");

const $c8a7e8befa4e0f56$export$9f7495958f6fc412 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $afaS6.stateKey), {
            type: (0, $8e2t2.ACTIONS).SHOW_MEDIA_VIEWER,
            mediaViewerSelectedMedia: media,
            isMediaViewerVisible: true
        });
        return tr;
    };
const $c8a7e8befa4e0f56$export$4e934779424102f3 = ({ tr: tr })=>{
    tr.setMeta((0, $afaS6.stateKey), {
        type: (0, $8e2t2.ACTIONS).HIDE_MEDIA_VIEWER,
        mediaViewerSelectedMedia: null,
        isMediaViewerVisible: false
    });
    return tr;
};
const $c8a7e8befa4e0f56$export$3d560bf5e623346d = (attrs)=>({ tr: tr })=>{
        const identifier = (0, $kjHnW.getIdentifier)(attrs);
        tr.setMeta((0, $afaS6.stateKey), {
            type: (0, $8e2t2.ACTIONS).TRACK_MEDIA_PASTE,
            identifier: identifier
        });
        return tr;
    };
const $c8a7e8befa4e0f56$export$483fbd616c5570ae = (editorAnalyticsAPI, allowPixelResizing)=>(mediaAttrs, inputMethod, insertMediaVia)=>(0, $7dSFG.createInsertMediaAsMediaSingleCommand)(mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing);








const $462b9684de6dabb9$export$1a764a38ffc131af = (0, $cgtv4.defineMessages)({
    MediaWidthIsMax: {
        id: "fabric.editor.media.pixelEntry.MediaWidthIsMax",
        defaultMessage: "Media increased to the maximum size"
    },
    MediaWidthIsMin: {
        id: "fabric.editor.media.MediaWidthIsMin",
        defaultMessage: "Media decreased to the minimum size"
    },
    DefaultMediaWidthIncreased: {
        id: "fabric.editor.media.DefaultMediaWidthIncreased",
        defaultMessage: "{newMediaWidth, plural, one {Media width increased to # pixel.} other {Media width increased to # pixels.}}"
    },
    DefaultMediaWidthDecreased: {
        id: "fabric.editor.media.DefaultMediaWidthDecreased",
        defaultMessage: "{newMediaWidth, plural, one {Media width decreased to # pixel.} other {Media width decreased to # pixels.}}"
    }
});








var $adhil = parcelRequire("adhil");


















var $cAGd7 = parcelRequire("cAGd7");

function $a8675c3206562635$var$keymapPlugin(options, editorAnalyticsAPI, editorSelectionAPI, widthPlugin, getIntl) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.undo).common, $a8675c3206562635$var$ignoreLinksInSteps, list);
    if (options?.allowCaptions) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, $a8675c3206562635$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.tab).common, $a8675c3206562635$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveLeft).common, $a8675c3206562635$var$arrowLeftFromMediaSingle(editorSelectionAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveRight).common, $a8675c3206562635$var$arrowRightFromMediaSingle(editorSelectionAPI), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.insertNewLine).common, $a8675c3206562635$var$splitMediaGroup, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.enter).common, $a8675c3206562635$var$splitMediaGroup, list);
    if (options?.allowPixelResizing) {
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.increaseMediaSize).common, $a8675c3206562635$var$handleMediaIncrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.decreaseMediaSize).common, $a8675c3206562635$var$handleMediaDecrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.activateVideoControls).common, $a8675c3206562635$var$focusPlayButton, list);
    return (0, $dus6D.keymap)(list);
}
const $a8675c3206562635$var$ignoreLinksInSteps = (state)=>{
    const mediaPluginState = (0, $afaS6.stateKey).getState(state);
    mediaPluginState.ignoreLinks = true;
    return false;
};
const $a8675c3206562635$var$splitMediaGroup = (state)=>{
    const mediaPluginState = (0, $afaS6.stateKey).getState(state);
    return mediaPluginState.splitMediaGroup();
};
const $a8675c3206562635$var$focusPlayButton = (state)=>{
    const videoControlsWrapperRef = (0, $afaS6.stateKey).getState(state)?.element;
    if (videoControlsWrapperRef) {
        const firstButton = videoControlsWrapperRef?.querySelector('button, [tabindex]:not([tabindex="-1"])');
        firstButton?.focus();
    }
    return true;
};
const $a8675c3206562635$var$validationMaxMin = (newWidth, maxWidth, minWidth, validation)=>{
    let newWidthValidated;
    if (newWidth > maxWidth) {
        newWidthValidated = maxWidth;
        validation = 'greater-than-max';
    } else if (newWidth < minWidth) {
        newWidthValidated = minWidth;
        validation = 'less-than-min';
    } else {
        newWidthValidated = newWidth;
        validation = 'valid';
    }
    return {
        newWidthValidated: newWidthValidated,
        validation: validation
    };
};
const $a8675c3206562635$var$createAnnouncer = (action, mediaWidth, changeAmount, validation, getIntl)=>{
    const announcerContainer = document.getElementById('media-announcer') || document.createElement('div');
    const intl = getIntl();
    if (!announcerContainer.id) {
        announcerContainer.id = 'media-announcer';
        announcerContainer.setAttribute('role', 'status');
        announcerContainer.setAttribute('aria-live', 'polite');
        announcerContainer.setAttribute('aria-atomic', 'true');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style = announcerContainer.style;
        style.position = 'absolute';
        style.width = '1px';
        style.height = '1px';
        style.marginTop = '-1px';
        style.opacity = '0';
        style.overflow = 'hidden';
        document.body.appendChild(announcerContainer);
    } else {
        const newMediaWidth = mediaWidth + changeAmount;
        if (validation === 'greater-than-max') announcerContainer.textContent = intl.formatMessage((0, $462b9684de6dabb9$export$1a764a38ffc131af).MediaWidthIsMax);
        else if (validation === 'less-than-min') announcerContainer.textContent = intl.formatMessage((0, $462b9684de6dabb9$export$1a764a38ffc131af).MediaWidthIsMin);
        else announcerContainer.textContent = intl.formatMessage(action === 'increased' ? (0, $462b9684de6dabb9$export$1a764a38ffc131af).DefaultMediaWidthIncreased : (0, $462b9684de6dabb9$export$1a764a38ffc131af).DefaultMediaWidthDecreased, {
            newMediaWidth: newMediaWidth
        });
    }
};
const $a8675c3206562635$var$handleMediaSizeChange = (editorAnalyticsAPI, widthPlugin, options, changeAmount, action, getIntl)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (!(selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'mediaSingle')) return false;
        const mediaWidth = (0, $cAGd7.getSelectedMediaSingle)(state)?.node?.attrs?.width;
        const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength || (0, $aFUXX.akEditorDefaultLayoutWidth);
        const mediaPluginState = (0, $afaS6.stateKey).getState(state);
        const maxWidthForNestedNode = mediaPluginState.currentMaxWidth;
        const minWidth = (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let maxWidth = maxWidthForNestedNode;
        const currentMaxWidth = widthPlugin?.sharedState.currentState()?.width || maxWidth;
        if (maxWidth === undefined && maxWidthForNestedNode === undefined) maxWidth = options?.fullWidthEnabled ? widthPlugin?.sharedState.currentState()?.lineLength : (0, $kfJSC.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        const validation = 'valid';
        const newWidth = mediaWidth + changeAmount;
        if (options?.fullWidthEnabled) maxWidth = widthPlugin?.sharedState.currentState()?.lineLength;
        else if (maxWidthForNestedNode === undefined) maxWidth = (0, $kfJSC.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        const { newWidthValidated: newWidthValidated, validation: validationResult } = $a8675c3206562635$var$validationMaxMin(newWidth, maxWidth, minWidth, validation);
        const newLayout = (0, $cAGd7.calcNewLayout)(newWidthValidated, (0, $cAGd7.getSelectedMediaSingle)(state)?.node?.attrs?.layout, contentWidth, options?.fullWidthEnabled);
        (0, $aR6HD.updateMediaSingleWidth)(editorAnalyticsAPI)(newWidthValidated, validationResult, 'keyboard', newLayout)(state, dispatch);
        $a8675c3206562635$var$createAnnouncer(action, mediaWidth, changeAmount, validationResult, getIntl);
        return true;
    };
const $a8675c3206562635$var$handleMediaIncrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$a8675c3206562635$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, 1, 'increased', getIntl);
const $a8675c3206562635$var$handleMediaDecrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$a8675c3206562635$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, -1, 'decreased', getIntl);
const $a8675c3206562635$var$insertAndSelectCaption = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        if (selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type === schema.nodes.mediaSingle && schema.nodes.caption) {
            if (dispatch) {
                const { from: from, node: node } = selection;
                if (!(0, $e9ac8e653661d18d$export$a34e35a63d969ea1)(editorAnalyticsAPI)(from, node)(state, dispatch)) (0, $e9ac8e653661d18d$export$994ea9c3fa8e0b0c)(from, node)(state, dispatch);
            }
            return true;
        }
        return false;
    };
const $a8675c3206562635$var$arrowLeftFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(selection.from), (0, $adhil.Side).LEFT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $a8675c3206562635$var$arrowRightFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(selection.to), (0, $adhil.Side).RIGHT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
var $a8675c3206562635$export$2e2bcd8739ae039 = $a8675c3206562635$var$keymapPlugin;






var $l6okE = parcelRequire("l6okE");





var $astHL = parcelRequire("astHL");










/**
 * Check if is an empty selection at the start of the node
 */ function $c67d1c0c7982952b$var$isEmptySelectionAtStart(selection) {
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    return $from.parentOffset <= 0;
}
/**
 * Check if the current selection is inside a node type
 */ function $c67d1c0c7982952b$var$isSelectionInsideOf(selection, nodeType) {
    const { $from: $from } = selection;
    const parent = $from.parent;
    return parent.type === nodeType;
}
/**
 * Return the sibling of the current selection
 */ function $c67d1c0c7982952b$var$getSibling(selection, sibling) {
    const { $from: $from } = selection;
    const index = $from.index($from.depth - 1);
    const grandParent = $from.node($from.depth - 1); // Get GrandParent
    return grandParent ? grandParent.maybeChild(index + sibling) : null;
}
/**
 * Check if respective sibling (negative number previous, positive number next)
 * is from the specified node
 */ function $c67d1c0c7982952b$var$isSiblingOfType(selection, node, sibling) {
    const maybeSiblingNode = $c67d1c0c7982952b$var$getSibling(selection, sibling);
    return !!maybeSiblingNode && maybeSiblingNode.type === node;
}
/**
 * When there's any empty block before another paragraph with wrap-right
 * mediaSingle. Pressing backspace at the start of the paragraph will select
 * the media but visually it makes more sense to remove the empty paragraph.
 *
 * Structure of the document: doc(block(), mediaSingle(media()), paragraph('{<>}hello!'))
 * But, visually it looks like the following:
 *
 *    [empty block] <- Remove this block
 * or [paragraph block] <- Move text inside this paragraph
 * or [any other block] <- Move paragraph node after this node
 * [Cursor] x x x x x x x x  +---------------+
 * x x x x x x x x x x       |  mediaSingle  |
 * x x x x x.                +---------------+
 */ function $c67d1c0c7982952b$var$handleSelectionAfterWrapRight(isEmptyNode) {
    function isEmptyWithoutThrow(node) {
        let isEmpty = false;
        try {
            // We dont have isEmptyNode definition for table for example.
            // In this case it will throw we need to catch it
            isEmpty = isEmptyNode(node);
        } catch (e) {}
        return isEmpty;
    }
    return (state, dispatch)=>{
        const { $from: $from } = state.selection;
        const { paragraph: paragraph } = state.schema.nodes;
        const previousMediaSingleSibling = -2;
        const maybeSibling = $c67d1c0c7982952b$var$getSibling(state.selection, previousMediaSingleSibling);
        if (!maybeSibling) // the last is the image so should let the default behaviour delete the image
        return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const mediaSingle = $c67d1c0c7982952b$var$getSibling(state.selection, -1); // Sibling is a media single already checked in main code
        const mediaSinglePos = $from.pos - mediaSingle.nodeSize;
        // Should find the position
        // Should move the current paragraph to the last line
        const maybeAnyBlockPos = mediaSinglePos - maybeSibling.nodeSize;
        let tr = state.tr;
        if (isEmptyWithoutThrow(maybeSibling)) // Should remove the empty sibling
        tr = tr.replace(maybeAnyBlockPos - 1, maybeAnyBlockPos + maybeSibling.nodeSize);
        else {
            // We move the current node, to the new position
            // 1. Remove current node, only if I am not removing the last node.
            if (!(0, $l9G9n.isSelectionInsideLastNodeInDocument)(state.selection)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
            else // Remove node content, if is the last node, let a empty paragraph
            tr.replace($from.pos, $from.pos + $from.parent.nodeSize - 1);
            // 2. Add it in the new position
            // If the sibling is a paragraph lets copy the text inside the paragraph
            // Like a normal backspace from paragraph to paragraph
            if (maybeSibling.type === paragraph) {
                const insideParagraphPos = maybeAnyBlockPos + maybeSibling.nodeSize - 2;
                (0, $8m4tT.safeInsert)($from.parent.content, insideParagraphPos)(tr);
            } else {
                // If is any other kind of block just add the paragraph after it
                const endOfBlockPos = maybeAnyBlockPos + maybeSibling.nodeSize - 1;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (0, $8m4tT.safeInsert)($from.parent.copy($from.parent.content), endOfBlockPos)(tr);
            }
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $c67d1c0c7982952b$var$backspaceAfterMediaNode = (schema)=>{
    const isEmptyNodeInSchema = (0, $l9G9n.isEmptyNode)(schema);
    return (state, dispatch)=>{
        const { selection: selection, schema: schema, tr: tr } = state;
        const { $from: $from } = selection;
        if (!$c67d1c0c7982952b$var$isEmptySelectionAtStart(state.selection)) return false;
        if (!$c67d1c0c7982952b$var$isSelectionInsideOf(state.selection, schema.nodes.paragraph)) return false;
        const previousSibling = -1;
        // no media single or media group
        if (!$c67d1c0c7982952b$var$isSiblingOfType(state.selection, schema.nodes.mediaSingle, previousSibling) && !$c67d1c0c7982952b$var$isSiblingOfType(state.selection, schema.nodes.mediaGroup, previousSibling)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const media = $c67d1c0c7982952b$var$getSibling(state.selection, previousSibling);
        // if media single
        if (media.type === schema.nodes.mediaSingle) {
            if (media.attrs.layout === 'wrap-right') return $c67d1c0c7982952b$var$handleSelectionAfterWrapRight(isEmptyNodeInSchema)(state, dispatch);
            if (dispatch) // Select media single, and remove paragraph if it's empty.
            (0, $astHL.selectNodeBackward)(state, (tr)=>{
                if (isEmptyNodeInSchema($from.parent) && !(0, $l6okE.atTheEndOfDoc)(state)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
                dispatch(tr);
            });
            return true;
        }
        // if media group
        if (dispatch) {
            // select media group, and remove paragraph if it's empty.
            if (isEmptyNodeInSchema($from.parent)) {
                tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // remove node
                tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve($from.pos - media.nodeSize))).scrollIntoView(); // select media
            }
            dispatch(tr);
        }
        return true;
    };
};
function $c67d1c0c7982952b$export$2e2bcd8739ae039(schema) {
    const list = {};
    const backspaceAfterMediaCommand = $c67d1c0c7982952b$var$backspaceAfterMediaNode(schema);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.backspace).common, backspaceAfterMediaCommand, list);
    return (0, $dus6D.keymap)(list);
}











var $367bc4b58467e5b0$export$6eb9cfa224a48678 = /*#__PURE__*/ function(MediaLinkingActionsTypes) {
    MediaLinkingActionsTypes["showToolbar"] = "MEDIA_SHOW_TOOLBAR";
    MediaLinkingActionsTypes["hideToolbar"] = "MEDIA_HIDE_TOOLBAR";
    MediaLinkingActionsTypes["setUrl"] = "MEDIA_SET_LINK_TO";
    MediaLinkingActionsTypes["unlink"] = "MEDIA_LINKING_UNLINK";
    return MediaLinkingActionsTypes;
}({});


var $01932a487d4be9bf$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).showToolbar:
            return {
                ...state,
                visible: true
            };
        case (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).setUrl:
            return {
                ...state,
                editable: true,
                link: action.payload
            };
        case (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).hideToolbar:
            return {
                ...state,
                visible: false
            };
        case (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).unlink:
            return {
                ...state,
                link: '',
                visible: false,
                editable: false
            };
    }
    return state;
};


const $11220e9e93c1fc6e$export$e8ef6001d0045a33 = new (0, $ks2lK.PluginKey)('mediaLinking');
const $11220e9e93c1fc6e$var$initialState = {
    visible: false,
    editable: false,
    mediaPos: null,
    link: ''
};
function $11220e9e93c1fc6e$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.mediaPos !== null) return {
        ...pluginState,
        mediaPos: tr.mapping.map(pluginState.mediaPos)
    };
    return pluginState;
}
function $11220e9e93c1fc6e$var$onSelectionChanged(tr) {
    const isNodeSelection = tr.selection instanceof (0, $ks2lK.NodeSelection);
    if (!isNodeSelection) return $11220e9e93c1fc6e$var$initialState;
    const pos = tr.selection.$from.pos;
    const mediaPos = tr.selection.node.type.name === 'mediaInline' ? pos : pos + 1;
    const node = tr.doc.nodeAt(mediaPos);
    if (!node || ![
        'media',
        'mediaInline'
    ].includes(node.type.name)) return $11220e9e93c1fc6e$var$initialState;
    const mark = node.marks.find((mark)=>mark.type.name === 'link');
    if (mark) return {
        ...$11220e9e93c1fc6e$var$initialState,
        mediaPos: mediaPos,
        editable: true,
        link: mark.attrs.href
    };
    return {
        ...$11220e9e93c1fc6e$var$initialState,
        mediaPos: mediaPos
    };
}
const $11220e9e93c1fc6e$var$mediaLinkingPluginFactory = (0, $lkJUe.pluginFactory)($11220e9e93c1fc6e$export$e8ef6001d0045a33, (0, $01932a487d4be9bf$export$2e2bcd8739ae039), {
    mapping: $11220e9e93c1fc6e$var$mapping,
    onSelectionChanged: $11220e9e93c1fc6e$var$onSelectionChanged
});
const { createCommand: $11220e9e93c1fc6e$export$2c81aa6d281594cd, getPluginState: $11220e9e93c1fc6e$export$a27ff1704d423d4e } = $11220e9e93c1fc6e$var$mediaLinkingPluginFactory;
var $11220e9e93c1fc6e$export$2e2bcd8739ae039 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        key: $11220e9e93c1fc6e$export$e8ef6001d0045a33,
        state: $11220e9e93c1fc6e$var$mediaLinkingPluginFactory.createPluginState(dispatch, $11220e9e93c1fc6e$var$initialState)
    });












var $dhoHU = parcelRequire("dhoHU");


var $b0F8r = parcelRequire("b0F8r");








var $jA06n = parcelRequire("jA06n");

const $1823b137770fdb05$export$e0eb18fceec368c4 = (0, $11220e9e93c1fc6e$export$2c81aa6d281594cd)((state)=>{
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    if (mediaLinkingState && mediaLinkingState.mediaPos !== null) {
        const node = state.doc.nodeAt(mediaLinkingState.mediaPos);
        if (node) return {
            type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).showToolbar
        };
    }
    return false;
});
const $1823b137770fdb05$export$f0b12e75a8c0baf5 = (editorState, dispatch, editorView)=>{
    if (dispatch && editorView) {
        const mediaNode = (0, $jA06n.currentMediaNode)(editorState);
        const mediaInlineNode = (0, $jA06n.currentMediaInlineNode)(editorState);
        const nodeSelection = editorState.selection;
        const currentSelectedNode = nodeSelection.node;
        if (!mediaNode && !mediaInlineNode) return false;
        const { mediaClientConfig: mediaClientConfig } = (0, $j5VfV.getMediaPluginState)(editorState);
        if (!mediaClientConfig) return false;
        if (mediaNode && currentSelectedNode !== mediaInlineNode) (0, $41126833ee1e2d2e$export$9573295345282b3b)(mediaNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $jA06n.currentMediaNode)(editorView.state) === mediaNode) dispatch(editorView.state.tr.setMeta((0, $11220e9e93c1fc6e$export$e8ef6001d0045a33), {
                type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).showToolbar
            }));
        });
        if (mediaInlineNode) (0, $41126833ee1e2d2e$export$9573295345282b3b)(mediaInlineNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $jA06n.currentMediaInlineNode)(editorView.state) === mediaInlineNode) dispatch(editorView.state.tr.setMeta((0, $11220e9e93c1fc6e$export$e8ef6001d0045a33), {
                type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).showToolbar
            }));
        });
    }
    return true;
};
const $1823b137770fdb05$var$hideLinkingToolbarCommand = (0, $11220e9e93c1fc6e$export$2c81aa6d281594cd)({
    type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).hideToolbar
});
const $1823b137770fdb05$export$3b74d2c3073f13a9 = (state, dispatch, view, focusFloatingToolbar)=>{
    $1823b137770fdb05$var$hideLinkingToolbarCommand(state, dispatch, view);
    // restore focus on the editor so keyboard shortcuts aren't lost to the browser
    if (view && !focusFloatingToolbar) view.focus();
};
function $1823b137770fdb05$var$getCurrentUrl(state) {
    const { link: linkType } = state.schema.marks;
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return;
    const hasLink = linkType.isInSet(node.marks);
    if (!hasLink) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const link = node.marks.find((mark)=>mark.type === linkType); // Already check exist
    const url = link.attrs.href;
    return url;
}
function $1823b137770fdb05$var$toggleLinkMark(tr, state, { forceRemove: forceRemove = false, url: url }) {
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return tr;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return tr;
    const linkMark = state.schema.marks.link;
    const { media: media, mediaInline: mediaInline } = state.schema.nodes;
    if (node.type !== mediaInline) {
        const toggleBlockLinkMark = (0, $dhoHU.createToggleBlockMarkOnRange)(linkMark, (prevAttrs, node)=>{
            // Only add mark to media
            if (!node || node.type !== media) return; //No op
            if (forceRemove) return false;
            const href = (0, $b0F8r.normalizeUrl)(url);
            if (prevAttrs && prevAttrs.href === href) return; //No op
            if (href.trim() === '') return false; // remove
            return {
                ...prevAttrs,
                href: href
            };
        }, [
            media
        ]);
        toggleBlockLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    }
    const toggleInlineLinkMark = (0, $dhoHU.createToggleInlineMarkOnRange)(linkMark, (prevAttrs, node)=>{
        // Only add mark to mediaInline
        if (!node || node.type !== mediaInline) return; //No op
        if (forceRemove) return false;
        const href = (0, $b0F8r.normalizeUrl)(url);
        if (prevAttrs && prevAttrs.href === href) return; //No op
        if (href.trim() === '') return false; // remove
        return {
            ...prevAttrs,
            href: href
        };
    });
    toggleInlineLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    return tr;
}
const $1823b137770fdb05$var$fireAnalyticForMediaLink = (tr, action, attributes, editorAnalyticsAPI)=>{
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK,
        attributes: attributes
    })(tr);
    return tr;
};
const $1823b137770fdb05$export$5e0808041271ce04 = (editorAnalyticsAPI)=>(0, $11220e9e93c1fc6e$export$2c81aa6d281594cd)({
        type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).unlink
    }, (tr, state)=>{
        const transaction = $1823b137770fdb05$var$toggleLinkMark(tr, state, {
            forceRemove: true
        });
        return $1823b137770fdb05$var$fireAnalyticForMediaLink(transaction, (0, $d925B.ACTION).DELETED, {
            ...$1823b137770fdb05$var$getNodeTypeAndMediaTypeAttributes(state)
        }, editorAnalyticsAPI);
    });
const $1823b137770fdb05$var$getAction = (newUrl, state)=>{
    const currentUrl = $1823b137770fdb05$var$getCurrentUrl(state);
    if (!currentUrl) return (0, $d925B.ACTION).ADDED;
    else if (newUrl !== currentUrl) return (0, $d925B.ACTION).EDITED;
    return undefined;
};
const $1823b137770fdb05$var$getNodeTypeAndMediaTypeAttributes = (state)=>{
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    const { allowInlineImages: allowInlineImages } = (0, $j5VfV.getMediaPluginState)(state);
    const { mediaInline: mediaInline, mediaSingle: mediaSingle } = state.schema.nodes;
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return {};
    if (allowInlineImages && node.type === mediaInline) return {
        type: mediaInline.name,
        mediaType: node.attrs.type
    };
    return {
        type: mediaSingle.name,
        mediaType: node.attrs.type
    };
};
const $1823b137770fdb05$export$b195a1839eae3673 = (url, inputMethod, editorAnalyticsAPI)=>(0, $11220e9e93c1fc6e$export$2c81aa6d281594cd)({
        type: (0, $367bc4b58467e5b0$export$6eb9cfa224a48678).setUrl,
        payload: (0, $b0F8r.normalizeUrl)(url)
    }, (tr, state)=>{
        const action = $1823b137770fdb05$var$getAction(url, state);
        if (!action) return tr;
        const nodeTypeAndMediaTypeAttrs = $1823b137770fdb05$var$getNodeTypeAndMediaTypeAttributes(state);
        try {
            const toggleLinkMarkResult = $1823b137770fdb05$var$toggleLinkMark(tr, state, {
                url: url
            });
            $1823b137770fdb05$var$fireAnalyticForMediaLink(tr, action, action === (0, $d925B.ACTION).ADDED ? {
                inputMethod: inputMethod,
                ...nodeTypeAndMediaTypeAttrs
            } : nodeTypeAndMediaTypeAttrs, editorAnalyticsAPI);
            return toggleLinkMarkResult;
        } catch (e) {
            $1823b137770fdb05$var$fireAnalyticForMediaLink(tr, (0, $d925B.ACTION).ERRORED, {
                action: action,
                ...nodeTypeAndMediaTypeAttrs
            }, editorAnalyticsAPI);
            throw e;
        }
    });


function $37685bafe60237da$export$2e2bcd8739ae039(schema) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.addLink).common, (0, $1823b137770fdb05$export$f0b12e75a8c0baf5), list);
    return (0, $dus6D.keymap)(list);
}














var $77a273b0db1cc17b$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'openPixelEditor':
            return {
                ...state,
                isPixelEditorOpen: true
            };
        case 'closePixelEditor':
            return {
                ...state,
                isPixelEditorOpen: false
            };
        default:
            return state;
    }
};


const $b2cea85c133cd38a$var$pluginKey = new (0, $ks2lK.PluginKey)('mediaPixelResizingPlugin');
const { createPluginState: $b2cea85c133cd38a$var$createPluginState, createCommand: $b2cea85c133cd38a$export$8d4021544bdece00, getPluginState: $b2cea85c133cd38a$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)($b2cea85c133cd38a$var$pluginKey, (0, $77a273b0db1cc17b$export$2e2bcd8739ae039), {
    onSelectionChanged () {
        return {
            isPixelEditorOpen: false
        };
    }
});
const $b2cea85c133cd38a$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $1S4f7.SafePlugin)({
        state: $b2cea85c133cd38a$var$createPluginState(dispatch, {
            isPixelEditorOpen: false
        }),
        key: $b2cea85c133cd38a$var$pluginKey
    });
};























parcelRequire("42omo");


var $10CSJ = parcelRequire("10CSJ");





var $jTxSS = parcelRequire("jTxSS");





var $dSVmA = parcelRequire("dSVmA");


var $kG148 = parcelRequire("kG148");

const $f8268604425bae0d$var$dummyMediaPickerObject = {
    on: ()=>{},
    removeAllListeners: ()=>{},
    emit: ()=>{},
    destroy: ()=>{},
    setUploadParams: ()=>{}
};
const $f8268604425bae0d$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider,
        mediaOptions: states.mediaState?.mediaOptions,
        insertFile: states.mediaState?.insertFile,
        options: states.mediaState?.options
    };
};
function $f8268604425bae0d$export$2e2bcd8739ae039({ api: api, analyticsName: analyticsName, children: children }) {
    const [state, setState] = (0, $42omo.useState)({
        pickerFacadeInstance: undefined,
        config: undefined,
        mediaClientConfig: undefined
    });
    const { mediaProvider: mediaProvider, mediaOptions: mediaOptions, insertFile: insertFile, options: options } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $f8268604425bae0d$var$selector);
    const handleMediaProvider = (0, $42omo.useCallback)(async (_name, provider)=>{
        const mediaProvider = await provider;
        if (!mediaProvider || !mediaProvider.uploadParams || !insertFile) return;
        const resolvedMediaClientConfig = await mediaProvider.uploadMediaClientConfig || await mediaProvider.viewMediaClientConfig;
        if (!resolvedMediaClientConfig) return;
        const pickerFacadeConfig = {
            mediaClientConfig: resolvedMediaClientConfig,
            errorReporter: options?.errorReporter || new (0, $dSVmA.ErrorReporter)(),
            featureFlags: mediaOptions && mediaOptions.featureFlags
        };
        const pickerFacadeInstance = await new (0, $kG148.default)('customMediaPicker', pickerFacadeConfig, $f8268604425bae0d$var$dummyMediaPickerObject, analyticsName).init();
        pickerFacadeInstance.onNewMedia(insertFile);
        pickerFacadeInstance.setUploadParams(mediaProvider.uploadParams);
        const config = {
            uploadParams: mediaProvider.uploadParams
        };
        (0, $jTxSS.flushSync)(()=>{
            setState({
                pickerFacadeInstance: pickerFacadeInstance,
                config: config,
                mediaClientConfig: resolvedMediaClientConfig
            });
        });
    }, [
        analyticsName,
        insertFile,
        mediaOptions,
        options?.errorReporter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mediaProvider) handleMediaProvider('mediaProvider', Promise.resolve(mediaProvider));
    }, [
        mediaProvider,
        handleMediaProvider
    ]);
    const { mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance } = state;
    if (!mediaClientConfig || !config || !pickerFacadeInstance) return null;
    return children({
        mediaClientConfig: mediaClientConfig,
        config: config,
        pickerFacadeInstance: pickerFacadeInstance
    });
}


const $73b71619487b5707$export$78e63feb3bcb89b0 = ({ api: api, isOpen: isOpen, onBrowseFn: onBrowseFn, featureFlags: featureFlags })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f8268604425bae0d$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "browser",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
            const browserConfig = {
                ...config,
                multiple: true
            };
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $10CSJ.BrowserLoader), {
                onBrowseFn: onBrowseFn,
                isOpen: isOpen,
                config: browserConfig,
                mediaClientConfig: mediaClientConfig,
                onEnd: pickerFacadeInstance.handleReady,
                onError: pickerFacadeInstance.handleUploadError,
                onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
                featureFlags: featureFlags
            });
        }
    });





parcelRequire("42omo");






class $4604cb0a3f342796$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        if (!this.state.Clipboard) Promise.all([
            (parcelRequire("iOEjY")),
            (parcelRequire("lNIRv"))
        ]).then(([mediaClient, clipboardModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $4604cb0a3f342796$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $4604cb0a3f342796$export$d7936799bf32b554.Clipboard
            });
        });
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            Clipboard: $4604cb0a3f342796$export$d7936799bf32b554.Clipboard
        };
    }
}
$4604cb0a3f342796$export$d7936799bf32b554.displayName = 'AsyncClipboard';
$4604cb0a3f342796$export$d7936799bf32b554.Clipboard = void 0;



const $bf5c2c48c38cbbb3$export$b7fcd7f87db4d1ee = ({ api: api, container: container, featureFlags: featureFlags })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f8268604425bae0d$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "clipboard",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
            const clipboardConfig = Object.assign({}, config);
            clipboardConfig.container = container;
            clipboardConfig.onPaste = (event)=>{
                event.stopPropagation();
                return false;
            };
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $4604cb0a3f342796$export$d7936799bf32b554), {
                mediaClientConfig: mediaClientConfig,
                config: clipboardConfig,
                onError: pickerFacadeInstance.handleUploadError,
                onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
                onEnd: pickerFacadeInstance.handleReady,
                featureFlags: featureFlags
            });
        }
    });





parcelRequire("42omo");





var $7YjFd = parcelRequire("7YjFd");


var $lhT9r = parcelRequire("lhT9r");


const $d5e201a6fe9989d2$var$selector = (states)=>{
    return {
        options: states.mediaState?.options,
        handleDrag: states.mediaState?.handleDrag
    };
};
const $d5e201a6fe9989d2$var$DropzoneWrapperInternal = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance, mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
    const { options: options, handleDrag: handleDrag } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $d5e201a6fe9989d2$var$selector);
    const { customDropzoneContainer: customDropzoneContainer } = options || {};
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorHtmlElement = editorDomElement;
    const scrollParent = appearance === 'full-page' && (0, $7YjFd.findOverflowScrollParent)(editorHtmlElement);
    const container = customDropzoneContainer || (scrollParent ? scrollParent : editorHtmlElement);
    const dropzoneConfig = {
        ...config,
        container: container
    };
    return isActive ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lhT9r.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onError: pickerFacadeInstance.handleUploadError,
        onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
        onEnd: pickerFacadeInstance.handleReady,
        onDragEnter: ()=>handleDrag?.('enter'),
        onDragLeave: ()=>handleDrag?.('leave'),
        featureFlags: featureFlags
    }) : null;
};
const $d5e201a6fe9989d2$export$1364cc2f4ae811f4 = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f8268604425bae0d$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "dropzone",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>/*#__PURE__*/ (0, $l998X.jsx)($d5e201a6fe9989d2$var$DropzoneWrapperInternal, {
                api: api,
                isActive: isActive,
                featureFlags: featureFlags,
                editorDomElement: editorDomElement,
                appearance: appearance,
                mediaClientConfig: mediaClientConfig,
                config: config,
                pickerFacadeInstance: pickerFacadeInstance
            })
    });


const $060092fbe00ceba4$var$selector = (states)=>{
    return {
        hasFocus: states.focusState?.hasFocus,
        connectivityMode: states.connectivityState?.mode,
        mediaOptions: states.mediaState?.mediaOptions
    };
};
const $060092fbe00ceba4$var$MediaPicker = ({ api: api, isPopupOpened: isPopupOpened, appearance: appearance, onBrowseFn: onBrowseFn, editorDomElement: editorDomElement })=>{
    const { hasFocus: hasFocus, connectivityMode: connectivityMode, mediaOptions: mediaOptions } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'focus',
        'connectivity',
        'media'
    ], $060092fbe00ceba4$var$selector);
    const featureFlags = mediaOptions && mediaOptions.featureFlags;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorDom = editorDomElement;
    const editorParent = editorDom.parentElement ?? undefined;
    /**
   * https://product-fabric.atlassian.net/browse/ED-21993
   * Avoid attach paste event to same dom element,
   * so editor-paste-plugin can use stopPropagation,
   * as stopImmediatePropagation could cause race condition issues
   */ const container = editorParent;
    const clipboard = hasFocus ? /*#__PURE__*/ (0, $l998X.jsx)((0, $bf5c2c48c38cbbb3$export$b7fcd7f87db4d1ee), {
        api: api,
        featureFlags: featureFlags,
        container: container
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            clipboard,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d5e201a6fe9989d2$export$1364cc2f4ae811f4), {
                api: api,
                isActive: !isPopupOpened && // If we're offline don't show the dropzone
                connectivityMode !== 'offline',
                featureFlags: featureFlags,
                editorDomElement: editorDomElement,
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $73b71619487b5707$export$78e63feb3bcb89b0), {
                api: api,
                onBrowseFn: onBrowseFn,
                featureFlags: featureFlags
            })
        ]
    });
};
class $060092fbe00ceba4$export$b8a89db960d45391 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const { onPopupToggle: onPopupToggle } = this.props;
        onPopupToggle((isPopupOpened)=>{
            this.setState({
                isPopupOpened: isPopupOpened
            });
        });
    }
    render() {
        const { api: api, editorDomElement: editorDomElement, appearance: appearance } = this.props;
        const { isPopupOpened: isPopupOpened } = this.state;
        return /*#__PURE__*/ (0, $l998X.jsx)($060092fbe00ceba4$var$MediaPicker, {
            editorDomElement: editorDomElement,
            appearance: appearance,
            isPopupOpened: isPopupOpened,
            onBrowseFn: this.onBrowseFn,
            api: api
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPopupOpened: false
        };
        this.onBrowseFn = (nativeBrowseFn)=>{
            const { setBrowseFn: setBrowseFn } = this.props;
            setBrowseFn(nativeBrowseFn);
        };
    }
}
$060092fbe00ceba4$export$b8a89db960d45391.displayName = 'MediaPickerComponents';



var $c6AnB = parcelRequire("c6AnB");




parcelRequire("42omo");





var $6xEOh = parcelRequire("6xEOh");





var $2YJKQ = parcelRequire("2YJKQ");


var $3RxtY = parcelRequire("3RxtY");

var $61p3e = parcelRequire("61p3e");

var $gVDfZ = parcelRequire("gVDfZ");





var $91bcx = parcelRequire("91bcx");











var $kqI1A = parcelRequire("kqI1A");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $9aGns = parcelRequire("9aGns");


var $lOzEN = parcelRequire("lOzEN");


var $eJ7sW = parcelRequire("eJ7sW");


var $2tC8Z = parcelRequire("2tC8Z");


var $jNL69 = parcelRequire("jNL69");


var $65WMN = parcelRequire("65WMN");


var $46EIy = parcelRequire("46EIy");

const $c3f4eab8cbe88239$export$ddc30058b32b7b60 = (offset)=>{
    return `.${0, $46EIy.MediaFilmStripListItemSelector}:nth-child(${offset})`;
};



var $31QJ7 = parcelRequire("31QJ7");














/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








const $84d25cbb5dfa06f5$export$41750bfa58c03af2 = (0, $cgtv4.defineMessages)({
    validationFailedMessage: {
        id: "fabric.editor.media.pixelEntry.validationFailedMessage",
        defaultMessage: "Validation for width failed"
    },
    inputWidthTooltip: {
        id: "fabric.editor.media.pixelEntry.inputWidthTooltip",
        defaultMessage: "Max width {maxWidth}px"
    },
    inputWidthAriaLabel: {
        id: "fabric.editor.media.pixelEntry.inputWidthAriaLabel",
        defaultMessage: "Max width {maxWidth}px"
    },
    inputWidthLabel: {
        id: "fabric.editor.media.pixelEntry.inputWidthLabel",
        defaultMessage: "Width"
    },
    inputHeightTooltip: {
        id: "fabric.editor.media.pixelEntry.inputHeightTooltip",
        defaultMessage: "Height"
    },
    inputHeightAriaLabel: {
        id: "fabric.editor.media.pixelEntry.inputHeightAriaLabel",
        defaultMessage: "height input"
    },
    submitButtonText: {
        id: "fabric.editor.media.pixelEntry.submitButtonText",
        defaultMessage: "Submit"
    },
    fullWidthLabel: {
        id: "fabric.editor.image.fullWidthLabel",
        defaultMessage: "Full-width"
    },
    migrationButtonText: {
        id: "fabric.editor.media.pixelEntry.migrationButtonText",
        defaultMessage: "Convert to pixels"
    },
    migrationButtonTooltip: {
        id: "fabric.editor.media.pixelEntry.migrationButtonTooltip",
        defaultMessage: "Migrate from percentage to fixed pixel sizing"
    },
    closePixelEntry: {
        id: "fabric.editor.media.pixelEntry.closePixelEntry",
        defaultMessage: "Close"
    },
    resizeOption: {
        id: "fabric.editor.media.pixelEntry.ResizeOption",
        defaultMessage: "Resize"
    }
});




















var $iXCQx = parcelRequire("iXCQx");











const $0871da91a4b46d6d$export$3f611b75d530f269 = ()=>{
    return (0, $b2cea85c133cd38a$export$8d4021544bdece00)({
        type: 'openPixelEditor'
    });
};
const $0871da91a4b46d6d$export$6113a2660dc189b8 = ()=>{
    return (0, $b2cea85c133cd38a$export$8d4021544bdece00)({
        type: 'closePixelEditor'
    });
};
const $0871da91a4b46d6d$export$b46ccfbc4dc863e = (saveTransform)=>{
    return (0, $b2cea85c133cd38a$export$8d4021544bdece00)({
        type: 'closePixelEditor'
    }, saveTransform);
};


/* eslint-disable jsdoc/check-tag-names */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $eEA8O = parcelRequire("eEA8O");


var $1qfLF = parcelRequire("1qfLF");



var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $hmuev = parcelRequire("hmuev");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");






var $4noo5 = parcelRequire("4noo5");


var $3gadb = parcelRequire("3gadb");

const $61e86bc6608390db$export$92acff719f79f188 = 'pixel-entry-convert-pixels-btn';
const $61e86bc6608390db$export$e879bf3f9286d0ca = 240;
const $61e86bc6608390db$export$82086c41f042e8aa = 204;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



function $afc0bf870773de88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $afc0bf870773de88$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH = 120;
const $afc0bf870773de88$export$7adff2da6cbda45a = /*#__PURE__*/ (0, $9K4OG.css)("display:grid;grid-template-columns:1fr 1em 1fr 0;grid-template-rows:auto;grid-template-areas:'widthinput label heightinput submit';width:", $afc0bf870773de88$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH, "px;text-align:center;height:var(--ds-space-300, 24px);&>*{margin-top:0!important;}");
const $afc0bf870773de88$export$a087928e226af252 = {
    name: "jf7je1",
    styles: "form{width:100%;}"
};
const $afc0bf870773de88$export$8eb4fadc3d78e5b8 = {
    name: "kleeuo",
    styles: "width:100%;height:var(--ds-space-300, 24px);& input{text-align:center;}"
};
const $afc0bf870773de88$export$24de6e5e0b062da4 = {
    name: "6o3mvm",
    styles: "grid-area:widthinput"
};
const $afc0bf870773de88$export$239e009fce8340c = {
    name: "10wktdx",
    styles: "grid-area:heightinput"
};
const $afc0bf870773de88$export$2eb599df69546ffe = {
    name: "1555zxw",
    styles: "grid-area:submit;visibility:hidden;width:0;height:0;padding:0"
};
const $afc0bf870773de88$export$e7603c3ecd81d479 = /*#__PURE__*/ (0, $9K4OG.css)({
    minWidth: `${$afc0bf870773de88$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH}px`,
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});


function $50a56b0a5f9dab8c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $50a56b0a5f9dab8c$var$pixelSizingLabel = (0, $ecnYn.xcss)({
    gridArea: 'label',
    lineHeight: "var(--ds-space-300, 24px)"
});
const $50a56b0a5f9dab8c$export$87ba3d82a3f32422 = ({ width: width, mediaWidth: mediaWidth, mediaHeight: mediaHeight, onSubmit: onSubmit, minWidth: minWidth, maxWidth: maxWidth, onChange: onChange, intl: { formatMessage: formatMessage }, showMigration: showMigration, onMigrate: onMigrate, onCloseAndSave: onCloseAndSave, isViewMode: isViewMode, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const ratioWidth = (0, $42omo.useMemo)(()=>{
        return mediaHeight / mediaWidth;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const ratioHeight = (0, $42omo.useMemo)(()=>{
        return mediaWidth / mediaHeight;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const [computedWidth, setComputedWidth] = (0, $42omo.useState)(width);
    const [computedHeight, setComputedHeight] = (0, $42omo.useState)(Math.round(ratioWidth * width));
    // Handle update to width from outside component
    (0, $42omo.useEffect)(()=>{
        setComputedWidth(width);
        setComputedHeight(Math.round(ratioWidth * width));
    }, [
        width,
        ratioWidth
    ]);
    // Handle submit when user presses enter in form
    const handleOnSubmit = (data)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onSubmit) {
            let widthToBeSumitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSumitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSumitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSumitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSumitted));
            }
            onSubmit({
                width: widthToBeSumitted,
                validation: validation
            });
        }
    };
    // Handle submit when user presses enter or click close button in PixelEntryComponentNext
    const handleCloseAndSave = (0, $42omo.useCallback)((data, setFocus)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onCloseAndSave) {
            let widthToBeSubmitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSubmitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSubmitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSubmitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSubmitted));
            }
            onCloseAndSave({
                width: widthToBeSubmitted,
                validation: validation
            }, setFocus);
        }
    }, [
        maxWidth,
        minWidth,
        onCloseAndSave,
        ratioWidth
    ]);
    // Handle updating computed fields based on
    const handleOnChange = (0, $42omo.useCallback)((type)=>(event)=>{
            const value = parseInt(event.currentTarget.value);
            const newInputValue = isNaN(value) ? '' : value;
            let newWidth = '';
            switch(type){
                case 'inputWidth':
                    {
                        newWidth = newInputValue;
                        setComputedWidth(newInputValue);
                        const newHeight = newInputValue !== '' ? Math.round(ratioWidth * newInputValue) : '';
                        setComputedHeight(newHeight);
                        break;
                    }
                case 'inputHeight':
                    setComputedHeight(newInputValue);
                    newWidth = newInputValue !== '' ? Math.round(ratioHeight * newInputValue) : '';
                    setComputedWidth(newWidth);
                    break;
            }
            const isInvalidInputValid = newWidth !== '' && (newWidth < minWidth || newWidth > maxWidth);
            onChange && onChange(isInvalidInputValid);
        }, [
        minWidth,
        maxWidth,
        onChange,
        ratioWidth,
        ratioHeight
    ]);
    if (showMigration) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).migrationButtonTooltip)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eEA8O.default), {
        appearance: "warning",
        spacing: "compact",
        onClick: onMigrate,
        testId: (0, $61e86bc6608390db$export$92acff719f79f188)
    }, formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).migrationButtonText)));
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $9K4OG.jsx)($50a56b0a5f9dab8c$export$94fe217aa650da08, {
        maxWidth: maxWidth,
        formatMessage: formatMessage,
        handleFieldChange: handleOnChange,
        computedWidth: computedWidth,
        computedHeight: computedHeight,
        handleCloseAndSave: handleCloseAndSave,
        isViewMode: isViewMode
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $afc0bf870773de88$export$a087928e226af252)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fzqvY.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps })=>{
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $9K4OG.jsx)("form", formProps, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $afc0bf870773de88$export$7adff2da6cbda45a)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fb3kw.default), {
            key: "inputWidth",
            name: "inputWidth",
            defaultValue: computedWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputWidthTooltip, {
                    maxWidth: maxWidth
                }),
                position: "top"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                css: [
                    (0, $afc0bf870773de88$export$24de6e5e0b062da4),
                    (0, $afc0bf870773de88$export$8eb4fadc3d78e5b8)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputWidth'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputWidthAriaLabel, {
                    maxWidth: maxWidth
                })
            }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $50a56b0a5f9dab8c$var$pixelSizingLabel
        }, "\xd7"), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fb3kw.default), {
            key: "inputHeight",
            name: "inputHeight",
            defaultValue: computedHeight
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputHeightTooltip),
                position: "top"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                css: [
                    (0, $afc0bf870773de88$export$239e009fce8340c),
                    (0, $afc0bf870773de88$export$8eb4fadc3d78e5b8)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputHeight'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputHeightAriaLabel)
            }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eEA8O.default), {
            css: (0, $afc0bf870773de88$export$2eb599df69546ffe),
            type: "submit"
        }, formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).submitButtonText)))));
    })));
};
const $50a56b0a5f9dab8c$var$pixelEntryWrapperStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $61e86bc6608390db$export$e879bf3f9286d0ca)}px`
});
const $50a56b0a5f9dab8c$var$pixelEntryWrapperViewModeStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $61e86bc6608390db$export$82086c41f042e8aa)}px`
});
const $50a56b0a5f9dab8c$var$fieldStyles = {
    name: "1we2h56",
    styles: "[data-ds--text-field--input]{padding-block:var(--ds-space-0, 0px);padding-inline:var(--ds-space-100, 8px);}flex:1"
};
const $50a56b0a5f9dab8c$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '1px',
    height: "var(--ds-space-500, 40px)",
    background: "var(--ds-border, #0B120E24)",
    marginInlineEnd: 'space.050'
});
const $50a56b0a5f9dab8c$export$94fe217aa650da08 = ({ maxWidth: maxWidth, formatMessage: formatMessage, handleFieldChange: handleFieldChange, computedWidth: computedWidth, computedHeight: computedHeight, handleCloseAndSave: handleCloseAndSave, isViewMode: isViewMode })=>{
    const widthInputRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (widthInputRef.current) {
            if (isViewMode) widthInputRef.current.blur();
            else widthInputRef.current.focus();
        }
    }, [
        isViewMode,
        widthInputRef
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') {
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    const handleCloseButtonKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: [
            $50a56b0a5f9dab8c$var$pixelEntryWrapperStyles,
            isViewMode && $50a56b0a5f9dab8c$var$pixelEntryWrapperViewModeStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputWidthLabel))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $50a56b0a5f9dab8c$var$fieldStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        position: "top",
        content: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputWidthTooltip, {
            maxWidth: maxWidth
        })
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
        name: "inputWidth",
        value: computedWidth,
        ref: widthInputRef,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputWidthAriaLabel, {
            maxWidth: maxWidth
        }),
        onChange: handleFieldChange('inputWidth'),
        onKeyDown: handleKeyDown
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputHeightTooltip))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $50a56b0a5f9dab8c$var$fieldStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        content: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputHeightTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
        name: "inputHeight",
        value: computedHeight,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).inputHeightAriaLabel),
        onChange: handleFieldChange('inputHeight'),
        onKeyDown: handleKeyDown
    }))), !isViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $50a56b0a5f9dab8c$var$dividerStyles
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).closePixelEntry),
        appearance: "subtle",
        onClick: ()=>{
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            });
        },
        onKeyDown: handleCloseButtonKeyDown
    }))));
};



const $a0d28fa5363c2665$export$4c9bbfa83ba6e1fa = ({ editorView: editorView, selectedMediaSingleNode: selectedMediaSingleNode, pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const contentWidth = pluginInjectionApi?.width.sharedState.currentState()?.lineLength || (0, $aFUXX.akEditorDefaultLayoutWidth);
    const { width: mediaSingleWidth, widthType: widthType, layout: layout } = selectedMediaSingleNode.node.attrs;
    // hasParentNode will return falsey value if selection depth === 0
    const isNested = (0, $8m4tT.hasParentNode)((n)=>n.type !== state.schema.nodes.doc)(state.selection);
    const updateNodeWithTr = (0, $42omo.useCallback)((width, validation)=>{
        const newLayout = (0, $cAGd7.calcNewLayout)(width, layout, contentWidth, isEditorFullWidthEnabled, isNested);
        return (0, $aR6HD.updateMediaSingleWidthTr)(pluginInjectionApi?.analytics?.actions, state, width, validation, 'floatingToolBar', newLayout);
    }, [
        layout,
        contentWidth,
        isEditorFullWidthEnabled,
        isNested,
        state,
        pluginInjectionApi
    ]);
    const selectedMediaNode = selectedMediaSingleNode.node.content.firstChild;
    if (!selectedMediaNode) return null;
    const { width: mediaWidth, height: mediaHeight } = selectedMediaNode.attrs;
    const maxWidthForNestedNode = pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth;
    const maxWidth = maxWidthForNestedNode || (0, $aFUXX.akEditorFullWidthLayoutWidth);
    const isVideoFile = (0, $7dSFG.isVideo)(selectedMediaNode.attrs.__fileMimeType);
    const minWidth = (0, $kfJSC.calcMinWidth)(isVideoFile, maxWidthForNestedNode || contentWidth);
    const hasPixelType = widthType === 'pixel';
    const pixelWidthFromElement = (0, $cAGd7.getPixelWidthOfElement)(editorView, selectedMediaSingleNode.pos + 1, // get pos of media node
    mediaWidth || (0, $gAARK.DEFAULT_IMAGE_WIDTH));
    const pixelWidth = hasPixelType ? mediaSingleWidth : pixelWidthFromElement;
    const forceFocusSelector = pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector;
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $50a56b0a5f9dab8c$export$87ba3d82a3f32422), {
        intl: intl,
        width: pluginState.isResizing ? pluginState.resizingWidth : pixelWidth,
        showMigration: !pluginState.isResizing && !hasPixelType,
        mediaWidth: mediaWidth || (0, $gAARK.DEFAULT_IMAGE_WIDTH),
        mediaHeight: mediaHeight || (0, $gAARK.DEFAULT_IMAGE_HEIGHT),
        minWidth: minWidth,
        maxWidth: maxWidth,
        onChange: (valid)=>{
            if (valid) hoverDecoration?.(mediaSingle, true, 'warning')(editorView.state, dispatch, editorView);
            else hoverDecoration?.(mediaSingle, false)(editorView.state, dispatch, editorView);
        },
        onSubmit: ({ width: width, validation: validation })=>{
            const tr = updateNodeWithTr(width, validation);
            if (tr) dispatch(tr);
        },
        onMigrate: ()=>{
            let tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
                ...selectedMediaSingleNode.node.attrs,
                width: pixelWidthFromElement,
                widthType: 'pixel'
            });
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
            if (triggerButtonSelector) {
                const newTr = forceFocusSelector && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            dispatch(tr);
        },
        onCloseAndSave: ({ width: width, validation: validation }, setFocus)=>{
            let tr = updateNodeWithTr(width, validation);
            if (setFocus && triggerButtonSelector) {
                const newTr = forceFocusSelector && tr && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            if (tr) return (0, $0871da91a4b46d6d$export$b46ccfbc4dc863e)(()=>tr)(state, dispatch);
        },
        isViewMode: pluginState.isResizing,
        triggerButtonSelector: triggerButtonSelector,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $a0d28fa5363c2665$export$8bde7db5b2aba7d = ({ intl: { formatMessage: formatMessage } })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $afc0bf870773de88$export$e7603c3ecd81d479)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), null, formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).fullWidthLabel))));
};











/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








const $1fef645a76895d1d$export$cb37ac89e145f1d = (0, $cgtv4.defineMessages)({
    borderColor: {
        id: "fabric.editor.imageBorderColor",
        defaultMessage: "Color"
    },
    borderColorDropdownAriaLabel: {
        id: "fabric.editor.imageBorderColor.dropdownAriaLabel",
        defaultMessage: "Image border options Color dropdown"
    },
    borderSize: {
        id: "fabric.editor.imageBorderSize",
        defaultMessage: "Size"
    },
    borderSizeDropdownAriaLabel: {
        id: "fabric.editor.imageBorderSize.dropdownAriaLabel",
        defaultMessage: "Image border options Size dropdown"
    },
    addBorder: {
        id: "fabric.editor.addImageBorder",
        defaultMessage: "Add border"
    },
    removeBorder: {
        id: "fabric.editor.removeImageBorder",
        defaultMessage: "Remove border"
    },
    borderOptions: {
        id: "fabric.editor.imageBorderOptions",
        defaultMessage: "Border options"
    },
    borderSizeSubtle: {
        id: "fabric.editor.imageBorderSubtle",
        defaultMessage: "Subtle"
    },
    borderSizeMedium: {
        id: "fabric.editor.imageBorderMedium",
        defaultMessage: "Medium"
    },
    borderSizeBold: {
        id: "fabric.editor.imageBorderBold",
        defaultMessage: "Bold"
    }
});



var $lwMQJ = parcelRequire("lwMQJ");


var $jwWgu = parcelRequire("jwWgu");


var $eINDz = parcelRequire("eINDz");


var $lhtyR = parcelRequire("lhtyR");


var $hMewq = parcelRequire("hMewq");


var $fWSjz = parcelRequire("fWSjz");

const $563fc0c751f52a9f$var$borderColorPalette = [];
(0, $eINDz.borderColorPalette).forEach((label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $hMewq.default)((0, $fWSjz.default), key);
    $563fc0c751f52a9f$var$borderColorPalette.push({
        value: color,
        label: label,
        border: (0, $lhtyR.DEFAULT_BORDER_COLOR),
        message: message
    });
});
var $563fc0c751f52a9f$export$2e2bcd8739ae039 = $563fc0c751f52a9f$var$borderColorPalette;


var $8LFdJ = parcelRequire("8LFdJ");

var $hxEux = parcelRequire("hxEux");


var $9Z3I5 = parcelRequire("9Z3I5");

var $5v8Ta = parcelRequire("5v8Ta");

var $h4TOP = parcelRequire("h4TOP");

var $a4eZN = parcelRequire("a4eZN");


var $bSKDV = parcelRequire("bSKDV");


var $6oGZN = parcelRequire("6oGZN");


var $ghftu = parcelRequire("ghftu");


var $3jDos = parcelRequire("3jDos");


var $gfsOF = parcelRequire("gfsOF");


var $gDgeb = parcelRequire("gDgeb");







/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766









function $558ce77c58bddfb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $558ce77c58bddfb6$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $558ce77c58bddfb6$export$e14354b446b68c1f = 4;
const $558ce77c58bddfb6$export$b102432b1d401cd6 = /*#__PURE__*/ (0, $9K4OG.css)("display:flex;&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:", `var(--ds-icon, ${(0, $6fnsQ.N90)})`, ";}");
const $558ce77c58bddfb6$export$3c6c744e4fb4ffeb = (color)=>/*#__PURE__*/ (0, $9K4OG.css)($558ce77c58bddfb6$export$b102432b1d401cd6, " &::before{content:'';display:block;border:1px solid ", (0, $lhtyR.DEFAULT_BORDER_COLOR), ";border-radius:var(--ds-radius-small, 3px);width:20px;height:20px;", color && `background: ${color}`, ";}");
const $558ce77c58bddfb6$export$22186258d84a0d25 = (index)=>/*#__PURE__*/ (0, $9K4OG.css)("border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N60A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`, ";display:flex;position:absolute;top:", index * ($558ce77c58bddfb6$export$1a7f12094b137d20.height + $558ce77c58bddfb6$export$e14354b446b68c1f * 2), "px;left:", $558ce77c58bddfb6$export$1a7f12094b137d20.width, "px;padding:var(--ds-space-100, 8px);>div{padding:0;}");
const $558ce77c58bddfb6$export$fd4d27a26b4854f3 = (selected)=>/*#__PURE__*/ (0, $9K4OG.css)("height:26px;width:26px;padding:0;border-radius:4px;background-color:", selected ? `var(--ds-text, ${0, $6fnsQ.N800})` : `var(--ds-background-neutral, ${0, $6fnsQ.N20A})`, ";border:1px solid ", (0, $lhtyR.DEFAULT_BORDER_COLOR), ";cursor:pointer;display:block;");
const $558ce77c58bddfb6$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $9K4OG.css)("border:1px solid transparent;margin:var(--ds-space-025, 2px);font-size:0;display:flex;align-items:center;padding:var(--ds-space-025, 2px);border-radius:6px;&:focus-within,&:focus,&:hover{border-color:", `var(--ds-border, ${(0, $6fnsQ.N50)})`, "!important;}");
const $558ce77c58bddfb6$export$53f1d5ea8de3d7c = (size, selected)=>/*#__PURE__*/ (0, $9K4OG.css)("position:relative;&:before{content:'';display:block;position:absolute;top:50%;left:50%;width:12px;height:", size, "px;background-color:", selected ? `var(--ds-icon-inverse, ${0, $6fnsQ.N0})` : "var(--ds-icon, #44546F)", ";border-radius:90px;transform:translate(-50%, -50%) rotate(135deg);}");
const $558ce77c58bddfb6$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${`var(--ds-background-neutral-subtle-hovered, ${$6fnsQ.N20A})`};

    &:hover {
      background: ${`var(--ds-background-neutral-hovered, ${$6fnsQ.N30A})`};
    }
  }`;
const $558ce77c58bddfb6$export$6d722733f5366928 = ({ enabled: enabled, isOpen: isOpen })=>/*#__PURE__*/ (0, $9K4OG.css)("display:flex;.image-border-toolbar-btn{border-top-right-radius:0;border-bottom-right-radius:0;padding:0;&>span{margin:0;}&:not([disabled])::after{border:none;}}.image-border-toolbar-dropdown{padding:0;width:16px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;margin-left:var(--ds-space-025, 2px);&>span{margin:0;}&:not([disabled])::after{border:none;}}", !enabled && $558ce77c58bddfb6$var$getHoverStyles('.image-border-toolbar-btn'), " ", !isOpen && !enabled && $558ce77c58bddfb6$var$getHoverStyles('.image-border-toolbar-dropdown'), ";");
const $558ce77c58bddfb6$export$8918fcb9aa07f104 = {
    name: "1gm9p5x",
    styles: "background:transparent;border:2px solid transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:8px 16px;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));border:2px solid var(--ds-border-focused, #2684FF);}"
};
const $558ce77c58bddfb6$export$89634948c2be5ede = {
    name: "3linml",
    styles: "span[role='menuitem']{padding:0;}"
};


const $28f444d0bba3edb5$var$ImageBorder = ({ intl: { formatMessage: formatMessage }, toggleBorder: toggleBorder, borderMark: borderMark, setBorder: setBorder })=>{
    const popupTarget = (0, $42omo.useRef)(null);
    const dropDownColorOptionButton = (0, $42omo.useRef)(null);
    const dropDownSizeOptionButton = (0, $42omo.useRef)(null);
    const colorSubmenuRef = (0, $42omo.useRef)(null);
    const sizeSubmenuRef = (0, $42omo.useRef)(null);
    const openDropdownButtonRef = (0, $42omo.useRef)(null);
    const enabled = !!borderMark;
    const color = borderMark?.color;
    const size = borderMark?.size;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $42omo.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $42omo.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $42omo.useState)(false);
    const handleColorSubmenuEsc = (0, $42omo.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton?.current?.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $42omo.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton?.current?.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, callback)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callback();
            setIsOpenedByKeyboard(true);
        }
    };
    (0, $42omo.useEffect)(()=>{
        const focusFirstOption = (submenuRef, isOpen)=>{
            if (!isOpenByKeyboard) return;
            if (isOpen && submenuRef.current) {
                const firstOption = submenuRef.current.querySelector('button');
                if (!firstOption) return;
                firstOption.focus();
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                firstOption.dispatchEvent(keyboardEvent);
            }
        };
        focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
        focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderSizeSubtle),
            value: 1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDgeb)))
        },
        {
            name: formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderSizeMedium),
            value: 2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gfsOF)))
        },
        {
            name: formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderSizeBold),
            value: 3,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3jDos)))
        }
    ];
    const items = [
        {
            content: /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                ref: dropDownColorOptionButton,
                type: "button",
                "aria-label": formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderColorDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-color",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: [
                    (0, $558ce77c58bddfb6$export$8918fcb9aa07f104)
                ],
                "aria-expanded": isColorSubmenuOpen,
                onKeyDown: (e)=>handleTriggerByKeyboard(e, ()=>setIsColorSubmenuOpen(!isColorSubmenuOpen))
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), null, formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderColor)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $558ce77c58bddfb6$export$b102432b1d401cd6)
            })), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU,
                ref: colorSubmenuRef
            }, isColorSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $558ce77c58bddfb6$export$22186258d84a0d25)(0),
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    handleColorSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hxEux.default), {
                onClick: (color)=>{
                    setBorder({
                        color: color
                    });
                    setIsOpen(!isOpen);
                },
                onKeyDown: (color, _, event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        setBorder({
                            color: color
                        });
                        setIsOpen(!isOpen);
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                        openDropdownButtonRef.current?.focus();
                    }
                },
                selectedColor: color ?? null,
                paletteOptions: {
                    palette: (0, $563fc0c751f52a9f$export$2e2bcd8739ae039),
                    paletteColorTooltipMessages: (0, $8LFdJ.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $bSKDV.hexToEditorBorderPaletteColor)
                }
            }))))),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-image-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                type: "button",
                "aria-label": formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderSizeDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-size",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: [
                    (0, $558ce77c58bddfb6$export$8918fcb9aa07f104)
                ],
                "aria-expanded": isSizeSubmenuOpen,
                ref: dropDownSizeOptionButton,
                onKeyDown: (e)=>handleTriggerByKeyboard(e, ()=>setIsSizeSubmenuOpen(!isSizeSubmenuOpen))
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), null, formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderSize)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $558ce77c58bddfb6$export$b102432b1d401cd6)
            })), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                //eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU,
                ref: sizeSubmenuRef
            }, isSizeSubmenuOpen && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    handleSizeSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $558ce77c58bddfb6$export$22186258d84a0d25)(1),
                ref: handleSubMenuRef
            }, borderSizeOptions.map(({ name: name, value: value, icon: icon }, idx)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = icon;
                return(// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                    key: idx,
                    content: name
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    css: (0, $558ce77c58bddfb6$export$7afe8f4b3442c19d)
                }, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                    type: "button",
                    /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $558ce77c58bddfb6$export$fd4d27a26b4854f3)(value === size),
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === size,
                    onClick: ()=>{
                        setBorder({
                            size: value
                        });
                        setIsOpen(false);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            setBorder({
                                size: value
                            });
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            openDropdownButtonRef.current?.focus();
                        }
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                    color: value === size ? "var(--ds-icon-inverse, #FFFFFF)" : 'currentColor',
                    spacing: "spacious",
                    label: ""
                })))));
            }))))),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-image-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ];
    /**
   * We want to change direction of our dropdowns a bit early,
   * not exactly when it hits the boundary.
   */ const fitTolerance = 10;
    const fitWidth = (0, $558ce77c58bddfb6$export$1a7f12094b137d20).width;
    const fitHeight = items.length * ((0, $558ce77c58bddfb6$export$1a7f12094b137d20).height + (0, $558ce77c58bddfb6$export$e14354b446b68c1f));
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $558ce77c58bddfb6$export$6d722733f5366928)({
            enabled: enabled,
            isOpen: isOpen
        })
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-btn",
        selected: enabled,
        onClick: toggleBorder,
        spacing: "compact",
        "aria-label": enabled ? formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).removeBorder) : formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).addBorder),
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6oGZN))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        title: enabled ? formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).removeBorder) : formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).addBorder)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: popupTarget
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-dropdown",
        ref: openDropdownButtonRef,
        selected: enabled || isOpen,
        "aria-expanded": isOpen,
        "aria-label": formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderOptions),
        title: formatMessage((0, $1fef645a76895d1d$export$cb37ac89e145f1d).borderOptions),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        onClick: ()=>{
            setIsOpen(!isOpen);
            setIsOpenedByKeyboard(false);
        },
        onKeyDown: (e)=>handleTriggerByKeyboard(e, ()=>setIsOpen(!isOpen))
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        target: popupTarget.current ? popupTarget.current : undefined,
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance,
        forcePlacement: true,
        stick: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $558ce77c58bddfb6$export$89634948c2be5ede)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $h4TOP.default), {
        //This needs be removed when the a11y is completely handled
        //Disabling key navigation now as it works only partially
        //Same with packages/editor/editor-plugin-table/src/plugins/table/ui/FloatingContextualMenu/ContextualMenu.tsx
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: isAnySubMenuOpen
        },
        allowEnterDefaultBehavior: isAnySubMenuOpen,
        handleEscapeKeydown: isAnySubMenuOpen ? ()=>{
            return;
        } : ()=>{
            openDropdownButtonRef.current?.focus();
        },
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        shouldFocusFirstItem: ()=>isOpenByKeyboard,
        onOpenChange: ()=>{
            setIsOpen(false);
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
            setIsOpenedByKeyboard(false);
        },
        onItemActivated: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen(!isColorSubmenuOpen);
            if (item.value.name === 'size') setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
        },
        onMouseEnter: ({ item: item })=>{
            if (item.value.name === 'color') {
                setIsColorSubmenuOpen(true);
                setIsOpenedByKeyboard(false);
            }
            if (item.value.name === 'size') {
                setIsSizeSubmenuOpen(true);
                setIsOpenedByKeyboard(false);
            }
        },
        onMouseLeave: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen(false);
            if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
        },
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance
    }))));
};
var $28f444d0bba3edb5$export$2e2bcd8739ae039 = $28f444d0bba3edb5$var$ImageBorder;





parcelRequire("42omo");







const $6fc78f23e5944af3$export$63563c8e4d4e5bae = (0, $cgtv4.defineMessages)({
    altText: {
        id: "fabric.editor.addAltText",
        defaultMessage: "Alt text"
    },
    addAltText: {
        id: "fabric.editor.addUpdatedAltText",
        defaultMessage: "Add alt text"
    },
    editAltText: {
        id: "fabric.editor.editAltText",
        defaultMessage: "Edit alt text"
    },
    back: {
        id: "fabric.editor.closeAltTextEdit",
        defaultMessage: "Back"
    },
    clear: {
        id: "fabric.editor.clearAltTextEdit",
        defaultMessage: "Clear alt text"
    },
    placeholder: {
        id: "fabric.editor.placeholderAltText",
        defaultMessage: "Describe this image with alt text"
    },
    supportText: {
        id: "fabric.editor.supportAltText",
        defaultMessage: "Alt text is useful for people using screen readers because of visual limitations."
    },
    validationMessage: {
        id: "fabric.editor.alttext.validation",
        defaultMessage: "Please remove any special characters in alt text."
    }
});



var $ag6aQ = parcelRequire("ag6aQ");


var $9fPrY = parcelRequire("9fPrY");





var $egUUs = parcelRequire("egUUs");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $gmMgo = parcelRequire("gmMgo");


var $1DWH0 = parcelRequire("1DWH0");




var $ajtqX = parcelRequire("ajtqX");








/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");







function $b07b1741f2735aa4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b07b1741f2735aa4$var$errorColor = {
    name: "hwd2ye",
    styles: "color:var(--ds-text-danger, #AE2E24)"
};
const $b07b1741f2735aa4$var$validColor = {
    name: "88plqi",
    styles: "color:var(--ds-text-success, #4C6B1F)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $b07b1741f2735aa4$var$messageStyle = ()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        marginTop: "var(--ds-space-050, 4px)",
        display: 'flex',
        justifyContent: 'baseline'
    });
const $b07b1741f2735aa4$var$iconWrapperStyle = {
    name: "15quk7w",
    styles: "display:flex;margin-right:var(--ds-space-050, 4px)"
};
const $b07b1741f2735aa4$export$8fbe3c7d0ed2c683 = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $b07b1741f2735aa4$var$messageStyle
    }, children);
const $b07b1741f2735aa4$export$915e9e7bd4f0f96d = ({ children: children })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>{
            return [
                $b07b1741f2735aa4$var$messageStyle(),
                $b07b1741f2735aa4$var$errorColor
            ];
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $b07b1741f2735aa4$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: (0, $dh538.fg)('platform_editor_dec_a11y_fixes') ? intl.formatMessage((0, $61p3e.default).error) : 'error',
        "aria-label": (0, $dh538.fg)('platform_editor_dec_a11y_fixes') ? undefined : 'error'
    })), children);
};
const $b07b1741f2735aa4$export$5505afb209a532c8 = ({ children: children })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>{
            return [
                $b07b1741f2735aa4$var$messageStyle(),
                $b07b1741f2735aa4$var$validColor
            ];
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $b07b1741f2735aa4$var$iconWrapperStyle
    }, (0, $dh538.fg)('platform_editor_dec_a11y_fixes') ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: intl.formatMessage((0, $61p3e.default).success)
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "success"
    })), children);
};


var $3P0Cg = parcelRequire("3P0Cg");

var $8i5w2 = parcelRequire("8i5w2");







var $laHi9 = parcelRequire("laHi9");


var $7yDmn = parcelRequire("7yDmn");





const $67ce4c7bd704ffcc$export$17c2363f220b4958 = 510; // double tweet length
const $67ce4c7bd704ffcc$var$supportTextStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(12),
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-500, 40px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`,
    margin: 0
});
const $67ce4c7bd704ffcc$var$containerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX)}px`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 2
});
const $67ce4c7bd704ffcc$var$inputWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $67ce4c7bd704ffcc$var$validationWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-danger, ${(0, $6fnsQ.R400)})`}`,
    alignItems: 'start',
    flexDirection: 'column'
});
const $67ce4c7bd704ffcc$var$buttonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
});
const $67ce4c7bd704ffcc$var$clearTextStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N80)})`
});
class $67ce4c7bd704ffcc$export$c3eac9b61d42d8a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.prevValue = this.props.value;
    }
    componentWillUnmount() {
        this.fireAnalytics((0, $d925B.ACTION).CLOSED);
        if (!this.prevValue && this.state.lastValue) this.fireAnalytics((0, $d925B.ACTION).ADDED);
        if (this.prevValue && !this.state.lastValue) this.fireAnalytics((0, $d925B.ACTION).CLEARED);
        if (this.prevValue && this.prevValue !== this.state.lastValue) this.fireAnalytics((0, $d925B.ACTION).EDITED);
    }
    getValidationErrors(value) {
        const { altTextValidator: altTextValidator } = this.props;
        if (value && typeof altTextValidator === 'function') return altTextValidator(value) || [];
        return [];
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { showClearTextButton: showClearTextButton } = this.state;
        const backButtonMessage = formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).back);
        const backButtonMessageComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: backButtonMessage,
            keymap: (0, $hgeg8.escape),
            shortcutOverride: "Esc"
        });
        const errorsList = (this.state.validationErrors || []).map(function(error, index) {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $b07b1741f2735aa4$export$915e9e7bd4f0f96d), {
                key: index
            }, error);
        });
        const hasErrors = !!errorsList.length;
        const onSubmit = this.props.areAnyNewToolbarFlagsEnabled ?? (0, $iHzeA.areToolbarFlagsEnabled)() ? this.closeMediaAltTextMenuAndSetFocus : this.closeMediaAltTextMenu;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $67ce4c7bd704ffcc$var$containerStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
            css: $67ce4c7bd704ffcc$var$inputWrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $67ce4c7bd704ffcc$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            title: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).back),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                label: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).back),
                size: "small"
            }),
            tooltipContent: backButtonMessageComponent,
            onClick: this.closeMediaAltTextMenu,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $iHzeA.areToolbarFlagsEnabled)()
        })), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8i5w2.default), {
            testId: "alt-text-input",
            ariaLabel: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).placeholder),
            describedById: `${hasErrors ? 'errors-list' : ''} support-text`,
            placeholder: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).placeholder),
            defaultValue: this.state.lastValue,
            onCancel: this.dispatchCancelEvent,
            onChange: this.handleOnChange,
            onBlur: this.handleOnBlur,
            onSubmit: onSubmit,
            maxLength: $67ce4c7bd704ffcc$export$17c2363f220b4958,
            ariaRequired: true,
            ariaInvalid: hasErrors,
            autoFocus: true
        }), showClearTextButton && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $67ce4c7bd704ffcc$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            testId: "alt-text-clear-button",
            title: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).clear),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: $67ce4c7bd704ffcc$var$clearTextStyles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).clear)
            })),
            tooltipContent: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).clear),
            onClick: this.handleClearText,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $iHzeA.areToolbarFlagsEnabled)()
        }))), hasErrors && /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
            id: "errors-list",
            ref: this.errorsListRef,
            "aria-live": "assertive",
            css: $67ce4c7bd704ffcc$var$validationWrapperStyles
        }, errorsList), /*#__PURE__*/ (0, $9K4OG.jsx)("p", {
            css: $67ce4c7bd704ffcc$var$supportTextStyles,
            id: "support-text"
        }, formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).supportText)));
    }
    fireAnalytics(actionType) {
        const { createAnalyticsEvent: createAnalyticsEvent, nodeType: nodeType, mediaType: mediaType } = this.props;
        if (createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: {
                action: actionType,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    type: nodeType,
                    mediaType: mediaType
                }
            }
        });
    }
    constructor(props){
        super(props);
        this.fireCustomAnalytics = void 0;
        this.errorsListRef = void 0;
        this.state = {
            showClearTextButton: Boolean(this.props.value),
            validationErrors: this.props.value ? this.getValidationErrors(this.props.value) : [],
            lastValue: this.props.value
        };
        this.prevValue = void 0;
        this.closeMediaAltTextMenu = ()=>{
            const { view: view } = this.props;
            if (this.state.validationErrors.length === 0) (0, $b5c14d60649e09b6$export$e494ea08c5b8d2cd)(this.state.lastValue || '')(view.state, view.dispatch);
            else (0, $b5c14d60649e09b6$export$56a9d6e428ac89c9)(view.state, view.dispatch);
        };
        this.closeMediaAltTextMenuAndSetFocus = ()=>{
            this.closeMediaAltTextMenu();
            this.props.onEnter?.();
        };
        this.dispatchCancelEvent = (event)=>{
            const { view: view, onEscape: onEscape } = this.props;
            // We need to pass down the ESCAPE keymap
            // because when we focus on the Toolbar, Prosemirror blur,
            // making all keyboard shortcuts not working
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            view.someProp('handleKeyDown', (fn)=>fn(view, event));
            onEscape?.();
        };
        this.handleOnChange = (newAltText)=>{
            const validationErrors = this.getValidationErrors(newAltText);
            if (this.state?.validationErrors?.length !== validationErrors?.length) // If number of errors was changed we need to reset attribute to get new SR announcement
            {
                if (this.errorsListRef) {
                    const errorsArea = this.errorsListRef?.current;
                    errorsArea?.removeAttribute('aria-live');
                    errorsArea?.setAttribute('aria-live', 'assertive');
                }
            }
            this.setState({
                showClearTextButton: Boolean(newAltText),
                validationErrors: validationErrors,
                lastValue: newAltText
            });
        };
        this.handleOnBlur = (e)=>{
            // prevent other selection transaction gets triggered
            e.stopPropagation();
            if (this.props.areAnyNewToolbarFlagsEnabled ?? (0, $iHzeA.areToolbarFlagsEnabled)()) this.closeMediaAltTextMenuAndSetFocus();
            else this.closeMediaAltTextMenu();
        };
        this.handleClearText = ()=>{
            this.handleOnChange('');
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        this.fireCustomAnalytics = (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent);
        this.errorsListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
var $67ce4c7bd704ffcc$export$2e2bcd8739ae039 = (0, $1DWH0.default)()((0, $gmMgo.default)($67ce4c7bd704ffcc$export$c3eac9b61d42d8a9));



var $9bkD0 = parcelRequire("9bkD0");







const $432518934a309d20$var$testId = 'alt-text-edit-button';
const $432518934a309d20$export$ee5eb653e9c77c53 = (intl, state, editorAnalyticsAPI)=>{
    const mediaNode = (0, $kjHnW.getMediaSingleOrInlineNodeFromSelection)(state);
    const message = mediaNode && mediaNode.attrs.alt ? (0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).editAltText : (0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).altText;
    const title = intl.formatMessage(message);
    return {
        title: title,
        id: 'editor.media.altText',
        type: 'button',
        onClick: (0, $b5c14d60649e09b6$export$e5f8c6baa484e73d)(editorAnalyticsAPI),
        showTitle: true,
        testId: $432518934a309d20$var$testId,
        tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: title,
            keymap: (0, $hgeg8.addAltText)
        })
    };
};
const $432518934a309d20$var$altTextEditComponent = (options)=>{
    return {
        type: 'custom',
        fallback: [],
        disableArrowNavigation: true,
        render: (view, idx)=>{
            if (!view) return null;
            const state = view.state;
            const mediaNode = (0, $kjHnW.getMediaSingleOrInlineNodeFromSelection)(state);
            if (!mediaNode) return null;
            /** Focus should move to the 'Alt text' button when the toolbar closes
       * and not close the floating toolbar.
       */ const setFocus = ()=>{
                const { state: { tr: tr }, dispatch: dispatch } = view;
                const elementSelector = options?.triggerButtonSelector && options?.areAnyNewToolbarFlagsEnabled ? options.triggerButtonSelector : `[data-testid="${$432518934a309d20$var$testId}"]`;
                const newTr = options?.forceFocusSelector?.(elementSelector)(tr);
                if (newTr) dispatch(newTr);
            };
            const type = (0, $aR6HD.getNodeType)(state);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $67ce4c7bd704ffcc$export$2e2bcd8739ae039), {
                view: view,
                nodeType: type,
                mediaType: mediaNode.attrs.type,
                value: mediaNode.attrs.alt,
                altTextValidator: options && options.altTextValidator,
                onEscape: setFocus,
                onEnter: setFocus,
                areAnyNewToolbarFlagsEnabled: options?.areAnyNewToolbarFlagsEnabled
            }, idx);
        }
    };
};
const $432518934a309d20$export$626712166441e24f = (toolbarBaseConfig, options)=>{
    return {
        ...toolbarBaseConfig,
        width: (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX),
        className: (0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT,
        items: [
            $432518934a309d20$var$altTextEditComponent(options)
        ]
    };
};
const $432518934a309d20$export$cf32f28463a52655 = (state, formatMessage, allowAltTextOnImages, selectedNodeType, editorAnalyticsAPI)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.attrs.type;
    if (allowAltTextOnImages && (selectedNodeType === mediaSingle || selectedNodeType === mediaInline && (0, $9bkD0.isImage)(mediaType))) return [
        {
            title: formatMessage((0, $6fc78f23e5944af3$export$63563c8e4d4e5bae).addAltText),
            onClick: (0, $b5c14d60649e09b6$export$e5f8c6baa484e73d)(editorAnalyticsAPI),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egUUs))), {
                label: ""
            }),
            testId: 'media-alt-text-dropdown-option'
        }
    ];
    return [];
};








parcelRequire("42omo");










var $7BTEV = parcelRequire("7BTEV");


var $ahUGI = parcelRequire("ahUGI");





var $1yB28 = parcelRequire("1yB28");










const $ab151bf461431233$export$c936f67f30fa5fde = (intl, state, api, onCommentButtonMount)=>{
    const selectMediaNode = (0, $cAGd7.getSelectedMediaSingle)(state)?.node.firstChild;
    let hasActiveComments = false;
    const annotations = api?.annotation?.sharedState.currentState()?.annotations;
    if (selectMediaNode && annotations) hasActiveComments = selectMediaNode.marks.some((mark)=>mark.type.name === 'annotation' && !annotations[mark.attrs.id]);
    const title = intl.formatMessage(hasActiveComments ? (0, $7BTEV.commentMessages).viewCommentsOnMedia : (0, $7BTEV.commentMessages).addCommentOnMedia);
    const buttonLabel = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
    const onClickHandler = (state, dispatch)=>{
        if (api?.annotation && selectMediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode, setInlineCommentDraftState: setInlineCommentDraftState } = api.annotation.actions;
            const isOpeningMediaCommentFromToolbar = (0, $dh538.fg)('confluence_frontend_media_scroll_fix') ? true : false;
            if (!showCommentForBlockNode(selectMediaNode, (0, $55QXP.VIEW_METHOD).COMMENT_BUTTON, isOpeningMediaCommentFromToolbar)(state, dispatch)) setInlineCommentDraftState(true, // TODO: ED-26962 - might need to update to reflect it's from media floating toolbar
            (0, $d925B.INPUT_METHOD).FLOATING_TB, 'block', selectMediaNode.attrs?.id, isOpeningMediaCommentFromToolbar)(state, dispatch);
        }
        return true;
    };
    return {
        type: 'button',
        testId: 'add-comment-media-button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        title: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? title : buttonLabel,
        showTitle: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
        onClick: onClickHandler,
        tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: title
        }),
        supportsViewMode: true,
        disabled: (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode),
        onMount: ()=>{
            if ((0, $dh538.fg)('confluence_frontend_preload_inline_comment_editor')) onCommentButtonMount && onCommentButtonMount();
        }
    };
};








function $91a37d1de1fe51de$export$5c7a39f9b065f644(editorState) {
    const border = editorState.schema.marks.border;
    if (!border) return false;
    const nodeWithPos = (0, $kfJSC.currentMediaNodeWithPos)(editorState) || (0, $jA06n.currentMediaInlineNodeWithPos)(editorState);
    if (!nodeWithPos) return false;
    const { parent: parent } = editorState.doc.resolve(nodeWithPos.pos);
    return parent && parent.type.allowsMarkType(border);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hArLp = parcelRequire("hArLp");




var $faH35 = parcelRequire("faH35");






const $1187043848f38019$var$containerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $1187043848f38019$export$7fe0cbe305f29bb4 = ({ layoutButtons: layoutButtons, dispatchCommand: dispatchCommand, hide: hide, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $1187043848f38019$var$containerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, layoutButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                        hide();
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};





parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");





var $fpEzC = parcelRequire("fpEzC");

var $ckqYV = parcelRequire("ckqYV");








var $1bY7o = parcelRequire("1bY7o");


var $8tdj3 = parcelRequire("8tdj3");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $3a8Ut = parcelRequire("3a8Ut");










var $48vaT = parcelRequire("48vaT");







function $cb194599536d1e97$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithActivityProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { providerFactory: providerFactory } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
                providers: [
                    'activityProvider'
                ],
                providerFactory: providerFactory,
                renderNode: this.renderNode
            });
        }
        constructor(...args){
            super(...args);
            this.renderNode = (providers)=>{
                const { providerFactory: providerFactory, ...props } = this.props;
                const { activityProvider: activityProvider } = providers;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                    activityProvider: activityProvider,
                    ...props
                });
            };
        }
    };
}


const $1145c7d3213c9839$var$DEFAULT_ITEMS_LIMIT = 5;
const $1145c7d3213c9839$var$limit = (items, max)=>{
    return items.slice(0, max);
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1145c7d3213c9839$var$RecentLink extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.defaultUrl !== this.props.defaultUrl) this.setState((state)=>{
            if (state.url !== this.props.defaultUrl) return {
                items: [],
                selectedIndex: -1,
                url: this.props.defaultUrl || ''
            };
            return null;
        });
    }
    async componentDidMount() {
        if (this.props.activityProvider) {
            this.activityProvider = await this.props.activityProvider;
            await this.loadRecentItems(this.activityProvider);
        }
    }
    async loadRecentItems(activityProvider) {
        try {
            if (!this.state.url) this.setState({
                isLoading: true,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                items: $1145c7d3213c9839$var$limit(await activityProvider.getRecentItems(), this.props.limit) // defaultProps assure that limit always contains a value
            });
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    getCurrentInputMethod() {
        const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
        if (items && items.length > 0 && selectedIndex > -1) return (0, $d925B.INPUT_METHOD).TYPEAHEAD;
        else if (url && url.length > 0) return (0, $d925B.INPUT_METHOD).MANUAL;
        return;
    }
    render() {
        const { render: render } = this.props;
        const { url: url } = this.state;
        return render({
            activityProvider: this.activityProvider,
            inputProps: {
                onChange: this.handleChange,
                onKeyDown: this.handleKeyDown,
                onSubmit: this.handleSubmit,
                value: url
            },
            clearValue: this.clearValue,
            currentInputMethod: this.getCurrentInputMethod(),
            renderRecentList: this.renderRecentList
        });
    }
    constructor(props){
        super(props);
        this.activityProvider = null;
        this.handleSubmit = ()=>{
            const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
            const inputMethod = this.getCurrentInputMethod();
            if (!inputMethod) return; // No call submit, if there is nothing to submit
            switch(inputMethod){
                case (0, $d925B.INPUT_METHOD).MANUAL:
                    this.props.onSubmit({
                        url: url,
                        text: url,
                        inputMethod: (0, $d925B.INPUT_METHOD).MANUAL
                    });
                    break;
                case (0, $d925B.INPUT_METHOD).TYPEAHEAD:
                    {
                        const item = items[selectedIndex];
                        this.setState(()=>({
                                url: item.url
                            }));
                        if (this.props.onSubmit) this.props.onSubmit({
                            url: item.url,
                            text: item.name,
                            inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                        });
                        break;
                    }
            }
        };
        this.handleSelected = (href, text)=>{
            if (this.props.onSubmit) {
                this.setState(()=>({
                        url: href
                    }));
                this.props.onSubmit({
                    text: text,
                    url: href,
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                });
            }
        };
        this.handleChange = async (input)=>{
            this.setState({
                url: input
            });
            if (this.activityProvider) {
                if (input.length === 0) this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $1145c7d3213c9839$var$limit(await this.activityProvider.getRecentItems(), this.props.limit),
                    selectedIndex: -1
                });
                else this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $1145c7d3213c9839$var$limit(await this.activityProvider.searchRecent(input), this.props.limit),
                    selectedIndex: 0
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (e)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (!items || !items.length) return;
            if (e.key === 'ArrowDown') {
                // down
                e.preventDefault();
                this.setState({
                    selectedIndex: (selectedIndex + 1) % items.length
                });
            } else if (e.key === 'ArrowUp') {
                // up
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : items.length - 1
                });
            }
        };
        this.handleMouseMove = (objectId)=>{
            const { items: items } = this.state;
            if (items) {
                const index = items.findIndex((item)=>item.objectId === objectId);
                this.setState({
                    selectedIndex: index
                });
            }
        };
        this.renderRecentList = ()=>{
            const { items: items, isLoading: isLoading, selectedIndex: selectedIndex } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48vaT.default), {
                items: items,
                isLoading: isLoading,
                selectedIndex: selectedIndex,
                onSelect: this.handleSelected,
                onMouseMove: this.handleMouseMove
            });
        };
        this.clearValue = ()=>{
            this.setState({
                url: ''
            });
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            items: [],
            url: props.defaultUrl || ''
        };
    }
}
$1145c7d3213c9839$var$RecentLink.defaultProps = {
    limit: $1145c7d3213c9839$var$DEFAULT_ITEMS_LIMIT
};
const $1145c7d3213c9839$var$_default_1 = (0, $cb194599536d1e97$export$2e2bcd8739ae039)((0, $gmMgo.default)($1145c7d3213c9839$var$RecentLink));
var $1145c7d3213c9839$export$2e2bcd8739ae039 = $1145c7d3213c9839$var$_default_1;





const $4ab4865cf1226f73$export$8fc7ee45d6c4fad2 = (0, $cgtv4.defineMessages)({
    backLink: {
        id: "fabric.editor.backLink",
        defaultMessage: "Go back"
    }
});



















var $dZMVn = parcelRequire("dZMVn");




const $41b22e566e31d3e5$var$validationWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-400, 32px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-danger, ${(0, $6fnsQ.R400)})`}`,
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column'
});
const $41b22e566e31d3e5$var$buttonWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} 0px`
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $41b22e566e31d3e5$var$LinkAddToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    getValidationErrors(value, inputMethod) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // dont show validation errors if input method is typeahed, which means user selects from search list
        if (inputMethod === (0, $d925B.INPUT_METHOD).TYPEAHEAD) return [];
        if (!value) return [
            formatMessage((0, $ckqYV.linkToolbarMessages).emptyLink)
        ];
        // if url can be normalized - we consider it is a valid url
        // also don't show validaition errors for empty values
        if ((0, $b0F8r.normalizeUrl)(value)) return [];
        else return [
            formatMessage((0, $ckqYV.linkToolbarMessages).invalidLink)
        ];
    }
    render() {
        const { providerFactory: providerFactory, displayUrl: displayUrl } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1145c7d3213c9839$export$2e2bcd8739ae039), {
            defaultUrl: (0, $b0F8r.normalizeUrl)(displayUrl),
            providerFactory: providerFactory,
            onSubmit: this.handleSubmit,
            onBlur: this.handleOnBlur,
            render: this.renderContainer
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationErrors: []
        };
        this.handleSubmit = ({ url: url, inputMethod: inputMethod })=>{
            this.props.onSubmit(url, {
                inputMethod: inputMethod
            });
        };
        this.handleOnBack = ({ url: url, inputMethod: inputMethod }, setFocus)=>{
            const { onBack: onBack } = this.props;
            if (onBack) onBack(url, {
                inputMethod: inputMethod
            }, setFocus);
        };
        this.handleCancel = ()=>{
            const { onCancel: onCancel } = this.props;
            if (onCancel) onCancel();
        };
        this.handleUnlink = (setFocus)=>{
            const { onUnlink: onUnlink } = this.props;
            if (onUnlink) onUnlink(setFocus);
        };
        this.handleOnBlur = (options)=>{
            this.props.onBlur(options.url);
        };
        this.renderContainer = ({ activityProvider: activityProvider, inputProps: { onChange: onChange, onKeyDown: onKeyDown, onSubmit: onSubmit, value: value }, currentInputMethod: currentInputMethod, renderRecentList: renderRecentList })=>{
            const { intl: { formatMessage: formatMessage }, displayUrl: displayUrl } = this.props;
            const getPlaceholder = (hasActivityProvider)=>formatMessage(hasActivityProvider ? (0, $ckqYV.linkToolbarMessages).placeholder : (0, $ckqYV.linkToolbarMessages).linkPlaceholder);
            const formatLinkAddressText = formatMessage((0, $4ab4865cf1226f73$export$8fc7ee45d6c4fad2).backLink);
            const formatUnlinkText = formatMessage((0, $ckqYV.linkToolbarMessages).unlink);
            const errorsList = this.state.validationErrors.map(function(error, index) {
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $b07b1741f2735aa4$export$915e9e7bd4f0f96d), {
                    key: index
                }, error);
            });
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                className: "recent-list"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: [
                    (0, $3a8Ut.container),
                    !!activityProvider && (0, $3a8Ut.containerWithProvider)
                ]
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $3a8Ut.inputWrapper)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: $41b22e566e31d3e5$var$buttonWrapper
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                title: formatLinkAddressText,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                    label: formatLinkAddressText,
                    size: "small"
                }),
                onClick: ()=>this.handleOnBack({
                        url: value,
                        inputMethod: currentInputMethod
                    }),
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleOnBack({
                            url: value,
                            inputMethod: currentInputMethod
                        }, true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            })), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8i5w2.default), {
                inputId: "media-link-search-input",
                testId: "media-link-input",
                placeholder: getPlaceholder(!!activityProvider),
                autoFocus: true,
                onCancel: this.handleCancel,
                defaultValue: value,
                onSubmit: (inputValue)=>{
                    const validationErrors = this.getValidationErrors(inputValue, currentInputMethod);
                    this.setState({
                        validationErrors: validationErrors
                    });
                    if (!validationErrors.length) onSubmit();
                },
                onChange: (value)=>{
                    this.setState({
                        validationErrors: []
                    });
                    onChange(value);
                },
                onKeyDown: onKeyDown
            }), /*#__PURE__*/ (0, $9K4OG.jsx)("label", {
                className: "assistive",
                htmlFor: "media-link-search-input"
            }, formatMessage((0, $ckqYV.linkToolbarMessages).searchInput)), (0, $b0F8r.normalizeUrl)(displayUrl) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                title: formatUnlinkText,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))), {
                    label: formatUnlinkText
                }),
                onClick: ()=>this.handleUnlink(),
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleUnlink(true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }))), !!errorsList.length && /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
                css: $41b22e566e31d3e5$var$validationWrapper
            }, errorsList), renderRecentList())));
        };
    }
}
var $41b22e566e31d3e5$export$2e2bcd8739ae039 = $41b22e566e31d3e5$var$LinkAddToolbar;


const $0be125e59081f49d$var$FORCE_FOCUS_SELECTOR = '[data-testid="add-link-button"],[data-testid="edit-link-button"]';
const $0be125e59081f49d$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS = '[data-testid="media-overflow-dropdown-trigger"]';
function $0be125e59081f49d$export$383c20208186148e(editorState) {
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(editorState);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return false;
    const { nodes: { media: media, mediaInline: mediaInline }, marks: { link: link } } = editorState.schema;
    const node = editorState.doc.nodeAt(mediaLinkingState.mediaPos);
    if (!node || ![
        media,
        mediaInline
    ].includes(node.type)) return false;
    const { parent: parent } = editorState.doc.resolve(mediaLinkingState.mediaPos);
    return parent && parent.type.allowsMarkType(link);
}
const $0be125e59081f49d$export$894ccf55bf35e0cb = (toolbarBaseConfig, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory)=>{
    const { link: link, visible: visible, editable: editing, mediaPos: mediaPos } = mediaLinkingState;
    if (visible && mediaPos !== null) {
        const node = state.doc.nodeAt(mediaPos);
        if (node) return {
            ...toolbarBaseConfig,
            height: (0, $9fPrY.RECENT_SEARCH_HEIGHT_IN_PX),
            width: (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX),
            forcePlacement: true,
            items: [
                {
                    type: 'custom',
                    fallback: [],
                    disableArrowNavigation: true,
                    render: (view, idx)=>{
                        if (!view || !providerFactory) return null;
                        const setFocusOnFloatingToolbar = (setFocus)=>{
                            if (setFocus && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
                                const { state: { tr: tr }, dispatch: dispatch } = view;
                                pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector($0be125e59081f49d$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS)(tr);
                                dispatch(tr);
                            }
                        };
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $41b22e566e31d3e5$export$2e2bcd8739ae039), {
                            displayUrl: link,
                            providerFactory: providerFactory,
                            intl: intl,
                            editing: editing,
                            onUnlink: (setFocus)=>{
                                (0, $1823b137770fdb05$export$5e0808041271ce04)(pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            onBack: (href, meta, setFocus)=>{
                                if (href.trim() && meta.inputMethod) (0, $1823b137770fdb05$export$b195a1839eae3673)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $1823b137770fdb05$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            onCancel: ()=>{
                                (0, $1823b137770fdb05$export$3b74d2c3073f13a9)(view.state, view.dispatch, view, true);
                                /** Focus should move to the 'Add link' button when the toolbar closes
               * and not close the floating toolbar.
               */ const { state: { tr: tr }, dispatch: dispatch } = view;
                                const selector = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar)) ? $0be125e59081f49d$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS : $0be125e59081f49d$var$FORCE_FOCUS_SELECTOR;
                                pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector(selector)(tr);
                                dispatch(tr);
                            },
                            onSubmit: (href, meta)=>{
                                (0, $1823b137770fdb05$export$b195a1839eae3673)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $1823b137770fdb05$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(true);
                            },
                            onBlur: ()=>{
                                (0, $1823b137770fdb05$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                            },
                            areAnyNewToolbarFlagsEnabled: (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
                        }, idx);
                    }
                }
            ]
        };
    }
};
const $0be125e59081f49d$var$mediaTypes = [
    'image',
    'video',
    'audio',
    'doc',
    'archive',
    'unknown'
];
const $0be125e59081f49d$var$getMediaType = (selectedNodeTypeSingle)=>{
    return $0be125e59081f49d$var$mediaTypes.find((type)=>selectedNodeTypeSingle?.includes(type));
};
const $0be125e59081f49d$export$ed96f06ad293a0a8 = (editorState, intl, mediaLinkingState, isInlineNode, allowLinking, isViewOnly)=>{
    if (isViewOnly || !allowLinking || !$0be125e59081f49d$export$383c20208186148e(editorState)) return [];
    let mediaType;
    const mediaNode = isInlineNode ? (0, $jA06n.currentMediaInlineNode)(editorState) : (0, $jA06n.currentMediaNode)(editorState);
    if (mediaNode) {
        const selectedNodeTypeSingle = mediaNode?.attrs.__fileMimeType;
        mediaType = $0be125e59081f49d$var$getMediaType(selectedNodeTypeSingle);
    }
    // Only show link dropdown option for images and external media (shown as images)
    if (mediaType !== 'image' && mediaNode?.attrs.type !== 'external') return [];
    if (mediaLinkingState && mediaLinkingState.editable) {
        const title = intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $1823b137770fdb05$export$e0eb18fceec368c4)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    label: ""
                })
            }
        ];
    } else {
        const title = intl.formatMessage((0, $ckqYV.linkToolbarMessages).addLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $1823b137770fdb05$export$e0eb18fceec368c4)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    label: ""
                })
            }
        ];
    }
};
const $0be125e59081f49d$export$23a4fa4e099d05b4 = (intl, mediaLinkingState, pluginInjectionApi)=>{
    const isValidUrl = (0, $81OAa.isSafeUrl)(mediaLinkingState.link);
    const linkTitle = intl.formatMessage(isValidUrl ? (0, $fpEzC.linkMessages).openLink : (0, $ckqYV.linkToolbarMessages).unableToOpenLink);
    return {
        id: 'editor.media.open-link',
        testId: 'open-link-toolbar-button',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        title: linkTitle,
        target: '_blank',
        href: isValidUrl ? mediaLinkingState.link : undefined,
        disabled: !isValidUrl,
        onClick: (state, dispatch, editorView)=>{
            if (editorView) {
                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    action: (0, $d925B.ACTION).VISITED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK
                })(tr);
                dispatch(tr);
            }
            return true;
        },
        supportsViewMode: true
    };
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


































function $944c3a04afe500ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $944c3a04afe500ea$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $944c3a04afe500ea$export$2a8c6fb42753b13e = ({ editorState: editorState, mediaLinkingState: mediaLinkingState, intl: intl, onAddLink: onAddLink, onEditLink: onEditLink, onOpenLink: onOpenLink, isInlineNode: isInlineNode, isViewOnly: isViewOnly, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [showLinkingControls, setShowLinkingControls] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        const mediaNode = isInlineNode ? (0, $jA06n.currentMediaInlineNode)(editorState) : (0, $jA06n.currentMediaNode)(editorState);
        if (!mediaNode) {
            setShowLinkingControls(false);
            return;
        }
        const mediaClientConfig = (0, $afaS6.stateKey).getState(editorState)?.mediaClientConfig;
        if (!mediaClientConfig) {
            setShowLinkingControls(false);
            return;
        }
        (0, $41126833ee1e2d2e$export$9573295345282b3b)(mediaNode, mediaClientConfig).then((mediaType)=>{
            setShowLinkingControls(mediaType === 'external' || mediaType === 'image');
        });
    }, [
        editorState,
        isInlineNode
    ]);
    if (!showLinkingControls) return null;
    if (mediaLinkingState && mediaLinkingState.editable) {
        const isValidUrl = (0, $81OAa.isSafeUrl)(mediaLinkingState.link);
        const title = intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink);
        const linkTitle = intl.formatMessage(isValidUrl ? (0, $fpEzC.linkMessages).openLink : (0, $ckqYV.linkToolbarMessages).unableToOpenLink);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, !isViewOnly && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $944c3a04afe500ea$var$wrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            onClick: onEditLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                description: title,
                keymap: (0, $hgeg8.addLink)
            }),
            testId: "edit-link-button",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            target: "_blank",
            href: isValidUrl ? mediaLinkingState.link : undefined,
            disabled: !isValidUrl,
            onClick: onOpenLink,
            title: linkTitle,
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                color: "currentColor",
                spacing: "spacious",
                label: linkTitle
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "hyperlink-open-link",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    } else {
        const title = intl.formatMessage((0, $ckqYV.linkToolbarMessages).addLink);
        return !isViewOnly ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            testId: "add-link-button",
            onClick: onAddLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                description: title,
                keymap: (0, $hgeg8.addLink)
            }),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                color: "currentColor",
                label: title,
                spacing: "spacious"
            }),
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        })) : null;
    }
};





parcelRequire("42omo");





























































const $5d551a3a8172c9e5$export$55564240c0c61582 = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options = {})=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const forceFocusSelector = pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector;
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.attrs.type;
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    if (mediaPluginState.allowInlineImages && (0, $9bkD0.isImage)(mediaType)) return $5d551a3a8172c9e5$var$getMediaInlineImageToolbar(state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options);
    const items = [];
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))) : (0, (/*@__PURE__*/$parcel$interopDefault($jNL69))),
        title: intl.formatMessage((0, $31QJ7.messages).preview),
        onClick: ()=>{
            return (0, $867c89c00d621557$export$19271a18f1ddc766)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    const disableDownloadButton = (0, $cAGd7.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aGns))),
        onClick: ()=>{
            (0, $cAGd7.downloadMedia)(mediaPluginState);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $31QJ7.messages).download),
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $3RxtY.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($65WMN))),
        selected: false,
        disabled: false,
        focusEditoronEnter: true,
        onClick: (0, $aR6HD.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $3RxtY.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onMouseEnter: hoverDecoration?.(mediaInline, true),
        onMouseLeave: hoverDecoration?.(mediaInline, false),
        onFocus: hoverDecoration?.(mediaInline, true),
        onBlur: hoverDecoration?.(mediaInline, false),
        title: intl.formatMessage((0, $61p3e.default).remove),
        onClick: (0, $aR6HD.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $3RxtY.messages).inlineTitle),
                onClick: ()=>true,
                selected: true,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $3RxtY.messages).blockTitle),
                onClick: (0, $aR6HD.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($65WMN))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $31QJ7.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, {
            type: 'separator',
            fullHeight: true
        }, download, {
            type: 'separator',
            supportsViewMode: true
        }, preview, {
            type: 'separator',
            fullHeight: true
        });
    }
    return items;
};
const $5d551a3a8172c9e5$var$getMediaInlineImageToolbar = (state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options = {})=>{
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaInlineImageTitle = intl.formatMessage((0, $gVDfZ.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $gVDfZ.toolbarMessages).changeToMediaSingle);
    const widthPluginState = pluginInjectionApi?.width?.sharedState.currentState();
    const inlineImageItems = [];
    const isEditorControlsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const { isViewOnly: isViewOnly, allowAltTextOnImages: allowAltTextOnImages, allowLinking: allowLinking, allowImagePreview: allowImagePreview } = options;
    if ((0, $91a37d1de1fe51de$export$5c7a39f9b065f644)(state)) {
        inlineImageItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $jA06n.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $28f444d0bba3edb5$export$2e2bcd8739ae039), {
                    toggleBorder: ()=>{
                        (0, $aR6HD.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    setBorder: (attrs)=>{
                        (0, $aR6HD.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!isEditorControlsEnabled) inlineImageItems.push({
            type: 'separator'
        });
    }
    const download = {
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aGns))),
        onClick: ()=>{
            (0, $cAGd7.downloadMedia)(mediaPluginState, options.isViewOnly);
            return true;
        },
        title: intl.formatMessage((0, $31QJ7.messages).download),
        supportsViewMode: true
    };
    // For Editor Controls: show options to convert from 'Inline' to 'Original size' via dropdown
    if (!isEditorControlsEnabled) inlineImageItems.push({
        id: 'editor.media.convert.mediainline',
        type: 'button',
        title: mediaInlineImageTitle,
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaInlineImageTitle
            }),
        onClick: ()=>{
            return true;
        },
        selected: true
    }, {
        id: 'editor.media.convert.mediasingle',
        type: 'button',
        title: mediaSingleTitle,
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJ7sW))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaSingleTitle
            }),
        onClick: (0, $aR6HD.changeMediaInlineToMediaSingle)(editorAnalyticsAPI, widthPluginState, options?.allowPixelResizing)
    }, {
        type: 'separator'
    }, {
        type: 'custom',
        fallback: [],
        render: (editorView, idx)=>{
            if (editorView?.state) {
                const editLink = ()=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $1823b137770fdb05$export$e0eb18fceec368c4)(state, dispatch);
                    }
                };
                const openLink = ()=>{
                    if (editorView) {
                        const { state: { tr: tr }, dispatch: dispatch } = editorView;
                        pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            action: (0, $d925B.ACTION).VISITED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK
                        })(tr);
                        dispatch(tr);
                        return true;
                    }
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $944c3a04afe500ea$export$2a8c6fb42753b13e), {
                    editorState: editorView.state,
                    intl: intl,
                    mediaLinkingState: mediaLinkingState,
                    onAddLink: editLink,
                    onEditLink: editLink,
                    onOpenLink: openLink,
                    isInlineNode: true,
                    isViewOnly: options.isViewOnly,
                    areAnyNewToolbarFlagsEnabled: (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
                }, idx);
            }
            return null;
        },
        supportsViewMode: true
    });
    else {
        const switchFromInlineToBlock = (0, $cAGd7.getMediaSingleAndMediaInlineSwitcherDropdown)('inline', intl, pluginInjectionApi);
        inlineImageItems.push(switchFromInlineToBlock, {
            type: 'separator',
            fullHeight: true
        });
        if (isViewOnly) inlineImageItems.push(download, {
            type: 'separator',
            supportsViewMode: true
        });
    }
    //Image Preview
    if (allowImagePreview) inlineImageItems.push({
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: isEditorControlsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))) : (0, (/*@__PURE__*/$parcel$interopDefault($jNL69))),
        title: intl.formatMessage((0, $31QJ7.messages).preview),
        onClick: ()=>{
            return (0, $867c89c00d621557$export$19271a18f1ddc766)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        supportsViewMode: true
    }, {
        type: 'separator',
        supportsViewMode: true
    });
    // open link
    if (allowLinking && (0, $0be125e59081f49d$export$383c20208186148e)(state) && mediaLinkingState && mediaLinkingState.editable && isEditorControlsEnabled) inlineImageItems.push((0, $0be125e59081f49d$export$23a4fa4e099d05b4)(intl, mediaLinkingState, pluginInjectionApi), {
        type: 'separator',
        supportsViewMode: true
    });
    if (isViewOnly && !isEditorControlsEnabled) inlineImageItems.push(download, {
        type: 'separator',
        supportsViewMode: true
    });
    if (allowAltTextOnImages && !isEditorControlsEnabled) inlineImageItems.push((0, $432518934a309d20$export$ee5eb653e9c77c53)(intl, state, pluginInjectionApi?.analytics?.actions), {
        type: 'separator'
    });
    if (isViewOnly || !isEditorControlsEnabled) inlineImageItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    });
    if (!isEditorControlsEnabled) {
        inlineImageItems.push({
            type: 'separator'
        });
        inlineImageItems.push({
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            onMouseEnter: hoverDecoration?.(mediaInline, true),
            onMouseLeave: hoverDecoration?.(mediaInline, false),
            onFocus: hoverDecoration?.(mediaInline, true),
            onBlur: hoverDecoration?.(mediaInline, false),
            title: intl.formatMessage((0, $61p3e.default).remove),
            onClick: (0, $aR6HD.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
            testId: 'media-toolbar-remove-button'
        });
    }
    return inlineImageItems;
};





parcelRequire("42omo");














const $36aed48b75091406$export$bee6402990837b71 = (toolbarBaseConfig, { pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>({
        ...toolbarBaseConfig,
        width: (0, $61e86bc6608390db$export$e879bf3f9286d0ca),
        scrollable: true,
        items: [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(editorView.state);
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a0d28fa5363c2665$export$4c9bbfa83ba6e1fa), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: isEditorFullWidthEnabled,
                        triggerButtonSelector: triggerButtonSelector
                    });
                }
            }
        ]
    });
const $36aed48b75091406$export$162f6210a4cda095 = (mediaOptions, state, formatMessage, selectedNodeType)=>{
    if (selectedNodeType?.name !== 'mediaSingle') return [];
    const { allowResizing: allowResizing, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = mediaOptions;
    const isWithinTable = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) return [
        {
            title: formatMessage((0, $84d25cbb5dfa06f5$export$41750bfa58c03af2).resizeOption),
            onClick: (0, $0871da91a4b46d6d$export$3f611b75d530f269)(),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJ7sW))), {
                label: ""
            }),
            testId: 'media-pixel-resizing-dropdown-option'
        }
    ];
    return [];
};





const $867c89c00d621557$var$mediaTypeMessages = {
    image: (0, $31QJ7.messages).file_image_is_selected,
    video: (0, $31QJ7.messages).file_video_is_selected,
    audio: (0, $31QJ7.messages).file_audio_is_selected,
    doc: (0, $31QJ7.messages).file_doc_is_selected,
    archive: (0, $31QJ7.messages).file_archive_is_selected,
    unknown: (0, $31QJ7.messages).file_unknown_is_selected
};
const $867c89c00d621557$var$getMediaActionSubject = (nodeType)=>{
    switch(nodeType.name){
        case 'mediaSingle':
            return (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE;
        case 'mediaInline':
            return (0, $d925B.ACTION_SUBJECT).MEDIA_INLINE;
        case 'mediaGroup':
            return (0, $d925B.ACTION_SUBJECT).MEDIA_GROUP;
        default:
            return (0, $d925B.ACTION_SUBJECT).MEDIA;
    }
};
const $867c89c00d621557$var$removeWithAnalytics = (editorAnalyticsApi, nodeType)=>{
    if (!nodeType) return $867c89c00d621557$var$remove;
    const mediaType = $867c89c00d621557$var$getMediaActionSubject(nodeType);
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: mediaType,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })($867c89c00d621557$var$remove);
};
const $867c89c00d621557$var$remove = (state, dispatch)=>{
    if (dispatch) dispatch((0, $8m4tT.removeSelectedNode)(state.tr));
    return true;
};
const $867c89c00d621557$var$handleRemoveMediaGroupWithAnalytics = (editorAnalyticsApi)=>{
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA_GROUP,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })($867c89c00d621557$var$handleRemoveMediaGroup);
};
const $867c89c00d621557$var$handleRemoveMediaGroup = (state, dispatch)=>{
    const tr = (0, $cAGd7.removeMediaGroupNode)(state);
    if (dispatch) dispatch(tr);
    return true;
};
const $867c89c00d621557$export$19271a18f1ddc766 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    const selectedNodeAttrs = (0, $cAGd7.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api?.core.actions.execute(api?.media.commands.showMediaViewer(selectedNodeAttrs));
};
const $867c89c00d621557$export$909b58dbf0af33b8 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    const selectedNodeAttrs = (0, $cAGd7.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api?.core.actions.execute(api?.mediaEditing?.commands.showImageEditor(selectedNodeAttrs));
};
const $867c89c00d621557$var$generateMediaCardFloatingToolbar = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, editorAnalyticsAPI, forceFocusSelector, isViewOnly)=>{
    const disableDownloadButton = (0, $cAGd7.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))) : (0, (/*@__PURE__*/$parcel$interopDefault($jNL69))),
        title: intl.formatMessage((0, $31QJ7.messages).preview),
        onClick: ()=>{
            return $867c89c00d621557$export$19271a18f1ddc766({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        disabled: (0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
        supportsViewMode: true
    };
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aGns))),
        onClick: ()=>{
            (0, $cAGd7.downloadMedia)(mediaPluginState);
            return true;
        },
        title: intl.formatMessage((0, $31QJ7.messages).download),
        disabled: disableDownloadButton,
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (isViewOnly && !areAnyNewToolbarFlagsEnabled) return [];
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const items = [];
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))),
        selected: false,
        focusEditoronEnter: true,
        disabled: false,
        onClick: (0, $aR6HD.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $3RxtY.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($65WMN))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $3RxtY.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaGroup
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onMouseEnter: hoverDecoration?.(mediaGroup, true),
        onMouseLeave: hoverDecoration?.(mediaGroup, false),
        onFocus: hoverDecoration?.(mediaGroup, true),
        onBlur: hoverDecoration?.(mediaGroup, false),
        title: intl.formatMessage((0, $61p3e.default).remove),
        onClick: $867c89c00d621557$var$handleRemoveMediaGroupWithAnalytics(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $3RxtY.messages).inlineTitle),
                onClick: (0, $aR6HD.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $3RxtY.messages).blockTitle),
                selected: true,
                onClick: ()=>true,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($65WMN))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $31QJ7.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($65WMN))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, {
            type: 'separator',
            fullHeight: true
        }, download, {
            type: 'separator',
            supportsViewMode: true
        }, preview, {
            type: 'separator',
            fullHeight: true
        });
    }
    return items;
};
const $867c89c00d621557$var$generateMediaSingleFloatingToolbar = (state, intl, options, pluginState, mediaLinkingState, pluginInjectionApi)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { allowResizing: allowResizing, allowLinking: allowLinking, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowCommentsOnMedia: allowCommentsOnMedia, allowResizingInTables: allowResizingInTables, allowAltTextOnImages: allowAltTextOnImages, allowMediaInline: allowMediaInline, allowMediaInlineImages: allowMediaInlineImages, allowImageEditing: allowImageEditing, allowImagePreview: allowImagePreview, isViewOnly: isViewOnly, allowPixelResizing: allowPixelResizing, onCommentButtonMount: onCommentButtonMount } = options;
    let toolbarButtons = [];
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const disableDownloadButton = (0, $cAGd7.getIsDownloadDisabledByDataSecurityPolicy)(pluginState);
    if ((0, $91a37d1de1fe51de$export$5c7a39f9b065f644)(state)) {
        toolbarButtons.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $jA06n.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $28f444d0bba3edb5$export$2e2bcd8739ae039), {
                    toggleBorder: ()=>{
                        (0, $aR6HD.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    setBorder: (attrs)=>{
                        (0, $aR6HD.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
            type: 'separator'
        });
    }
    if (allowAdvancedToolBarOptions) {
        const widthPlugin = pluginInjectionApi?.width;
        let isChangingLayoutDisabled = false;
        const selectedNode = (0, $cAGd7.getSelectedMediaSingle)(state);
        if (allowPixelResizing) {
            const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength;
            const selectedNodeMaxWidth = pluginState.currentMaxWidth || contentWidth;
            if (selectedNode && selectedNodeMaxWidth && selectedNode.node.attrs.width >= selectedNodeMaxWidth) isChangingLayoutDisabled = true;
        }
        const layoutButtons = (0, $6xEOh.default)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi?.analytics?.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
        const addLayoutDropdownToToolbar = ()=>{
            if (areAnyNewToolbarFlagsEnabled) {
                const layoutDropdown = (0, $6xEOh.buildLayoutDropdown)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi?.analytics?.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
                toolbarButtons = [
                    ...toolbarButtons,
                    ...layoutDropdown
                ];
            } else {
                const selectedLayoutIcon = (0, $cAGd7.getSelectedLayoutIcon)([
                    ...(0, $6xEOh.alignmentIcons),
                    ...(0, $6xEOh.wrappingIcons)
                ], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectedNode.node);
                if (selectedLayoutIcon && layoutButtons.length) {
                    const options = {
                        render: (props)=>{
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $1187043848f38019$export$7fe0cbe305f29bb4), {
                                layoutButtons: layoutButtons,
                                ...props,
                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                            });
                        },
                        width: 188,
                        height: 32
                    };
                    const trigger = {
                        id: 'media-single-layout',
                        testId: 'media-single-layout-dropdown-trigger',
                        type: 'dropdown',
                        options: options,
                        title: intl.formatMessage((0, $6xEOh.layoutToMessages)[selectedLayoutIcon.value]),
                        icon: selectedLayoutIcon.icon
                    };
                    toolbarButtons = [
                        ...toolbarButtons,
                        trigger,
                        ...areAnyNewToolbarFlagsEnabled ? [] : [
                            {
                                type: 'separator'
                            }
                        ]
                    ];
                }
            }
        };
        if ((0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag')) {
            if (allowMediaInlineImages && selectedNode) addLayoutDropdownToToolbar();
            else {
                toolbarButtons = [
                    ...toolbarButtons,
                    ...layoutButtons
                ];
                if (layoutButtons.length) toolbarButtons.push({
                    type: 'separator'
                });
            }
        } else if ((0, $2YJKQ.mediaInlineImagesEnabled)(allowMediaInline, allowMediaInlineImages) && selectedNode) addLayoutDropdownToToolbar();
        else {
            toolbarButtons = [
                ...toolbarButtons,
                ...layoutButtons
            ];
            if (layoutButtons.length && !areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
                type: 'separator'
            });
        }
        // floating and inline switcher
        if (pluginState.allowInlineImages && selectedNode && (0, $cAGd7.canShowSwitchButtons)(selectedNode.node)) // mediaInlne doesn't suppprt external images, so hiding buttons to prevent conversion from mediaSingle to mediaInline
        {
            if (selectedNode.node.firstChild?.attrs.type !== 'external') {
                const hasCaption = (0, $8m4tT.contains)(selectedNode.node, state.schema.nodes.caption);
                const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $gVDfZ.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $gVDfZ.toolbarMessages).changeToMediaInlineImage);
                const floatingSwitcherTitle = intl.formatMessage((0, $gVDfZ.toolbarMessages).changeToMediaSingle);
                if (!areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
                    type: 'button',
                    id: 'editor.media.image.view.switcher.inline',
                    title: inlineSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: inlineSwitcherTitle
                        }),
                    onClick: (0, $aR6HD.changeMediaSingleToMediaInline)(pluginInjectionApi?.analytics?.actions),
                    testId: 'image-inline-appearance',
                    selected: (0, $1oCLl.expValEquals)('platform_editor_add_aria_checked_to_inline_img_btn', 'isEnabled', true) ? false : undefined
                }, {
                    type: 'button',
                    id: 'editor.media.image.view.switcher.floating',
                    title: floatingSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJ7sW))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: floatingSwitcherTitle
                        }),
                    onClick: ()=>{
                        return true;
                    },
                    testId: 'image-floating-appearance',
                    selected: true
                }, {
                    type: 'separator'
                });
                else {
                    const switchFromBlockToInline = (0, $cAGd7.getMediaSingleAndMediaInlineSwitcherDropdown)('block', intl, pluginInjectionApi, hasCaption);
                    toolbarButtons.push(switchFromBlockToInline, {
                        type: 'separator',
                        fullHeight: true
                    });
                }
            }
        }
        // A separator is needed regardless switcher is enabled or not
        if (Boolean(pluginInjectionApi?.toolbar)) toolbarButtons.push({
            type: 'separator',
            fullHeight: true
        });
        // Pixel Entry Toolbar Support
        const { selection: selection } = state;
        const isWithinTable = (0, $8m4tT.hasParentNodeOfType)([
            state.schema.nodes.table
        ])(selection);
        if (allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) {
            const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
            const sizeInput = {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a0d28fa5363c2665$export$4c9bbfa83ba6e1fa), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: options.fullWidthEnabled
                    });
                }
            };
            if (pluginState.isResizing) {
                // If the image is resizing
                // then return pixel entry component or full width label as the only toolbar item
                if (!selectedMediaSingleNode) return [];
                const { layout: layout } = selectedMediaSingleNode.node.attrs;
                if (layout === 'full-width') {
                    const fullWidthLabel = {
                        type: 'custom',
                        fallback: [],
                        render: ()=>{
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $a0d28fa5363c2665$export$8bde7db5b2aba7d), {
                                intl: intl
                            });
                        }
                    };
                    return [
                        fullWidthLabel
                    ];
                }
                return [
                    sizeInput
                ];
            }
            if (!areAnyNewToolbarFlagsEnabled) {
                toolbarButtons.push(sizeInput);
                toolbarButtons.push({
                    type: 'separator'
                });
            }
        }
        if (!areAnyNewToolbarFlagsEnabled) {
            if (allowCommentsOnMedia) toolbarButtons.push((0, $ab151bf461431233$export$c936f67f30fa5fde)(intl, state, pluginInjectionApi, onCommentButtonMount), {
                type: 'separator',
                supportsViewMode: true
            });
            if (allowLinking && (0, $0be125e59081f49d$export$383c20208186148e)(state)) toolbarButtons.push({
                type: 'custom',
                fallback: [],
                render: (editorView, idx)=>{
                    if (editorView?.state) {
                        const editLink = ()=>{
                            if (editorView) {
                                const { state: state, dispatch: dispatch } = editorView;
                                (0, $1823b137770fdb05$export$e0eb18fceec368c4)(state, dispatch);
                            }
                        };
                        const openLink = ()=>{
                            if (editorView) {
                                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                                pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                                    action: (0, $d925B.ACTION).VISITED,
                                    actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK
                                })(tr);
                                dispatch(tr);
                                return true;
                            }
                        };
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $944c3a04afe500ea$export$2a8c6fb42753b13e), {
                            editorState: editorView.state,
                            intl: intl,
                            mediaLinkingState: mediaLinkingState,
                            onAddLink: editLink,
                            onEditLink: editLink,
                            onOpenLink: openLink,
                            isViewOnly: isViewOnly,
                            areAnyNewToolbarFlagsEnabled: false
                        }, idx);
                    }
                    return null;
                },
                supportsViewMode: true
            });
            // Image Editing Support
            if (!!pluginInjectionApi?.mediaEditing && allowImageEditing && (0, $1oCLl.expValEquals)('platform_editor_add_image_editing', 'isEnabled', true)) {
                const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
                // Disable image editing for external media, as we cannot save changes to external images per CORS policy
                const isExternal = mediaNode?.attrs?.type === 'external';
                // Disable image editing for gifs as CropperJS does not support gif editing
                const isGif = mediaNode?.attrs?.__fileMimeType === 'image/gif';
                if (!(0, $7dSFG.isVideo)(mediaNode?.attrs?.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                    id: 'editor.media.edit',
                    testId: 'image-edit-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqI1A))),
                    title: intl.formatMessage((0, $61p3e.default).imageEdit),
                    onClick: ()=>{
                        return $867c89c00d621557$export$909b58dbf0af33b8({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    // Making the button more accessible
                    supportsViewMode: false,
                    isRadioButton: true,
                    selected: false
                });
            }
            // Preview Support
            if (allowImagePreview) {
                const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
                if (!(0, $7dSFG.isVideo)(mediaNode?.attrs?.__fileMimeType)) toolbarButtons.push({
                    id: 'editor.media.viewer',
                    testId: 'file-preview-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jNL69))),
                    title: intl.formatMessage((0, $31QJ7.messages).preview),
                    onClick: ()=>{
                        return $867c89c00d621557$export$19271a18f1ddc766({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    disabled: (0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
                    supportsViewMode: true
                }, {
                    type: 'separator',
                    supportsViewMode: true
                });
            }
        }
    }
    if (isViewOnly) toolbarButtons.push({
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aGns))),
        onClick: ()=>{
            (0, $cAGd7.downloadMedia)(pluginState, isViewOnly);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $31QJ7.messages).download),
        supportsViewMode: true
    }, {
        type: 'separator',
        supportsViewMode: true
    });
    if (!areAnyNewToolbarFlagsEnabled) {
        if (allowAltTextOnImages) toolbarButtons.push((0, $432518934a309d20$export$ee5eb653e9c77c53)(intl, state, pluginInjectionApi?.analytics?.actions), {
            type: 'separator'
        });
        const removeButton = {
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            onMouseEnter: hoverDecoration?.(mediaSingle, true),
            onMouseLeave: hoverDecoration?.(mediaSingle, false),
            onFocus: hoverDecoration?.(mediaSingle, true),
            onBlur: hoverDecoration?.(mediaSingle, false),
            title: intl.formatMessage((0, $61p3e.default).remove),
            onClick: $867c89c00d621557$var$removeWithAnalytics(pluginInjectionApi?.analytics?.actions),
            testId: 'media-toolbar-remove-button',
            supportsViewMode: false
        };
        const items = [
            ...toolbarButtons,
            {
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: intl.formatMessage,
                        nodeType: mediaSingle
                    }
                ],
                supportsViewMode: true
            }
        ];
        items.push({
            type: 'separator',
            supportsViewMode: false
        });
        items.push(removeButton);
        return items;
    } else {
        // Preview Support
        if (allowAdvancedToolBarOptions && allowImagePreview) {
            const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
            if (!(0, $7dSFG.isVideo)(mediaNode?.attrs?.__fileMimeType)) toolbarButtons.push({
                id: 'editor.media.viewer',
                testId: 'file-preview-toolbar-button',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
                title: intl.formatMessage((0, $31QJ7.messages).preview),
                onClick: ()=>{
                    return $867c89c00d621557$export$19271a18f1ddc766({
                        api: pluginInjectionApi,
                        mediaPluginState: pluginState
                    }) ?? false;
                },
                disabled: (0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
                supportsViewMode: true
            }, {
                type: 'separator',
                supportsViewMode: true
            });
        }
        if (allowAdvancedToolBarOptions && allowImageEditing && (0, $1oCLl.expValEquals)('platform_editor_add_image_editing', 'isEnabled', true)) {
            const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
            // Disable image editing for external media, as we cannot save changes to external images per CORS policy
            const isExternal = mediaNode?.attrs?.type === 'external';
            // Disable image editing for gifs as CropperJS does not support gif editing
            const isGif = mediaNode?.attrs?.__fileMimeType === 'image/gif';
            if (!(0, $7dSFG.isVideo)(mediaNode?.attrs?.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                id: 'editor.media.edit',
                testId: 'image-edit-toolbar-button',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqI1A))),
                title: intl.formatMessage((0, $61p3e.default).imageEdit),
                onClick: ()=>{
                    return $867c89c00d621557$export$909b58dbf0af33b8({
                        api: pluginInjectionApi,
                        mediaPluginState: pluginState
                    }) ?? false;
                },
                supportsViewMode: false
            }, {
                type: 'separator',
                supportsViewMode: false
            });
        }
        // open link
        if (allowLinking && (0, $0be125e59081f49d$export$383c20208186148e)(state) && mediaLinkingState && mediaLinkingState.editable) toolbarButtons.push((0, $0be125e59081f49d$export$23a4fa4e099d05b4)(intl, mediaLinkingState, pluginInjectionApi), {
            type: 'separator',
            supportsViewMode: true
        });
        isViewOnly && toolbarButtons.push({
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaSingle
                }
            ],
            supportsViewMode: true
        }, {
            type: 'separator',
            supportsViewMode: true
        });
        if (allowAdvancedToolBarOptions && allowCommentsOnMedia) {
            (0, $cAGd7.updateToFullHeightSeparator)(toolbarButtons);
            toolbarButtons.push((0, $ab151bf461431233$export$c936f67f30fa5fde)(intl, state, pluginInjectionApi, onCommentButtonMount));
        }
        return toolbarButtons;
    }
};
const $867c89c00d621557$var$getMediaTypeMessage = (selectedNodeTypeSingle)=>{
    const mediaType = Object.keys($867c89c00d621557$var$mediaTypeMessages).find((key)=>selectedNodeTypeSingle?.includes(key));
    return mediaType ? $867c89c00d621557$var$mediaTypeMessages[mediaType] : (0, $31QJ7.messages).file_unknown_is_selected;
};
const $867c89c00d621557$export$893b800ba7bfda6d = 'media-overflow-dropdown-trigger';
const $867c89c00d621557$var$isMediaSelection = (selection, nodeType)=>{
    if (selection instanceof (0, $ks2lK.NodeSelection)) return nodeType.includes(selection.node.type);
    return false;
};
const $867c89c00d621557$export$4850df084251d287 = (state, intl, options = {}, pluginInjectionApi)=>{
    const { media: media, mediaInline: mediaInline, mediaSingle: mediaSingle, mediaGroup: mediaGroup } = state.schema.nodes;
    const { altTextValidator: altTextValidator, allowLinking: allowLinking, allowAltTextOnImages: allowAltTextOnImages, providerFactory: providerFactory, allowMediaInlineImages: allowMediaInlineImages, allowResizing: allowResizing, isViewOnly: isViewOnly, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = options;
    let { allowMediaInline: allowMediaInline } = options;
    allowMediaInline = (0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : allowMediaInline;
    const mediaPluginState = (0, $afaS6.stateKey).getState(state);
    const mediaLinkingState = (0, $11220e9e93c1fc6e$export$a27ff1704d423d4e)(state);
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    if (!mediaPluginState) return;
    const nodeType = allowMediaInline ? [
        mediaInline,
        mediaSingle,
        media
    ] : [
        mediaSingle
    ];
    const isSelectedNodeMediaSingle = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === mediaSingle;
    if (!$867c89c00d621557$var$isMediaSelection(state.selection, nodeType)) return;
    const baseToolbar = {
        title: 'Media floating controls',
        nodeType: nodeType,
        getDomRef: ()=>{
            const element = isSelectedNodeMediaSingle ? mediaPluginState.element?.querySelector(`.${(0, $6ZrgC.MediaSingleNodeSelector)}`) || mediaPluginState.element : mediaPluginState.element;
            return element;
        }
    };
    if (allowLinking && mediaLinkingState && mediaLinkingState.visible && (0, $0be125e59081f49d$export$383c20208186148e)(state)) {
        const linkingToolbar = (0, $0be125e59081f49d$export$894ccf55bf35e0cb)(baseToolbar, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory);
        if (linkingToolbar) return linkingToolbar;
    }
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const overflowButtonSelector = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar)) ? `[data-testid="${$867c89c00d621557$export$893b800ba7bfda6d}"]` : undefined;
    if (allowAltTextOnImages) {
        const mediaAltTextPluginState = (0, $e285d524337ca108$export$f05434c51e3762e)(state);
        if (mediaAltTextPluginState.isAltTextEditorOpen) return (0, $432518934a309d20$export$626712166441e24f)(baseToolbar, {
            altTextValidator: altTextValidator,
            forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
            triggerButtonSelector: overflowButtonSelector,
            areAnyNewToolbarFlagsEnabled: (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
        });
    }
    const { selection: selection } = state;
    const isWithinTable = (0, $8m4tT.hasParentNodeOfType)([
        state.schema.nodes.table
    ])(selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        const mediaPixelResizingPluginState = (0, $b2cea85c133cd38a$export$f05434c51e3762e)(state);
        if (mediaPixelResizingPluginState?.isPixelEditorOpen) return (0, $36aed48b75091406$export$bee6402990837b71)(baseToolbar, {
            intl: intl,
            pluginInjectionApi: pluginInjectionApi,
            pluginState: mediaPluginState,
            hoverDecoration: hoverDecoration,
            isEditorFullWidthEnabled: options.fullWidthEnabled,
            triggerButtonSelector: overflowButtonSelector
        });
    }
    let items = [];
    const parentMediaGroupNode = (0, $8m4tT.findParentNodeOfType)(mediaGroup)(state.selection);
    let selectedNodeType;
    if (state.selection instanceof (0, $ks2lK.NodeSelection)) selectedNodeType = state.selection.node.type;
    if (allowMediaInline && parentMediaGroupNode?.node.type === mediaGroup) {
        const mediaOffset = state.selection.$from.parentOffset + 1;
        baseToolbar.getDomRef = ()=>{
            const selector = (0, $c3f4eab8cbe88239$export$ddc30058b32b7b60)(mediaOffset);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            return mediaPluginState.element?.querySelector(selector);
        };
        items = $867c89c00d621557$var$generateMediaCardFloatingToolbar(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector, isViewOnly);
    } else if (allowMediaInline && selectedNodeType && selectedNodeType === mediaInline) items = (0, $5d551a3a8172c9e5$export$55564240c0c61582)(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options);
    else {
        baseToolbar.getDomRef = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const element = mediaPluginState.element?.querySelector(`.${(0, $6ZrgC.MediaSingleNodeSelector)}`);
            return element || mediaPluginState.element;
        };
        items = $867c89c00d621557$var$generateMediaSingleFloatingToolbar(state, intl, options, mediaPluginState, mediaLinkingState, pluginInjectionApi);
    }
    if (!mediaPluginState.isResizing && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        (0, $cAGd7.updateToFullHeightSeparator)(items);
        const customOptions = [
            ...(0, $0be125e59081f49d$export$ed96f06ad293a0a8)(state, intl, mediaLinkingState, allowMediaInline && selectedNodeType && selectedNodeType === mediaInline, allowLinking, isViewOnly),
            ...(0, $432518934a309d20$export$cf32f28463a52655)(state, intl.formatMessage, allowAltTextOnImages, selectedNodeType, pluginInjectionApi?.analytics?.actions),
            ...(0, $36aed48b75091406$export$162f6210a4cda095)(options, state, intl.formatMessage, selectedNodeType)
        ];
        if (customOptions.length) customOptions.push({
            type: 'separator'
        });
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        items.push({
            type: 'overflow-dropdown',
            id: 'media',
            testId: $867c89c00d621557$export$893b800ba7bfda6d,
            options: [
                ...customOptions,
                {
                    title: intl?.formatMessage((0, $61p3e.default).copyToClipboard),
                    onClick: ()=>{
                        pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                        pluginInjectionApi?.floatingToolbar?.commands.copyNode(nodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
                },
                {
                    title: intl?.formatMessage((0, $61p3e.default).delete),
                    onClick: parentMediaGroupNode?.node.type === mediaGroup ? $867c89c00d621557$var$handleRemoveMediaGroupWithAnalytics(pluginInjectionApi?.analytics?.actions) : $867c89c00d621557$var$removeWithAnalytics(pluginInjectionApi?.analytics?.actions, selectedNodeType),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    var assistiveMessage = '';
    const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
    if (selectedMediaSingleNode) {
        const selectedMediaNodeView = selectedMediaSingleNode?.node.content;
        if (selectedMediaNodeView) {
            const selectedMediaNode = selectedMediaNodeView.firstChild;
            const selectedNodeTypeSingle = selectedMediaNode?.attrs.__fileMimeType;
            const selectedMediaAlt = selectedMediaNode?.attrs.alt;
            assistiveMessage = intl?.formatMessage($867c89c00d621557$var$getMediaTypeMessage(selectedNodeTypeSingle), {
                name: selectedMediaAlt
            });
        }
    }
    const toolbarConfig = {
        ...baseToolbar,
        items: items,
        scrollable: true,
        mediaAssistiveMessage: assistiveMessage
    };
    if (allowResizing && allowPixelResizing) return {
        ...toolbarConfig,
        width: mediaPluginState.isResizing ? undefined : (0, $cAGd7.getMaxToolbarWidth)()
    };
    return toolbarConfig;
};





parcelRequire("42omo");










const $9b13221547acf60a$export$1e0626fa34762ce3 = (0, $cgtv4.defineMessages)({
    toolbarMediaTitle: {
        id: "fabric.editor.toolbarMediaTitle",
        defaultMessage: "Add image, video, or file"
    }
});



var $8TW6I = parcelRequire("8TW6I");




var $9lz2c = parcelRequire("9lz2c");

const $44e98bca39fd3cdb$var$onClickMediaButton = (showMediaPicker)=>()=>{
        showMediaPicker();
        return true;
    };
const $44e98bca39fd3cdb$var$selector = (states)=>{
    return {
        allowsUploads: states.mediaState?.allowsUploads,
        showMediaPicker: states.mediaState?.showMediaPicker
    };
};
const $44e98bca39fd3cdb$var$ToolbarMedia = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: intl, api: api })=>{
    const { allowsUploads: allowsUploads, showMediaPicker: showMediaPicker } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $44e98bca39fd3cdb$var$selector);
    if (!allowsUploads || !showMediaPicker) return null;
    const { toolbarMediaTitle: toolbarMediaTitle } = (0, $9b13221547acf60a$export$1e0626fa34762ce3);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).MEDIA,
        onClick: $44e98bca39fd3cdb$var$onClickMediaButton(showMediaPicker),
        disabled: isDisabled,
        title: intl.formatMessage(toolbarMediaTitle),
        spacing: isReducedSpacing ? 'none' : 'default',
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
            label: intl.formatMessage(toolbarMediaTitle)
        })
    });
};
var $44e98bca39fd3cdb$export$2e2bcd8739ae039 = (0, $gmMgo.default)($44e98bca39fd3cdb$var$ToolbarMedia);


const $c95e16e0e9a520c7$var$selector = (states)=>{
    return {
        onPopupToggle: states.mediaState?.onPopupToggle,
        setBrowseFn: states.mediaState?.setBrowseFn
    };
};
const $c95e16e0e9a520c7$var$MediaPickerFunctionalComponent = ({ api: api, editorDomElement: editorDomElement, appearance: appearance })=>{
    const { onPopupToggle: onPopupToggle, setBrowseFn: setBrowseFn } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $c95e16e0e9a520c7$var$selector);
    if (!onPopupToggle || !setBrowseFn) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $060092fbe00ceba4$export$b8a89db960d45391), {
        onPopupToggle: onPopupToggle,
        setBrowseFn: setBrowseFn,
        editorDomElement: editorDomElement,
        appearance: appearance,
        api: api
    });
};
const $c95e16e0e9a520c7$var$mediaViewerStateSelector = (states)=>{
    return {
        isMediaViewerVisible: states.mediaState?.isMediaViewerVisible,
        mediaViewerSelectedMedia: states.mediaState?.mediaViewerSelectedMedia,
        mediaClientConfig: states.mediaState?.mediaClientConfig
    };
};
const $c95e16e0e9a520c7$var$MediaViewerFunctionalComponent = ({ api: api, editorView: editorView })=>{
    // Only traverse document once when media viewer is visible, media viewer items will not update
    // when document changes are made while media viewer is open
    const { isMediaViewerVisible: isMediaViewerVisible, mediaViewerSelectedMedia: mediaViewerSelectedMedia, mediaClientConfig: mediaClientConfig } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $c95e16e0e9a520c7$var$mediaViewerStateSelector);
    const mediaItems = (0, $42omo.useMemo)(()=>{
        if (isMediaViewerVisible) {
            const mediaNodes = (0, $kjHnW.extractMediaNodes)(editorView.state.doc);
            return (0, $kjHnW.createMediaIdentifierArray)(mediaNodes);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only update mediaItems once when media viewer is visible
    }, [
        isMediaViewerVisible
    ]);
    // Viewer does not have required attributes to render the media viewer
    if (!isMediaViewerVisible || !mediaViewerSelectedMedia || !mediaClientConfig) return null;
    const handleOnClose = ()=>{
        // Run Command to hide the media viewer
        api?.core.actions.execute(api?.media.commands.hideMediaViewer);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c6AnB.RenderMediaViewer), {
        mediaClientConfig: mediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: mediaViewerSelectedMedia,
        items: mediaItems
    });
};
const $c95e16e0e9a520c7$export$a4dd0667e1feabbd = ({ config: options = {}, api: api })=>{
    let previousMediaProvider;
    const mediaErrorLocalIds = new Set();
    return {
        name: 'media',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $afaS6.stateKey).getState(editorState) || null;
        },
        actions: {
            handleMediaNodeRenderError: (node, reason)=>{
                // Only fire the errored event once per media node
                if (mediaErrorLocalIds.has(node.attrs.localId)) return;
                mediaErrorLocalIds.add(node.attrs.localId);
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).ERRORED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        reason: reason,
                        external: node.attrs.__external
                    }
                });
            },
            insertMediaAsMediaSingle: (view, node, inputMethod, insertMediaVia)=>(0, $7dSFG.insertMediaAsMediaSingle)(view, node, inputMethod, api?.analytics?.actions, insertMediaVia, options?.allowPixelResizing),
            setProvider: (provider)=>{
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $afaS6.stateKey), {
                        mediaProvider: provider
                    })) ?? false;
            }
        },
        commands: {
            showMediaViewer: $c8a7e8befa4e0f56$export$9f7495958f6fc412,
            hideMediaViewer: $c8a7e8befa4e0f56$export$4e934779424102f3,
            trackMediaPaste: $c8a7e8befa4e0f56$export$3d560bf5e623346d,
            insertMediaSingle: (0, $c8a7e8befa4e0f56$export$483fbd616c5570ae)(api?.analytics?.actions, options.allowPixelResizing)
        },
        nodes () {
            const { allowMediaGroup: allowMediaGroup = true, allowMediaSingle: allowMediaSingle = false, allowPixelResizing: allowPixelResizing = false, allowCaptions: allowCaptions, allowMediaInlineImages: allowMediaInlineImages, featureFlags: mediaFeatureFlags } = options || {};
            const allowMediaInline = (0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : (0, $8QL6C.getMediaFeatureFlag)('mediaInline', mediaFeatureFlags);
            const mediaSingleOption = {
                withCaption: allowCaptions,
                withExtendedWidthTypes: allowPixelResizing
            };
            return [
                {
                    name: 'mediaGroup',
                    node: (0, $935bd411531f9b17$export$927453cb1fcf720e)()
                },
                {
                    name: 'mediaSingle',
                    node: (0, $4f6a96073a9759d6$export$7540e2ccc4187dcf)(mediaSingleOption)
                },
                {
                    name: 'media',
                    node: (0, $57f5ea6c60a1dc14$export$9f8a4f04eb482f68)()
                },
                {
                    name: 'mediaInline',
                    node: (0, $12c849f248a88385$export$e71594f26ef09ec1)()
                }
            ].filter((node)=>{
                if (node.name === 'mediaGroup') return allowMediaGroup;
                if (node.name === 'mediaSingle') return allowMediaSingle;
                if (node.name === 'mediaInline') return allowMediaInline;
                return true;
            });
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'media',
                    plugin: ({ schema: schema, dispatch: dispatch, getIntl: getIntl, eventDispatcher: eventDispatcher, providerFactory: providerFactory, errorReporter: errorReporter, portalProviderAPI: portalProviderAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $j5VfV.createPlugin)(schema, {
                            providerFactory: providerFactory,
                            nodeViews: {
                                mediaGroup: (0, $60012dd187d0d1ed$export$a1a01149851636f0)(portalProviderAPI, eventDispatcher, providerFactory, options, api),
                                mediaSingle: (0, $89a4e9b063bbde1b$export$fd09b1a92f5ce9f7)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options),
                                media: (0, $dadb75f02854ce81$export$a8df8d02db5c2be0)(portalProviderAPI, eventDispatcher, providerFactory, options, api),
                                mediaInline: (0, $aaffc5069c492c8e$export$c4ddfa4daf804695)(portalProviderAPI, eventDispatcher, providerFactory, api)
                            },
                            errorReporter: errorReporter,
                            uploadErrorHandler: options && options.uploadErrorHandler,
                            waitForMediaUpload: options && options.waitForMediaUpload,
                            customDropzoneContainer: options && options.customDropzoneContainer,
                            customMediaPicker: options && options.customMediaPicker,
                            allowResizing: !!(options && options.allowResizing)
                        }, getIntl, api, nodeViewPortalProviderAPI, dispatch, options);
                    }
                },
                {
                    name: 'mediaKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $a8675c3206562635$export$2e2bcd8739ae039)(options, api?.analytics?.actions, api?.selection?.actions, api?.width, getIntl)
                }
            ];
            if (options && options.allowMediaSingle) pmPlugins.push({
                name: 'mediaSingleKeymap',
                plugin: ({ schema: schema })=>(0, $c67d1c0c7982952b$export$2e2bcd8739ae039)(schema)
            });
            if (options && options.allowAltTextOnImages) {
                pmPlugins.push({
                    name: 'mediaAltText',
                    plugin: (0, $e285d524337ca108$export$ae829ec7b2625219)
                });
                pmPlugins.push({
                    name: 'mediaAltTextKeymap',
                    plugin: ({ schema: schema })=>(0, $6ad39c5d88144513$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                });
            }
            if (options && options.allowLinking) {
                pmPlugins.push({
                    name: 'mediaLinking',
                    plugin: ({ dispatch: dispatch })=>(0, $11220e9e93c1fc6e$export$2e2bcd8739ae039)(dispatch)
                });
                pmPlugins.push({
                    name: 'mediaLinkingKeymap',
                    plugin: ({ schema: schema })=>(0, $37685bafe60237da$export$2e2bcd8739ae039)(schema)
                });
            }
            if (options && options.allowAdvancedToolBarOptions && options.allowResizing && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) && options.allowPixelResizing) pmPlugins.push({
                name: 'mediaPixelResizing',
                plugin: (0, $b2cea85c133cd38a$export$ae829ec7b2625219)
            });
            pmPlugins.push({
                name: 'mediaSelectionHandler',
                plugin: ()=>{
                    const mediaSelectionHandlerPlugin = new (0, $1S4f7.SafePlugin)({
                        key: new (0, $ks2lK.PluginKey)('mediaSelectionHandlerPlugin'),
                        props: {
                            handleScrollToSelection: (view)=>{
                                const { state: { selection: selection } } = view;
                                if (!(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type.name !== 'media') return false;
                                const { node: node, offset: offset } = view.domAtPos(selection.from);
                                if (// Is the media element mounted already?
                                offset === node.childNodes.length) // Media is not ready, so stop the scroll request
                                return true;
                                // Media is ready, keep the scrolling request
                                return false;
                            }
                        }
                    });
                    return mediaSelectionHandlerPlugin;
                }
            });
            return pmPlugins;
        },
        contentComponent ({ editorView: editorView, appearance: appearance }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($c95e16e0e9a520c7$var$MediaViewerFunctionalComponent, {
                        api: api,
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($c95e16e0e9a520c7$var$MediaPickerFunctionalComponent, {
                        editorDomElement: editorView.dom,
                        appearance: appearance,
                        api: api
                    })
                ]
            });
        },
        secondaryToolbarComponent ({ disabled: disabled }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $44e98bca39fd3cdb$export$2e2bcd8739ae039), {
                isDisabled: disabled,
                isReducedSpacing: true,
                api: api
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>!api?.mediaInsert && (0, $dh538.fg)('platform_editor_media_insert_check') ? [
                    {
                        id: 'media',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconImages), {}),
                        isDisabledOffline: true,
                        action (insert, state) {
                            const pluginState = (0, $afaS6.stateKey).getState(state);
                            pluginState?.showMediaPicker();
                            const tr = insert('');
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).OPENED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_CLOUD,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ] : [],
            floatingToolbar: (state, intl, providerFactory)=>(0, $867c89c00d621557$export$4850df084251d287)(state, intl, {
                    providerFactory: providerFactory,
                    allowMediaInline: options && (0, $8QL6C.getMediaFeatureFlag)('mediaInline', options.featureFlags),
                    allowResizing: options && options.allowResizing,
                    allowResizingInTables: options && options.allowResizingInTables,
                    allowCommentsOnMedia: options && options.allowCommentsOnMedia,
                    allowLinking: options && options.allowLinking,
                    allowAdvancedToolBarOptions: options && options.allowAdvancedToolBarOptions,
                    allowAltTextOnImages: options && options.allowAltTextOnImages,
                    allowImageEditing: !!api?.mediaEditing && options && options.allowImageEditing,
                    allowImagePreview: options && options.allowImagePreview,
                    altTextValidator: options && options.altTextValidator,
                    fullWidthEnabled: options && options.fullWidthEnabled,
                    allowMediaInlineImages: options && options.allowMediaInlineImages,
                    isViewOnly: api?.editorViewMode?.sharedState.currentState()?.mode === 'view',
                    allowPixelResizing: options?.allowPixelResizing,
                    onCommentButtonMount: options?.onCommentButtonMount
                }, api)
        }
    };
};
module.exports["mediaPlugin"] = $c95e16e0e9a520c7$export$a4dd0667e1feabbd;

});

parcelRegister("aPufn", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $dYBVS = parcelRequire("dYBVS");


var $2gkmX = parcelRequire("2gkmX");


var $1oCLl = parcelRequire("1oCLl");


var $42omo = parcelRequire("42omo");




const $0c04462018cc888c$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider
    };
};
const $0c04462018cc888c$export$669acb2735f045dd = (pluginInjectionApi)=>{
    const { mediaProvider: mediaProvider } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $0c04462018cc888c$var$selector);
    const provider = (0, $42omo.useMemo)(()=>{
        return mediaProvider;
    }, [
        mediaProvider
    ]);
    return provider;
};









var $gmMgo = parcelRequire("gmMgo");


var $7541v = parcelRequire("7541v");


var $cgtv4 = parcelRequire("cgtv4");

const $f40eb66a88e5dc3f$export$788459419c7c9712 = (0, $cgtv4.defineMessages)({
    mediaGroupDeleteLabel: {
        id: "fabric.editor.mediaGroupDeleteLabel",
        defaultMessage: "delete"
    }
});



var $7iE7T = parcelRequire("7iE7T");

var $kTbzR = parcelRequire("kTbzR");


var $hmuev = parcelRequire("hmuev");


var $8QL6C = parcelRequire("8QL6C");





var $1BiXn = parcelRequire("1BiXn");

var $9s7Po = parcelRequire("9s7Po");

var $3BZZG = parcelRequire("3BZZG");


var $46EIy = parcelRequire("46EIy");

let $d1d428c814be1f46$var$lastKey = 1;
const $d1d428c814be1f46$var$identifiersMap = new Map();
const $d1d428c814be1f46$export$5d5de19b6d92a058 = (identifier)=>{
    switch(identifier.mediaItemType){
        case 'external-image':
            return identifier.dataURI;
        case 'file':
            if (typeof identifier.id === 'string') return identifier.id;
            else {
                const currentKey = $d1d428c814be1f46$var$identifiersMap.get(identifier.id);
                if (currentKey) return currentKey;
                // We want to increment the key before using it
                $d1d428c814be1f46$var$lastKey++;
                const newKey = `${$d1d428c814be1f46$var$lastKey}`;
                $d1d428c814be1f46$var$identifiersMap.set(identifier.id, newKey);
                return newKey;
            }
    }
};






var $3rvSa = parcelRequire("3rvSa");

var $aL0VQ = parcelRequire("aL0VQ");













var $e63NX = parcelRequire("e63NX");

function $cf71bed50f85623e$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
const $cf71bed50f85623e$var$DeduplicatedFilmStripInternal = ({ items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, testId: testId = 'media-filmstrip', isLazy: isLazy })=>{
    const [animate, setAnimate] = (0, $42omo.useState)(false);
    const [offset, setOffset] = (0, $42omo.useState)(0);
    const handleSize = ({ offset: offset })=>{
        setOffset(offset);
    };
    const handleScroll = ({ animate: animate, offset: offset })=>{
        setAnimate(animate);
        setOffset(offset);
    };
    const ids = (0, $42omo.useMemo)(()=>items.map(({ identifier: identifier })=>identifier).filter((0, $e63NX.isFileIdentifier)), [
        items
    ]);
    const fileHashes = (0, $aL0VQ.useFileHashes)(ids);
    const cards = (0, $42omo.useMemo)(()=>{
        // filters only the first item when encountering duplicated hashes
        const uniqueItems = items.filter(({ identifier: identifier }, i)=>identifier.mediaItemType !== 'file' || !fileHashes[identifier.id] || !items.some((currentItem, currI)=>currentItem.identifier.mediaItemType === 'file' && currI < i && fileHashes[identifier.id] === fileHashes[currentItem.identifier.id]));
        return uniqueItems.map((item)=>{
            const key = (0, $d1d428c814be1f46$export$5d5de19b6d92a058)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
                key: key,
                dimensions: (0, $3BZZG.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? uniqueItems.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1BiXn.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $3BZZG.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                includeHashForDuplicateFiles: true,
                isLazy: isLazy,
                ...item
            });
        });
    }, [
        items,
        fileHashes,
        mediaClientConfig,
        shouldOpenMediaViewer,
        featureFlags,
        viewerOptions,
        isLazy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46EIy.FilmstripView), {
        animate: animate,
        offset: offset,
        onSize: handleSize,
        onScroll: handleScroll,
        testId: testId
    }, cards);
};
const $cf71bed50f85623e$var$EmptyFilmstripView = ({ items: items, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46EIy.FilmstripView), {
        animate: false,
        offset: 0,
        onSize: ()=>{},
        onScroll: ()=>{},
        testId: testId
    }, items.map((item, _i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
            key: (0, $d1d428c814be1f46$export$5d5de19b6d92a058)(item.identifier),
            dimensions: (0, $3BZZG.defaultImageCardDimensions),
            interactionName: "media-filmstrip-card-loading"
        })));
};
const $cf71bed50f85623e$export$f2e48bfda187171f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3rvSa.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf71bed50f85623e$var$DeduplicatedFilmStripInternal, props) : !props.mediaClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf71bed50f85623e$var$EmptyFilmstripView, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3rvSa.MediaClientProvider), {
            clientConfig: props.mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf71bed50f85623e$var$DeduplicatedFilmStripInternal, props)));


class $b0c5504554e68b9a$export$8be30a51dc0802a7 extends (0, $42omo.Component) {
    renderCards() {
        const { items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, isLazy: isLazy } = this.props;
        return items.map((item)=>{
            const key = (0, $d1d428c814be1f46$export$5d5de19b6d92a058)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
                key: key,
                dimensions: (0, $3BZZG.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? items.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1BiXn.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $3BZZG.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                isLazy: isLazy,
                ...item
            });
        });
    }
    render() {
        const { testId: testId = 'media-filmstrip', includeHashForDuplicateFiles: includeHashForDuplicateFiles } = this.props;
        if (includeHashForDuplicateFiles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf71bed50f85623e$export$f2e48bfda187171f), this.props);
        const { animate: animate, offset: offset } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46EIy.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            testId: testId
        }, this.renderCards());
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
    }
}



var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $afaS6 = parcelRequire("afaS6");


var $gEIpk = parcelRequire("gEIpk");

const $dbd59dc6035946c4$var$getIdentifier = (item)=>{
    if (item.attrs.type === 'external') return {
        mediaItemType: 'external-image',
        dataURI: item.attrs.url
    };
    return {
        id: item.attrs.id,
        mediaItemType: 'file',
        collectionName: item.attrs.collection
    };
};
const $dbd59dc6035946c4$var$isNodeSelected = (props)=>(mediaItemPos, mediaGroupPos)=>{
        const selected = (0, $7iE7T.isNodeSelectedOrInRange)(props.anchorPos, props.headPos, mediaGroupPos, props.nodeSize);
        if (selected === (0, $7iE7T.SelectedState).selectedInRange) return true;
        if (selected === (0, $7iE7T.SelectedState).selectedInside && props.anchorPos === mediaItemPos) return true;
        return false;
    };
const $dbd59dc6035946c4$var$prepareFilmstripItem = ({ allowLazyLoading: allowLazyLoading, allowMediaInlineImages: allowMediaInlineImages, enableDownloadButton: enableDownloadButton, handleMediaNodeRemoval: handleMediaNodeRemoval, getPos: getPos, intl: intl, isMediaItemSelected: isMediaItemSelected, setMediaGroupNodeSelection: setMediaGroupNodeSelection, featureFlags: featureFlags })=>(item, idx)=>{
        // We declared this to get a fresh position every time
        const getNodePos = ()=>{
            const pos = getPos();
            if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
            // Because the original code would return NaN on runtime
            // We are just make it explict now.
            // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
            // TODO: ED-13910 - prosemirror-bump leftovers
            return NaN;
            return pos + idx + 1;
        };
        // Media Inline creates a floating toolbar with the same options, excludes these options if enabled
        const mediaInlineOptions = (allowMediaInline = false)=>{
            if (!allowMediaInline) return {
                shouldEnableDownloadButton: enableDownloadButton,
                actions: [
                    {
                        handler: handleMediaNodeRemoval.bind(null, undefined, getNodePos),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            label: intl.formatMessage((0, $f40eb66a88e5dc3f$export$788459419c7c9712).mediaGroupDeleteLabel)
                        })
                    }
                ]
            };
        };
        const mediaGroupPos = getPos();
        return {
            identifier: $dbd59dc6035946c4$var$getIdentifier(item),
            isLazy: allowLazyLoading,
            selected: isMediaItemSelected(getNodePos(), typeof mediaGroupPos === 'number' ? mediaGroupPos : NaN),
            onClick: ()=>{
                setMediaGroupNodeSelection(getNodePos());
            },
            ...mediaInlineOptions((0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : (0, $8QL6C.getMediaFeatureFlag)('mediaInline', featureFlags))
        };
    };
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $dbd59dc6035946c4$var$useLatestMediaGroupNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $7541v.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!previousMediaNode) return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $dbd59dc6035946c4$var$runMediaNodeUpdate = async ({ mediaNodeUpdater: mediaNodeUpdater, getPos: getPos, node: node, updateAttrs: updateAttrs })=>{
    if (updateAttrs) await mediaNodeUpdater.updateNodeAttrs(getPos);
    const contextId = mediaNodeUpdater.getNodeContextId();
    if (!contextId) await mediaNodeUpdater.updateNodeContextId(getPos);
    const shouldNodeBeDeepCopied = await mediaNodeUpdater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) await mediaNodeUpdater.copyNodeFromPos(getPos, {
        traceId: node.attrs.__mediaTraceId
    });
};
const $dbd59dc6035946c4$var$noop = ()=>{};
const $dbd59dc6035946c4$export$7fbb084971a34492 = (0, $gmMgo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { mediaOptions: { allowLazyLoading: allowLazyLoading, allowMediaInlineImages: allowMediaInlineImages, enableDownloadButton: enableDownloadButton, featureFlags: featureFlags }, intl: intl, getPos: getPos, anchorPos: anchorPos, headPos: headPos, view: view, disabled: disabled, editorViewMode: editorViewMode, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider, isCopyPasteEnabled: isCopyPasteEnabled } = props;
    const mediaGroupNode = $dbd59dc6035946c4$var$useLatestMediaGroupNode(props.node);
    const mediaPluginState = (0, $42omo.useMemo)(()=>{
        return (0, $afaS6.stateKey).getState(view.state);
    }, [
        view.state
    ]);
    const mediaClientConfig = mediaPluginState?.mediaClientConfig;
    const handleMediaGroupUpdate = mediaPluginState?.handleMediaGroupUpdate;
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, $42omo.useState)(undefined);
    const nodeSize = mediaGroupNode.nodeSize;
    const mediaNodesWithOffsets = (0, $42omo.useMemo)(()=>{
        const result = [];
        mediaGroupNode.forEach((item, childOffset)=>{
            result.push({
                node: item,
                offset: childOffset
            });
        });
        return result;
    }, [
        mediaGroupNode
    ]);
    const previousMediaNodesWithOffsets = (0, $7541v.default)(mediaNodesWithOffsets);
    const handleMediaNodeRemoval = (0, $42omo.useMemo)(()=>{
        return disabled || !mediaPluginState ? $dbd59dc6035946c4$var$noop : mediaPluginState.handleMediaNodeRemoval;
    }, [
        disabled,
        mediaPluginState
    ]);
    const setMediaGroupNodeSelection = (0, $42omo.useCallback)((pos)=>{
        (0, $kTbzR.setNodeSelection)(view, pos);
    }, [
        view
    ]);
    const isMediaItemSelected = (0, $42omo.useMemo)(()=>{
        return $dbd59dc6035946c4$var$isNodeSelected({
            anchorPos: anchorPos,
            headPos: headPos,
            nodeSize: nodeSize
        });
    }, [
        anchorPos,
        headPos,
        nodeSize
    ]);
    const filmstripItem = (0, $42omo.useMemo)(()=>{
        return $dbd59dc6035946c4$var$prepareFilmstripItem({
            allowLazyLoading: allowLazyLoading,
            allowMediaInlineImages: allowMediaInlineImages,
            enableDownloadButton: enableDownloadButton,
            handleMediaNodeRemoval: handleMediaNodeRemoval,
            getPos: getPos,
            intl: intl,
            isMediaItemSelected: isMediaItemSelected,
            setMediaGroupNodeSelection: setMediaGroupNodeSelection,
            featureFlags: featureFlags
        });
    }, [
        allowLazyLoading,
        allowMediaInlineImages,
        enableDownloadButton,
        handleMediaNodeRemoval,
        getPos,
        intl,
        isMediaItemSelected,
        setMediaGroupNodeSelection,
        featureFlags
    ]);
    const items = (0, $42omo.useMemo)(()=>{
        return mediaNodesWithOffsets.map(({ node: node, offset: offset })=>{
            return filmstripItem(node, offset);
        });
    }, [
        mediaNodesWithOffsets,
        filmstripItem
    ]);
    (0, $42omo.useEffect)(()=>{
        setViewMediaClientConfig(mediaClientConfig);
    }, [
        mediaClientConfig
    ]);
    (0, $42omo.useEffect)(()=>{
        mediaNodesWithOffsets.forEach(({ node: node, offset: offset })=>{
            const mediaNodeUpdater = (0, $gEIpk.createMediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                isMediaSingle: false
            });
            const updateAttrs = isCopyPasteEnabled || isCopyPasteEnabled === undefined;
            $dbd59dc6035946c4$var$runMediaNodeUpdate({
                mediaNodeUpdater: mediaNodeUpdater,
                node: node,
                updateAttrs: updateAttrs,
                getPos: ()=>{
                    const pos = getPos();
                    if (typeof pos !== 'number') return undefined;
                    return pos + offset + 1;
                }
            });
        });
    }, [
        view,
        contextIdentifierProvider,
        getPos,
        mediaProvider,
        mediaNodesWithOffsets,
        isCopyPasteEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!handleMediaGroupUpdate || !previousMediaNodesWithOffsets) return;
        const old = previousMediaNodesWithOffsets.map(({ node: node })=>node);
        const next = mediaNodesWithOffsets.map(({ node: node })=>node);
        handleMediaGroupUpdate(old, next);
        return ()=>{
            handleMediaGroupUpdate(next, []);
        };
    }, [
        handleMediaGroupUpdate,
        mediaNodesWithOffsets,
        previousMediaNodesWithOffsets
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b0c5504554e68b9a$export$8be30a51dc0802a7), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        featureFlags: featureFlags,
        shouldOpenMediaViewer: editorViewMode && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control')
    });
}));
$dbd59dc6035946c4$export$7fbb084971a34492.displayName = 'MediaGroup';


const $e34ee5f2a51e7d26$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled,
        editorViewMode: states.editorViewModeState?.mode
    };
};
function $e34ee5f2a51e7d26$var$MediaGroupNodeViewInternal({ renderFn: renderFn, pluginInjectionApi: pluginInjectionApi }) {
    const { editorDisabled: editorDisabled, editorViewMode: editorViewMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled',
        'editorViewMode'
    ], $e34ee5f2a51e7d26$var$selector);
    const mediaProvider = (0, $0c04462018cc888c$export$669acb2735f045dd)(pluginInjectionApi);
    return renderFn({
        editorDisabled: editorDisabled,
        editorViewMode: editorViewMode,
        mediaProvider: mediaProvider
    });
}
class $e34ee5f2a51e7d26$var$MediaGroupNodeView extends (0, $2gkmX.default) {
    render(props, forwardRef) {
        const { providerFactory: providerFactory, mediaOptions: mediaOptions, pluginInjectionApi: pluginInjectionApi } = props;
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dYBVS.WithProviders), {
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                const renderFn = ({ mediaProvider: mediaProviderFromState, editorDisabled: editorDisabled, editorViewMode: editorViewMode })=>{
                    const mediaProvider = mediaProviderFromState ? Promise.resolve(mediaProviderFromState) : undefined;
                    if (!mediaProvider && !(0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dbd59dc6035946c4$export$7fbb084971a34492), {
                        node: this.node,
                        getPos: getPos,
                        view: this.view,
                        forwardRef: forwardRef,
                        disabled: editorDisabled,
                        allowLazyLoading: mediaOptions.allowLazyLoading,
                        mediaProvider: mediaProvider,
                        contextIdentifierProvider: contextIdentifierProvider,
                        isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
                        anchorPos: this.view.state.selection.$anchor.pos,
                        headPos: this.view.state.selection.$head.pos,
                        mediaOptions: mediaOptions,
                        editorViewMode: editorViewMode === 'view'
                    });
                };
                return /*#__PURE__*/ (0, $l998X.jsx)($e34ee5f2a51e7d26$var$MediaGroupNodeViewInternal, {
                    renderFn: renderFn,
                    pluginInjectionApi: pluginInjectionApi
                });
            }
        });
    }
}
const $e34ee5f2a51e7d26$export$dc2dedbaab4b1587 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi)=>(node, view, getPos)=>{
        return new $e34ee5f2a51e7d26$var$MediaGroupNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi
        }).init();
    };
module.exports["ReactMediaGroupNode"] = $e34ee5f2a51e7d26$export$dc2dedbaab4b1587;

});

parcelRegister("gEIpk", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");


var $gAARK = parcelRequire("gAARK");


var $Girkv = parcelRequire("Girkv");

var $hZ6O7 = parcelRequire("hZ6O7");


var $grxv4 = parcelRequire("grxv4");


var $6taGi = parcelRequire("6taGi");


var $dh538 = parcelRequire("dh538");


var $aRHMp = parcelRequire("aRHMp");


var $afaS6 = parcelRequire("afaS6");


var $jSnXV = parcelRequire("jSnXV");


var $5d9b4 = parcelRequire("5d9b4");


var $7Mtx3 = parcelRequire("7Mtx3");


var $h3X17 = parcelRequire("h3X17");

const $f5ac7a0cac9b18ec$export$4dd32806a37c505b = (editorView, steps)=>{
    const { state: state, dispatch: dispatch } = editorView;
    const tr = state.tr;
    if (steps.length === 0) return false;
    tr.step(new (0, $7Mtx3.BatchAttrsStep)(steps));
    if (tr.steps.length > 0 && tr.doc.eq(state.doc)) return false;
    (0, $h3X17.tintDirtyTransaction)(tr);
    dispatch(tr);
};


/**
 * 🧱 Internal: Editor FE Platform
 * Based on https://github.com/lodash/lodash/issues/2403#issuecomment-1706130395
 *
 * Creates a debounced function that delays invoking the provided function until after a specified
 * wait time has elapsed since the last time the debounced function was invoked. Additionally, the
 * debounced function is memoized so that the same function instance is used for each unique set
 * of arguments based on the resolver.
 *
 * This is particularly useful in scenarios where you want to debounce function calls while ensuring
 * that each unique input combination receives its own debounced function instance. It's a combination
 * of lodash's `debounce` and `memoize`.
 *
 * @template T
 * @param {T} func - The function to debounce.
 * @param {number} [wait=0] - The number of milliseconds to delay.
 * @param {object} [options] - The options object to pass to `debounce`.
 * @param {Function} [resolver] - The function to resolve the cache key for memoization.
 * @returns {Function} A new debounced and memoized function.
 *
 * @example
 * const debouncedFunction = memoizeDebounce(myFunction, 300, { leading: true }, myResolver);
 * debouncedFunction(arg1, arg2);
 */ function $7a01797c05236635$var$memoizeDebounce(func, wait = 0, options, resolver) {
    const mem = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(func, wait, options);
    }, resolver);
    return function(...args) {
        return mem(...args)(...args);
    };
}
const $7a01797c05236635$var$mediaAttributesCache = new WeakMap();
const $7a01797c05236635$var$debouncedTime = 500;
const $7a01797c05236635$export$e13de86a39dc2884 = (a, b)=>{
    // a contains b, and want to check if attributes in b are same in a
    return Object.entries(b).every(([bkey, bValue])=>{
        if (bkey in a) {
            const aValue = a[bkey];
            // Check if types match before comparing values
            return typeof aValue === typeof bValue && aValue === bValue;
        }
        return false;
    });
};
const $7a01797c05236635$export$36f3e00b05c9935d = (editorView, cache)=>{
    const toUpdateValues = cache.get(editorView) || {};
    // clear the media attributes cache per editor view
    cache.delete(editorView);
    const ids = Object.keys(toUpdateValues);
    const { state: state } = editorView;
    const mediaSteps = [];
    // search node positions by id
    state.doc.descendants((node, position)=>{
        if (![
            node.type.schema.nodes.media,
            node.type.schema.nodes.mediaInline
        ].includes(node.type)) return true;
        if (!ids.includes(node.attrs.id)) return false;
        const attrs = toUpdateValues[node.attrs.id];
        if ($7a01797c05236635$export$e13de86a39dc2884(node.attrs, attrs)) return false;
        mediaSteps.push({
            position: position,
            nodeType: node.type.name,
            attrs: attrs
        });
    });
    if (mediaSteps.length > 0) (0, $f5ac7a0cac9b18ec$export$4dd32806a37c505b)(editorView, mediaSteps);
};
const $7a01797c05236635$export$8ad1cb8a3a0ac36b = $7a01797c05236635$var$memoizeDebounce($7a01797c05236635$export$36f3e00b05c9935d, $7a01797c05236635$var$debouncedTime, /**
	 * Use the default debounce options:
	 * {leading: false, trailing: true}
	 */ undefined, (view)=>{
    /**
		 * EditorView is a singleton.
		 * There is only one instance per Editor.
		 */ return view;
});
const $7a01797c05236635$export$298f04086ed0efe2 = (editorView, props)=>{
    let cachePerView = $7a01797c05236635$var$mediaAttributesCache.get(editorView);
    if (!cachePerView) cachePerView = {
        records: {}
    };
    cachePerView[props.id] = {
        ...cachePerView[props.id] || {},
        ...props.nextAttributes
    };
    $7a01797c05236635$var$mediaAttributesCache.set(editorView, cachePerView);
    $7a01797c05236635$export$8ad1cb8a3a0ac36b(editorView, $7a01797c05236635$var$mediaAttributesCache);
};



var $kjHnW = parcelRequire("kjHnW");

const $3ffe31a0bf369f79$var$isMediaTypeSupported = (type)=>{
    if (type) return [
        'image',
        'file'
    ].includes(type);
    return false;
};
class $3ffe31a0bf369f79$export$e115d1293528d541 {
    setProps(newComponentProps) {
        this.props = {
            ...this.props,
            ...newComponentProps
        };
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return !!(attrs && attrs.type === 'external' && (0, $Girkv.isMediaBlobUrl)(attrs.url));
    }
    async getRemoteDimensions() {
        const mediaProvider = await this.props.mediaProvider;
        const { mediaOptions: mediaOptions } = this.props;
        const attrs = this.getAttrs();
        if (!mediaProvider || !attrs) return false;
        const { height: height, width: width } = attrs;
        if (attrs.type === 'external' || !attrs.id) return false;
        const { id: id, collection: collection } = attrs;
        if (height && width) return false;
        // can't fetch remote dimensions on mobile, so we'll default them
        if (mediaOptions && !mediaOptions.allowRemoteDimensionsFetch) return {
            id: id,
            height: (0, $gAARK.DEFAULT_IMAGE_HEIGHT),
            width: (0, $gAARK.DEFAULT_IMAGE_WIDTH)
        };
        const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
        const mediaClient = (0, $grxv4.getMediaClient)(viewMediaClientConfig);
        const currentState = await mediaClient.file.getCurrentState(id, {
            collectionName: collection
        });
        if (!(0, $hZ6O7.isImageRepresentationReady)(currentState)) return false;
        const imageMetadata = await mediaClient.getImageMetadata(id, {
            collection: collection
        });
        if (!imageMetadata || !imageMetadata.original) return false;
        return {
            id: id,
            height: imageMetadata.original.height || (0, $gAARK.DEFAULT_IMAGE_HEIGHT),
            width: imageMetadata.original.width || (0, $gAARK.DEFAULT_IMAGE_WIDTH)
        };
    }
    async handleExternalMedia(getPos) {
        if (this.isMediaBlobUrl()) try {
            await this.copyNodeFromBlobUrl(getPos);
        } catch  {
            await this.uploadExternalMedia(getPos);
        }
        else await this.uploadExternalMedia(getPos);
    }
    constructor(props){
        this.props = void 0;
        this.mediaPluginState = void 0;
        // Updates the node with contextId if it doesn't have one already
        this.updateContextId = async ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return;
            const { id: id } = attrs;
            const objectId = await this.getObjectId();
            (0, $7a01797c05236635$export$298f04086ed0efe2)(this.props.view, {
                id: id,
                nextAttributes: {
                    __contextId: objectId
                }
            });
        };
        this.updateNodeContextId = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return;
            const objectId = await this.getObjectId();
            (0, $aRHMp.updateCurrentMediaNodeAttrs)({
                __contextId: objectId
            }, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.hasFileAttributesDefined = (attrs)=>{
            return attrs && attrs.type === 'file' && attrs.__fileName && attrs.__fileMimeType && attrs.__fileSize && attrs.__contextId;
        };
        this.getNewFileAttrsForNode = async ()=>{
            const attrs = this.getAttrs();
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams || !attrs || !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type) || this.hasFileAttributesDefined(attrs)) return;
            const mediaClientConfig = mediaProvider.viewMediaClientConfig;
            const mediaClient = (0, $grxv4.getMediaClient)(mediaClientConfig);
            let fileState;
            const { id: id, collection: collectionName } = attrs;
            try {
                fileState = await mediaClient.file.getCurrentState(id, {
                    collectionName: collectionName
                });
                if (fileState.status === 'error') return;
            } catch  {
                return;
            }
            const contextId = this.getNodeContextId() || await this.getObjectId();
            const { name: name, mimeType: mimeType, size: size } = fileState;
            const newAttrs = {
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size,
                __contextId: contextId
            };
            if (!$3ffe31a0bf369f79$var$hasPrivateAttrsChanged(attrs, newAttrs)) return;
            return newAttrs;
        };
        this.updateMediaSingleFileAttrs = async ()=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            const { id: id } = this.getAttrs();
            if (id && newAttrs) (0, $7a01797c05236635$export$298f04086ed0efe2)(this.props.view, {
                id: id,
                nextAttributes: newAttrs
            });
        };
        this.updateNodeAttrs = async (getPos)=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            if (newAttrs) (0, $aRHMp.updateCurrentMediaNodeAttrs)(newAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.getAttrs = ()=>{
            const { attrs: attrs } = this.props.node;
            if (attrs) return attrs;
            return undefined;
        };
        this.getObjectId = async ()=>{
            const contextIdentifierProvider = await this.props.contextIdentifierProvider;
            return contextIdentifierProvider?.objectId || null;
        };
        this.uploadExternalMedia = async (getPos)=>{
            const { node: node, mediaOptions: mediaOptions } = this.props;
            if (mediaOptions?.isExternalMediaUploadDisabled) return;
            const mediaProvider = await this.props.mediaProvider;
            if (node && mediaProvider) {
                const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
                if (!uploadMediaClientConfig || !node.attrs.url) return;
                const mediaClient = (0, $grxv4.getMediaClient)(uploadMediaClientConfig);
                const collection = mediaProvider.uploadParams && mediaProvider.uploadParams.collection;
                try {
                    const uploader = await mediaClient.file.uploadExternal(node.attrs.url, collection);
                    const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions } = uploader;
                    const pos = getPos();
                    if (typeof pos !== 'number') return;
                    (0, $aRHMp.replaceExternalMedia)(pos + 1, {
                        id: uploadableFileUpfrontIds.id,
                        collection: collection,
                        height: dimensions.height,
                        width: dimensions.width,
                        occurrenceKey: uploadableFileUpfrontIds.occurrenceKey
                    })(this.props.view.state, this.props.view.dispatch);
                } catch  {
                    //keep it as external media
                    if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                        action: (0, $d925B.ACTION).UPLOAD_EXTERNAL_FAIL,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        };
        this.getNodeContextId = ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return null;
            return attrs.__contextId || null;
        };
        this.updateDimensions = (dimensions)=>{
            (0, $7a01797c05236635$export$298f04086ed0efe2)(this.props.view, {
                id: dimensions.id,
                nextAttributes: {
                    height: dimensions.height,
                    width: dimensions.width
                }
            });
        };
        this.shouldNodeBeDeepCopied = async ()=>{
            const scope = this.props.mediaOptions?.mediaShallowCopyScope ?? this.mediaPluginState?.mediaOptions?.mediaShallowCopyScope ?? 'context';
            if (scope === 'context') return await this.hasDifferentContextId();
            else {
                const attrs = this.getAttrs();
                if (!attrs || !this.mediaPluginState) return false;
                const id = (0, $kjHnW.getIdentifier)(attrs);
                const isIdentifierOutsideEditorScope = !this.mediaPluginState.isIdentifierInEditorScope(id);
                return isIdentifierOutsideEditorScope;
            }
        };
        this.hasDifferentContextId = async ()=>{
            const nodeContextId = this.getNodeContextId();
            const currentContextId = await this.getObjectId();
            if (nodeContextId && currentContextId && nodeContextId !== currentContextId) return true;
            return false;
        };
        this.isNodeFromDifferentCollection = async ()=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return false;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return false;
            const { collection: nodeCollection, __contextId: __contextId } = attrs;
            const contextId = __contextId || await this.getObjectId();
            if (contextId && currentCollectionName !== nodeCollection) return true;
            return false;
        };
        this.handleCopyFileSwitcher = async (attrs)=>{
            const { mediaClient: mediaClient, source: source, destination: destination, traceContext: traceContext } = attrs;
            try {
                // calling copyWithToken by passing the auth providers
                const { id: id } = await mediaClient.file.copyFile(source, destination, undefined, traceContext);
                return id;
            } catch (err) {
                if ((0, $dh538.fg)('platform_media_cross_client_copy')) {
                    // calling /v2/file/copy by removing the auth tokens to make cross product copy and pastes
                    const { authProvider: _sourceAP, ...copyV2Source } = source;
                    const { authProvider: _destAP, ...copyV2Destination } = destination;
                    const { id: id } = await mediaClient.file.copyFile(copyV2Source, copyV2Destination, undefined, traceContext);
                    return id;
                } else throw err;
            }
        };
        this.copyNodeFromBlobUrl = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs.type !== 'external') return;
            const { url: url } = attrs;
            const mediaAttrs = (0, $Girkv.getAttrsFromUrl)(url);
            if (!mediaAttrs) return;
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const { contextId: contextId, clientId: clientId, id: id, collection: collection, height: height, width: width, mimeType: mimeType, name: name, size: size } = mediaAttrs;
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig || !uploadMediaClientConfig.getAuthFromContext) return;
            const mediaClient = (0, $grxv4.getMediaClient)(uploadMediaClientConfig);
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(contextId),
                    clientId: (0, $dh538.fg)('platform_media_cross_client_copy_with_auth') ? clientId : undefined
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
                }
            });
            const pos = getPos();
            if (typeof pos !== 'number') return;
            (0, $aRHMp.replaceExternalMedia)(pos + 1, {
                id: mediaFileId,
                collection: currentCollectionName,
                height: height,
                width: width,
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection using a getPos handler
        this.copyNodeFromPos = async (getPos, traceContext)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $aRHMp.updateCurrentMediaNodeAttrs)(copiedAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection
        this.copyNode = async (traceContext)=>{
            const attrs = this.getAttrs();
            const { view: view } = this.props;
            if (!attrs || attrs && !$3ffe31a0bf369f79$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $aRHMp.updateMediaNodeAttrs)(attrs.id, copiedAttrs)(view.state, view.dispatch);
        };
        this.copyFile = async (id, collection, traceContext)=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider?.uploadParams) return;
            const nodeContextId = this.getNodeContextId();
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig?.getAuthFromContext || !nodeContextId) return;
            const mediaClient = (0, $grxv4.getMediaClient)(uploadMediaClientConfig);
            const clientId = (0, $dh538.fg)('platform_media_cross_client_copy_with_auth') ? (0, $6taGi.getClientIdForFile)(id) : undefined;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const objectId = await this.getObjectId();
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(nodeContextId),
                    clientId: clientId
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
                },
                traceContext: traceContext
            });
            return {
                id: mediaFileId,
                collection: currentCollectionName,
                __contextId: objectId
            };
        };
        this.props = props;
        this.mediaPluginState = (0, $afaS6.stateKey).getState(props.view.state);
    }
}
const $3ffe31a0bf369f79$var$hasPrivateAttrsChanged = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};
const $3ffe31a0bf369f79$export$5acae1477d0bf3d = (props)=>{
    const updaterProps = {
        ...props
    };
    return new $3ffe31a0bf369f79$export$e115d1293528d541(updaterProps);
};
module.exports["MediaNodeUpdater"] = $3ffe31a0bf369f79$export$e115d1293528d541;
module.exports["createMediaNodeUpdater"] = $3ffe31a0bf369f79$export$5acae1477d0bf3d;

});

parcelRegister("7Mtx3", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");

const $575ee1da6f54eab1$var$stepType = 'batchAttrs';
const $575ee1da6f54eab1$var$isValidData = (data)=>{
    if (data !== null && !Array.isArray(data)) return false;
    return !data.some((d)=>{
        const invalidPosition = typeof d.position !== 'number';
        const invalidNodeType = typeof d.nodeType !== 'string';
        const invalidAttrs = typeof d.attrs !== 'object';
        return invalidPosition || invalidNodeType || invalidAttrs;
    });
};
class $575ee1da6f54eab1$export$4fd0fe0f65803356 extends (0, $cO9ey.Step) {
    apply(doc) {
        const resultDoc = this.data.reduce((acc, value)=>{
            if (!acc.doc || acc.failed) return acc;
            const { position: position, attrs: attrs } = value;
            if (acc.doc && position > acc.doc.nodeSize || position < 0) return (0, $aXG5V.StepResult).fail(`Position ${position} out of document range.`);
            const target = acc.doc?.nodeAt(position);
            if (!target) return (0, $aXG5V.StepResult).fail(`No node at given position: ${position}`);
            if (target.isText) return (0, $aXG5V.StepResult).fail('Target is a text node. Attributes are not allowed.');
            const mergedAttrs = {
                ...target.attrs || {},
                ...attrs || {}
            };
            const updatedNode = target.type.create(mergedAttrs, null, target.marks);
            const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(updatedNode), 0, target.isLeaf ? 0 : 1);
            return (0, $aXG5V.StepResult).fromReplace(acc.doc, position, position + 1, slice);
        }, (0, $aXG5V.StepResult).ok(doc));
        return resultDoc;
    }
    invert(doc) {
        const previousData = this.data.reduce((acc, value)=>{
            const { position: position, nodeType: nodeType, attrs: nextAttrs } = value;
            if (position > doc.nodeSize) return acc;
            const target = doc.nodeAt(position);
            if (!target) return acc;
            if (target.isText) return acc;
            const previousAttrs = Object.keys(nextAttrs).reduce((attributesIterator, key)=>{
                const oldValue = target.attrs[key];
                attributesIterator[key] = oldValue;
                return attributesIterator;
            }, {});
            const prev = {
                position: position,
                nodeType: nodeType,
                attrs: previousAttrs
            };
            acc.push(prev);
            return acc;
        }, []);
        return new $575ee1da6f54eab1$export$4fd0fe0f65803356(previousData, true);
    }
    map(mapping) {
        const mappedData = this.data.reduce((acc, value)=>{
            const { position: position } = value;
            const mappedPosition = mapping.mapResult(position);
            if (mappedPosition.deleted) return acc;
            acc.push({
                ...value,
                position: mappedPosition.pos
            });
            return acc;
        }, []);
        if (mappedData.length === 0) return null;
        return new $575ee1da6f54eab1$export$4fd0fe0f65803356(mappedData, this.inverted);
    }
    toJSON() {
        return {
            stepType: $575ee1da6f54eab1$var$stepType,
            data: this.data,
            inverted: this.inverted
        };
    }
    static fromJSON(_schema, json) {
        const data = json?.data;
        if (!$575ee1da6f54eab1$var$isValidData(data)) throw new Error('Invalid input for BatchAttrsStep.fromJSON');
        return new $575ee1da6f54eab1$export$4fd0fe0f65803356(data, Boolean(json.inverted));
    }
    constructor(data, inverted = false){
        super(), this.data = data, this.inverted = inverted;
    }
}
(0, $cO9ey.Step).jsonID($575ee1da6f54eab1$var$stepType, $575ee1da6f54eab1$export$4fd0fe0f65803356);
module.exports["BatchAttrsStep"] = $575ee1da6f54eab1$export$4fd0fe0f65803356;

});

parcelRegister("cAGd7", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $gAARK = parcelRequire("gAARK");


var $gVDfZ = parcelRequire("gVDfZ");


var $lqWNh = parcelRequire("lqWNh");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $2tC8Z = parcelRequire("2tC8Z");


var $jNL69 = parcelRequire("jNL69");


var $grxv4 = parcelRequire("grxv4");


var $31QJ7 = parcelRequire("31QJ7");


var $7dSFG = parcelRequire("7dSFG");


var $aR6HD = parcelRequire("aR6HD");

const $d6fdd0133bad61e4$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};
const $d6fdd0133bad61e4$var$getSelectedMediaContainerNodeAttrs = (mediaPluginState)=>{
    const selectedNode = mediaPluginState.selectedMediaContainerNode?.();
    if (selectedNode && selectedNode.attrs) return selectedNode.attrs;
    return null;
};
const $d6fdd0133bad61e4$export$a5d2856f3da2ba87 = (selectedMediaContainerNode)=>{
    const selectedNode = selectedMediaContainerNode?.();
    if (selectedNode) switch(selectedNode.type.name){
        case 'mediaSingle':
            {
                const childNode = selectedNode.firstChild;
                return childNode?.attrs;
            }
        default:
            return selectedNode.attrs;
    }
    return null;
};
const $d6fdd0133bad61e4$export$33674170711ec257 = (mediaPluginState)=>{
    return $d6fdd0133bad61e4$export$a5d2856f3da2ba87(mediaPluginState.selectedMediaContainerNode);
};
const $d6fdd0133bad61e4$export$de36002be6360c60 = (mediaPluginState)=>{
    const enforceMediaDataSecurityPolicy = mediaPluginState?.mediaClientConfig?.enforceDataSecurityPolicy;
    return typeof enforceMediaDataSecurityPolicy === 'boolean' ? enforceMediaDataSecurityPolicy : false;
};
const $d6fdd0133bad61e4$export$e8f97a24a74eb5e0 = async (mediaPluginState, isViewMode)=>{
    try {
        const selectedNodeAttrs = isViewMode ? $d6fdd0133bad61e4$export$33674170711ec257(mediaPluginState) : $d6fdd0133bad61e4$var$getSelectedMediaContainerNodeAttrs(mediaPluginState);
        if (selectedNodeAttrs && mediaPluginState.mediaClientConfig && !$d6fdd0133bad61e4$export$c8d0f9dbb5a183eb(selectedNodeAttrs)) {
            const { id: id, collection: collection = '' } = selectedNodeAttrs;
            const mediaClient = (0, $grxv4.getMediaClient)(mediaPluginState.mediaClientConfig);
            const fileState = await mediaClient.file.getCurrentState(id, {
                collectionName: collection
            });
            const fileName = fileState.status === 'error' ? undefined : fileState.name;
            mediaClient.file.downloadBinary(id, fileName, collection);
        }
        return true;
    } catch (err) {
        return false;
    }
};
const $d6fdd0133bad61e4$export$83833694bbefe84a = (state)=>{
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const mediaGroupParent = (0, $8m4tT.findParentNodeOfType)(mediaGroup)(state.selection);
    let tr = state.tr;
    // If it is the last media group in filmstrip, remove the entire filmstrip
    if (mediaGroupParent && mediaGroupParent.node.childCount === 1) tr = (0, $8m4tT.removeParentNodeOfType)(mediaGroup)(tr);
    else tr = (0, $8m4tT.removeSelectedNode)(tr);
    return tr;
};
const $d6fdd0133bad61e4$export$3b6a8a992fa2a6d6 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(mediaSingle)(state.selection) || (0, $8m4tT.findParentNodeOfType)(mediaSingle)(state.selection);
};
const $d6fdd0133bad61e4$export$5b609aa7c383235 = (0, $2XqLN.default)((editorView, pos, mediaWidth)=>{
    const domNode = editorView.nodeDOM(pos);
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return mediaWidth;
});
const $d6fdd0133bad61e4$export$62003b26b3b70d62 = (width, layout, contentWidth, fullWidthMode = false, isNested = false)=>{
    const isWrappedLayout = (0, $gAARK.wrappedLayouts).indexOf(layout) > -1;
    //See flowchart for layout logic: https://hello.atlassian.net/wiki/spaces/TWPCP/whiteboard/2969594044
    if (width >= (0, $aFUXX.akEditorFullWidthLayoutWidth)) // If width is greater than or equal to full editor width
    return 'full-width';
    if (fullWidthMode) // If under editor full width mode
    return isWrappedLayout ? layout : 'center';
    if (width > contentWidth && !isNested) // If width is greater than content length and not nested
    return 'wide';
    return isNested || isWrappedLayout && width !== contentWidth ? layout : 'center';
};
let $d6fdd0133bad61e4$var$maxToolbarFitWidth = 0;
const $d6fdd0133bad61e4$export$6bd6107b1c4a8338 = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="Media floating controls"]`);
    const toolbarWidth = toolbar?.getBoundingClientRect().width;
    if (!toolbar) $d6fdd0133bad61e4$var$maxToolbarFitWidth = 0;
    if (toolbarWidth && toolbarWidth > $d6fdd0133bad61e4$var$maxToolbarFitWidth) $d6fdd0133bad61e4$var$maxToolbarFitWidth = toolbarWidth;
    return $d6fdd0133bad61e4$var$maxToolbarFitWidth;
};
const $d6fdd0133bad61e4$export$247dbed7311e99c7 = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $lqWNh.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $d6fdd0133bad61e4$export$e9cd793e76f25514 = (mediaSingleNode)=>{
    if (mediaSingleNode) {
        const mediaNode = mediaSingleNode.content.firstChild;
        return mediaNode && !(0, $7dSFG.isVideo)(mediaNode.attrs.__fileMimeType);
    }
    return false;
};
const $d6fdd0133bad61e4$export$e13ccac5f0484027 = (items)=>{
    const lastItem = items.at(-1);
    if (lastItem?.type === 'separator') lastItem.fullHeight = true;
    else if (items.length) items.push({
        type: 'separator',
        fullHeight: true
    });
};
const $d6fdd0133bad61e4$export$cf30b16cfb070b4a = (nodeType, intl, pluginInjectionApi, hasCaption = false)=>{
    const mediaInlineImageTitle = intl.formatMessage((0, $gVDfZ.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $gVDfZ.toolbarMessages).changeToMediaSingle);
    const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $gVDfZ.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $gVDfZ.toolbarMessages).changeToMediaInlineImage);
    const InlineIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2tC8Z))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const BlockIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jNL69))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const dropdownConfig = {
        inline: {
            handleInlineButtonClick: ()=>{
                return true;
            },
            handleBlockButtonClick: (0, $aR6HD.changeMediaInlineToMediaSingle)(pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.width.sharedState.currentState()),
            id: 'media-inline-to-block-toolbar-item',
            icon: InlineIcon
        },
        block: {
            handleInlineButtonClick: (0, $aR6HD.changeMediaSingleToMediaInline)(pluginInjectionApi?.analytics?.actions),
            handleBlockButtonClick: ()=>{
                return true;
            },
            id: 'media-block-to-inline-toolbar-item',
            icon: BlockIcon
        }
    };
    const options = [
        {
            id: 'editor.media.convert.mediainline',
            title: mediaInlineImageTitle,
            onClick: dropdownConfig[nodeType].handleInlineButtonClick,
            selected: nodeType === 'inline',
            icon: /*#__PURE__*/ (0, $l998X.jsx)(InlineIcon, {}),
            tooltip: hasCaption ? inlineSwitcherTitle : undefined
        },
        {
            id: 'editor.media.convert.mediasingle',
            title: mediaSingleTitle,
            onClick: dropdownConfig[nodeType].handleBlockButtonClick,
            selected: nodeType === 'block',
            icon: /*#__PURE__*/ (0, $l998X.jsx)(BlockIcon, {})
        }
    ];
    return {
        id: dropdownConfig[nodeType].id,
        testId: 'media-inline-to-block-dropdown',
        title: intl.formatMessage((0, $31QJ7.messages).sizeOptions),
        type: 'dropdown',
        options: options,
        icon: dropdownConfig[nodeType].icon
    };
};
module.exports["isExternalMedia"] = $d6fdd0133bad61e4$export$c8d0f9dbb5a183eb;
module.exports["getSelectedNearestMediaContainerNodeAttrsFunction"] = $d6fdd0133bad61e4$export$a5d2856f3da2ba87;
module.exports["getSelectedNearestMediaContainerNodeAttrs"] = $d6fdd0133bad61e4$export$33674170711ec257;
module.exports["getIsDownloadDisabledByDataSecurityPolicy"] = $d6fdd0133bad61e4$export$de36002be6360c60;
module.exports["downloadMedia"] = $d6fdd0133bad61e4$export$e8f97a24a74eb5e0;
module.exports["removeMediaGroupNode"] = $d6fdd0133bad61e4$export$83833694bbefe84a;
module.exports["getSelectedMediaSingle"] = $d6fdd0133bad61e4$export$3b6a8a992fa2a6d6;
module.exports["getPixelWidthOfElement"] = $d6fdd0133bad61e4$export$5b609aa7c383235;
module.exports["calcNewLayout"] = $d6fdd0133bad61e4$export$62003b26b3b70d62;
module.exports["getMaxToolbarWidth"] = $d6fdd0133bad61e4$export$6bd6107b1c4a8338;
module.exports["getSelectedLayoutIcon"] = $d6fdd0133bad61e4$export$247dbed7311e99c7;
module.exports["canShowSwitchButtons"] = $d6fdd0133bad61e4$export$e9cd793e76f25514;
module.exports["updateToFullHeightSeparator"] = $d6fdd0133bad61e4$export$e13ccac5f0484027;
module.exports["getMediaSingleAndMediaInlineSwitcherDropdown"] = $d6fdd0133bad61e4$export$cf30b16cfb070b4a;

});

parcelRegister("9bkD0", function(module, exports) {
const $9a4473017cd39c26$export$fb85bc5d6d9ef19b = (type)=>{
    return !!type && (type.indexOf('image/') > -1 || type.indexOf('video/') > -1 || type === 'image');
};
const $9a4473017cd39c26$export$ac5608bbe92d6fdc = (fileType)=>{
    return !!fileType && fileType.includes('video/');
};
module.exports["isImage"] = $9a4473017cd39c26$export$fb85bc5d6d9ef19b;
module.exports["isVideo"] = $9a4473017cd39c26$export$ac5608bbe92d6fdc;

});

parcelRegister("bLrKs", function(module, exports) {

let $89099bb9231f6068$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $89099bb9231f6068$var$load("8j9XC"),
    $89099bb9231f6068$var$load("f35QR"),
    $89099bb9231f6068$var$load("eVYW1"),
    $89099bb9231f6068$var$load("ls0Um"),
    $89099bb9231f6068$var$load("020xd"),
    $89099bb9231f6068$var$load("eTBsW"),
    $89099bb9231f6068$var$load("bYxCZ"),
    $89099bb9231f6068$var$load("6HBYC"),
    $89099bb9231f6068$var$load("eDqo1"),
    $89099bb9231f6068$var$load("lxiFd"),
    $89099bb9231f6068$var$load("1oiJ6"),
    $89099bb9231f6068$var$load("huUvS"),
    $89099bb9231f6068$var$load("9oODd"),
    $89099bb9231f6068$var$load("fsikk"),
    $89099bb9231f6068$var$load("6vhrJ"),
    $89099bb9231f6068$var$load("fxC6e"),
    $89099bb9231f6068$var$load("7EorR"),
    $89099bb9231f6068$var$load("bZI8l")
]).then(()=>parcelRequire('avlz5'));

});

parcelRegister("iOEjY", function(module, exports) {

let $db2c2c741befac9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db2c2c741befac9d$var$load("87xQF"),
    $db2c2c741befac9d$var$load("aQsXG"),
    $db2c2c741befac9d$var$load("5QoON"),
    $db2c2c741befac9d$var$load("5A9du"),
    $db2c2c741befac9d$var$load("8j9XC"),
    $db2c2c741befac9d$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("lNIRv", function(module, exports) {

let $fdf0f93b7660f10a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fdf0f93b7660f10a$var$load("8j9XC"),
    $fdf0f93b7660f10a$var$load("f35QR"),
    $fdf0f93b7660f10a$var$load("eVYW1"),
    $fdf0f93b7660f10a$var$load("ls0Um"),
    $fdf0f93b7660f10a$var$load("020xd"),
    $fdf0f93b7660f10a$var$load("eTBsW"),
    $fdf0f93b7660f10a$var$load("bYxCZ"),
    $fdf0f93b7660f10a$var$load("6HBYC"),
    $fdf0f93b7660f10a$var$load("eDqo1"),
    $fdf0f93b7660f10a$var$load("lxiFd"),
    $fdf0f93b7660f10a$var$load("1oiJ6"),
    $fdf0f93b7660f10a$var$load("huUvS"),
    $fdf0f93b7660f10a$var$load("dT77m"),
    $fdf0f93b7660f10a$var$load("6vhrJ"),
    $fdf0f93b7660f10a$var$load("fxC6e"),
    $fdf0f93b7660f10a$var$load("9KJWc")
]).then(()=>parcelRequire('gVDaR'));

});

parcelRegister("c6AnB", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $7NoXb = parcelRequire("7NoXb");


var $cAGd7 = parcelRequire("cAGd7");

const $63f0ba53674530da$var$getIdentifier = (attrs)=>{
    if ((0, $cAGd7.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $63f0ba53674530da$export$d852d5f849a8df8d = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, items: items = [] })=>{
    const identifier = $63f0ba53674530da$var$getIdentifier(selectedNodeAttrs);
    const collectionName = (0, $cAGd7.isExternalMedia)(selectedNodeAttrs) ? '' : selectedNodeAttrs.collection;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $l998X.jsx)((0, $7NoXb.default), {
        collectionName: collectionName,
        items: items,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        mediaClientConfig: mediaClientConfig,
        selectedItem: identifier,
        onClose: onClose
    }), document.body);
};
module.exports["RenderMediaViewer"] = $63f0ba53674530da$export$d852d5f849a8df8d;

});

parcelRegister("2U68K", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $ks2lK = parcelRequire("ks2lK");

const $c9f6e98abd492632$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('mediaInsertPlugin');


const $1945e0e8fce84b29$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $1945e0e8fce84b29$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $1945e0e8fce84b29$var$setPopupMeta = ({ type: type, tr: tr, mountInfo: mountInfo })=>tr.setMeta((0, $c9f6e98abd492632$export$18d4026d1ea86bb1), {
        type: type,
        mountInfo: mountInfo
    });
const $1945e0e8fce84b29$export$3e81af3e1bf8bdd1 = (tr, mountInfo)=>{
    return $1945e0e8fce84b29$var$setPopupMeta({
        type: $1945e0e8fce84b29$export$f766031ad28e12e3,
        mountInfo: mountInfo,
        tr: tr
    });
};
const $1945e0e8fce84b29$export$e89adf8af9d31a9f = (tr)=>{
    return $1945e0e8fce84b29$var$setPopupMeta({
        type: $1945e0e8fce84b29$export$1be3e111c71a5c61,
        tr: tr
    });
};



var $1S4f7 = parcelRequire("1S4f7");



const $675eed2d2d5327ca$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    mountInfo: undefined
                };
            },
            apply (tr, mediaInsertPluginState) {
                const meta = tr.getMeta((0, $c9f6e98abd492632$export$18d4026d1ea86bb1));
                switch(meta?.type){
                    case 0, $1945e0e8fce84b29$export$f766031ad28e12e3:
                        return {
                            isOpen: true,
                            mountInfo: meta.mountInfo
                        };
                    case 0, $1945e0e8fce84b29$export$1be3e111c71a5c61:
                        return {
                            isOpen: false
                        };
                    default:
                        return mediaInsertPluginState;
                }
            }
        },
        key: (0, $c9f6e98abd492632$export$18d4026d1ea86bb1)
    });
};






parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");





var $kuh1P = parcelRequire("kuh1P");


var $eiA8Z = parcelRequire("eiA8Z");


var $b0RMS = parcelRequire("b0RMS");


var $g6sXu = parcelRequire("g6sXu");

var $jwWgu = parcelRequire("jwWgu");


var $aFUXX = parcelRequire("aFUXX");


var $gdv5Z = parcelRequire("gdv5Z");


var $4A7Gn = parcelRequire("4A7Gn");

var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");

var $k0WY4 = parcelRequire("k0WY4");


var $42omo = parcelRequire("42omo");

const $6d272c0f3c3eb410$export$97a7acd021cf4e6b = ({ editorView: editorView })=>{
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use setTimeout to run this async after the call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    return focusEditor;
};





const $18c24cf1fe4cba73$export$51343998e6e270fe = ()=>{
    const autofocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const positionRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((position)=>{
        if (positionRef.current === null) // Initial position is _always incorrect, so the first time this is set
        // we're going to ignore it.
        positionRef.current = position;
        else if (positionRef.current !== position) {
            // If it isn't the first position and it has changed, we're likely in
            // the actual position we want. We'll call focus and update the position.
            autofocusRef.current?.focus();
            positionRef.current = position;
        }
        // Important to return this as the popup uses the returned position
        return position;
    }, [
        autofocusRef
    ]);
    /**
	 * If we don't clear the ref, then reopening the media picker will
	 * not correctly focus the button.
	 *
	 * WARNING: If the component re-renders the ref will be cleared and
	 * the button will be focused again.
	 *
	 * This is a trade-off, we prefer that the button is correctly focused
	 * if the media picker is re-opened, rather than re-focusing the button
	 * if the component re-renders/ the browser window is resized.
	 *
	 * This is a temporary solution until we can find a better way to do it.
	 */ (0, $42omo.useEffect)(()=>{
        return ()=>{
            positionRef.current = null;
        };
    });
    return {
        autofocusRef: autofocusRef,
        onPositionCalculated: onPositionCalculated
    };
};












var $ccHMk = parcelRequire("ccHMk");








var $hw7wB = parcelRequire("hw7wB");


var $10CSJ = parcelRequire("10CSJ");


var $eyWa4 = parcelRequire("eyWa4");


var $aoVih = parcelRequire("aoVih");







function $3d58037b9f8fe495$export$5bf35293e545f20c(dispatchAnalyticsEvent) {
    const onUploadButtonClickedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadCommencedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).UPLOAD_COMMENCED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadSuccessAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).UPLOAD_SUCCEEDED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadFailureAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((reason, mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).UPLOAD_FAILED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                reason: reason,
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics,
            onUploadCommencedAnalytics: onUploadCommencedAnalytics,
            onUploadSuccessAnalytics: onUploadSuccessAnalytics,
            onUploadFailureAnalytics: onUploadFailureAnalytics
        }), [
        onUploadButtonClickedAnalytics,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
}


const $c89ddf9b5504702c$var$INITIAL_UPLOAD_STATE = Object.freeze({
    isOpen: false,
    error: null
});
const $c89ddf9b5504702c$var$uploadReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...$c89ddf9b5504702c$var$INITIAL_UPLOAD_STATE,
                isOpen: true
            };
        case 'close':
            // This is the only case where we don't reset state. This is because
            // onClose gets called for cancel _and_ upload, so we don't want to
            // reset any loading or error states that may have occured
            return {
                ...state,
                isOpen: false
            };
        case 'error':
            return {
                ...$c89ddf9b5504702c$var$INITIAL_UPLOAD_STATE,
                error: action.error
            };
        case 'reset':
            return $c89ddf9b5504702c$var$INITIAL_UPLOAD_STATE;
    }
};
const $c89ddf9b5504702c$var$isImagePreview = (preview)=>{
    return 'dimensions' in preview;
};
const $c89ddf9b5504702c$export$72542eb1d24a31e0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertFile: insertFile }, ref)=>{
    const intl = (0, $8C5kA.default)();
    const strings = {
        upload: intl.formatMessage((0, $b0RMS.mediaInsertMessages).upload),
        networkError: intl.formatMessage((0, $b0RMS.mediaInsertMessages).localFileNetworkErrorMessage),
        genericError: intl.formatMessage((0, $b0RMS.mediaInsertMessages).localFileErrorMessage)
    };
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $3d58037b9f8fe495$export$5bf35293e545f20c)(dispatchAnalyticsEvent);
    const [uploadState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer($c89ddf9b5504702c$var$uploadReducer, $c89ddf9b5504702c$var$INITIAL_UPLOAD_STATE);
    const erroredFileIds = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(new Set())[0];
    // This is a bit horrendous. Fundementally though, `insertFile` takes a
    // callback that can ask for us to add listeners to any and all of the
    // `Browser` events for each file uplaoded. We add a track those in a
    // ref, call the CBs so the media-plugin can do it's thing, and then
    // remove all listeners `onEnd`.
    const eventSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    const onStateChanged = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((fileId)=>(cb)=>{
            eventSubscribers.current = {
                ...eventSubscribers.current,
                [fileId]: [
                    ...eventSubscribers.current?.[fileId] ?? [],
                    cb
                ]
            };
        }, []);
    const onPreviewUpdate = ({ file: file, preview: preview })=>{
        onUploadSuccessAnalytics('local');
        const isErroredFile = erroredFileIds.has(file.id);
        const { dimensions: dimensions, scaleFactor: scaleFactor } = $c89ddf9b5504702c$var$isImagePreview(preview) ? preview : {
            dimensions: undefined,
            scaleFactor: undefined
        };
        const mediaState = {
            id: file.id,
            collection: mediaProvider.uploadParams?.collection,
            fileMimeType: file.type,
            fileSize: file.size,
            fileName: file.name,
            dimensions: dimensions,
            scaleFactor: scaleFactor,
            status: isErroredFile ? 'error' : undefined
        };
        insertFile({
            mediaState: mediaState,
            inputMethod: (0, $d925B.INPUT_METHOD).MEDIA_PICKER,
            onMediaStateChanged: onStateChanged(file.id)
        });
        closeMediaInsertPicker();
        // Probably not needed but I guess it _could_ fail to close for some reason
        dispatch({
            type: 'reset'
        });
    };
    const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = mediaProvider;
    const onEnd = (0, $42omo.useCallback)((payload)=>{
        eventSubscribers.current?.[payload.file.id]?.forEach((cb)=>cb({
                id: payload.file.id,
                status: 'ready'
            }));
        delete eventSubscribers.current?.[payload.file.id];
    }, []);
    const onError = (0, $42omo.useCallback)(({ error: error, fileId: fileId })=>{
        // Dispatch the error events
        onUploadFailureAnalytics(error.name, 'local');
        dispatch({
            type: 'error',
            error: error.name
        });
        // Update the status of the errored file
        erroredFileIds.add(fileId);
        // Update and remove listeners
        eventSubscribers.current?.[fileId]?.forEach((cb)=>cb({
                id: fileId,
                status: 'error',
                error: error
            }));
        delete eventSubscribers.current?.[fileId];
    }, [
        erroredFileIds,
        onUploadFailureAnalytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        grow: "fill",
        space: "space.200",
        children: [
            uploadState.error && /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                appearance: "error",
                children: uploadState.error === 'upload_fail' ? strings.networkError : strings.genericError
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                id: "local-media-upload-button",
                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
                        label: ""
                    }),
                ref: ref,
                shouldFitContainer: true,
                isDisabled: !uploadMediaClientConfig || !uploadParams,
                onClick: ()=>{
                    onUploadButtonClickedAnalytics();
                    dispatch({
                        type: 'open'
                    });
                },
                children: strings.upload
            }),
            uploadMediaClientConfig && uploadParams && /*#__PURE__*/ (0, $l998X.jsx)((0, $10CSJ.BrowserLoader), {
                isOpen: uploadState.isOpen,
                config: {
                    uploadParams: uploadParams,
                    multiple: true
                },
                mediaClientConfig: uploadMediaClientConfig,
                onUploadsStart: ()=>onUploadCommencedAnalytics('local'),
                onPreviewUpdate: onPreviewUpdate,
                onEnd: onEnd,
                // NOTE: this will fire for some errors like network failures, but not
                // for others like empty files. Those have their own feedback toast
                // owned by media.
                onError: onError,
                onClose: ()=>{
                    erroredFileIds.clear();
                    dispatch({
                        type: 'close'
                    });
                }
            })
        ]
    });
});












var $81OAa = parcelRequire("81OAa");


var $hArLp = parcelRequire("hArLp");











var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $dn4ZF = parcelRequire("dn4ZF");


var $lOzEN = parcelRequire("lOzEN");


var $grxv4 = parcelRequire("grxv4");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");





var $4noo5 = parcelRequire("4noo5");














var $1BiXn = parcelRequire("1BiXn");

var $9s7Po = parcelRequire("9s7Po");

const $eb5b811ff5121f7a$var$maxDimensions = {
    width: '100%',
    height: '100%'
};
const $eb5b811ff5121f7a$export$a6543a2e3828db2c = ({ attrs: attrs, mediaProvider: mediaProvider })=>{
    const intl = (0, $8C5kA.default)();
    const mediaAlt = intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaAlt);
    const dimensions = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            width: attrs.dimensions.width,
            height: attrs.dimensions.height
        };
    }, [
        attrs.dimensions.width,
        attrs.dimensions.height
    ]);
    const identifier = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            id: attrs.id,
            mediaItemType: 'file',
            collectionName: attrs.collection
        }), [
        attrs.collection,
        attrs.id
    ]);
    if (!mediaProvider) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
        dimensions: dimensions,
        interactionName: "editor-media-insert-card-loading"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1BiXn.default), {
        mediaClientConfig: mediaProvider.viewMediaClientConfig,
        resizeMode: "stretchy-fit",
        dimensions: $eb5b811ff5121f7a$var$maxDimensions,
        originalDimensions: dimensions,
        identifier: identifier,
        alt: mediaAlt,
        disableOverlay: true
    });
};



const $725c8a9665811553$var$PreviewBoxStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'dashed',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    height: '200px'
});
const $725c8a9665811553$var$PreviewImageStyles = (0, $ecnYn.xcss)({
    height: '200px'
});
const $725c8a9665811553$var$FormStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $725c8a9665811553$var$INITIAL_PREVIEW_STATE = Object.freeze({
    isLoading: false,
    error: null,
    warning: null,
    previewInfo: null
});
const $725c8a9665811553$var$isValidInput = (value, customizedUrlValidation)=>{
    if (customizedUrlValidation) return customizedUrlValidation(value);
    return $725c8a9665811553$export$bef94a5618bf18bf(value);
};
const $725c8a9665811553$var$MAX_URL_LENGTH = 2048;
const $725c8a9665811553$export$bef94a5618bf18bf = (value)=>{
    try {
        // Check for spaces and length first to avoid the expensive URL parsing
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        if (/\s/.test(value) || value.length > $725c8a9665811553$var$MAX_URL_LENGTH) return false;
        new URL(value);
    } catch (e) {
        return false;
    }
    return (0, $81OAa.isSafeUrl)(value);
};
const $725c8a9665811553$var$previewStateReducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                ...$725c8a9665811553$var$INITIAL_PREVIEW_STATE,
                isLoading: true
            };
        case 'error':
            return {
                ...$725c8a9665811553$var$INITIAL_PREVIEW_STATE,
                error: action.error
            };
        case 'warning':
            return {
                ...$725c8a9665811553$var$INITIAL_PREVIEW_STATE,
                warning: action.warning
            };
        case 'success':
            return {
                ...$725c8a9665811553$var$INITIAL_PREVIEW_STATE,
                previewInfo: action.payload
            };
        case 'reset':
            return $725c8a9665811553$var$INITIAL_PREVIEW_STATE;
        default:
            return state;
    }
};
function $725c8a9665811553$export$903b9b47fa175337({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, isOnlyExternalLinks: isOnlyExternalLinks, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage }) {
    const intl = (0, $8C5kA.default)();
    const strings = {
        loadPreview: intl.formatMessage((0, $b0RMS.mediaInsertMessages).loadPreview),
        insert: intl.formatMessage((0, $b0RMS.mediaInsertMessages).insert),
        pasteLinkToUpload: intl.formatMessage((0, $b0RMS.mediaInsertMessages).pasteLinkToUpload),
        cancel: intl.formatMessage((0, $b0RMS.mediaInsertMessages).cancel),
        errorMessage: intl.formatMessage((0, $b0RMS.mediaInsertMessages).fromUrlErrorMessage),
        warning: intl.formatMessage((0, $b0RMS.mediaInsertMessages).fromUrlWarning),
        invalidUrl: intl.formatMessage((0, $b0RMS.mediaInsertMessages).invalidUrlErrorMessage)
    };
    const [previewState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer($725c8a9665811553$var$previewStateReducer, $725c8a9665811553$var$INITIAL_PREVIEW_STATE);
    const [input, setInput] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState('');
    const pasteFlag = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $3d58037b9f8fe495$export$5bf35293e545f20c)(dispatchAnalyticsEvent);
    const uploadExternalMedia = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (url)=>{
        onUploadButtonClickedAnalytics();
        dispatch({
            type: 'loading'
        });
        const { uploadMediaClientConfig: uploadMediaClientConfig, uploadParams: uploadParams } = mediaProvider;
        if (!uploadMediaClientConfig) return;
        const mediaClient = (0, $grxv4.getMediaClient)(uploadMediaClientConfig);
        const collection = uploadParams?.collection;
        onUploadCommencedAnalytics('url');
        try {
            const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions, mimeType: mimeType } = await mediaClient.file.uploadExternal(url, collection);
            onUploadSuccessAnalytics('url');
            dispatch({
                type: 'success',
                payload: {
                    id: uploadableFileUpfrontIds.id,
                    collection: collection,
                    dimensions: dimensions,
                    occurrenceKey: uploadableFileUpfrontIds.occurrenceKey,
                    fileMimeType: mimeType
                }
            });
        } catch (e) {
            if (typeof e === 'string' && e === 'Could not download remote file') {
                // TODO: ED-26962 - Make sure this gets good unit test coverage with the actual media plugin.
                // This hard coded error message could be changed at any
                // point and we need a unit test to break to stop people changing it.
                onUploadFailureAnalytics(e, 'url');
                dispatch({
                    type: 'warning',
                    warning: e,
                    url: url
                });
            } else if (e instanceof Error) {
                const message = 'Image preview fetch failed';
                onUploadFailureAnalytics(message, 'url');
                dispatch({
                    type: 'error',
                    error: message
                });
            } else {
                onUploadFailureAnalytics('Unknown error', 'url');
                dispatch({
                    type: 'error',
                    error: 'Unknown error'
                });
            }
        }
    }, [
        onUploadButtonClickedAnalytics,
        mediaProvider,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
    const onURLChange = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        const url = e.currentTarget.value;
        dispatch({
            type: 'reset'
        });
        setInput(url);
        if (!$725c8a9665811553$var$isValidInput(url, customizedUrlValidation)) return;
        if (pasteFlag.current) {
            pasteFlag.current = false;
            if (!isOnlyExternalLinks) uploadExternalMedia(url);
        }
    }, [
        uploadExternalMedia,
        isOnlyExternalLinks,
        customizedUrlValidation
    ]);
    const onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e, inputUrl)=>{
        // Note: this is a little weird, but the paste event will always be
        // fired before the change event when pasting. We don't really want to
        // duplicate logic by handling pastes separately to changes, so we're
        // just noting paste occurred to then be handled in the onURLChange fn
        // above. The one exception to this is where paste inputs exactly what was
        // already in the input, in which case we want to ignore it.
        if (e.clipboardData.getData('text') !== inputUrl) pasteFlag.current = true;
    }, []);
    const onInsert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (previewState.previewInfo) insertMediaSingle({
            mediaState: previewState.previewInfo,
            inputMethod: (0, $d925B.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertMediaSingle,
        previewState.previewInfo
    ]);
    const onExternalInsert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((url)=>{
        if (previewState.warning || isOnlyExternalLinks) insertExternalMediaSingle({
            url: url,
            alt: '',
            inputMethod: (0, $d925B.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertExternalMediaSingle,
        previewState.warning,
        isOnlyExternalLinks
    ]);
    const onInputKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (event && event.key === 'Esc') {
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $d925B.ACTION).CLOSED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: (0, $d925B.INPUT_METHOD).KEYBOARD
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
        }
    }, [
        dispatchAnalyticsEvent,
        closeMediaInsertPicker
    ]);
    const onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).CANCELLED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            dispatchAnalyticsEvent(payload);
        }
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
        onSubmit: ({ inputUrl: inputUrl }, form)=>{
            // This can be triggered from an enter key event on the input even when
            // the button is disabled, so we explicitly do nothing when in loading
            // state.
            if (previewState.isLoading || form.getState().invalid) return;
            if (previewState.previewInfo) return onInsert();
            if (previewState.warning || isOnlyExternalLinks) return onExternalInsert(inputUrl);
            return uploadExternalMedia(inputUrl);
        },
        children: ({ formProps: formProps })=>// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $725c8a9665811553$var$FormStyles,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.150",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                            isRequired: true,
                            name: "inputUrl",
                            validate: (value)=>value && $725c8a9665811553$var$isValidInput(value, customizedUrlValidation) ? undefined : strings.invalidUrl,
                            children: ({ fieldProps: { value: value, onChange: onChange, ...rest }, error: error, meta: meta })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                                    space: "space.150",
                                    grow: "fill",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                                    ...rest,
                                                    value: value,
                                                    "aria-label": (0, $dh538.fg)('platform_editor_nov_a11y_fixes') ? strings.pasteLinkToUpload : undefined,
                                                    placeholder: strings.pasteLinkToUpload,
                                                    maxLength: $725c8a9665811553$var$MAX_URL_LENGTH,
                                                    onKeyPress: onInputKeyPress,
                                                    onPaste: (event)=>onPaste(event, value),
                                                    onChange: (value)=>{
                                                        onURLChange(value);
                                                        onChange(value);
                                                    },
                                                    onKeyDown: (e)=>{
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            formProps.onSubmit();
                                                        }
                                                    }
                                                }),
                                                customizedHelperMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                                                        children: customizedHelperMessage
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.MessageWrapper), {
                                                    children: error && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                            as: "span",
                                                            children: error
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        !previewState.previewInfo && !previewState.error && !previewState.warning && !isOnlyExternalLinks && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                            xcss: $725c8a9665811553$var$PreviewBoxStyles,
                                            alignItems: "center",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                type: "button",
                                                onClick: ()=>formProps.onSubmit(),
                                                isLoading: previewState.isLoading,
                                                isDisabled: !!error || !meta.dirty,
                                                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
                                                        label: ""
                                                    }),
                                                children: strings.loadPreview
                                            })
                                        })
                                    ]
                                })
                        }),
                        previewState.previewInfo && /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                            alignInline: "center",
                            alignBlock: "center",
                            xcss: $725c8a9665811553$var$PreviewImageStyles,
                            space: "space.200",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eb5b811ff5121f7a$export$a6543a2e3828db2c), {
                                attrs: previewState.previewInfo,
                                mediaProvider: mediaProvider
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gQhRa.MessageWrapper), {
                            children: [
                                previewState.error && /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                    appearance: "error",
                                    children: strings.errorMessage
                                }),
                                previewState.warning && /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                    appearance: "warning",
                                    children: strings.warning
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dn4ZF.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hArLp.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: strings.cancel
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        type: "button",
                                        appearance: "primary",
                                        isDisabled: isOnlyExternalLinks ? !input || !$725c8a9665811553$var$isValidInput(input, customizedUrlValidation) : !previewState.previewInfo && !previewState.warning,
                                        onClick: ()=>formProps.onSubmit(),
                                        children: strings.insert
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
}













const $6740051163476303$var$styles = (0, $ecnYn.xcss)({
    /* Reset inherited styles from toolbar */ whiteSpace: 'initial',
    textAlign: 'initial',
    boxShadow: 'elevation.shadow.overflow',
    width: '340px',
    padding: 'space.200',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay'
});
const $6740051163476303$export$d01f0fa2ebc904b8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ref: ref,
        xcss: $6740051163476303$var$styles,
        children: children
    });
});


const $85e0a32478fee0ec$var$PopupWithListeners = (0, $g6sXu.default)((0, $jwWgu.default));
/**
 * A custom TabPanel that is non-focusable.
 */ const $85e0a32478fee0ec$var$CustomTabPanel = ({ children: children })=>{
    const tabPanelAttributes = (0, $k0WY4.useTabPanel)();
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingBlockEnd: "space.150",
        ...tabPanelAttributes,
        tabIndex: -1,
        children: children
    }));
};
const $85e0a32478fee0ec$export$6a978a6c0eb24e84 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, insertFile: insertFile, isOnlyExternalLinks: isOnlyExternalLinks = false, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage })=>{
    const { mediaProvider: mediaProvider, isOpen: isOpen, mountInfo: mountInfo } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media',
        'mediaInsert'
    ], (states)=>({
            mediaProvider: states.mediaState?.mediaProvider,
            isOpen: states.mediaInsertState?.isOpen,
            mountInfo: states.mediaInsertState?.mountInfo
        }));
    let targetRef;
    let mountPoint;
    if (mountInfo) {
        targetRef = mountInfo.ref;
        mountPoint = mountInfo.mountPoint;
    } else {
        // If targetRef is undefined, target the selection in the editor
        targetRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_MEDIA, api?.analytics?.actions);
        mountPoint = popupsMountPoint;
    }
    const intl = (0, $8C5kA.default)();
    const focusEditor = (0, $6d272c0f3c3eb410$export$97a7acd021cf4e6b)({
        editorView: editorView
    });
    const { autofocusRef: autofocusRef, onPositionCalculated: onPositionCalculated } = (0, $18c24cf1fe4cba73$export$51343998e6e270fe)();
    if (!isOpen || !mediaProvider) return null;
    const handleClose = (exitMethod)=>(event)=>{
            event.preventDefault();
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $d925B.ACTION).CLOSED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: exitMethod
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
            focusEditor();
        };
    return /*#__PURE__*/ (0, $l998X.jsx)($85e0a32478fee0ec$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaPickerPopupAriaLabel),
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: mountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClose((0, $d925B.INPUT_METHOD).MOUSE),
        handleEscapeKeydown: handleClose((0, $d925B.INPUT_METHOD).KEYBOARD),
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        onPositionCalculated: onPositionCalculated,
        focusTrap: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $g6sXu.PlainOutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6740051163476303$export$d01f0fa2ebc904b8), {
                    ref: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4A7Gn.default), {
                        id: "media-insert-tab-navigation",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                paddingBlockEnd: "space.150",
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                                    children: [
                                        !isOnlyExternalLinks && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                            children: intl.formatMessage((0, $b0RMS.mediaInsertMessages).fileTabTitle)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                            children: intl.formatMessage((0, $b0RMS.mediaInsertMessages).linkTabTitle)
                                        })
                                    ]
                                })
                            }),
                            !isOnlyExternalLinks && /*#__PURE__*/ (0, $l998X.jsx)($85e0a32478fee0ec$var$CustomTabPanel, {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c89ddf9b5504702c$export$72542eb1d24a31e0), {
                                    ref: autofocusRef,
                                    mediaProvider: mediaProvider,
                                    closeMediaInsertPicker: ()=>{
                                        closeMediaInsertPicker();
                                        focusEditor();
                                    },
                                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                    insertFile: insertFile
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)($85e0a32478fee0ec$var$CustomTabPanel, {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $725c8a9665811553$export$903b9b47fa175337), {
                                    mediaProvider: mediaProvider,
                                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                    closeMediaInsertPicker: ()=>{
                                        closeMediaInsertPicker();
                                        focusEditor();
                                    },
                                    insertMediaSingle: insertMediaSingle,
                                    insertExternalMediaSingle: insertExternalMediaSingle,
                                    isOnlyExternalLinks: isOnlyExternalLinks,
                                    customizedUrlValidation: customizedUrlValidation,
                                    customizedHelperMessage: customizedHelperMessage
                                })
                            })
                        ]
                    })
                })
        })
    });
};


const $104385baa454f7ff$export$922c51f87f6fe974 = ({ api: api, config: config })=>{
    return {
        name: 'mediaInsert',
        pmPlugins () {
            return [
                {
                    name: 'mediaInsert',
                    plugin: ()=>(0, $675eed2d2d5327ca$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const { isOpen: isOpen, mountInfo: mountInfo } = (0, $c9f6e98abd492632$export$18d4026d1ea86bb1).getState(editorState) || {};
            return {
                isOpen: isOpen,
                mountInfo: mountInfo
            };
        },
        commands: {
            showMediaInsertPopup: (mountInfo)=>({ tr: tr })=>(0, $1945e0e8fce84b29$export$3e81af3e1bf8bdd1)(tr, mountInfo)
        },
        contentComponent: ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            const insertMediaSingle = ({ mediaState: mediaState, inputMethod: inputMethod })=>{
                const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName, collection: collection } = mediaState;
                const { width: width, height: height } = dimensions || {
                    height: undefined,
                    width: undefined
                };
                const scaledWidth = width && Math.round(width / scaleFactor);
                const node = editorView.state.schema.nodes.media.create({
                    id: id,
                    type: 'file',
                    collection: collection,
                    contextId: contextId,
                    width: scaledWidth,
                    height: height && Math.round(height / scaleFactor),
                    alt: fileName,
                    __fileMimeType: mediaState.fileMimeType
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $d925B.INSERT_MEDIA_VIA).EXTERNAL_UPLOAD) ?? false;
            };
            const insertExternalMediaSingle = ({ url: url, alt: alt, inputMethod: inputMethod })=>{
                const node = editorView.state.schema.nodes.media.create({
                    type: 'external',
                    url: url,
                    alt: alt,
                    __external: true
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $d925B.INSERT_MEDIA_VIA).EXTERNAL_URL) ?? false;
            };
            const insertFile = ({ mediaState: mediaState, inputMethod: inputMethod, onMediaStateChanged: onMediaStateChanged })=>{
                const collection = mediaState.collection;
                return collection !== undefined ? api?.media.sharedState.currentState()?.insertFile(mediaState, onMediaStateChanged, inputMethod, (0, $d925B.INSERT_MEDIA_VIA).LOCAL_UPLOAD) ?? false : false;
            };
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $85e0a32478fee0ec$export$6a978a6c0eb24e84), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                closeMediaInsertPicker: ()=>editorView.dispatch((0, $1945e0e8fce84b29$export$e89adf8af9d31a9f)(editorView.state.tr)),
                insertMediaSingle: insertMediaSingle,
                insertExternalMediaSingle: insertExternalMediaSingle,
                insertFile: insertFile,
                isOnlyExternalLinks: config?.isOnlyExternalLinks,
                customizedUrlValidation: config?.customizedUrlValidation,
                customizedHelperMessage: config?.customizedHelperMessage
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'media-insert',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconImages), {}),
                        isDisabledOffline: true,
                        action (insert) {
                            // Insert empty string to remove the typeahead raw text
                            // close the quick insert immediately
                            const tr = insert('');
                            api?.mediaInsert.commands.showMediaInsertPopup()({
                                tr: tr
                            });
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).OPENED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_MEDIA,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["mediaInsertPlugin"] = $104385baa454f7ff$export$922c51f87f6fe974;

});

parcelRegister("8HLyI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jEypY = parcelRequire("jEypY");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $1S4f7 = parcelRequire("1S4f7");


var $l9G9n = parcelRequire("l9G9n");


var $ks2lK = parcelRequire("ks2lK");


var $f8c3d = parcelRequire("f8c3d");




const $9e04eeca38565b10$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('placeholderTextPlugin');


const $db9c80a61f72fa10$export$cf72668e5bda227e = (state, dispatch)=>{
    const tr = state.tr;
    if (!state.selection.empty) tr.deleteSelection();
    tr.setMeta((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), {
        showInsertPanelAt: tr.selection.anchor
    });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
const $db9c80a61f72fa10$export$478f9b36a44ad411 = (value)=>(state, dispatch)=>{
        dispatch(state.tr.replaceSelectionWith(state.schema.nodes.placeholder.createChecked({
            text: value
        })).setMeta((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), {
            showInsertPanelAt: null
        }).scrollIntoView());
        return true;
    };
const $db9c80a61f72fa10$export$722fce80225bc19b = (state, dispatch)=>{
    dispatch(state.tr.setMeta((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), {
        showInsertPanelAt: null
    }));
    return true;
};



var $5SAOw = parcelRequire("5SAOw");





var $ftzrq = parcelRequire("ftzrq");

class $b407e6ea96d05343$export$9f5092f54ccc15c6 {
    map(mapping) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return new $b407e6ea96d05343$export$9f5092f54ccc15c6(mapping.map(this.pos));
    }
    resolve(doc) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const $pos = doc.resolve(this.pos);
        return (0, $ks2lK.Selection).near($pos);
    }
    constructor(pos){
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
}
class $b407e6ea96d05343$export$37936ceed0f40761 extends (0, $ks2lK.Selection) {
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.$head.pos));
        return new $b407e6ea96d05343$export$37936ceed0f40761($pos);
    }
    static content() {
        return (0, $5SAOw.Slice).empty;
    }
    eq(other) {
        return other instanceof $b407e6ea96d05343$export$37936ceed0f40761 && other.head === this.head;
    }
    toJSON() {
        return {
            type: 'Cursor',
            pos: this.head
        };
    }
    static fromJSON(doc, json) {
        return new $b407e6ea96d05343$export$37936ceed0f40761(doc.resolve(json.pos));
    }
    getBookmark() {
        return new $b407e6ea96d05343$export$9f5092f54ccc15c6(this.anchor);
    }
    constructor($pos){
        super($pos, $pos);
    }
}
(0, $ks2lK.Selection).jsonID('fake-text-cursor', $b407e6ea96d05343$export$37936ceed0f40761);
const $b407e6ea96d05343$export$b8cf92335d1aa4be = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection.empty) {
        const { selection: { $from: $from } } = state;
        dispatch(state.tr.setSelection(new $b407e6ea96d05343$export$37936ceed0f40761($from)));
    }
};
const $b407e6ea96d05343$export$b0a69583d8930ac5 = (state, dispatch)=>{
    if (state.selection instanceof $b407e6ea96d05343$export$37936ceed0f40761) {
        const { $from: $from } = state.selection;
        dispatch(state.tr.setSelection(new (0, $ks2lK.TextSelection)($from)));
    }
};
const $b407e6ea96d05343$export$e3d497d0280bbada = (state)=>{
    if (!(state.selection instanceof $b407e6ea96d05343$export$37936ceed0f40761)) return null;
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $ftzrq.DecorationSet).create(state.doc, [
        (0, $ftzrq.Decoration).widget(state.selection.head, node, {
            key: 'Cursor'
        })
    ]);
};



var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");





var $1oCLl = parcelRequire("1oCLl");

const $d895e3167962be91$var$serializePlaceholderNode = (node)=>{
    const element = document.createElement('span');
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    element.classList.add('pm-placeholder');
    // the inline node api test suite requires the following class name
    element.classList.add('placeholderView-content-wrap');
    element.innerText = (0, $TfRUG.ZERO_WIDTH_SPACE);
    const elementChildren = document.createElement('span');
    elementChildren.classList.add('pm-placeholder__text');
    elementChildren.dataset.placeholder = node.attrs.text;
    elementChildren.setAttribute('contenteditable', 'false');
    element.appendChild(elementChildren);
    if (browser.safari) element.appendChild(document.createTextNode((0, $TfRUG.ZERO_WIDTH_SPACE)));
    else element.appendChild(document.createElement('wbr'));
    return element;
};
class $d895e3167962be91$export$442d0baedc2512a6 {
    stopEvent(e) {
        if (e.type === 'mousedown' && typeof this.getPos === 'function') {
            e.preventDefault();
            const { view: view } = this;
            const startNodePosition = this.getPos();
            if (typeof startNodePosition !== 'number') return false;
            const tr = view.state.tr;
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(startNodePosition)));
            view.dispatch(tr);
            if (!view.hasFocus()) window.requestAnimationFrame(()=>{
                view.focus();
            });
            return true;
        }
        return false;
    }
    ignoreMutation(record) {
        if (typeof this.getPos !== 'function' || record.type !== 'selection') return true;
        const { view: view, node: node } = this;
        const placeholderStartPosition = this.getPos();
        if (typeof placeholderStartPosition !== 'number') return false;
        const placeholderEndPosition = placeholderStartPosition + node.nodeSize;
        const selection = view.state.selection;
        // when the selection is set right after the placeholder.
        // we should let ProseMirror deal with this edge-case
        if (selection.from === placeholderEndPosition) return false;
        const isSelectionAtPlaceholder = selection.from === placeholderStartPosition;
        const isSelectionAfterlaceholder = selection.from > placeholderEndPosition;
        if (isSelectionAtPlaceholder || isSelectionAfterlaceholder) {
            const tr = view.state.tr;
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(placeholderEndPosition)));
            view.dispatch(tr);
            return true;
        }
        return true;
    }
    constructor(node, view, getPos){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = void 0;
        this.dom = $d895e3167962be91$var$serializePlaceholderNode(this.node);
        this.getPos = getPos;
    }
}






const $0e0568ea62cfecf5$export$fcfa1d7f51efd169 = (selection)=>{
    if (!(selection instanceof (0, $ks2lK.TextSelection)) || !selection.$cursor) return false;
    const node = selection.$cursor.doc.nodeAt(selection.$cursor.pos);
    return node?.type.name === 'placeholder';
};






var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $hdkJi = parcelRequire("hdkJi");


var $8i5w2 = parcelRequire("8i5w2");

/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $jwWgu = parcelRequire("jwWgu");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $6fnsQ = parcelRequire("6fnsQ");

const $6a5bf8d47c81bc2c$export$34e0f9847d4c02dd = (height)=>/*#__PURE__*/ (0, $9K4OG.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $6fnsQ.N50A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        backgroundColor: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? `${height}px` : undefined
    });


function $88b9e0104e05cdd5$export$2e2bcd8739ae039({ children: children, target: target, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight = 40, onPositionCalculated: onPositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, className: className, absoluteOffset: absoluteOffset, alignX: alignX, alignY: alignY, zIndex: zIndex }) {
    if (!target) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        absoluteOffset: absoluteOffset,
        alignX: alignX,
        alignY: alignY,
        target: target,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        offset: offset,
        fitWidth: fitWidth,
        fitHeight: fitHeight,
        onPositionCalculated: onPositionCalculated
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $6a5bf8d47c81bc2c$export$34e0f9847d4c02dd)(fitHeight),
        "data-testid": "popup-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children));
}


const $878291c099908c4c$var$getCursorHeightFrom = (node)=>parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
const $878291c099908c4c$export$5055c4a13011779 = (editorViewDom, popupsMountPoint)=>popupsMountPoint ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
    popupsMountPoint.offsetParent : // eslint-disable-next-line @atlaskit/editor/no-as-casting
    editorViewDom.offsetParent;
const $878291c099908c4c$export$dcb2d1671e2c93d4 = (node)=>// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    node.nodeType === Node.TEXT_NODE ? node.parentNode : node;
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */ const $878291c099908c4c$var$convertFixedCoordinatesToAbsolutePositioning = (coordinates, offsetParent, cursorHeight)=>{
    const { left: offsetParentLeft, top: offsetParentTop, height: offsetParentHeight } = offsetParent.getBoundingClientRect();
    return {
        left: (coordinates.left ?? 0) - offsetParentLeft,
        right: (coordinates.right ?? 0) - offsetParentLeft,
        top: (coordinates.top ?? 0) - (offsetParentTop - cursorHeight) + offsetParent.scrollTop,
        bottom: offsetParentHeight - ((coordinates.top ?? 0) - (offsetParentTop - cursorHeight) - offsetParent.scrollTop)
    };
};
const $878291c099908c4c$export$499dde0ed160b17d = (offsetParent, node, getCurrentFixedCoordinates)=>(position)=>{
        if (!offsetParent) return position;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = $878291c099908c4c$export$dcb2d1671e2c93d4(node);
        const cursorHeight = $878291c099908c4c$var$getCursorHeightFrom(target);
        const fixedCoordinates = getCurrentFixedCoordinates();
        const absoluteCoordinates = $878291c099908c4c$var$convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
        return {
            left: position.left ? absoluteCoordinates.left : undefined,
            right: position.right ? absoluteCoordinates.right : undefined,
            top: position.top ? absoluteCoordinates.top : undefined,
            bottom: position.bottom ? absoluteCoordinates.bottom : undefined
        };
    };


// eslint-disable-next-line @repo/internal/react/no-class-components
class $68f079c09b6123c0$var$PlaceholderFloatingToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { getNodeFromPos: getNodeFromPos, showInsertPanelAt: showInsertPanelAt, editorViewDOM: editorViewDOM, popupsMountPoint: popupsMountPoint, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, popupsBoundariesElement: popupsBoundariesElement, intl: { formatMessage: formatMessage } } = this.props;
        const target = getNodeFromPos(showInsertPanelAt);
        const offsetParent = (0, $878291c099908c4c$export$5055c4a13011779)(editorViewDOM, popupsMountPoint);
        const getFixedCoordinates = ()=>getFixedCoordinatesFromPos(showInsertPanelAt);
        const handlePositionCalculated = (0, $878291c099908c4c$export$499dde0ed160b17d)(offsetParent, target, getFixedCoordinates);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $88b9e0104e05cdd5$export$2e2bcd8739ae039), {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            target: (0, $878291c099908c4c$export$dcb2d1671e2c93d4)(target),
            onPositionCalculated: handlePositionCalculated,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            fitHeight: 32,
            offset: [
                0,
                12
            ],
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8i5w2.default), {
                placeholder: formatMessage((0, $hdkJi.placeholderTextMessages).placeholderTextPlaceholder),
                onSubmit: this.handleSubmit,
                onBlur: this.handleBlur,
                autoFocus: true,
                width: 300
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleSubmit = (value)=>{
            if (value) {
                this.props.insertPlaceholder(value);
                this.props.setFocusInEditor();
            } else this.props.hidePlaceholderFloatingToolbar();
        };
        this.handleBlur = ()=>{
            this.props.hidePlaceholderFloatingToolbar();
        };
    }
}
var $68f079c09b6123c0$export$2e2bcd8739ae039 = (0, $gmMgo.default)($68f079c09b6123c0$var$PlaceholderFloatingToolbar);


const $87eb8bf8ace2e0b7$var$getOpenTypeAhead = (trigger, api)=>{
    const typeAheadHandler = api?.typeAhead?.actions?.findHandlerByTrigger(trigger);
    if (!typeAheadHandler || !typeAheadHandler.id) return null;
    return api?.typeAhead?.actions?.openAtTransaction({
        triggerHandler: typeAheadHandler,
        inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD
    });
};
function $87eb8bf8ace2e0b7$export$ae829ec7b2625219(dispatch, options, api) {
    const allowInserting = !!options.allowInserting;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $9e04eeca38565b10$export$18d4026d1ea86bb1),
        state: {
            init: ()=>({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting
                }),
            apply: (tr, state)=>{
                const meta = tr.getMeta((0, $9e04eeca38565b10$export$18d4026d1ea86bb1));
                if (meta && meta.showInsertPanelAt !== undefined) {
                    const newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting
                    };
                    dispatch((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), newState);
                    return newState;
                } else if (state.showInsertPanelAt) {
                    const newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting
                    };
                    dispatch((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            if (transactions.some((txn)=>txn.docChanged)) {
                const didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter === newState.selection.$head.nodeAfter;
                const adjacentNode = newState.selection.$head.nodeAfter;
                const adjacentNodePos = newState.selection.$head.pos;
                const placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode && adjacentNode.type === placeholderNodeType && didPlaceholderExistBeforeTxn) {
                    const { $head: $newHead } = newState.selection;
                    const { $head: $oldHead } = oldState.selection;
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    const cursorMoved = $oldHead.pos < $newHead.pos;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const nodeBeforeHasContent = !(0, $l9G9n.isNodeEmpty)($newHead.nodeBefore);
                    const nodeBeforeIsInline = $newHead.nodeBefore?.type.isInline;
                    if (cursorMoved && (nodeBeforeHasContent || nodeBeforeIsInline)) {
                        const { $from: $from, $to: $to } = (0, $ks2lK.NodeSelection).create(newState.doc, adjacentNodePos);
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!(0, $9e04eeca38565b10$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && (0, $9e04eeca38565b10$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) return newState.tr.setSelection(new (0, $b407e6ea96d05343$export$37936ceed0f40761)(newState.selection.$from));
            if ((0, $9e04eeca38565b10$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && !(0, $9e04eeca38565b10$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof (0, $b407e6ea96d05343$export$37936ceed0f40761)) return newState.tr.setSelection(new (0, $ks2lK.TextSelection)(newState.selection.$from));
            }
            return;
        },
        props: {
            decorations: (0, $b407e6ea96d05343$export$e3d497d0280bbada),
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    const { state: state } = view;
                    if (event instanceof InputEvent && !event.isComposing && event.inputType === 'insertText' && (0, $0e0568ea62cfecf5$export$fcfa1d7f51efd169)(view.state.selection)) {
                        event.stopPropagation();
                        event.preventDefault();
                        const startNodePosition = state.selection.from;
                        const content = event.data || '';
                        const tr = view.state.tr;
                        tr.delete(startNodePosition, startNodePosition + 1);
                        const openTypeAhead = $87eb8bf8ace2e0b7$var$getOpenTypeAhead(content, api);
                        if (openTypeAhead) openTypeAhead(tr);
                        else tr.insertText(content);
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            nodeViews: {
                placeholder: (node, view, getPos)=>new (0, $d895e3167962be91$export$442d0baedc2512a6)(node, view, getPos)
            }
        }
    });
}
function $87eb8bf8ace2e0b7$var$ContentComponent({ editorView: editorView, dependencyApi: dependencyApi, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
    const { showInsertPanelAt: showInsertPanelAt } = (0, $eiA8Z.useSharedPluginStateWithSelector)(dependencyApi, [
        'placeholderText'
    ], (states)=>({
            showInsertPanelAt: states.placeholderTextState?.showInsertPanelAt
        }));
    const insertPlaceholderText = (value)=>(0, $db9c80a61f72fa10$export$478f9b36a44ad411)(value)(editorView.state, editorView.dispatch);
    const hidePlaceholderToolbar = ()=>(0, $db9c80a61f72fa10$export$722fce80225bc19b)(editorView.state, editorView.dispatch);
    const getNodeFromPos = (pos)=>editorView.domAtPos(pos).node;
    const getFixedCoordinatesFromPos = (pos)=>editorView.coordsAtPos(pos);
    const setFocusInEditor = ()=>editorView.focus();
    if (showInsertPanelAt) return /*#__PURE__*/ (0, $l998X.jsx)((0, $68f079c09b6123c0$export$2e2bcd8739ae039), {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorViewDOM: editorView.dom,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        getFixedCoordinatesFromPos: getFixedCoordinatesFromPos,
        getNodeFromPos: getNodeFromPos,
        hidePlaceholderFloatingToolbar: hidePlaceholderToolbar,
        showInsertPanelAt: showInsertPanelAt,
        insertPlaceholder: insertPlaceholderText,
        setFocusInEditor: setFocusInEditor
    });
    return null;
}
const $87eb8bf8ace2e0b7$var$basePlaceholderTextPlugin = ({ api: api, config: options })=>({
        name: 'placeholderText',
        nodes () {
            return [
                {
                    name: 'placeholder',
                    node: (0, $jEypY.placeholder)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholderText',
                    plugin: ({ dispatch: dispatch })=>$87eb8bf8ace2e0b7$export$ae829ec7b2625219(dispatch, options, api)
                }
            ];
        },
        actions: {
            showPlaceholderFloatingToolbar: $db9c80a61f72fa10$export$cf72668e5bda227e
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { showInsertPanelAt: showInsertPanelAt, allowInserting: allowInserting } = (0, $9e04eeca38565b10$export$18d4026d1ea86bb1).getState(editorState) || {
                showInsertPanelAt: null
            };
            return {
                showInsertPanelAt: showInsertPanelAt,
                allowInserting: !!allowInserting
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($87eb8bf8ace2e0b7$var$ContentComponent, {
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                dependencyApi: api
            });
        }
    });
const $87eb8bf8ace2e0b7$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (!options.allowInserting) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'placeholderText',
                    title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).placeholderText),
                    description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).placeholderTextDescription),
                    priority: 1400,
                    keywords: [
                        'placeholder'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
                            label: ""
                        }),
                    action (insert, state) {
                        const tr = state.tr;
                        tr.setMeta((0, $9e04eeca38565b10$export$18d4026d1ea86bb1), {
                            showInsertPanelAt: tr.selection.anchor
                        });
                        api?.analytics?.actions.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).INSERTED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
                            attributes: {
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            },
                            eventType: (0, $d925B.EVENT_TYPE).TRACK
                        })(tr);
                        return tr;
                    }
                }
            ]
    };
    return plugin;
};
const $87eb8bf8ace2e0b7$var$placeholderTextPlugin = ({ config: options = {}, api: api })=>$87eb8bf8ace2e0b7$var$decorateWithPluginOptions($87eb8bf8ace2e0b7$var$basePlaceholderTextPlugin({
        config: options,
        api: api
    }), options, api);
var $87eb8bf8ace2e0b7$export$2e2bcd8739ae039 = $87eb8bf8ace2e0b7$var$placeholderTextPlugin;
module.exports["default"] = $87eb8bf8ace2e0b7$export$2e2bcd8739ae039;

});

parcelRegister("c8680", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $f4dR3 = parcelRequire("f4dR3");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $lNDSG = parcelRequire("lNDSG");


var $1yB28 = parcelRequire("1yB28");


var $fO7hX = parcelRequire("fO7hX");





var $dAtrv = parcelRequire("dAtrv");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");




const $f2fd7a6434f542ed$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('statusPlugin');


const $6d822d97c2f1195f$export$ac80046fa87f5a7a = {
    text: '',
    color: 'neutral'
};
const $6d822d97c2f1195f$export$83bafcce64b36a62 = (statusNode, tr, annotationMarks)=>{
    const fragment = (0, $5SAOw.Fragment).fromArray([
        statusNode,
        tr.doc.type.schema.text(' ', annotationMarks)
    ]);
    const insertable = (0, $8m4tT.canInsert)(tr.selection.$from, fragment);
    if (!insertable) {
        const parentSelection = (0, $ks2lK.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
        tr.insert(parentSelection.to, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, parentSelection.to + 1));
    } else tr.insert(tr.selection.from, fragment).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
    return tr.setMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), {
        showStatusPickerAt: tr.selection.from,
        isNew: true
    }).scrollIntoView();
};
const $6d822d97c2f1195f$export$1cefe804e0e75f6d = (tr)=>{
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(tr.selection.$head);
    const statusNode = tr.doc.type.schema.nodes.status.createChecked({
        ...$6d822d97c2f1195f$export$ac80046fa87f5a7a,
        localId: (0, $fO7hX.uuid).generate()
    }, null, annotationMarksForPos);
    return $6d822d97c2f1195f$export$83bafcce64b36a62(statusNode, tr, annotationMarksForPos);
};
const $6d822d97c2f1195f$export$84e57993298e69f2 = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR)=>({ tr: tr })=>{
            const statusTr = $6d822d97c2f1195f$export$1cefe804e0e75f6d(tr);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(statusTr);
            return statusTr;
        };
const $6d822d97c2f1195f$export$dd127eb7207846ef = (status)=>(state, dispatch)=>{
        const { schema: schema } = state;
        const selectedStatus = status ? Object.assign(status, {
            text: status.text.trim(),
            localId: status.localId || (0, $fO7hX.uuid).generate()
        }) : status;
        const statusProps = {
            ...$6d822d97c2f1195f$export$ac80046fa87f5a7a,
            ...selectedStatus
        };
        let tr = state.tr;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1).getState(state) || {};
        if (!showStatusPickerAt) {
            // Same behaviour as quick insert (used in createStatus)
            const statusNode = schema.nodes.status.createChecked(statusProps);
            tr = $6d822d97c2f1195f$export$83bafcce64b36a62(statusNode, state.tr);
            if (dispatch) dispatch(tr);
            return true;
        }
        if (state.doc.nodeAt(showStatusPickerAt)) {
            tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps).setSelection((0, $ks2lK.NodeSelection).create(tr.doc, showStatusPickerAt)).setMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), {
                showStatusPickerAt: showStatusPickerAt
            }).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $6d822d97c2f1195f$export$2d82855a8f0dcacb = (editorAnalyticsAPI)=>(inputMethod, status)=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).STATUS,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })($6d822d97c2f1195f$export$dd127eb7207846ef(status));
const $6d822d97c2f1195f$export$9bef27b5339b1a7a = (showStatusPickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), {
            showStatusPickerAt: showStatusPickerAt,
            isNew: false
        }));
        return true;
    };
const $6d822d97c2f1195f$export$38345b9b03bc4599 = (showStatusPickerAt)=>({ tr: tr })=>{
        tr.replace(showStatusPickerAt, showStatusPickerAt + 1);
        return tr;
    };
const $6d822d97c2f1195f$export$89aebd528a1fddb6 = ()=>(state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), {
            focusStatusInput: true
        });
        dispatch(tr);
        return true;
    };
const $6d822d97c2f1195f$var$handleClosingByArrows = (closingMethod, state, showStatusPickerAt, tr)=>{
    if (closingMethod === 'arrowLeft') // put cursor right before status Lozenge
    tr = tr.setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(showStatusPickerAt), -1));
    else if (closingMethod === 'arrowRight') // put cursor right after status Lozenge
    tr = tr.setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 1)));
};
const $6d822d97c2f1195f$export$cdfbbd5b38df803 = (closingPayload)=>(editorView)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1).getState(state) || {};
        const { closingMethod: closingMethod } = closingPayload || {};
        if (!showStatusPickerAt) return;
        const statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
        if (!statusNode) return;
        let tr = state.tr;
        tr = tr.setMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), {
            showStatusPickerAt: null,
            focusStatusInput: false,
            isNew: false
        });
        if (closingMethod) $6d822d97c2f1195f$var$handleClosingByArrows(closingMethod, state, showStatusPickerAt, tr);
        else if (statusNode.attrs.text) // still has content - keep content
        // move selection after status if selection did not change
        {
            if (tr.selection.from === showStatusPickerAt) tr = tr.setSelection((0, $ks2lK.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 2)));
        } else // no content - remove node
        tr = tr.delete(showStatusPickerAt, showStatusPickerAt + 1);
        dispatch(tr);
        editorView.focus();
    };






var $dus6D = parcelRequire("dus6D");









const $092eb59fd0d7e219$export$ae039c0c89d3061 = (selection)=>{
    if (selection && selection instanceof (0, $ks2lK.NodeSelection)) {
        const nodeSelection = selection;
        if (nodeSelection.node.type.name === 'status') return selection.node.attrs || null;
    }
    return null;
};
const $092eb59fd0d7e219$export$4e209830f320e9a = (node)=>node && (node.text && node.text.trim().length === 0 || node.text === '');
const $092eb59fd0d7e219$export$9a35f63e5088c6ab = (tr, pos)=>tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map(pos)));


function $ad66dde51bd4d59f$export$e832373cff8dec22() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.enter).common, $ad66dde51bd4d59f$var$consumeKeyEvent, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch)=>{
        const statusPluginState = (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1).getState(state);
        const isStatusNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node.type === state.schema.nodes.status : false;
        if (!isStatusNode) return false;
        if (statusPluginState?.showStatusPickerAt) {
            (0, $6d822d97c2f1195f$export$89aebd528a1fddb6)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
// consume event to prevent status node problems with positioning and selection
const $ad66dde51bd4d59f$var$consumeKeyEvent = (state, _dispatch)=>!!(0, $092eb59fd0d7e219$export$ae039c0c89d3061)(state.tr.selection);
var $ad66dde51bd4d59f$export$2e2bcd8739ae039 = $ad66dde51bd4d59f$export$e832373cff8dec22;



var $1S4f7 = parcelRequire("1S4f7");


var $l9G9n = parcelRequire("l9G9n");





var $agX1m = parcelRequire("agX1m");





var $1oCLl = parcelRequire("1oCLl");


var $d7ZU3 = parcelRequire("d7ZU3");


var $24P9d = parcelRequire("24P9d");


var $TfRUG = parcelRequire("TfRUG");


var $dh538 = parcelRequire("dh538");




// eg. Version/4.0 Chrome/95.0.4638.50
const $a4d6789ee51a62fa$var$isAndroidChromium = // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
typeof window !== 'undefined' && /Version\/.* Chrome\/.*/u.test(window.navigator.userAgent);
const $a4d6789ee51a62fa$export$5318aa2f7ab92c01 = (node)=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const { text: text, color: color, style: style, localId: localId } = node.attrs;
    const editorNodeWrapperAttrs = {
        class: 'statusView-content-wrap inlineNodeView',
        'data-testid': 'statusContainerView',
        'data-prosemirror-node-name': 'status',
        localid: localId,
        // Required for parseDOM to correctly parse status when NodeView DOM is copied directly
        ...(0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? {
            'data-node-type': 'status',
            'data-color': color,
            'data-text': text // Text stored as attribute for parseDOM extraction
        } : {}
    };
    const statusElementAttrs = {
        style: (0, $24P9d.convertToInlineCss)($a4d6789ee51a62fa$var$isAndroidChromium ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'inline-block !important',
            verticalAlign: 'middle'
        } : {}),
        class: 'status-lozenge-span',
        'data-node-type': 'status',
        'data-color': color,
        'data-style': style
    };
    const lozengeWrapperAttrs = {
        class: 'lozenge-wrapper'
    };
    const lozengeTextAttrs = {
        class: 'lozenge-text',
        style: (0, $24P9d.convertToInlineCss)({
            ...(0, $dh538.fg)('platform-lozenge-custom-letterspacing') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                letterSpacing: '0.165px'
            } : {}
        })
    };
    return [
        'span',
        editorNodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            statusElementAttrs,
            [
                'span',
                lozengeWrapperAttrs,
                [
                    'span',
                    lozengeTextAttrs,
                    text
                ]
            ]
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $9d504296f6fac314$export$54e825089e34a876 {
    setPlaceholder() {
        if (this.textContainer && this.domElement) {
            this.textContainer.textContent = this.intl.formatMessage((0, $agX1m.messages).placeholder);
            this.domElement.style.setProperty('opacity', '0.83');
        }
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        if (node.type !== this.node.type) return false;
        if (this.textContainer && node.attrs.text !== this.node.attrs.text) {
            this.textContainer.textContent = node.attrs.text;
            // Also update data-text on outer wrapper for parseDOM extraction when copying
            if ((0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true)) this.domElement?.setAttribute('data-text', node.attrs.text);
        }
        if (node.attrs.color !== this.node.attrs.color) {
            this.box?.setAttribute('data-color', node.attrs.color);
            // Also update data-color on outer wrapper for parseDOM extraction when copying
            if ((0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true)) this.domElement?.setAttribute('data-color', node.attrs.color);
        }
        if (!node.attrs.text) this.setPlaceholder();
        if (node.attrs.text && this.domElement) this.domElement.style.setProperty('opacity', '1');
        this.node = node;
        return true;
    }
    /**
   *
   * @param node
   * @param intl
   * @example
   */ constructor(node, intl){
        this.dom = void 0;
        this.domElement = void 0;
        this.box = null;
        this.textContainer = null;
        this.node = void 0;
        this.intl = void 0;
        this.node = node;
        this.intl = intl;
        const spec = (0, $a4d6789ee51a62fa$export$5318aa2f7ab92c01)(node);
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if (this.domElement) {
            this.box = this.domElement.querySelector('.status-lozenge-span');
            this.textContainer = this.domElement.querySelector('.lozenge-text');
        }
        if (!node.attrs.text) this.setPlaceholder();
    }
}




const $b29d59a51a2b361f$var$createPlugin = (pmPluginFactoryParams, options)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>({
                    isNew: false,
                    showStatusPickerAt: null,
                    focusStatusInput: false
                }),
            apply (tr, state, oldEditorState) {
                const meta = tr.getMeta((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    pmPluginFactoryParams.dispatch((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.showStatusPickerAt);
                    const showStatusPickerAt = deleted ? null : pos;
                    const newState = {
                        ...state,
                        showStatusPickerAt: showStatusPickerAt
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        pmPluginFactoryParams.dispatch((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                if (tr.selectionSet) {
                    // Change in selection, while status picker was open, update state, if required.
                    const selectionFrom = tr.selection.from;
                    const nodeAtSelection = tr.doc.nodeAt(selectionFrom);
                    let showStatusPickerAt = null;
                    if (nodeAtSelection && nodeAtSelection.type === oldEditorState.schema.nodes.status && tr.selection instanceof (0, $ks2lK.NodeSelection)) showStatusPickerAt = selectionFrom;
                    if (showStatusPickerAt !== state.showStatusPickerAt) {
                        const newState = {
                            ...state,
                            isNew: false,
                            showStatusPickerAt: showStatusPickerAt,
                            focusStatusInput: false
                        };
                        pmPluginFactoryParams.dispatch((0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                return state;
            }
        },
        filterTransaction: (tr, state)=>{
            // if it is a selection change transaction, and selection changes from node to text
            if (tr.selectionSet && !tr.steps.length && tr.isGeneric && tr.selection instanceof (0, $ks2lK.TextSelection) && state.selection instanceof (0, $ks2lK.NodeSelection)) {
                const { isNew: isNew, showStatusPickerAt: showStatusPickerAt } = (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1).getState(state) || {};
                const nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                // prevent changing node selection to text selection on dom change right after inserting status
                // if newly selected status is selected with status picker opened
                if (isNew && showStatusPickerAt && nodeAtSelection && nodeAtSelection.type === state.schema.nodes.status) return false;
            }
            return true;
        },
        appendTransaction: (transactions, oldEditorState, newEditorState)=>{
            let changed = false;
            const tr = newEditorState.tr;
            /**
			 * When user start creating status, and, when users navigates away
			 *  while empty, then we want to remove empty ("set a status") status.
			 * But when transaction to add empty status happens from undo/redo
			 *  we don't want to remove it.
			 */ if (transactions.find((tr)=>tr.selectionSet && !tr.getMeta((0, $l9G9n.pmHistoryPluginKey)))) {
                const oldStatus = (0, $092eb59fd0d7e219$export$ae039c0c89d3061)(oldEditorState.selection);
                const newStatus = (0, $092eb59fd0d7e219$export$ae039c0c89d3061)(newEditorState.selection);
                if (oldStatus && (newStatus && oldStatus.localId !== newStatus.localId || !newStatus)) {
                    if ((0, $092eb59fd0d7e219$export$4e209830f320e9a)(oldStatus)) {
                        const pos = oldEditorState.selection.from;
                        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + 1));
                        changed = true;
                    }
                }
            }
            return changed ? tr : undefined;
        },
        key: (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                status: (node)=>{
                    return new (0, $9d504296f6fac314$export$54e825089e34a876)(node, pmPluginFactoryParams.getIntl());
                }
            }
        }
    });
var $b29d59a51a2b361f$export$2e2bcd8739ae039 = $b29d59a51a2b361f$var$createPlugin;







var $42omo = parcelRequire("42omo");


var $1Oo9w = parcelRequire("1Oo9w");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $1DWH0 = parcelRequire("1DWH0");


var $hTKp4 = parcelRequire("hTKp4");





var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");


var $1eLzC = parcelRequire("1eLzC");


var $aFUXX = parcelRequire("aFUXX");




/* StatusPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4noo5 = parcelRequire("4noo5");







/* color-palette.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* color.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cvXh8 = parcelRequire("cvXh8");


var $fVUfS = parcelRequire("fVUfS");


var $gtD4K = parcelRequire("gtD4K");


var $aLypr = parcelRequire("aLypr");


var $cgtv4 = parcelRequire("cgtv4");

const $b2dbd3712267d542$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    neutralColor: {
        id: "fabric.status.color.grey",
        defaultMessage: "Grey"
    },
    purpleColor: {
        id: "fabric.status.color.purple",
        defaultMessage: "Purple"
    },
    blueColor: {
        id: "fabric.status.color.blue",
        defaultMessage: "Blue"
    },
    redColor: {
        id: "fabric.status.color.red",
        defaultMessage: "Red"
    },
    yellowColor: {
        id: "fabric.status.color.yellow",
        defaultMessage: "Yellow"
    },
    greenColor: {
        id: "fabric.status.color.green",
        defaultMessage: "Green"
    },
    statusInputLabel: {
        id: "fabric.status.input.label",
        defaultMessage: "Set a status"
    }
});


function $9e4f2c5f26ccfc92$var$_defineProperty(e, r, t) {
    return (r = $9e4f2c5f26ccfc92$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9e4f2c5f26ccfc92$var$_toPropertyKey(t) {
    var i = $9e4f2c5f26ccfc92$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9e4f2c5f26ccfc92$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $9e4f2c5f26ccfc92$var$styles = {
    button: "_2rko12b0 _19itia51 _1reo15vq _18m915vq _4t3i1tcg _1bsb1tcg _bfhki8nm _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1ule"
};
const $9e4f2c5f26ccfc92$var$buttonWrapperStyles = null;
class $9e4f2c5f26ccfc92$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { tabIndex: tabIndex, backgroundColor: backgroundColor, isSelected: isSelected, borderColor: borderColor, iconColor: iconColor, value: value, setRef: setRef } = this.props;
        return /*#__PURE__*/ $42omo.createElement("li", {
            className: (0, $gMc0m.default)([
                "_2rko12x7 _189ee4h9 _1dqonqa1 _1h6d1j28 _19pkze3t _2hwxv77o _otyrze3t _18u0v77o _1e0c1txw _4cvr1h6o _ca0qe4h9 _u5f3e4h9 _n3tde4h9 _19bve4h9 _bfw7ia51"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $b2dbd3712267d542$export$defe85febe8b728c)[`${value}Color`], (labels)=>/*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                xcss: $9e4f2c5f26ccfc92$var$styles.button,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                tabIndex: tabIndex,
                title: labels[0],
                // For button selected (to be precise pressed) or not
                //  use aria-pressed as per
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
                "aria-pressed": isSelected,
                style: {
                    backgroundColor: backgroundColor || 'transparent',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    color: iconColor,
                    borderColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderColor
                },
                ref: setRef
            }, isSelected && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                color: "currentColor",
                label: labels[0]
            }))));
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    constructor(...args){
        super(...args);
        $9e4f2c5f26ccfc92$var$_defineProperty(this, "hoverStartTime", 0);
        $9e4f2c5f26ccfc92$var$_defineProperty(this, "onMouseEnter", ()=>{
            this.hoverStartTime = Date.now();
        });
        $9e4f2c5f26ccfc92$var$_defineProperty(this, "onMouseLeave", ()=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover(this.props.value);
            this.hoverStartTime = 0;
        });
        $9e4f2c5f26ccfc92$var$_defineProperty(this, "onMouseDown", (e)=>{
            e.preventDefault();
        });
        $9e4f2c5f26ccfc92$var$_defineProperty(this, "onClick", (e)=>{
            const { onClick: onClick, value: value } = this.props;
            e.preventDefault();
            onClick(value);
        });
    }
}





const $3eaaac6acd017e09$var$paletteLegacy = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery, #F8EEFE)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon-discovery, #AF59E1)"
    ],
    [
        'blue',
        "var(--ds-background-information, #E9F2FE)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon-information, #357DE8)"
    ],
    [
        'red',
        "var(--ds-background-danger, #FFECEB)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon-danger, #C9372C)"
    ],
    [
        'yellow',
        "var(--ds-background-warning, #FFF5DB)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon-warning, #E06C00)"
    ],
    [
        'green',
        "var(--ds-background-success, #EFFFD6)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon-success, #6A9A23)"
    ]
];
const $3eaaac6acd017e09$var$paletteRefreshed = [
    [
        'neutral',
        "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-pressed, #ADCBFB)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-pressed, #BDE97C)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-pressed, #FBD779)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-pressed, #FFB8B2)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-pressed, #E3BDFA)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon, #292A2E)"
    ]
];
const $3eaaac6acd017e09$var$getPalette = ()=>(0, $dh538.fg)('platform-component-visual-refresh') ? $3eaaac6acd017e09$var$paletteRefreshed : $3eaaac6acd017e09$var$paletteLegacy; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $3eaaac6acd017e09$var$colorPaletteWrapperStyles = null;
var $3eaaac6acd017e09$export$2e2bcd8739ae039 = ({ cols: cols = 7, onClick: onClick, selectedColor: selectedColor, className: className, onHover: onHover })=>{
    const palette = $3eaaac6acd017e09$var$getPalette();
    const colorRefs = (0, $42omo.useRef)([]);
    const [currentFocusedColor, setCurrentFocusedColor] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        colorRefs.current = colorRefs.current.slice(0, palette.length);
    }, [
        palette.length
    ]);
    const memoizedHandleKeyDown = (0, $42omo.useCallback)((e)=>{
        let newColorIndex = null;
        const nextColor = ()=>currentFocusedColor + 1 > palette.length - 1 ? 0 : currentFocusedColor + 1;
        const previousColor = ()=>currentFocusedColor - 1 < 0 ? palette.length - 1 : currentFocusedColor - 1;
        switch(e.key){
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                newColorIndex = nextColor();
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                newColorIndex = previousColor();
                break;
            case 'Tab':
                setCurrentFocusedColor(0);
                break;
        }
        if (newColorIndex === null) return;
        setCurrentFocusedColor(newColorIndex);
        const newRef = colorRefs.current[newColorIndex];
        newRef?.focus();
    }, [
        currentFocusedColor,
        setCurrentFocusedColor,
        colorRefs,
        palette.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19bvidpf _19pku2gc _2hwxu2gc _otyridpf _18u0u2gc _1e0c1txw _1n261g80",
            className
        ]),
        style: {
            maxWidth: cols * 32
        },
        onKeyDown: memoizedHandleKeyDown
    }, palette.map(([colorValue, backgroundColor, borderColor, iconColor], i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e4f2c5f26ccfc92$export$2e2bcd8739ae039), {
            key: colorValue,
            value: colorValue,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            iconColor: iconColor,
            onClick: onClick,
            onHover: onHover,
            isSelected: colorValue === selectedColor,
            tabIndex: i === 0 ? 0 : -1,
            setRef: (el)=>colorRefs.current[i] = el
        });
    }));
};



function $f47823e274b8232f$var$_defineProperty(e, r, t) {
    return (r = $f47823e274b8232f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f47823e274b8232f$var$_toPropertyKey(t) {
    var i = $f47823e274b8232f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f47823e274b8232f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $f47823e274b8232f$var$fieldTextWrapperStyles = null;
class $f47823e274b8232f$var$Picker extends (0, $42omo.PureComponent) {
    render() {
        const { text: text, selectedColor: selectedColor, onColorClick: onColorClick, onColorHover: onColorHover, intl: intl } = this.props;
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: this.fieldTextWrapperKey,
            className: (0, $gMc0m.default)([
                "_19pkidpf _otyridpf _2hwxu2gc _18u0u2gc _n6341ihb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            value: text,
            isCompact: true,
            ref: this.handleInputRef,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            spellCheck: false,
            autoComplete: "off",
            "aria-label": intl.formatMessage((0, $b2dbd3712267d542$export$defe85febe8b728c).statusInputLabel)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eaaac6acd017e09$export$2e2bcd8739ae039), {
            key: this.colorPaletteKey,
            onClick: onColorClick,
            onHover: onColorHover,
            selectedColor: selectedColor
        }));
    }
    componentDidUpdate() {
        if (this.inputRef && this.props.autoFocus) this.focusInput();
    }
    componentWillUnmount() {
        if (this.autofocusTimeout !== undefined) clearTimeout(this.autofocusTimeout);
    }
    constructor(...args){
        super(...args);
        $f47823e274b8232f$var$_defineProperty(this, "inputRef", void 0);
        $f47823e274b8232f$var$_defineProperty(this, "autofocusTimeout", void 0);
        $f47823e274b8232f$var$_defineProperty(this, "fieldTextWrapperKey", Math.random().toString());
        $f47823e274b8232f$var$_defineProperty(this, "colorPaletteKey", Math.random().toString());
        $f47823e274b8232f$var$_defineProperty(this, "onChange", (evt)=>{
            // @ts-ignore
            this.props.onTextChanged(evt.target.value);
        });
        $f47823e274b8232f$var$_defineProperty(this, "onKeyPress", (event)=>{
            if (event.key === 'Enter') this.props.onEnter();
        });
        $f47823e274b8232f$var$_defineProperty(this, "handleInputRef", (ref)=>{
            this.inputRef = ref;
            if (ref && this.props.autoFocus) this.focusInput();
        });
        $f47823e274b8232f$var$_defineProperty(this, "focusInput", ()=>{
            if (!this.inputRef) return;
             // Defer to prevent editor scrolling to top
            this.autofocusTimeout = setTimeout(()=>{
                this.inputRef?.focus();
            });
        });
    }
}
$f47823e274b8232f$var$_defineProperty($f47823e274b8232f$var$Picker, "defaultProps", {
    autoFocus: true
});
const $f47823e274b8232f$export$39975ce689bf0105 = (0, $gmMgo.default)($f47823e274b8232f$var$Picker);



var $6fnsQ = parcelRequire("6fnsQ");





var $6F6hl = parcelRequire("6F6hl");


const $f8449954b9b4970f$export$7787c7adba71b8c3 = 'fabric-elements';
const $f8449954b9b4970f$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent && payload) {
            const statusPayload = {
                ...payload,
                eventType: 'ui'
            };
            if (!statusPayload.attributes) statusPayload.attributes = {};
            statusPayload.attributes.componentName = 'status';
            createAnalyticsEvent(statusPayload).fire($f8449954b9b4970f$export$7787c7adba71b8c3);
        }
    };
const $f8449954b9b4970f$export$69e00be7c24e6455 = (isNew)=>isNew ? 'new' : 'update';


const $6a643df42a7164f2$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
var $6a643df42a7164f2$export$4182489224ea9c47 = /*#__PURE__*/ function(InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
    return InputMethod;
}({});
var $6a643df42a7164f2$export$cc742728d048210b = /*#__PURE__*/ function(closingMethods) {
    closingMethods["ArrowLeft"] = "arrowLeft";
    closingMethods["ArrowRight"] = "arrowRight";
    return closingMethods;
}({});
const $6a643df42a7164f2$var$pickerContainerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`,
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase'
    }
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $6a643df42a7164f2$var$StatusPickerWithIntl extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    fireStatusPopupOpenedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.startTime = Date.now();
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $f8449954b9b4970f$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    fireStatusPopupClosedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: this.inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $f8449954b9b4970f$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    reset() {
        this.startTime = Date.now();
        this.inputMethod = "blur";
    }
    componentDidMount() {
        this.reset();
        this.fireStatusPopupOpenedAnalytics(this.state);
    }
    componentWillUnmount() {
        this.focusTimeout && cancelAnimationFrame(this.focusTimeout);
        this.fireStatusPopupClosedAnalytics(this.state);
        this.startTime = 0;
    }
    componentDidUpdate(prevProps, prevState) {
        const element = this.props.target;
        if (prevProps.target !== element) {
            const newState = this.extractStateFromProps(this.props);
            this.setState(newState);
            this.fireStatusPopupClosedAnalytics(prevState);
            this.reset();
            this.fireStatusPopupOpenedAnalytics(newState);
        }
    }
    extractStateFromProps(props) {
        const { defaultColor: defaultColor, defaultText: defaultText, defaultLocalId: defaultLocalId, isNew: isNew } = props;
        return {
            color: defaultColor || (0, $6d822d97c2f1195f$export$ac80046fa87f5a7a).color,
            text: defaultText || (0, $6d822d97c2f1195f$export$ac80046fa87f5a7a).text,
            localId: defaultLocalId,
            isNew: isNew
        };
    }
    setRef(setOutsideClickTargetRef) {
        return (ref)=>{
            setOutsideClickTargetRef(ref);
            this.popupBodyWrapper.current = ref;
        };
    }
    renderWithSetOutsideClickTargetRef(setOutsideClickTargetRef) {
        const { isNew: isNew, focusStatusInput: focusStatusInput, api: api } = this.props;
        const { color: color, text: text } = this.state;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1eLzC.UserIntentPopupWrapper), {
            api: api,
            userIntent: "statusPickerOpen"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6a643df42a7164f2$var$pickerContainerStyles,
            role: "none",
            ref: this.setRef(setOutsideClickTargetRef),
            onClick: this.handlePopupClick,
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f47823e274b8232f$export$39975ce689bf0105), {
            autoFocus: isNew || focusStatusInput,
            selectedColor: color,
            text: text,
            onColorClick: this.onColorClick,
            onColorHover: this.onColorHover,
            onTextChanged: this.onTextChanged,
            onEnter: this.onEnter
        })));
    }
    render() {
        const { target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, intl: intl } = this.props;
        if (!editorView?.editable) return null;
        return target && /*#__PURE__*/ (0, $9K4OG.jsx)($6a643df42a7164f2$var$PopupWithListeners, {
            ariaLabel: (0, $dh538.fg)('_editor_a11y_aria_label_removal_popup') ? intl.formatMessage((0, $agX1m.messages).statusEditorLabel) : undefined,
            target: target,
            offset: [
                0,
                8
            ],
            handleClickOutside: this.handleClickOutside,
            handleEscapeKeydown: this.handleEscapeKeydown,
            zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
            fitHeight: 40,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            closeOnTab: false
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6F6hl.default), {
            "aria-atomic": true,
            role: "alert"
        }, intl.formatMessage((0, $agX1m.messages).statusPickerOpenedAlert)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, null, this.renderWithSetOutsideClickTargetRef.bind(this)));
    }
    constructor(props){
        super(props);
        this.startTime = void 0;
        this.inputMethod = void 0;
        this.createStatusAnalyticsAndFireFunc = void 0;
        this.popupBodyWrapper = void 0;
        this.focusTimeout = void 0;
        this.handleClickOutside = (event)=>{
            event.preventDefault();
            this.inputMethod = "blur";
            const selectedText = window.getSelection();
            if (!selectedText) this.props.closeStatusPicker();
        };
        this.handleEscapeKeydown = (event)=>{
            event.preventDefault();
            this.inputMethod = "escKey";
            this.props.onEnter(this.state);
        };
        this.handleTabPress = (event)=>{
            const colorButtons = event.currentTarget.querySelectorAll('button');
            const inputField = event.currentTarget.querySelector('input');
            const activeElement = (0, $1oCLl.expValEquals)('platform_editor_a11y_eslint_fix', 'isEnabled', true) ? (0, $hTKp4.getDocument)()?.activeElement : document?.activeElement;
            const isInputFocussed = activeElement === inputField;
            const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            if (event?.shiftKey) {
                /* shift + tab */ if (isInputFocussed) {
                    colorButtons[0].focus();
                    event.preventDefault();
                }
                /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
               To correctly set focus to the input field instead of the first color button we need to set focus manually
               */ if (isButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
            } else /* tab */ if (isButtonFocussed) {
                inputField?.focus();
                event.preventDefault();
            }
        };
        this.handleArrow = (event, closingMethod)=>{
            const activeElement = (0, $1oCLl.expValEquals)('platform_editor_a11y_eslint_fix', 'isEnabled', true) ? (0, $hTKp4.getDocument)()?.activeElement : document?.activeElement;
            if (activeElement === this.popupBodyWrapper.current) {
                event.preventDefault();
                this.popupBodyWrapper?.current?.blur();
                this.props.closeStatusPicker({
                    closingMethod: closingMethod
                });
            }
        };
        this.onKeyDown = (event)=>{
            const isTabPressed = event.key === 'Tab';
            if (isTabPressed) return this.handleTabPress(event);
            if (event.key in $6a643df42a7164f2$export$cc742728d048210b) return this.handleArrow(event, $6a643df42a7164f2$export$cc742728d048210b[event.key]);
        };
        this.onColorHover = (color)=>{
            this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: this.state.localId,
                    state: (0, $f8449954b9b4970f$export$69e00be7c24e6455)(this.props.isNew)
                }
            });
        };
        this.onColorClick = (color)=>{
            const { text: text, localId: localId } = this.state;
            if (color === this.state.color) {
                this.createStatusAnalyticsAndFireFunc({
                    action: 'clicked',
                    actionSubject: 'statusColorPicker',
                    attributes: {
                        color: color,
                        localId: localId,
                        state: (0, $f8449954b9b4970f$export$69e00be7c24e6455)(this.props.isNew)
                    }
                });
                // closes status box and commits colour
                this.onEnter();
            } else {
                this.setState({
                    color: color
                });
                this.props.onSelect({
                    text: text,
                    color: color,
                    localId: localId
                });
            }
        };
        this.onTextChanged = (text)=>{
            const { color: color, localId: localId } = this.state;
            this.setState({
                text: text
            });
            this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId
            }, !!this.props.isNew);
        };
        this.onEnter = ()=>{
            this.inputMethod = "enterKey";
            this.props.onEnter(this.state);
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        this.handlePopupClick = (event)=>event.nativeEvent.stopImmediatePropagation();
        this.state = this.extractStateFromProps(props);
        this.createStatusAnalyticsAndFireFunc = (0, $f8449954b9b4970f$export$aa98853957f9f5aa)(props.createAnalyticsEvent);
        this.popupBodyWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
const $6a643df42a7164f2$export$bcfa9a4744e42b68 = (0, $gmMgo.default)($6a643df42a7164f2$var$StatusPickerWithIntl);
var $6a643df42a7164f2$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($6a643df42a7164f2$export$bcfa9a4744e42b68);


function $8aa3e5c551c8fa7f$export$2dda1e4a1d1f6a81({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, domAtPos: domAtPos }) {
    const { statusState: statusState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'status'
    ]);
    const { showStatusPickerAt: showStatusPickerAt } = statusState ?? {};
    const target = (0, $42omo.useMemo)(()=>// Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        showStatusPickerAt ? (0, $8m4tT.findDomRefAtPos)(showStatusPickerAt, domAtPos) : null, [
        showStatusPickerAt,
        domAtPos
    ]);
    const statusNode = (0, $42omo.useMemo)(()=>showStatusPickerAt ? editorView.state.doc.nodeAt(showStatusPickerAt) : undefined, [
        showStatusPickerAt,
        editorView
    ]);
    const onSelect = (0, $42omo.useCallback)((status)=>{
        (0, $6d822d97c2f1195f$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onTextChanged = (0, $42omo.useCallback)((status)=>{
        (0, $6d822d97c2f1195f$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const closeStatusPicker = (0, $42omo.useCallback)((closingPayload)=>{
        (0, $6d822d97c2f1195f$export$cdfbbd5b38df803)(closingPayload)(editorView);
    }, [
        editorView
    ]);
    const onEnter = (0, $42omo.useCallback)(()=>{
        (0, $6d822d97c2f1195f$export$cdfbbd5b38df803)()(editorView);
    }, [
        editorView
    ]);
    if (typeof showStatusPickerAt !== 'number') return null;
    if (!statusNode || statusNode.type.name !== 'status') return null;
    const { text: text, color: color, localId: localId } = statusNode.attrs;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6a643df42a7164f2$export$2e2bcd8739ae039), {
        isNew: statusState?.isNew,
        focusStatusInput: statusState?.focusStatusInput,
        target: target,
        defaultText: text,
        defaultColor: color,
        defaultLocalId: localId,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onSelect: onSelect,
        onTextChanged: onTextChanged,
        closeStatusPicker: closeStatusPicker,
        onEnter: onEnter,
        editorView: editorView,
        api: api
    });
}


const $e35b044f3506762d$export$4c24fc5ab73049c9 = ({ config: options, api: api })=>({
        name: 'status',
        nodes () {
            return [
                {
                    name: 'status',
                    node: (0, $f4dR3.status)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'status',
                    plugin: (pmPluginFactoryParams)=>(0, $b29d59a51a2b361f$export$2e2bcd8739ae039)(pmPluginFactoryParams, options)
                },
                {
                    name: 'statusKeymap',
                    plugin: (0, $ad66dde51bd4d59f$export$e832373cff8dec22)
                }
            ];
        },
        actions: {
            commitStatusPicker: $6d822d97c2f1195f$export$cdfbbd5b38df803,
            updateStatus: (0, $6d822d97c2f1195f$export$2d82855a8f0dcacb)(api?.analytics?.actions)
        },
        commands: {
            removeStatus: $6d822d97c2f1195f$export$38345b9b03bc4599,
            insertStatus: (0, $6d822d97c2f1195f$export$84e57993298e69f2)(api?.analytics?.actions)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $f2fd7a6434f542ed$export$18d4026d1ea86bb1).getState(state);
            return pluginState ? {
                isNew: pluginState.isNew,
                showStatusPickerAt: pluginState.showStatusPickerAt,
                focusStatusInput: pluginState.focusStatusInput
            } : undefined;
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options?.menuDisabled === true) return [];
                return [
                    {
                        id: 'status',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).status),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).statusDescription),
                        priority: 700,
                        keywords: [
                            'lozenge'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconStatus), {}),
                        action (_insert, state) {
                            return (0, $6d822d97c2f1195f$export$84e57993298e69f2)(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).QUICK_INSERT)({
                                tr: state.tr
                            }) ?? state.tr;
                        }
                    }
                ];
            },
            floatingToolbar (state, intl) {
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                return {
                    title: 'Status floating toolbar',
                    nodeType: state.schema.nodes.status,
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Status floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const hasActiveMark = node.marks.some((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && isViewMode() && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !hasActiveMark;
                        const onCommentClick = (stateFromClickEvent, dispatch)=>{
                            if (!api?.annotation) return true;
                            const command = api.annotation.actions.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                            api?.analytics?.actions?.fireAnalyticsEvent({
                                action: (0, $d925B.ACTION).CLICKED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                                eventType: (0, $d925B.EVENT_TYPE).UI,
                                attributes: {
                                    source: 'highlightActionsMenu',
                                    pageMode: 'edit',
                                    sourceNode: 'status'
                                }
                            });
                            return command(stateFromClickEvent, dispatch);
                        };
                        const createCommentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
                        const commentItems = showAnnotation ? [
                            {
                                type: 'button',
                                title: createCommentMessage,
                                onClick: onCommentClick,
                                showTitle: true,
                                tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: createCommentMessage,
                                    keymap: (0, $hgeg8.addInlineComment)
                                }),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                supportsViewMode: true
                            }
                        ] : [];
                        return [
                            ...commentItems
                        ];
                    }
                };
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            const domAtPos = editorView.domAtPos.bind(editorView);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8aa3e5c551c8fa7f$export$2dda1e4a1d1f6a81), {
                domAtPos: domAtPos,
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["statusPlugin"] = $e35b044f3506762d$export$4c24fc5ab73049c9;

});

parcelRegister("fTvEN", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4r9Pq = parcelRequire("4r9Pq");

var $iw2ID = parcelRequire("iw2ID");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $l9FJJ = parcelRequire("l9FJJ");


var $dZ8uq = parcelRequire("dZ8uq");


var $adayn = parcelRequire("adayn");


var $1oCLl = parcelRequire("1oCLl");

const $7a3c52dd7aa30a82$export$de35616b4bcd2077 = (from, to, open = true)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        const fromClamped = from && from >= 0 ? from : 0;
        const toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
        tr.doc.nodesBetween(fromClamped, toClamped, (node)=>{
            if ([
                expand,
                nestedExpand
            ].includes(node.type)) (0, $adayn.expandedState).set(node, open);
        });
        if ((0, $1oCLl.expValEquals)('platform_editor_aifc_expand_collapses_oncreate_fix', 'isEnabled', true)) return tr;
        return null;
    };





parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");








var $2GVu1 = parcelRequire("2GVu1");


var $cZifa = parcelRequire("cZifa");

const $0405d2e291010188$var$NODE_NAME = 'expand';
const $0405d2e291010188$var$ExpandBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.expand, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $0405d2e291010188$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cZifa))), {
            label: ""
        }),
        children: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand)
    });
};
const $0405d2e291010188$export$43e1eed033b6f3d3 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($0405d2e291010188$var$ExpandBlockMenuItem, {
            api: api
        });
};



var $9YoeD = parcelRequire("9YoeD");




var $e2wMq = parcelRequire("e2wMq");


var $adhil = parcelRequire("adhil");


var $iMS6j = parcelRequire("iMS6j");


var $hcbpx = parcelRequire("hcbpx");





var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $id9O1 = parcelRequire("id9O1");







const $03a586ef1cfe8548$export$62b7afc61dbab067 = (state)=>(0, $8m4tT.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);



var $lkJUe = parcelRequire("lkJUe");




var $c9c406e5d4a9b269$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};


const $70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('expandPlugin');
const { createPluginState: $70a6c6d5a1b7b8ee$export$656c7661095efe2e, createCommand: $70a6c6d5a1b7b8ee$export$8d4021544bdece00, getPluginState: $70a6c6d5a1b7b8ee$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)($70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1, (0, $c9c406e5d4a9b269$export$2e2bcd8739ae039));


const $0fa109554c968699$export$491ffa7e89016e5c = (ref)=>(0, $70a6c6d5a1b7b8ee$export$8d4021544bdece00)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $0fa109554c968699$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $ks2lK.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $0fa109554c968699$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) return false;
        return $0fa109554c968699$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $0fa109554c968699$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage) tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $0fa109554c968699$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage) tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage ? isExpandedNext === true : isExpandedNext === false && (0, $hcbpx.findExpand)(state)) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $adhil.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $d925B.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $e2wMq.PLATFORMS).WEB,
                    mode: (0, $e2wMq.MODE).EDITOR,
                    expanded: __livePage ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $0fa109554c968699$export$b7c6a6a1365fc215 = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $id9O1.findTable)(state.selection);
    const isSelectionInExpand = (0, $03a586ef1cfe8548$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $0fa109554c968699$export$4782944d4b10fd76 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $0fa109554c968699$export$b7c6a6a1365fc215(state);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $8m4tT.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $l9FJJ.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const payload = {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT_ID).EXPAND : (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $0fa109554c968699$export$982de01464f3ba33 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        return $0fa109554c968699$export$4782944d4b10fd76(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $0fa109554c968699$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $0fa109554c968699$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $0fa109554c968699$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_native_expand_button cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true) ? expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $0fa109554c968699$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $ks2lK.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $0fa109554c968699$export$6f1dc7179cebfcb1 = (_selection)=>({ tr: tr })=>{
        // this action exists so that we can keep the plugin types consistent across the
        // the legacy expand plugin and the single player expand plugin until
        // we will remove the legacy expand plugin
        return null;
    };






var $hgeg8 = parcelRequire("hgeg8");




var $cQ4aK = parcelRequire("cQ4aK");





var $l9G9n = parcelRequire("l9G9n");

var $caYZ2 = parcelRequire("caYZ2");


var $dus6D = parcelRequire("dus6D");





var $bMyNT = parcelRequire("bMyNT");





const $2ec9d324b9bded96$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $2ec9d324b9bded96$var$isExpandSelected = (selection)=>selection instanceof (0, $ks2lK.NodeSelection) && $2ec9d324b9bded96$var$isExpandNode(selection.node);
function $2ec9d324b9bded96$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($2ec9d324b9bded96$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($2ec9d324b9bded96$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($2ec9d324b9bded96$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $0fa109554c968699$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $ks2lK.TextSelection) && !(0, $bMyNT.isInTable)(state)) {
                const expand = (0, $hcbpx.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $0fa109554c968699$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $0fa109554c968699$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $hcbpx.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $caYZ2.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $0fa109554c968699$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $adayn.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$2ec9d324b9bded96$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $0fa109554c968699$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}



var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");














parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $kbdB6 = parcelRequire("kbdB6");










var $kSoKM = parcelRequire("kSoKM");


var $4vlwG = parcelRequire("4vlwG");




var $5SAOw = parcelRequire("5SAOw");








var $ke2AI = parcelRequire("ke2AI");










function $d94ff661d09ba197$export$dde15965bbee9f3e(container, buttonProps) {
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = buttonProps;
    // Update existing button attributes
    const label = intl.formatMessage(expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode);
    const existingButton = container.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`);
    if (existingButton) {
        existingButton.setAttribute('aria-label', label);
        existingButton.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) {
            existingButton.setAttribute('title', label);
            existingButton.removeAttribute('disabled');
        } else {
            existingButton.removeAttribute('title');
            existingButton.setAttribute('disabled', 'true');
        }
    } else {
        const doc = container.ownerDocument;
        if (!doc) return;
        const button = doc.createElement('button');
        button.className = (0, $iMS6j.expandClassNames).iconButton;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) button.setAttribute('title', label);
        else button.setAttribute('disabled', 'true');
        container.appendChild(button);
        const svgIcon = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcon.setAttribute('class', (0, $iMS6j.expandClassNames).iconSvg);
        svgIcon.setAttribute('width', '12');
        svgIcon.setAttribute('height', '12');
        svgIcon.setAttribute('viewBox', '0 0 16 16');
        svgIcon.setAttribute('role', 'presentation');
        const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentcolor');
        path.setAttribute('d', 'm6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z');
        svgIcon.appendChild(path);
        button.appendChild(svgIcon);
    }
}



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $4KS7f = parcelRequire("4KS7f");








var $aFUXX = parcelRequire("aFUXX");


var $6R5uz = parcelRequire("6R5uz");


var $3gadb = parcelRequire("3gadb");

const $47829bbad8b17906$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { label: label } = this.props;
            return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                content: label,
                position: "top",
                tag: (0, $kSoKM.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(WrapperComponent, this.props)));
        }
        constructor(props){
            super(props);
        }
    };
};
const $47829bbad8b17906$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = props;
    const useTheme = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $aFUXX.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const label = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iMS6j.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $47829bbad8b17906$var$ButtonWithTooltip = $47829bbad8b17906$export$9a7250d72c34c156($47829bbad8b17906$export$aa86be27b687b166);
const $47829bbad8b17906$var$ButtonWithoutTooltip = $47829bbad8b17906$export$aa86be27b687b166;
const $47829bbad8b17906$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($47829bbad8b17906$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $kSoKM.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($47829bbad8b17906$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};


function $303b6a7761c63646$var$buildExpandClassName(type, expanded) {
    return `${(0, $iMS6j.expandClassNames).prefix} ${(0, $iMS6j.expandClassNames).type(type)} ${expanded ? (0, $iMS6j.expandClassNames).expanded : ''}`;
}
const $303b6a7761c63646$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $303b6a7761c63646$var$buildExpandClassName(node.type.name, __livePage ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $iMS6j.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $iMS6j.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $iMS6j.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $iMS6j.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $kSoKM.messages).expandArialabel) || (0, $kSoKM.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $kSoKM.messages).expandPlaceholderText) || (0, $kSoKM.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $iMS6j.expandClassNames).content,
                style: (0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true) ? `display: ${__livePage ? !node.attrs.__expanded : node.attrs.__expanded ? 'flow-root' : 'none'}` : undefined,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];
class $303b6a7761c63646$export$e6a0ba759c3724b0 {
    initHandlers() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) this.updateDisplayStyle(this.node);
        });
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node.attrs;
        (0, $d94ff661d09ba197$export$dde15965bbee9f3e)(this.icon, {
            expanded: this.__livePage ? !__expanded : __expanded,
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $47829bbad8b17906$export$e20de71cd82a9fe9), {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            }), this.icon, this.renderKey);
    }
    updateDisplayStyle(node) {
        if (this.content) {
            const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
            this.content.style.display = isCollapsed ? 'none' : 'flow-root';
        }
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $iMS6j.expandClassNames).expanded);
                    if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(node);
                    else this.renderIcon(this && this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
                if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) this.updateDisplayStyle(node);
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            this.nodeViewPortalProviderAPI.remove(this.renderKey);
        }
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $0fa109554c968699$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $0fa109554c968699$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0fa109554c968699$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteExpand = (_event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode)) (0, $0fa109554c968699$export$ea222cb41be5bea0)(this.api?.analytics?.actions)(pos, expandNode)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0fa109554c968699$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $adhil.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).End,
                    selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start,
                        selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $303b6a7761c63646$var$toDOM(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).content}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.intl);
        this.initHandlers();
    }
}
function $303b6a7761c63646$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $303b6a7761c63646$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}



function $b81d4838f9c86ef1$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $b81d4838f9c86ef1$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $70a6c6d5a1b7b8ee$export$656c7661095efe2e)(dispatch, {});
    const isMobile = false;
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        key: (0, $70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                expand: (0, $303b6a7761c63646$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $303b6a7761c63646$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $iMS6j.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                return $b81d4838f9c86ef1$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($b81d4838f9c86ef1$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $hcbpx.findExpand)(state);
                    if (node) {
                        const expandRef = (0, $8m4tT.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $70a6c6d5a1b7b8ee$export$f05434c51e3762e)(state).expandRef !== expandRef) (0, $0fa109554c968699$export$491ffa7e89016e5c)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $b81d4838f9c86ef1$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $hcbpx.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hcbpx.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}



var $61p3e = parcelRequire("61p3e");


var $gKvd9 = parcelRequire("gKvd9");



const $9ab18ecd727cc007$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        // JST-1060364: We are observing this crashing the editor where the `expandPlugin` doesn't exist
        // in the editor (resulting in `Cannot destructure property 'expandRef' of ...`).
        // For now let's add a null check to ensure we don't crash while we investigate further.
        const { expandRef: expandRef } = (0, $70a6c6d5a1b7b8ee$export$f05434c51e3762e)(state) ?? {};
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                        onClick: (0, $0fa109554c968699$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $61p3e.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $57efadb92d61d420$var$EXPAND_NODE_NAME = 'expand';
let $57efadb92d61d420$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $0405d2e291010188$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($57efadb92d61d420$var$EXPAND_NODE_NAME))
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $4r9Pq.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $iw2ID.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $0fa109554c968699$export$982de01464f3ba33)(api?.analytics?.actions),
            insertExpandWithInputMethod: (0, $0fa109554c968699$export$4782944d4b10fd76)(api?.analytics?.actions)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $0fa109554c968699$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $7a3c52dd7aa30a82$export$de35616b4bcd2077
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $b81d4838f9c86ef1$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $2ec9d324b9bded96$export$e4ebafd8ecd98be0)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $9ab18ecd727cc007$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconExpand), {}),
                        action (insert, state) {
                            const node = (0, $0fa109554c968699$export$b7c6a6a1365fc215)(state);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $l9FJJ.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $d925B.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};





parcelRequire("42omo");































// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead










































const $23dc4b86d38a9de7$export$b7c6a6a1365fc215 = (state, setExpandedState = true, addLocalId)=>{
    const { expand: expand, nestedExpand: nestedExpand, paragraph: paragraph } = state.schema.nodes;
    const isSelectionInTable = !!(0, $id9O1.findTable)(state.selection);
    const isSelectionInExpand = (0, $03a586ef1cfe8548$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? expandType.createAndFill(addLocalId ? {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
    } : {}, // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    paragraph.createAndFill(addLocalId ? {
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
    } : {})) : expandType.createAndFill({});
    if (setExpandedState) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $adayn.expandedState).set(expandNode, true);
    return expandNode;
};
const $23dc4b86d38a9de7$export$b07fdfa9172394f4 = (state, node)=>{
    const tr = (0, $l9FJJ.createWrapSelectionTransaction)({
        state: state,
        type: node.type,
        nodeAttributes: node.attrs
    });
    const wrapperNode = (0, $8m4tT.findParentNodeOfType)(node.type)(tr.selection);
    if (wrapperNode) (0, $adayn.expandedState).set(wrapperNode.node, true);
    return tr;
};
const $23dc4b86d38a9de7$export$4782944d4b10fd76 = (api)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $23dc4b86d38a9de7$export$b7c6a6a1365fc215(state, false, !!api?.localId);
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $8m4tT.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $adayn.expandedState).set(expandNode, true);
            } else {
                tr = (0, $l9FJJ.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type,
                    ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                        nodeAttributes: expandNode.attrs
                    }
                });
                const wrapperNode = (0, $8m4tT.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $adayn.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT_ID).EXPAND : (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (dispatch) {
                api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $23dc4b86d38a9de7$export$982de01464f3ba33 = (api)=>(state, dispatch)=>{
        return $23dc4b86d38a9de7$export$4782944d4b10fd76(api)((0, $d925B.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $23dc4b86d38a9de7$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) return false;
        return $23dc4b86d38a9de7$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $23dc4b86d38a9de7$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $ks2lK.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $23dc4b86d38a9de7$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $ks2lK.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $23dc4b86d38a9de7$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $adayn.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $adayn.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $adhil.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $d925B.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $e2wMq.PLATFORMS).WEB,
                    mode: (0, $e2wMq.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            tr.setMeta('scrollIntoView', false);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $23dc4b86d38a9de7$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $23dc4b86d38a9de7$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $23dc4b86d38a9de7$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $23dc4b86d38a9de7$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_native_expand_button cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true) ? expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $23dc4b86d38a9de7$export$6f1dc7179cebfcb1 = (selection)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        // if match is inside a nested expand, open the nested expand
        const nestedExpandNode = (0, $8m4tT.findParentNodeOfType)(nestedExpand)(selection);
        if (nestedExpandNode && (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
            const expanded = (0, $adayn.expandedState).get(nestedExpandNode.node) ?? false;
            if (!expanded) (0, $adayn.expandedState).set(nestedExpandNode.node, true);
        }
        // if match is (also) inside an expand, open the expand
        const expandNode = (0, $8m4tT.findParentNodeOfType)(expand)(selection);
        if (expandNode && (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
            const expanded = (0, $adayn.expandedState).get(expandNode.node) ?? false;
            if (!expanded) (0, $adayn.expandedState).set(expandNode.node, true);
        }
        return tr;
    };


































const $e6879c09d9ccef0f$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $e6879c09d9ccef0f$var$isExpandSelected = (selection)=>selection instanceof (0, $ks2lK.NodeSelection) && $e6879c09d9ccef0f$var$isExpandNode(selection.node);
function $e6879c09d9ccef0f$export$e4ebafd8ecd98be0(api) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($e6879c09d9ccef0f$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($e6879c09d9ccef0f$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($e6879c09d9ccef0f$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $23dc4b86d38a9de7$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $ks2lK.TextSelection) && !(0, $bMyNT.isInTable)(state)) {
                const expand = (0, $hcbpx.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $23dc4b86d38a9de7$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $adayn.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $hcbpx.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $caYZ2.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $adayn.isExpandCollapsed)(expandBefore.node)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $adayn.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $adayn.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $adayn.isExpandCollapsed)(expandBefore.node)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$e6879c09d9ccef0f$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}




















parcelRequire("42omo");





































/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 























function $9e7b30065529e96c$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: props.label,
            position: "top",
            tag: (0, $kSoKM.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)(Component, props)));
    };
}
const $9e7b30065529e96c$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $aFUXX.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const { intl: intl, expanded: expanded } = props;
    const label = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iMS6j.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $9e7b30065529e96c$var$ButtonWithTooltip = $9e7b30065529e96c$var$withTooltip($9e7b30065529e96c$export$aca20190620a52ea);
const $9e7b30065529e96c$var$ButtonWithoutTooltip = $9e7b30065529e96c$export$aca20190620a52ea;
const $9e7b30065529e96c$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($9e7b30065529e96c$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $kSoKM.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($9e7b30065529e96c$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

















const $ae1f32e2614f45d5$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $iMS6j.expandClassNames).prefix} ${(0, $iMS6j.expandClassNames).type(type)} ${expanded ? (0, $iMS6j.expandClassNames).expanded : ''}`;
};
const $ae1f32e2614f45d5$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $ae1f32e2614f45d5$export$f7373e0b2eb22549(node.type.name, (0, $adayn.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $iMS6j.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $iMS6j.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $iMS6j.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $iMS6j.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $kSoKM.messages).expandArialabel) || (0, $kSoKM.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $kSoKM.messages).expandPlaceholderText) || (0, $kSoKM.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $iMS6j.expandClassNames).content,
                style: (0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true) ? `display: ${(0, $adayn.expandedState).get(node) ? 'flow-root' : 'none'}` : undefined,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];











// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
const $0134e57ff27e25ee$var$darkModeSearchMatchClass = 'search-match-dark';
const $0134e57ff27e25ee$var$searchMatchExpandTitleClass = 'search-match-expand-title';
const $0134e57ff27e25ee$var$selectedSearchMatchClass = 'selected-search-match';
const $0134e57ff27e25ee$export$60784e18d5db1cae = (state)=>{
    const nestedOrParentExpand = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
    if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) // If it's nested expand, we should check if its parent expand is collapsed.
    // If the parent expand is collapsed, the nested expand is not visible,
    // so it could not be selected.
    // In this case, we return the parent expand node instead of the nested expand node.
    {
        if (nestedOrParentExpand?.node.type === state.schema.nodes.nestedExpand) {
            const parentExpand = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
            if (parentExpand && (0, $adayn.isExpandCollapsed)(parentExpand.node)) return parentExpand;
        }
    }
    return nestedOrParentExpand;
};
const $0134e57ff27e25ee$export$ce3a0b3822605e07 = [
    $0134e57ff27e25ee$var$darkModeSearchMatchClass,
    $0134e57ff27e25ee$var$searchMatchExpandTitleClass,
    $0134e57ff27e25ee$var$selectedSearchMatchClass
];


class $197804485c007bc9$export$e6a0ba759c3724b0 {
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $adayn.expandedState).get(this.node);
                if (wasExpanded) (0, $adayn.expandedState).set(node, wasExpanded);
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
                this.node = node;
                const hasChanged = this.isExpanded !== (0, $adayn.expandedState).get(node);
                if (hasChanged) {
                    this.updateExpandToggleIcon(node);
                    if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) this.updateDisplayStyle(node);
                }
            } else this.node = node;
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $adayn.expandedState).get(node) ? (0, $adayn.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                const classes = this.dom.className.split(' ');
                // find & replace styles might be applied to the expand title and we need to keep them
                const findReplaceDecorationsApplied = classes.filter((className)=>(0, $0134e57ff27e25ee$export$ce3a0b3822605e07).includes(className)).join(' ');
                this.dom.className = findReplaceDecorationsApplied ? (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded) + ` ${findReplaceDecorationsApplied}` : (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded);
            } else this.dom.className = (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(node);
            else this.renderIcon(this.icon ? this.icon : null, (0, $adayn.expandedState).get(node) ?? false);
        }
        this.updateExpandBodyContentEditable();
        if ((0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) this.isExpanded = expanded;
    }
    updateDisplayStyle(node) {
        if (this.content) this.content.style.display = (0, $adayn.isExpandCollapsed)(node) ? 'none' : 'flow-root';
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        (0, $d94ff661d09ba197$export$dde15965bbee9f3e)(this.icon, {
            expanded: !(0, $adayn.isExpandCollapsed)(node),
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    destroy() {
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        this.nodeViewPortalProviderAPI.remove(this.renderKey);
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange, isExpanded = false){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.isExpanded = isExpanded;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $23dc4b86d38a9de7$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if ((0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $23dc4b86d38a9de7$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) this.updateDisplayStyle(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $23dc4b86d38a9de7$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode)) (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(this.api?.analytics?.actions)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $23dc4b86d38a9de7$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
                if ((0, $1oCLl.expValEquals)('platform_editor_display_none_to_expand', 'isEnabled', true)) this.updateDisplayStyle(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $adayn.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $adhil.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).End,
                    selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start,
                        selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $adayn.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.renderIcon = (icon, expanded)=>{
            if (!icon) return;
            this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9e7b30065529e96c$export$5663c8f5aeb8c1c4), {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                }), icon, this.renderKey);
        };
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $ae1f32e2614f45d5$export$289411c5a7970646)(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleContainer}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.content = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).content}`);
        if (!(0, $adayn.expandedState).has(this.node)) (0, $adayn.expandedState).set(this.node, false);
        if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.icon, !(0, $adayn.isExpandCollapsed)(this.node));
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
}
function $197804485c007bc9$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $197804485c007bc9$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}


const $361634b7ec855877$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('expandPlugin');
function $361634b7ec855877$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $361634b7ec855877$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $1S4f7.SafePlugin)({
        key: $361634b7ec855877$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                expand: (0, $197804485c007bc9$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $197804485c007bc9$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $361634b7ec855877$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $361634b7ec855877$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $361634b7ec855877$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $iMS6j.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                return $361634b7ec855877$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($361634b7ec855877$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        }
    });
};
function $361634b7ec855877$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $hcbpx.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hcbpx.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}













const $294c9fc9dbf7e37f$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const selectedExpandNode = (0, $0134e57ff27e25ee$export$60784e18d5db1cae)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>// Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $8m4tT.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                        onClick: (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $61p3e.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $34ab5564dede0481$var$EXPAND_NODE_NAME = 'expand';
let $34ab5564dede0481$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $0405d2e291010188$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($34ab5564dede0481$var$EXPAND_NODE_NAME))
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $4r9Pq.expandWithNestedExpandLocalId) : (0, $4r9Pq.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $iw2ID.nestedExpandWithLocalId) : (0, $iw2ID.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $23dc4b86d38a9de7$export$982de01464f3ba33)(api),
            insertExpandWithInputMethod: (0, $23dc4b86d38a9de7$export$4782944d4b10fd76)(api)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $23dc4b86d38a9de7$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $7a3c52dd7aa30a82$export$de35616b4bcd2077
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $361634b7ec855877$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $e6879c09d9ccef0f$export$e4ebafd8ecd98be0)(api)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $294c9fc9dbf7e37f$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconExpand), {}),
                        action (insert, state) {
                            const node = (0, $23dc4b86d38a9de7$export$b7c6a6a1365fc215)(state, undefined, !!api?.localId);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $23dc4b86d38a9de7$export$b07fdfa9172394f4)(state, node) : (0, $l9FJJ.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $d925B.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};


let $a184b98f7d3b65cc$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options?.__livePage) return (0, $34ab5564dede0481$export$a4a90f0c2a6f7a01)({
        config: options,
        api: api
    });
    else {
        if ((0, $dh538.fg)('platform-editor-single-player-expand')) return (0, $34ab5564dede0481$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
        else return (0, $57efadb92d61d420$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
    }
};
module.exports["expandPlugin"] = $a184b98f7d3b65cc$export$a4a90f0c2a6f7a01;

});

parcelRegister("05jmd", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lifsC = parcelRequire("lifsC");

var $hVXQj = parcelRequire("hVXQj");





var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $l51YQ = parcelRequire("l51YQ");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");




var $eKaDU = parcelRequire("eKaDU");


var $dAtrv = parcelRequire("dAtrv");


var $3Ter7 = parcelRequire("3Ter7");

var $2pjJ5 = parcelRequire("2pjJ5");


var $5SAOw = parcelRequire("5SAOw");













const $65c263491f5c07f1$export$faa6744ce57d263b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};





const $3b01e13caf7407ac$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('layout');


const $9d764ec1dd06128c$export$6ff908759d68cbdd = [
    'single'
];
const $9d764ec1dd06128c$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $9d764ec1dd06128c$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $9d764ec1dd06128c$var$getWidthsForPreset = (presetLayout)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
        case 'three_left_sidebars':
            return [
                25,
                25,
                50
            ];
        case 'three_right_sidebars':
            return [
                50,
                25,
                25
            ];
        case 'four_equal':
            return [
                25,
                25,
                25,
                25
            ];
        case 'five_equal':
            return [
                20,
                20,
                20,
                20,
                20
            ];
    }
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
    return [];
};
const $9d764ec1dd06128c$var$isValidLayoutWidthDistributions = (layoutSection)=>{
    let totalWidth = 0;
    let hasInvalidWidth = false;
    (0, $3Ter7.mapChildren)(layoutSection, (column)=>column.attrs.width).forEach((width)=>{
        if (typeof width === 'number' && isFinite(width) && width > 0 && width <= 100) totalWidth += width;
        else hasInvalidWidth = true;
    });
    return !hasInvalidWidth && Math.round(totalWidth) === 100;
};
const $9d764ec1dd06128c$export$e406155610be725b = (section)=>{
    const widths = (0, $3Ter7.mapChildren)(section, (column)=>column.attrs.width).join(',');
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
        switch(widths){
            case '100':
                return 'single';
            case '33.33,33.33,33.33':
                return 'three_equal';
            case '25,50,25':
                return 'three_with_sidebars';
            case '50,25,25':
                return 'three_right_sidebars';
            case '25,25,50':
                return 'three_left_sidebars';
            case '50,50':
                return 'two_equal';
            case '33.33,66.66':
                return 'two_left_sidebar';
            case '66.66,33.33':
                return 'two_right_sidebar';
            case '25,25,25,25':
                return 'four_equal';
            case '20,20,20,20,20':
                return 'five_equal';
        }
        return;
    }
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $9d764ec1dd06128c$var$isLayoutOutOfSync = (node, presetLayout)=>{
    return node.childCount !== $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout).length;
};
const $9d764ec1dd06128c$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $9d764ec1dd06128c$var$isLayoutOutOfSync(maybeLayoutSection, current) && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $9d764ec1dd06128c$var$getDefaultPresetLayout(maybeLayoutSection);
    if (maybeLayoutSection && $9d764ec1dd06128c$export$e406155610be725b(maybeLayoutSection)) return $9d764ec1dd06128c$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $9d764ec1dd06128c$export$af0aef1ee58dfcf = (state, numberOfColumns = 2)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    const columns = (0, $5SAOw.Fragment).fromArray(Array.from({
        length: numberOfColumns
    }, ()=>layoutColumn.createAndFill({
            width: (0, $65c263491f5c07f1$export$faa6744ce57d263b)[numberOfColumns]
        })));
    return layoutSection.createAndFill(undefined, columns);
};
const $9d764ec1dd06128c$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $5SAOw.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $9d764ec1dd06128c$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $8m4tT.safeInsert)($9d764ec1dd06128c$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $9d764ec1dd06128c$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: inputMethod,
                columnCount: (0, $dh538.fg)('platform_editor_column_count_analytics') ? 2 : undefined
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })((state, dispatch)=>{
            if (dispatch) dispatch((0, $8m4tT.safeInsert)($9d764ec1dd06128c$export$24df8f7ba30643b8(state))(state.tr));
            return true;
        });
/**
 * Add a column to the right of existing layout
 */ function $9d764ec1dd06128c$var$addColumn(schema, pos) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', false)) return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill(undefined));
    };
}
function $9d764ec1dd06128c$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        // check if the column only contains a paragraph with a placeholder text
        // if so, remove the whole column, otherwise just remove the paragraph
        if ((0, $2pjJ5.isEmptyDocument)(column)) {
            const fromPos = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? columnPos : columnPos - 1;
            tr.replaceRange(tr.mapping.map(fromPos), tr.mapping.map(insideRightEdgePos), (0, $5SAOw.Slice).empty);
        } else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $5SAOw.Slice).empty);
    };
}
const $9d764ec1dd06128c$var$fromTwoColsToThree = $9d764ec1dd06128c$var$addColumn;
const $9d764ec1dd06128c$var$fromOneColToTwo = $9d764ec1dd06128c$var$addColumn;
const $9d764ec1dd06128c$var$fromTwoColsToOne = $9d764ec1dd06128c$var$removeLastColumnInLayout;
const $9d764ec1dd06128c$var$fromThreeColsToTwo = $9d764ec1dd06128c$var$removeLastColumnInLayout;
const $9d764ec1dd06128c$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
        $9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
    };
};
const $9d764ec1dd06128c$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $9d764ec1dd06128c$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $9d764ec1dd06128c$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
const $9d764ec1dd06128c$var$increaseColumns = (schema, pos, newColumnsNumber = 1)=>{
    return (tr)=>{
        for(let i = 0; i < newColumnsNumber; i++)$9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
    };
};
const $9d764ec1dd06128c$var$decreaseColumns = (node, insideRightEdgePos, columnsNumberToRemove = 1)=>{
    return (tr)=>{
        let endPos = insideRightEdgePos;
        let lastColumn = node.content.lastChild;
        for(let i = 0; i < columnsNumberToRemove; i++){
            lastColumn && $9d764ec1dd06128c$var$removeLastColumnInLayout(lastColumn, endPos - lastColumn.nodeSize, endPos)(tr);
            endPos -= lastColumn?.nodeSize || 0;
            lastColumn = node.content.child(node.childCount - i - 2);
        }
    };
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $9d764ec1dd06128c$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($9d764ec1dd06128c$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $9d764ec1dd06128c$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($9d764ec1dd06128c$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $9d764ec1dd06128c$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($9d764ec1dd06128c$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $9d764ec1dd06128c$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($9d764ec1dd06128c$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $9d764ec1dd06128c$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($9d764ec1dd06128c$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $9d764ec1dd06128c$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($9d764ec1dd06128c$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $9d764ec1dd06128c$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $9d764ec1dd06128c$var$forceColumnStructureNew(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    const columnChange = $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout).length - numCols;
    if (columnChange > 0) $9d764ec1dd06128c$var$increaseColumns(state.schema, insideRightEdgeOfLayoutSection, columnChange)(tr);
    else if (columnChange < 0) $9d764ec1dd06128c$var$decreaseColumns(node, insideRightEdgeOfLayoutSection, -columnChange)(tr);
    return tr;
}
function $9d764ec1dd06128c$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $3Ter7.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $9d764ec1dd06128c$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $9d764ec1dd06128c$var$columnWidth(node, state.schema, $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout)));
}
function $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    const forceColumnStructureFn = (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $9d764ec1dd06128c$var$forceColumnStructureNew : $9d764ec1dd06128c$var$forceColumnStructure;
    let tr = forceColumnStructureFn(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $9d764ec1dd06128c$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $ks2lK.NodeSelection) ? new (0, $ks2lK.NodeSelection)(selectionPos$) : new (0, $ks2lK.TextSelection)(selectionPos$));
}
const $9d764ec1dd06128c$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
            if (pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            if (selectedLayout === layout && node.childCount > 1) return false;
            const tr = $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $9d764ec1dd06128c$var$formatLayoutName(selectedLayout),
                        newLayout: $9d764ec1dd06128c$var$formatLayoutName(layout)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $9d764ec1dd06128c$var$layoutNeedChanges(node) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return !$9d764ec1dd06128c$export$e406155610be725b(node) || !$9d764ec1dd06128c$var$isValidLayoutWidthDistributions(node);
    return !$9d764ec1dd06128c$export$e406155610be725b(node);
}
const $9d764ec1dd06128c$var$getDefaultPresetLayout = (layoutNode)=>{
    const layoutColumnCount = layoutNode.childCount;
    if (layoutColumnCount <= 1) return 'single';
    switch(layoutColumnCount){
        case 1:
            return 'single';
        case 2:
            return 'two_equal';
        case 3:
            return 'three_equal';
        case 4:
            return 'four_equal';
        case 5:
            return 'five_equal';
        default:
            return 'five_equal';
    }
};
function $9d764ec1dd06128c$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$9d764ec1dd06128c$var$layoutNeedChanges(node)) return;
        const presetLayout = (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $9d764ec1dd06128c$var$getDefaultPresetLayout(node) : node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $9d764ec1dd06128c$var$columnWidth(node, schema, $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $5SAOw.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $9d764ec1dd06128c$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $2pjJ5.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($9d764ec1dd06128c$var$layoutNeedChanges(node)) change = $9d764ec1dd06128c$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $9d764ec1dd06128c$var$layoutNeedChanges(node)) change = $9d764ec1dd06128c$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $9d764ec1dd06128c$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node) {
            if (node.childCount !== $9d764ec1dd06128c$var$getWidthsForPreset(selectedLayout).length) return $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
            if (!$9d764ec1dd06128c$var$isValidLayoutWidthDistributions(node) && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
        }
    }
    return;
};
const $9d764ec1dd06128c$export$7472487719e2c16f = (editorAnalyticsAPI, inputMethod)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                const tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).DELETED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $9d764ec1dd06128c$var$formatLayoutName(selectedLayout),
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $9d764ec1dd06128c$var$formatLayoutName = (layout)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) switch(layout){
        case 'single':
            return (0, $eKaDU.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $eKaDU.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
        case 'four_equal':
            return (0, $eKaDU.LAYOUT_TYPE).FOUR_COLS_EQUAL;
        case 'five_equal':
            return (0, $eKaDU.LAYOUT_TYPE).FIVE_COLS_EQUAL;
    }
    switch(layout){
        case 'single':
            return (0, $eKaDU.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $eKaDU.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};



var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");


var $e7tBw = parcelRequire("e7tBw");


var $dus6D = parcelRequire("dus6D");











var $ftzrq = parcelRequire("ftzrq");








var $adhil = parcelRequire("adhil");










const $2bde854adcad6d37$export$9adba9ade368b431 = (state)=>{
    const { schema: { nodes: { layoutSection: layoutSection, layoutColumn: layoutColumn } }, selection: selection } = state;
    const isLayoutColumn = (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $8m4tT.findSelectedNodeOfType)([
        layoutColumn
    ])(selection);
    // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
    return isLayoutColumn ? undefined : (0, $8m4tT.findParentNodeOfType)(layoutSection)(selection) || (0, $8m4tT.findSelectedNodeOfType)([
        layoutSection
    ])(selection);
};
/**
 * The depth of the layout column inside the layout section.
 * As per the current implementation, the layout column ALWAYS has a depth of 1.
 */ const $2bde854adcad6d37$var$LAYOUT_COLUMN_DEPTH = 1;
const $2bde854adcad6d37$export$c13dbc07830c6c42 = (view, posOfLayout, childIndex = 0)=>{
    const $maybeLayoutSection = view.state.doc.resolve(posOfLayout);
    if ($maybeLayoutSection.nodeAfter?.type.name === 'layoutSection') {
        const layoutSectionNode = $maybeLayoutSection.nodeAfter;
        // check if the childIndex is valid
        if (childIndex < 0 || childIndex >= layoutSectionNode.childCount) return;
        const childPos = $maybeLayoutSection.posAtIndex(childIndex, $2bde854adcad6d37$var$LAYOUT_COLUMN_DEPTH);
        const tr = view.state.tr;
        const $selectionPos = tr.doc.resolve(childPos);
        if (layoutSectionNode.firstChild?.type.name === 'paragraph') view.dispatch(tr.setSelection((0, $ks2lK.TextSelection).near($selectionPos)));
        else view.dispatch(tr.setSelection((0, $adhil.GapCursorSelection).near($selectionPos)));
        return tr;
    }
};


const $ef7d532c79770eba$export$cfaf3f619f4fde4d = 'two_equal';
const $ef7d532c79770eba$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $ef7d532c79770eba$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const section = (0, $8m4tT.findParentNodeOfType)(layoutSection)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const column = (0, $8m4tT.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $ks2lK.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
const $ef7d532c79770eba$var$getNodeDecoration = (pos, node)=>[
        (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
const $ef7d532c79770eba$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $2bde854adcad6d37$export$9adba9ade368b431)(state);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $9d764ec1dd06128c$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, $ef7d532c79770eba$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout,
        isResizing: false
    };
};
// To prevent a single-column layout,
// if a user attempts to delete a layout column and
// we will force remove the content instead.
// There are some edge cases where user can delete a layout column
// see packages/editor/editor-plugin-layout-tests/src/__tests__/unit/delete.ts
const $ef7d532c79770eba$var$handleDeleteLayoutColumn = (state, dispatch)=>{
    const sel = state.selection;
    if (sel instanceof (0, $ks2lK.NodeSelection) && sel.node.type.name === 'layoutColumn' && sel.$from.parent.type.name === 'layoutSection' && sel.$from.parent.childCount === 2 && dispatch && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && !(0, $iu6m9.editorExperiment)('single_column_layouts', true)) {
        const tr = state.tr;
        const layoutContentFragment = sel.$from.parentOffset === 0 ? (0, $5SAOw.Fragment).from(sel.$from.parent.lastChild?.content) : (0, $5SAOw.Fragment).from(sel.$from.parent.firstChild?.content);
        const parent = (0, $8m4tT.findParentNodeClosestToPos)(sel.$from, (node)=>{
            return node.type.name === 'layoutSection';
        });
        if (parent) {
            const layoutSectionPos = tr.mapping.map(parent.pos);
            const layoutSectionNodeSize = parent.node.nodeSize;
            dispatch(state.tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment));
            return true;
        }
        return false;
    }
    return false;
};
var $ef7d532c79770eba$export$2e2bcd8739ae039 = (options)=>new (0, $1S4f7.SafePlugin)({
        key: (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1),
        state: {
            init: (_, state)=>$ef7d532c79770eba$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, oldState, newState)=>{
                const isResizing = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? tr.getMeta('is-resizer-resizing') ?? (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(oldState)?.isResizing : false;
                if (tr.docChanged || tr.selectionSet) {
                    const maybeLayoutSection = (0, $2bde854adcad6d37$export$9adba9ade368b431)(newState);
                    const newPluginState = {
                        ...pluginState,
                        pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                        isResizing: isResizing,
                        selectedLayout: (0, $9d764ec1dd06128c$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pluginState.selectedLayout)
                    };
                    return newPluginState;
                }
                return {
                    ...pluginState,
                    isResizing: isResizing
                };
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
                if (layoutState.pos !== null) return (0, $ftzrq.DecorationSet).create(state.doc, $ef7d532c79770eba$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)));
                return undefined;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Tab: (0, $e7tBw.filterCommand)($ef7d532c79770eba$var$isWholeSelectionInsideLayoutColumn, $ef7d532c79770eba$var$moveCursorToNextColumn),
                'Mod-Backspace': $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                'Mod-Delete': $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                Backspace: $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                Delete: $ef7d532c79770eba$var$handleDeleteLayoutColumn
            }),
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'layoutColumn'
            ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                useLongPressSelection: options.useLongPressSelection || false,
                getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
            })
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            const changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                const change = (0, $9d764ec1dd06128c$export$ea5c48c44d467c6)(prevTr, newState);
                if (change) changes.push(change);
            });
            if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && changes.length === 1) {
                const change = changes[0];
                // When editorExperiment('single_column_layouts', true) is on
                // delete can create a single column layout
                // otherwise we replace the single column layout with its content
                if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true) && change.slice.content.childCount === 1 && change.slice.content.firstChild?.type.name === 'layoutColumn' && change.slice.content.firstChild?.attrs.width === (0, $65c263491f5c07f1$export$faa6744ce57d263b)[1]) {
                    const tr = newState.tr;
                    const { content: content } = change.slice.content.firstChild;
                    tr.replaceWith(change.from - 1, change.to, content);
                    return tr;
                }
            }
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $9d764ec1dd06128c$export$35e1f731e4a1d52)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $ks2lK.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });













var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $2gkmX = parcelRequire("2gkmX");





var $fFa3V = parcelRequire("fFa3V");


var $aFUXX = parcelRequire("aFUXX");





var $1oCLl = parcelRequire("1oCLl");








var $boKri = parcelRequire("boKri");


var $d7ZU3 = parcelRequire("d7ZU3");


var $8b5jG = parcelRequire("8b5jG");


var $7x0qS = parcelRequire("7x0qS");










const $946a54e61dd6924e$export$6cdb476c834bc60 = 8;
const $946a54e61dd6924e$var$GUIDELINE_KEYS = {
    lineLength: 'grid',
    wide: 'wide',
    fullWidth: 'full_width'
};
const $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS = {
    lineLength: 'center',
    wide: 'wide',
    fullWidth: 'full-width'
};
const $946a54e61dd6924e$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
function $946a54e61dd6924e$export$54a1e15ba45852e2(getEditorWidth, isResizing, dynamicFullWidthGuidelineOffset = 0) {
    const widthState = getEditorWidth();
    const { lineLength: lineLength, wide: wide, fullWidth: fullWidth } = (0, $42omo.useMemo)(()=>{
        if (!isResizing) return {};
        const { width: width, lineLength: lineLength } = widthState || {};
        const wideCalWithRatio = lineLength ? Math.round(lineLength * (0, $aFUXX.breakoutWideScaleRatio)) : undefined;
        // When page is full width, lineLength from widthState can be much wider than 760.
        // But the lineLength variable here is being used like a const 760.
        // when the page is full width, the calculation of wide is wrong.
        // Actuall the wide is the wide breakout point, which is
        const wide = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
        const padding = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : undefined;
        return {
            wide: wide,
            fullWidth: fullWidth,
            // When page is full width, lineLength from widthState can be much wider than 760.
            // But the lineLength variable here is being used like a const 760.
            lineLength: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorDefaultLayoutWidth) : lineLength
        };
    }, [
        widthState,
        isResizing,
        dynamicFullWidthGuidelineOffset
    ]);
    // calculate snapping width
    const defaultSnappingWidths = (0, $42omo.useMemo)(()=>{
        if (!fullWidth || !wide || !lineLength || fullWidth <= ((0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorDefaultLayoutWidth) : lineLength)) return null;
        if (fullWidth - wide > $946a54e61dd6924e$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            wide: wide,
            fullWidth: fullWidth
        };
        if (fullWidth <= wide && fullWidth - lineLength > $946a54e61dd6924e$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            fullWidth: fullWidth
        };
        return null;
    }, [
        fullWidth,
        lineLength,
        wide
    ]);
    const snaps = (0, $42omo.useMemo)(()=>{
        if (!isResizing || !defaultSnappingWidths) return null;
        return {
            x: Object.values(defaultSnappingWidths)
        };
    }, [
        defaultSnappingWidths,
        isResizing
    ]);
    // calculate guidelines, and calculate which lines are active
    const [currentLayout, setCurrentLayout] = (0, $42omo.useState)(null);
    const guidelines = (0, $42omo.useMemo)(()=>{
        const guidelines = [];
        if (!defaultSnappingWidths) return guidelines;
        Object.entries(defaultSnappingWidths).map(([key, value])=>{
            if (value) {
                guidelines.push({
                    key: `${$946a54e61dd6924e$var$GUIDELINE_KEYS[key]}_left`,
                    position: {
                        x: -$946a54e61dd6924e$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS[key]
                });
                guidelines.push({
                    key: `${$946a54e61dd6924e$var$GUIDELINE_KEYS[key]}_right`,
                    position: {
                        x: $946a54e61dd6924e$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS[key]
                });
            }
        });
        return guidelines;
    }, [
        defaultSnappingWidths,
        currentLayout
    ]);
    const setCurrentWidth = (0, $42omo.useCallback)((newWidth)=>{
        if (typeof newWidth !== 'number') {
            setCurrentLayout(null);
            return;
        }
        if (lineLength && Math.abs(newWidth - lineLength) < $946a54e61dd6924e$export$6cdb476c834bc60 / 2) setCurrentLayout('center');
        else if (wide && Math.abs(newWidth - wide) < $946a54e61dd6924e$export$6cdb476c834bc60 / 2) setCurrentLayout('wide');
        else if (fullWidth && // we only allow snap from one side, so we don't use Math.abs here
        (fullWidth + (0, $aFUXX.akEditorGutterPadding) - newWidth < $946a54e61dd6924e$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth)) setCurrentLayout('full-width');
        else setCurrentLayout(null);
    }, [
        lineLength,
        wide,
        fullWidth
    ]);
    return {
        snaps: snaps,
        currentLayout: currentLayout,
        guidelines: guidelines,
        setCurrentWidth: setCurrentWidth
    };
}


const $4cf13f9507f13269$var$breakoutSupportedNodes = [
    'layoutSection',
    'expand',
    'codeBlock'
];
const $4cf13f9507f13269$var$getHandleStyle = (node, hidden)=>{
    const layoutMarginOffset = 12;
    if (hidden) return {
        left: {
            display: 'none'
        },
        right: {
            display: 'none'
        }
    };
    switch(node){
        case 'codeBlock':
            return {
                left: {
                    left: '-12px'
                },
                right: {
                    right: '-12px'
                }
            };
        // expand and layout section elements have a negative margin applied
        default:
            const handleOffset = (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $boKri.LAYOUT_SECTION_MARGIN) * 2 + layoutMarginOffset : (0, $boKri.LAYOUT_COLUMN_PADDING) * 2;
            return {
                left: {
                    left: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                },
                right: {
                    right: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                }
            };
    }
};
const $4cf13f9507f13269$export$256eed97177e990e = (mutation)=>{
    if (mutation.target instanceof Element) return mutation.target.classList.contains('resizer-item') || mutation.type === 'attributes' && mutation.attributeName === 'style';
    return mutation.type === 'attributes' && mutation.attributeName === 'style';
};
const $4cf13f9507f13269$var$resizingStyles = {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'grid'
};
// Apply grid to stop drag handles rendering inside .resizer-item affecting its height
const $4cf13f9507f13269$var$defaultStyles = {
    display: 'grid'
};
const $4cf13f9507f13269$var$RESIZE_STEP_VALUE = 10;
/**
 * BreakoutResizer is a common component used to resize nodes that support the 'Breakout' mark, so it requires
 * correct ADF support.
 *
 * use experiment platform_editor_advanced_layouts
 * @param root0
 * @param root0.editorView
 * @param root0.nodeType
 * @param root0.getPos
 * @param root0.getRef
 * @param root0.disabled
 * @param root0.getEditorWidth
 * @param root0.parentRef
 * @param root0.displayGuidelines
 * @param root0.editorAnalyticsApi
 * @param root0.displayGapCursor
 * @param root0.onResizeStart
 * @param root0.dynamicFullWidthGuidelineOffset
 * @param root0.hidden Hide the resizer handles without outright unrendering them
 * @returns BreakoutResizer component
 * @example
 */ const $4cf13f9507f13269$export$d6c278682f48fbc4 = ({ editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: hidden = false })=>{
    const [{ minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing }, setResizingState] = (0, $42omo.useState)({
        minWidth: undefined,
        maxWidth: undefined,
        isResizing: false
    });
    const areResizeMetaKeysPressed = (0, $42omo.useRef)(false);
    const resizerRef = (0, $42omo.useRef)(null);
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $946a54e61dd6924e$export$54a1e15ba45852e2)(getEditorWidth, isResizing && (0, $iu6m9.editorExperiment)('single_column_layouts', true), dynamicFullWidthGuidelineOffset);
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    (0, $42omo.useEffect)(()=>{
        if (displayGuidelines) displayGuidelines(guidelines || []);
    }, [
        displayGuidelines,
        guidelines
    ]);
    // Relying on re-renders caused by selection changes inside/around node
    const isSelectionInNode = (0, $42omo.useMemo)(()=>{
        const pos = getPos();
        if (pos === undefined) return false;
        const node = editorView.state.doc.nodeAt(pos);
        if (node === null) return false;
        const endPos = pos + node.nodeSize;
        const startPos = pos;
        const { $from: $from, $to: $to } = editorView.state.selection;
        return $from.pos >= startPos && endPos >= $to.pos;
    }, [
        editorView.state.doc,
        editorView.state.selection,
        getPos
    ]);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        onResizeStart?.();
        let newMinWidth;
        let newMaxWidth;
        const widthState = getEditorWidth();
        const { dispatch: dispatch, state: state } = editorView;
        displayGapCursor(false);
        if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
            const padding = widthState.width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
            newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $aFUXX.akEditorGutterPadding), (0, $aFUXX.akEditorFullWidthLayoutWidth));
            newMinWidth = Math.min(widthState.lineLength, (0, $aFUXX.akEditorDefaultLayoutWidth), newMaxWidth);
        }
        setResizingState({
            isResizing: true,
            minWidth: newMinWidth,
            maxWidth: newMaxWidth
        });
        dispatch(state.tr.setMeta('is-resizer-resizing', true));
    }, [
        onResizeStart,
        getEditorWidth,
        editorView,
        displayGapCursor
    ]);
    const handleResize = (0, $42omo.useCallback)((originalState, delta)=>{
        if ((0, $iu6m9.editorExperiment)('single_column_layouts', true)) {
            const newWidth = originalState.width + delta.width;
            setCurrentWidth(newWidth);
        }
    }, [
        setCurrentWidth
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((originalState, delta)=>{
        const newWidth = originalState.width + delta.width;
        const pos = getPos();
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        const { breakout: breakout } = state.schema.marks;
        const node = state.doc.nodeAt(pos);
        const newTr = state.tr;
        if (node && $4cf13f9507f13269$var$breakoutSupportedNodes.includes(node.type.name)) {
            if (currentLayout && [
                'wide',
                'full-width'
            ].includes(currentLayout) && (0, $iu6m9.editorExperiment)('single_column_layouts', true)) newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    mode: currentLayout,
                    width: null
                })
            ]);
            else {
                const newBreakoutWidth = Math.max(newWidth, (0, $aFUXX.akEditorDefaultLayoutWidth));
                newTr.setNodeMarkup(pos, node.type, node.attrs, [
                    breakout.create({
                        width: newBreakoutWidth
                    })
                ]);
                const breakoutResizePayload = {
                    action: (0, $d925B.ACTION).RESIZED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: node.type.name,
                        prevWidth: originalState.width,
                        newWidth: newBreakoutWidth
                    }
                };
                editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
            }
        }
        newTr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
        displayGapCursor(true);
        dispatch(newTr);
        setResizingState({
            isResizing: false,
            minWidth: undefined,
            maxWidth: undefined
        });
        setCurrentWidth(null);
    }, [
        getPos,
        editorView,
        displayGapCursor,
        setCurrentWidth,
        currentLayout,
        editorAnalyticsApi
    ]);
    const handleEscape = (0, $42omo.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleLayoutSizeChangeOnKeypress = (0, $42omo.useCallback)((step)=>{
        if (!parentRef) return;
        const resizerItem = parentRef.closest('.resizer-item');
        if (!(resizerItem instanceof HTMLElement)) return;
        const newWidth = resizerItem.offsetWidth + step;
        if (maxWidth && newWidth > maxWidth || minWidth && newWidth < minWidth) return;
        handleResizeStop({
            width: resizerItem.offsetWidth,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        handleResizeStop,
        maxWidth,
        minWidth,
        parentRef
    ]);
    const resizeHandleKeyDownHandler = (0, $42omo.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleLayoutSizeChangeOnKeypress(event.code === 'BracketRight' ? $4cf13f9507f13269$var$RESIZE_STEP_VALUE : -$4cf13f9507f13269$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleLayoutSizeChangeOnKeypress,
        browser
    ]);
    const resizeHandleKeyUpHandler = (0, $42omo.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    const resizerGlobalKeyDownHandler = (0, $42omo.useCallback)((event)=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isTargetResizeHandle = event.target instanceof HTMLElement && event.target.classList.contains('resizer-handle-thumb');
        if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR' || isTargetResizeHandle && (event.altKey || metaKey || event.shiftKey)) {
            event.preventDefault();
            if (!resizeHandleThumbEl) return;
            resizeHandleThumbEl.focus();
            resizeHandleThumbEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, [
        resizerRef,
        browser
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!resizerRef.current || !editorView) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        if (!resizeHandleThumbEl) return;
        const editorViewDom = editorView.dom;
        const unbindEditorViewDom = (0, $fFa3V.bind)(editorViewDom, {
            type: 'keydown',
            listener: resizerGlobalKeyDownHandler
        });
        const unbindResizeHandle = (0, $fFa3V.bindAll)(resizeHandleThumbEl, [
            {
                type: 'keydown',
                listener: resizeHandleKeyDownHandler
            },
            {
                type: 'keyup',
                listener: resizeHandleKeyUpHandler
            }
        ]);
        return ()=>{
            unbindEditorViewDom();
            unbindResizeHandle();
        };
    }, [
        editorView,
        resizerGlobalKeyDownHandler,
        resizeHandleKeyDownHandler,
        resizeHandleKeyUpHandler
    ]);
    if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "breakout-resizer-editor-view-wrapper",
        ref: (ref)=>getRef && getRef(ref)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b5jG.default), {
        ref: resizerRef,
        enable: {
            left: true,
            right: true
        },
        snap: snaps || undefined,
        snapGap: (0, $946a54e61dd6924e$export$6cdb476c834bc60),
        handleStyles: $4cf13f9507f13269$var$getHandleStyle(nodeType, hidden),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: isResizing ? $4cf13f9507f13269$var$resizingStyles : $4cf13f9507f13269$var$defaultStyles,
        handleResizeStart: handleResizeStart,
        handleResizeStop: handleResizeStop,
        handleResize: handleResize,
        childrenDOMRef: getRef,
        resizeRatio: 2,
        isHandleVisible: isSelectionInNode,
        handleSize: "clamped",
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleAlignmentMethod: "sticky",
        labelComponent: currentLayout && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && [
            'full-width',
            'wide'
        ].includes(currentLayout || '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7x0qS.ResizerBreakoutModeLabel), {
            layout: currentLayout
        })
    });
};



var $b3YrF = parcelRequire("b3YrF");














const $ba567578d7e42e9a$var$layoutDynamicFullWidthGuidelineOffset = 16;
const $ba567578d7e42e9a$var$isEmptyParagraph = (node)=>{
    return !!node && node.type.name === 'paragraph' && !node.childCount;
};
const $ba567578d7e42e9a$var$isBreakoutAvailable = (schema)=>{
    return Boolean(schema.marks.breakout);
};
const $ba567578d7e42e9a$var$isEmptyLayout = (node)=>{
    if (!node) return false;
    // fast check
    // each column should have size 2 from layoutcolumn and 2 from empty paragraph
    if (node.content.size / node.childCount !== 4) return false;
    let isEmpty = true;
    node.content.forEach((maybelayoutColumn)=>{
        if (maybelayoutColumn.type.name !== 'layoutColumn' || maybelayoutColumn.childCount > 1 || !$ba567578d7e42e9a$var$isEmptyParagraph(maybelayoutColumn.firstChild)) {
            isEmpty = false;
            return;
        }
    });
    return isEmpty;
};
const $ba567578d7e42e9a$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $ba567578d7e42e9a$var$LayoutBreakoutResizer = ({ pluginInjectionApi: pluginInjectionApi, forwardRef: forwardRef, getPos: getPos, view: view, parentRef: parentRef })=>{
    const { editorDisabled: editorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled'
    ], $ba567578d7e42e9a$var$selector);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const getEditorWidth = ()=>{
        return pluginInjectionApi?.width?.sharedState.currentState();
    };
    const displayGapCursor = (0, $42omo.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const displayGuidelines = (0, $42omo.useCallback)((guidelines)=>{
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: guidelines
        });
    }, [
        pluginInjectionApi,
        view
    ]);
    // we want to hide the floating toolbar for other nodes.
    // e.g. info panel inside the current layout section
    const selectIntoCurrentLayout = (0, $42omo.useCallback)(()=>{
        const pos = getPos();
        if (pos === undefined) return;
        // put the selection into the first column of the layout
        (0, $2bde854adcad6d37$export$c13dbc07830c6c42)(view, pos, 0);
    }, [
        getPos,
        view
    ]);
    if (interactionState === 'hasNotHadInteraction' && !(0, $1oCLl.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4cf13f9507f13269$export$d6c278682f48fbc4), {
        getRef: forwardRef,
        getPos: getPos,
        editorView: view,
        nodeType: "layoutSection",
        getEditorWidth: getEditorWidth,
        disabled: (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) ? true : editorDisabled === true || !$ba567578d7e42e9a$var$isBreakoutAvailable(view.state.schema),
        hidden: interactionState === 'hasNotHadInteraction' && (0, $1oCLl.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true),
        parentRef: parentRef,
        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
        displayGuidelines: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? displayGuidelines : undefined,
        displayGapCursor: displayGapCursor,
        onResizeStart: ()=>{
            selectIntoCurrentLayout();
        },
        dynamicFullWidthGuidelineOffset: $ba567578d7e42e9a$var$layoutDynamicFullWidthGuidelineOffset
    });
};
const $ba567578d7e42e9a$var$toDOM = (node)=>[
        'div',
        {
            class: 'layout-section-container'
        },
        [
            'div',
            {
                'data-layout-section': true,
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                    'data-local-id': node.attrs.localId
                }
            },
            0
        ]
    ];
class $ba567578d7e42e9a$export$8bfc7bdc15be731c extends (0, $2gkmX.default) {
    /**
   * getContentDOM
   * @example
   * @returns
   */ getContentDOM() {
        const { dom: container, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $ba567578d7e42e9a$var$toDOM(this.node));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.layoutDOM = container.querySelector('[data-layout-section]');
        this.layoutDOM.setAttribute('data-column-rule-style', this.node.attrs.columnRuleStyle);
        this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $dh538.fg)('platform_editor_adf_with_localid')) this.layoutDOM.setAttribute('data-local-id', this.node.attrs.localId);
        return {
            dom: container,
            contentDOM: contentDOM
        };
    }
    /**
   * setDomAttrs
   * @param node
   * @param element
   * @example
   */ setDomAttrs(node, element) {
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle);
    }
    /**
   * render
   * @param props
   * @param forwardRef
   * @example
   * @returns
   */ render(props, forwardRef) {
        this.isEmpty = $ba567578d7e42e9a$var$isEmptyLayout(this.node);
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($ba567578d7e42e9a$var$LayoutBreakoutResizer, {
            pluginInjectionApi: props.pluginInjectionApi,
            forwardRef: forwardRef,
            getPos: props.getPos,
            view: props.view,
            parentRef: this.layoutDOM
        });
    }
    /**
   * ignoreMutation
   * @param mutation
   * @example
   * @returns
   */ ignoreMutation(mutation) {
        return (0, $4cf13f9507f13269$export$256eed97177e990e)(mutation);
    }
    /**
   * constructor
   * @param props
   * @param props.node
   * @param props.view
   * @param props.getPos
   * @param props.portalProviderAPI
   * @param props.eventDispatcher
   * @param props.pluginInjectionApi
   * @param props.options
   * @example
   */ constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.layoutDOM = void 0;
        this.isEmpty = void 0;
        this.isEmpty = $ba567578d7e42e9a$var$isEmptyLayout(this.node);
        this.options = props.options;
    }
}


const $2026add019094e18$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('layoutResizingPlugin');
var $2026add019094e18$export$2e2bcd8739ae039 = (options, pluginInjectionApi, portalProviderAPI, eventDispatcher)=>new (0, $1S4f7.SafePlugin)({
        key: $2026add019094e18$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                layoutSection: (node, view, getPos)=>{
                    return new (0, $ba567578d7e42e9a$export$8bfc7bdc15be731c)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        options: options
                    }).init();
                }
            }
        }
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");







const $cd4b583b7f685bd2$var$PLACEHOLDER_SELECTOR = '.ProseMirror-focused .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)';
const $cd4b583b7f685bd2$var$getPlaceholderStyle = (message)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $9K4OG.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`${$cd4b583b7f685bd2$var$PLACEHOLDER_SELECTOR}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-subtlest, #6B6E76)",
                pointerEvents: 'none'
            }
        }
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '.ProseMirror .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-disabled, #A5ADBA)",
                font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                marginTop: "var(--ds-space-050, 4px)",
                pointerEvents: 'none'
            }
        }
    });
};
const $cd4b583b7f685bd2$export$cc5403d58ddfa812 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const placeholderStyle = (0, $42omo.useMemo)(()=>{
        const placeholderText = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $l51YQ.toolbarMessages).controlslayoutPlaceholder : (0, $l51YQ.toolbarMessages).layoutPlaceholder;
        return $cd4b583b7f685bd2$var$getPlaceholderStyle(formatMessage(placeholderText));
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: placeholderStyle
    });
};





parcelRequire("42omo");








var $eKkkY = parcelRequire("eKkkY");


var $2GVu1 = parcelRequire("2GVu1");


var $asgOl = parcelRequire("asgOl");

const $2f8097f6f209c685$var$NODE_NAME = 'layoutSection';
const $2f8097f6f209c685$var$LayoutBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.layoutSection, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $2f8097f6f209c685$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($asgOl))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).layout)
    });
};
const $2f8097f6f209c685$export$83047c2fe2258f8 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($2f8097f6f209c685$var$LayoutBlockMenuItem, {
            api: api
        });
};





parcelRequire("42omo");





var $61p3e = parcelRequire("61p3e");




var $iHzeA = parcelRequire("iHzeA");








var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $bmsMK = parcelRequire("bmsMK");


var $f22ZH = parcelRequire("f22ZH");


var $5NtbR = parcelRequire("5NtbR");





var $e0qVa = parcelRequire("e0qVa");


var $dIYpm = parcelRequire("dIYpm");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $gF8oK = parcelRequire("gF8oK");


var $2q3lZ = parcelRequire("2q3lZ");

function $b6015fa02fe61471$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b6015fa02fe61471$var$wrapperStyle = {
    name: "dzd8y1",
    styles: "padding:0 4px"
};
const $b6015fa02fe61471$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $b6015fa02fe61471$var$wrapperStyle
    }, children);
};
const $b6015fa02fe61471$export$3cfd1ab6a9856e7e = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($b6015fa02fe61471$var$Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF8oK))), {
        label: ""
    }));
};
const $b6015fa02fe61471$export$38b01bd15f6a5487 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($b6015fa02fe61471$var$Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2q3lZ))), {
        label: ""
    }));
};





parcelRequire("42omo");


var $4ED0i = parcelRequire("4ED0i");

const $43d7012a9bdae225$export$4518caee70c71b2e = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ED0i))), {
        ...props
    });
};





parcelRequire("42omo");


var $hLZr6 = parcelRequire("hLZr6");

const $a8a38269ac67ed48$export$36efe6f2091df089 = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLZr6))), {
        ...props
    });
};


const $f6e81127694e1694$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $l51YQ.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($asgOl)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $l51YQ.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f22ZH)))
    }
];
const $f6e81127694e1694$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $l51YQ.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bmsMK)))
    },
    ...$f6e81127694e1694$var$LAYOUT_TYPES
];
const $f6e81127694e1694$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $l51YQ.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIYpm)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $l51YQ.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0qVa)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5NtbR)))
    }
];
// These are used for advanced layout options
const $f6e81127694e1694$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $l51YQ.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($asgOl)))
    },
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $l51YQ.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIYpm)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $l51YQ.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0qVa)))
    }
];
const $f6e81127694e1694$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $l51YQ.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f22ZH)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5NtbR)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $a8a38269ac67ed48$export$36efe6f2091df089),
        iconFallback: (0, $a8a38269ac67ed48$export$36efe6f2091df089)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $43d7012a9bdae225$export$4518caee70c71b2e),
        iconFallback: (0, $43d7012a9bdae225$export$4518caee70c71b2e)
    }
];
const $f6e81127694e1694$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        iconFallback: item.iconFallback,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $f6e81127694e1694$export$cbec87ad92a1069a = 'Layout floating controls';
const $f6e81127694e1694$var$iconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($asgOl))); // TODO: ED-25466 - Replace with proper icon
const $f6e81127694e1694$var$getLayoutColumnsIcons = (colCount)=>{
    if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true) && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return undefined;
    switch(colCount){
        case 1:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmsMK))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($asgOl))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f22ZH))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6015fa02fe61471$export$38b01bd15f6a5487), {});
        case 5:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6015fa02fe61471$export$3cfd1ab6a9856e7e), {});
        default:
            return undefined;
    }
};
const $f6e81127694e1694$var$getAdvancedLayoutItems = ({ addSidebarLayouts: addSidebarLayouts, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, state: state, node: node, nodeType: nodeType, separator: separator, deleteButton: deleteButton, currentLayout: currentLayout, allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout })=>{
    const numberOfColumns = node.content.childCount || 2;
    const distributionOptions = numberOfColumns === 2 ? $f6e81127694e1694$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION : numberOfColumns === 3 ? $f6e81127694e1694$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION : [];
    const columnOptions = [
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 2
            }),
            //'2-columns',
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(2) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('two_equal'),
            selected: numberOfColumns === 2
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 3
            }),
            //'3-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(3) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('three_equal'),
            selected: numberOfColumns === 3
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 4
            }),
            //'4-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(4) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('four_equal'),
            selected: numberOfColumns === 4
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 5
            }),
            //'5-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(5) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('five_equal'),
            selected: numberOfColumns === 5
        }
    ];
    const singleColumnOption = allowAdvancedSingleColumnLayout ? {
        title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
            count: 1
        }),
        //'1-columns',
        icon: $f6e81127694e1694$var$getLayoutColumnsIcons(1) || $f6e81127694e1694$var$iconPlaceholder,
        onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('single'),
        selected: numberOfColumns === 1
    } : [];
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: numberOfColumns
            }),
            //`${numberOfColumns}-columns`,
            options: [
                singleColumnOption,
                columnOptions
            ].flat(),
            showSelected: true,
            testId: 'column-options-button'
        },
        ...distributionOptions.length > 0 ? [
            separator
        ] : [],
        ...addSidebarLayouts ? distributionOptions.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
    ];
};
const $f6e81127694e1694$var$fullHeightSeparator = {
    type: 'separator',
    fullHeight: true
};
const $f6e81127694e1694$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api)=>{
    const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    const node = state.doc.nodeAt(pos);
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    if (node) {
        const currentLayout = (0, $9d764ec1dd06128c$export$e406155610be725b)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            testId: (0, $61p3e.default).remove.id,
            title: intl.formatMessage((0, $61p3e.default).remove),
            onClick: (0, $9d764ec1dd06128c$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            tabIndex: null
        };
        const copyButton = {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: nodeType
                }
            ]
        };
        const layoutTypes = allowSingleColumnLayout ? $f6e81127694e1694$var$LAYOUT_TYPES_WITH_SINGLE_COL : $f6e81127694e1694$var$LAYOUT_TYPES;
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'layout-overflow-dropdown-trigger';
        const overflowMenu = {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                    onClick: ()=>{
                        api?.core?.actions.execute(// @ts-ignore
                        api?.floatingToolbar?.commands.copyNode(nodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
                },
                {
                    title: intl.formatMessage((0, $61p3e.default).delete),
                    onClick: (0, $9d764ec1dd06128c$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        };
        return {
            title: $f6e81127694e1694$export$cbec87ad92a1069a,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $8m4tT.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $l51YQ.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $f6e81127694e1694$var$getAdvancedLayoutItems({
                    addSidebarLayouts: addSidebarLayouts,
                    intl: intl,
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    state: state,
                    nodeType: nodeType,
                    node: node,
                    separator: separator,
                    deleteButton: deleteButton,
                    currentLayout: currentLayout,
                    allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout
                }) : [
                    ...layoutTypes.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                    ...addSidebarLayouts ? $f6e81127694e1694$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
                ],
                ...toolbarFlagsEnabled ? [
                    $f6e81127694e1694$var$fullHeightSeparator,
                    overflowMenu
                ] : [
                    separator,
                    copyButton,
                    separator,
                    deleteButton
                ]
            ],
            scrollable: true
        };
    }
    return;
};


const $d82516aa109c1d2e$var$LAYOUT_SECTION_NODE_NAME = 'layoutSection';
const $d82516aa109c1d2e$export$abf76f127fb6937c = (tr)=>{
    if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true)) return tr;
    const { layoutSection: layoutSection, paragraph: paragraph } = tr.doc.type.schema.nodes;
    const nodeWithPos = (0, $8m4tT.findParentNode)((node)=>node.type === layoutSection)(tr.selection);
    if (!nodeWithPos || !nodeWithPos.node || nodeWithPos.node.type.name !== 'layoutSection' || nodeWithPos.node.firstChild?.firstChild?.type !== paragraph) return tr;
    // set text selection at the beginning of the layout section
    // will set the selection to the first column
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, nodeWithPos.pos));
    return tr;
};
const $d82516aa109c1d2e$export$2229806460c545ea = ({ config: options = {}, api: api })=>{
    const allowAdvancedSingleColumnLayout = (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('single_column_layouts', true, {
        exposure: true
    });
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]
            },
            component: (0, $2f8097f6f209c685$export$83047c2fe2258f8)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($d82516aa109c1d2e$var$LAYOUT_SECTION_NODE_NAME))
        }
    ]);
    return {
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $hVXQj.layoutSectionWithSingleColumnLocalId) : (0, $hVXQj.layoutSectionWithSingleColumn) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $hVXQj.layoutSectionWithLocalId) : (0, $hVXQj.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $lifsC.layoutColumnWithLocalId) : (0, $lifsC.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'layout',
                    plugin: ()=>(0, $ef7d532c79770eba$export$2e2bcd8739ae039)(options)
                }
            ];
            if ((options.editorAppearance === 'full-page' || options.editorAppearance === 'full-width') && api && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) plugins.push({
                name: 'layoutResizing',
                plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>(0, $2026add019094e18$export$2e2bcd8739ae039)(options, api, portalProviderAPI, eventDispatcher)
            });
            return plugins;
        },
        actions: {
            insertLayoutColumns: (0, $9d764ec1dd06128c$export$3517c001098bb0a9)(api?.analytics?.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout, isResizing: isResizing } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
                const shouldHideToolbar = isResizing && (0, $iu6m9.editorExperiment)('single_column_layouts', true);
                if (pos !== null && !shouldHideToolbar) return (0, $f6e81127694e1694$export$6dd6ab35df8f7f86)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: ({ formatMessage: formatMessage })=>{
                const withInsertLayoutAnalytics = (tr, columnCount)=>{
                    api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).INSERTED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
                        attributes: {
                            inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                            columnCount: columnCount
                        },
                        eventType: (0, $d925B.EVENT_TYPE).TRACK
                    })(tr);
                    return tr;
                };
                const advancedSingleColumnOption = allowAdvancedSingleColumnLayout ? [
                    {
                        id: 'onecolumnlayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).singleColumnAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).singleColumnsDescriptionAdvancedLayout),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'single column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconOneColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 1));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 1);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    }
                ] : [];
                if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return [
                    ...advancedSingleColumnOption,
                    {
                        id: 'twocolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).twoColumnsAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'two'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'two column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconTwoColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 2));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 2);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'threecolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).threeColumnsAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'three'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'three column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconThreeColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 3));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 3);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'fourcolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).fourColumns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'four'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'four column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFourColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 4));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 4);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'fivecolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).fiveColumns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'five'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'five column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFiveColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 5));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 5);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    }
                ];
                else return [
                    {
                        id: 'layout',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$24df8f7ba30643b8)(state));
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        },
        contentComponent () {
            return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cd4b583b7f685bd2$export$cc5403d58ddfa812), {}) : null;
        }
    };
};
module.exports["layoutPlugin"] = $d82516aa109c1d2e$export$2229806460c545ea;

});

parcelRegister("b3BjA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dGKc1 = parcelRequire("dGKc1");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $zT4ZO = parcelRequire("zT4ZO");


var $2UWDO = parcelRequire("2UWDO");


var $42omo = parcelRequire("42omo");


var $1R4Hk = parcelRequire("1R4Hk");

function $3a491b7898bae957$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $1R4Hk.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#fff',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
        fill: iconThemed({
            light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
        fill: iconThemed({
            light: '#6E5DC6',
            dark: '#9F8FEF'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
        fill: iconThemed({
            light: '#E34935',
            dark: '#EF5C48'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
        fill: iconThemed({
            light: '#D97008',
            dark: '#F18D13'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
        fill: iconThemed({
            light: '#E2B203',
            dark: '#E2B203'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
        fill: iconThemed({
            light: '#6A9A23',
            dark: '#82B536'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
        fill: iconThemed({
            light: '#0055CC',
            dark: '#579DFF'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8",
        height: "8",
        fill: iconThemed({
            light: '#fff',
            dark: '#fff'
        }),
        transform: "translate(12 16)"
    }))));
}


var $3pLGZ = parcelRequire("3pLGZ");


var $l9FJJ = parcelRequire("l9FJJ");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $dZ8uq = parcelRequire("dZ8uq");


var $l9G9n = parcelRequire("l9G9n");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");

function $902d62fc2eaf77bf$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $8m4tT.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $902d62fc2eaf77bf$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $902d62fc2eaf77bf$var$findParentNode(selection, nodeType);
    return parentNode && (0, $l9G9n.isEmptyNode)(schema)(parentNode);
}
function $902d62fc2eaf77bf$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { panel: panel, blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup, extension: extension } = nodes;
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType === panel;
            const isParentNodeAPanel = parentNodeType === panel;
            const nodeBeforePanel = $previousPos?.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // identifies if new position after backspace is at the start of a non-bodied extension node
            const isPreviousPosAtExtension = $previousPos.nodeAfter?.type === extension;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel && !isPreviousPosAtExtension || $902d62fc2eaf77bf$var$isInsideAnEmptyNode(selection, panel, state.schema) || (0, $8m4tT.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia && !isPreviousPosAtExtension || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel?.type?.spec?.isolating && (0, $8m4tT.hasParentNodeOfType)(panel)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $8m4tT.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (nodeType !== panel) return false;
            return true;
        }
    };
    return (0, $dus6D.keymap)(keymaps);
}
var $902d62fc2eaf77bf$export$2e2bcd8739ae039 = $902d62fc2eaf77bf$export$e832373cff8dec22;



var $DoNsZ = parcelRequire("DoNsZ");


var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");




parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");








var $etuMO = parcelRequire("etuMO");

const $28f8b0c1361f9945$var$EmojiNodeFunctional = (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $42omo.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $42omo.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName
    }, fallback || shortName);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true
    });
};
const $28f8b0c1361f9945$var$EmojiNode = ({ allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28f8b0c1361f9945$var$EmojiNodeFunctional, {
        allowTextFallback: allowTextFallback,
        shortName: shortName,
        id: id,
        fallback: fallback,
        fitToHeight: fitToHeight,
        showTooltip: showTooltip,
        resourceConfig: resourceConfig,
        emojiProvider: emojiProvider,
        providers: providers
    });
};
var $28f8b0c1361f9945$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($28f8b0c1361f9945$var$EmojiNode);



var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");





var $5SAOw = parcelRequire("5SAOw");


var $aFUXX = parcelRequire("aFUXX");


var $3HOqx = parcelRequire("3HOqx");








var $6icEc = parcelRequire("6icEc");


var $ks2lK = parcelRequire("ks2lK");








var $1oCLl = parcelRequire("1oCLl");

const $e0cd121451b09006$export$ddbd7c123a514b96 = (state, selection)=>{
    const { panel: panel } = state.schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(panel)(selection || state.selection) || (0, $8m4tT.findParentNodeOfType)(panel)(selection || state.selection);
};
const $e0cd121451b09006$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $dGKc1.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = panelColor && (0, $6icEc.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const style = [
        `${panelColor && isCustomPanel ? `background-color: ${panelBackgroundColor};` : ''}`,
        `${!hasIcon && !(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? `padding-left: 12px;padding-right: 12px;` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $DoNsZ.PanelSharedCssClassName).prefix}${!hasIcon && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ` ${(0, $DoNsZ.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $dGKc1.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    // Required for parseDOM to correctly parse custom panel when NodeView DOM is copied directly
    // Schema's parseDOM expects data-panel-icon on all custom panels, not just ones with color
    if (isCustomPanel && (0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true)) panelAttrs = {
        ...panelAttrs,
        'data-panel-icon': panelIcon
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) panelAttrs = {
        ...panelAttrs,
        'data-local-id': attrs.localId
    };
    const iconDiv = [
        'div',
        // EDITOR-266 This fixes an issue in LCM where if you have nested panels
        // The icon colour will be overridden by the parent panel style, this is used to create a more specific css selector
        {
            class: (0, $DoNsZ.PanelSharedCssClassName).icon,
            'data-panel-type': panelType || (0, $dGKc1.PanelType).INFO
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $DoNsZ.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $e0cd121451b09006$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($e0cd121451b09006$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $8m4tT.findParentNode)((node)=>node.type.name === 'panel')(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode?.node.copy();
        const newPanelNode = schema.nodes.panel.create({
            ...clonedPanelNode?.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $ks2lK.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $e0cd121451b09006$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $ks2lK.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $8m4tT.findParentNodeOfType)(newState.schema.nodes.panel)(oldState.tr.selection);
    const isparentTypeDecision = (0, $8m4tT.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && isParentTypePanel?.node.childCount === 1 && (isparentTypeDecision?.node.childCount === 1 || isNodeTypeRuleOrCodeBlock));
};


const $96a452062b45ae95$export$4641b622f6c36f58 = {
    info: (0, $cQMhV.PanelInfoIcon),
    success: (0, $cQMhV.PanelSuccessIcon),
    note: (0, $cQMhV.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))),
    warning: (0, $cQMhV.PanelWarningIcon),
    error: (0, $cQMhV.PanelErrorIcon),
    custom: (0, $cQMhV.PanelInfoIcon)
};
const $96a452062b45ae95$var$selector = (states)=>{
    return {
        emojiState: states.emojiState
    };
};
const $96a452062b45ae95$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const { emojiState: emojiState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'emoji'
    ], $96a452062b45ae95$var$selector);
    const emojiProvider = emojiState?.emojiProvider;
    if (allowCustomPanel && panelIcon && panelType === (0, $dGKc1.PanelType).CUSTOM) return /*#__PURE__*/ (0, $l998X.jsx)((0, $28f8b0c1361f9945$export$2e2bcd8739ae039), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $aFUXX.akEditorCustomIconSize)
    });
    const Icon = $96a452062b45ae95$export$4641b622f6c36f58[panelType];
    return Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: `${panelType} panel`
    }) : null;
};
class $96a452062b45ae95$var$PanelNodeView {
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
    destroy() {
        this.nodeViewPortalProviderAPI.remove(this.key);
    }
    constructor(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory){
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.providerFactory = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.pluginOptions = void 0;
        this.key = void 0;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $e0cd121451b09006$export$4dbd81d91bb3604b)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.icon = this.dom.querySelector(`.${(0, $DoNsZ.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)($96a452062b45ae95$export$2ba98455e5e9d756, {
                pluginInjectionApi: api,
                allowCustomPanel: pluginOptions.allowCustomPanel,
                panelAttributes: node.attrs,
                providerFactory: this.providerFactory
            }), this.icon, this.key);
    }
}
const $96a452062b45ae95$export$544c25cc15cdca2 = (pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)=>(node, view, getPos)=>{
        return new $96a452062b45ae95$var$PanelNodeView(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory);
    };





const $f67a67bd596a2db4$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('panelPlugin');



const $45e5886bb64c7c75$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api, nodeViewPortalProviderAPI)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $f67a67bd596a2db4$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $e0cd121451b09006$export$1c3f791fb2a5168)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $96a452062b45ae95$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'panel'
            ], (target)=>!!target.closest(`.${(0, $DoNsZ.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};





parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");








var $2GVu1 = parcelRequire("2GVu1");


var $8tSmd = parcelRequire("8tSmd");

const $3362d16afd56bb0c$var$NODE_NAME = 'panel';
const $3362d16afd56bb0c$var$PanelBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.panel, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $3362d16afd56bb0c$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: ""
        }),
        children: formatMessage((0, $2UWDO.messages).panel)
    });
};
const $3362d16afd56bb0c$export$33a19cd537147781 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($3362d16afd56bb0c$var$PanelBlockMenuItem, {
            api: api
        });
};





parcelRequire("42omo");








var $dAtrv = parcelRequire("dAtrv");


var $61p3e = parcelRequire("61p3e");

var $02xUP = parcelRequire("02xUP");





var $iHzeA = parcelRequire("iHzeA");


var $lhtyR = parcelRequire("lhtyR");



const $6f19e76ade7c1b04$export$4c05e6c3475702fb = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: `var(--ds-border, ${0, $lhtyR.DEFAULT_BORDER_COLOR})`
    }));









var $2MuFw = parcelRequire("2MuFw");


var $7yDmn = parcelRequire("7yDmn");


var $gKvd9 = parcelRequire("gKvd9");


var $2G5zx = parcelRequire("2G5zx");


var $3gddQ = parcelRequire("3gddQ");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");














const $c4a15bca763b3f4b$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        let deleteTr = tr;
        if ((0, $8m4tT.findSelectedNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $8m4tT.removeSelectedNode)(tr);
        else if ((0, $8m4tT.findParentNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $8m4tT.removeParentNodeOfType)(nodes.panel)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $c4a15bca763b3f4b$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
            if (panelNode === undefined) return false;
            const newType = panelType;
            const previousType = panelNode.node.attrs.panelType;
            let newTr;
            if (allowCustomPanel) {
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(previousType);
                const previousIcon = panelNode.node.attrs.panelIcon;
                const previousIconId = panelNode.node.attrs.panelIconId;
                const previousIconText = panelNode.node.attrs.panelIconText;
                const newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                panelType: panelType
            });
            const payload = {
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type.name === 'panel' ? newTr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };













var $isYda = parcelRequire("isYda");














const $f02842ff9c12a8ad$var$panelTitleAndIcon = {
    [(0, $dGKc1.PanelType).INFO]: {
        title: (0, $02xUP.panelMessages).info,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ)))({
            label: 'info-icon',
            color: "var(--ds-icon-information, #357DE8)"
        })
    },
    [(0, $dGKc1.PanelType).NOTE]: {
        title: (0, $02xUP.panelMessages).note,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ)))({
            label: 'note-icon',
            color: "var(--ds-icon-discovery, #AF59E1)"
        })
    },
    [(0, $dGKc1.PanelType).SUCCESS]: {
        title: (0, $02xUP.panelMessages).success,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD)))({
            label: 'success-icon',
            color: "var(--ds-icon-success, #6A9A23)"
        })
    },
    [(0, $dGKc1.PanelType).WARNING]: {
        title: (0, $02xUP.panelMessages).warning,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi)))({
            label: 'warning-icon',
            color: "var(--ds-icon-warning, #E06C00)"
        })
    },
    [(0, $dGKc1.PanelType).ERROR]: {
        title: (0, $02xUP.panelMessages).error,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7yDmn)))({
            label: 'error-icon',
            color: "var(--ds-icon-danger, #C9372C)"
        })
    },
    [(0, $dGKc1.PanelType).CUSTOM]: {
        title: (0, $02xUP.panelMessages).custom,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))({
            label: 'custom-icon'
        })
    }
};
const $f02842ff9c12a8ad$export$b79ba0272604ac1c = ({ activePanelType: activePanelType, editorAnalyticsAPI: editorAnalyticsAPI, formatMessage: formatMessage })=>{
    const dropdownOptions = [
        {
            id: 'editor.panel.info',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).INFO].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).INFO),
            selected: activePanelType === (0, $dGKc1.PanelType).INFO,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).INFO].title)
        },
        {
            id: 'editor.panel.note',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).NOTE].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).NOTE),
            selected: activePanelType === (0, $dGKc1.PanelType).NOTE,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).NOTE].title)
        },
        {
            id: 'editor.panel.success',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).SUCCESS].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).SUCCESS),
            selected: activePanelType === (0, $dGKc1.PanelType).SUCCESS,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).SUCCESS].title)
        },
        {
            id: 'editor.panel.warning',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).WARNING].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).WARNING),
            selected: activePanelType === (0, $dGKc1.PanelType).WARNING,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).WARNING].title)
        },
        {
            id: 'editor.panel.error',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).ERROR].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).ERROR),
            selected: activePanelType === (0, $dGKc1.PanelType).ERROR,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).ERROR].title)
        }
    ];
    const selectedPanelType = activePanelType || (0, $dGKc1.PanelType).INFO;
    const selectedTitleAndIcon = $f02842ff9c12a8ad$var$panelTitleAndIcon[selectedPanelType] || $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).CUSTOM];
    return {
        id: 'panel-type-dropdown',
        testId: 'panel-type-dropdown-trigger',
        type: 'dropdown',
        options: dropdownOptions,
        showSelected: true,
        iconBefore: ()=>selectedTitleAndIcon.icon,
        title: formatMessage(selectedTitleAndIcon.title)
    };
};


const $470fc4451c578198$export$f17692e562e3afad = {
    [(0, $dGKc1.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $dGKc1.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $dGKc1.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $dGKc1.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $dGKc1.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $dGKc1.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $470fc4451c578198$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state, api)=>{
    const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // TODO: ED-14403 - investigate why these titles are not getting translated for the tooltips
    const items = areAllNewToolbarFlagsDisabled ? [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).INFO),
            selected: activePanelType === (0, $dGKc1.PanelType).INFO,
            title: formatMessage((0, $02xUP.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).NOTE),
            selected: activePanelType === (0, $dGKc1.PanelType).NOTE,
            title: formatMessage((0, $02xUP.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).SUCCESS),
            selected: activePanelType === (0, $dGKc1.PanelType).SUCCESS,
            title: formatMessage((0, $02xUP.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).WARNING),
            selected: activePanelType === (0, $dGKc1.PanelType).WARNING,
            title: formatMessage((0, $02xUP.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).ERROR),
            selected: activePanelType === (0, $dGKc1.PanelType).ERROR,
            title: formatMessage((0, $02xUP.panelMessages).error),
            tabIndex: null
        }
    ] : [
        (0, $f02842ff9c12a8ad$export$b79ba0272604ac1c)({
            activePanelType: activePanelType,
            editorAnalyticsAPI: editorAnalyticsAPI,
            formatMessage: formatMessage
        }),
        ...Boolean(api?.toolbar) ? [] : [
            {
                type: 'separator'
            }
        ]
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $470fc4451c578198$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $d925B.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $d925B.ACTION).CHANGED_ICON,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (activePanelType === (0, $dGKc1.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $d925B.ACTION).REMOVE_ICON,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $dGKc1.PanelType).CUSTOM ? activePanelColor || (0, $DoNsZ.getPanelTypeBackgroundNoTokens)((0, $dGKc1.PanelType).INFO) : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(activePanelType);
        const defaultPalette = (0, $6f19e76ade7c1b04$export$4c05e6c3475702fb).find((item)=>item.value === panelColor) || {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Custom',
            value: panelColor,
            border: (0, $lhtyR.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $02xUP.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: (0, $6f19e76ade7c1b04$export$4c05e6c3475702fb),
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $02xUP.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $dGKc1.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2G5zx))), {
                        spacing: 'spacious',
                        label: ''
                    }),
                onClick: removeEmoji(),
                title: formatMessage((0, $61p3e.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (areAllNewToolbarFlagsDisabled) {
        if (state) {
            items.push({
                type: 'separator'
            });
            items.push({
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: formatMessage,
                        nodeType: panelNodeType
                    }
                ]
            });
        }
        items.push({
            type: 'separator'
        }, {
            id: 'editor.panel.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                    spacing: 'spacious',
                    label: ''
                }),
            onClick: (0, $c4a15bca763b3f4b$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration?.(panelNodeType, true),
            onMouseLeave: hoverDecoration?.(panelNodeType, false),
            onFocus: hoverDecoration?.(panelNodeType, true),
            onBlur: hoverDecoration?.(panelNodeType, false),
            title: formatMessage((0, $61p3e.default).remove),
            tabIndex: null
        });
    } else {
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'panel-overflow-dropdown-trigger';
        const overflowMenuConfig = [
            {
                type: 'separator',
                fullHeight: true
            },
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: formatMessage((0, $61p3e.default).copyToClipboard),
                        onClick: ()=>{
                            api?.core?.actions.execute(// @ts-ignore
                            api?.floatingToolbar?.commands.copyNode(panelNodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
                    },
                    {
                        title: formatMessage((0, $61p3e.default).delete),
                        onClick: (0, $c4a15bca763b3f4b$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    return items;
};
const $470fc4451c578198$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
    if (panelObject) {
        const nodeType = state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $dGKc1.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $470fc4451c578198$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api?.decorations?.actions.hoverDecoration, api?.analytics?.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state, (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? api : undefined);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $8m4tT.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $02xUP.panelMessages).panelsGroup)
        };
    }
    return;
};


const $e35c1438196cadae$var$PANEL_NODE_NAME = 'panel';
const $e35c1438196cadae$var$panelPlugin = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]
            },
            component: (0, $3362d16afd56bb0c$export$33a19cd537147781)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($e35c1438196cadae$var$PANEL_NODE_NAME))
        }
    ]);
    return {
        name: 'panel',
        nodes () {
            if ((0, $dh538.fg)('platform_editor_adf_with_localid')) return [
                {
                    name: 'panel',
                    node: {
                        ...(0, $dGKc1.extendedPanelWithLocalId)(!!options.allowCustomPanel),
                        definingAsContext: true
                    }
                }
            ];
            return [
                {
                    name: 'panel',
                    node: (0, $dGKc1.extendedPanel)(!!options.allowCustomPanel)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $45e5886bb64c7c75$export$ae829ec7b2625219)(dispatch, providerFactory, options, api, nodeViewPortalProviderAPI)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $902d62fc2eaf77bf$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                return function(state, dispatch) {
                    const tr = $e35c1438196cadae$var$createPanelAction({
                        state: state,
                        attributes: {
                            panelType: (0, $dGKc1.PanelType).INFO
                        },
                        api: api,
                        inputMethod: inputMethod
                    });
                    if (!tr) return false;
                    if (dispatch) dispatch(tr);
                    return true;
                };
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertOptions = [
                    {
                        id: 'infopanel',
                        title: formatMessage((0, $2UWDO.messages).infoPanel),
                        keywords: [
                            'panel'
                        ],
                        description: formatMessage((0, $2UWDO.messages).infoPanelDescription),
                        priority: 800,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanel), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).INFO
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'notepanel',
                        title: formatMessage((0, $2UWDO.messages).notePanel),
                        description: formatMessage((0, $2UWDO.messages).notePanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelNote), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).NOTE
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'successpanel',
                        title: formatMessage((0, $2UWDO.messages).successPanel),
                        description: formatMessage((0, $2UWDO.messages).successPanelDescription),
                        keywords: [
                            'tip'
                        ],
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelSuccess), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).SUCCESS
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'warningpanel',
                        title: formatMessage((0, $2UWDO.messages).warningPanel),
                        description: formatMessage((0, $2UWDO.messages).warningPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelWarning), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).WARNING
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'errorpanel',
                        title: formatMessage((0, $2UWDO.messages).errorPanel),
                        description: formatMessage((0, $2UWDO.messages).errorPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelError), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).ERROR
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    }
                ];
                if (options.allowCustomPanel && options.allowCustomPanelEdit) quickInsertOptions.push({
                    id: 'custompanel',
                    title: formatMessage((0, $2UWDO.messages).customPanel),
                    description: formatMessage((0, $2UWDO.messages).customPanelDescription),
                    priority: 1000,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3a491b7898bae957$export$2e2bcd8739ae039), {}),
                    action (typeAheadInsert, state) {
                        return $e35c1438196cadae$var$createPanelAction({
                            state: state,
                            attributes: {
                                panelType: (0, $dGKc1.PanelType).CUSTOM,
                                panelIcon: ':rainbow:',
                                panelIconId: '1f308',
                                panelIconText: "\uD83C\uDF08",
                                // Ignored via go/ees007
                                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                                // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                panelColor: (0, $6fnsQ.T50)
                            },
                            api: api,
                            typeAheadInsert: typeAheadInsert
                        });
                    }
                });
                return quickInsertOptions;
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $470fc4451c578198$export$86ce8f8241c20a3)(state, intl, options, providerFactory, api)
        }
    };
};
/**
 * Creates panel action and wrap selection transaction with analytics for the panel insertion.
 *
 * @example
 * const tr = createPanelAction({
 *   state: editorState,
 *   attributes: { panelType: 'info' },
 * });
 * if (tr) {
 *   applyTransaction(tr);
 * }
 */ function $e35c1438196cadae$var$createPanelAction({ state: state, attributes: attributes, api: api, typeAheadInsert: typeAheadInsert, inputMethod: inputMethod = (0, $d925B.INPUT_METHOD).QUICK_INSERT }) {
    const { panel: panel } = state.schema.nodes;
    let tr;
    // If the selection is empty, we want to insert the panel on a new line
    if (state.selection.empty) {
        const node = panel.createAndFill({
            ...attributes
        });
        if (!node) return false;
        if (typeAheadInsert !== undefined) // If the type-ahead insert is provided, we should use that to insert the node
        tr = typeAheadInsert(node);
        else // Otherwise we can use insertSelectedItem to insert the node
        tr = (0, $zT4ZO.insertSelectedItem)(node)(state, state.tr, state.selection.head)?.scrollIntoView();
    } else tr = (0, $l9FJJ.createWrapSelectionTransaction)({
        state: state,
        type: panel,
        nodeAttributes: {
            ...attributes
        }
    });
    if (tr) api?.analytics?.actions.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: attributes.panelType
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
    return tr ?? false;
}
var $e35c1438196cadae$export$2e2bcd8739ae039 = $e35c1438196cadae$var$panelPlugin;
module.exports["default"] = $e35c1438196cadae$export$2e2bcd8739ae039;

});

parcelRegister("jaskt", function(module, exports) {
/* tasksAndDecisionsPlugin.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gClzS = parcelRequire("gClzS");

var $cXZ4C = parcelRequire("cXZ4C");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $5abq6 = parcelRequire("5abq6");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $b3YrF = parcelRequire("b3YrF");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $5elS6 = parcelRequire("5elS6");


var $24P9d = parcelRequire("24P9d");


var $2iuib = parcelRequire("2iuib");


var $7iisy = parcelRequire("7iisy");





var $iu6m9 = parcelRequire("iu6m9");

const $d9e9935026bf8066$export$c0efac86beb21f01 = (node)=>{
    if (node.content.childCount === 0) return true;
    if (node.type.name === 'blockTaskItem') return node.content.childCount === 1 && node.content.firstChild?.type.name === 'paragraph' && node.content.firstChild?.childCount === 0;
    return false;
};


const $13787dd647975a80$export$aa7ccb8f78e9cbdd = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $5elS6.taskItem;
    return {
        ...(0, $5elS6.taskItem),
        toDOM: (node)=>$13787dd647975a80$export$61f6ad164c5ca628(node)
    };
};
const $13787dd647975a80$export$526b6659b16d1721 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $5elS6.blockTaskItem;
    return {
        ...(0, $5elS6.blockTaskItem),
        toDOM: (node)=>$13787dd647975a80$export$61f6ad164c5ca628(node)
    };
};
const $13787dd647975a80$var$getCheckBoxId = (localId)=>`task-checkbox-${localId}`;
function $13787dd647975a80$export$640336359e1ccaeb(node, placeholder, intl) {
    const checked = node.attrs.state === 'DONE';
    const checkboxId = $13787dd647975a80$var$getCheckBoxId(node.attrs.localId);
    const inputAttrs = {
        name: checkboxId,
        id: checkboxId,
        type: 'checkbox',
        'aria-label': intl.formatMessage(checked ? (0, $2iuib.tasksAndDecisionsMessages).markTaskAsNotCompleted : (0, $2iuib.tasksAndDecisionsMessages).markTaskAsCompleted)
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        'data-prosemirror-node-name': 'taskItem',
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    let contentDomDataAttrs = node.content.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) contentDomDataAttrs = (0, $d9e9935026bf8066$export$c0efac86beb21f01)(node) ? {
        'data-empty': 'true'
    } : {};
    const checkboxIcons = (0, $1oCLl.expValEquals)('platform_editor_task_item_styles', 'isEnabled', true) ? [
        'http://www.w3.org/2000/svg svg',
        {
            width: '20',
            height: '20',
            viewBox: '2 2 20 20',
            role: 'presentation',
            'data-component': 'checkbox-icon'
        },
        [
            'http://www.w3.org/2000/svg g',
            {
                'fill-rule': 'evenodd'
            },
            [
                'http://www.w3.org/2000/svg rect',
                {
                    fill: 'currentcolor',
                    x: '5.5',
                    y: '5.5',
                    width: '13',
                    height: '13',
                    rx: '1.5'
                }
            ],
            [
                'http://www.w3.org/2000/svg path',
                {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'm16.326 9.48-1.152-.96-4.424 5.308-1.924-2.308-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z',
                    fill: 'inherit'
                }
            ]
        ]
    ] : [
        'span',
        {
            'aria-hidden': true,
            'data-component': 'checkbox-icon-wrap'
        },
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `0 0 16 16`,
                width: '16',
                height: '16',
                role: 'presentation',
                fill: 'none',
                'data-component': 'checkbox-unchecked-icon'
            },
            [
                'http://www.w3.org/2000/svg rect',
                {
                    width: '12.5',
                    height: '12.5',
                    x: '1.75',
                    y: '1.75',
                    stroke: 'currentcolor',
                    'stroke-width': '1.5',
                    rx: '1.25'
                }
            ]
        ],
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `0 0 16 16`,
                width: '16',
                height: '16',
                role: 'presentation',
                fill: 'none',
                'data-component': 'checkbox-checked-icon'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z'
                }
            ]
        ]
    ];
    return [
        'div',
        {
            class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`,
            ...dataAttrs,
            state: node.attrs.state
        },
        [
            'div',
            {
                'data-component': 'task-item-main'
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`,
                    'data-component': 'task-item-input-wrap'
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'task-item',
                        'data-task-input': true,
                        'data-testid': 'task-item-checkbox',
                        'data-component': 'task-item-input',
                        role: 'checkbox'
                    }
                ],
                checkboxIcons
            ],
            [
                'span',
                {
                    class: 'placeholder-node-view',
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contenteditable: 'false'
                },
                placeholder
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
}
const $13787dd647975a80$export$61f6ad164c5ca628 = (node)=>{
    const checked = node.attrs.state === 'DONE';
    const inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    return [
        'div',
        {
            class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER,
            ...dataAttrs,
            style: (0, $24P9d.convertToInlineCss)({
                listStyleType: 'none',
                lineHeight: '24px',
                minWidth: '48px',
                position: 'relative'
            })
        },
        [
            'div',
            {
                style: (0, $24P9d.convertToInlineCss)({
                    display: 'flex'
                })
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    style: (0, $24P9d.convertToInlineCss)({
                        width: '24px',
                        height: '24px',
                        lineHeight: '24px',
                        display: 'grid',
                        placeContent: 'center center'
                    })
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'lazy-task-item',
                        style: (0, $24P9d.convertToInlineCss)({
                            width: '13px',
                            height: '13px',
                            margin: '1px 0 0 0',
                            padding: 0,
                            accentColor: "var(--ds-background-selected-bold, #1868DB)"
                        })
                    }
                ]
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        style: (0, $24P9d.convertToInlineCss)({
                            display: 'block',
                            fontSize: '16px',
                            fontFamily: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            color: "var(--ds-text, #292A2E)"
                        })
                    },
                    0
                ]
            ]
        ]
    ];
};



var $bpTLT = parcelRequire("bpTLT");







const $2dd6d5f87dea1a71$export$7727308e3d6fe8e9 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $bpTLT.decisionItem;
    return {
        ...(0, $bpTLT.decisionItem),
        toDOM: (node)=>{
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state,
                class: 'decisionItemView-content-wrap'
            };
            const showPlaceholder = node.content.size === 0;
            return [
                'li',
                attrs,
                [
                    'div',
                    {
                        'data-decision-wrapper': true,
                        'data-testid': 'elements-decision-item',
                        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
                        style: (0, $24P9d.convertToInlineCss)({
                            background: "var(--ds-background-neutral, #0515240F)",
                            padding: "var(--ds-space-100, 8px)",
                            paddingLeft: "var(--ds-space-150, 12px)",
                            margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                            display: 'flex',
                            borderRadius: "var(--ds-radius-small, 3px)"
                        })
                    },
                    [
                        'span',
                        {
                            style: (0, $24P9d.convertToInlineCss)({
                                width: '16px',
                                height: '16px',
                                margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
                                color: showPlaceholder ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-success, #6A9A23)",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }),
                            contentEditable: 'false',
                            'data-component': 'icon'
                        },
                        [
                            'span',
                            {
                                role: 'img',
                                'aria-label': 'Decision',
                                style: (0, $24P9d.convertToInlineCss)({
                                    width: '32px',
                                    height: '32px'
                                })
                            },
                            [
                                'http://www.w3.org/2000/svg svg',
                                {
                                    viewBox: `0 0 24 24`,
                                    role: 'presentation',
                                    width: '24',
                                    height: '24',
                                    'data-icon-source': 'legacy',
                                    style: (0, $24P9d.convertToInlineCss)({
                                        width: '32px',
                                        height: '32px'
                                    })
                                },
                                [
                                    'http://www.w3.org/2000/svg path',
                                    {
                                        fill: 'currentcolor',
                                        'fill-rule': 'evenodd',
                                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                                    }
                                ]
                            ]
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: 'decision-item'
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};



var $adhil = parcelRequire("adhil");


var $l9G9n = parcelRequire("l9G9n");

var $irKZA = parcelRequire("irKZA");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");





var $dh538 = parcelRequire("dh538");







const $e74ddcb3d2085778$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('tasksAndDecisionsPlugin');


var $c5154c0aaa7029e9$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
    ACTIONS[ACTIONS["OPEN_REQUEST_TO_EDIT_POPUP"] = 2] = "OPEN_REQUEST_TO_EDIT_POPUP";
    return ACTIONS;
}({});





function $e1b246d999b63af5$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $ks2lK.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $ks2lK.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $e1b246d999b63af5$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $ks2lK.TextSelection)(head, head);
    }
    const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $ks2lK.TextSelection)(anchor, head);
};
const $e1b246d999b63af5$export$11f4e85d86397169 = ($from)=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    const firstParent = $from.parent;
    if (firstParent.type === blockTaskItem) return {
        blockTaskItemNode: firstParent,
        hasParagraph: false
    };
    else if (firstParent.type === paragraph) {
        if ($from.depth >= 1) {
            const secondParent = $from.node($from.depth - 1);
            if (secondParent.type === blockTaskItem) return {
                blockTaskItemNode: secondParent,
                hasParagraph: true
            };
            else return false;
        } else return false;
    }
    return false;
};


const $2fc4254aeefcece8$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    if (blockTaskItem) return Boolean((0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.selection.$from, [
        decisionItem,
        taskItem,
        blockTaskItem
    ]));
    return (0, $8m4tT.hasParentNodeOfType)([
        decisionItem,
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem, blockTaskItem: blockTaskItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem,
        blockTaskItem
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $2fc4254aeefcece8$export$f029cbac7e0ab14c = ({ $from: $from, $to: $to })=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    if (blockTaskItem) {
        const result = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (result) {
            const { hasParagraph: hasParagraph } = result;
            const blockTaskItemDepth = hasParagraph ? $from.depth - 1 : $from.depth;
            let blockRangeDepth = blockTaskItemDepth - 1;
            // Calculate start position of the block range
            let startPos = $from.start(blockTaskItemDepth) - 1;
            // Calculate end position and get node after the current selection
            const endPos = $to.end();
            let $after = $to.doc.resolve(endPos + 1);
            let afterNode = $after.nodeAfter;
            const lastNode = $to.node($to.depth);
            let endRangePos = $to.start() + lastNode.nodeSize;
            // Make adjustments for paragraph nodes
            if (lastNode.type === paragraph) {
                $after = $to.doc.resolve(endPos + 2);
                afterNode = $after.nodeAfter;
            } else {
                blockRangeDepth--;
                endRangePos--;
            }
            // Extend range if there's a sibling taskList
            if (afterNode && afterNode.type === taskList && $after.depth === blockTaskItemDepth - 1) endRangePos += afterNode.nodeSize;
            // Check if preceded by another taskItem/blockTaskItem
            const $prevNode = $from.doc.resolve(startPos - 1);
            const prevNodeSize = $prevNode.nodeBefore?.nodeSize || 0;
            const $prevNodeParent = $from.doc.resolve($prevNode.pos - prevNodeSize - 1);
            const prevNodeParent = $prevNodeParent.nodeAfter;
            if (prevNodeParent && [
                blockTaskItem,
                taskItem
            ].includes(prevNodeParent.type)) {
                blockRangeDepth = blockTaskItemDepth - 1;
                endRangePos -= 2;
                startPos += 1;
            }
            // Create and return the NodeRange
            return new (0, $5SAOw.NodeRange)($to.doc.resolve(startPos), $to.doc.resolve(endRangePos), blockRangeDepth);
        }
    }
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $2fc4254aeefcece8$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList, blockTaskItem: blockTaskItem } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    if ((0, $8m4tT.hasParentNodeOfType)([
        blockTaskItem
    ])(selection)) {
        const blockTaskItemNode = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === blockTaskItem)($from);
        if (blockTaskItemNode) /**
			 * If we are inside a blockTaskItem, calculate the indent level from the
			 * blockTaskItemNode instead of the selection, in case the selection is
			 * nested inside a blockTaskItem.
			 */ return blockTaskItemNode.depth - furthestParent.depth;
    }
    return $from.depth - furthestParent.depth;
};
const $2fc4254aeefcece8$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>node?.type.name === 'taskList';
    const itemAtPos = (0, $8m4tT.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $2fc4254aeefcece8$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $2fc4254aeefcece8$export$59958047ba34fe83 = ($from, $to, types)=>{
    const root = (0, $l9G9n.findFarthestParentNode)((node)=>types.indexOf(node.type) > -1)($from);
    if (!root) return -1;
    // get the height between the root and the current position
    const distToParent = $from.depth - root.depth;
    // include any following taskList since nested lists appear
    // as siblings
    //
    // this is unlike regular bullet lists where the orderedList
    // appears as descendent of listItem
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return -1;
    // and get the max height from the current position to the
    // deepest leaf node
    let maxChildDepth = $from.depth;
    $from.doc.nodesBetween(blockRange.start, blockRange.end, (descendent, relPos, parent)=>{
        maxChildDepth = Math.max($from.doc.resolve(relPos).depth, maxChildDepth);
        // keep descending down the tree if we can
        if (types.indexOf(descendent.type) > -1) return true;
    });
    return distToParent + (maxChildDepth - $from.depth);
};
const $2fc4254aeefcece8$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { paragraph: paragraph, blockTaskItem: blockTaskItem, decisionItem: decisionItem, taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const isEmptyTaskOrDecisionItem = node && (node.type === taskItem || node.type === decisionItem) && node.content.size === 0;
    // Block task items must contain a single empty paragraph to be considered empty
    const isInEmptyBlockTaskItem = // If in an empty paragraph that's not at the doc level
    node.content.size === 0 && node.type === paragraph && $from.depth > 0 && // and it's parent is a blockTaskItem with only this paragraph inside it
    $from.node($from.depth - 1).type === blockTaskItem && $from.node($from.depth - 1).childCount === 1 && (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3');
    return isEmptyTaskOrDecisionItem || isInEmptyBlockTaskItem;
};
const $2fc4254aeefcece8$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $aXG5V.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $2fc4254aeefcece8$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true)) {
        const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const maybeTask = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($from, [
            taskItem,
            blockTaskItem
        ]);
        // current selection has to be inside taskitem
        if (maybeTask) return {
            pos: maybeTask?.pos,
            localId: maybeTask?.node.attrs.localId
        };
    } else {
        const isInTaskItem = $from.node().type === schema.nodes.taskItem;
        // current selection has to be inside taskitem
        if (isInTaskItem) {
            const taskItemPos = $from.before();
            return {
                pos: taskItemPos,
                localId: $from.node().attrs.localId
            };
        }
    }
}
function $2fc4254aeefcece8$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    const isInTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? $2fc4254aeefcece8$export$2fad51fb9cb5e2d1(state) : $fromPos.node().type === schema.nodes.taskItem;
    // if not inside task item then return undefined;
    if (!isInTaskItem) return;
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const rootTaskListData = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem || (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && blockTaskItem && node.type === blockTaskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems) {
    const { state: state } = view;
    const { schema: schema } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $8m4tT.findParentNodeOfTypeClosestToPos)($fromPos, [
        taskItem,
        blockTaskItem
    ])?.node : $fromPos.node($fromPos.depth);
    if (currentTaskItem) {
        const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
        return currentTaskItemIndex;
    } else return -1;
}
function $2fc4254aeefcece8$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $2fc4254aeefcece8$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $2fc4254aeefcece8$export$6ddc162ae107856(view, taskItemData) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    if (taskItemData) {
        tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
            data: taskItemData.localId
        });
        dispatch(tr);
    }
}
function $2fc4254aeefcece8$export$965155ace97a0424(view, taskItemData) {
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc } = state;
    const { schema: schema } = state;
    const { extension: extension } = schema.nodes;
    const tr = state.tr;
    // if there's an extension at this position, we're in a blockTaskItem, set a gapCursor
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && extension && doc.resolve(pos + 1).nodeAfter?.type === extension) tr.setSelection(new (0, $adhil.GapCursorSelection)(doc.resolve(pos + 1)));
    else if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && doc.resolve(pos + 1).nodeAfter?.isTextblock) tr.setSelection(new (0, $ks2lK.TextSelection)(doc.resolve(pos + 2)));
    else tr.setSelection(new (0, $ks2lK.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $2fc4254aeefcece8$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID
    }));
}
function $2fc4254aeefcece8$export$ccb659c518fe26ad(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: pos
    }));
}
function $2fc4254aeefcece8$export$6e1436cb7b69383b(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: null
    }));
}
function $2fc4254aeefcece8$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $irKZA.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $8m4tT.findParentNodeClosestToPos)($pos, (0, $irKZA.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
const $2fc4254aeefcece8$export$2ca50ccc2f45db88 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    return $from.parent.isTextblock && $from.node($from.depth - 1).type === blockTaskItem && $from.index($from.depth - 1) === 0;
};
const $2fc4254aeefcece8$export$bcd44b9b102ed403 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const parentNode = $from.node($from.depth - 1);
    return $from.parent.isTextblock && parentNode.type === blockTaskItem && $from.index($from.depth - 1) === parentNode.childCount - 1;
};






var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");








var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


var $fO7hX = parcelRequire("fO7hX");



var $ba0339a1ea50ea9d$export$f78f4c81bbd3af70 = /*#__PURE__*/ function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
    return USER_CONTEXT;
}({});
var $ba0339a1ea50ea9d$export$5981355d1002ed79 = /*#__PURE__*/ function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
    return LINK_STATUS;
}({});
var $ba0339a1ea50ea9d$export$6c486891427a9a0 = /*#__PURE__*/ function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
    return LINK_REPRESENTATION;
}({});
var $ba0339a1ea50ea9d$export$7c9a0eeb2da3d2de = /*#__PURE__*/ function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
    return LINK_RESOURCE;
}({});






var $56SXY = parcelRequire("56SXY");















const $593b7407307544bb$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $ba0339a1ea50ea9d$export$f78f4c81bbd3af70).EDIT : (0, $ba0339a1ea50ea9d$export$f78f4c81bbd3af70).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $593b7407307544bb$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $d925B.ACTION_SUBJECT_ID).ACTION : (0, $d925B.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $593b7407307544bb$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $593b7407307544bb$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$593b7407307544bb$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $593b7407307544bb$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $56SXY.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $593b7407307544bb$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $593b7407307544bb$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $593b7407307544bb$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $593b7407307544bb$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $8m4tT.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $593b7407307544bb$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $8m4tT.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $fO7hX.uuid).generate();
        itemLocalId = itemLocalId || (0, $fO7hX.uuid).generate();
        if (insertTrCreator) {
            const insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI?.attachAnalyticsEvent($593b7407307544bb$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $593b7407307544bb$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $8m4tT.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $593b7407307544bb$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $593b7407307544bb$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $fO7hX.uuid).generate(), itemLocalId = (0, $fO7hX.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $adhil.GapCursorSelection)) return (0, $8m4tT.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($593b7407307544bb$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $fO7hX.uuid).generate()
        }, [
            item.create({
                localId: (0, $fO7hX.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $8m4tT.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $5SAOw.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $aXG5V.liftTarget)(range));
        }
        const listParent = (0, $8m4tT.findParentNodeOfType)(taskList)(selection) || (0, $8m4tT.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $8m4tT.findParentNodeOfType)(taskItem)(selection) || (0, $8m4tT.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $8m4tT.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $8m4tT.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $593b7407307544bb$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $8m4tT.safeInsert)(emptyList)(tr);
};
const $593b7407307544bb$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER,
            data: provider
        });
    };


const $ac4bed0eb4b2d5b6$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $l03WE.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $593b7407307544bb$export$c8b7fdb74eb8fe5c)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $8m4tT.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $d925B.INPUT_METHOD).FORMATTING, $ac4bed0eb4b2d5b6$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $ac4bed0eb4b2d5b6$var$isCursorInsideList = ($pos)=>{
    return $pos.node($pos.depth - 1)?.type.name === 'listItem';
};
const $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $ac4bed0eb4b2d5b6$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($ac4bed0eb4b2d5b6$var$isCursorInsideList($from)) {
                $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $593b7407307544bb$export$eb5c8ff5b17fd36b)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $ac4bed0eb4b2d5b6$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[\\]\\s$`), 'taskList'));
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039 = $ac4bed0eb4b2d5b6$export$568a7ed6897c4817;







var $9YoeD = parcelRequire("9YoeD");




var $aU3dp = parcelRequire("aU3dp");


var $dAtrv = parcelRequire("dAtrv");


var $hgeg8 = parcelRequire("hgeg8");





var $e7tBw = parcelRequire("e7tBw");


var $astHL = parcelRequire("astHL");


var $dus6D = parcelRequire("dus6D");

















var $dhoHU = parcelRequire("dhoHU");






const $8a662c092cc6e62e$export$2837bcd4021a2a47 = (state, dispatch)=>{
    const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
    const { $from: $from, $to: $to } = normalizedSelection;
    const tr = (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(state.tr, $from, $to);
    if (dispatch && tr) dispatch(tr);
    return !!tr;
};
const $8a662c092cc6e62e$export$b9f50dd5ccd0f20 = (state, dispatch)=>{
    const { $from: $from, $to: $to } = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
    // limit ui indentation to 6 levels
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    let maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
        taskList,
        taskItem
    ]);
    if (blockTaskItem) {
        const resultOfFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (resultOfFindBlockTaskItem) {
            const { hasParagraph: hasParagraph } = resultOfFindBlockTaskItem;
            // If the selection is inside a nested node inside the blockTaskItem
            // Remove the difference in depth between the selection and the blockTaskItemNode
            if (hasParagraph) maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]) - 1;
            else maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]);
        }
    }
    if (maxDepth >= 6) return true;
    const blockRange = (0, $2fc4254aeefcece8$export$f029cbac7e0ab14c)({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return true;
    const wrapping = (0, $aXG5V.findWrapping)(blockRange, state.schema.nodes.taskList);
    if (!wrapping) return true;
    if (dispatch) dispatch(state.tr.wrap(blockRange, wrapping).scrollIntoView());
    return true;
};
const $8a662c092cc6e62e$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $dhoHU.findCutBefore)($pos);
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $2fc4254aeefcece8$export$6f0e2eafb461f634)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            let slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            let from = $lastNode.pos;
            const to = $cut.pos + $cut.nodeAfter.nodeSize;
            let gapFrom = $cut.pos + 1;
            let gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
            const insert = 0;
            if (blockTaskItem) {
                if ($lastNode.parent.type === blockTaskItem) {
                    const childOfLastNode = state.doc.resolve($lastNode.pos - 1);
                    if (childOfLastNode.parent.type === paragraph) {
                        // Recalculate the slice to include the full blockTaskItem structure
                        slice = state.tr.doc.slice(childOfLastNode.pos, $cut.pos);
                        // Need to move one pos in to get to the text node of the paragraph
                        from = $lastNode.pos - 1;
                    } else {
                        // If the blockTaskItem last node is not a paragraph
                        // Expand the gap to include the paragraph being merged
                        gapFrom = $cut.pos; // To get the actual paragraph node
                        gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
                    }
                }
            }
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            const tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)(from, to, gapFrom, gapTo, slice, insert, true));
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };











var $e6Sje = parcelRequire("e6Sje");







const $0af71c7c009df6fc$export$1d7e7dcd2590e9c6 = (nodeType)=>{
    return nodeType.name === 'bulletList' || nodeType.name === 'orderedList';
};
const $0af71c7c009df6fc$export$adef7a5f125e0514 = (nodeType)=>{
    return nodeType.name === 'taskList';
};
const $0af71c7c009df6fc$export$98148b07df5ff68c = (nodes)=>{
    return [
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList
    ].filter(Boolean);
};
const $0af71c7c009df6fc$export$3fd351b2ea86488c = (nodes)=>{
    return new Set($0af71c7c009df6fc$export$98148b07df5ff68c(nodes));
};
const $0af71c7c009df6fc$export$3b2ae917fa66948c = (node, schema)=>{
    const { paragraph: paragraph, hardBreak: hardBreak } = schema.nodes;
    if (node.type === paragraph) return [
        ...node.content.content
    ];
    if (node.isBlock) {
        const textContent = node.textContent;
        const lines = textContent.split('\n');
        const newText = [];
        lines.forEach((line, index)=>{
            if (line !== '') newText.push(line ? schema.text(line) : schema.text(' '));
            if (lines.length > 1 && index !== lines.length - 1) newText.push(hardBreak.create());
        });
        return newText;
    }
    return [
        node
    ];
};


const $40ae9645382f099a$var$getContentSupportChecker = (targetNodeType)=>{
    return (node)=>{
        try {
            return targetNodeType.validContent((0, $5SAOw.Fragment).from(node));
        } catch  {
            return false;
        }
    };
};
const $40ae9645382f099a$export$95df50ae6315ead6 = (props, onhandleUnsupportedContent)=>{
    const transformedItems = [];
    const { listNode: listNode, isSourceBulletOrOrdered: isSourceBulletOrOrdered, isTargetBulletOrOrdered: isTargetBulletOrOrdered, isSourceTask: isSourceTask, isTargetTask: isTargetTask, supportedListTypes: supportedListTypes, schema: schema, targetNodeType: targetNodeType } = props;
    const { taskList: taskList, listItem: listItem, taskItem: taskItem, paragraph: paragraph } = schema.nodes;
    listNode.forEach((child)=>{
        if (isSourceBulletOrOrdered && isTargetTask) // Convert bullet/ordered => task
        {
            if (child.type === listItem) {
                const inlineContent = [];
                const nestedTaskLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== taskList) nestedTaskLists.push($40ae9645382f099a$export$95df50ae6315ead6({
                        ...props,
                        listNode: grandChild
                    }, onhandleUnsupportedContent));
                    else if (!$40ae9645382f099a$var$getContentSupportChecker(taskItem)(grandChild) && !grandChild.isTextblock) onhandleUnsupportedContent?.(grandChild);
                    else inlineContent.push(...(0, $0af71c7c009df6fc$export$3b2ae917fa66948c)(grandChild, schema));
                });
                transformedItems.push(taskItem.create(null, inlineContent.length > 0 ? inlineContent : null));
                transformedItems.push(...nestedTaskLists);
            }
        } else if (isSourceTask && isTargetBulletOrOrdered) {
            // Convert task => bullet/ordered
            if (child.type === taskItem) {
                const inlineContent = [
                    ...child.content.content
                ];
                const paragraphNode = paragraph.create(null, inlineContent.length > 0 ? inlineContent : null);
                transformedItems.push(listItem.create(null, [
                    paragraphNode
                ]));
            } else if (child.type === taskList) {
                const transformedNestedList = $40ae9645382f099a$export$95df50ae6315ead6({
                    ...props,
                    listNode: child
                }, onhandleUnsupportedContent);
                const lastItem = transformedItems[transformedItems.length - 1];
                if (lastItem?.type === listItem) {
                    // Attach nested list to previous item
                    const updatedContent = [
                        ...lastItem.content.content,
                        transformedNestedList
                    ];
                    transformedItems[transformedItems.length - 1] = listItem.create(lastItem.attrs, updatedContent);
                } else // No previous item, flatten nested items
                transformedItems.push(...transformedNestedList.content.content);
            }
        } else if (isSourceBulletOrOrdered && isTargetBulletOrOrdered) {
            if (child.type === listItem) {
                const convertedNestedLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== targetNodeType) {
                        const convertedNode = $40ae9645382f099a$export$95df50ae6315ead6({
                            ...props,
                            listNode: grandChild
                        }, onhandleUnsupportedContent);
                        convertedNestedLists.push(convertedNode);
                    } else convertedNestedLists.push(grandChild);
                });
                transformedItems.push(listItem.create(null, convertedNestedLists));
            }
        }
    });
    return targetNodeType.create(null, transformedItems);
};
const $40ae9645382f099a$export$f6e356fc6d93cbb1 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const nodes = tr.doc.type.schema.nodes;
    const unsupportedContent = [];
    const onhandleUnsupportedContent = (content)=>{
        unsupportedContent.push(content);
    };
    try {
        const listNode = {
            node: sourceNode,
            pos: sourcePos
        };
        const { node: sourceList, pos: listPos } = listNode;
        // const { taskList, listItem, taskItem, paragraph } = nodes;
        const isSourceBulletOrOrdered = (0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(sourceList.type);
        const isTargetTask = (0, $0af71c7c009df6fc$export$adef7a5f125e0514)(targetNodeType);
        const isSourceTask = (0, $0af71c7c009df6fc$export$adef7a5f125e0514)(sourceList.type);
        const isTargetBulletOrOrdered = (0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(targetNodeType);
        const supportedListTypes = (0, $0af71c7c009df6fc$export$3fd351b2ea86488c)(nodes);
        const newList = $40ae9645382f099a$export$95df50ae6315ead6({
            isSourceBulletOrOrdered: isSourceBulletOrOrdered,
            isSourceTask: isSourceTask,
            isTargetBulletOrOrdered: isTargetBulletOrOrdered,
            isTargetTask: isTargetTask,
            listNode: sourceList,
            schema: tr.doc.type.schema,
            supportedListTypes: supportedListTypes,
            targetNodeType: targetNodeType
        }, onhandleUnsupportedContent);
        tr.replaceWith(listPos, listPos + sourceList.nodeSize, [
            newList,
            ...unsupportedContent
        ]);
        return tr;
    } catch  {
        return tr;
    }
};
const $40ae9645382f099a$export$2f7df9065a975ace = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const { nodes: nodes } = tr.doc.type.schema;
    const sourceListType = sourceNode.type;
    const isSourceBulletOrOrdered = (0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(sourceListType);
    const isTargetTask = (0, $0af71c7c009df6fc$export$adef7a5f125e0514)(targetNodeType);
    const isSourceTask = (0, $0af71c7c009df6fc$export$adef7a5f125e0514)(sourceListType);
    const isTargetBulletOrOrdered = (0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(targetNodeType);
    // Check if we need structure transformation
    const needsStructureTransform = isSourceBulletOrOrdered && isTargetTask || isSourceTask && isTargetBulletOrOrdered;
    try {
        if (!needsStructureTransform) {
            // Simple type change for same structure lists (bullet <-> ordered)
            // Apply to the main list
            tr.setNodeMarkup(sourcePos, targetNodeType);
            // Apply to nested lists
            const listStart = sourcePos;
            const listEnd = sourcePos + sourceNode.nodeSize;
            const supportedListTypesSet = (0, $0af71c7c009df6fc$export$3fd351b2ea86488c)(nodes);
            tr.doc.nodesBetween(listStart, listEnd, (node, pos, parent)=>{
                // Only process nested lists (not the root list we already handled)
                if (supportedListTypesSet.has(node.type) && pos !== sourcePos) {
                    const isNestedList = parent && (supportedListTypesSet.has(parent.type) || parent.type === nodes.listItem);
                    if (isNestedList) {
                        const shouldTransformNode = node.type === sourceListType || (0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(node.type) && isTargetBulletOrOrdered;
                        if (shouldTransformNode) tr.setNodeMarkup(pos, targetNodeType);
                    }
                }
                return true; // Continue traversing
            });
            return tr;
        } else return $40ae9645382f099a$export$f6e356fc6d93cbb1(context);
    } catch  {
        return null;
    }
};
const $40ae9645382f099a$export$201fb3474673bbf3 = (tr, range, targetNodeType, targetAttrs, nodes)=>{
    try {
        const { taskItem: taskItem } = nodes;
        const listItems = [];
        // Process each block in the range
        tr.doc.nodesBetween(range.start, range.end, (node)=>{
            if (node.isBlock) {
                // For block nodes like paragraphs, directly use their inline content
                const inlineContent = [
                    ...node.content.content
                ];
                if (inlineContent.length > 0) {
                    // Create task item with inline content directly
                    const listItem = taskItem.create(targetAttrs, inlineContent);
                    listItems.push(listItem);
                }
            }
            return false; // Don't traverse into children
        });
        if (listItems.length === 0) return null;
        // Create the new task list
        const newList = targetNodeType.create(targetAttrs, listItems);
        // Replace the range with the new list
        tr.replaceWith(range.start, range.end, newList);
        return tr;
    } catch  {
        return null;
    }
};
const $40ae9645382f099a$export$d9cdacbed7444a4a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const taskItemsResult = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.taskItem);
    const taskItems = taskItemsResult.map((item)=>item.node);
    const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
    let targetNodes = [];
    // Convert fragments to headings if target is heading
    if (targetNodeType === schema.nodes.heading && targetAttrs) {
        // convert the fragments to headings
        const targetHeadingLevel = targetAttrs.level;
        targetNodes = taskItemFragments.map((fragment)=>schema.nodes.heading.createChecked({
                level: targetHeadingLevel
            }, fragment.content));
    }
    // Convert fragments to paragraphs if target is paragraphs
    if (targetNodeType === schema.nodes.paragraph) // convert the fragments to paragraphs
    targetNodes = taskItemFragments.map((fragment)=>schema.nodes.paragraph.createChecked({}, fragment.content));
    // Convert fragments to code block if target is code block
    if (targetNodeType === schema.nodes.codeBlock) {
        // convert the fragments to one code block
        const codeBlockContent = taskItemFragments.map((fragment)=>fragment.textBetween(0, fragment.size, '\n')).join('\n');
        targetNodes = [
            schema.nodes.codeBlock.createChecked({}, schema.text(codeBlockContent))
        ];
    }
    // Replace the task list node with the new content in the transaction
    const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(targetNodes), 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};
const $40ae9645382f099a$export$c0b9021b626ac150 = (tr)=>{
    const { selection: selection } = tr;
    const { nodes: nodes } = tr.doc.type.schema;
    // Find the node to format from the current selection
    let nodeToFormat;
    let nodePos = selection.from;
    // Try to find the current node from selection
    const selectedNode = (0, $8m4tT.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.expand,
        nodes.codeBlock,
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.layoutSection
    ])(selection);
    if (selectedNode) {
        nodeToFormat = selectedNode.node;
        nodePos = selectedNode.pos;
    } else {
        // Try to find parent node (including list parents)
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            nodes.blockquote,
            nodes.panel,
            nodes.expand,
            nodes.codeBlock,
            nodes.listItem,
            nodes.taskItem,
            nodes.layoutSection
        ])(selection);
        if (parentNode) {
            nodeToFormat = parentNode.node;
            nodePos = parentNode.pos;
            const paragraphOrHeadingNode = (0, $8m4tT.findParentNodeOfType)([
                nodes.paragraph,
                nodes.heading
            ])(selection);
            // Special case: if we found a listItem, check if we need the parent list instead
            if (parentNode.node.type === nodes.listItem || parentNode.node.type === nodes.taskItem) {
                const listParent = (0, $8m4tT.findParentNodeOfType)([
                    nodes.bulletList,
                    nodes.orderedList,
                    nodes.taskList
                ])(selection);
                if (listParent) {
                    // For list transformations, we want the list parent, not the listItem
                    nodeToFormat = listParent.node;
                    nodePos = listParent.pos;
                }
            } else if (parentNode.node.type !== nodes.blockquote && paragraphOrHeadingNode) {
                nodeToFormat = paragraphOrHeadingNode.node;
                nodePos = paragraphOrHeadingNode.pos;
            }
        }
    }
    if (!nodeToFormat) {
        nodeToFormat = selection.$from.node();
        nodePos = selection.$from.pos;
    }
    return {
        node: nodeToFormat,
        pos: nodePos
    };
};











const $2b7d7c8d49850f96$export$2e48e3ea1c210731 = (editorAnalyticsAPI)=>(targetType = 'paragraph')=>{
        return ({ tr: tr })=>{
            const inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR;
            const { nodes: nodes } = tr.doc.type.schema;
            const { selection: selection } = tr;
            // Handle empty selection: insert a new task item
            const { $from: $from } = selection;
            const isEmpty = $from.parent.content.size === 0;
            if (isEmpty && nodes.taskList && nodes.taskItem) {
                // Create an empty task list with one empty task item
                const listLocalId = (0, $fO7hX.uuid).generate();
                const itemLocalId = (0, $fO7hX.uuid).generate();
                const emptyList = nodes.taskList.create({
                    localId: listLocalId
                }, [
                    nodes.taskItem.create({
                        localId: itemLocalId
                    })
                ]);
                // Insert the empty list at the current selection
                const insertTr = (0, $8m4tT.safeInsert)(emptyList)(tr);
                if (insertTr !== tr) {
                    if ((0, $dh538.fg)('platform_editor_toolbar_task_list_analytics')) // Fire INSERT analytics event when creating a new task list
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).INSERTED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ACTION,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: inputMethod,
                            listLocalId: listLocalId,
                            listSize: 1,
                            localId: itemLocalId,
                            position: 0
                        }
                    })(insertTr);
                    // Set cursor inside the new task item
                    const insertPos = insertTr.selection.$from.pos;
                    return insertTr.setSelection((0, $ks2lK.TextSelection).near(insertTr.doc.resolve(insertPos)));
                }
            }
            const { node: node, pos: pos } = (0, $40ae9645382f099a$export$c0b9021b626ac150)(tr);
            if (node !== null && pos !== null) {
                if ((0, $0af71c7c009df6fc$export$1d7e7dcd2590e9c6)(node.type)) {
                    const transformedFrom = node.type.name === 'bulletList' ? (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes.taskList,
                        tr: tr
                    };
                    const resultTr = (0, $40ae9645382f099a$export$2f7df9065a975ace)(context);
                    if ((0, $dh538.fg)('platform_editor_toolbar_task_list_analytics')) // Fire CONVERTED analytics event when transforming a list to task list
                    {
                        if (resultTr && resultTr.docChanged) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).CONVERTED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).LIST,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                ...(0, $e6Sje.getCommonListAnalyticsAttributes)(tr),
                                transformedFrom: transformedFrom,
                                inputMethod: inputMethod
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
                if ((0, $0af71c7c009df6fc$export$adef7a5f125e0514)(node.type)) {
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes[targetType],
                        tr: tr
                    };
                    const resultTr = targetType === 'paragraph' ? (0, $40ae9645382f099a$export$d9cdacbed7444a4a)(context) : (0, $40ae9645382f099a$export$2f7df9065a975ace)(context);
                    // Fire CONVERTED analytics event when transforming from task list
                    if (resultTr && resultTr.docChanged && targetType !== 'paragraph') {
                        const transformedFrom = (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
                        const targetListType = targetType === 'bulletList' ? (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $d925B.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                        if ((0, $dh538.fg)('platform_editor_toolbar_task_list_analytics')) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).CONVERTED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).LIST,
                            actionSubjectId: targetListType,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                ...(0, $e6Sje.getCommonListAnalyticsAttributes)(tr),
                                transformedFrom: transformedFrom,
                                inputMethod: inputMethod
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
                const { $from: $from, $to: $to } = selection;
                const range = $from.blockRange($to);
                if (range) {
                    const resultTr = (0, $40ae9645382f099a$export$201fb3474673bbf3)(tr, range, nodes.taskList, undefined, nodes);
                    // Fire INSERT analytics event when creating task list from selection
                    if (resultTr && resultTr.docChanged) {
                        const listNode = resultTr.doc.nodeAt(range.start);
                        const listLocalIdFromNode = listNode?.attrs?.localId ?? (0, $fO7hX.uuid).generate();
                        const listSizeFromNode = listNode?.childCount ?? 0;
                        const localIdFromNode = listNode?.firstChild?.attrs?.localId ?? (0, $fO7hX.uuid).generate();
                        if ((0, $dh538.fg)('platform_editor_toolbar_task_list_analytics')) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).INSERTED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ACTION,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                inputMethod: inputMethod,
                                listLocalId: listLocalIdFromNode,
                                listSize: listSizeFromNode,
                                localId: localIdFromNode,
                                position: 0
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
            }
            return tr;
        };
    };



const $2da1bf346dcac0f3$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $aU3dp.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $aU3dp.INDENT_TYPE).TASK_LIST
        }
    });
const $2da1bf346dcac0f3$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $2da1bf346dcac0f3$var$nodeAfter($pos);
    return !after || (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(after);
};
const $2da1bf346dcac0f3$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !(0, $2fc4254aeefcece8$export$c4942fd0ddcad0b)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $8a662c092cc6e62e$export$3553eb36282f092b)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $astHL.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $2da1bf346dcac0f3$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel === 1) return false;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).OUTDENT, inputMethod))((0, $astHL.autoJoin)((0, $8a662c092cc6e62e$export$2837bcd4021a2a47), [
                'taskList'
            ]))(state, dispatch);
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $2da1bf346dcac0f3$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(state.selection);
    const curIndex = (0, $2fc4254aeefcece8$export$af0098af8462419f)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cell = (0, $8m4tT.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $2fc4254aeefcece8$export$cc187e317961fba)(state)) && cell) return true;
    return false;
};
const $2da1bf346dcac0f3$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel >= 6) return true;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).INDENT, inputMethod))((0, $astHL.autoJoin)((0, $8a662c092cc6e62e$export$b9f50dd5ccd0f20), [
                'taskList'
            ]))(state, dispatch);
        });
const $2da1bf346dcac0f3$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            const { taskList: taskList, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
            if ((0, $1oCLl.expValEquals)('editor_refactor_backspace_task_and_decisions', 'isEnabled', true)) {
                // Check if selection is inside a blockTaskItem paragraph
                const resultOfFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
                const isInBlockTaskItemParagraph = resultOfFindBlockTaskItem && resultOfFindBlockTaskItem?.hasParagraph;
                // Get the node before the current position
                const beforePos = isInBlockTaskItemParagraph ? $from.before() - 1 : $from.before();
                const nodeBefore = $from.doc.resolve(beforePos).nodeBefore;
                // Check if the node before is an empty task item
                const isEmptyActionOrDecisionItem = nodeBefore && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(nodeBefore) && nodeBefore.content.size === 0;
                const isEmptyBlockTaskItem = blockTaskItem && nodeBefore?.type === blockTaskItem && nodeBefore?.firstChild?.type === paragraph && nodeBefore?.firstChild?.content?.size === 0;
                // previous was empty, just delete backwards
                if (isEmptyActionOrDecisionItem || isEmptyBlockTaskItem) return false;
                // If nested in a taskList, unindent
                const depthFromSelectionToBlockTaskItem = isInBlockTaskItemParagraph ? 2 : 1;
                const depthFromSelectionToNestedTaskList = depthFromSelectionToBlockTaskItem + 1;
                const parentDepth = $from.depth - depthFromSelectionToNestedTaskList;
                if ($from.node(parentDepth).type === taskList) return $2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
                // If at the end of an item, unwrap contents into a paragraph
                // we achieve this by slicing the content out, and replacing
                if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
                    if (dispatch) {
                        // If we are in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                        // So we reduce the depth by 1 to get to the blockTaskItem node content
                        const taskContent = isInBlockTaskItemParagraph ? state.doc.slice($from.start($from.depth - 1), $from.end($from.depth - 1)).content : state.doc.slice($from.start(), $from.end()).content;
                        let slice;
                        try {
                            slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                            // might be end of document after
                            const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        } catch  {
                            // If there's an error creating a paragraph, check if we are in a blockTaskItem
                            // Block task item's can have non-text content that cannot be wrapped in a paragraph
                            // So if the selection is in a blockTaskItem, just pass the content as is
                            if (resultOfFindBlockTaskItem && resultOfFindBlockTaskItem.blockTaskItemNode) {
                                // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                                slice = Array.from(taskContent.content);
                                const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                                dispatch(tr);
                                return true;
                            }
                        }
                    }
                }
            } else {
                // previous was empty, just delete backwards
                const taskBefore = $from.doc.resolve($from.before());
                if (taskBefore.nodeBefore && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(taskBefore.nodeBefore) && taskBefore.nodeBefore.nodeSize === 2) return false;
                // if nested, just unindent
                if ($from.node($from.depth - 2).type === taskList) return $2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
                // If at the end of an item, unwrap contents into a paragraph
                // we achieve this by slicing the content out, and replacing
                if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
                    if (dispatch) {
                        const taskContent = state.doc.slice($from.start(), $from.end()).content;
                        let slice;
                        try {
                            slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                            // might be end of document after
                            const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        } catch  {
                            // If there's an error creating a paragraph, then just pass the content as is
                            // Block task item's can have non-text content that cannot be wrapped in a paragraph
                            if (blockTaskItem) {
                                // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                                slice = Array.from(taskContent.content);
                                const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                                dispatch(tr);
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        };
const $2da1bf346dcac0f3$var$backspace = (editorAnalyticsAPI)=>(0, $e7tBw.filterCommand)((0, $e7tBw.isEmptySelectionAtStart), (0, $astHL.autoJoin)((0, $astHL.chainCommands)((state, dispatch)=>(0, $8a662c092cc6e62e$export$3553eb36282f092b)(state.selection.$from)(state, dispatch), (0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (state, dispatch)=>$2da1bf346dcac0f3$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph, blockTaskItem: blockTaskItem, taskItem: taskItem } }, tr: tr } = state;
    if ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_3')) {
        // only run if cursor is at the end of the node
        if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !dispatch) return false;
        // look for the node after this current one
        const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)($from);
        // this is a top-level node it wont have $next.before()
        if (!$next.parent || $next.parent.type === doc) return false;
        // get resolved position of parent
        const $parentPos = $from.doc.resolve($from.start($from.depth - 1));
        const currentNode = $from.node();
        const parentNode = $parentPos.node();
        // if current position isn't an action or decision item, return false
        if (!(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(currentNode) && !(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(parentNode)) return false;
        const resultOfCurrentFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($next);
        let isCurrentEmptyBlockTaskItem = false;
        if (resultOfCurrentFindBlockTaskItem) {
            const { blockTaskItemNode: blockTaskItemNode } = resultOfCurrentFindBlockTaskItem;
            isCurrentEmptyBlockTaskItem = blockTaskItem && blockTaskItemNode && blockTaskItemNode.childCount === 1 && blockTaskItemNode.firstChild?.type === paragraph && blockTaskItemNode.firstChild.childCount === 0;
        }
        const isEmptyActionOrDecisionItem = currentNode && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(currentNode) && currentNode.childCount === 0;
        // If empty item, use default handler
        if (isEmptyActionOrDecisionItem || isCurrentEmptyBlockTaskItem) return false;
        // Check if next node is a blockTaskItem paragraph
        const resultOfNextFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($next);
        const isNextInBlockTaskItemParagraph = resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem?.hasParagraph;
        // if nested, just unindent
        if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
        $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
            (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(tr, $next, $next);
            dispatch(tr);
            return true;
        }
        const isNextCompatibleWithBlockTaskItem = blockTaskItem && ($next?.node()?.type === taskItem && $from?.node()?.type === blockTaskItem || $next?.node()?.type === blockTaskItem && $from?.node()?.type === taskItem || [
            taskItem,
            blockTaskItem
        ].includes($next?.node()?.type) && resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode);
        // if next node is of same type or compatible type, remove the node wrapping and create paragraph
        if (!(0, $2fc4254aeefcece8$export$567a2801b8f40ab5)($next.nodeAfter) && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($from.parent) || resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode && $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type or compatible
        ($next.node().type.name === $from.node().type.name || isNextCompatibleWithBlockTaskItem)) {
            if (dispatch) {
                // If next node is in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                // So we reduce the depth by 1 to get to the blockTaskItem node content
                const taskContent = isNextInBlockTaskItemParagraph ? state.doc.slice($next.start($next.depth - 1), $next.end($next.depth - 1)).content : state.doc.slice($next.start(), $next.end()).content;
                let slice;
                try {
                    slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                    // might be end of document after
                    const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $next, false);
                    dispatch(tr);
                    return true;
                } catch  {
                    // If there's an error creating a paragraph, check if we are in a blockTaskItem
                    // Block task item's can have non-text content that cannot be wrapped in a paragraph
                    // So if the selection is in a blockTaskItem, just pass the content as is
                    if (resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem.blockTaskItemNode) {
                        // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                        slice = Array.from(taskContent.content);
                        let $splitPos = $next;
                        if ($next.node().firstChild?.isTextblock) // set $next to the resolved position of inside the textblock
                        $splitPos = $next.doc.resolve($next.pos + 1);
                        const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $splitPos, false);
                        dispatch(tr);
                        return true;
                    }
                }
            }
        }
    } else {
        // only run if cursor is at the end of the node
        if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !dispatch) return false;
        // look for the node after this current one
        const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)($from);
        // this is a top-level node it wont have $next.before()
        if (!$next.parent || $next.parent.type === doc) return false;
        // if nested, just unindent
        if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
        $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
            (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(tr, $next, $next);
            dispatch(tr);
            return true;
        }
        // if next node is of same type, remove the node wrapping and create paragraph
        if (!(0, $2fc4254aeefcece8$export$567a2801b8f40ab5)($next.nodeAfter) && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($from.parent) && $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type
        $next.node().type.name === $from.node().type.name) {
            const taskContent = state.doc.slice($next.start(), $next.end()).content;
            // might be end of document after
            const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : [];
            dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, slice, $next, false));
            return true;
        }
    }
    return false;
};
const $2da1bf346dcac0f3$var$deleteForwards = (0, $astHL.autoJoin)((0, $astHL.chainCommands)((0, $e7tBw.deleteEmptyParagraphAndMoveBlockUp)((0, $2fc4254aeefcece8$export$6f0e2eafb461f634)), $2da1bf346dcac0f3$var$joinTaskDecisionFollowing, $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $2da1bf346dcac0f3$var$deleteExtraListItem = (tr, _$from)=>{
    /*
    After we replace actionItem with empty list item if there's the anomaly of extra empty list item
    the cursor moves inside the first taskItem of splitted taskList
    so the extra list item present above the list item containing taskList & cursor
  */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $2da1bf346dcac0f3$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $2fc4254aeefcece8$export$cd0bf0d386a8d5a7)($from);
    const previousChildCountOfList = parentListNode?.node.childCount;
    const currentParentListNode = (0, $2fc4254aeefcece8$export$cd0bf0d386a8d5a7)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode?.node.childCount;
    /*
    While replacing range with empty list item an extra list item gets created in some of the scenarios
    After splitting only one extra listItem should be created else an extra listItem is created
  */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $2da1bf346dcac0f3$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $2da1bf346dcac0f3$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    const origDoc = tr.doc;
    const { blockTaskItem: blockTaskItem, taskList: taskList } = tr.doc.type.schema.nodes;
    let baseDepth = $from.depth;
    let $oldAfter = origDoc.resolve($from.after());
    let textSelectionModifier = 0;
    let replaceFromModifier = 0;
    let deleteBlockModifier = 0;
    let shouldSplitBlockTaskItem = true;
    let isGapCursorSelection = false;
    let hasBlockTaskItem = false;
    if (blockTaskItem) {
        const result = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (result) {
            const { blockTaskItemNode: blockTaskItemNode, hasParagraph: hasParagraph } = result;
            hasBlockTaskItem = (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3') && !!blockTaskItemNode;
            if (blockTaskItemNode) {
                // If the case there is a paragraph in the block task item we need to
                // adjust some calculations
                if (hasParagraph) {
                    baseDepth = $from.depth - 1;
                    $oldAfter = origDoc.resolve($from.after(baseDepth));
                    // When we're removing the extra empty task item we need to reduce the range a bit
                    deleteBlockModifier = 1;
                } else {
                    textSelectionModifier = 1;
                    isGapCursorSelection = true;
                }
                textSelectionModifier = 1;
                const hasSiblingTaskList = $oldAfter.nodeAfter?.type === taskList;
                if (hasSiblingTaskList) // Don't use the split command if there is a sibling taskList
                shouldSplitBlockTaskItem = false;
                const posPreviousSibling = $from.start(hasParagraph ? $from.depth - 1 : $from.depth) - 1;
                const $posPreviousSibling = tr.doc.resolve(posPreviousSibling);
                const hasPreviousTaskItem = $posPreviousSibling.nodeBefore?.type === blockTaskItem;
                if (hasPreviousTaskItem && hasParagraph) replaceFromModifier = 1;
            }
        }
    }
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node(baseDepth - 2);
    const posInList = $from.index(baseDepth - 1);
    const shouldSplit = !(!(0, $2fc4254aeefcece8$export$6f0e2eafb461f634)(container) && posInList === 0) && shouldSplitBlockTaskItem;
    const frag = (0, $5SAOw.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && frag.firstChild?.type.name === 'listItem';
    /*
	 * We don't split the list item if it's nested inside lists
	 * to have consistent behaviour and their resolution.
	 */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3') && hasBlockTaskItem ? 0 : 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $fO7hX.uuid).generate()
            }
        }
    ]);
    /*
	 * In case of nested action inside lists we explicitly set the cursor
	 * We need to insert it relatively to previous doc structure
	 * So we calculate the position of previous list item and save that position
	 * (The cursor can be placed easily next to list item)
	 */ const previousListItemPos = isNestedActionInsideLists ? $from.start(baseDepth - 2) : 0;
    tr = tr.replace(tr.mapping.map($from.start(baseDepth) - 2 + replaceFromModifier), tr.mapping.map($from.end(baseDepth) + 2), frag.size ? new (0, $5SAOw.Slice)(frag, 0, 0) : (0, $5SAOw.Slice).empty);
    if (setSelection && !isNestedActionInsideLists) {
        const newPos = $from.pos + 1 - ((shouldSplit ? 0 : 2) + textSelectionModifier);
        if (isGapCursorSelection) tr = tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(newPos), (0, $adhil.Side).LEFT));
        else tr = tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(newPos)));
    }
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === baseDepth - 1) {
        if ($oldAfter.nodeAfter && (0, $2fc4254aeefcece8$export$6f0e2eafb461f634)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $2fc4254aeefcece8$export$f029cbac7e0ab14c)({
                $from: $after,
                $to: tr.doc.resolve($after.after($after.depth - 1) - 1)
            });
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // After replacing the range there is an empty task item that
            // we need to remove.
            // We delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            // If this operation was done on a blockTaskItem we
            // have a modifier for the position
            tr = tr.deleteRange(pos - 3 - deleteBlockModifier, pos - 1 - deleteBlockModifier);
        }
    }
    if (isNestedActionInsideLists) $2da1bf346dcac0f3$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $2da1bf346dcac0f3$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $2da1bf346dcac0f3$var$splitListItem = (state, dispatch)=>{
    const { tr: tr, selection: { $from: $from } } = state;
    const { listItem: listItem, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph } = state.schema.nodes;
    if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            if ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_3')) {
                // If previous node is a blockTaskItem we just want to delete the existing node and replace it with a paragraph
                const nodeBefore = state.doc.resolve($from.pos - 1).nodeBefore;
                if (blockTaskItem && nodeBefore?.type === blockTaskItem) {
                    if ($from.parent.type === taskItem) {
                        const nodeSize = $from.parent.nodeSize;
                        tr.delete($from.pos - Math.floor(nodeSize / 2), $from.pos + Math.ceil(nodeSize / 2));
                        tr.insert($from.pos, paragraph.createChecked());
                        dispatch(tr);
                        return true;
                    }
                }
            }
            if ((0, $8m4tT.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, $2da1bf346dcac0f3$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, paragraph.createChecked(), $from, true));
        }
        return true;
    }
    return false;
};
const $2da1bf346dcac0f3$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (0, $astHL.chainCommands)((0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$e29ace8e645e5684), (0, $astHL.chainCommands)($2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $2da1bf346dcac0f3$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        let nodeType = node && node.type;
        // Get the parent node type if the current node type is not one of the task or decision items
        // This is required to handle blockTaskItem
        if (![
            decisionItem,
            taskItem,
            blockTaskItem
        ].includes(nodeType)) {
            const possibleNodeType = (0, $8m4tT.findParentNodeOfType)([
                decisionItem,
                taskItem,
                blockTaskItem
            ])(selection)?.node?.type;
            if (possibleNodeType) nodeType = possibleNodeType;
        }
        const listType = [
            taskItem,
            blockTaskItem
        ].includes(nodeType) ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0 && ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? !$from.parent.isTextblock || (0, $2fc4254aeefcece8$export$2ca50ccc2f45db88)(state) : true)) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) {
                    if (nodeType === blockTaskItem) {
                        const blockTaskItemNode = (0, $8m4tT.findParentNodeOfType)([
                            blockTaskItem
                        ])(selection);
                        // New task items for blockTaskItem should be taskItem
                        // We want to prevent creating new blockTaskItems as much as possible
                        const newTaskItem = taskItem.createAndFill({
                            localId: itemLocalId
                        });
                        if (!blockTaskItemNode || !newTaskItem) return tr;
                        return tr.insert(blockTaskItemNode.pos, newTaskItem);
                    }
                    // Current position will point to text node, but we want to insert above the taskItem node
                    return tr.insert($from.pos - 1, newTask);
                }
            }
            /**
					 * For blockTaskItem, must handle it differently because it can have a different depth
					 */ if (nodeType === blockTaskItem) {
                const blockTaskItemNode = (0, $8m4tT.findParentNodeOfType)([
                    blockTaskItem
                ])(selection);
                if (!blockTaskItemNode) return tr;
                // If the selection is a gap cursor at the end of the blockTaskItem,
                // we should insert a new taskItem.
                if (((0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? !$from.parent.isTextblock || (0, $2fc4254aeefcece8$export$bcd44b9b102ed403)(state) : true) && $from.parentOffset === $from.parent.nodeSize - 2) {
                    const newTaskItem = taskItem.createAndFill({
                        localId: itemLocalId
                    });
                    if (newTaskItem) {
                        tr.insert(blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize, newTaskItem);
                        // Move the cursor to the end of the newly inserted blockTaskItem
                        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize + 1));
                        return tr;
                    }
                }
                // Split near the depth of the current selection
                return tr.split($from.pos, (0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? $from?.parent?.isTextblock ? 2 : 1 : $from.depth - 1, [
                    {
                        type: blockTaskItem,
                        attrs: {
                            localId: itemLocalId
                        }
                    }
                ]);
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $593b7407307544bb$export$14f75d90d7dffdab)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $d925B.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $2da1bf346dcac0f3$var$cmdOptEnter = (0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $9YoeD.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $2da1bf346dcac0f3$export$e832373cff8dec22(_schema, api, allowNestedTasks, consumeTabs) {
    const getContextIdentifier = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    const indentHandlers = {
        'Shift-Tab': (0, $e7tBw.filterCommand)([
            (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$d5d1010fad3453fa(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs),
        Tab: (0, $e7tBw.filterCommand)([
            (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$b294289254b8cdac(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs)
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
        Tab: (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b)
    } : {};
    const toggleTaskListShortcut = (state, dispatch)=>{
        if (!state.schema.nodes.taskItem) return false;
        if (dispatch) {
            const command = (0, $2b7d7c8d49850f96$export$2e48e3ea1c210731)(api?.analytics?.actions)();
            const tr = command({
                tr: state.tr
            });
            if (tr) {
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
    const keymaps = {
        Backspace: $2da1bf346dcac0f3$var$backspace(api?.analytics?.actions),
        Delete: $2da1bf346dcac0f3$var$deleteForwards,
        'Ctrl-d': $2da1bf346dcac0f3$var$deleteForwards,
        Enter: $2da1bf346dcac0f3$var$enter(api?.analytics?.actions, getContextIdentifier),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $hgeg8.toggleTaskItemCheckbox).common]: $2da1bf346dcac0f3$var$cmdOptEnter,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $hgeg8.toggleTaskList).common]: toggleTaskListShortcut,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $dus6D.keymap)(keymaps);
}
var $2da1bf346dcac0f3$export$2e2bcd8739ae039 = $2da1bf346dcac0f3$export$e832373cff8dec22;












var $3tffm = parcelRequire("3tffm");




var $2pjJ5 = parcelRequire("2pjJ5");





var $ftzrq = parcelRequire("ftzrq");













// This value can be a fixed constant as it doesn't depend on runtime values or arguments.
const $02f4886b88fe9752$var$iconDOM = [
    'span',
    {
        contentEditable: false,
        'data-component': 'icon'
    },
    [
        'span',
        {
            role: 'img',
            'aria-label': 'Decision'
        },
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `0 0 24 24`,
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'legacy'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                }
            ]
        ],
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `-4 -4 24 24`,
                fill: 'none',
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'refreshed'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z'
                }
            ]
        ]
    ]
];
const $02f4886b88fe9752$export$e9f11508261835be = (node, intl)=>{
    const contentDomDataAttrs = node.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    return [
        'li',
        {
            'data-decision-local-id': node.attrs.localId || 'local-decision',
            'data-decision-state': node.attrs.state,
            'data-prosemirror-node-name': 'decisionItem',
            class: 'decisionItemView-content-wrap'
        },
        [
            'div',
            {
                'data-testid': 'elements-decision-item',
                'data-decision-wrapper': true
            },
            $02f4886b88fe9752$var$iconDOM,
            // renderPlaceholder
            [
                'span',
                {
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contentEditable: false
                },
                intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).decisionPlaceholder)
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: 'decision-item',
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
};


class $2e866c54e15eb318$export$a190d28468c64715 {
    /**
   * Updates the hasChildren state based on the node's child count by setting the `data-empty` attribute on the contentDOM.
   * @param node - The ProseMirror node to check for children.
   * @private
   */ updateHasChildren(node) {
        const currentlyHasChildren = node.childCount > 0;
        if (currentlyHasChildren !== this.hasChildren) {
            this.hasChildren = currentlyHasChildren;
            this.contentDOM?.toggleAttribute('data-empty', !currentlyHasChildren);
        }
        return this.hasChildren;
    }
    /**
   * Updates the node view when the ProseMirror node changes.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @param {PMNode} node - The ProseMirror node to update the view with.
   * @example
   * decisionItemNodeView.update(node);
   * @returns {boolean} - Returns true if the view was updated successfully.
   */ update(node) {
        this.updateHasChildren(node);
        return true;
    }
    /**
   * Determines whether a mutation should be ignored by ProseMirror.
   * This prevents unnecessary node view destruction during DOM changes that don't affect our content.
   * @param mutation - The DOM mutation record or selection change
   * @returns true if the mutation should be ignored, false if it should be processed
   * @example
   * // Mutation outside contentDOM will be ignored
   * const shouldIgnore = decisionItemNodeView.ignoreMutation(mutationRecord);
   */ ignoreMutation(mutation) {
        // This was discovered while implementing the platform_editor_debounce_portal_provider experiment
        // And there will only be an issue if the experiment is enabled.
        // As such, this fix is behind this experiment.
        if (!(0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true, false)) return false; // Let ProseMirror handle all mutations when experiment is disabled
        if (!this.contentDOM) return true;
        // Ignore mutations that don't target our contentDOM and aren't selection changes
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    /**
   * Creates a new DecisionItemNodeView.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @import type {IntlShape} from 'react-intl-next';
   * @param {PMNode} node - The ProseMirror node representing the decision item.
   * @param {IntlShape} intl - The IntlShape for internationalization, used to format the placeholder text.
   * @example
   * const decisionItemNodeView = new DecisionItemNodeView(node, getIntl());
   */ constructor(node, intl){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.hasChildren = undefined;
        const spec = (0, $02f4886b88fe9752$export$e9f11508261835be)(node, intl);
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}



var $fFa3V = parcelRequire("fFa3V");
















class $7906c8f910b83ab0$export$8e651bc5e6600399 {
    getContextIdentifierProvider() {
        return this.api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    getObjectAri() {
        const provider = this.getContextIdentifierProvider();
        if (provider) return provider.objectId;
        return undefined;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    // Update the placeholder visibility based on content
    updatePlaceholder(node) {
        let currentIsContentEmpty = this.isContentEmpty(node);
        if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) currentIsContentEmpty = (0, $d9e9935026bf8066$export$c0efac86beb21f01)(node);
        if (currentIsContentEmpty !== this.emptyContent) {
            this.emptyContent = currentIsContentEmpty;
            this.contentDOM?.toggleAttribute('data-empty', currentIsContentEmpty);
        }
    }
    update(node) {
        if (!(0, $1oCLl.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            const isValidUpdate = node.type === this.node.type && !!(node.attrs.state === this.node.attrs.state);
            if (!isValidUpdate) return false;
        }
        // Only return false if this is a completely different task
        if (this.node.attrs.localId !== node.attrs.localId) return false;
        if ((0, $1oCLl.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            if (node.type !== this.node.type) return false;
            const stateChanged = node.type === this.node.type && !!(node.attrs.state !== this.node.attrs.state);
            // Update task checkbox state to match document state.
            // It's possible the state may have changed from a collab edit and not from a checkbox click
            // so we need to update the checkbox to match.
            if (stateChanged && this.input) this.input.checked = node.attrs.state === 'DONE';
        }
        this.updatePlaceholder(node);
        if (this.domElement && !node.sameMarkup(this.node)) {
            this.domElement.setAttribute('data-task-state', node.attrs.state);
            this.domElement.setAttribute('data-task-local-id', node.attrs.localId);
            this.domElement.setAttribute('state', node.attrs.state);
        }
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.unbindInputDom) this.unbindInputDom();
        this.contentDOM = undefined;
        this.input = undefined;
        this.emptyContent = undefined;
        this.api = undefined;
    }
    constructor(node, view, getPos, { api: api, placeholder: placeholder, intl: intl }){
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.unbindInputDom = void 0;
        this.emptyContent = void 0;
        this.input = void 0;
        this.handleOnClick = (event)=>{
            if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                event.stopImmediatePropagation();
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $2fc4254aeefcece8$export$ccb659c518fe26ad)(this.view, pos);
                return;
            }
        };
        this.handleOnChange = ()=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return;
            const { localId: localId, state: state } = this.node.attrs;
            const isDone = state === 'DONE';
            const nextState = isDone ? 'TODO' : 'DONE';
            const currentTaskDecisionState = this.api?.taskDecision.sharedState.currentState();
            // logic is inspired from packages/elements/task-decision/src/components/ResourcedTaskItem.tsx
            const objectAri = this.getObjectAri();
            if (currentTaskDecisionState?.taskDecisionProvider && objectAri) currentTaskDecisionState.taskDecisionProvider.toggleTask({
                localId: localId,
                objectAri: objectAri
            }, nextState);
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $9YoeD.SetAttrsStep)(nodePos, {
                state: nextState,
                localId: localId
            }));
            tr.setMeta('scrollIntoView', false);
            const taskItemInfoMeta = {
                checkState: nextState,
                from: nodePos,
                to: nodePos + this.node.nodeSize
            };
            tr.setMeta('taskItemInfo', taskItemInfoMeta);
            this.view.dispatch(tr);
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.intl = intl;
        this.api = api;
        this.view = view;
        const domPlaceholder = placeholder ?? this.intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskPlaceholder);
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $13787dd647975a80$export$640336359e1ccaeb)(node, domPlaceholder, intl));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.domElement = this.dom instanceof HTMLElement ? this.dom : undefined;
        if (this.domElement) {
            this.input = this.domElement.querySelector('input[type="checkbox"]');
            this.unbindInputDom = (0, $fFa3V.bindAll)(this.input, [
                {
                    type: 'click',
                    listener: this.handleOnClick
                },
                {
                    type: 'change',
                    listener: this.handleOnChange
                }
            ]);
        }
    }
}


const $ea01580a5a6127d1$export$da2f2be53bb82f44 = (api, intl, placeholder)=>{
    return (node, view, getPos)=>{
        return new (0, $7906c8f910b83ab0$export$8e651bc5e6600399)(node, view, getPos, {
            placeholder: placeholder,
            api: api,
            intl: intl
        });
    };
};


const $06de0f51abda899d$export$9af39543e75ed75a = (state, action)=>{
    return {
        ...state,
        focusedTaskItemLocalId: action.data
    };
};
const $06de0f51abda899d$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        taskDecisionProvider: action.data
    };
};
const $06de0f51abda899d$export$571ff0891839feec = (state, action)=>{
    return {
        ...state,
        openRequestToEditPopupAt: action.data
    };
};




function $34bba4e4e015a378$export$4f9e52c150984a8a(view, event) {
    const { target: target } = event;
    if (!target || !(target instanceof HTMLInputElement) || target.type !== 'checkbox' || target.getAttribute('data-input-type') !== 'lazy-task-item') return;
    const pos = view.posAtDOM(target, 0);
    // Resolve the position in the current document
    const resolvedPos = view.state.doc.resolve(pos);
    // Access the parent node
    const parentNode = resolvedPos?.parent;
    if (parentNode?.type?.name !== 'taskItem') return;
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const tr = view.state.tr.setNodeMarkup(parentPos, null, {
        ...parentNode.attrs,
        state: target.checked ? 'DONE' : 'TODO'
    });
    view.dispatch(tr);
}









const $1c1225914357e914$export$7e04b173e2b79898 = (slice, view)=>{
    const { schema: schema } = view.state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    // Check if we're pasting into a taskItem
    const { $from: $from } = view.state.selection;
    const isInTaskItem = $from.node().type === taskItem;
    if (isInTaskItem && blockTaskItem) {
        // Transform the slice to replace blockTaskItems with taskItems
        const transformedContent = [];
        slice.content.forEach((node)=>{
            if (node.type === blockTaskItem) {
                // Check if blockTaskItem only contains paragraphs
                let allChildrenAreParagraphs = true;
                node.content.forEach((child)=>{
                    if (child.type !== paragraph) allChildrenAreParagraphs = false;
                });
                if (allChildrenAreParagraphs && node.childCount > 0) // Convert each paragraph to a taskItem
                node.content.forEach((paragraphNode)=>{
                    const newTaskItem = taskItem.create({
                        localId: (0, $fO7hX.uuid).generate(),
                        state: node.attrs.state || 'TODO'
                    }, paragraphNode.content);
                    transformedContent.push(newTaskItem);
                });
                else // Keep the blockTaskItem as is if it doesn't only contain paragraphs
                transformedContent.push(node);
            } else // Keep other nodes as is
            transformedContent.push(node);
        });
        // Create new slice with transformed content
        if (transformedContent.length !== slice.content.childCount || transformedContent.some((node, idx)=>node !== slice.content.child(idx))) {
            const newFragment = (0, $5SAOw.Fragment).from(transformedContent);
            return new (0, $5SAOw.Slice)(newFragment, slice.openStart, slice.openEnd);
        }
    }
    return slice;
};


function $bc3faaa8c98786d9$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $2pjJ5.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $bc3faaa8c98786d9$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder) {
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $ea01580a5a6127d1$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder),
                decisionItem: (node)=>{
                    return new (0, $2e866c54e15eb318$export$a190d28468c64715)(node, getIntl());
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? {
                    blockTaskItem: (0, $ea01580a5a6127d1$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder)
                } : {}
            },
            decorations (state) {
                const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(state);
                if (pluginState?.decorations) return pluginState.decorations;
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'decisionItem',
                'taskItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                // When the page is lazy loaded and task item is not yet available this allows
                // our toDOM implementation to toggle the node state
                change: (0, $34bba4e4e015a378$export$4f9e52c150984a8a)
            },
            handleKeyDown: (view, event)=>{
                const { state: state } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1)(state) : $from.node().type === schema.nodes.taskItem;
                const focusedTaskItemLocalId = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $2fc4254aeefcece8$export$bb36b9aa75d84160)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === currentTaskItemData?.localId;
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $2fc4254aeefcece8$export$84c7d27d1433771f)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    (0, $2fc4254aeefcece8$export$6ddc162ae107856)(view, currentTaskItemData);
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === 'left' && $from.nodeAfter?.type === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $2fc4254aeefcece8$export$84c7d27d1433771f)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            },
            transformPasted: (slice, view)=>{
                if (Boolean(view?.state?.schema?.nodes?.blockTaskItem)) slice = (0, $1c1225914357e914$export$7e04b173e2b79898)(slice, view);
                return slice;
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent,
                    focusedTaskItemLocalId: null,
                    taskDecisionProvider: undefined,
                    decorations: (0, $ftzrq.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882));
                const { action: action, data: data } = metaData ?? {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID:
                        newPluginState = (0, $06de0f51abda899d$export$9af39543e75ed75a)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
                            data: data
                        });
                        break;
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER:
                        newPluginState = (0, $06de0f51abda899d$export$1572b3eade6662f9)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER,
                            data: data
                        });
                        break;
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP:
                        newPluginState = (0, $06de0f51abda899d$export$571ff0891839feec)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
                            data: data
                        });
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                const taskItemInfo = tr.getMeta('taskItemInfo');
                let decorations = (0, $ftzrq.DecorationSet).empty;
                if (taskItemInfo) decorations = (0, $ftzrq.DecorationSet).create(tr.doc, [
                    (0, $ftzrq.Decoration).inline(taskItemInfo.from, taskItemInfo.to, {}, {
                        dataTaskNodeCheckState: taskItemInfo.checkState
                    })
                ]);
                else decorations = newPluginState.decorations?.map(tr.mapping, tr.doc);
                const newState = {
                    ...newPluginState,
                    decorations: decorations
                };
                dispatch((0, $e74ddcb3d2085778$export$77b371d6becc8882), newState);
                return newState;
            }
        },
        key: (0, $e74ddcb3d2085778$export$77b371d6becc8882),
        /*
     * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
     * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
     * Prosemirror capability where node attributes could be generated dynamically.
     * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
     *
     * Note: we currently do not handle the edge case where two nodes may have the same localId
     */ appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $bc3faaa8c98786d9$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem || blockTaskItem && node.type === blockTaskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                                localId: (0, $fO7hX.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(view.state);
                    const prevPluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(prevState);
                    if (pluginState.focusedTaskItemLocalId === prevPluginState.focusedTaskItemLocalId) return;
                    const taskItem = (0, $2fc4254aeefcece8$export$bb36b9aa75d84160)(view);
                    if (!taskItem) return;
                    if (pluginState.focusedTaskItemLocalId === taskItem.localId) {
                        const taskElement = view.nodeDOM(taskItem.pos);
                        if (taskElement instanceof HTMLElement) taskElement?.querySelector('input')?.focus();
                    }
                }
            };
        }
    });
}







parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");





var $eKkkY = parcelRequire("eKkkY");


var $2GVu1 = parcelRequire("2GVu1");


var $ejBUP = parcelRequire("ejBUP");

const $f7fe21105709aaf2$var$NODE_NAME = 'decisionList';
const $f7fe21105709aaf2$export$77edd8d99970778c = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.decisionList, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $f7fe21105709aaf2$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ejBUP))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).decisionList)
    });
};


/* RequestToEditPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ // import Popup from '@atlaskit/popup';




var $42omo = parcelRequire("42omo");










var $e2wMq = parcelRequire("e2wMq");





var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");





var $aFUXX = parcelRequire("aFUXX");


var $cO1el = parcelRequire("cO1el");


var $cvXh8 = parcelRequire("cvXh8");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

const $3825fe6825229574$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT = 3000;
const $3825fe6825229574$var$popupContentWrapper = null;
const $3825fe6825229574$var$wrapperStyles = null;
const $3825fe6825229574$var$wrapperBoxStyles = null;
const $3825fe6825229574$var$dotStyles = null;
const $3825fe6825229574$var$dotStylesUnbounded = null;
const $3825fe6825229574$var$pressableStyles = {
    pressable: "_ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1oa5 _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $3825fe6825229574$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $e2wMq.PLATFORMS).WEB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    };
};
const $3825fe6825229574$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit),
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "requested-to-edit",
                color: "var(--ds-icon-disabled, #080F214A)"
            })
        ]
    });
};
const $3825fe6825229574$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: onClick,
            xcss: $3825fe6825229574$var$pressableStyles.pressable,
            testId: "request-to-edit-popup-request-btn",
            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit)
        })
    });
};
const $3825fe6825229574$export$2dae066a4c27dc7a = ({ element: element, api: api, editorView: editorView, onClose: onClose, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const hasRequestedEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.openRequestToEditPopupAt');
    const [isOpen, setIsOpen] = (0, $42omo.useState)(!!openRequestToEditPopupAt);
    const [requested, setRequested] = (0, $42omo.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const onHandleEdit = (event)=>{
        event.stopPropagation();
        const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
        if (viewMode !== 'view') return;
        const editorAnalyticsAPI = api?.analytics?.actions;
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        tr.setMeta('scrollIntoView', false);
        if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
            const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI?.attachAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).DISMISSED));
        setIsOpen(false);
        onClose();
    };
    const onHandleCancel = (event)=>{
        // Check if the click is on task item checkbox, if so, do not close the popup
        const target = event.target;
        if (target && (element.contains(target) || element === target)) return;
        setIsOpen(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$PopupWithListeners // Ignored via go/ees005
    , {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        target: element,
        fitHeight: 148,
        handleClickOutside: onHandleCancel,
        handleEscapeKeydown: onHandleCancel,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        ariaLabel: null,
        preventOverflow: true,
        focusTrap: true,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: setOutsideClickTargetRef,
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _ca0qv77o _n3tdv77o _19bvv77o _u5f3v77o _16qs130s _bfhk1bhr"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).editAccessTitle)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEditDescription)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                    className: (0, $gMc0m.default)([
                                        "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1gmx"
                                    ]),
                                    children: [
                                        tryingRequest || requested ? /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$RequestedMessage, {}) : /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$RequestToEditButton, {
                                            onClick: onHandleEdit
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            className: (0, $gMc0m.default)([
                                                "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhk16e3",
                                                "_2rko1rr0"
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                                onClick: ()=>onHandleDismiss(api?.analytics?.actions),
                                                xcss: $3825fe6825229574$var$pressableStyles.pressable,
                                                testId: "request-to-edit-popup-cancel-btn",
                                                children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).dismiss)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
        })
    });
};





parcelRequire("42omo");














var $dmbve = parcelRequire("dmbve");

const $fef31ad80b5dd689$var$NODE_NAME = 'taskList';
const $fef31ad80b5dd689$export$de5198967b780ae = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.taskList, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $fef31ad80b5dd689$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            label: ""
        }),
        children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskList)
    });
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




parcelRequire("42omo");





var $eiA8Z = parcelRequire("eiA8Z");












var $jbmmV = parcelRequire("jbmmV");

const $619e6ad826b1d0bb$export$a78d1842153dea18 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isInsideTask: isInsideTask } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>({
            isInsideTask: states.taskDecisionState?.isInsideTask
        }));
    const handleClick = ()=>{
        api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $hgeg8.formatShortcut)((0, $hgeg8.toggleTaskList))
        }),
        isSelected: isInsideTask,
        isDisabled: false,
        onClick: handleClick,
        ariaKeyshortcuts: (0, $hgeg8.formatShortcut)((0, $hgeg8.toggleTaskList)),
        children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskList)
    });
};


const $9346d09a2f438667$export$f1884d013db554cc = ({ api: api })=>{
    return [
        {
            type: (0, $cPCP8.TASK_LIST_MENU_ITEM).type,
            key: (0, $cPCP8.TASK_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $4Chin.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $cPCP8.TASK_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $619e6ad826b1d0bb$export$a78d1842153dea18), {
                    api: api,
                    parents: parents
                })
        }
    ];
};





parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");





var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");





const $ed8ed537ed67ff6e$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $593b7407307544bb$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ejBUP))), {
            label: label
        })
    });
};
var $ed8ed537ed67ff6e$export$2e2bcd8739ae039 = (0, $gmMgo.default)($ed8ed537ed67ff6e$var$ToolbarDecision);





parcelRequire("42omo");













var $7FcUt = parcelRequire("7FcUt");


const $50c6c5eb0364220d$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $593b7407307544bb$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FcUt))), {
            label: label
        })
    });
};
var $50c6c5eb0364220d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($50c6c5eb0364220d$var$ToolbarTask);


const $715bf2373cc9aad1$var$taskDecisionToolbarGroupStyles = null;
const $715bf2373cc9aad1$var$TASK_LIST_NODE_NAME = 'taskList';
const $715bf2373cc9aad1$var$DECISION_LIST_NODE_NAME = 'decisionList';
const $715bf2373cc9aad1$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $593b7407307544bb$export$c8b7fdb74eb8fe5c)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
function $715bf2373cc9aad1$var$ContentComponent({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi }) {
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.openRequestToEditPopupAt');
    const hasEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.hasEditPermission');
    if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return null;
    if (hasEditPermission || !openRequestToEditPopupAt) return null;
    const domAtPos = editorView.domAtPos.bind(editorView); // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $8m4tT.findDomRefAtPos)(openRequestToEditPopupAt, domAtPos);
    const handleOnClose = ()=>{
        (0, $2fc4254aeefcece8$export$6e1436cb7b69383b)(editorView);
        editorView.focus();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3825fe6825229574$export$2dae066a4c27dc7a), {
        api: dependencyApi,
        editorView: editorView,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: element,
        onClose: handleOnClose
    }, openRequestToEditPopupAt);
}
const $715bf2373cc9aad1$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission = true, hasRequestedEditPermission: hasRequestedEditPermission, quickInsertActionDescription: quickInsertActionDescription, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, taskPlaceholder: taskPlaceholder, allowBlockTaskItem: allowBlockTaskItem } = {}, api: api })=>{
    const getIdentifierProvider = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    let previousTaskAndDecisionProvider;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $9346d09a2f438667$export$f1884d013db554cc)({
        api: api
    }));
    if (taskDecisionProvider) taskDecisionProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>(0, $593b7407307544bb$export$1572b3eade6662f9)(provider)(tr));
    });
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]
            },
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $fef31ad80b5dd689$export$de5198967b780ae), {
                    api: api
                });
            },
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($715bf2373cc9aad1$var$TASK_LIST_NODE_NAME))
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]
            },
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $f7fe21105709aaf2$export$77edd8d99970778c), {
                    api: api
                });
            },
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($715bf2373cc9aad1$var$DECISION_LIST_NODE_NAME))
        }
    ]);
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $gClzS.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $2dd6d5f87dea1a71$export$7727308e3d6fe8e9)()
                },
                {
                    name: 'taskList',
                    node: (0, $cXZ4C.taskList)
                },
                {
                    name: 'taskItem',
                    node: (0, $13787dd647975a80$export$aa7ccb8f78e9cbdd)()
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) && allowBlockTaskItem ? [
                    {
                        name: 'blockTaskItem',
                        node: (0, $13787dd647975a80$export$526b6659b16d1721)()
                    }
                ] : []
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(editorState);
            const indentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(editorState.selection) || 0;
            const itemIndex = (0, $2fc4254aeefcece8$export$af0098af8462419f)(editorState);
            return {
                focusedTaskItemLocalId: pluginState?.focusedTaskItemLocalId || null,
                isInsideTask: (0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1)(editorState),
                indentDisabled: itemIndex === 0 || indentLevel >= (0, $5abq6.MAX_INDENTATION_LEVEL),
                outdentDisabled: indentLevel <= 1,
                // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
                // this allows the default plugin state to initialise as true if the extra configuration is not provided
                hasEditPermission: pluginState?.hasEditPermission !== undefined ? pluginState?.hasEditPermission : true,
                requestToEditContent: pluginState?.requestToEditContent,
                hasRequestedEditPermission: pluginState?.hasRequestedEditPermission,
                taskDecisionProvider: pluginState?.taskDecisionProvider,
                openRequestToEditPopupAt: pluginState?.openRequestToEditPopupAt
            };
        },
        commands: {
            toggleTaskList: (targetType)=>(0, $2b7d7c8d49850f96$export$2e48e3ea1c210731)(api?.analytics?.actions)(targetType),
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $593b7407307544bb$export$d1657e7847eaa8d6)(api?.analytics?.actions, getIdentifierProvider),
            indentTaskList: (0, $2da1bf346dcac0f3$export$b294289254b8cdac)(api?.analytics?.actions),
            outdentTaskList: (0, $2da1bf346dcac0f3$export$d5d1010fad3453fa)(api?.analytics?.actions),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise; // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise) return false;
                previousTaskAndDecisionProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $593b7407307544bb$export$1572b3eade6662f9)(provider)(tr)) ?? false;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $bc3faaa8c98786d9$export$ae829ec7b2625219)(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039)(api?.analytics?.actions, getIdentifierProvider)(schema, featureFlags)
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $2da1bf346dcac0f3$export$2e2bcd8739ae039)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ed8ed537ed67ff6e$export$2e2bcd8739ae039), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $50c6c5eb0364220d$export$2e2bcd8739ae039), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    })
                ]
            });
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($715bf2373cc9aad1$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'action',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action),
                        description: quickInsertActionDescription ?? formatMessage((0, $4HWgE.toolbarInsertBlockMessages).actionDescription),
                        priority: 100,
                        keywords: [
                            'checkbox',
                            'task',
                            'todo'
                        ],
                        keyshortcut: '[]',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconAction), {}),
                        action (insert, state) {
                            return (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'taskList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'taskList', state.schema));
                        }
                    },
                    {
                        id: 'decision',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decisionDescription),
                        priority: 900,
                        keyshortcut: '<>',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDecision), {}),
                        action (insert, state) {
                            return (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'decisionList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'decisionList', state.schema));
                        }
                    }
                ]
        }
    };
};
module.exports["tasksAndDecisionsPlugin"] = $715bf2373cc9aad1$export$582323d9689d93fc;

});

parcelRegister("3ihIB", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $6F6hl = parcelRequire("6F6hl");

const $1916947757a3ce4a$var$accessibilityUtilsPluginKey = new (0, $ks2lK.PluginKey)('accessibilityUtilsPlugin');
const $1916947757a3ce4a$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($1916947757a3ce4a$var$accessibilityUtilsPluginKey, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            if (!editorView || (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($1916947757a3ce4a$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $1916947757a3ce4a$var$accessibilityUtilsPluginKey.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: $1916947757a3ce4a$var$accessibilityUtilsPluginKey,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($1916947757a3ce4a$var$accessibilityUtilsPluginKey);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $1916947757a3ce4a$var$ContentComponent({ api: api }) {
    const { ariaLiveElementAttributes: ariaLiveElementAttributes, key: key, message: message } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'accessibilityUtils'
    ], (states)=>{
        return {
            ariaLiveElementAttributes: states.accessibilityUtilsState?.ariaLiveElementAttributes,
            key: states.accessibilityUtilsState?.key,
            message: states.accessibilityUtilsState?.message
        };
    });
    const role = ariaLiveElementAttributes?.priority === 'important' ? 'alert' : 'status';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        },
        children: message
    });
}
module.exports["accessibilityUtilsPlugin"] = $1916947757a3ce4a$export$8bab9b7a6db7fbeb;

});

parcelRegister("fPXRH", function(module, exports) {

var $7Mtx3 = parcelRequire("7Mtx3");

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

const $87a97b02b68ffbeb$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $9YoeD.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $87a97b02b68ffbeb$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $87a97b02b68ffbeb$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $87a97b02b68ffbeb$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $9YoeD.SetAttrsStep);
        const isAttrStep = step instanceof (0, $aXG5V.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $87a97b02b68ffbeb$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$87a97b02b68ffbeb$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $87a97b02b68ffbeb$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $7Mtx3.BatchAttrsStep)(data);
};


const $109ba4bfab5ff805$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $87a97b02b68ffbeb$export$383250d570a1fb48
        }
    };
};
module.exports["batchAttributeUpdatesPlugin"] = $109ba4bfab5ff805$export$5af772f765987c49;

});

parcelRegister("hSJYu", function(module, exports) {

var $eINDz = parcelRequire("eINDz");

const $bb41ee0a2501fba2$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $eINDz.border)
                }
            ];
        }
    });
module.exports["borderPlugin"] = $bb41ee0a2501fba2$export$39349c329288443f;

});

parcelRegister("01uqX", function(module, exports) {

var $7Rcde = parcelRequire("7Rcde");


var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");


var $ks2lK = parcelRequire("ks2lK");

const $03134e7b83656df3$export$bdb7e84dad6ef3a = new (0, $ks2lK.PluginKey)('codeBidiWarningPlugin');



var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $lkJUe = parcelRequire("lkJUe");

var $kTbzR = parcelRequire("kTbzR");





var $defaa468a0f3b2b9$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};


const $23228c277756d7fb$export$a4805b2c1b031d72 = (nodeViewPortalProviderAPI)=>(0, $lkJUe.pluginFactory)((0, $03134e7b83656df3$export$bdb7e84dad6ef3a), (0, $defaa468a0f3b2b9$export$2e2bcd8739ae039), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $kTbzR.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $23228c277756d7fb$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $23228c277756d7fb$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $ftzrq.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $ftzrq.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        return (0, $ftzrq.Decoration).widget(position, (el)=>$23228c277756d7fb$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                renderKey: renderKey
            }), {
            destroy: (el)=>{
            // removing portalprovider clean up due to a rendering bug
            // with this plugin under React 18. This matches the previous
            // React 16 behaviour which never cleaned up rendering.
            //
            // This will mean CodeBidi instances are not cleaned up, but
            // this is expected to be minimal due to the low frequency of
            // bidi characters in code blocks.
            //
            // We will fix this in a follow up ticket to rewrite the plugin
            // to use pure toDOM -> ED-26540
            // nodeViewPortalProviderAPI.remove(renderKey);
            }
        });
    }));
    return newBidiWarningsDecorationSet;
}
function $23228c277756d7fb$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, renderKey: renderKey }) {
    const element = document.createElement('span');
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
            bidiCharacter: bidiCharacter,
            skipChildren: true,
            label: codeBidiWarningLabel,
            tooltipEnabled: tooltipEnabled
        }), element, renderKey);
    return element;
}


const $23b3865760ba2e9b$export$ae829ec7b2625219 = (api, { dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $23228c277756d7fb$export$a4805b2c1b031d72)(nodeViewPortalProviderAPI);
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $03134e7b83656df3$export$bdb7e84dad6ef3a),
        state: createPluginState(dispatch, (state)=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return {
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            if (api?.limitedMode?.sharedState.currentState()?.enabled) return {
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            return {
                decorationSet: (0, $23228c277756d7fb$export$f1e73511389847e5)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return (0, $ftzrq.DecorationSet).empty;
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            }
        }
    });
};


const $ee52efc8a78efe34$export$d7bb9295cdf61833 = ({ config: config, api: api })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $23b3865760ba2e9b$export$ae829ec7b2625219)(api, options, config ?? {});
                    }
                }
            ];
        }
    });
module.exports["codeBidiWarningPlugin"] = $ee52efc8a78efe34$export$d7bb9295cdf61833;

});

parcelRegister("bS1lJ", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $dus6D = parcelRequire("dus6D");


var $6tl2G = parcelRequire("6tl2G");


var $ke2AI = parcelRequire("ke2AI");


var $ks2lK = parcelRequire("ks2lK");

const $131d10f93817f2cc$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('customAutoformatPlugin');
const $131d10f93817f2cc$export$f05434c51e3762e = (editorState)=>$131d10f93817f2cc$export$18d4026d1ea86bb1.getState(editorState);
const $131d10f93817f2cc$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($131d10f93817f2cc$export$18d4026d1ea86bb1, action);
};


const $f1668ed15bca155e$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $6tl2G.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $f1668ed15bca155e$export$44515d004ac96c3b = (docText, match)=>{
    const REPLACEMENT_CHARACTER = '\ufffc';
    const docTextStartChar = docText[0];
    const docTextEndSlice = docText.slice(1);
    const matchStartChar = match[0][0];
    const matchEndSlice = match[0].slice(1);
    const slicesMatch = docTextEndSlice === matchEndSlice;
    const isAlternator = docTextStartChar === '|';
    const isObjReplaceChar = matchStartChar === REPLACEMENT_CHARACTER;
    return slicesMatch && isAlternator && isObjReplaceChar;
};
const $f1668ed15bca155e$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            const canAutoformatAfterSoftbreak = $f1668ed15bca155e$export$44515d004ac96c3b(docText, match);
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0] || canAutoformatAfterSoftbreak) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $ke2AI.closeHistory)(tr));
    });
};


const $b8aef149b15efe55$var$MAX_MATCH = 500;
const $b8aef149b15efe55$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $b8aef149b15efe55$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};


const $6d3dbd7d7860c54d$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $6d3dbd7d7860c54d$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $6d3dbd7d7860c54d$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $6d3dbd7d7860c54d$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};


const $a0456d233170b8b0$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $6d3dbd7d7860c54d$export$b373f08cf72033a1)(state, action);
        case 'resolved':
            return (0, $6d3dbd7d7860c54d$export$d06d16b20ced9190)(state, action);
        case 'finish':
            return (0, $6d3dbd7d7860c54d$export$5953b28951b32649)(state, action);
        case 'setProvider':
            return (0, $6d3dbd7d7860c54d$export$1572b3eade6662f9)(state, action);
        default:
            return state;
    }
};
var $a0456d233170b8b0$export$2e2bcd8739ae039 = $a0456d233170b8b0$var$reduce;



const $38455a59ff85d29b$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $131d10f93817f2cc$export$18d4026d1ea86bb1));
                if (!meta) return remappedPluginState;
                return (0, $a0456d233170b8b0$export$2e2bcd8739ae039)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $b8aef149b15efe55$export$2b7343a2464fe84e)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $b8aef149b15efe55$export$2b7343a2464fe84e)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            /**
							 * On Shift + Enter, after the first word an Object Replacement Character (/ufffc) is added.
							 * We still want to match strings that start with an Object Replacement Character.
							 */ // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchTyping: new RegExp('(\\s+|^|\\ufffc)' + rule + '(\\s|,|\\.)$'),
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $f1668ed15bca155e$export$c95e7d405e6ed1df)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            return {
                update (view) {
                    const currentState = (0, $131d10f93817f2cc$export$f05434c51e3762e)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $f1668ed15bca155e$export$e9a01ad76956fe83)(view, currentState);
                }
            };
        },
        key: (0, $131d10f93817f2cc$export$18d4026d1ea86bb1)
    });
};
const $38455a59ff85d29b$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $38455a59ff85d29b$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>$38455a59ff85d29b$export$1572b3eade6662f9(provider)(tr));
    });
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $38455a59ff85d29b$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $131d10f93817f2cc$export$f05434c51e3762e)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                previousProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$38455a59ff85d29b$export$1572b3eade6662f9(provider)(tr)) ?? false;
            }
        }
    };
};
module.exports["customAutoformatPlugin"] = $38455a59ff85d29b$export$aa4fc86248a63de6;

});

parcelRegister("2nH2Y", function(module, exports) {

var $4dOgb = parcelRequire("4dOgb");

const $e8dc27017aa97706$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $4dOgb.dataConsumer)
                }
            ];
        }
    });
module.exports["dataConsumerPlugin"] = $e8dc27017aa97706$export$1dc90efb79c37811;

});

parcelRegister("1GAIu", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $14sLv = parcelRequire("14sLv");

const $66ec9ab0f200151b$export$a86035451b36e0f9 = new (0, $ks2lK.PluginKey)('scrollIntoViewPlugin');
/**
 * Determines if a transaction contains changes that should trigger scrolling into view.
 * This includes:
 * - Specific step types (Replace, ReplaceAround)
 */ const $66ec9ab0f200151b$var$hasRelevantChanges = (tr)=>{
    // Check if there are any steps that modified the document
    if (!tr.docChanged) return false;
    // Look for specific types of steps that should trigger scrolling
    const hasRelevantStep = tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    return hasRelevantStep;
};
const $66ec9ab0f200151b$var$createPlugin = ()=>new (0, $1S4f7.SafePlugin)({
        key: $66ec9ab0f200151b$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if (($66ec9ab0f200151b$var$hasRelevantChanges(tr) || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $14sLv.TEXT_INPUT_RULE_TRANSACTION_KEY)) && // ignore appended transactions as they should be treated as side effects
            tr.getMeta('appendedTransaction') === undefined) return newState.tr.scrollIntoView();
        }
    });
const $66ec9ab0f200151b$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$66ec9ab0f200151b$var$createPlugin()
                }
            ];
        }
    });
module.exports["scrollIntoViewPlugin"] = $66ec9ab0f200151b$export$750392944713b1a5;

});

parcelRegister("59fTa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $d925B = parcelRequire("d925B");

var $aSgIe = parcelRequire("aSgIe");


var $dAtrv = parcelRequire("dAtrv");

var $1342a56b1febaadc$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
    return PastePluginActionTypes;
}({});



var $lkJUe = parcelRequire("lkJUe");



var $ks2lK = parcelRequire("ks2lK");

const $605b26f4929db737$export$2b71482310d8c520 = new (0, $ks2lK.PluginKey)('paste-options');
var $605b26f4929db737$export$ec4e67a10e59fca = /*#__PURE__*/ function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
    return ToolbarDropdownOption;
}({});


const $1f78ff91b043d5f4$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $1f78ff91b043d5f4$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $1f78ff91b043d5f4$export$78dda1ebb9a1ea84 = 'text-highlight';
const $1f78ff91b043d5f4$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $1f78ff91b043d5f4$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $1f78ff91b043d5f4$export$220f0307408bc0c = 'akEditor';
const $1f78ff91b043d5f4$export$299d35c5583816ad = 'paste-options-testid';
const $1f78ff91b043d5f4$export$d1234a98f427930 = 'paste-options$';



const $c58e58996beaa411$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};


const { createPluginState: $e07496a754522791$export$656c7661095efe2e, createCommand: $e07496a754522791$export$8d4021544bdece00, getPluginState: $e07496a754522791$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $605b26f4929db737$export$2b71482310d8c520), (0, $c58e58996beaa411$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($e07496a754522791$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $e07496a754522791$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $1f78ff91b043d5f4$export$d1234a98f427930));
    if (meta && meta.type === (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT) return true;
    return false;
};



var $hWRJP = parcelRequire("hWRJP");


var $jvA0K = parcelRequire("jvA0K");


var $aRZzN = parcelRequire("aRZzN");


var $5SAOw = parcelRequire("5SAOw");





var $aXG5V = parcelRequire("aXG5V");

function $59655049ca4ee713$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $59655049ca4ee713$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/) ? `<${str}>` : str;
    });
}
const $59655049ca4ee713$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $59655049ca4ee713$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $59655049ca4ee713$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        const marks = node.marks?.map((mark)=>mark.type.name);
        hasLinkMark = marks?.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};


const $1227962d9e59dddd$export$f9baf8679201c53f = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $1227962d9e59dddd$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection);
    if (!markdownSlice) return tr;
    $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $1227962d9e59dddd$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $1227962d9e59dddd$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $1227962d9e59dddd$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $5SAOw.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $5SAOw.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $aXG5V.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode?.type.createAndFill();
    const isLastNodeEmpty = emptyNodeReference?.nodeSize === lastInsertNode?.nodeSize;
    const isStepSplitingTarget = !lastInsertNode?.isLeaf && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $ks2lK.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1227962d9e59dddd$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $aXG5V.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1227962d9e59dddd$export$3f1f93abf0f3a57(text, schema, selection) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        let textInput = text;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const textSplitByCodeBlock = textInput.split(/```/);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const atlassianMarkDownParser = new (0, $aRZzN.MarkdownTransformer)(schema, (0, $jvA0K.md));
        const doc = atlassianMarkDownParser.parse((0, $59655049ca4ee713$export$8acd10161c5f8b07)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === doc.content.firstChild?.type;
        const canMergeOpenEnd = targetOpenEndNode.type === doc.content.lastChild?.type;
        const $start = (0, $ks2lK.Selection).atStart(doc).$from;
        const $end = (0, $ks2lK.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return new (0, $5SAOw.Slice)(doc.content, openStart, openEnd);
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}



const $666b1f40c60bb978$export$1ad95a504fba561e = (lastContentPasted, selectedOption)=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text ?? '',
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText) return tr;
        return (0, $1227962d9e59dddd$export$60ca0c8603a51ef1)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, plaintextTransformer);
};
const $666b1f40c60bb978$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).PASTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                type: (0, $aSgIe.PasteTypes).plain,
                content: (0, $aSgIe.PasteContents).text,
                pasteSize: sliceSize
            }
        })($666b1f40c60bb978$export$ff80cd8c68a7a6ad());
    };
const $666b1f40c60bb978$export$405f0689dadde83d = ()=>{
    return $666b1f40c60bb978$export$3367fb592cb1ac64();
};
const $666b1f40c60bb978$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText) return tr;
        return (0, $1227962d9e59dddd$export$da9c2ff7c79a9eab)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, transformer);
};
const $666b1f40c60bb978$export$849d50d444ed50f8 = (editorAnalyticsAPI)=>()=>{
        const payloadCallback = (state)=>{
            const pastePluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
            return {
                action: (0, $d925B.ACTION).PASTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                    type: (0, $aSgIe.PasteTypes).richText,
                    content: (0, $aSgIe.PasteContents).text,
                    pasteSize: pastePluginState.richTextSlice?.size || 0
                }
            };
        };
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payloadCallback)($666b1f40c60bb978$export$50a682c7628ffa4e());
    };
const $666b1f40c60bb978$export$f22e171f994ad9d1 = ()=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown) return tr;
        return (0, $1227962d9e59dddd$export$f9baf8679201c53f)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, markdownTransformer);
};
const $666b1f40c60bb978$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).PASTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                type: (0, $aSgIe.PasteTypes).markdown,
                content: (0, $aSgIe.PasteContents).text,
                pasteSize: sliceSize
            }
        })($666b1f40c60bb978$export$f22e171f994ad9d1());
    };
const $666b1f40c60bb978$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$70777665aad0464c = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(view.state);
    if (pluginState.showToolbar) $666b1f40c60bb978$export$70777665aad0464c()(view.state, view.dispatch);
};



var $1S4f7 = parcelRequire("1S4f7");





var $ftzrq = parcelRequire("ftzrq");





function $c2cc415fa3636815$export$ae829ec7b2625219(dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $605b26f4929db737$export$2b71482310d8c520),
        state: (0, $e07496a754522791$export$656c7661095efe2e)(dispatch, {
            showToolbar: false,
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $ftzrq.DecorationSet).empty,
            richTextSlice: (0, $5SAOw.Slice).empty,
            selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).None
        }),
        view (editorView) {
            return {
                update (view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                // Hide toolbar when clicked outside the editor
                blur: (0, $666b1f40c60bb978$export$8b65e7aad6163588),
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $666b1f40c60bb978$export$8b65e7aad6163588)
            },
            handleKeyDown: (view)=>{
                (0, $666b1f40c60bb978$export$8b65e7aad6163588)(view);
                return false;
            },
            decorations: (state)=>{
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state) || {};
                const decorationSet = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state)?.highlightDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $ftzrq.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $1f78ff91b043d5f4$export$78dda1ebb9a1ea84)
                }, {
                    key: (0, $1f78ff91b043d5f4$export$d829547aa567b0f1)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}




var $fHFVT = parcelRequire("fHFVT");


var $aFUXX = parcelRequire("aFUXX");






var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iV0NL = parcelRequire("iV0NL");

// Ignored via go/ees005
// eslint-disable-next-line react/jsx-props-no-spreading
const $1d8936e5d970124c$var$EditorPasteIcon = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV0NL))), {
        ...props
    });
};
$1d8936e5d970124c$var$EditorPasteIcon.displayName = 'EditorPasteIcon';
var $1d8936e5d970124c$export$2e2bcd8739ae039 = $1d8936e5d970124c$var$EditorPasteIcon;


const $fb8dc68c754fae4d$export$208ad7410c805534 = (state, lastContentPasted)=>{
    /**
   * Conditions for not showing the toolbar:
   * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
   * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
   *    (grandParent node should be root doc for showing up the toolbar)
   * 3. Cursor is inside the codeblock.
   */ const $from = state.selection.$from;
    if ((0, $59655049ca4ee713$export$ec154944314bb7c)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = $from.parent?.type;
    const grandParentNodeType = $from.node($from.depth - 1)?.type;
    if (grandParentNodeType && grandParentNodeType.name === state.schema.nodes.doc.name && parentNodeType.name !== state.schema.nodes.codeBlock?.name && !(0, $59655049ca4ee713$export$6c3620a9f018c4e)(lastContentPasted.pasteSource) && !(0, $59655049ca4ee713$export$2d7feffd198c797d)(lastContentPasted.pastedSlice) && !(0, $59655049ca4ee713$export$e7b0e22080760bf0)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $fb8dc68c754fae4d$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $666b1f40c60bb978$export$849d50d444ed50f8)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown,
            onClick: (0, $666b1f40c60bb978$export$a1a13c805bf0cea1)(editorAnalyticsAPI, pluginState.plaintext.length)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText,
            onClick: (0, $666b1f40c60bb978$export$c833704cd36ac295)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $1f78ff91b043d5f4$export$af443436fa5992cb),
        icon: (0, $1d8936e5d970124c$export$2e2bcd8739ae039),
        type: 'dropdown',
        testId: (0, $1f78ff91b043d5f4$export$299d35c5583816ad),
        title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $fb8dc68c754fae4d$var$onToggleHandler
    };
};
const $fb8dc68c754fae4d$var$onToggleHandler = (state, dispatch)=>{
    return (0, $666b1f40c60bb978$export$405f0689dadde83d)()(state, dispatch);
};
const $fb8dc68c754fae4d$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
    const menu = $fb8dc68c754fae4d$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI);
    return {
        title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
        className: (0, $1f78ff91b043d5f4$export$164821e1c3d789fd),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $fb8dc68c754fae4d$var$onPositionCalculated
    };
};
const $fb8dc68c754fae4d$var$onPositionCalculated = (editorView, nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="${(0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = toolbar?.offsetParent || editorView.dom;
    const offsetParentRect = offsetParent?.getBoundingClientRect();
    const offsetTop = offsetParentRect?.top || 0;
    const offsetLeft = offsetParentRect?.left || 0;
    const offsetScrollTop = offsetParent?.scrollTop || 0;
    const cursorHeight = $fb8dc68c754fae4d$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $fb8dc68c754fae4d$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = nodeAtFrom?.nodeType === Node.TEXT_NODE ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom.parentNode : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};


const $d3b480babb517bc1$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'pasteOptionsToolbarPlugin',
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $c2cc415fa3636815$export$ae829ec7b2625219)(dispatch)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const pastePluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
                if (pastePluginState.showToolbar) return (0, $fb8dc68c754fae4d$export$6dd6ab35df8f7f86)(state, intl, editorAnalyticsAPI);
                return;
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { lastContentPasted: lastContentPasted } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'paste'
            ], (states)=>({
                    lastContentPasted: states.pasteState?.lastContentPasted
                }));
            (0, $42omo.useEffect)(()=>{
                if (!lastContentPasted) {
                    (0, $666b1f40c60bb978$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText;
                else selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown;
                if (!(0, $fb8dc68c754fae4d$export$208ad7410c805534)(editorView.state, lastContentPasted)) return;
                (0, $666b1f40c60bb978$export$1ad95a504fba561e)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};
module.exports["pasteOptionsToolbarPlugin"] = $d3b480babb517bc1$export$2eabbda136e01363;

});

parcelRegister("bz4KD", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

const $3074fcc4b1d6f955$export$e137bce9a5077ae5 = ()=>({
        name: 'ufo',
        pmPlugins () {
            const isSSR = Boolean($kyRHQ?.env?.REACT_SSR);
            if (isSSR) // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
            return [];
            // This Plugin is not currently used as it leads to too high a level of abortions (due to the current TTAI timing being long, and users starting click before TTAI completes).
            // This can be reconsidered if we meaningfully reduce our TTAI (ie. <7 seconds)
            return [];
        // return [
        // 	{
        // 		name: 'traceUFOInteractionOnFirstInteraction',
        // 		plugin: traceUFOInteractionOnFirstInteraction,
        // 	},
        // ];
        }
    });
module.exports["ufoPlugin"] = $3074fcc4b1d6f955$export$e137bce9a5077ae5;

});

parcelRegister("cwPVT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gWpm5 = parcelRequire("gWpm5");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ly3wu = parcelRequire("ly3wu");


var $6qdjm = parcelRequire("6qdjm");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $ks2lK = parcelRequire("ks2lK");

const $c0a482e4157215ff$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('breakoutPlugin');
const $c0a482e4157215ff$export$f05434c51e3762e = (state)=>$c0a482e4157215ff$export$18d4026d1ea86bb1.getState(state) || undefined;






var $fJNzZ = parcelRequire("fJNzZ");

var $kTbzR = parcelRequire("kTbzR");


var $2pjJ5 = parcelRequire("2pjJ5");











var $d7ZU3 = parcelRequire("d7ZU3");

















var $dNXVc = parcelRequire("dNXVc");





var $adayn = parcelRequire("adayn");


var $dh538 = parcelRequire("dh538");




const $de180ab218c9eae9$export$cc135306f1c4ff36 = ({ tr: tr, node: node, pos: pos, isLivePage: isLivePage })=>{
    if (isLivePage || (0, $dh538.fg)('platform-editor-single-player-expand')) {
        const wasExpandExpanded = (0, $adayn.expandedState).get(node);
        const newExpand = tr.doc.nodeAt(pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $adayn.expandedState).set(newExpand, wasExpandExpanded);
    }
};
const $de180ab218c9eae9$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true)) $de180ab218c9eae9$export$cc135306f1c4ff36({
        tr: tr,
        node: node.node,
        pos: node.pos,
        isLivePage: isLivePage
    });
    else if (isLivePage || (0, $dh538.fg)('platform-editor-single-player-expand')) {
        const wasExpandExpanded = (0, $adayn.expandedState).get(node.node);
        const newExpand = tr.doc.nodeAt(node.pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $adayn.expandedState).set(newExpand, wasExpandExpanded);
    }
};


function $1f06cd6ea94cc3ac$export$2347aa63864fccd4(width, mode, pos, isLivePage) {
    return (state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
            state.schema.marks.breakout.create({
                width: width,
                mode: mode
            })
        ]);
        if (node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
            tr: tr,
            node: node,
            pos: pos,
            isLivePage: isLivePage
        });
        else if (node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(pos);
            const oldNode = node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        // keep current selection, necessary to not remove NodeSelection for keyboard resizing
        if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.eq(node)) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
        if (dispatch) dispatch(tr);
        return true;
    };
}


const $fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP = 10;
const $fe1c4be5bd3b93b3$var$getAncestorResizableNode = (view, breakoutResizableNodes)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const selectedNode = selection.node;
        if (breakoutResizableNodes.has(selectedNode.type)) return {
            node: selectedNode,
            pos: selection.$from.pos
        };
    } else if (selection instanceof (0, $ks2lK.TextSelection)) {
        let node = null;
        let nodePos = null;
        // only top level nodes are resizable
        const resolvedPos = view.state.doc.resolve(selection.$from.pos);
        const currentNode = resolvedPos.node(1);
        if (breakoutResizableNodes.has(currentNode.type)) {
            node = currentNode;
            nodePos = resolvedPos.before(1);
            return {
                node: node,
                pos: nodePos
            };
        }
    }
    return null;
};
const $fe1c4be5bd3b93b3$export$bab59f27a7347e45 = (api)=>(view, event)=>{
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        if (metaKey && event.altKey && isBracketKey) {
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection } = view.state.schema.nodes;
            const breakoutResizableNodes = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $fJNzZ.getBreakoutResizableNodeTypes)(view.state.schema) : new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            const result = $fe1c4be5bd3b93b3$var$getAncestorResizableNode(view, breakoutResizableNodes);
            if (result) {
                const { node: node, pos: pos } = result;
                const breakoutMark = node?.marks.find((mark)=>mark.type.name === 'breakout');
                if (breakoutMark) {
                    const step = event.code === 'BracketRight' ? $fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP : -$fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP;
                    const newWidth = breakoutMark.attrs.width + step;
                    if (newWidth < (0, $aFUXX.akEditorFullWidthLayoutWidth) && newWidth > (0, $aFUXX.akEditorDefaultLayoutWidth)) {
                        const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
                        (0, $1f06cd6ea94cc3ac$export$2347aa63864fccd4)(breakoutMark.attrs.width + step, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
                        view.focus();
                    }
                    return true;
                }
            }
        }
        return false;
    };












var $fFa3V = parcelRequire("fFa3V");


var $cUcZ5 = parcelRequire("cUcZ5");


var $5duTD = parcelRequire("5duTD");





var $4T4vf = parcelRequire("4T4vf");


var $5X6QO = parcelRequire("5X6QO");


var $gZctg = parcelRequire("gZctg");


var $3gadb = parcelRequire("3gadb");

const $1a5749845d01d8bf$var$getNodeName = (nodeName)=>{
    if (nodeName === 'layoutSection') return 'layout';
    else if (nodeName === 'codeBlock' || nodeName === 'expand') return nodeName;
    else return 'node';
};
const $1a5749845d01d8bf$export$5c0a5eee165b9845 = {
    expand: (0, $5duTD.messages).resizeExpand,
    codeBlock: (0, $5duTD.messages).resizeCodeBlock,
    layout: (0, $5duTD.messages).resizeLayout,
    node: (0, $5duTD.messages).resizeElement
};
const $1a5749845d01d8bf$var$RailWithTooltip = ({ rail: rail, target: target, intl: intl })=>{
    const [nodeName, setNodeName] = (0, $42omo.useState)('node');
    (0, $42omo.useLayoutEffect)(()=>{
        const node = target.querySelector('[data-prosemirror-node-name]');
        const name = $1a5749845d01d8bf$var$getNodeName(node?.dataset.prosemirrorNodeName);
        setNodeName(name);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: intl.formatMessage($1a5749845d01d8bf$export$5c0a5eee165b9845[nodeName]),
        position: "mouse",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "pm-breakout-resize-handle-rail-inside-tooltip",
            ref: (el)=>{
                if (el && rail.parentNode !== el) el.appendChild(rail);
            }
        })
    });
};
const $1a5749845d01d8bf$export$2023dee10a108a1 = ({ target: target, onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
    let state = 'default';
    const createHandle = (side)=>{
        const handle = document.createElement('div');
        handle.contentEditable = 'false';
        handle.classList.add('pm-breakout-resize-handle-container');
        handle.style.gridColumn = side === 'left' ? '1' : '3';
        const rail = document.createElement('div');
        rail.classList.add('pm-breakout-resize-handle-rail');
        if (side === 'left') {
            handle.classList.add('pm-breakout-resize-handle-container--left');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-left');
        } else {
            handle.classList.add('pm-breakout-resize-handle-container--right');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-right');
        }
        const handleHitBox = document.createElement('div');
        handleHitBox.classList.add('pm-breakout-resize-handle-hit-box');
        const thumb = document.createElement('div');
        thumb.classList.add('pm-breakout-resize-handle-thumb');
        if ((0, $dh538.fg)('platform_editor_fix_resize_selected_node')) thumb.style.pointerEvents = 'none';
        rail.appendChild(thumb);
        const tooltipContainer = document.createElement('div');
        tooltipContainer.classList.add('pm-breakout-resize-handle-rail-wrapper');
        handle.appendChild(tooltipContainer);
        handle.appendChild(handleHitBox);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)($1a5749845d01d8bf$var$RailWithTooltip, {
                rail: rail,
                target: target,
                intl: intl
            }), tooltipContainer, key);
        return {
            handle: handle,
            rail: rail,
            handleHitBox: handleHitBox,
            destroyTooltip: ()=>nodeViewPortalProviderAPI.remove(key)
        };
    };
    const rightHandle = createHandle('right');
    const leftHandle = createHandle('left');
    const registerHandle = (handleElement, handleSide)=>{
        return (0, $4T4vf.draggable)({
            element: handleElement,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $5X6QO.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $gZctg.preventUnhandled).start();
            },
            getInitialData: ()=>({
                    handleSide: handleSide
                }),
            onDragStart (args) {
                state = 'resizing';
                handleElement.classList.add('pm-breakout-resize-handle-container--active');
                onDragStart(args);
            },
            onDrag: onDrag,
            onDrop (args) {
                (0, $gZctg.preventUnhandled).stop();
                state = 'default';
                handleElement.classList.remove('pm-breakout-resize-handle-container--active');
                onDrop(args);
            }
        });
    };
    const registerEvents = (element)=>{
        return [
            (0, $fFa3V.bind)(element, {
                type: 'mouseenter',
                listener: ()=>{
                    rightHandle.rail.style.setProperty('opacity', '1');
                    leftHandle.rail.style.setProperty('opacity', '1');
                }
            }),
            (0, $fFa3V.bind)(element, {
                type: 'mouseleave',
                listener: ()=>{
                    if (state === 'resizing') return;
                    rightHandle.rail.style.removeProperty('opacity');
                    leftHandle.rail.style.removeProperty('opacity');
                }
            })
        ];
    };
    const unbindFns = [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(leftHandle.handleHitBox),
        ...registerEvents(rightHandle.rail),
        ...registerEvents(leftHandle.rail)
    ];
    const handleElement = (0, $dh538.fg)('platform_editor_fix_resize_selected_node') ? 'rail' : 'handle';
    const destroyFns = [
        registerHandle(rightHandle[handleElement], 'right'),
        registerHandle(leftHandle[handleElement], 'left'),
        rightHandle.destroyTooltip,
        leftHandle.destroyTooltip
    ];
    return {
        rightHandle: rightHandle.handle,
        leftHandle: leftHandle.handle,
        destroy: (isChangeToViewMode)=>{
            destroyFns.forEach((destroyFn)=>destroyFn());
            unbindFns.forEach((unbindFn)=>unbindFn());
            if (isChangeToViewMode) {
                rightHandle.handle.parentElement?.removeChild(rightHandle.handle);
                leftHandle.handle.parentElement?.removeChild(leftHandle.handle);
            }
        }
    };
};













var $2XqLN = parcelRequire("2XqLN");

const $631ba4830cc4824c$export$6065600df915db53 = 8;


var $boKri = parcelRequire("boKri");

var $7QdQz = parcelRequire("7QdQz");










const $c55c2990d369b072$var$WIDTHS = {
    MIN: (0, $aFUXX.akEditorDefaultLayoutWidth),
    WIDE: (0, $aFUXX.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    MAX: (0, $aFUXX.akEditorMaxLayoutWidth)
};
const $c55c2990d369b072$export$dd27ecfadfde9946 = {
    lineLengthLeft: 'grid_left',
    lineLengthRight: 'grid_right',
    wideLeft: 'wide_left',
    wideRight: 'wide_right',
    fullWidthLeft: 'full_width_left',
    fullWidthRight: 'full_width_right',
    maxWidthLeft: 'max_width_left',
    maxWidthRight: 'max_width_right'
};
const $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $c55c2990d369b072$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $c55c2990d369b072$export$47dec483f7d48a59 = (0, $2XqLN.default)((isResizing, newWidth, getEditorWidth, nodeType)=>{
    const guidelines = [];
    if (!isResizing) return guidelines;
    let innerPaddingOffset = 0;
    if (nodeType) switch(nodeType.name){
        case 'expand':
            innerPaddingOffset = (0, $631ba4830cc4824c$export$6065600df915db53) + (0, $7QdQz.resizerHandleThumbWidth) + $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'layoutSection':
            innerPaddingOffset = (0, $boKri.LAYOUT_COLUMN_PADDING) + $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        default:
            break;
    }
    const { width: width } = getEditorWidth() || {};
    const padding = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidth = width ? Math.min($c55c2990d369b072$var$WIDTHS.FULL, width - 2 * padding - (0, $aFUXX.akEditorGutterPadding)) : undefined;
    const maxWidth = width && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? Math.min($c55c2990d369b072$var$WIDTHS.MAX, width - 2 * padding - (0, $aFUXX.akEditorGutterPadding)) : undefined;
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.lineLengthLeft,
        position: {
            x: -$c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.lineLengthRight,
        position: {
            x: $c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.wideLeft,
        position: {
            x: -$c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.WIDE
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.wideRight,
        position: {
            x: $c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.WIDE
    });
    if (fullWidth) {
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.fullWidthLeft,
            position: {
                x: -$c55c2990d369b072$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.fullWidthRight,
            position: {
                x: $c55c2990d369b072$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
    }
    if (maxWidth) {
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.maxWidthLeft,
            position: {
                x: -$c55c2990d369b072$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.maxWidthRight,
            position: {
                x: $c55c2990d369b072$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
    }
    return guidelines;
});





var $d925B = parcelRequire("d925B");

const $dce7a089fb4e15a6$export$29574a7e6ffc8eb4 = (props)=>{
    return props.frameRateSamples.map((frameRateSample, index)=>({
            action: (0, $d925B.ACTION).RESIZED_PERF_SAMPLING,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                nodeType: props.originalNode.type.name,
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $dce7a089fb4e15a6$export$6b143296f4c6108b = ({ node: node, prevWidth: prevWidth, newWidth: newWidth })=>{
    return {
        action: (0, $d925B.ACTION).RESIZED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            nodeType: node.type.name,
            prevWidth: prevWidth,
            newWidth: newWidth
        }
    };
};


/**
 * Measure the FPS of a resizing component.
 *
 * This is a simplified version of the `useMeasureFramerate` hook from `editor-plugin-table`.
 * (packages/editor/editor-plugin-table/src/pm-plugins/utils/analytics.ts)
 */ const $71ded837f678e901$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $71ded837f678e901$export$499e6cf908107611 = (config)=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config || {};
    let frameCount = 0;
    let lastTime = 0;
    let timeoutId;
    let frameRateSamples = [];
    const startMeasure = ()=>{
        frameCount = 0;
        lastTime = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 * @returns {number[]} An array of frame rate samples as integers.
	 * @example
	 * const samples = endMeasure(); // [60, 58, 62]
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples;
        frameRateSamples = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount / (deltaTime / 1000));
            frameRateSamples.push(frameRate);
        }
        frameCount = 0;
        lastTime = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 * @example
	 * const animate = () => {
	 *   countFrames();
	 *   requestAnimationFrame(animate);
	 * };
	 */ const countFrames = ()=>{
        if (frameRateSamples.length >= maxSamples && timeoutId) {
            clearTimeout(timeoutId);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime === 0) lastTime = performance.now();
        frameCount++;
        if (timeoutId) clearTimeout(timeoutId);
        if (performance.now() - lastTime > sampleRateMs) sampleFrameRate();
        else timeoutId = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};


const $5a34cf47b86dc148$var$RESIZE_RATIO = 2;
const $5a34cf47b86dc148$var$SNAP_GAP = 10;
const $5a34cf47b86dc148$var$WIDTHS = {
    MIN: (0, $aFUXX.akEditorDefaultLayoutWidth),
    WIDE: (0, $aFUXX.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    MAX: (0, $aFUXX.akEditorMaxLayoutWidth)
};
function $5a34cf47b86dc148$export$39e6ff87d188b0e6({ initialWidth: initialWidth, location: location, api: api, source: source }) {
    const directionMultiplier = source.data.handleSide === 'left' ? -1 : 1;
    const diffX = (location.current.input.clientX - location.initial.input.clientX) * $5a34cf47b86dc148$var$RESIZE_RATIO * directionMultiplier;
    const width = api?.width.sharedState?.currentState()?.width || 0;
    const padding = width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const containerWidth = width - 2 * padding - (0, $aFUXX.akEditorGutterPadding);
    // the node width may be greater than the container width so we resize using the smaller value
    const proposedWidth = Math.min(initialWidth, containerWidth) + diffX;
    const snapPoints = [
        $5a34cf47b86dc148$var$WIDTHS.MIN,
        $5a34cf47b86dc148$var$WIDTHS.WIDE,
        Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.FULL)
    ];
    if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) snapPoints.push(Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.MAX));
    for (const snapPoint of snapPoints){
        if (snapPoint - $5a34cf47b86dc148$var$SNAP_GAP < proposedWidth && snapPoint + $5a34cf47b86dc148$var$SNAP_GAP > proposedWidth) return snapPoint;
    }
    const hardMax = (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.MAX) : Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.FULL);
    return Math.max($5a34cf47b86dc148$var$WIDTHS.MIN, Math.min(proposedWidth, hardMax));
}
function $5a34cf47b86dc148$export$d3619fd797e636fb({ dom: dom, view: view, mark: mark, api: api }) {
    let node = null;
    let guidelines = [];
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $71ded837f678e901$export$499e6cf908107611)();
    const getEditorWidth = ()=>{
        return api?.width?.sharedState.currentState();
    };
    return {
        onDragStart: ()=>{
            startMeasure();
            const pos = view.posAtDOM(dom, 0);
            node = view.state.doc.nodeAt(pos);
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                tr.setMeta('is-resizer-resizing', true);
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'UPDATE_BREAKOUT_NODE',
                    data: {
                        node: node,
                        pos: pos,
                        start: pos,
                        depth: 0
                    }
                });
                return tr;
            });
        },
        onDrag: ({ location: location, source: source })=>{
            countFrames();
            const initialWidth = mark.attrs.width;
            const newWidth = $5a34cf47b86dc148$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            guidelines = (0, $c55c2990d369b072$export$47dec483f7d48a59)(true, newWidth, getEditorWidth, node?.type);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const activeGuideline = guidelines.find((guideline)=>guideline.active && !guideline.key.startsWith('grid'));
            if (activeGuideline) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'UPDATE_ACTIVE_GUIDELINE_KEY',
                    data: {
                        activeGuidelineKey: activeGuideline.key
                    }
                });
                return tr;
            });
            if (!activeGuideline && api?.breakout.sharedState.currentState()?.activeGuidelineKey) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'CLEAR_ACTIVE_GUIDELINE_KEY'
                });
                return tr;
            });
            // dom is used for width calculations
            dom.style.setProperty((0, $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e), `${newWidth}px`);
        },
        onDrop ({ location: location, source: source }) {
            let payloads = [];
            const frameRateSamples = endMeasure();
            payloads = (0, $dce7a089fb4e15a6$export$29574a7e6ffc8eb4)({
                docSize: view.state.doc.nodeSize,
                frameRateSamples: (0, $71ded837f678e901$export$52625746d6329c8a)(frameRateSamples),
                originalNode: node
            });
            const isResizedToFullWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('full_width') && guideline.active);
            let isResizedToMaxWidth = false;
            if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) isResizedToMaxWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('max_width') && guideline.active);
            guidelines = (0, $c55c2990d369b072$export$47dec483f7d48a59)(false, 0, getEditorWidth);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const pos = view.posAtDOM(dom, 0);
            const mode = mark.attrs.mode;
            const initialWidth = mark.attrs.width;
            let newWidth = isResizedToFullWidth ? $5a34cf47b86dc148$var$WIDTHS.FULL : $5a34cf47b86dc148$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
                if (isResizedToMaxWidth) newWidth = $5a34cf47b86dc148$var$WIDTHS.MAX;
            }
            const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
            (0, $1f06cd6ea94cc3ac$export$2347aa63864fccd4)(newWidth, mode, pos, isEditMode)(view.state, view.dispatch);
            dom.style.removeProperty((0, $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e));
            if (node) {
                const resizedPayload = (0, $dce7a089fb4e15a6$export$6b143296f4c6108b)({
                    node: node,
                    prevWidth: initialWidth,
                    newWidth: newWidth
                });
                payloads.push(resizedPayload);
            }
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                payloads.forEach((payload)=>{
                    api.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                });
                tr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'RESET_STATE'
                });
                return tr;
            });
        }
    };
}


const $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e = '--local-resizing-width';
class $ddcb98fa7f5afd3a$export$4fb684fac6535bde {
    setupResizerCallbacks(dom, contentDOM, view, mark, api) {
        const callbacks = (0, $5a34cf47b86dc148$export$d3619fd797e636fb)({
            dom: dom,
            view: view,
            mark: mark,
            api: api
        });
        const { leftHandle: leftHandle, rightHandle: rightHandle, destroy: destroy } = (0, $1a5749845d01d8bf$export$2023dee10a108a1)({
            target: contentDOM,
            ...callbacks,
            intl: this.intl,
            nodeViewPortalProviderAPI: this.nodeViewPortalProviderAPI
        });
        this.dom.prepend(leftHandle);
        this.dom.appendChild(rightHandle);
        this.destroyFn = destroy;
        this.isResizingInitialised = true;
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        this.destroyFn?.();
        this.unsubscribeToViewModeChange?.();
    }
    /**
   * Wrap node view in a resizing mark view
   * @param {Mark} mark - The breakout mark to resize
   * @param {EditorView} view - The editor view
   * @param {ExtractInjectionAPI<BreakoutPlugin> | undefined} api - The pluginInjectionAPI
   * @param {Function} getIntl - () => IntlShape
   * @param {PortalProviderAPI} - The nodeViewPortalProviderAPI
   * @example
   * ```ts
   * ```
   */ constructor(mark, view, api, getIntl, nodeViewPortalProviderAPI){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        this.destroyFn = void 0;
        this.intl = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.unsubscribeToViewModeChange = void 0;
        this.isResizingInitialised = false;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        // dom - styles
        dom.style.transform = 'none';
        dom.style.display = 'grid';
        dom.style.justifyContent = 'center';
        // contentDOM - styles
        contentDOM.style.gridColumn = '2';
        contentDOM.style.zIndex = '1';
        if (mark.attrs.width) dom.style.gridTemplateColumns = `auto max(var(--ak-editor--breakout-min-width), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) auto`;
        else {
            if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.view = view;
        this.mark = mark;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        const isLiveViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (!isLiveViewMode) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        this.unsubscribeToViewModeChange = api?.editorViewMode?.sharedState.onChange((sharedState)=>{
            if (sharedState.nextSharedState?.mode !== sharedState.prevSharedState?.mode) {
                if (sharedState.nextSharedState?.mode === 'view' && this.isResizingInitialised) {
                    this.destroyFn?.(true);
                    this.isResizingInitialised = false;
                } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            }
        });
    }
}



const $0270481e4dcc36c1$var$addBreakoutToResizableNode = ({ node: node, pos: pos, newState: newState, newTr: newTr, breakoutResizableNodes: breakoutResizableNodes, isFullWidthEnabled: isFullWidthEnabled })=>{
    let updatedDocChanged = false;
    let updatedTr = newTr;
    const $pos = newState.doc.resolve(pos);
    const isTopLevelNode = $pos?.depth === 0;
    if (breakoutResizableNodes.has(node.type) && isTopLevelNode) {
        const { breakout: breakout } = newState.schema.marks;
        const { expand: expand } = newState.schema.nodes;
        const breakoutMark = node.marks.find((mark)=>mark.type === breakout);
        const isExpand = node.type === expand;
        if (!breakoutMark) {
            const width = isFullWidthEnabled ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorDefaultLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width
                })
            ]);
            if (isExpand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        } else if (breakoutMark?.attrs.width === null || breakoutMark?.attrs.width === undefined) {
            const mode = breakoutMark.attrs.mode;
            // if breakout is present on node, but page appearance is 'full width' force width to full width to maintain backwards compatibility
            const newWidth = isFullWidthEnabled || mode === 'full-width' ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorCalculatedWideLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: newWidth,
                    mode: mode
                })
            ]);
            if (isExpand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        }
    }
    return {
        updatedTr: updatedTr,
        updatedDocChanged: updatedDocChanged
    };
};
const $0270481e4dcc36c1$export$ca33a310187a5f87 = new (0, $ks2lK.PluginKey)('breakout-resizing');
const $0270481e4dcc36c1$var$pluginState = {
    init () {
        return {
            breakoutNode: undefined,
            activeGuidelineLabel: undefined
        };
    },
    apply (tr, pluginState) {
        const meta = tr.getMeta($0270481e4dcc36c1$export$ca33a310187a5f87);
        if (meta) switch(meta.type){
            case 'UPDATE_BREAKOUT_NODE':
                return {
                    ...pluginState,
                    breakoutNode: meta.data
                };
            case 'UPDATE_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: meta.data.activeGuidelineKey
                };
            case 'CLEAR_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: undefined
                };
            case 'RESET_STATE':
                return {
                    activeGuidelineLabel: undefined,
                    breakoutNode: undefined
                };
        }
        return pluginState;
    }
};
const $0270481e4dcc36c1$export$522e3e76a011a0b1 = (api, getIntl, nodeViewPortalProviderAPI, options)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $0270481e4dcc36c1$export$ca33a310187a5f87,
        state: $0270481e4dcc36c1$var$pluginState,
        props: {
            markViews: {
                breakout: (mark, view)=>{
                    return new (0, $ddcb98fa7f5afd3a$export$4fb684fac6535bde)(mark, view, api, getIntl, nodeViewPortalProviderAPI);
                }
            },
            handleKeyDown: (0, $fe1c4be5bd3b93b3$export$bab59f27a7347e45)(api)
        },
        appendTransaction (transactions, oldState, newState) {
            if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return;
            let newTr = newState.tr;
            let hasDocChanged = false;
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection } = newState.schema.nodes;
            const breakoutResizableNodes = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $fJNzZ.getBreakoutResizableNodeTypes)(newState.schema) : new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            const isFullWidthEnabled = !(options?.allowBreakoutButton === true);
            if ((0, $2pjJ5.isReplaceDocOperation)(transactions, oldState)) newState.doc.forEach((node, pos)=>{
                const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $0270481e4dcc36c1$var$addBreakoutToResizableNode({
                    node: node,
                    pos: pos,
                    newState: newState,
                    newTr: newTr,
                    breakoutResizableNodes: breakoutResizableNodes,
                    isFullWidthEnabled: isFullWidthEnabled
                });
                newTr = updatedTr;
                hasDocChanged = hasDocChanged || updatedDocChanged;
            });
            else transactions.forEach((tr)=>{
                const isAddingResizableNodes = tr.steps.some((step)=>(0, $kTbzR.stepAddsOneOf)(step, breakoutResizableNodes));
                if (isAddingResizableNodes) {
                    const changedNodes = (0, $2pjJ5.getChangedNodes)(tr);
                    changedNodes.forEach(({ node: node, pos: pos })=>{
                        const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $0270481e4dcc36c1$var$addBreakoutToResizableNode({
                            node: node,
                            pos: pos,
                            newState: newState,
                            newTr: newTr,
                            breakoutResizableNodes: breakoutResizableNodes,
                            isFullWidthEnabled: isFullWidthEnabled
                        });
                        newTr = updatedTr;
                        hasDocChanged = hasDocChanged || updatedDocChanged;
                    });
                }
            });
            if (hasDocChanged) return newTr;
        }
    });
};






var $8m4tT = parcelRequire("8m4tT");




const $60e85c3f0a757043$var$supportedNodesForBreakout = [
    'codeBlock',
    'layoutSection',
    'expand'
];
const $60e85c3f0a757043$var$supportedNodesForBreakoutAdvancedLayouts = [
    'codeBlock',
    'expand'
];
function $60e85c3f0a757043$export$2e02ca5ba4632d0a(node) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $60e85c3f0a757043$var$supportedNodesForBreakoutAdvancedLayouts.indexOf(node.type.name) !== -1;
    return $60e85c3f0a757043$var$supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}


function $18e70c0aec555722$export$b3e00d6ce0602166(selection) {
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const supportsBreakout = (0, $60e85c3f0a757043$export$2e02ca5ba4632d0a)(selection.node);
        if (supportsBreakout) return {
            pos: selection.from,
            start: selection.from,
            node: selection.node,
            // If a selected expand is in a doc, the depth of that expand is 0. Therefore
            // we don't need to subtract 1 or instantly return false if the depth is 0
            depth: selection.$anchor.depth
        };
    }
    const breakoutNode = (0, $8m4tT.findParentNode)((0, $60e85c3f0a757043$export$2e02ca5ba4632d0a))(selection);
    if (!breakoutNode || breakoutNode.depth === 0) // If this node doesn't exist or the only supporting node is the document
    // (with depth 0), then we're not inside a node that supports breakout
    return undefined;
    return {
        node: breakoutNode.node,
        start: breakoutNode.start,
        pos: breakoutNode.pos,
        depth: breakoutNode.depth - 1
    };
}



function $b725ae1e8e0afe9c$export$7293881dc293b44d(state) {
    const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
    if (!node) return;
    const breakoutMark = node.node.marks.find((m)=>m.type.name === 'breakout');
    if (!breakoutMark) return;
    return breakoutMark.attrs.mode;
}





parcelRequire("42omo");


var $7x0qS = parcelRequire("7x0qS");


var $jwWgu = parcelRequire("jwWgu");







const $43857bfdf468c71f$var$GUIDELINE_KEY_TO_LAYOUT = {
    wide_left: 'wide',
    wide_right: 'wide',
    full_width_left: 'full-width',
    full_width_right: 'full-width',
    max_width_left: 'max',
    max_width_right: 'max'
};
const $43857bfdf468c71f$export$ee321e647107007d = ({ api: api, editorView: editorView, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const breakoutNode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'breakout.breakoutNode');
    const activeGuidelineKey = (0, $b3YrF.useSharedPluginStateSelector)(api, 'breakout.activeGuidelineKey');
    if (!breakoutNode || !activeGuidelineKey) return null;
    const element = (0, $8m4tT.findDomRefAtPos)(breakoutNode.pos, editorView.domAtPos.bind(editorView));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        target: element && element instanceof HTMLElement ? element : undefined,
        offset: [
            0,
            10
        ],
        alignY: "bottom",
        alignX: "center",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7x0qS.ResizerBreakoutModeLabel), {
            layout: $43857bfdf468c71f$var$GUIDELINE_KEY_TO_LAYOUT[activeGuidelineKey]
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");











var $a4eZN = parcelRequire("a4eZN");














var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");


var $6fnsQ = parcelRequire("6fnsQ");


var $dTk3A = parcelRequire("dTk3A");















function $68cc69d900fe69e9$export$8adb30fdfe0dc8a3(isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const marks = node.node.marks.filter((m)=>m.type.name !== 'breakout');
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        if (node.node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}










function $1a1107a596130634$export$835e4fcd1fc926bc(mode, isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
            state.schema.marks.breakout.create({
                mode: mode
            })
        ]);
        if (node.node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}




function $069dacd057fce6fd$export$caf83e14f3995804(state) {
    if (!state.schema.marks.breakout) return false;
    const supportedNodeParent = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
    if (!supportedNodeParent) return false;
    // At the moment we can only breakout when the depth is 0, ie. doc is the only node
    // that supports breakout. This *could* change though.
    const parent = state.selection.$from.node(supportedNodeParent.depth);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}



const $a9ff937bba932aa9$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20A)})`,
        color: `var(--ds-icon, ${(0, $6fnsQ.N300)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.B300)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon, white)"} !important`
        }
    }
});
const $a9ff937bba932aa9$var$toolbarButtonNarrowScreenStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/design-system/no-nested-styles,  @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            visibility: 'hidden',
            opacity: 0
        }
    }
});
function $a9ff937bba932aa9$var$getBreakoutNodeElement(pluginState, selection, editorView) {
    if (!pluginState.breakoutNode) return undefined;
    if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $60e85c3f0a757043$export$2e02ca5ba4632d0a)(selection.node)) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $8m4tT.findDomRefAtPos)(selection.from, editorView.domAtPos.bind(editorView));
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $8m4tT.findParentDomRefOfType)(pluginState.breakoutNode.node.type, editorView.domAtPos.bind(editorView))(selection);
}
const $a9ff937bba932aa9$var$LayoutButton = ({ intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isLivePage: isLivePage, isBreakoutNodePresent: isBreakoutNodePresent, breakoutMode: breakoutModeProp, api: api })=>{
    const handleClick = (0, $42omo.useCallback)((breakoutMode)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        // Remove ! during platform_editor_hydratable_ui cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { state: state, dispatch: dispatch } = editorView;
        const breakoutNode = (0, $c0a482e4157215ff$export$f05434c51e3762e)(state)?.breakoutNode;
        if ([
            'wide',
            'full-width'
        ].indexOf(breakoutMode) !== -1) {
            (0, $1a1107a596130634$export$835e4fcd1fc926bc)(breakoutMode, isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    mode: breakoutMode,
                    nodeType: breakoutNode?.node.type.name
                }
            });
        } else {
            (0, $68cc69d900fe69e9$export$8adb30fdfe0dc8a3)(isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    mode: 'center',
                    nodeType: breakoutNode?.node.type.name
                }
            });
        }
    }, [
        api?.analytics?.actions,
        editorView,
        isLivePage
    ]);
    if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (!isBreakoutNodePresent || !(0, $069dacd057fce6fd$export$caf83e14f3995804)(editorView.state)) return null;
    const breakoutMode = breakoutModeProp;
    const titleMessage = (0, $fJNzZ.getTitle)(breakoutMode);
    const title = formatMessage(titleMessage);
    const nextBreakoutMode = (0, $fJNzZ.getNextBreakoutMode)(breakoutMode);
    const belowOtherPopupsZIndex = (0, $dTk3A.layers).layer() - 1;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const pluginState = (0, $c0a482e4157215ff$export$f05434c51e3762e)(editorView.state);
    if (!pluginState) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let element = $a9ff937bba932aa9$var$getBreakoutNodeElement(pluginState, editorView.state.selection, editorView);
    if (!element) return null;
    const closestEl = element.querySelector(`.${(0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK_DOM}`);
    if (closestEl && closestEl.firstChild) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    element = closestEl.firstChild;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        ariaLabel: title,
        target: element,
        offset: [
            5,
            0
        ],
        alignY: "start",
        alignX: "end",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        zIndex: belowOtherPopupsZIndex
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $a9ff937bba932aa9$var$toolbarButtonWrapperStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $a9ff937bba932aa9$var$toolbarButtonNarrowScreenStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        title: title,
        testId: titleMessage.id,
        onClick: ()=>handleClick(nextBreakoutMode),
        iconBefore: breakoutMode === 'full-width' ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
            label: title,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            label: title,
            spacing: "spacious"
        })
    })));
};
$a9ff937bba932aa9$var$LayoutButton.displayName = 'LayoutButton';
var $a9ff937bba932aa9$export$2e2bcd8739ae039 = (0, $gmMgo.default)($a9ff937bba932aa9$var$LayoutButton);


class $7cd6ea70a0939c4e$var$BreakoutView {
    constructor(/**
   * Note: this is actually a PMMark -- however our version
   * of the prosemirror and prosemirror types mean using PMNode
   * is not problematic.
   */ mark, view, appearance){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        dom.style.transform = 'none';
        dom.style.display = 'flex';
        dom.style.justifyContent = 'center';
        contentDOM.style.transition = `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`;
        if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
            if (mark.attrs.width) contentDOM.style.minWidth = `min(${mark.attrs.width}px, calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
            else {
                // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
                if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                if (mark.attrs.mode === 'wide') {
                    if (appearance && appearance === 'full-width' && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && true) contentDOM.style.minWidth = `min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
                    else contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                }
            }
        } else {
            // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
            if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'wide') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
    }
}
function $7cd6ea70a0939c4e$var$shouldPluginStateUpdate(newBreakoutNode, currentBreakoutNode) {
    if (newBreakoutNode && currentBreakoutNode) return newBreakoutNode !== currentBreakoutNode;
    return newBreakoutNode || currentBreakoutNode ? true : false;
}
function $7cd6ea70a0939c4e$var$createPlugin(api, { dispatch: dispatch }, appearance) {
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
            },
            apply (tr, pluginState) {
                const breakoutNode = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(tr.selection);
                if ($7cd6ea70a0939c4e$var$shouldPluginStateUpdate(breakoutNode, pluginState.breakoutNode)) {
                    const nextPluginState = {
                        ...pluginState,
                        breakoutNode: breakoutNode
                    };
                    dispatch((0, $c0a482e4157215ff$export$18d4026d1ea86bb1), nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            }
        },
        key: (0, $c0a482e4157215ff$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                // Note: When we upgrade to prosemirror 1.27.2 -- we should
                // move this to markViews.
                // See the following link for more details:
                // https://prosemirror.net/docs/ref/#view.EditorProps.nodeViews.
                breakout: (mark, view)=>{
                    return new $7cd6ea70a0939c4e$var$BreakoutView(mark, view, appearance);
                }
            }
        }
    });
}
const $7cd6ea70a0939c4e$var$LayoutButtonWrapper = ({ api: api, editorView: editorView, boundariesElement: boundariesElement, scrollableElement: scrollableElement, mountPoint: mountPoint })=>{
    const { editorDisabled: editorDisabled, isDragging: isDragging, isPMDragging: isPMDragging, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'editorDisabled',
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging,
            isPMDragging: states.blockControlsState?.isPMDragging,
            mode: states.editorViewModeState?.mode,
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const [breakoutNodePresent, setBreakoutNodePresent] = (0, $42omo.useState)(false);
    const [breakoutMode, setBreakoutMode] = (0, $42omo.useState)((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView ? undefined : // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $b725ae1e8e0afe9c$export$7293881dc293b44d)(editorView.state));
    (0, $6qdjm.usePluginStateEffect)(api, [
        'breakout'
    ], ({ breakoutState: breakoutState })=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        if (breakoutState?.breakoutNode && !breakoutNodePresent) setBreakoutNodePresent(true);
        if (!breakoutState?.breakoutNode && breakoutNodePresent) setBreakoutNodePresent(false);
        // Remove ! during platform_editor_hydratable_ui cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextBreakoutMode = (0, $b725ae1e8e0afe9c$export$7293881dc293b44d)(editorView.state);
        if (nextBreakoutMode !== breakoutMode) setBreakoutMode(nextBreakoutMode);
    });
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    if (interactionState === 'hasNotHadInteraction') return null;
    if (isDragging || isPMDragging) {
        if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return null;
    }
    const isViewMode = mode === 'view';
    const isEditMode = mode === 'edit';
    return !isViewMode && editorDisabled === false ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ff937bba932aa9$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isLivePage: isEditMode,
        isBreakoutNodePresent: breakoutNodePresent,
        breakoutMode: breakoutMode,
        api: api
    }) : null;
};
const $7cd6ea70a0939c4e$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return [
                {
                    name: 'breakout-resizing',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $0270481e4dcc36c1$export$522e3e76a011a0b1)(api, getIntl, nodeViewPortalProviderAPI, options)
                }
            ];
            return [
                {
                    name: 'breakout',
                    plugin: (props)=>$7cd6ea70a0939c4e$var$createPlugin(api, props, options?.appearance)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $gWpm5.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                const resizingPluginState = (0, $0270481e4dcc36c1$export$ca33a310187a5f87).getState(editorState);
                if (!resizingPluginState) return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
                return resizingPluginState;
            }
            const pluginState = (0, $c0a482e4157215ff$export$18d4026d1ea86bb1).getState(editorState);
            if (!pluginState) return {
                breakoutNode: undefined
            };
            return pluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $43857bfdf468c71f$export$ee321e647107007d), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
            // This is a bit crappy, but should be resolved once we move to a static schema.
            if (options && !options.allowBreakoutButton) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($7cd6ea70a0939c4e$var$LayoutButtonWrapper, {
                api: api,
                mountPoint: popupsMountPoint,
                editorView: editorView,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["breakoutPlugin"] = $7cd6ea70a0939c4e$export$f56f43f1e6905418;

});

parcelRegister("hr8mu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $anbEX = parcelRequire("anbEX");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");

var $60bKU = parcelRequire("60bKU");





var $dhoHU = parcelRequire("dhoHU");


var $dAtrv = parcelRequire("dAtrv");


var $ks2lK = parcelRequire("ks2lK");

/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $ce6a26a2978f2920$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        const { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $ks2lK.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $ce6a26a2978f2920$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $dhoHU.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $dhoHU.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ]))(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = tr.doc.type.schema;
        const alignmentApplied = (0, $dhoHU.toggleBlockMarkNext)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $ce6a26a2978f2920$var$changeImageAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $dhoHU.changeImageAlignment)(align))(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeImageAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const alignmentApplied = (0, $dhoHU.changeImageAlignmentNext)(align)(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $ce6a26a2978f2920$export$7364e99daa3bbf34 = (align, api, inputMethod)=>(state, dispatch)=>{
        return $ce6a26a2978f2920$var$cascadeCommands([
            $ce6a26a2978f2920$var$changeImageAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod),
            $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod)
        ])(state, dispatch);
    };
const $ce6a26a2978f2920$export$69636f7bd4c47a65 = (api, align, inputMethod)=>({ tr: tr })=>{
        $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        $ce6a26a2978f2920$var$changeImageAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        return tr;
    };


function $1d83767db168a60d$export$e832373cff8dec22(api) {
    const list = {};
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignLeft).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('start', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignCenter).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('center', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignRight).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('end', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    return (0, $60bKU.keymap)(list);
}



var $1S4f7 = parcelRequire("1S4f7");






var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $e1909cf6b30b9ea2$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $7XFGZ.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $8m4tT.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};


function $e5b264df70ce239d$var$createInitialPluginState(editorState, pluginConfig) {
    return {
        align: (0, $e1909cf6b30b9ea2$export$fcb629559422d129)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $e5b264df70ce239d$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('alignmentPlugin');
function $e5b264df70ce239d$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $1S4f7.SafePlugin)({
        key: $e5b264df70ce239d$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $e5b264df70ce239d$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextPluginState = (0, $e1909cf6b30b9ea2$export$fcb629559422d129)(nextState);
                const isEnabled = (0, $ce6a26a2978f2920$export$f3f99b2459c4a09f)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($e5b264df70ce239d$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}






var $42omo = parcelRequire("42omo");





var $eiA8Z = parcelRequire("eiA8Z");





var $806bba3ad7232b9a$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gmMgo = parcelRequire("gmMgo");





var $hkTaH = parcelRequire("hkTaH");


var $807Mc = parcelRequire("807Mc");

var $7k7Bn = parcelRequire("7k7Bn");

var $8mBDG = parcelRequire("8mBDG");

var $l1m3U = parcelRequire("l1m3U");

var $jN96M = parcelRequire("jN96M");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");

var $h4TOP = parcelRequire("h4TOP");

var $a4eZN = parcelRequire("a4eZN");


var $kiZiu = parcelRequire("kiZiu");


var $6bJyJ = parcelRequire("6bJyJ");


var $cOZT3 = parcelRequire("cOZT3");





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");













parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");













const $9077f92b6f7c0540$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))),
        label: (0, $hkTaH.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))),
        label: (0, $hkTaH.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))),
        label: (0, $hkTaH.alignmentMessages).alignCenter
    }
};
const $9077f92b6f7c0540$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $9077f92b6f7c0540$var$iconAndMessageMap[props.alignment];
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};





parcelRequire("42omo");







function $8f58ec37c0df463c$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $hgeg8.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content,
        titlePosition: 'bottom'
    });
}
var $8f58ec37c0df463c$export$2e2bcd8739ae039 = $8f58ec37c0df463c$var$AlignmentButton;


const $5be52fb152fadf6d$var$alignmentWrapper = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $5be52fb152fadf6d$var$alignmentWrapperStylesUnbounded = null;
const $5be52fb152fadf6d$var$alignCenterKeyboardShortcut = (0, $hgeg8.alignCenter);
const $5be52fb152fadf6d$var$alignRightKeyboardShortcut = (0, $hgeg8.alignRight);
const $5be52fb152fadf6d$var$alignmentOptions = [
    {
        title: (0, $hkTaH.alignmentMessages).alignLeft,
        shortcut: (0, $hgeg8.alignLeft),
        value: 'start'
    },
    {
        title: (0, $hkTaH.alignmentMessages).alignCenter,
        shortcut: $5be52fb152fadf6d$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $hkTaH.alignmentMessages).alignRight,
        shortcut: $5be52fb152fadf6d$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $5be52fb152fadf6d$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "alignment-buttons",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gMc0m.default)([
            "_1e0c1txw _ca0qze3t _n3tdze3t _19bvu2gc _u5f3u2gc _p12f53f4 _gy1pv77o",
            "_1fvdglyw",
            className
        ]),
        children: $5be52fb152fadf6d$var$alignmentOptions.map((alignment)=>{
            const { value: value, title: title, shortcut: shortcut } = alignment;
            const message = intl.formatMessage(title);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f58ec37c0df463c$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                    alignment: value
                }),
                value: value,
                label: message,
                shortcut: shortcut,
                onClick: onClick,
                isSelected: value === selectedAlignment
            }, value);
        })
    });
}
var $5be52fb152fadf6d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5be52fb152fadf6d$var$Alignment);



function $26b4ba5a10aa334a$var$_defineProperty(e, r, t) {
    return (r = $26b4ba5a10aa334a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $26b4ba5a10aa334a$var$_toPropertyKey(t) {
    var i = $26b4ba5a10aa334a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $26b4ba5a10aa334a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $26b4ba5a10aa334a$var$AlignmentToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, align: align, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = align ?? 'start';
        const title = intl.formatMessage((0, $hkTaH.alignmentMessages).alignment);
        const reducedSpacing = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? 'compact' : 'none';
        const items = [
            {
                key: 'alignmentLeft',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignLeft),
                value: {
                    name: 'start'
                },
                isActive: align === 'start',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignLeft))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                    label: ""
                })
            },
            {
                key: 'alignmentCenter',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignCenter),
                value: {
                    name: 'center'
                },
                isActive: align === 'center',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignCenter))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
                    label: ""
                })
            },
            {
                key: 'alignmentRight',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignRight),
                value: {
                    name: 'end'
                },
                isActive: align === 'end',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignRight))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))), {
                    label: ""
                })
            }
        ];
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8mBDG.ToolbarDropdownWrapper), {
            children: [
                (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    },
                    items: [
                        {
                            items: items
                        }
                    ],
                    isOpen: isOpen,
                    onItemActivated: this.handleOnItemActivated,
                    onOpenChange: (attrs)=>this.setState({
                            isOpen: attrs?.isOpen
                        }),
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    fitWidth: 200,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        "aria-label": title,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7k7Bn.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $l1m3U.ToolbarExpandIcon), {})
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    isOpen: isOpen,
                    handleClickOutside: (event)=>{
                        if (event instanceof MouseEvent) this.hide({
                            isOpen: false,
                            event: event
                        });
                    },
                    handleEscapeKeydown: this.hideOnEscape,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    },
                    fitWidth: 112,
                    fitHeight: 80,
                    closeOnTab: true,
                    trigger: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        className: "align-btn",
                        "aria-label": title,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7k7Bn.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $l1m3U.ToolbarExpandIcon), {})
                            ]
                        }),
                        ref: this.toolbarItemRef
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5be52fb152fadf6d$export$2e2bcd8739ae039), {
                        onClick: (align)=>this.changeAlignment(align, false),
                        selectedAlignment: alignment
                    })
                }),
                !api?.primaryToolbar && /*#__PURE__*/ (0, $l998X.jsx)((0, $jN96M.ToolbarSeparator), {})
            ]
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.toolbarType !== (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).FLOATING && this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.toolbarItemRef.current?.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args);
        $26b4ba5a10aa334a$var$_defineProperty(this, "toolbarItemRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef());
        $26b4ba5a10aa334a$var$_defineProperty(this, "state", {
            isOpen: false
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "changeAlignment", (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "toggleOpen", ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "toggleOpenByKeyboard", (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "handleOnItemActivated", ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>this.changeAlignment(item.value.name, shouldCloseMenu));
        $26b4ba5a10aa334a$var$_defineProperty(this, "hide", (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if (attrs?.event instanceof KeyboardEvent && attrs.event.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "hideOnEscape", ()=>{
            this.hide();
            this.toolbarItemRef?.current?.focus();
        });
    }
}
$26b4ba5a10aa334a$var$_defineProperty($26b4ba5a10aa334a$var$AlignmentToolbar, "displayName", 'AlignmentToolbar');
var $26b4ba5a10aa334a$export$2e2bcd8739ae039 = (0, $gmMgo.default)($26b4ba5a10aa334a$var$AlignmentToolbar);


const $43cfda29e24b9fdf$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true
};
function $43cfda29e24b9fdf$export$b15abb95157a91c7({ api: api, editorView: editorView }) {
    const { align: align, isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $42omo.useCallback)((align)=>{
        return (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)(align, api, (0, $d925B.INPUT_METHOD).FLOATING_TB)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $26b4ba5a10aa334a$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : $43cfda29e24b9fdf$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: $43cfda29e24b9fdf$var$FloatingToolbarSettings.disabled || !isEnabled,
        toolbarType: (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).FLOATING,
        api: api
    });
}

















function $78654db6b6a6a165$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { align: align, isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $42omo.useCallback)((align)=>(0, $ce6a26a2978f2920$export$7364e99daa3bbf34)(align, api, (0, $d925B.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch), [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $26b4ba5a10aa334a$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api,
        toolbarType: (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).PRIMARY
    });
}





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




parcelRequire("42omo");











var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");


var $1oCLl = parcelRequire("1oCLl");



















const $02889ce465edde7a$export$8a5a39b03f4aaab = ()=>({
        start: {
            key: (0, $cPCP8.ALIGN_LEFT_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_LEFT_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_LEFT_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignLeft,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))),
            keymap: (0, $hgeg8.alignLeft)
        },
        center: {
            key: (0, $cPCP8.ALIGN_CENTER_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_CENTER_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_CENTER_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignCenter,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))),
            keymap: (0, $hgeg8.alignCenter)
        },
        end: {
            key: (0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignRight,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))),
            keymap: (0, $hgeg8.alignRight)
        }
    });


const $41509ad770a558ab$export$4301fcd45f99f8a5 = ({ children: children, api: api })=>{
    const { align: align = 'start', isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const { icon: Icon } = (0, $02889ce465edde7a$export$8a5a39b03f4aaab)()[align];
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const title = formatMessage((0, $hkTaH.alignmentMessages).alignment);
    if ((0, $1oCLl.expValEquals)('platform_editor_hide_toolbar_tooltips_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: "",
            size: "small"
        }),
        isDisabled: !isEnabled,
        testId: "text-alignment-menu",
        label: title,
        tooltipComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
            content: title
        }),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: title,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: "",
                size: "small"
            }),
            isDisabled: !isEnabled,
            testId: "text-alignment-menu",
            label: title,
            children: children
        })
    });
};





parcelRequire("42omo");











var $4Dsx2 = parcelRequire("4Dsx2");


var $2GVu1 = parcelRequire("2GVu1");

var $jbmmV = parcelRequire("jbmmV");


const $235527fa0af4c687$export$ff21a61af4a241d = ({ option: { label: label, icon: Icon, keymap: keymap }, api: api, alignment: alignment, parents: parents })=>{
    const { align: align } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align
        };
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shortcut = (0, $hgeg8.tooltip)(keymap);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        isSelected: align === alignment,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut && /*#__PURE__*/ (0, $l998X.jsx)((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }),
        ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)(keymap),
        onClick: ()=>{
            api?.core.actions.execute((0, $ce6a26a2978f2920$export$69636f7bd4c47a65)(api, alignment, (0, $4Dsx2.getInputMethodFromParentKeys)(parents)));
        },
        children: formatMessage(label)
    });
};





parcelRequire("42omo");





var $6UWPx = parcelRequire("6UWPx");

const $ad2ecd4529c8501c$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $cPCP8.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};



const $5f64fe0bd2a0a4c4$var$getAlignmentMenuItems = (api)=>{
    return Object.entries((0, $02889ce465edde7a$export$8a5a39b03f4aaab)()).map(([alignment, item])=>{
        const { key: key, type: type, rank: rank } = item;
        return {
            type: type,
            key: key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_MENU_SECTION).type,
                    key: (0, $cPCP8.ALIGNMENT_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $235527fa0af4c687$export$ff21a61af4a241d), {
                    api: api,
                    option: item,
                    alignment: alignment,
                    parents: parents
                });
            }
        };
    });
};
const $5f64fe0bd2a0a4c4$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            type: (0, $cPCP8.ALIGNMENT_GROUP).type,
            key: (0, $cPCP8.ALIGNMENT_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION).type,
                    key: (0, $cPCP8.TEXT_SECTION).key,
                    rank: (0, $4Chin.TEXT_SECTION_RANK)[(0, $cPCP8.ALIGNMENT_GROUP).key]
                },
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.ALIGNMENT_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.ALIGNMENT_MENU).type,
            key: (0, $cPCP8.ALIGNMENT_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_GROUP).type,
                    key: (0, $cPCP8.ALIGNMENT_GROUP).key,
                    rank: (0, $4Chin.ALIGNMENT_GROUP_RANK)[(0, $cPCP8.ALIGNMENT_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $41509ad770a558ab$export$4301fcd45f99f8a5), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.ALIGNMENT_MENU_SECTION).type,
            key: (0, $cPCP8.ALIGNMENT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_MENU).type,
                    key: (0, $cPCP8.ALIGNMENT_MENU).key,
                    rank: (0, $4Chin.ALIGNMENT_MENU_RANK)[(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]
                },
                {
                    type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
                    key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $4Chin.TEXT_COLLAPSED_MENU_RANK)[(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]
                }
            ],
            component: (0, $ad2ecd4529c8501c$export$4b1545b4f2016d26)
        },
        ...$5f64fe0bd2a0a4c4$var$getAlignmentMenuItems(api)
    ];
};


const $e91e4386e86c6360$var$defaultConfig = {
    align: 'start'
};
const $e91e4386e86c6360$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $78654db6b6a6a165$export$94516d5cccf573e3), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $5f64fe0bd2a0a4c4$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'alignment',
        component: primaryToolbarComponent
    });
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $anbEX.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $e5b264df70ce239d$export$18d4026d1ea86bb1).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $e5b264df70ce239d$export$ae829ec7b2625219)(dispatch, $e91e4386e86c6360$var$defaultConfig)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $1d83767db168a60d$export$e832373cff8dec22)(api)
                }
            ];
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : ()=>{
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $43cfda29e24b9fdf$export$b15abb95157a91c7), {
                                api: api,
                                editorView: view
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 4,
                        pluginName: 'alignment'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["alignmentPlugin"] = $e91e4386e86c6360$export$48e8beb2d4cfb048;

});

parcelRegister("dtCIm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $zMjD6 = parcelRequire("zMjD6");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

var $0ea83d7668f10440$export$29dff82773c5f10f = /*#__PURE__*/ function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
    return FindReplaceActionTypes;
}({});



var $lkJUe = parcelRequire("lkJUe");

var $kTbzR = parcelRequire("kTbzR");























const $e8b1b385096c80fd$export$e7697da71e34f0a6 = new (0, $ks2lK.PluginKey)('findReplace');


const $797013ea47834520$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $ftzrq.DecorationSet).empty,
    shouldMatchCase: false
};
const $797013ea47834520$export$ae829ec7b2625219 = (dispatch, getIntl, api)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $e8b1b385096c80fd$export$e7697da71e34f0a6),
        state: (0, $68a609e009bbcefe$export$656c7661095efe2e)(dispatch, ()=>(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) || (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true) ? {
                ...$797013ea47834520$export$d4c72bab9d6cc13a,
                getIntl: getIntl,
                api: api
            } : {
                ...$797013ea47834520$export$d4c72bab9d6cc13a
            }),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });
};







const $ddd7d9e0e4897838$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE:
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE:
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).CANCEL:
                const { getIntl: getIntl, api: api } = state;
                return (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? {
                    ...getInitialState(),
                    getIntl: getIntl,
                    api: api
                } : getInitialState();
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $ddd7d9e0e4897838$export$2e2bcd8739ae039 = $ddd7d9e0e4897838$var$reducer;



var $2daQU = parcelRequire("2daQU");


var $dIxHZ = parcelRequire("dIxHZ");








var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");





var $8z9j5 = parcelRequire("8z9j5");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $a2f418c832d6976a$export$cec6db4af40340f0 = 'search-match';
const $a2f418c832d6976a$export$a19ecadc9ecc39b1 = 'search-match-text';
const $a2f418c832d6976a$export$bf208a338b2a2f1f = 'selected-search-match';
const $a2f418c832d6976a$export$bb09fa712812841f = 'search-match-block';
const $a2f418c832d6976a$export$99146b4c1ad5837a = 'search-match-block-selected';
const $a2f418c832d6976a$export$6cc90c491f952538 = 'search-match-dark';
const $a2f418c832d6976a$export$2414358ab66f419a = 'search-match-expand-title';


function $68ba69b3f7b9f0e7$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $68ba69b3f7b9f0e7$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end, canReplace: canReplace, nodeType: nodeType }, i)=>$68ba69b3f7b9f0e7$export$83df86cadabd260({
            start: start,
            end: end,
            canReplace: canReplace,
            nodeType: nodeType
        }, i === selectedIndex));
const $68ba69b3f7b9f0e7$var$isElement = (nodeType)=>[
        'blockCard',
        'embedCard',
        'inlineCard',
        'status',
        'mention',
        'date'
    ].includes(nodeType || '');
const $68ba69b3f7b9f0e7$var$isExpandTitle = (match)=>[
        'expand',
        'nestedExpand'
    ].includes(match.nodeType || '') && !match.canReplace;
const $68ba69b3f7b9f0e7$export$83df86cadabd260 = (match, isSelected)=>{
    const { start: start, end: end, nodeType: nodeType } = match;
    if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        if ($68ba69b3f7b9f0e7$var$isElement(nodeType)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$bb09fa712812841f), {
                [(0, $a2f418c832d6976a$export$99146b4c1ad5837a)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).node(start, end, {
                class: className
            });
        } else if ($68ba69b3f7b9f0e7$var$isExpandTitle(match)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$2414358ab66f419a), {
                [(0, $a2f418c832d6976a$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).node(start, end, {
                class: className
            });
        } else {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$a19ecadc9ecc39b1), {
                [(0, $a2f418c832d6976a$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).inline(start, end, {
                class: className
            });
        }
    } else {
        let className = (0, $a2f418c832d6976a$export$cec6db4af40340f0);
        if (isSelected) className += ` ${0, $a2f418c832d6976a$export$bf208a338b2a2f1f}`;
        return (0, $ftzrq.Decoration).inline(start, end, {
            class: className
        });
    }
};
function $68ba69b3f7b9f0e7$export$f4585c00f32d9257({ content: content, searchText: searchText, shouldMatchCase: shouldMatchCase, contentIndex: contentIndex = 0, getIntl: getIntl, api: api }) {
    const matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectTextMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text } = textGrouping;
        const { pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end,
                canReplace: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? true : undefined,
                nodeType: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 'text' : undefined
            });
            index = text.indexOf(searchText, end);
        }
    };
    const collectNodeMatch = (textGrouping, node)=>{
        if (!textGrouping) return;
        const { pos: pos } = textGrouping;
        let { text: text } = textGrouping;
        if (node.type.name === 'status' && shouldMatchCase) text = text.toUpperCase();
        else if (!shouldMatchCase) {
            text = text.toLowerCase();
            searchText = searchText.toLowerCase();
        }
        const index = text.indexOf(searchText);
        if (index !== -1) matches.push({
            start: pos,
            end: pos + node.nodeSize,
            canReplace: false,
            nodeType: node.type.name
        });
    };
    const collectCardTitleMatch = (node, pos)=>{
        const cards = api?.card?.sharedState.currentState()?.cards;
        if (cards) {
            const relevantCard = cards.find((card)=>card.url === node.attrs.url);
            const title = relevantCard?.title;
            if (relevantCard) {
                if (title) collectNodeMatch({
                    text: title,
                    pos: pos
                }, node);
                else // when there is no title, e.g. in an error case like unauthorized
                // the link card just shows the entire url as the title in inline card
                if (node.type.name === 'inlineCard') collectNodeMatch({
                    text: node.attrs.url,
                    pos: pos
                }, node);
            }
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text = textGrouping.text + node.text;
            } else {
                collectTextMatch(textGrouping);
                textGrouping = null;
                if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) switch(node.type.name){
                    case 'status':
                        collectNodeMatch({
                            text: node.attrs.text,
                            pos: pos
                        }, node);
                        break;
                    case 'date':
                        collectNodeMatch({
                            text: (0, $dIxHZ.timestampToString)(node.attrs.timestamp, getIntl ? getIntl() : null),
                            pos: pos
                        }, node);
                        break;
                    case 'expand':
                    case 'nestedExpand':
                        collectNodeMatch({
                            text: node.attrs.title,
                            pos: pos
                        }, node);
                        break;
                    case 'mention':
                        let text;
                        if (node.attrs.text) text = node.attrs.text;
                        else {
                            // the text may be sanitised from the node for privacy reasons
                            // so we need to use the mentionProvider to resolve it
                            const mentionProvider = api?.mention?.sharedState.currentState()?.mentionProvider;
                            if ((0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) {
                                const nameDetail = mentionProvider.resolveMentionName(node.attrs.id);
                                if ((0, $6mYMS.isPromise)(nameDetail)) text = '@...';
                                else if (nameDetail.status === (0, $6mYMS.MentionNameStatus).OK) text = `@${nameDetail.name || ''}`;
                                else text = '@_|unknown|_';
                            }
                        }
                        if (text) collectNodeMatch({
                            text: text,
                            pos: pos
                        }, node);
                        break;
                    case 'inlineCard':
                    case 'blockCard':
                    case 'embedCard':
                        collectCardTitleMatch(node, pos);
                        break;
                    default:
                        break;
                }
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectTextMatch, manually collectTextMatch
        if (textGrouping) collectTextMatch(textGrouping);
    }
    return matches;
}
function $68ba69b3f7b9f0e7$export$6df7393992287695(selectionPos, matches) {
    const forwardMatchIndex = matches.findIndex((match)=>match.start >= selectionPos);
    if (forwardMatchIndex === -1) // if there are no forward matches, it must be the last match
    return matches.length > 0 ? matches.length - 1 : 0;
    else if (forwardMatchIndex === 0) return forwardMatchIndex;
    const backwardMatchIndex = forwardMatchIndex - 1;
    const forwardMatchPos = matches[forwardMatchIndex].start;
    const backwardMatchPos = matches[backwardMatchIndex].start;
    if (forwardMatchPos - selectionPos < selectionPos - backwardMatchPos) return forwardMatchIndex;
    else return backwardMatchIndex;
}
function $68ba69b3f7b9f0e7$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $68ba69b3f7b9f0e7$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $68ba69b3f7b9f0e7$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $68ba69b3f7b9f0e7$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) {
        if ($68ba69b3f7b9f0e7$var$isExpandTitle(matches[index])) return (0, $ks2lK.NodeSelection).create(doc, matches[index].start);
        return (0, $ks2lK.TextSelection).create(doc, matches[index].start + offset);
    }
    return selection;
};
const $68ba69b3f7b9f0e7$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    const lostDecorations = $68ba69b3f7b9f0e7$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $68ba69b3f7b9f0e7$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$68ba69b3f7b9f0e7$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $68ba69b3f7b9f0e7$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $68ba69b3f7b9f0e7$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $68ba69b3f7b9f0e7$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $68ba69b3f7b9f0e7$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $68ba69b3f7b9f0e7$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};
function $68ba69b3f7b9f0e7$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}


const $68a609e009bbcefe$var$handleDocChanged = (tr, pluginState)=>{
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $kTbzR.stepHasSlice))) return pluginState;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, decorationSet: decorationSet, matches: matches, shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = pluginState;
    const newMatches = (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
        content: tr.doc,
        searchText: findText,
        shouldMatchCase: shouldMatchCase,
        getIntl: getIntl,
        api: api
    });
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end),
            canReplace: match.canReplace,
            nodeType: match.nodeType
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $ftzrq.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $kTbzR.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $68ba69b3f7b9f0e7$export$7d11bfeb87290a13)(match, step, tr) && !(0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $68ba69b3f7b9f0e7$export$bb98a54aeaa7e0c0)(mappedMatches.filter((match)=>(0, $68ba69b3f7b9f0e7$export$7d11bfeb87290a13)(match, step, tr) && !!(0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(tr.selection.from, newMatches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $68ba69b3f7b9f0e7$export$b5b5304233807f24)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(0, [
        newSelectedMatch
    ]));
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, newMatches);
        // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
    }
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const { createCommand: $68a609e009bbcefe$export$8d4021544bdece00, getPluginState: $68a609e009bbcefe$export$f05434c51e3762e, createPluginState: $68a609e009bbcefe$export$656c7661095efe2e } = (0, $lkJUe.pluginFactory)((0, $e8b1b385096c80fd$export$e7697da71e34f0a6), (0, $ddd7d9e0e4897838$export$2e2bcd8739ae039)(()=>(0, $797013ea47834520$export$d4c72bab9d6cc13a)), {
    onDocChanged: $68a609e009bbcefe$var$handleDocChanged
});








// max number of decorations to apply at once
const $327618b7c36ee16b$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $327618b7c36ee16b$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $327618b7c36ee16b$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
   * Applies the decorations needed for the current search results
   * It does so async, splitting them up into batches to help with performance
   */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $327618b7c36ee16b$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $327618b7c36ee16b$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $327618b7c36ee16b$var$posIncrement));
        } else {
            after = Math.min(after + $327618b7c36ee16b$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $327618b7c36ee16b$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            const matchesToDecorate = matchesBetween.slice(counter, counter + $327618b7c36ee16b$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $327618b7c36ee16b$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $327618b7c36ee16b$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(useSelectionIndex ? selectionIndex % $327618b7c36ee16b$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $327618b7c36ee16b$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $327618b7c36ee16b$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $327618b7c36ee16b$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
   * Calculates Prosemirror start and end positions we want to apply the decorations
   * between
   * Also calculates the positions the are the start and end of the user's viewport
   * so we can apply decorations there first and work outwards
   */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 0 : 1,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return startPos ? startPos.pos : 0;
        else return startPos ? startPos.pos : 1;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
   * Util to batch function calls by animation frames
   * A counter will start at 0 and increment by provided value until reaches limit
   * Passed in fn receives the counter as a param, return false to skip waiting
   * for the animation frame for the next call
   */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
    constructor(){
        this.rafId = void 0;
        this.addDecorations = void 0;
        this.removeDecorations = void 0;
    }
}
const $327618b7c36ee16b$var$batchDecorations = new $327618b7c36ee16b$var$BatchDecorations();
var $327618b7c36ee16b$export$2e2bcd8739ae039 = $327618b7c36ee16b$var$batchDecorations;


const $77b74506ab92b199$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);


const $92ce31c77152d962$export$234c45b355edd85b = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $ks2lK.TextSelection) && !selection.empty) {
            findText = (0, $68ba69b3f7b9f0e7$export$93850515e4be65a3)(selection);
            const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
            matches = (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
                content: state.doc,
                searchText: findText,
                shouldMatchCase: shouldMatchCase,
                getIntl: getIntl,
                api: api
            });
            index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
        }
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $92ce31c77152d962$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        const index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $327618b7c36ee16b$export$2e2bcd8739ae039).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$92ce31c77152d962$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$92ce31c77152d962$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        if (matches.length > 0) {
            const index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
            const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, index, matches);
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
            api?.expand?.commands.toggleExpandWithMatch(newSelection)({
                tr: tr
            });
            return tr.setSelection(newSelection);
        }
        return tr;
    }));
const $92ce31c77152d962$export$ebdf538520f8717 = (editorView)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>$92ce31c77152d962$var$findInDirection(state, 'next'), (tr, state)=>{
        const { matches: matches, index: index, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(searchIndex, matches.length);
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $92ce31c77152d962$export$eef4841c27f82c55 = (editorView)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>$92ce31c77152d962$var$findInDirection(state, 'previous'), (tr, state)=>{
        const { matches: matches, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches, true);
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $92ce31c77152d962$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length) : (0, $68ba69b3f7b9f0e7$export$9041fedbf960fcef)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $92ce31c77152d962$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_NEXT : (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $92ce31c77152d962$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const { findText: findText, matches: matches } = pluginState;
        let { decorationSet: decorationSet, index: index } = pluginState;
        decorationSet = $92ce31c77152d962$var$updateSelectedHighlight(state, (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $68ba69b3f7b9f0e7$export$b5b5304233807f24)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        if (matches[index]) {
            if (!matches[index].canReplace && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length);
            tr.insertText(replaceText, start, end).setSelection((0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length));
        }
        return tr;
    }));
const $92ce31c77152d962$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $ftzrq.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        pluginState.matches.forEach((match)=>{
            if (!match.canReplace && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $92ce31c77152d962$export$e17d1d1acde229e1 = (decorations)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $92ce31c77152d962$export$f9e1c8eeab9872dc = (decorations)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorations, state.doc)
        };
    });
const $92ce31c77152d962$export$58f3f9b95b84be3c = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)(()=>{
        (0, $327618b7c36ee16b$export$2e2bcd8739ae039).stop();
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).CANCEL
        };
    });
const $92ce31c77152d962$export$2cc7ff91bcacba5e = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).BLUR
    });
const $92ce31c77152d962$export$4e987d48fa8a04d7 = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).TOGGLE_MATCH_CASE
    });
const $92ce31c77152d962$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    const { index: index, matches: matches } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    let { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $68ba69b3f7b9f0e7$export$83df86cadabd260)(currentSelectedMatch)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $68ba69b3f7b9f0e7$export$83df86cadabd260)(nextSelectedMatch, true)
    ]);
    return decorationSet;
};






var $dAtrv = parcelRequire("dAtrv");





const $11e7df9f05f7da42$export$f4a2dfcbc300db1a = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, (state)=>({
                eventType: (0, $d925B.EVENT_TYPE).UI,
                action: (0, $d925B.ACTION).ACTIVATED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $ks2lK.TextSelection) && !state.selection.empty ? (0, $d925B.INPUT_METHOD).PREFILL : (0, $d925B.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod
                }
            }))((0, $92ce31c77152d962$export$234c45b355edd85b)());
const $11e7df9f05f7da42$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT
        })((0, $92ce31c77152d962$export$71aa6c912b956294)(editorView, containerElement, keyword));
const $11e7df9f05f7da42$export$da0da8f66917d4cd = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$ebdf538520f8717)(editorView));
    };
const $11e7df9f05f7da42$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$eef4841c27f82c55)(editorView));
const $11e7df9f05f7da42$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).REPLACED_ONE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$77ad94ebf1c2b9ed)(replaceText));
const $11e7df9f05f7da42$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).REPLACED_ALL,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT
        })((0, $92ce31c77152d962$export$b8b3234b4edfc4c2)(replaceText));
const $11e7df9f05f7da42$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).UI,
            action: (0, $d925B.ACTION).DEACTIVATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$58f3f9b95b84be3c)());






var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


const $0cc9e4cfac335e7b$var$activateFindReplace = (editorAnalyticsAPI)=>(state, dispatch)=>{
        (0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $0cc9e4cfac335e7b$var$keymapPlugin = (editorAnalyticsAPI)=>{
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.find).common, $0cc9e4cfac335e7b$var$activateFindReplace(editorAnalyticsAPI), list);
    return (0, $dus6D.keymap)(list);
};
var $0cc9e4cfac335e7b$export$2e2bcd8739ae039 = $0cc9e4cfac335e7b$var$keymapPlugin;








var $42omo = parcelRequire("42omo");












parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");





var $5v8Ta = parcelRequire("5v8Ta");

var $6qITU = parcelRequire("6qITU");


var $aFUXX = parcelRequire("aFUXX");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $lzn6v = parcelRequire("lzn6v");







/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $jSnXV = parcelRequire("jSnXV");


var $2P8Ax = parcelRequire("2P8Ax");











var $bfgIy = parcelRequire("bfgIy");


var $1FOj2 = parcelRequire("1FOj2");


var $5gydP = parcelRequire("5gydP");


var $4noo5 = parcelRequire("4noo5");











var $1qfLF = parcelRequire("1qfLF");





var $3gadb = parcelRequire("3gadb");

class $77fa80c59f0bb86c$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                description: title,
                keymap: (0, $hgeg8.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                id: "afterInputSection",
                label: title,
                appearance: appearance,
                testId: title,
                ref: this.buttonRef,
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        ...iconProps,
                        size: iconSize
                    }),
                isDisabled: disabled,
                onClick: this.handleClick,
                isSelected: isPressed,
                ...pressedProps
            })
        });
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}
$77fa80c59f0bb86c$export$d7a26608845e3a06.defaultProps = {
    keymapDescription: 'no-keymap',
    appearance: 'subtle'
};


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $6fnsQ = parcelRequire("6fnsQ");

function $6f19b0f678d47301$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f19b0f678d47301$var$fontSize = 14;
const $6f19b0f678d47301$export$2413e968422424ec = /*#__PURE__*/ (0, $9K4OG.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${`var(--ds-border, ${(0, $6fnsQ.N30A)})`}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: "var(--ds-border-width, 1px)"
});
const $6f19b0f678d47301$export$491e6397d7c1480b = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $6f19b0f678d47301$export$263284dac1af2f8a = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $6f19b0f678d47301$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $6f19b0f678d47301$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $6f19b0f678d47301$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $9K4OG.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14)
});
const $6f19b0f678d47301$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $9K4OG.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${36 / $6f19b0f678d47301$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px'
    }
});
const $6f19b0f678d47301$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $6f19b0f678d47301$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $6f19b0f678d47301$export$df58af0590d04217 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $6f19b0f678d47301$export$1e2581329286cf31 = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `${"var(--ds-text-subtlest, #626F86)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    fontSize: `${(0, $aFUXX.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $6f19b0f678d47301$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $6f19b0f678d47301$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $6f19b0f678d47301$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $9K4OG.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $6f19b0f678d47301$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};


const $f64d7eaf6f543352$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f64d7eaf6f543352$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) // Wait for findTextfieldRef to become available then focus
        setTimeout(()=>{
            this.focusFindTextfield();
        }, 100);
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        // focus on update if find text did not change
        if (this.props.findText === this.state?.localFindText) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $lzn6v.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$d449744ea6979b42)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $6f19b0f678d47301$export$1e2581329286cf31),
                (0, $6f19b0f678d47301$export$3fc34436808d2893)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$24f07703e9463557)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
            title: this.matchCase,
            appearance: "default",
            icon: this.matchCaseIconEle,
            iconLabel: this.matchCase,
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                (0, $6f19b0f678d47301$export$4fcc6c669daa3229),
                (0, $6f19b0f678d47301$export$1c21208bb1fdf473)
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$7910eaff0a3df2fc)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bfgIy.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
    constructor(props){
        super(props);
        this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.isComposing = false;
        this.find = void 0;
        this.noResultsFound = void 0;
        this.matchCase = void 0;
        this.syncFindText = (onSynced)=>{
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== this.state?.localFindText) this.updateFindValue(this.props.findText || '', onSynced);
        };
        this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        };
        this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        };
        // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((value)=>{
            this.props.onFind(value);
        }, $f64d7eaf6f543352$export$c7a15a679416091a);
        this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        };
        // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $2P8Ax.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        });
        this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        };
        this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        };
        this.handleFindNextClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleMatchCaseClick = ()=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        };
        this.matchCaseIconEle = (iconProps)=>{
            return (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1FOj2))), {
                label: iconProps.label,
                size: "small"
            }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
                label: this.matchCase
            });
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $lzn6v.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $lzn6v.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $lzn6v.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
}
var $f64d7eaf6f543352$export$2e2bcd8739ae039 = (0, $gmMgo.default)($f64d7eaf6f543352$var$Find);












var $ccHMk = parcelRequire("ccHMk");








var $gQhRa = parcelRequire("gQhRa");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");




var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");










const $c7ca968779a672f3$var$replaceContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $c7ca968779a672f3$var$replaceWithLabelStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $c7ca968779a672f3$var$actionButtonContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200'
});
const $c7ca968779a672f3$var$actionButtonParentInlineStyles = (0, $ecnYn.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $c7ca968779a672f3$var$actionButtonParentInlineStylesNew = (0, $ecnYn.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap'
});
const $c7ca968779a672f3$var$actionButtonInlineStyles = (0, $ecnYn.xcss)({
    gap: 'space.075'
});
const $c7ca968779a672f3$var$closeButtonInlineStyles = (0, $ecnYn.xcss)({
    marginRight: 'auto'
});
const $c7ca968779a672f3$var$Replace = ({ canReplace: canReplace, replaceText: initialReplaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, onReplaceTextfieldRefSet: onReplaceTextfieldRefSet, onArrowUp: onArrowUp, onCancel: onCancel, count: count, onFindNext: onFindNext, onFindPrev: onFindPrev, dispatchAnalyticsEvent: dispatchAnalyticsEvent, setFindTyped: setFindTyped, findTyped: findTyped, focusToolbarButton: focusToolbarButton, intl: { formatMessage: formatMessage } })=>{
    const [replaceText, setReplaceText] = (0, $42omo.useState)(initialReplaceText || '');
    const [isComposing, setIsComposing] = (0, $42omo.useState)(false);
    const [isHelperMessageVisible, setIsHelperMessageVisible] = (0, $42omo.useState)(false);
    const [fakeSuccessReplacementMessageUpdate, setFakeSuccessReplacementMessageUpdate] = (0, $42omo.useState)(false);
    const [replaceCount, setReplaceCount] = (0, $42omo.useState)(0);
    const replaceTextfieldRef = (0, $42omo.useRef)(null);
    const successReplacementMessageRef = (0, $42omo.useRef)(null);
    const replaceWith = formatMessage((0, $lzn6v.findReplaceMessages).replaceWith);
    const replaceAll = formatMessage((0, $lzn6v.findReplaceMessages).replaceAll);
    const findPrevious = formatMessage((0, $lzn6v.findReplaceMessages).findPrevious);
    const closeFindReplaceDialog = formatMessage((0, $lzn6v.findReplaceMessages).closeFindReplaceDialog);
    (0, $42omo.useEffect)(()=>{
        onReplaceTextfieldRefSet(replaceTextfieldRef);
    }, [
        onReplaceTextfieldRefSet
    ]);
    (0, $42omo.useEffect)(()=>{
        setReplaceText(initialReplaceText || '');
    }, [
        initialReplaceText
    ]);
    const skipWhileComposing = (fn)=>{
        if (!isComposing) fn();
    };
    const triggerSuccessReplacementMessageUpdate = (currentReplaceCount)=>{
        if (replaceCount === currentReplaceCount) setFakeSuccessReplacementMessageUpdate(!fakeSuccessReplacementMessageUpdate);
        if (successReplacementMessageRef.current) {
            const ariaLiveRegion = successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion?.removeAttribute('aria-live');
            ariaLiveRegion?.setAttribute('aria-live', 'polite');
        }
    };
    const handleReplaceClick = ()=>skipWhileComposing(()=>{
            onReplace({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON,
                replaceText: replaceText
            });
            triggerSuccessReplacementMessageUpdate(1);
            setIsHelperMessageVisible(true);
            setReplaceCount(1);
            setFindTyped(false);
        });
    const handleReplaceChange = (event)=>skipWhileComposing(()=>{
            updateReplaceValue(event.target.value);
        });
    const updateReplaceValue = (text)=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).CHANGED_REPLACEMENT_TEXT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG
        });
        setReplaceText(text);
    };
    const handleReplaceKeyDown = (event)=>skipWhileComposing(()=>{
            if (event.key === 'Enter') onReplace({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD,
                replaceText: replaceText
            });
            else if (event.key === 'ArrowUp') onArrowUp();
        });
    const handleReplaceAllClick = ()=>skipWhileComposing(()=>{
            onReplaceAll({
                replaceText: replaceText
            });
            setIsHelperMessageVisible(true);
            if (count.totalReplaceable && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                triggerSuccessReplacementMessageUpdate(count.totalReplaceable);
                setReplaceCount(count.totalReplaceable);
            } else {
                triggerSuccessReplacementMessageUpdate(count.total);
                setReplaceCount(count.total);
            }
            setFindTyped(false);
        });
    const handleCompositionStart = ()=>{
        setIsComposing(true);
    };
    const handleCompositionEnd = (event)=>{
        setIsComposing(false);
        // type for React.CompositionEvent doesn't set type for target correctly
        updateReplaceValue(event.target.value);
    };
    const clearSearch = ()=>{
        onCancel({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
        focusToolbarButton();
    };
    const handleFindNextClick = ()=>{
        if (!isComposing) onFindNext({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
    };
    const handleFindPrevClick = ()=>{
        if (!isComposing) onFindPrev({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
    };
    const resultsReplace = formatMessage((0, $lzn6v.findReplaceMessages).replaceSuccess, {
        numberOfMatches: replaceCount
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $c7ca968779a672f3$var$replaceContainerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c7ca968779a672f3$var$replaceWithLabelStyle,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    id: "replace-text-field-label",
                    size: "medium",
                    weight: "bold",
                    color: "color.text.subtle",
                    children: replaceWith
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                name: "replace",
                "aria-labelledby": "replace-text-field-label",
                testId: "replace-field",
                appearance: "standard",
                defaultValue: replaceText,
                ref: replaceTextfieldRef,
                autoComplete: "off",
                onChange: handleReplaceChange,
                onKeyDown: handleReplaceKeyDown,
                onCompositionStart: handleCompositionStart,
                onCompositionEnd: handleCompositionEnd
            }),
            isHelperMessageVisible && !findTyped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: successReplacementMessageRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ValidMessage), {
                    testId: "message-success-replacement",
                    children: fakeSuccessReplacementMessageUpdate ? // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    resultsReplace.replace(/ /u, '\u00a0') : resultsReplace
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c7ca968779a672f3$var$actionButtonContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    xcss: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? [
                        $c7ca968779a672f3$var$actionButtonInlineStyles,
                        $c7ca968779a672f3$var$actionButtonParentInlineStylesNew
                    ] : [
                        $c7ca968779a672f3$var$actionButtonInlineStyles,
                        $c7ca968779a672f3$var$actionButtonParentInlineStyles
                    ],
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            xcss: $c7ca968779a672f3$var$actionButtonInlineStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
                                    title: formatMessage((0, $lzn6v.findReplaceMessages).findNext),
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: formatMessage((0, $lzn6v.findReplaceMessages).findNext),
                                    keymapDescription: 'Enter',
                                    onClick: handleFindNextClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
                                    title: findPrevious,
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: findPrevious,
                                    keymapDescription: 'Shift Enter',
                                    onClick: handleFindPrevClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    testId: 'Replace',
                                    id: "replace-button",
                                    onClick: handleReplaceClick,
                                    isDisabled: !canReplace,
                                    children: formatMessage((0, $lzn6v.findReplaceMessages).replace)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "primary",
                                    testId: replaceAll,
                                    id: "replaceAll-button",
                                    onClick: handleReplaceAllClick,
                                    isDisabled: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? count.totalReplaceable === 0 : !canReplace,
                                    children: replaceAll
                                })
                            ]
                        }),
                        (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                            xcss: $c7ca968779a672f3$var$closeButtonInlineStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                testId: closeFindReplaceDialog,
                                onClick: clearSearch,
                                children: closeFindReplaceDialog
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            testId: closeFindReplaceDialog,
                            onClick: clearSearch,
                            children: closeFindReplaceDialog
                        })
                    ]
                })
            })
        ]
    });
};
var $c7ca968779a672f3$export$2e2bcd8739ae039 = (0, $gmMgo.default)($c7ca968779a672f3$var$Replace);



// eslint-disable-next-line @repo/internal/react/no-class-components
class $a6441227f3fef772$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { findText: findText, count: count, isReplaceable: isReplaceable, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase, intl: intl } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            role: 'dialog',
            "aria-label": (0, $dh538.fg)('platform_editor_dec_a11y_fixes') ? intl?.formatMessage((0, $lzn6v.findReplaceMessages).findReplaceDialogAriaLabel) : 'Find and Replace',
            "aria-modal": false,
            ref: this.modalRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $6f19b0f678d47301$export$491e6397d7c1480b),
                (0, $6f19b0f678d47301$export$263284dac1af2f8a)
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f64d7eaf6f543352$export$2e2bcd8739ae039), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("hr", {
            role: "presentation",
            css: (0, $6f19b0f678d47301$export$2413e968422424ec),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c7ca968779a672f3$export$2e2bcd8739ae039), {
            canReplace: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? !!isReplaceable : count.total > 0,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        }));
    }
    constructor(props){
        super(props);
        this.findTextfield = null;
        this.replaceTextfield = null;
        this.modalRef = void 0;
        this.state = {
            findTyped: false
        };
        this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        };
        this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        };
        this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        };
        this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        };
        this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
var $a6441227f3fef772$export$2e2bcd8739ae039 = $a6441227f3fef772$var$FindReplace;


const $f0283781bba03353$var$findReplaceWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
// Magic number taken from ../FindReplaceToolbarButton.tsx
const $f0283781bba03353$var$dropdownWidthNewDesign = 382;
const $f0283781bba03353$var$FindReplaceDropdown = (props)=>{
    const { findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, popupsMountPoint: popupsMountPoint, numReplaceable: numReplaceable, onCancel: onCancel } = props;
    if (!popupsMountPoint) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6qITU.default), {
        target: popupsMountPoint,
        mountTo: popupsMountPoint,
        forcePlacement: true,
        alignX: 'right',
        alignY: 'start',
        offset: [
            4,
            0
        ],
        isOpen: isActive,
        handleEscapeKeydown: ()=>{
            if (isActive) onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
            });
        },
        fitWidth: $f0283781bba03353$var$dropdownWidthNewDesign,
        zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: true
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $f0283781bba03353$var$findReplaceWrapperStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a6441227f3fef772$export$2e2bcd8739ae039), {
                findText: findText,
                replaceText: replaceText,
                count: {
                    index: index,
                    total: numMatches,
                    totalReplaceable: numReplaceable
                },
                ...props
            })
        })
    });
};
var $f0283781bba03353$export$2e2bcd8739ae039 = (0, $gmMgo.default)($f0283781bba03353$var$FindReplaceDropdown);


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






















var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");





var $jluld = parcelRequire("jluld");





function $5b4854d00022f7d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $5b4854d00022f7d3$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $9K4OG.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $aFUXX.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $5b4854d00022f7d3$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $9K4OG.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $5b4854d00022f7d3$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $5b4854d00022f7d3$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $5b4854d00022f7d3$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $5b4854d00022f7d3$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $5b4854d00022f7d3$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, numReplaceable: numReplaceable, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $lzn6v.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $aFUXX.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $hgeg8.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                $5b4854d00022f7d3$var$toolbarButtonWrapper,
                takeFullWidth && $5b4854d00022f7d3$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') && $5b4854d00022f7d3$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6qITU.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $5b4854d00022f7d3$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            arrowKeyNavigationProviderOptions: {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? /*#__PURE__*/ (0, $9K4OG.jsx)($5b4854d00022f7d3$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
                buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $hgeg8.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
                buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $hgeg8.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $5b4854d00022f7d3$var$wrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a6441227f3fef772$export$2e2bcd8739ae039), {
            findText: findText,
            replaceText: replaceText,
            count: {
                index: index,
                total: numMatches,
                totalReplaceable: numReplaceable
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            openedByClick: false
        };
        this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        };
        this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        };
        this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
var $5b4854d00022f7d3$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5b4854d00022f7d3$var$FindReplaceToolbarButton);


// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $325a0911b0fccbbc$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $42omo.useState)(api?.findReplace?.sharedState.currentState());
    (0, $42omo.useLayoutEffect)(()=>{
        const unsub = api?.findReplace?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $325a0911b0fccbbc$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden, doesNotHaveButton: doesNotHaveButton })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { findReplaceState: findReplaceState } = $325a0911b0fccbbc$var$useSharedPluginStateNoDebounce(api);
    const shouldMatchCase = findReplaceState?.shouldMatchCase;
    const isActive = findReplaceState?.isActive;
    const findText = findReplaceState?.findText;
    const replaceText = findReplaceState?.replaceText;
    const index = findReplaceState?.index;
    const matches = findReplaceState?.matches;
    const shouldFocus = findReplaceState?.shouldFocus;
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement?.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$a1f845c5f9c28dec)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$da0da8f66917d4cd)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$67b10f9d7f5c44e1)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$95c81501036a7f64)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$99b6462294b19fcd)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $92ce31c77152d962$export$2cc7ff91bcacba5e)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $11e7df9f05f7da42$export$330be886194dc3c6)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $92ce31c77152d962$export$4e987d48fa8a04d7)());
    };
    if (shouldMatchCase === undefined || isActive === undefined || findText === undefined || replaceText === undefined || index === undefined || matches === undefined || shouldFocus === undefined) return null;
    const DropDownComponent = doesNotHaveButton ? (0, $f0283781bba03353$export$2e2bcd8739ae039) : (0, $5b4854d00022f7d3$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $l998X.jsx)(DropDownComponent, {
        shouldMatchCase: shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: isActive,
        findText: findText,
        index: index,
        numMatches: matches.length,
        isReplaceable: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? matches[index]?.canReplace : undefined,
        numReplaceable: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? matches.filter((match)=>match.canReplace === true).length : undefined,
        replaceText: replaceText,
        shouldFocus: shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden
    });
};
var $325a0911b0fccbbc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($325a0911b0fccbbc$var$FindReplaceToolbarButtonWithState);


const $1a62205aee226efe$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const toolbarButtonRegisteredExternally = {
        current: false
    };
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        const isButtonHidden = (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? toolbarSize < (0, $zMjD6.ToolbarSize).XL : false;
        if (props?.twoLineEditorToolbar) return null;
        else if (toolbarButtonRegisteredExternally.current && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return null;
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props?.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            const plugins = [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $797013ea47834520$export$ae829ec7b2625219)(dispatch, getIntl, api)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>(0, $0cc9e4cfac335e7b$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'findReplaceEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $1S4f7.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $e8b1b385096c80fd$export$e7697da71e34f0a6).getState(editorState) || undefined;
        },
        actions: {
            registerToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                toolbarButtonRegisteredExternally.current = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            },
            activateFindReplace: (triggerMethod)=>{
                if (!editorViewRef.current) return false;
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                if (api?.analytics?.actions) (0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(api?.analytics?.actions)({
                    triggerMethod: triggerMethod || (0, $d925B.TRIGGER_METHOD).EXTERNAL
                })(state, dispatch);
                else (0, $92ce31c77152d962$export$234c45b355edd85b)()(state, dispatch);
                return true;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        contentComponent: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
            if (toolbarButtonRegisteredExternally.current || !editorView) return null;
            const popupsMountPointEl = popupsMountPoint || // eslint-disable-next-line @atlaskit/editor/no-as-casting
            wrapperElement?.querySelector("[data-editor-container='true']");
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPointEl,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined,
                isToolbarReducedSpacing: false,
                editorView: editorView,
                containerElement: containerElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                takeFullWidth: props?.takeFullWidth,
                api: api,
                doesNotHaveButton: true
            });
        } : undefined
    };
};
module.exports["findReplacePlugin"] = $1a62205aee226efe$export$e5ceda4aabe9bb08;

});

parcelRegister("6q6xk", function(module, exports) {

var $jTb2k = parcelRequire("jTb2k");

/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $fO7hX = parcelRequire("fO7hX");


var $1S4f7 = parcelRequire("1S4f7");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");

const $4a71249a4b84ed5d$var$pluginKey = new (0, $ks2lK.PluginKey)('fragmentMarkConsistencyPlugin');
const $4a71249a4b84ed5d$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $4a71249a4b84ed5d$export$ae829ec7b2625219 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        key: $4a71249a4b84ed5d$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $4a71249a4b84ed5d$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $2pjJ5.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $fO7hX.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });


const $bf157b4cb7a600ae$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $jTb2k.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $4a71249a4b84ed5d$export$ae829ec7b2625219)(dispatch)
                }
            ];
        }
    });
module.exports["fragmentPlugin"] = $bf157b4cb7a600ae$export$36fc1707093eff41;

});

parcelRegister("1nZXu", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1nZXu = parcelRequire("1nZXu");

const $b87598ef7fd9944b$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $1nZXu.pluginKey), {
        changed: true
    });


const $1751bdac665e8ba7$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('contextPanelPluginKey');
function $1751bdac665e8ba7$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: $1751bdac665e8ba7$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($1751bdac665e8ba7$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                    const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                    if (contentsLengthChanged || contentChanged) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($1751bdac665e8ba7$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $1751bdac665e8ba7$export$773ed6f43b4b1d8f = ({ config: config })=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $b87598ef7fd9944b$export$6fbe08f3dbfbccb2),
            showPanel: config?.objectSideBar.showPanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (panel, behavior, panelWidth)=>config.objectSideBar.showPanel(panel, behavior, panelWidth) : undefined,
            closePanel: config?.objectSideBar.closePanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? ()=>config.objectSideBar.closePanel() : undefined,
            closePanelById: config?.objectSideBar.closePanelById && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (id)=>config.objectSideBar.closePanelById(id) : undefined
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $1751bdac665e8ba7$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$1751bdac665e8ba7$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });
module.exports["pluginKey"] = $1751bdac665e8ba7$export$18d4026d1ea86bb1;
module.exports["contextPanelPlugin"] = $1751bdac665e8ba7$export$773ed6f43b4b1d8f;

});

parcelRegister("ccx2d", function(module, exports) {
var $b1c12d06bb4fd9ca$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var $b1c12d06bb4fd9ca$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b1c12d06bb4fd9ca$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
var $b1c12d06bb4fd9ca$export$2e2bcd8739ae039 = $b1c12d06bb4fd9ca$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $e019b26b59011d07$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $e019b26b59011d07$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e019b26b59011d07$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e019b26b59011d07$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $e019b26b59011d07$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $e019b26b59011d07$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $e019b26b59011d07$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e019b26b59011d07$export$2e2bcd8739ae039 = $e019b26b59011d07$var$formatLong;


var $9e1a6fecf29d8641$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $9e1a6fecf29d8641$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9e1a6fecf29d8641$var$formatRelativeLocale[token];
};
var $9e1a6fecf29d8641$export$2e2bcd8739ae039 = $9e1a6fecf29d8641$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $bdadd0be50045449$var$eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $bdadd0be50045449$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var $bdadd0be50045449$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $bdadd0be50045449$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var $bdadd0be50045449$var$dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var $bdadd0be50045449$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var $bdadd0be50045449$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var $bdadd0be50045449$var$localize = {
    ordinalNumber: $bdadd0be50045449$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $bdadd0be50045449$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $bdadd0be50045449$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $bdadd0be50045449$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $bdadd0be50045449$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $bdadd0be50045449$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $bdadd0be50045449$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bdadd0be50045449$export$2e2bcd8739ae039 = $bdadd0be50045449$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2320154a06b9bda1$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $2320154a06b9bda1$var$parseOrdinalNumberPattern = /\d+/i;
var $2320154a06b9bda1$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $2320154a06b9bda1$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $2320154a06b9bda1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $2320154a06b9bda1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2320154a06b9bda1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $2320154a06b9bda1$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $2320154a06b9bda1$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $2320154a06b9bda1$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $2320154a06b9bda1$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $2320154a06b9bda1$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $2320154a06b9bda1$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2320154a06b9bda1$var$matchOrdinalNumberPattern,
        parsePattern: $2320154a06b9bda1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2320154a06b9bda1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2320154a06b9bda1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2320154a06b9bda1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2320154a06b9bda1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2320154a06b9bda1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2320154a06b9bda1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2320154a06b9bda1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2320154a06b9bda1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2320154a06b9bda1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2320154a06b9bda1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2320154a06b9bda1$export$2e2bcd8739ae039 = $2320154a06b9bda1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $8e203b0a42c0232a$var$locale = {
    code: 'af',
    formatDistance: (0, $b1c12d06bb4fd9ca$export$2e2bcd8739ae039),
    formatLong: (0, $e019b26b59011d07$export$2e2bcd8739ae039),
    formatRelative: (0, $9e1a6fecf29d8641$export$2e2bcd8739ae039),
    localize: (0, $bdadd0be50045449$export$2e2bcd8739ae039),
    match: (0, $2320154a06b9bda1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8e203b0a42c0232a$export$2e2bcd8739ae039 = $8e203b0a42c0232a$var$locale;
module.exports["default"] = $8e203b0a42c0232a$export$2e2bcd8739ae039;

});

parcelRegister("cAsrS", function(module, exports) {
var $62a9f7801b0a7bed$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var $62a9f7801b0a7bed$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $62a9f7801b0a7bed$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $62a9f7801b0a7bed$export$2e2bcd8739ae039 = $62a9f7801b0a7bed$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $3e4463ca081d6fd7$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $3e4463ca081d6fd7$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3e4463ca081d6fd7$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3e4463ca081d6fd7$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $3e4463ca081d6fd7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $3e4463ca081d6fd7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $3e4463ca081d6fd7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3e4463ca081d6fd7$export$2e2bcd8739ae039 = $3e4463ca081d6fd7$var$formatLong;


var $47585cb8c9ffc8c7$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $47585cb8c9ffc8c7$var$formatRelative = function formatRelative(token) {
    return $47585cb8c9ffc8c7$var$formatRelativeLocale[token];
};
var $47585cb8c9ffc8c7$export$2e2bcd8739ae039 = $47585cb8c9ffc8c7$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $88f3e52dd36c28ea$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $88f3e52dd36c28ea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $88f3e52dd36c28ea$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $88f3e52dd36c28ea$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $88f3e52dd36c28ea$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $88f3e52dd36c28ea$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $88f3e52dd36c28ea$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $88f3e52dd36c28ea$var$localize = {
    ordinalNumber: $88f3e52dd36c28ea$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $88f3e52dd36c28ea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $88f3e52dd36c28ea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $88f3e52dd36c28ea$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $88f3e52dd36c28ea$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $88f3e52dd36c28ea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $88f3e52dd36c28ea$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $88f3e52dd36c28ea$export$2e2bcd8739ae039 = $88f3e52dd36c28ea$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $0524ea8f920d8119$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0524ea8f920d8119$var$parseOrdinalNumberPattern = /\d+/i;
var $0524ea8f920d8119$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $0524ea8f920d8119$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $0524ea8f920d8119$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $0524ea8f920d8119$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0524ea8f920d8119$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $0524ea8f920d8119$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $0524ea8f920d8119$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $0524ea8f920d8119$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $0524ea8f920d8119$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $0524ea8f920d8119$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $0524ea8f920d8119$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $0524ea8f920d8119$var$matchOrdinalNumberPattern,
        parsePattern: $0524ea8f920d8119$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $0524ea8f920d8119$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0524ea8f920d8119$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $0524ea8f920d8119$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0524ea8f920d8119$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $0524ea8f920d8119$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0524ea8f920d8119$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $0524ea8f920d8119$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0524ea8f920d8119$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $0524ea8f920d8119$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0524ea8f920d8119$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0524ea8f920d8119$export$2e2bcd8739ae039 = $0524ea8f920d8119$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $929eea1d11ae8258$var$locale = {
    code: 'ar',
    formatDistance: (0, $62a9f7801b0a7bed$export$2e2bcd8739ae039),
    formatLong: (0, $3e4463ca081d6fd7$export$2e2bcd8739ae039),
    formatRelative: (0, $47585cb8c9ffc8c7$export$2e2bcd8739ae039),
    localize: (0, $88f3e52dd36c28ea$export$2e2bcd8739ae039),
    match: (0, $0524ea8f920d8119$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $929eea1d11ae8258$export$2e2bcd8739ae039 = $929eea1d11ae8258$var$locale;
module.exports["default"] = $929eea1d11ae8258$export$2e2bcd8739ae039;

});

parcelRegister("6wu0n", function(module, exports) {
var $5d6d0c92e25a7680$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $5d6d0c92e25a7680$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $5d6d0c92e25a7680$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $5d6d0c92e25a7680$export$2e2bcd8739ae039 = $5d6d0c92e25a7680$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $e12ba167839218bd$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $e12ba167839218bd$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e12ba167839218bd$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e12ba167839218bd$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $e12ba167839218bd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $e12ba167839218bd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $e12ba167839218bd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e12ba167839218bd$export$2e2bcd8739ae039 = $e12ba167839218bd$var$formatLong;


var $4e6b1f72d887106a$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $4e6b1f72d887106a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4e6b1f72d887106a$var$formatRelativeLocale[token];
};
var $4e6b1f72d887106a$export$2e2bcd8739ae039 = $4e6b1f72d887106a$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $178dd5c224a103a3$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $178dd5c224a103a3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $178dd5c224a103a3$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $178dd5c224a103a3$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $178dd5c224a103a3$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $178dd5c224a103a3$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $178dd5c224a103a3$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $178dd5c224a103a3$var$localize = {
    ordinalNumber: $178dd5c224a103a3$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $178dd5c224a103a3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $178dd5c224a103a3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $178dd5c224a103a3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $178dd5c224a103a3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $178dd5c224a103a3$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $178dd5c224a103a3$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $178dd5c224a103a3$export$2e2bcd8739ae039 = $178dd5c224a103a3$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $cb8de2dec8d6a530$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $cb8de2dec8d6a530$var$parseOrdinalNumberPattern = /\d+/i;
var $cb8de2dec8d6a530$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $cb8de2dec8d6a530$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $cb8de2dec8d6a530$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $cb8de2dec8d6a530$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cb8de2dec8d6a530$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $cb8de2dec8d6a530$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $cb8de2dec8d6a530$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $cb8de2dec8d6a530$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $cb8de2dec8d6a530$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $cb8de2dec8d6a530$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $cb8de2dec8d6a530$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $cb8de2dec8d6a530$var$matchOrdinalNumberPattern,
        parsePattern: $cb8de2dec8d6a530$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $cb8de2dec8d6a530$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cb8de2dec8d6a530$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $cb8de2dec8d6a530$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cb8de2dec8d6a530$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $cb8de2dec8d6a530$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cb8de2dec8d6a530$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $cb8de2dec8d6a530$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cb8de2dec8d6a530$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $cb8de2dec8d6a530$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $cb8de2dec8d6a530$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $cb8de2dec8d6a530$export$2e2bcd8739ae039 = $cb8de2dec8d6a530$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $4bfd019e72819643$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $5d6d0c92e25a7680$export$2e2bcd8739ae039),
    formatLong: (0, $e12ba167839218bd$export$2e2bcd8739ae039),
    formatRelative: (0, $4e6b1f72d887106a$export$2e2bcd8739ae039),
    localize: (0, $178dd5c224a103a3$export$2e2bcd8739ae039),
    match: (0, $cb8de2dec8d6a530$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $4bfd019e72819643$export$2e2bcd8739ae039 = $4bfd019e72819643$var$locale;
module.exports["default"] = $4bfd019e72819643$export$2e2bcd8739ae039;

});

parcelRegister("hWVUZ", function(module, exports) {
var $834388dce7871270$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var $834388dce7871270$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $834388dce7871270$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
var $834388dce7871270$export$2e2bcd8739ae039 = $834388dce7871270$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $46aabd1e9798d9aa$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var $46aabd1e9798d9aa$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $46aabd1e9798d9aa$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $46aabd1e9798d9aa$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $46aabd1e9798d9aa$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $46aabd1e9798d9aa$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $46aabd1e9798d9aa$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $46aabd1e9798d9aa$export$2e2bcd8739ae039 = $46aabd1e9798d9aa$var$formatLong;


var $c62ba66199ea3509$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $c62ba66199ea3509$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c62ba66199ea3509$var$formatRelativeLocale[token];
};
var $c62ba66199ea3509$export$2e2bcd8739ae039 = $c62ba66199ea3509$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $16e671e2d7ae7aae$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $16e671e2d7ae7aae$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $16e671e2d7ae7aae$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $16e671e2d7ae7aae$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $16e671e2d7ae7aae$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $16e671e2d7ae7aae$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $16e671e2d7ae7aae$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $16e671e2d7ae7aae$var$localize = {
    ordinalNumber: $16e671e2d7ae7aae$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $16e671e2d7ae7aae$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $16e671e2d7ae7aae$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $16e671e2d7ae7aae$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $16e671e2d7ae7aae$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $16e671e2d7ae7aae$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $16e671e2d7ae7aae$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $16e671e2d7ae7aae$export$2e2bcd8739ae039 = $16e671e2d7ae7aae$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $dc58fcce4913d42a$var$matchOrdinalNumberPattern = /^(\d+)/;
var $dc58fcce4913d42a$var$parseOrdinalNumberPattern = /\d+/i;
var $dc58fcce4913d42a$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $dc58fcce4913d42a$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $dc58fcce4913d42a$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $dc58fcce4913d42a$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $dc58fcce4913d42a$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $dc58fcce4913d42a$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $dc58fcce4913d42a$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $dc58fcce4913d42a$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $dc58fcce4913d42a$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $dc58fcce4913d42a$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $dc58fcce4913d42a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $dc58fcce4913d42a$var$matchOrdinalNumberPattern,
        parsePattern: $dc58fcce4913d42a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $dc58fcce4913d42a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc58fcce4913d42a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $dc58fcce4913d42a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc58fcce4913d42a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $dc58fcce4913d42a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc58fcce4913d42a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $dc58fcce4913d42a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc58fcce4913d42a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $dc58fcce4913d42a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dc58fcce4913d42a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dc58fcce4913d42a$export$2e2bcd8739ae039 = $dc58fcce4913d42a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $d114c7c4def53286$var$locale = {
    code: 'ar-EG',
    formatDistance: (0, $834388dce7871270$export$2e2bcd8739ae039),
    formatLong: (0, $46aabd1e9798d9aa$export$2e2bcd8739ae039),
    formatRelative: (0, $c62ba66199ea3509$export$2e2bcd8739ae039),
    localize: (0, $16e671e2d7ae7aae$export$2e2bcd8739ae039),
    match: (0, $dc58fcce4913d42a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d114c7c4def53286$export$2e2bcd8739ae039 = $d114c7c4def53286$var$locale;
module.exports["default"] = $d114c7c4def53286$export$2e2bcd8739ae039;

});

parcelRegister("7hwNo", function(module, exports) {
var $0c776882f85fb7ec$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $0c776882f85fb7ec$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $0c776882f85fb7ec$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $0c776882f85fb7ec$export$2e2bcd8739ae039 = $0c776882f85fb7ec$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $2ba6db271eaf5e32$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $2ba6db271eaf5e32$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $2ba6db271eaf5e32$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2ba6db271eaf5e32$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $2ba6db271eaf5e32$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $2ba6db271eaf5e32$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $2ba6db271eaf5e32$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2ba6db271eaf5e32$export$2e2bcd8739ae039 = $2ba6db271eaf5e32$var$formatLong;


var $1802c2690c24363e$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $1802c2690c24363e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1802c2690c24363e$var$formatRelativeLocale[token];
};
var $1802c2690c24363e$export$2e2bcd8739ae039 = $1802c2690c24363e$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $b5eb78ac3ad53303$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $b5eb78ac3ad53303$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $b5eb78ac3ad53303$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var $b5eb78ac3ad53303$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $b5eb78ac3ad53303$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $b5eb78ac3ad53303$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b5eb78ac3ad53303$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $b5eb78ac3ad53303$var$localize = {
    ordinalNumber: $b5eb78ac3ad53303$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $b5eb78ac3ad53303$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $b5eb78ac3ad53303$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $b5eb78ac3ad53303$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $b5eb78ac3ad53303$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $b5eb78ac3ad53303$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b5eb78ac3ad53303$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b5eb78ac3ad53303$export$2e2bcd8739ae039 = $b5eb78ac3ad53303$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $986fc269b83d752c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $986fc269b83d752c$var$parseOrdinalNumberPattern = /\d+/i;
var $986fc269b83d752c$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $986fc269b83d752c$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $986fc269b83d752c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $986fc269b83d752c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $986fc269b83d752c$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $986fc269b83d752c$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $986fc269b83d752c$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $986fc269b83d752c$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $986fc269b83d752c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $986fc269b83d752c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $986fc269b83d752c$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $986fc269b83d752c$var$matchOrdinalNumberPattern,
        parsePattern: $986fc269b83d752c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $986fc269b83d752c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $986fc269b83d752c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $986fc269b83d752c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $986fc269b83d752c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $986fc269b83d752c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $986fc269b83d752c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $986fc269b83d752c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $986fc269b83d752c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $986fc269b83d752c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $986fc269b83d752c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $986fc269b83d752c$export$2e2bcd8739ae039 = $986fc269b83d752c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $54d38f7eb763ba25$var$locale = {
    code: 'ar-MA',
    formatDistance: (0, $0c776882f85fb7ec$export$2e2bcd8739ae039),
    formatLong: (0, $2ba6db271eaf5e32$export$2e2bcd8739ae039),
    formatRelative: (0, $1802c2690c24363e$export$2e2bcd8739ae039),
    localize: (0, $b5eb78ac3ad53303$export$2e2bcd8739ae039),
    match: (0, $986fc269b83d752c$export$2e2bcd8739ae039),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $54d38f7eb763ba25$export$2e2bcd8739ae039 = $54d38f7eb763ba25$var$locale;
module.exports["default"] = $54d38f7eb763ba25$export$2e2bcd8739ae039;

});

parcelRegister("hVIfN", function(module, exports) {
var $77bc0eaece8b2970$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $77bc0eaece8b2970$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $77bc0eaece8b2970$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $77bc0eaece8b2970$export$2e2bcd8739ae039 = $77bc0eaece8b2970$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $ae1c5afd5aab7da4$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $ae1c5afd5aab7da4$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $ae1c5afd5aab7da4$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ae1c5afd5aab7da4$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $ae1c5afd5aab7da4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $ae1c5afd5aab7da4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $ae1c5afd5aab7da4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ae1c5afd5aab7da4$export$2e2bcd8739ae039 = $ae1c5afd5aab7da4$var$formatLong;


var $f4131fc6ff13af39$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $f4131fc6ff13af39$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f4131fc6ff13af39$var$formatRelativeLocale[token];
};
var $f4131fc6ff13af39$export$2e2bcd8739ae039 = $f4131fc6ff13af39$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8ebcd324e876d542$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $8ebcd324e876d542$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $8ebcd324e876d542$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $8ebcd324e876d542$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $8ebcd324e876d542$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $8ebcd324e876d542$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $8ebcd324e876d542$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $8ebcd324e876d542$var$localize = {
    ordinalNumber: $8ebcd324e876d542$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8ebcd324e876d542$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8ebcd324e876d542$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8ebcd324e876d542$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8ebcd324e876d542$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8ebcd324e876d542$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8ebcd324e876d542$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8ebcd324e876d542$export$2e2bcd8739ae039 = $8ebcd324e876d542$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $bbc382ec12fab0ea$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $bbc382ec12fab0ea$var$parseOrdinalNumberPattern = /\d+/i;
var $bbc382ec12fab0ea$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $bbc382ec12fab0ea$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $bbc382ec12fab0ea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $bbc382ec12fab0ea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bbc382ec12fab0ea$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $bbc382ec12fab0ea$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $bbc382ec12fab0ea$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $bbc382ec12fab0ea$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $bbc382ec12fab0ea$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $bbc382ec12fab0ea$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $bbc382ec12fab0ea$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $bbc382ec12fab0ea$var$matchOrdinalNumberPattern,
        parsePattern: $bbc382ec12fab0ea$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $bbc382ec12fab0ea$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bbc382ec12fab0ea$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $bbc382ec12fab0ea$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bbc382ec12fab0ea$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $bbc382ec12fab0ea$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bbc382ec12fab0ea$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $bbc382ec12fab0ea$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bbc382ec12fab0ea$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $bbc382ec12fab0ea$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $bbc382ec12fab0ea$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $bbc382ec12fab0ea$export$2e2bcd8739ae039 = $bbc382ec12fab0ea$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $d0da16708977d825$var$locale = {
    code: 'ar-SA',
    formatDistance: (0, $77bc0eaece8b2970$export$2e2bcd8739ae039),
    formatLong: (0, $ae1c5afd5aab7da4$export$2e2bcd8739ae039),
    formatRelative: (0, $f4131fc6ff13af39$export$2e2bcd8739ae039),
    localize: (0, $8ebcd324e876d542$export$2e2bcd8739ae039),
    match: (0, $bbc382ec12fab0ea$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d0da16708977d825$export$2e2bcd8739ae039 = $d0da16708977d825$var$locale;
module.exports["default"] = $d0da16708977d825$export$2e2bcd8739ae039;

});

parcelRegister("ejvVa", function(module, exports) {
var $8d547c784093ae12$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var $8d547c784093ae12$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $8d547c784093ae12$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
var $8d547c784093ae12$export$2e2bcd8739ae039 = $8d547c784093ae12$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $61919be28a424cb0$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $61919be28a424cb0$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $61919be28a424cb0$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $61919be28a424cb0$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $61919be28a424cb0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $61919be28a424cb0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $61919be28a424cb0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $61919be28a424cb0$export$2e2bcd8739ae039 = $61919be28a424cb0$var$formatLong;


var $6aee70d1eb453dfc$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var $6aee70d1eb453dfc$var$formatRelative = function formatRelative(token) {
    return $6aee70d1eb453dfc$var$formatRelativeLocale[token];
};
var $6aee70d1eb453dfc$export$2e2bcd8739ae039 = $6aee70d1eb453dfc$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $d07471379e2bac50$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $d07471379e2bac50$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $d07471379e2bac50$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $d07471379e2bac50$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $d07471379e2bac50$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $d07471379e2bac50$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $d07471379e2bac50$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $d07471379e2bac50$var$localize = {
    ordinalNumber: $d07471379e2bac50$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $d07471379e2bac50$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $d07471379e2bac50$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $d07471379e2bac50$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $d07471379e2bac50$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $d07471379e2bac50$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d07471379e2bac50$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d07471379e2bac50$export$2e2bcd8739ae039 = $d07471379e2bac50$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $dcc956cfaa83210d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $dcc956cfaa83210d$var$parseOrdinalNumberPattern = /\d+/i;
var $dcc956cfaa83210d$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $dcc956cfaa83210d$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $dcc956cfaa83210d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $dcc956cfaa83210d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dcc956cfaa83210d$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $dcc956cfaa83210d$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $dcc956cfaa83210d$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $dcc956cfaa83210d$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $dcc956cfaa83210d$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $dcc956cfaa83210d$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $dcc956cfaa83210d$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $dcc956cfaa83210d$var$matchOrdinalNumberPattern,
        parsePattern: $dcc956cfaa83210d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $dcc956cfaa83210d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcc956cfaa83210d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $dcc956cfaa83210d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcc956cfaa83210d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $dcc956cfaa83210d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcc956cfaa83210d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $dcc956cfaa83210d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcc956cfaa83210d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $dcc956cfaa83210d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dcc956cfaa83210d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dcc956cfaa83210d$export$2e2bcd8739ae039 = $dcc956cfaa83210d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $a6bb99df21d89587$var$locale = {
    code: 'ar-TN',
    formatDistance: (0, $8d547c784093ae12$export$2e2bcd8739ae039),
    formatLong: (0, $61919be28a424cb0$export$2e2bcd8739ae039),
    formatRelative: (0, $6aee70d1eb453dfc$export$2e2bcd8739ae039),
    localize: (0, $d07471379e2bac50$export$2e2bcd8739ae039),
    match: (0, $dcc956cfaa83210d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $a6bb99df21d89587$export$2e2bcd8739ae039 = $a6bb99df21d89587$var$locale;
module.exports["default"] = $a6bb99df21d89587$export$2e2bcd8739ae039;

});

parcelRegister("gV1cj", function(module, exports) {
var $aa44176f8594c562$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var $aa44176f8594c562$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $aa44176f8594c562$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
var $aa44176f8594c562$export$2e2bcd8739ae039 = $aa44176f8594c562$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $814837c5001e2f7a$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var $814837c5001e2f7a$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $814837c5001e2f7a$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $814837c5001e2f7a$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $814837c5001e2f7a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $814837c5001e2f7a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $814837c5001e2f7a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $814837c5001e2f7a$export$2e2bcd8739ae039 = $814837c5001e2f7a$var$formatLong;


var $43b2b2b012b93850$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var $43b2b2b012b93850$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $43b2b2b012b93850$var$formatRelativeLocale[token];
};
var $43b2b2b012b93850$export$2e2bcd8739ae039 = $43b2b2b012b93850$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $349e263f6928f081$var$eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var $349e263f6928f081$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $349e263f6928f081$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $349e263f6928f081$var$dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var $349e263f6928f081$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $349e263f6928f081$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $349e263f6928f081$var$suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var $349e263f6928f081$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($349e263f6928f081$var$suffixes[a]) return $349e263f6928f081$var$suffixes[a];
    else if ($349e263f6928f081$var$suffixes[b]) return $349e263f6928f081$var$suffixes[b];
    else if (c !== null) return $349e263f6928f081$var$suffixes[c];
    return '';
};
var $349e263f6928f081$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $349e263f6928f081$var$getSuffix(number);
    return number + suffix;
};
var $349e263f6928f081$var$localize = {
    ordinalNumber: $349e263f6928f081$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $349e263f6928f081$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $349e263f6928f081$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $349e263f6928f081$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $349e263f6928f081$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $349e263f6928f081$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $349e263f6928f081$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $349e263f6928f081$export$2e2bcd8739ae039 = $349e263f6928f081$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $810dfd5af27def46$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $810dfd5af27def46$var$parseOrdinalNumberPattern = /\d+/i;
var $810dfd5af27def46$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $810dfd5af27def46$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $810dfd5af27def46$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $810dfd5af27def46$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $810dfd5af27def46$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $810dfd5af27def46$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $810dfd5af27def46$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $810dfd5af27def46$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $810dfd5af27def46$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $810dfd5af27def46$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $810dfd5af27def46$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $810dfd5af27def46$var$matchOrdinalNumberPattern,
        parsePattern: $810dfd5af27def46$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $810dfd5af27def46$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $810dfd5af27def46$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $810dfd5af27def46$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $810dfd5af27def46$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $810dfd5af27def46$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $810dfd5af27def46$var$parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $810dfd5af27def46$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $810dfd5af27def46$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $810dfd5af27def46$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $810dfd5af27def46$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $810dfd5af27def46$export$2e2bcd8739ae039 = $810dfd5af27def46$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $c512e6077fc14aa6$var$locale = {
    code: 'az',
    formatDistance: (0, $aa44176f8594c562$export$2e2bcd8739ae039),
    formatLong: (0, $814837c5001e2f7a$export$2e2bcd8739ae039),
    formatRelative: (0, $43b2b2b012b93850$export$2e2bcd8739ae039),
    localize: (0, $349e263f6928f081$export$2e2bcd8739ae039),
    match: (0, $810dfd5af27def46$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $c512e6077fc14aa6$export$2e2bcd8739ae039 = $c512e6077fc14aa6$var$locale;
module.exports["default"] = $c512e6077fc14aa6$export$2e2bcd8739ae039;

});

parcelRegister("kZaIb", function(module, exports) {
function $bef4b0417cd0a974$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $bef4b0417cd0a974$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $bef4b0417cd0a974$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $bef4b0417cd0a974$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $bef4b0417cd0a974$var$declension(scheme.past, count);
                else return $bef4b0417cd0a974$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $bef4b0417cd0a974$var$declension(scheme.regular, count);
    };
}
var $bef4b0417cd0a974$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $bef4b0417cd0a974$var$formatDistanceLocale = {
    lessThanXSeconds: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $bef4b0417cd0a974$var$halfAMinute,
    lessThanXMinutes: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $bef4b0417cd0a974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $bef4b0417cd0a974$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $bef4b0417cd0a974$var$formatDistanceLocale[token](count, options);
};
var $bef4b0417cd0a974$export$2e2bcd8739ae039 = $bef4b0417cd0a974$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $c91eccce520c34d7$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $c91eccce520c34d7$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $c91eccce520c34d7$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $c91eccce520c34d7$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $c91eccce520c34d7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $c91eccce520c34d7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $c91eccce520c34d7$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $c91eccce520c34d7$export$2e2bcd8739ae039 = $c91eccce520c34d7$var$formatLong;



var $egXhZ = parcelRequire("egXhZ");


var $c3GpY = parcelRequire("c3GpY");

var $5fbc7837e262e993$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $5fbc7837e262e993$var$lastWeek(day) {
    var weekday = $5fbc7837e262e993$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $5fbc7837e262e993$var$thisWeek(day) {
    var weekday = $5fbc7837e262e993$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $5fbc7837e262e993$var$nextWeek(day) {
    var weekday = $5fbc7837e262e993$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $5fbc7837e262e993$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $5fbc7837e262e993$var$thisWeek(day);
    else return $5fbc7837e262e993$var$lastWeek(day);
};
var $5fbc7837e262e993$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $5fbc7837e262e993$var$thisWeek(day);
    else return $5fbc7837e262e993$var$nextWeek(day);
};
var $5fbc7837e262e993$var$formatRelativeLocale = {
    lastWeek: $5fbc7837e262e993$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $5fbc7837e262e993$var$nextWeekFormat,
    other: 'P'
};
var $5fbc7837e262e993$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $5fbc7837e262e993$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $5fbc7837e262e993$export$2e2bcd8739ae039 = $5fbc7837e262e993$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $9a9c7d363ae66398$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $9a9c7d363ae66398$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $9a9c7d363ae66398$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $9a9c7d363ae66398$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $9a9c7d363ae66398$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $9a9c7d363ae66398$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $9a9c7d363ae66398$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $9a9c7d363ae66398$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $9a9c7d363ae66398$var$localize = {
    ordinalNumber: $9a9c7d363ae66398$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $9a9c7d363ae66398$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $9a9c7d363ae66398$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $9a9c7d363ae66398$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $9a9c7d363ae66398$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $9a9c7d363ae66398$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $9a9c7d363ae66398$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $9a9c7d363ae66398$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9a9c7d363ae66398$export$2e2bcd8739ae039 = $9a9c7d363ae66398$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $1fbfb68f49eabf6d$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $1fbfb68f49eabf6d$var$parseOrdinalNumberPattern = /\d+/i;
var $1fbfb68f49eabf6d$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $1fbfb68f49eabf6d$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $1fbfb68f49eabf6d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $1fbfb68f49eabf6d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1fbfb68f49eabf6d$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $1fbfb68f49eabf6d$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $1fbfb68f49eabf6d$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $1fbfb68f49eabf6d$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $1fbfb68f49eabf6d$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $1fbfb68f49eabf6d$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $1fbfb68f49eabf6d$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $1fbfb68f49eabf6d$var$matchOrdinalNumberPattern,
        parsePattern: $1fbfb68f49eabf6d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $1fbfb68f49eabf6d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1fbfb68f49eabf6d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $1fbfb68f49eabf6d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1fbfb68f49eabf6d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $1fbfb68f49eabf6d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1fbfb68f49eabf6d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $1fbfb68f49eabf6d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1fbfb68f49eabf6d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $1fbfb68f49eabf6d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1fbfb68f49eabf6d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1fbfb68f49eabf6d$export$2e2bcd8739ae039 = $1fbfb68f49eabf6d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $f471d0416a48f0f8$var$locale = {
    code: 'be',
    formatDistance: (0, $bef4b0417cd0a974$export$2e2bcd8739ae039),
    formatLong: (0, $c91eccce520c34d7$export$2e2bcd8739ae039),
    formatRelative: (0, $5fbc7837e262e993$export$2e2bcd8739ae039),
    localize: (0, $9a9c7d363ae66398$export$2e2bcd8739ae039),
    match: (0, $1fbfb68f49eabf6d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f471d0416a48f0f8$export$2e2bcd8739ae039 = $f471d0416a48f0f8$var$locale;
module.exports["default"] = $f471d0416a48f0f8$export$2e2bcd8739ae039;

});

parcelRegister("1IENB", function(module, exports) {
function $dab72ee5696bbc4c$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $dab72ee5696bbc4c$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $dab72ee5696bbc4c$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $dab72ee5696bbc4c$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $dab72ee5696bbc4c$var$declension(scheme.past, count);
                else return $dab72ee5696bbc4c$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $dab72ee5696bbc4c$var$declension(scheme.regular, count);
    };
}
var $dab72ee5696bbc4c$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $dab72ee5696bbc4c$var$formatDistanceLocale = {
    lessThanXSeconds: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $dab72ee5696bbc4c$var$halfAMinute,
    lessThanXMinutes: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $dab72ee5696bbc4c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $dab72ee5696bbc4c$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $dab72ee5696bbc4c$var$formatDistanceLocale[token](count, options);
};
var $dab72ee5696bbc4c$export$2e2bcd8739ae039 = $dab72ee5696bbc4c$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $fdb195177ae0ea2d$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $fdb195177ae0ea2d$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $fdb195177ae0ea2d$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $fdb195177ae0ea2d$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $fdb195177ae0ea2d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $fdb195177ae0ea2d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $fdb195177ae0ea2d$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $fdb195177ae0ea2d$export$2e2bcd8739ae039 = $fdb195177ae0ea2d$var$formatLong;



var $egXhZ = parcelRequire("egXhZ");


var $c3GpY = parcelRequire("c3GpY");

var $80bd6bab433d8d28$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $80bd6bab433d8d28$var$lastWeek(day) {
    var weekday = $80bd6bab433d8d28$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $80bd6bab433d8d28$var$thisWeek(day) {
    var weekday = $80bd6bab433d8d28$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $80bd6bab433d8d28$var$nextWeek(day) {
    var weekday = $80bd6bab433d8d28$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $80bd6bab433d8d28$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $80bd6bab433d8d28$var$thisWeek(day);
    else return $80bd6bab433d8d28$var$lastWeek(day);
};
var $80bd6bab433d8d28$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $80bd6bab433d8d28$var$thisWeek(day);
    else return $80bd6bab433d8d28$var$nextWeek(day);
};
var $80bd6bab433d8d28$var$formatRelativeLocale = {
    lastWeek: $80bd6bab433d8d28$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $80bd6bab433d8d28$var$nextWeekFormat,
    other: 'P'
};
var $80bd6bab433d8d28$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $80bd6bab433d8d28$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $80bd6bab433d8d28$export$2e2bcd8739ae039 = $80bd6bab433d8d28$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $efbeefab18cfb8a1$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $efbeefab18cfb8a1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $efbeefab18cfb8a1$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $efbeefab18cfb8a1$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $efbeefab18cfb8a1$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $efbeefab18cfb8a1$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $efbeefab18cfb8a1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $efbeefab18cfb8a1$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $efbeefab18cfb8a1$var$localize = {
    ordinalNumber: $efbeefab18cfb8a1$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $efbeefab18cfb8a1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $efbeefab18cfb8a1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $efbeefab18cfb8a1$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $efbeefab18cfb8a1$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $efbeefab18cfb8a1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $efbeefab18cfb8a1$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $efbeefab18cfb8a1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $efbeefab18cfb8a1$export$2e2bcd8739ae039 = $efbeefab18cfb8a1$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $b643cbae9925e666$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $b643cbae9925e666$var$parseOrdinalNumberPattern = /\d+/i;
var $b643cbae9925e666$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $b643cbae9925e666$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $b643cbae9925e666$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $b643cbae9925e666$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b643cbae9925e666$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $b643cbae9925e666$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $b643cbae9925e666$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $b643cbae9925e666$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $b643cbae9925e666$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $b643cbae9925e666$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $b643cbae9925e666$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $b643cbae9925e666$var$matchOrdinalNumberPattern,
        parsePattern: $b643cbae9925e666$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $b643cbae9925e666$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b643cbae9925e666$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $b643cbae9925e666$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b643cbae9925e666$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $b643cbae9925e666$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b643cbae9925e666$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $b643cbae9925e666$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b643cbae9925e666$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $b643cbae9925e666$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b643cbae9925e666$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b643cbae9925e666$export$2e2bcd8739ae039 = $b643cbae9925e666$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $14098c59b820eaa0$var$locale = {
    code: 'be-tarask',
    formatDistance: (0, $dab72ee5696bbc4c$export$2e2bcd8739ae039),
    formatLong: (0, $fdb195177ae0ea2d$export$2e2bcd8739ae039),
    formatRelative: (0, $80bd6bab433d8d28$export$2e2bcd8739ae039),
    localize: (0, $efbeefab18cfb8a1$export$2e2bcd8739ae039),
    match: (0, $b643cbae9925e666$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $14098c59b820eaa0$export$2e2bcd8739ae039 = $14098c59b820eaa0$var$locale;
module.exports["default"] = $14098c59b820eaa0$export$2e2bcd8739ae039;

});

parcelRegister("grFlY", function(module, exports) {
var $0b10804d84729a49$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $0b10804d84729a49$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0b10804d84729a49$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
var $0b10804d84729a49$export$2e2bcd8739ae039 = $0b10804d84729a49$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $b0c2b6e526a2771f$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $b0c2b6e526a2771f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $b0c2b6e526a2771f$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $b0c2b6e526a2771f$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $b0c2b6e526a2771f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $b0c2b6e526a2771f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $b0c2b6e526a2771f$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $b0c2b6e526a2771f$export$2e2bcd8739ae039 = $b0c2b6e526a2771f$var$formatLong;



var $egXhZ = parcelRequire("egXhZ");


var $c3GpY = parcelRequire("c3GpY");

// Adapted from the `ru` translation
var $8968b3eee3beb374$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $8968b3eee3beb374$var$lastWeek(day) {
    var weekday = $8968b3eee3beb374$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $8968b3eee3beb374$var$thisWeek(day) {
    var weekday = $8968b3eee3beb374$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $8968b3eee3beb374$var$nextWeek(day) {
    var weekday = $8968b3eee3beb374$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var $8968b3eee3beb374$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $8968b3eee3beb374$var$thisWeek(day);
    else return $8968b3eee3beb374$var$lastWeek(day);
};
var $8968b3eee3beb374$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $8968b3eee3beb374$var$thisWeek(day);
    else return $8968b3eee3beb374$var$nextWeek(day);
};
var $8968b3eee3beb374$var$formatRelativeLocale = {
    lastWeek: $8968b3eee3beb374$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $8968b3eee3beb374$var$nextWeekFormatToken,
    other: 'P'
};
var $8968b3eee3beb374$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $8968b3eee3beb374$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $8968b3eee3beb374$export$2e2bcd8739ae039 = $8968b3eee3beb374$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $d0088c49064c46f5$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $d0088c49064c46f5$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var $d0088c49064c46f5$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $d0088c49064c46f5$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var $d0088c49064c46f5$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $d0088c49064c46f5$var$isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function $d0088c49064c46f5$var$isNeuter(unit) {
    return unit === 'quarter';
}
function $d0088c49064c46f5$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $d0088c49064c46f5$var$isNeuter(unit) ? neuter : $d0088c49064c46f5$var$isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var $d0088c49064c46f5$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $d0088c49064c46f5$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $d0088c49064c46f5$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var $d0088c49064c46f5$var$localize = {
    ordinalNumber: $d0088c49064c46f5$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $d0088c49064c46f5$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $d0088c49064c46f5$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $d0088c49064c46f5$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $d0088c49064c46f5$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $d0088c49064c46f5$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $d0088c49064c46f5$export$2e2bcd8739ae039 = $d0088c49064c46f5$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $745d46b182a22e9e$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $745d46b182a22e9e$var$parseOrdinalNumberPattern = /\d+/i;
var $745d46b182a22e9e$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $745d46b182a22e9e$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $745d46b182a22e9e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $745d46b182a22e9e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $745d46b182a22e9e$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $745d46b182a22e9e$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $745d46b182a22e9e$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $745d46b182a22e9e$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $745d46b182a22e9e$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $745d46b182a22e9e$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $745d46b182a22e9e$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $745d46b182a22e9e$var$matchOrdinalNumberPattern,
        parsePattern: $745d46b182a22e9e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $745d46b182a22e9e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $745d46b182a22e9e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $745d46b182a22e9e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $745d46b182a22e9e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $745d46b182a22e9e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $745d46b182a22e9e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $745d46b182a22e9e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $745d46b182a22e9e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $745d46b182a22e9e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $745d46b182a22e9e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $745d46b182a22e9e$export$2e2bcd8739ae039 = $745d46b182a22e9e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $bf8f3ee67159f3be$var$locale = {
    code: 'bg',
    formatDistance: (0, $0b10804d84729a49$export$2e2bcd8739ae039),
    formatLong: (0, $b0c2b6e526a2771f$export$2e2bcd8739ae039),
    formatRelative: (0, $8968b3eee3beb374$export$2e2bcd8739ae039),
    localize: (0, $d0088c49064c46f5$export$2e2bcd8739ae039),
    match: (0, $745d46b182a22e9e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $bf8f3ee67159f3be$export$2e2bcd8739ae039 = $bf8f3ee67159f3be$var$locale;
module.exports["default"] = $bf8f3ee67159f3be$export$2e2bcd8739ae039;

});

parcelRegister("jTGMT", function(module, exports) {

var $lo4TZ = parcelRequire("lo4TZ");

var $f4800bc22175fc66$var$numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var $f4800bc22175fc66$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var $f4800bc22175fc66$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var $f4800bc22175fc66$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var $f4800bc22175fc66$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var $f4800bc22175fc66$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var $f4800bc22175fc66$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $f4800bc22175fc66$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var $f4800bc22175fc66$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $f4800bc22175fc66$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return $f4800bc22175fc66$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function $f4800bc22175fc66$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $f4800bc22175fc66$var$numberValues.locale[match];
    });
}
var $f4800bc22175fc66$var$localize = {
    ordinalNumber: $f4800bc22175fc66$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $f4800bc22175fc66$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $f4800bc22175fc66$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $f4800bc22175fc66$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $f4800bc22175fc66$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $f4800bc22175fc66$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f4800bc22175fc66$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f4800bc22175fc66$export$2e2bcd8739ae039 = $f4800bc22175fc66$var$localize;


var $430260b5f42ca29b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var $430260b5f42ca29b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $430260b5f42ca29b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $f4800bc22175fc66$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
var $430260b5f42ca29b$export$2e2bcd8739ae039 = $430260b5f42ca29b$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $1c5cb1a5bec77856$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $1c5cb1a5bec77856$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1c5cb1a5bec77856$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1c5cb1a5bec77856$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $1c5cb1a5bec77856$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $1c5cb1a5bec77856$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $1c5cb1a5bec77856$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1c5cb1a5bec77856$export$2e2bcd8739ae039 = $1c5cb1a5bec77856$var$formatLong;


var $65a8d2852a4aea16$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var $65a8d2852a4aea16$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $65a8d2852a4aea16$var$formatRelativeLocale[token];
};
var $65a8d2852a4aea16$export$2e2bcd8739ae039 = $65a8d2852a4aea16$var$formatRelative;




var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2bdd35f66961f30c$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $2bdd35f66961f30c$var$parseOrdinalNumberPattern = /\d+/i;
var $2bdd35f66961f30c$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $2bdd35f66961f30c$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $2bdd35f66961f30c$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $2bdd35f66961f30c$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $2bdd35f66961f30c$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $2bdd35f66961f30c$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $2bdd35f66961f30c$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $2bdd35f66961f30c$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $2bdd35f66961f30c$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $2bdd35f66961f30c$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $2bdd35f66961f30c$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2bdd35f66961f30c$var$matchOrdinalNumberPattern,
        parsePattern: $2bdd35f66961f30c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2bdd35f66961f30c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2bdd35f66961f30c$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2bdd35f66961f30c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2bdd35f66961f30c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2bdd35f66961f30c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2bdd35f66961f30c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2bdd35f66961f30c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2bdd35f66961f30c$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2bdd35f66961f30c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2bdd35f66961f30c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2bdd35f66961f30c$export$2e2bcd8739ae039 = $2bdd35f66961f30c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $e7c458139646119d$var$locale = {
    code: 'bn',
    formatDistance: (0, $430260b5f42ca29b$export$2e2bcd8739ae039),
    formatLong: (0, $1c5cb1a5bec77856$export$2e2bcd8739ae039),
    formatRelative: (0, $65a8d2852a4aea16$export$2e2bcd8739ae039),
    localize: (0, $f4800bc22175fc66$export$2e2bcd8739ae039),
    match: (0, $2bdd35f66961f30c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e7c458139646119d$export$2e2bcd8739ae039 = $e7c458139646119d$var$locale;
module.exports["default"] = $e7c458139646119d$export$2e2bcd8739ae039;

});

parcelRegister("lfdvS", function(module, exports) {
var $832f9bd773dced6f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $832f9bd773dced6f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $832f9bd773dced6f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $832f9bd773dced6f$export$2e2bcd8739ae039 = $832f9bd773dced6f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $4dd22f488a2e3a62$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $4dd22f488a2e3a62$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4dd22f488a2e3a62$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $4dd22f488a2e3a62$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $4dd22f488a2e3a62$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $4dd22f488a2e3a62$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $4dd22f488a2e3a62$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4dd22f488a2e3a62$export$2e2bcd8739ae039 = $4dd22f488a2e3a62$var$formatLong;


var $a8978bef7f2aa049$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $a8978bef7f2aa049$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $a8978bef7f2aa049$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a8978bef7f2aa049$export$2e2bcd8739ae039 = $a8978bef7f2aa049$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $a66907256c1d6326$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var $a66907256c1d6326$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $a66907256c1d6326$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $a66907256c1d6326$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $a66907256c1d6326$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $a66907256c1d6326$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $a66907256c1d6326$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $a66907256c1d6326$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var $a66907256c1d6326$var$localize = {
    ordinalNumber: $a66907256c1d6326$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $a66907256c1d6326$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $a66907256c1d6326$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $a66907256c1d6326$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $a66907256c1d6326$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $a66907256c1d6326$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $a66907256c1d6326$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a66907256c1d6326$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a66907256c1d6326$export$2e2bcd8739ae039 = $a66907256c1d6326$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $e565a3473d90beee$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $e565a3473d90beee$var$parseOrdinalNumberPattern = /\d+/i;
var $e565a3473d90beee$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $e565a3473d90beee$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $e565a3473d90beee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $e565a3473d90beee$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e565a3473d90beee$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $e565a3473d90beee$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e565a3473d90beee$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $e565a3473d90beee$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $e565a3473d90beee$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $e565a3473d90beee$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $e565a3473d90beee$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $e565a3473d90beee$var$matchOrdinalNumberPattern,
        parsePattern: $e565a3473d90beee$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $e565a3473d90beee$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e565a3473d90beee$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $e565a3473d90beee$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e565a3473d90beee$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $e565a3473d90beee$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e565a3473d90beee$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $e565a3473d90beee$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e565a3473d90beee$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $e565a3473d90beee$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e565a3473d90beee$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e565a3473d90beee$export$2e2bcd8739ae039 = $e565a3473d90beee$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $03fdc40cf4416b6f$var$locale = {
    code: 'bs',
    formatDistance: (0, $832f9bd773dced6f$export$2e2bcd8739ae039),
    formatLong: (0, $4dd22f488a2e3a62$export$2e2bcd8739ae039),
    formatRelative: (0, $a8978bef7f2aa049$export$2e2bcd8739ae039),
    localize: (0, $a66907256c1d6326$export$2e2bcd8739ae039),
    match: (0, $e565a3473d90beee$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $03fdc40cf4416b6f$export$2e2bcd8739ae039 = $03fdc40cf4416b6f$var$locale;
module.exports["default"] = $03fdc40cf4416b6f$export$2e2bcd8739ae039;

});

parcelRegister("cYC81", function(module, exports) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $773f7bc553e63936$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $773f7bc553e63936$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $773f7bc553e63936$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
var $773f7bc553e63936$export$2e2bcd8739ae039 = $773f7bc553e63936$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $aeb50e67ef38b5ec$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $aeb50e67ef38b5ec$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aeb50e67ef38b5ec$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $aeb50e67ef38b5ec$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $aeb50e67ef38b5ec$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $aeb50e67ef38b5ec$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $aeb50e67ef38b5ec$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aeb50e67ef38b5ec$export$2e2bcd8739ae039 = $aeb50e67ef38b5ec$var$formatLong;


var $ad6d9066fe55d86f$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $ad6d9066fe55d86f$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var $ad6d9066fe55d86f$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $ad6d9066fe55d86f$var$formatRelativeLocalePlural[token];
    return $ad6d9066fe55d86f$var$formatRelativeLocale[token];
};
var $ad6d9066fe55d86f$export$2e2bcd8739ae039 = $ad6d9066fe55d86f$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $50cb6fbde57177cf$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var $50cb6fbde57177cf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $50cb6fbde57177cf$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $50cb6fbde57177cf$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $50cb6fbde57177cf$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var $50cb6fbde57177cf$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $50cb6fbde57177cf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var $50cb6fbde57177cf$var$localize = {
    ordinalNumber: $50cb6fbde57177cf$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $50cb6fbde57177cf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $50cb6fbde57177cf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $50cb6fbde57177cf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $50cb6fbde57177cf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $50cb6fbde57177cf$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $50cb6fbde57177cf$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $50cb6fbde57177cf$export$2e2bcd8739ae039 = $50cb6fbde57177cf$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $7c6febaff897a99f$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $7c6febaff897a99f$var$parseOrdinalNumberPattern = /\d+/i;
var $7c6febaff897a99f$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $7c6febaff897a99f$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $7c6febaff897a99f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $7c6febaff897a99f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7c6febaff897a99f$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $7c6febaff897a99f$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $7c6febaff897a99f$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $7c6febaff897a99f$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $7c6febaff897a99f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $7c6febaff897a99f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $7c6febaff897a99f$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $7c6febaff897a99f$var$matchOrdinalNumberPattern,
        parsePattern: $7c6febaff897a99f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $7c6febaff897a99f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c6febaff897a99f$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $7c6febaff897a99f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c6febaff897a99f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $7c6febaff897a99f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c6febaff897a99f$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $7c6febaff897a99f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c6febaff897a99f$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $7c6febaff897a99f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c6febaff897a99f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7c6febaff897a99f$export$2e2bcd8739ae039 = $7c6febaff897a99f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $9728aa1fa64d9546$var$locale = {
    code: 'ca',
    formatDistance: (0, $773f7bc553e63936$export$2e2bcd8739ae039),
    formatLong: (0, $aeb50e67ef38b5ec$export$2e2bcd8739ae039),
    formatRelative: (0, $ad6d9066fe55d86f$export$2e2bcd8739ae039),
    localize: (0, $50cb6fbde57177cf$export$2e2bcd8739ae039),
    match: (0, $7c6febaff897a99f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9728aa1fa64d9546$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $9728aa1fa64d9546$var$locale;
module.exports["default"] = $9728aa1fa64d9546$export$2e2bcd8739ae039;

});

parcelRegister("4ATJv", function(module, exports) {
var $2c8e49b318956438$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var $2c8e49b318956438$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2c8e49b318956438$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $2c8e49b318956438$export$2e2bcd8739ae039 = $2c8e49b318956438$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $8fc64cb5f0cb5d73$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $8fc64cb5f0cb5d73$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $8fc64cb5f0cb5d73$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8fc64cb5f0cb5d73$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $8fc64cb5f0cb5d73$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $8fc64cb5f0cb5d73$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $8fc64cb5f0cb5d73$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8fc64cb5f0cb5d73$export$2e2bcd8739ae039 = $8fc64cb5f0cb5d73$var$formatLong;


var $bc6d498b7c4292c0$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var $bc6d498b7c4292c0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bc6d498b7c4292c0$var$formatRelativeLocale[token];
};
var $bc6d498b7c4292c0$export$2e2bcd8739ae039 = $bc6d498b7c4292c0$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $4acbc7acdf45b0ef$var$eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var $4acbc7acdf45b0ef$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $4acbc7acdf45b0ef$var$monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var $4acbc7acdf45b0ef$var$dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var $4acbc7acdf45b0ef$var$dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var $4acbc7acdf45b0ef$var$formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var $4acbc7acdf45b0ef$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var $4acbc7acdf45b0ef$var$localize = {
    ordinalNumber: $4acbc7acdf45b0ef$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4acbc7acdf45b0ef$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4acbc7acdf45b0ef$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4acbc7acdf45b0ef$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4acbc7acdf45b0ef$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4acbc7acdf45b0ef$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4acbc7acdf45b0ef$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4acbc7acdf45b0ef$export$2e2bcd8739ae039 = $4acbc7acdf45b0ef$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $1119202e46c1e940$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $1119202e46c1e940$var$parseOrdinalNumberPattern = /\d+/i;
var $1119202e46c1e940$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $1119202e46c1e940$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $1119202e46c1e940$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $1119202e46c1e940$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1119202e46c1e940$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $1119202e46c1e940$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $1119202e46c1e940$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $1119202e46c1e940$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $1119202e46c1e940$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $1119202e46c1e940$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $1119202e46c1e940$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $1119202e46c1e940$var$matchOrdinalNumberPattern,
        parsePattern: $1119202e46c1e940$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $1119202e46c1e940$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1119202e46c1e940$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $1119202e46c1e940$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1119202e46c1e940$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $1119202e46c1e940$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1119202e46c1e940$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $1119202e46c1e940$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1119202e46c1e940$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $1119202e46c1e940$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1119202e46c1e940$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1119202e46c1e940$export$2e2bcd8739ae039 = $1119202e46c1e940$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $3585c19b13e6dc93$var$locale = {
    code: 'cy',
    formatDistance: (0, $2c8e49b318956438$export$2e2bcd8739ae039),
    formatLong: (0, $8fc64cb5f0cb5d73$export$2e2bcd8739ae039),
    formatRelative: (0, $bc6d498b7c4292c0$export$2e2bcd8739ae039),
    localize: (0, $4acbc7acdf45b0ef$export$2e2bcd8739ae039),
    match: (0, $1119202e46c1e940$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $3585c19b13e6dc93$export$2e2bcd8739ae039 = $3585c19b13e6dc93$var$locale;
module.exports["default"] = $3585c19b13e6dc93$export$2e2bcd8739ae039;

});

parcelRegister("3evgL", function(module, exports) {

var $habgs = parcelRequire("habgs");


var $3xVG3 = parcelRequire("3xVG3");


var $95e3R = parcelRequire("95e3R");


var $1BsG4 = parcelRequire("1BsG4");


var $lo4TZ = parcelRequire("lo4TZ");

var $101cedece9fef0a5$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $101cedece9fef0a5$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $101cedece9fef0a5$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $101cedece9fef0a5$var$formattingMonthValues = {
    narrow: $101cedece9fef0a5$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $101cedece9fef0a5$var$monthValues.wide
};
var $101cedece9fef0a5$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $101cedece9fef0a5$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $101cedece9fef0a5$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $101cedece9fef0a5$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $101cedece9fef0a5$var$localize = {
    ordinalNumber: $101cedece9fef0a5$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $101cedece9fef0a5$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $101cedece9fef0a5$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $101cedece9fef0a5$var$monthValues,
        formattingValues: $101cedece9fef0a5$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $101cedece9fef0a5$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $101cedece9fef0a5$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $101cedece9fef0a5$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $101cedece9fef0a5$export$2e2bcd8739ae039 = $101cedece9fef0a5$var$localize;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $25aaef5eeb152bf2$var$locale = {
    code: 'de-AT',
    formatDistance: (0, $habgs.default),
    formatLong: (0, $3xVG3.default),
    formatRelative: (0, $95e3R.default),
    localize: (0, $101cedece9fef0a5$export$2e2bcd8739ae039),
    match: (0, $1BsG4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $25aaef5eeb152bf2$export$2e2bcd8739ae039 = $25aaef5eeb152bf2$var$locale;
module.exports["default"] = $25aaef5eeb152bf2$export$2e2bcd8739ae039;

});

parcelRegister("h1o1V", function(module, exports) {
var $bfa3392d9fc0cb40$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var $bfa3392d9fc0cb40$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bfa3392d9fc0cb40$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
var $bfa3392d9fc0cb40$export$2e2bcd8739ae039 = $bfa3392d9fc0cb40$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $f35cf30c5aa9cf39$var$dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var $f35cf30c5aa9cf39$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f35cf30c5aa9cf39$var$dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f35cf30c5aa9cf39$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $f35cf30c5aa9cf39$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $f35cf30c5aa9cf39$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $f35cf30c5aa9cf39$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f35cf30c5aa9cf39$export$2e2bcd8739ae039 = $f35cf30c5aa9cf39$var$formatLong;


var $8ec8212d2aa99f87$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var $8ec8212d2aa99f87$var$formatRelative = function formatRelative(token, date) {
    var format = $8ec8212d2aa99f87$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $8ec8212d2aa99f87$export$2e2bcd8739ae039 = $8ec8212d2aa99f87$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $2ad937841840d7f2$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var $2ad937841840d7f2$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var $2ad937841840d7f2$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var $2ad937841840d7f2$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var $2ad937841840d7f2$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var $2ad937841840d7f2$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var $2ad937841840d7f2$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var $2ad937841840d7f2$var$localize = {
    ordinalNumber: $2ad937841840d7f2$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $2ad937841840d7f2$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $2ad937841840d7f2$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $2ad937841840d7f2$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $2ad937841840d7f2$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $2ad937841840d7f2$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $2ad937841840d7f2$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $2ad937841840d7f2$export$2e2bcd8739ae039 = $2ad937841840d7f2$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $9a8ace934f42bea0$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $9a8ace934f42bea0$var$parseOrdinalNumberPattern = /\d+/i;
var $9a8ace934f42bea0$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $9a8ace934f42bea0$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $9a8ace934f42bea0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $9a8ace934f42bea0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9a8ace934f42bea0$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $9a8ace934f42bea0$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $9a8ace934f42bea0$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $9a8ace934f42bea0$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $9a8ace934f42bea0$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $9a8ace934f42bea0$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $9a8ace934f42bea0$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $9a8ace934f42bea0$var$matchOrdinalNumberPattern,
        parsePattern: $9a8ace934f42bea0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $9a8ace934f42bea0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a8ace934f42bea0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $9a8ace934f42bea0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a8ace934f42bea0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $9a8ace934f42bea0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a8ace934f42bea0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $9a8ace934f42bea0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a8ace934f42bea0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $9a8ace934f42bea0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9a8ace934f42bea0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9a8ace934f42bea0$export$2e2bcd8739ae039 = $9a8ace934f42bea0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $c6452b887af3b516$var$locale = {
    code: 'el',
    formatDistance: (0, $bfa3392d9fc0cb40$export$2e2bcd8739ae039),
    formatLong: (0, $f35cf30c5aa9cf39$export$2e2bcd8739ae039),
    formatRelative: (0, $8ec8212d2aa99f87$export$2e2bcd8739ae039),
    localize: (0, $2ad937841840d7f2$export$2e2bcd8739ae039),
    match: (0, $9a8ace934f42bea0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c6452b887af3b516$export$2e2bcd8739ae039 = $c6452b887af3b516$var$locale;
module.exports["default"] = $c6452b887af3b516$export$2e2bcd8739ae039;

});

parcelRegister("gYOIj", function(module, exports) {

var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");

var $33f7f09a9f5b0756$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var $33f7f09a9f5b0756$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $33f7f09a9f5b0756$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $33f7f09a9f5b0756$export$2e2bcd8739ae039 = $33f7f09a9f5b0756$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $cac152c227fc20a3$var$dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var $cac152c227fc20a3$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cac152c227fc20a3$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cac152c227fc20a3$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $cac152c227fc20a3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $cac152c227fc20a3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $cac152c227fc20a3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cac152c227fc20a3$export$2e2bcd8739ae039 = $cac152c227fc20a3$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $c5c996a2692a6777$var$locale = {
    code: 'en-CA',
    formatDistance: (0, $33f7f09a9f5b0756$export$2e2bcd8739ae039),
    formatLong: (0, $cac152c227fc20a3$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $c5c996a2692a6777$export$2e2bcd8739ae039 = $c5c996a2692a6777$var$locale;
module.exports["default"] = $c5c996a2692a6777$export$2e2bcd8739ae039;

});

parcelRegister("8hVqv", function(module, exports) {

var $hnQFw = parcelRequire("hnQFw");


var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");


var $jCY1h = parcelRequire("jCY1h");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $608c74f32445df8c$var$locale = {
    code: 'en-IE',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $jCY1h.default),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $608c74f32445df8c$export$2e2bcd8739ae039 = $608c74f32445df8c$var$locale;
module.exports["default"] = $608c74f32445df8c$export$2e2bcd8739ae039;

});

parcelRegister("615gv", function(module, exports) {

var $hnQFw = parcelRequire("hnQFw");


var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");


var $ke66V = parcelRequire("ke66V");

var $9b00c3bdd9231dcb$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var $9b00c3bdd9231dcb$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $9b00c3bdd9231dcb$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9b00c3bdd9231dcb$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $9b00c3bdd9231dcb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $9b00c3bdd9231dcb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $9b00c3bdd9231dcb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9b00c3bdd9231dcb$export$2e2bcd8739ae039 = $9b00c3bdd9231dcb$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $4616eba2ce91d7d9$var$locale = {
    code: 'en-IN',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $9b00c3bdd9231dcb$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $4616eba2ce91d7d9$export$2e2bcd8739ae039 = $4616eba2ce91d7d9$var$locale;
module.exports["default"] = $4616eba2ce91d7d9$export$2e2bcd8739ae039;

});

parcelRegister("2QFTn", function(module, exports) {

var $hnQFw = parcelRequire("hnQFw");


var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");


var $ke66V = parcelRequire("ke66V");

var $c430ad2a359d413a$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $c430ad2a359d413a$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $c430ad2a359d413a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c430ad2a359d413a$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $c430ad2a359d413a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $c430ad2a359d413a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $c430ad2a359d413a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c430ad2a359d413a$export$2e2bcd8739ae039 = $c430ad2a359d413a$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $2130eefedbe8388f$var$locale = {
    code: 'en-NZ',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $c430ad2a359d413a$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2130eefedbe8388f$export$2e2bcd8739ae039 = $2130eefedbe8388f$var$locale;
module.exports["default"] = $2130eefedbe8388f$export$2e2bcd8739ae039;

});

parcelRegister("1FiBY", function(module, exports) {

var $hnQFw = parcelRequire("hnQFw");


var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");


var $ke66V = parcelRequire("ke66V");

var $5809cabc66baccf4$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $5809cabc66baccf4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $5809cabc66baccf4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $5809cabc66baccf4$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $5809cabc66baccf4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $5809cabc66baccf4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $5809cabc66baccf4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5809cabc66baccf4$export$2e2bcd8739ae039 = $5809cabc66baccf4$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $13680ea0d260ce23$var$locale = {
    code: 'en-ZA',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $5809cabc66baccf4$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $13680ea0d260ce23$export$2e2bcd8739ae039 = $13680ea0d260ce23$var$locale;
module.exports["default"] = $13680ea0d260ce23$export$2e2bcd8739ae039;

});

parcelRegister("7jF1H", function(module, exports) {
var $113f1d21b08e278e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var $113f1d21b08e278e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $113f1d21b08e278e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
var $113f1d21b08e278e$export$2e2bcd8739ae039 = $113f1d21b08e278e$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $f6b6c1f5a88d4a8c$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var $f6b6c1f5a88d4a8c$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f6b6c1f5a88d4a8c$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $f6b6c1f5a88d4a8c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $f6b6c1f5a88d4a8c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $f6b6c1f5a88d4a8c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $f6b6c1f5a88d4a8c$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $f6b6c1f5a88d4a8c$export$2e2bcd8739ae039 = $f6b6c1f5a88d4a8c$var$formatLong;


var $fabfb96dfcc9d719$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var $fabfb96dfcc9d719$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fabfb96dfcc9d719$var$formatRelativeLocale[token];
};
var $fabfb96dfcc9d719$export$2e2bcd8739ae039 = $fabfb96dfcc9d719$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $b37043d16c848b44$var$eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var $b37043d16c848b44$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var $b37043d16c848b44$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var $b37043d16c848b44$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var $b37043d16c848b44$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var $b37043d16c848b44$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var $b37043d16c848b44$var$localize = {
    ordinalNumber: $b37043d16c848b44$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $b37043d16c848b44$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $b37043d16c848b44$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $b37043d16c848b44$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $b37043d16c848b44$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $b37043d16c848b44$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $b37043d16c848b44$export$2e2bcd8739ae039 = $b37043d16c848b44$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $c97e98eefcbc6644$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $c97e98eefcbc6644$var$parseOrdinalNumberPattern = /\d+/i;
var $c97e98eefcbc6644$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $c97e98eefcbc6644$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $c97e98eefcbc6644$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $c97e98eefcbc6644$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c97e98eefcbc6644$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $c97e98eefcbc6644$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $c97e98eefcbc6644$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $c97e98eefcbc6644$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $c97e98eefcbc6644$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $c97e98eefcbc6644$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $c97e98eefcbc6644$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $c97e98eefcbc6644$var$matchOrdinalNumberPattern,
        parsePattern: $c97e98eefcbc6644$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $c97e98eefcbc6644$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c97e98eefcbc6644$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $c97e98eefcbc6644$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c97e98eefcbc6644$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $c97e98eefcbc6644$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c97e98eefcbc6644$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $c97e98eefcbc6644$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c97e98eefcbc6644$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $c97e98eefcbc6644$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c97e98eefcbc6644$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c97e98eefcbc6644$export$2e2bcd8739ae039 = $c97e98eefcbc6644$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $553a21c27f48b92f$var$locale = {
    code: 'eo',
    formatDistance: (0, $113f1d21b08e278e$export$2e2bcd8739ae039),
    formatLong: (0, $f6b6c1f5a88d4a8c$export$2e2bcd8739ae039),
    formatRelative: (0, $fabfb96dfcc9d719$export$2e2bcd8739ae039),
    localize: (0, $b37043d16c848b44$export$2e2bcd8739ae039),
    match: (0, $c97e98eefcbc6644$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $553a21c27f48b92f$export$2e2bcd8739ae039 = $553a21c27f48b92f$var$locale;
module.exports["default"] = $553a21c27f48b92f$export$2e2bcd8739ae039;

});

parcelRegister("hDlC6", function(module, exports) {
var $c2e176c0bb907417$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $c2e176c0bb907417$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $c2e176c0bb907417$var$formatDistanceLocale[token].withPreposition : $c2e176c0bb907417$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $c2e176c0bb907417$export$2e2bcd8739ae039 = $c2e176c0bb907417$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $7b72608165bb225f$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $7b72608165bb225f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7b72608165bb225f$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $7b72608165bb225f$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $7b72608165bb225f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $7b72608165bb225f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $7b72608165bb225f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7b72608165bb225f$export$2e2bcd8739ae039 = $7b72608165bb225f$var$formatLong;


var $1dac11c832fbf0d2$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $1dac11c832fbf0d2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1dac11c832fbf0d2$var$formatRelativeLocale[token];
};
var $1dac11c832fbf0d2$export$2e2bcd8739ae039 = $1dac11c832fbf0d2$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $56ec449dedb3b6da$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $56ec449dedb3b6da$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $56ec449dedb3b6da$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $56ec449dedb3b6da$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $56ec449dedb3b6da$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $56ec449dedb3b6da$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $56ec449dedb3b6da$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $56ec449dedb3b6da$var$localize = {
    ordinalNumber: $56ec449dedb3b6da$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $56ec449dedb3b6da$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $56ec449dedb3b6da$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $56ec449dedb3b6da$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $56ec449dedb3b6da$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $56ec449dedb3b6da$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $56ec449dedb3b6da$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $56ec449dedb3b6da$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $56ec449dedb3b6da$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $56ec449dedb3b6da$export$2e2bcd8739ae039 = $56ec449dedb3b6da$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $096484436c06c904$var$matchOrdinalNumberPattern = /^\d+\./i;
var $096484436c06c904$var$parseOrdinalNumberPattern = /\d+/i;
var $096484436c06c904$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $096484436c06c904$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $096484436c06c904$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $096484436c06c904$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $096484436c06c904$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $096484436c06c904$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $096484436c06c904$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $096484436c06c904$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $096484436c06c904$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $096484436c06c904$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $096484436c06c904$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $096484436c06c904$var$matchOrdinalNumberPattern,
        parsePattern: $096484436c06c904$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $096484436c06c904$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $096484436c06c904$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $096484436c06c904$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $096484436c06c904$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $096484436c06c904$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $096484436c06c904$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $096484436c06c904$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $096484436c06c904$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $096484436c06c904$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $096484436c06c904$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $096484436c06c904$export$2e2bcd8739ae039 = $096484436c06c904$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $cd66d8342e4b215a$var$locale = {
    code: 'et',
    formatDistance: (0, $c2e176c0bb907417$export$2e2bcd8739ae039),
    formatLong: (0, $7b72608165bb225f$export$2e2bcd8739ae039),
    formatRelative: (0, $1dac11c832fbf0d2$export$2e2bcd8739ae039),
    localize: (0, $56ec449dedb3b6da$export$2e2bcd8739ae039),
    match: (0, $096484436c06c904$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $cd66d8342e4b215a$export$2e2bcd8739ae039 = $cd66d8342e4b215a$var$locale;
module.exports["default"] = $cd66d8342e4b215a$export$2e2bcd8739ae039;

});

parcelRegister("lXpvm", function(module, exports) {
var $0041f84c7634a3f0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var $0041f84c7634a3f0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0041f84c7634a3f0$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
var $0041f84c7634a3f0$export$2e2bcd8739ae039 = $0041f84c7634a3f0$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $a9d3515c85f6bf41$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var $a9d3515c85f6bf41$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a9d3515c85f6bf41$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a9d3515c85f6bf41$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $a9d3515c85f6bf41$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $a9d3515c85f6bf41$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $a9d3515c85f6bf41$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a9d3515c85f6bf41$export$2e2bcd8739ae039 = $a9d3515c85f6bf41$var$formatLong;


var $aeb36d06e7bdca58$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $aeb36d06e7bdca58$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $aeb36d06e7bdca58$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $aeb36d06e7bdca58$var$formatRelativeLocalePlural[token];
    return $aeb36d06e7bdca58$var$formatRelativeLocale[token];
};
var $aeb36d06e7bdca58$export$2e2bcd8739ae039 = $aeb36d06e7bdca58$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $902f17cf5194493f$var$eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var $902f17cf5194493f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var $902f17cf5194493f$var$monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var $902f17cf5194493f$var$dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var $902f17cf5194493f$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var $902f17cf5194493f$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var $902f17cf5194493f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $902f17cf5194493f$var$localize = {
    ordinalNumber: $902f17cf5194493f$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $902f17cf5194493f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $902f17cf5194493f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $902f17cf5194493f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $902f17cf5194493f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $902f17cf5194493f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $902f17cf5194493f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $902f17cf5194493f$export$2e2bcd8739ae039 = $902f17cf5194493f$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $3389c78d7083691a$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $3389c78d7083691a$var$parseOrdinalNumberPattern = /\d+/i;
var $3389c78d7083691a$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $3389c78d7083691a$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $3389c78d7083691a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $3389c78d7083691a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3389c78d7083691a$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $3389c78d7083691a$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $3389c78d7083691a$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $3389c78d7083691a$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $3389c78d7083691a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $3389c78d7083691a$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $3389c78d7083691a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $3389c78d7083691a$var$matchOrdinalNumberPattern,
        parsePattern: $3389c78d7083691a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $3389c78d7083691a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3389c78d7083691a$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $3389c78d7083691a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3389c78d7083691a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $3389c78d7083691a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3389c78d7083691a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $3389c78d7083691a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3389c78d7083691a$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $3389c78d7083691a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3389c78d7083691a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3389c78d7083691a$export$2e2bcd8739ae039 = $3389c78d7083691a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $ffc2e467246a5c09$var$locale = {
    code: 'eu',
    formatDistance: (0, $0041f84c7634a3f0$export$2e2bcd8739ae039),
    formatLong: (0, $a9d3515c85f6bf41$export$2e2bcd8739ae039),
    formatRelative: (0, $aeb36d06e7bdca58$export$2e2bcd8739ae039),
    localize: (0, $902f17cf5194493f$export$2e2bcd8739ae039),
    match: (0, $3389c78d7083691a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ffc2e467246a5c09$export$2e2bcd8739ae039 = $ffc2e467246a5c09$var$locale;
module.exports["default"] = $ffc2e467246a5c09$export$2e2bcd8739ae039;

});

parcelRegister("dQ1Ff", function(module, exports) {
var $af624b233ec88242$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var $af624b233ec88242$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $af624b233ec88242$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
var $af624b233ec88242$export$2e2bcd8739ae039 = $af624b233ec88242$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $43b5e35da1d3c885$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var $43b5e35da1d3c885$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $43b5e35da1d3c885$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $43b5e35da1d3c885$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $43b5e35da1d3c885$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $43b5e35da1d3c885$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $43b5e35da1d3c885$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $43b5e35da1d3c885$export$2e2bcd8739ae039 = $43b5e35da1d3c885$var$formatLong;


var $da3c51f5df960002$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var $da3c51f5df960002$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $da3c51f5df960002$var$formatRelativeLocale[token];
};
var $da3c51f5df960002$export$2e2bcd8739ae039 = $da3c51f5df960002$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $d7a03a380f555038$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var $d7a03a380f555038$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d7a03a380f555038$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var $d7a03a380f555038$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var $d7a03a380f555038$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $d7a03a380f555038$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $d7a03a380f555038$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $d7a03a380f555038$var$localize = {
    ordinalNumber: $d7a03a380f555038$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $d7a03a380f555038$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $d7a03a380f555038$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $d7a03a380f555038$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $d7a03a380f555038$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $d7a03a380f555038$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d7a03a380f555038$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d7a03a380f555038$export$2e2bcd8739ae039 = $d7a03a380f555038$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $70e2dee2e3d3a4d9$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $70e2dee2e3d3a4d9$var$parseOrdinalNumberPattern = /\d+/i;
var $70e2dee2e3d3a4d9$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $70e2dee2e3d3a4d9$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $70e2dee2e3d3a4d9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $70e2dee2e3d3a4d9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $70e2dee2e3d3a4d9$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $70e2dee2e3d3a4d9$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $70e2dee2e3d3a4d9$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $70e2dee2e3d3a4d9$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $70e2dee2e3d3a4d9$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $70e2dee2e3d3a4d9$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $70e2dee2e3d3a4d9$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $70e2dee2e3d3a4d9$var$matchOrdinalNumberPattern,
        parsePattern: $70e2dee2e3d3a4d9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $70e2dee2e3d3a4d9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70e2dee2e3d3a4d9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $70e2dee2e3d3a4d9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70e2dee2e3d3a4d9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $70e2dee2e3d3a4d9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70e2dee2e3d3a4d9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $70e2dee2e3d3a4d9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70e2dee2e3d3a4d9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $70e2dee2e3d3a4d9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $70e2dee2e3d3a4d9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $70e2dee2e3d3a4d9$export$2e2bcd8739ae039 = $70e2dee2e3d3a4d9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $a1316c2dd2e52417$var$locale = {
    code: 'fa-IR',
    formatDistance: (0, $af624b233ec88242$export$2e2bcd8739ae039),
    formatLong: (0, $43b5e35da1d3c885$export$2e2bcd8739ae039),
    formatRelative: (0, $da3c51f5df960002$export$2e2bcd8739ae039),
    localize: (0, $d7a03a380f555038$export$2e2bcd8739ae039),
    match: (0, $70e2dee2e3d3a4d9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $a1316c2dd2e52417$export$2e2bcd8739ae039 = $a1316c2dd2e52417$var$locale;
module.exports["default"] = $a1316c2dd2e52417$export$2e2bcd8739ae039;

});

parcelRegister("7iC3U", function(module, exports) {
// Same as fr

var $fnPCM = parcelRequire("fnPCM");


var $01rSh = parcelRequire("01rSh");


var $bgELe = parcelRequire("bgELe");


var $5uKey = parcelRequire("5uKey");


var $ke66V = parcelRequire("ke66V");

var $190af264bdbcd5e3$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var $190af264bdbcd5e3$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $190af264bdbcd5e3$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $190af264bdbcd5e3$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $190af264bdbcd5e3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $190af264bdbcd5e3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $190af264bdbcd5e3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $190af264bdbcd5e3$export$2e2bcd8739ae039 = $190af264bdbcd5e3$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $5507bd2fe8f39911$var$locale = {
    code: 'fr-CA',
    formatDistance: (0, $fnPCM.default),
    formatLong: (0, $190af264bdbcd5e3$export$2e2bcd8739ae039),
    formatRelative: (0, $01rSh.default),
    localize: (0, $bgELe.default),
    match: (0, $5uKey.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $5507bd2fe8f39911$export$2e2bcd8739ae039 = $5507bd2fe8f39911$var$locale;
module.exports["default"] = $5507bd2fe8f39911$export$2e2bcd8739ae039;

});

parcelRegister("8vHDr", function(module, exports) {
// Same as fr

var $fnPCM = parcelRequire("fnPCM");


var $bgELe = parcelRequire("bgELe");


var $5uKey = parcelRequire("5uKey");


var $ke66V = parcelRequire("ke66V");

var $6c53bdec258b75b0$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $6c53bdec258b75b0$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6c53bdec258b75b0$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6c53bdec258b75b0$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $6c53bdec258b75b0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $6c53bdec258b75b0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $6c53bdec258b75b0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6c53bdec258b75b0$export$2e2bcd8739ae039 = $6c53bdec258b75b0$var$formatLong;


var $557ed965bdc6a690$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var $557ed965bdc6a690$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $557ed965bdc6a690$var$formatRelativeLocale[token];
};
var $557ed965bdc6a690$export$2e2bcd8739ae039 = $557ed965bdc6a690$var$formatRelative;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $632310fd960a0662$var$locale = {
    code: 'fr-CH',
    formatDistance: (0, $fnPCM.default),
    formatLong: (0, $6c53bdec258b75b0$export$2e2bcd8739ae039),
    formatRelative: (0, $557ed965bdc6a690$export$2e2bcd8739ae039),
    localize: (0, $bgELe.default),
    match: (0, $5uKey.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $632310fd960a0662$export$2e2bcd8739ae039 = $632310fd960a0662$var$locale;
module.exports["default"] = $632310fd960a0662$export$2e2bcd8739ae039;

});

parcelRegister("kTJct", function(module, exports) {
var $159e382f9f33fbbd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var $159e382f9f33fbbd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $159e382f9f33fbbd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
var $159e382f9f33fbbd$export$2e2bcd8739ae039 = $159e382f9f33fbbd$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $2fcc6d2bad486242$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $2fcc6d2bad486242$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $2fcc6d2bad486242$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2fcc6d2bad486242$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $2fcc6d2bad486242$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $2fcc6d2bad486242$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $2fcc6d2bad486242$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2fcc6d2bad486242$export$2e2bcd8739ae039 = $2fcc6d2bad486242$var$formatLong;


var $ac06212223a0026b$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $ac06212223a0026b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ac06212223a0026b$var$formatRelativeLocale[token];
};
var $ac06212223a0026b$export$2e2bcd8739ae039 = $ac06212223a0026b$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $1bfceb019ffeb8bf$var$eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var $1bfceb019ffeb8bf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var $1bfceb019ffeb8bf$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var $1bfceb019ffeb8bf$var$dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var $1bfceb019ffeb8bf$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var $1bfceb019ffeb8bf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $1bfceb019ffeb8bf$var$localize = {
    ordinalNumber: $1bfceb019ffeb8bf$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $1bfceb019ffeb8bf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $1bfceb019ffeb8bf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $1bfceb019ffeb8bf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $1bfceb019ffeb8bf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $1bfceb019ffeb8bf$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $1bfceb019ffeb8bf$export$2e2bcd8739ae039 = $1bfceb019ffeb8bf$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $7bfc19eff34369bd$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $7bfc19eff34369bd$var$parseOrdinalNumberPattern = /\d+/i;
var $7bfc19eff34369bd$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $7bfc19eff34369bd$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $7bfc19eff34369bd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $7bfc19eff34369bd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7bfc19eff34369bd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $7bfc19eff34369bd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $7bfc19eff34369bd$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $7bfc19eff34369bd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $7bfc19eff34369bd$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $7bfc19eff34369bd$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $7bfc19eff34369bd$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $7bfc19eff34369bd$var$matchOrdinalNumberPattern,
        parsePattern: $7bfc19eff34369bd$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $7bfc19eff34369bd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7bfc19eff34369bd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $7bfc19eff34369bd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7bfc19eff34369bd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $7bfc19eff34369bd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7bfc19eff34369bd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $7bfc19eff34369bd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7bfc19eff34369bd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $7bfc19eff34369bd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7bfc19eff34369bd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7bfc19eff34369bd$export$2e2bcd8739ae039 = $7bfc19eff34369bd$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $f36c0180651fad90$var$locale = {
    code: 'fy',
    formatDistance: (0, $159e382f9f33fbbd$export$2e2bcd8739ae039),
    formatLong: (0, $2fcc6d2bad486242$export$2e2bcd8739ae039),
    formatRelative: (0, $ac06212223a0026b$export$2e2bcd8739ae039),
    localize: (0, $1bfceb019ffeb8bf$export$2e2bcd8739ae039),
    match: (0, $7bfc19eff34369bd$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f36c0180651fad90$export$2e2bcd8739ae039 = $f36c0180651fad90$var$locale;
module.exports["default"] = $f36c0180651fad90$export$2e2bcd8739ae039;

});

parcelRegister("7sVju", function(module, exports) {
var $33a3687ef83d8a97$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $33a3687ef83d8a97$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $33a3687ef83d8a97$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
var $33a3687ef83d8a97$export$2e2bcd8739ae039 = $33a3687ef83d8a97$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $57283bccd6fa5672$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $57283bccd6fa5672$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $57283bccd6fa5672$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $57283bccd6fa5672$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $57283bccd6fa5672$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $57283bccd6fa5672$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $57283bccd6fa5672$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $57283bccd6fa5672$export$2e2bcd8739ae039 = $57283bccd6fa5672$var$formatLong;


var $d3d25c45938bc0bc$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var $d3d25c45938bc0bc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d3d25c45938bc0bc$var$formatRelativeLocale[token];
};
var $d3d25c45938bc0bc$export$2e2bcd8739ae039 = $d3d25c45938bc0bc$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $0521239172084ecd$var$eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var $0521239172084ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0521239172084ecd$var$monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var $0521239172084ecd$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var $0521239172084ecd$var$dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var $0521239172084ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var $0521239172084ecd$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var $0521239172084ecd$var$localize = {
    ordinalNumber: $0521239172084ecd$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $0521239172084ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $0521239172084ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $0521239172084ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $0521239172084ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $0521239172084ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0521239172084ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0521239172084ecd$export$2e2bcd8739ae039 = $0521239172084ecd$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $228be8ef87166035$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $228be8ef87166035$var$parseOrdinalNumberPattern = /\d+/i;
var $228be8ef87166035$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $228be8ef87166035$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $228be8ef87166035$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $228be8ef87166035$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $228be8ef87166035$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $228be8ef87166035$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $228be8ef87166035$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $228be8ef87166035$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $228be8ef87166035$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $228be8ef87166035$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $228be8ef87166035$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $228be8ef87166035$var$matchOrdinalNumberPattern,
        parsePattern: $228be8ef87166035$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $228be8ef87166035$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $228be8ef87166035$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $228be8ef87166035$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $228be8ef87166035$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $228be8ef87166035$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $228be8ef87166035$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $228be8ef87166035$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $228be8ef87166035$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $228be8ef87166035$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $228be8ef87166035$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $228be8ef87166035$export$2e2bcd8739ae039 = $228be8ef87166035$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $56f79b2ddbd11a3c$var$locale = {
    code: 'gd',
    formatDistance: (0, $33a3687ef83d8a97$export$2e2bcd8739ae039),
    formatLong: (0, $57283bccd6fa5672$export$2e2bcd8739ae039),
    formatRelative: (0, $d3d25c45938bc0bc$export$2e2bcd8739ae039),
    localize: (0, $0521239172084ecd$export$2e2bcd8739ae039),
    match: (0, $228be8ef87166035$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $56f79b2ddbd11a3c$export$2e2bcd8739ae039 = $56f79b2ddbd11a3c$var$locale;
module.exports["default"] = $56f79b2ddbd11a3c$export$2e2bcd8739ae039;

});

parcelRegister("1JL6a", function(module, exports) {
var $40dc2329f2a52982$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var $40dc2329f2a52982$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $40dc2329f2a52982$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
var $40dc2329f2a52982$export$2e2bcd8739ae039 = $40dc2329f2a52982$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $d284343004f122c8$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $d284343004f122c8$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $d284343004f122c8$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d284343004f122c8$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $d284343004f122c8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $d284343004f122c8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $d284343004f122c8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d284343004f122c8$export$2e2bcd8739ae039 = $d284343004f122c8$var$formatLong;


var $fd23c52e365534e7$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var $fd23c52e365534e7$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var $fd23c52e365534e7$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $fd23c52e365534e7$var$formatRelativeLocalePlural[token];
    return $fd23c52e365534e7$var$formatRelativeLocale[token];
};
var $fd23c52e365534e7$export$2e2bcd8739ae039 = $fd23c52e365534e7$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $fb19647b10906c3b$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var $fb19647b10906c3b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $fb19647b10906c3b$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var $fb19647b10906c3b$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var $fb19647b10906c3b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var $fb19647b10906c3b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var $fb19647b10906c3b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $fb19647b10906c3b$var$localize = {
    ordinalNumber: $fb19647b10906c3b$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $fb19647b10906c3b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $fb19647b10906c3b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $fb19647b10906c3b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $fb19647b10906c3b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $fb19647b10906c3b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $fb19647b10906c3b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $fb19647b10906c3b$export$2e2bcd8739ae039 = $fb19647b10906c3b$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $fd1db7e21dc52f4d$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $fd1db7e21dc52f4d$var$parseOrdinalNumberPattern = /\d+/i;
var $fd1db7e21dc52f4d$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $fd1db7e21dc52f4d$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $fd1db7e21dc52f4d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $fd1db7e21dc52f4d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fd1db7e21dc52f4d$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $fd1db7e21dc52f4d$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $fd1db7e21dc52f4d$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $fd1db7e21dc52f4d$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $fd1db7e21dc52f4d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $fd1db7e21dc52f4d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $fd1db7e21dc52f4d$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $fd1db7e21dc52f4d$var$matchOrdinalNumberPattern,
        parsePattern: $fd1db7e21dc52f4d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $fd1db7e21dc52f4d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fd1db7e21dc52f4d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $fd1db7e21dc52f4d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fd1db7e21dc52f4d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $fd1db7e21dc52f4d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fd1db7e21dc52f4d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $fd1db7e21dc52f4d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fd1db7e21dc52f4d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $fd1db7e21dc52f4d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fd1db7e21dc52f4d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fd1db7e21dc52f4d$export$2e2bcd8739ae039 = $fd1db7e21dc52f4d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $143e872e5c11a005$var$locale = {
    code: 'gl',
    formatDistance: (0, $40dc2329f2a52982$export$2e2bcd8739ae039),
    formatLong: (0, $d284343004f122c8$export$2e2bcd8739ae039),
    formatRelative: (0, $fd23c52e365534e7$export$2e2bcd8739ae039),
    localize: (0, $fb19647b10906c3b$export$2e2bcd8739ae039),
    match: (0, $fd1db7e21dc52f4d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $143e872e5c11a005$export$2e2bcd8739ae039 = $143e872e5c11a005$var$locale;
module.exports["default"] = $143e872e5c11a005$export$2e2bcd8739ae039;

});

parcelRegister("8F1uG", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $830e7eefd2b4cddb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var $830e7eefd2b4cddb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $830e7eefd2b4cddb$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
var $830e7eefd2b4cddb$export$2e2bcd8739ae039 = $830e7eefd2b4cddb$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $f8e544f23785df28$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var $f8e544f23785df28$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var $f8e544f23785df28$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var $f8e544f23785df28$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $f8e544f23785df28$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $f8e544f23785df28$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $f8e544f23785df28$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f8e544f23785df28$export$2e2bcd8739ae039 = $f8e544f23785df28$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $347a42065ca98ff5$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var $347a42065ca98ff5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $347a42065ca98ff5$var$formatRelativeLocale[token];
};
var $347a42065ca98ff5$export$2e2bcd8739ae039 = $347a42065ca98ff5$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

// #1621 - #1630
var $7afa369dc456eb22$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $7afa369dc456eb22$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $7afa369dc456eb22$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $7afa369dc456eb22$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $7afa369dc456eb22$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7afa369dc456eb22$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7afa369dc456eb22$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $7afa369dc456eb22$var$localize = {
    ordinalNumber: $7afa369dc456eb22$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $7afa369dc456eb22$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $7afa369dc456eb22$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $7afa369dc456eb22$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $7afa369dc456eb22$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $7afa369dc456eb22$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7afa369dc456eb22$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7afa369dc456eb22$export$2e2bcd8739ae039 = $7afa369dc456eb22$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $95f7fb6504f4106c$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $95f7fb6504f4106c$var$parseOrdinalNumberPattern = /\d+/i;
var $95f7fb6504f4106c$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $95f7fb6504f4106c$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $95f7fb6504f4106c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $95f7fb6504f4106c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $95f7fb6504f4106c$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $95f7fb6504f4106c$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $95f7fb6504f4106c$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $95f7fb6504f4106c$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $95f7fb6504f4106c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $95f7fb6504f4106c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $95f7fb6504f4106c$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $95f7fb6504f4106c$var$matchOrdinalNumberPattern,
        parsePattern: $95f7fb6504f4106c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $95f7fb6504f4106c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95f7fb6504f4106c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $95f7fb6504f4106c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95f7fb6504f4106c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $95f7fb6504f4106c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95f7fb6504f4106c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $95f7fb6504f4106c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95f7fb6504f4106c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $95f7fb6504f4106c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $95f7fb6504f4106c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $95f7fb6504f4106c$export$2e2bcd8739ae039 = $95f7fb6504f4106c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $64e34fb2eaa784e4$var$locale = {
    code: 'gu',
    formatDistance: (0, $830e7eefd2b4cddb$export$2e2bcd8739ae039),
    formatLong: (0, $f8e544f23785df28$export$2e2bcd8739ae039),
    formatRelative: (0, $347a42065ca98ff5$export$2e2bcd8739ae039),
    localize: (0, $7afa369dc456eb22$export$2e2bcd8739ae039),
    match: (0, $95f7fb6504f4106c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $64e34fb2eaa784e4$export$2e2bcd8739ae039 = $64e34fb2eaa784e4$var$locale;
module.exports["default"] = $64e34fb2eaa784e4$export$2e2bcd8739ae039;

});

parcelRegister("f8KYU", function(module, exports) {
var $ddbad7b47dec2b02$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var $ddbad7b47dec2b02$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = $ddbad7b47dec2b02$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
var $ddbad7b47dec2b02$export$2e2bcd8739ae039 = $ddbad7b47dec2b02$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $0118b705cd52865e$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var $0118b705cd52865e$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $0118b705cd52865e$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0118b705cd52865e$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $0118b705cd52865e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $0118b705cd52865e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $0118b705cd52865e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0118b705cd52865e$export$2e2bcd8739ae039 = $0118b705cd52865e$var$formatLong;


var $aad64b5ceaa13efb$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var $aad64b5ceaa13efb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $aad64b5ceaa13efb$var$formatRelativeLocale[token];
};
var $aad64b5ceaa13efb$export$2e2bcd8739ae039 = $aad64b5ceaa13efb$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $23947e269dc1aefc$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var $23947e269dc1aefc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var $23947e269dc1aefc$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var $23947e269dc1aefc$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var $23947e269dc1aefc$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var $23947e269dc1aefc$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var $23947e269dc1aefc$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $23947e269dc1aefc$var$localize = {
    ordinalNumber: $23947e269dc1aefc$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $23947e269dc1aefc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $23947e269dc1aefc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $23947e269dc1aefc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $23947e269dc1aefc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $23947e269dc1aefc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $23947e269dc1aefc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $23947e269dc1aefc$export$2e2bcd8739ae039 = $23947e269dc1aefc$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $5d223499a1c3a028$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $5d223499a1c3a028$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $5d223499a1c3a028$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $5d223499a1c3a028$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $5d223499a1c3a028$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $5d223499a1c3a028$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5d223499a1c3a028$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $5d223499a1c3a028$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $5d223499a1c3a028$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $5d223499a1c3a028$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $5d223499a1c3a028$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $5d223499a1c3a028$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $5d223499a1c3a028$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var $5d223499a1c3a028$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $5d223499a1c3a028$var$matchOrdinalNumberPattern,
        parsePattern: $5d223499a1c3a028$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $5d223499a1c3a028$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $5d223499a1c3a028$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d223499a1c3a028$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $5d223499a1c3a028$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d223499a1c3a028$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $5d223499a1c3a028$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d223499a1c3a028$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $5d223499a1c3a028$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d223499a1c3a028$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $5d223499a1c3a028$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5d223499a1c3a028$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5d223499a1c3a028$export$2e2bcd8739ae039 = $5d223499a1c3a028$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $b05c0bec986a50cb$var$locale = {
    code: 'he',
    formatDistance: (0, $ddbad7b47dec2b02$export$2e2bcd8739ae039),
    formatLong: (0, $0118b705cd52865e$export$2e2bcd8739ae039),
    formatRelative: (0, $aad64b5ceaa13efb$export$2e2bcd8739ae039),
    localize: (0, $23947e269dc1aefc$export$2e2bcd8739ae039),
    match: (0, $5d223499a1c3a028$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b05c0bec986a50cb$export$2e2bcd8739ae039 = $b05c0bec986a50cb$var$locale;
module.exports["default"] = $b05c0bec986a50cb$export$2e2bcd8739ae039;

});

parcelRegister("eIPle", function(module, exports) {

var $lo4TZ = parcelRequire("lo4TZ");

var $12cd8aa241914f02$var$numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var $12cd8aa241914f02$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var $12cd8aa241914f02$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $12cd8aa241914f02$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var $12cd8aa241914f02$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var $12cd8aa241914f02$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $12cd8aa241914f02$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $12cd8aa241914f02$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $12cd8aa241914f02$export$3e1d599946644f03(number);
};
function $12cd8aa241914f02$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $12cd8aa241914f02$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $12cd8aa241914f02$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $12cd8aa241914f02$var$numberValues.locale[match];
    });
}
var $12cd8aa241914f02$var$localize = {
    ordinalNumber: $12cd8aa241914f02$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $12cd8aa241914f02$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $12cd8aa241914f02$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $12cd8aa241914f02$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $12cd8aa241914f02$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $12cd8aa241914f02$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $12cd8aa241914f02$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $12cd8aa241914f02$export$2e2bcd8739ae039 = $12cd8aa241914f02$var$localize;


var $310fff3d26c8ea7b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var $310fff3d26c8ea7b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $310fff3d26c8ea7b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $12cd8aa241914f02$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
var $310fff3d26c8ea7b$export$2e2bcd8739ae039 = $310fff3d26c8ea7b$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $ccee82bde6b5fbab$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var $ccee82bde6b5fbab$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var $ccee82bde6b5fbab$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var $ccee82bde6b5fbab$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $ccee82bde6b5fbab$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $ccee82bde6b5fbab$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $ccee82bde6b5fbab$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ccee82bde6b5fbab$export$2e2bcd8739ae039 = $ccee82bde6b5fbab$var$formatLong;


var $e529df9df13f8085$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var $e529df9df13f8085$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e529df9df13f8085$var$formatRelativeLocale[token];
};
var $e529df9df13f8085$export$2e2bcd8739ae039 = $e529df9df13f8085$var$formatRelative;




var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");


var $045cb103ab3a9002$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $045cb103ab3a9002$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $045cb103ab3a9002$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $045cb103ab3a9002$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $045cb103ab3a9002$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $045cb103ab3a9002$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $045cb103ab3a9002$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $045cb103ab3a9002$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $045cb103ab3a9002$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $045cb103ab3a9002$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $045cb103ab3a9002$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $045cb103ab3a9002$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $045cb103ab3a9002$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $045cb103ab3a9002$var$matchOrdinalNumberPattern,
        parsePattern: $045cb103ab3a9002$var$parseOrdinalNumberPattern,
        valueCallback: (0, $12cd8aa241914f02$export$b431cabd737c2a)
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $045cb103ab3a9002$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $045cb103ab3a9002$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $045cb103ab3a9002$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $045cb103ab3a9002$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $045cb103ab3a9002$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $045cb103ab3a9002$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $045cb103ab3a9002$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $045cb103ab3a9002$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $045cb103ab3a9002$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $045cb103ab3a9002$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $045cb103ab3a9002$export$2e2bcd8739ae039 = $045cb103ab3a9002$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $ab7d001482d0c0e4$var$locale = {
    code: 'hi',
    formatDistance: (0, $310fff3d26c8ea7b$export$2e2bcd8739ae039),
    formatLong: (0, $ccee82bde6b5fbab$export$2e2bcd8739ae039),
    formatRelative: (0, $e529df9df13f8085$export$2e2bcd8739ae039),
    localize: (0, $12cd8aa241914f02$export$2e2bcd8739ae039),
    match: (0, $045cb103ab3a9002$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ab7d001482d0c0e4$export$2e2bcd8739ae039 = $ab7d001482d0c0e4$var$locale;
module.exports["default"] = $ab7d001482d0c0e4$export$2e2bcd8739ae039;

});

parcelRegister("bXqD0", function(module, exports) {
var $d12247ec4e59cc33$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $d12247ec4e59cc33$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d12247ec4e59cc33$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $d12247ec4e59cc33$export$2e2bcd8739ae039 = $d12247ec4e59cc33$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $79f8aa26fc77cad8$var$dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var $79f8aa26fc77cad8$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $79f8aa26fc77cad8$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $79f8aa26fc77cad8$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $79f8aa26fc77cad8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $79f8aa26fc77cad8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $79f8aa26fc77cad8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $79f8aa26fc77cad8$export$2e2bcd8739ae039 = $79f8aa26fc77cad8$var$formatLong;


var $250b9bc3195186fc$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $250b9bc3195186fc$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $250b9bc3195186fc$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $250b9bc3195186fc$export$2e2bcd8739ae039 = $250b9bc3195186fc$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $197501700121c23b$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var $197501700121c23b$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $197501700121c23b$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var $197501700121c23b$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var $197501700121c23b$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $197501700121c23b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $197501700121c23b$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $197501700121c23b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $197501700121c23b$var$localize = {
    ordinalNumber: $197501700121c23b$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $197501700121c23b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $197501700121c23b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $197501700121c23b$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $197501700121c23b$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $197501700121c23b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $197501700121c23b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $197501700121c23b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $197501700121c23b$export$2e2bcd8739ae039 = $197501700121c23b$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $7e0d382e2dce53c9$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $7e0d382e2dce53c9$var$parseOrdinalNumberPattern = /\d+/i;
var $7e0d382e2dce53c9$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $7e0d382e2dce53c9$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $7e0d382e2dce53c9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $7e0d382e2dce53c9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7e0d382e2dce53c9$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $7e0d382e2dce53c9$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $7e0d382e2dce53c9$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $7e0d382e2dce53c9$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7e0d382e2dce53c9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $7e0d382e2dce53c9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $7e0d382e2dce53c9$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $7e0d382e2dce53c9$var$matchOrdinalNumberPattern,
        parsePattern: $7e0d382e2dce53c9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $7e0d382e2dce53c9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e0d382e2dce53c9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $7e0d382e2dce53c9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e0d382e2dce53c9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $7e0d382e2dce53c9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e0d382e2dce53c9$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $7e0d382e2dce53c9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e0d382e2dce53c9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $7e0d382e2dce53c9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7e0d382e2dce53c9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7e0d382e2dce53c9$export$2e2bcd8739ae039 = $7e0d382e2dce53c9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $8b49dc2d773e76c0$var$locale = {
    code: 'hr',
    formatDistance: (0, $d12247ec4e59cc33$export$2e2bcd8739ae039),
    formatLong: (0, $79f8aa26fc77cad8$export$2e2bcd8739ae039),
    formatRelative: (0, $250b9bc3195186fc$export$2e2bcd8739ae039),
    localize: (0, $197501700121c23b$export$2e2bcd8739ae039),
    match: (0, $7e0d382e2dce53c9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8b49dc2d773e76c0$export$2e2bcd8739ae039 = $8b49dc2d773e76c0$var$locale;
module.exports["default"] = $8b49dc2d773e76c0$export$2e2bcd8739ae039;

});

parcelRegister("l3nMN", function(module, exports) {
var $7aea888a0a6bd035$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $7aea888a0a6bd035$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7aea888a0a6bd035$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $7aea888a0a6bd035$export$2e2bcd8739ae039 = $7aea888a0a6bd035$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $86e2a38d9ec036eb$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $86e2a38d9ec036eb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $86e2a38d9ec036eb$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $86e2a38d9ec036eb$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $86e2a38d9ec036eb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $86e2a38d9ec036eb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $86e2a38d9ec036eb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $86e2a38d9ec036eb$export$2e2bcd8739ae039 = $86e2a38d9ec036eb$var$formatLong;


var $c4c1781c246f6438$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var $c4c1781c246f6438$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c4c1781c246f6438$var$formatRelativeLocale[token];
};
var $c4c1781c246f6438$export$2e2bcd8739ae039 = $c4c1781c246f6438$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $9ecaef729cead351$var$eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var $9ecaef729cead351$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $9ecaef729cead351$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var $9ecaef729cead351$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var $9ecaef729cead351$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var $9ecaef729cead351$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var $9ecaef729cead351$var$localize = {
    ordinalNumber: $9ecaef729cead351$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $9ecaef729cead351$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $9ecaef729cead351$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $9ecaef729cead351$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $9ecaef729cead351$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $9ecaef729cead351$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $9ecaef729cead351$export$2e2bcd8739ae039 = $9ecaef729cead351$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $c2e36a716d02febe$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $c2e36a716d02febe$var$parseOrdinalNumberPattern = /\d+/i;
var $c2e36a716d02febe$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $c2e36a716d02febe$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $c2e36a716d02febe$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $c2e36a716d02febe$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c2e36a716d02febe$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $c2e36a716d02febe$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $c2e36a716d02febe$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $c2e36a716d02febe$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $c2e36a716d02febe$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $c2e36a716d02febe$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $c2e36a716d02febe$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $c2e36a716d02febe$var$matchOrdinalNumberPattern,
        parsePattern: $c2e36a716d02febe$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $c2e36a716d02febe$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2e36a716d02febe$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $c2e36a716d02febe$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2e36a716d02febe$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $c2e36a716d02febe$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2e36a716d02febe$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $c2e36a716d02febe$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2e36a716d02febe$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $c2e36a716d02febe$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c2e36a716d02febe$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c2e36a716d02febe$export$2e2bcd8739ae039 = $c2e36a716d02febe$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $f53c543585d9e5a7$var$locale = {
    code: 'ht',
    formatDistance: (0, $7aea888a0a6bd035$export$2e2bcd8739ae039),
    formatLong: (0, $86e2a38d9ec036eb$export$2e2bcd8739ae039),
    formatRelative: (0, $c4c1781c246f6438$export$2e2bcd8739ae039),
    localize: (0, $9ecaef729cead351$export$2e2bcd8739ae039),
    match: (0, $c2e36a716d02febe$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f53c543585d9e5a7$export$2e2bcd8739ae039 = $f53c543585d9e5a7$var$locale;
module.exports["default"] = $f53c543585d9e5a7$export$2e2bcd8739ae039;

});

parcelRegister("9Oln7", function(module, exports) {
var $fe198df44eafc0f7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var $fe198df44eafc0f7$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fe198df44eafc0f7$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
var $fe198df44eafc0f7$export$2e2bcd8739ae039 = $fe198df44eafc0f7$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $fb14826c6f620b07$var$dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var $fb14826c6f620b07$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $fb14826c6f620b07$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fb14826c6f620b07$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $fb14826c6f620b07$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $fb14826c6f620b07$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $fb14826c6f620b07$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fb14826c6f620b07$export$2e2bcd8739ae039 = $fb14826c6f620b07$var$formatLong;


var $d861c8c085f7dfd7$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var $d861c8c085f7dfd7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d861c8c085f7dfd7$var$formatRelativeLocale[token];
};
var $d861c8c085f7dfd7$export$2e2bcd8739ae039 = $d861c8c085f7dfd7$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $4e3b1e9205818d06$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var $4e3b1e9205818d06$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var $4e3b1e9205818d06$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var $4e3b1e9205818d06$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var $4e3b1e9205818d06$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var $4e3b1e9205818d06$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var $4e3b1e9205818d06$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var $4e3b1e9205818d06$var$localize = {
    ordinalNumber: $4e3b1e9205818d06$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4e3b1e9205818d06$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4e3b1e9205818d06$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4e3b1e9205818d06$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4e3b1e9205818d06$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4e3b1e9205818d06$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4e3b1e9205818d06$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4e3b1e9205818d06$export$2e2bcd8739ae039 = $4e3b1e9205818d06$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $93dc83145c21edeb$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $93dc83145c21edeb$var$parseOrdinalNumberPattern = /\d+/i;
var $93dc83145c21edeb$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $93dc83145c21edeb$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $93dc83145c21edeb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $93dc83145c21edeb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $93dc83145c21edeb$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $93dc83145c21edeb$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $93dc83145c21edeb$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $93dc83145c21edeb$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $93dc83145c21edeb$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $93dc83145c21edeb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $93dc83145c21edeb$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $93dc83145c21edeb$var$matchOrdinalNumberPattern,
        parsePattern: $93dc83145c21edeb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $93dc83145c21edeb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $93dc83145c21edeb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $93dc83145c21edeb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $93dc83145c21edeb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $93dc83145c21edeb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $93dc83145c21edeb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $93dc83145c21edeb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $93dc83145c21edeb$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $93dc83145c21edeb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $93dc83145c21edeb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $93dc83145c21edeb$export$2e2bcd8739ae039 = $93dc83145c21edeb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $72495c91867abfbc$var$locale = {
    code: 'hy',
    formatDistance: (0, $fe198df44eafc0f7$export$2e2bcd8739ae039),
    formatLong: (0, $fb14826c6f620b07$export$2e2bcd8739ae039),
    formatRelative: (0, $d861c8c085f7dfd7$export$2e2bcd8739ae039),
    localize: (0, $4e3b1e9205818d06$export$2e2bcd8739ae039),
    match: (0, $93dc83145c21edeb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $72495c91867abfbc$export$2e2bcd8739ae039 = $72495c91867abfbc$var$locale;
module.exports["default"] = $72495c91867abfbc$export$2e2bcd8739ae039;

});

parcelRegister("595k0", function(module, exports) {
var $62a28bc77d1a43bd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $62a28bc77d1a43bd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $62a28bc77d1a43bd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $62a28bc77d1a43bd$export$2e2bcd8739ae039 = $62a28bc77d1a43bd$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $7f5ae3cde260e12f$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $7f5ae3cde260e12f$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $7f5ae3cde260e12f$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7f5ae3cde260e12f$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $7f5ae3cde260e12f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $7f5ae3cde260e12f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $7f5ae3cde260e12f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7f5ae3cde260e12f$export$2e2bcd8739ae039 = $7f5ae3cde260e12f$var$formatLong;


var $86b5ec8e311c75f3$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var $86b5ec8e311c75f3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $86b5ec8e311c75f3$var$formatRelativeLocale[token];
};
var $86b5ec8e311c75f3$export$2e2bcd8739ae039 = $86b5ec8e311c75f3$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

// https://www.unicode.org/cldr/charts/32/summary/id.html
var $2c9222571941a2fa$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var $2c9222571941a2fa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $2c9222571941a2fa$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $2c9222571941a2fa$var$dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var $2c9222571941a2fa$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $2c9222571941a2fa$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $2c9222571941a2fa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var $2c9222571941a2fa$var$localize = {
    ordinalNumber: $2c9222571941a2fa$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $2c9222571941a2fa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $2c9222571941a2fa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $2c9222571941a2fa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $2c9222571941a2fa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $2c9222571941a2fa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2c9222571941a2fa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2c9222571941a2fa$export$2e2bcd8739ae039 = $2c9222571941a2fa$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $292bbd3eb4a3cb9a$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $292bbd3eb4a3cb9a$var$parseOrdinalNumberPattern = /\d+/i;
var $292bbd3eb4a3cb9a$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $292bbd3eb4a3cb9a$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $292bbd3eb4a3cb9a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $292bbd3eb4a3cb9a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $292bbd3eb4a3cb9a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $292bbd3eb4a3cb9a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $292bbd3eb4a3cb9a$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $292bbd3eb4a3cb9a$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $292bbd3eb4a3cb9a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $292bbd3eb4a3cb9a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $292bbd3eb4a3cb9a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $292bbd3eb4a3cb9a$var$matchOrdinalNumberPattern,
        parsePattern: $292bbd3eb4a3cb9a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $292bbd3eb4a3cb9a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $292bbd3eb4a3cb9a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $292bbd3eb4a3cb9a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $292bbd3eb4a3cb9a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $292bbd3eb4a3cb9a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $292bbd3eb4a3cb9a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $292bbd3eb4a3cb9a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $292bbd3eb4a3cb9a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $292bbd3eb4a3cb9a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $292bbd3eb4a3cb9a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $292bbd3eb4a3cb9a$export$2e2bcd8739ae039 = $292bbd3eb4a3cb9a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $3bf1ebc53085a4f9$var$locale = {
    code: 'id',
    formatDistance: (0, $62a28bc77d1a43bd$export$2e2bcd8739ae039),
    formatLong: (0, $7f5ae3cde260e12f$export$2e2bcd8739ae039),
    formatRelative: (0, $86b5ec8e311c75f3$export$2e2bcd8739ae039),
    localize: (0, $2c9222571941a2fa$export$2e2bcd8739ae039),
    match: (0, $292bbd3eb4a3cb9a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $3bf1ebc53085a4f9$export$2e2bcd8739ae039 = $3bf1ebc53085a4f9$var$locale;
module.exports["default"] = $3bf1ebc53085a4f9$export$2e2bcd8739ae039;

});

parcelRegister("79XIC", function(module, exports) {
var $21ade50341df772e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $21ade50341df772e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $21ade50341df772e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $21ade50341df772e$export$2e2bcd8739ae039 = $21ade50341df772e$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $635d84b93de24f99$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $635d84b93de24f99$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $635d84b93de24f99$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $635d84b93de24f99$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $635d84b93de24f99$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $635d84b93de24f99$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $635d84b93de24f99$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $635d84b93de24f99$export$2e2bcd8739ae039 = $635d84b93de24f99$var$formatLong;


var $80f83345a9e09b25$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $80f83345a9e09b25$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $80f83345a9e09b25$var$formatRelativeLocale[token];
};
var $80f83345a9e09b25$export$2e2bcd8739ae039 = $80f83345a9e09b25$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $eddb758d8c9b6db1$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $eddb758d8c9b6db1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $eddb758d8c9b6db1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $eddb758d8c9b6db1$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $eddb758d8c9b6db1$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $eddb758d8c9b6db1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $eddb758d8c9b6db1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $eddb758d8c9b6db1$var$localize = {
    ordinalNumber: $eddb758d8c9b6db1$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $eddb758d8c9b6db1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $eddb758d8c9b6db1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $eddb758d8c9b6db1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $eddb758d8c9b6db1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $eddb758d8c9b6db1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $eddb758d8c9b6db1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $eddb758d8c9b6db1$export$2e2bcd8739ae039 = $eddb758d8c9b6db1$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2b102f4d8e9d80d1$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $2b102f4d8e9d80d1$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $2b102f4d8e9d80d1$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $2b102f4d8e9d80d1$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $2b102f4d8e9d80d1$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $2b102f4d8e9d80d1$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $2b102f4d8e9d80d1$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $2b102f4d8e9d80d1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $2b102f4d8e9d80d1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $2b102f4d8e9d80d1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $2b102f4d8e9d80d1$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $2b102f4d8e9d80d1$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $2b102f4d8e9d80d1$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2b102f4d8e9d80d1$var$matchOrdinalNumberPattern,
        parsePattern: $2b102f4d8e9d80d1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2b102f4d8e9d80d1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b102f4d8e9d80d1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2b102f4d8e9d80d1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b102f4d8e9d80d1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2b102f4d8e9d80d1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b102f4d8e9d80d1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2b102f4d8e9d80d1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b102f4d8e9d80d1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2b102f4d8e9d80d1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2b102f4d8e9d80d1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2b102f4d8e9d80d1$export$2e2bcd8739ae039 = $2b102f4d8e9d80d1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $5367b2873c0372dd$var$locale = {
    code: 'is',
    formatDistance: (0, $21ade50341df772e$export$2e2bcd8739ae039),
    formatLong: (0, $635d84b93de24f99$export$2e2bcd8739ae039),
    formatRelative: (0, $80f83345a9e09b25$export$2e2bcd8739ae039),
    localize: (0, $eddb758d8c9b6db1$export$2e2bcd8739ae039),
    match: (0, $2b102f4d8e9d80d1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5367b2873c0372dd$export$2e2bcd8739ae039 = $5367b2873c0372dd$var$locale;
module.exports["default"] = $5367b2873c0372dd$export$2e2bcd8739ae039;

});

parcelRegister("ay3fF", function(module, exports) {

var $9TnnD = parcelRequire("9TnnD");


var $kA6JQ = parcelRequire("kA6JQ");


var $7Mnkf = parcelRequire("7Mnkf");


var $lX7nd = parcelRequire("lX7nd");


var $ke66V = parcelRequire("ke66V");

var $ec98c3de82c1dceb$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $ec98c3de82c1dceb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ec98c3de82c1dceb$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ec98c3de82c1dceb$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $ec98c3de82c1dceb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $ec98c3de82c1dceb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $ec98c3de82c1dceb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ec98c3de82c1dceb$export$2e2bcd8739ae039 = $ec98c3de82c1dceb$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $7adf9a19782c71f3$var$locale = {
    code: 'it-CH',
    formatDistance: (0, $9TnnD.default),
    formatLong: (0, $ec98c3de82c1dceb$export$2e2bcd8739ae039),
    formatRelative: (0, $kA6JQ.default),
    localize: (0, $7Mnkf.default),
    match: (0, $lX7nd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7adf9a19782c71f3$export$2e2bcd8739ae039 = $7adf9a19782c71f3$var$locale;
module.exports["default"] = $7adf9a19782c71f3$export$2e2bcd8739ae039;

});

parcelRegister("kfY4v", function(module, exports) {
var $f7a0260251986911$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var $f7a0260251986911$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $f7a0260251986911$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
var $f7a0260251986911$export$2e2bcd8739ae039 = $f7a0260251986911$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $eb5dbc62a9b8d002$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $eb5dbc62a9b8d002$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $eb5dbc62a9b8d002$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $eb5dbc62a9b8d002$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $eb5dbc62a9b8d002$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $eb5dbc62a9b8d002$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $eb5dbc62a9b8d002$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $eb5dbc62a9b8d002$export$2e2bcd8739ae039 = $eb5dbc62a9b8d002$var$formatLong;


var $84b86a69352ba33c$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var $84b86a69352ba33c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $84b86a69352ba33c$var$formatRelativeLocale[token];
};
var $84b86a69352ba33c$export$2e2bcd8739ae039 = $84b86a69352ba33c$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $c44faea4e0f57a00$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var $c44faea4e0f57a00$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var $c44faea4e0f57a00$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var $c44faea4e0f57a00$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var $c44faea4e0f57a00$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $c44faea4e0f57a00$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $c44faea4e0f57a00$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var $c44faea4e0f57a00$var$localize = {
    ordinalNumber: $c44faea4e0f57a00$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $c44faea4e0f57a00$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $c44faea4e0f57a00$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $c44faea4e0f57a00$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $c44faea4e0f57a00$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $c44faea4e0f57a00$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c44faea4e0f57a00$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c44faea4e0f57a00$export$2e2bcd8739ae039 = $c44faea4e0f57a00$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $b482f19d6c399582$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $b482f19d6c399582$var$parseOrdinalNumberPattern = /\d+/i;
var $b482f19d6c399582$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $b482f19d6c399582$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $b482f19d6c399582$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $b482f19d6c399582$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $b482f19d6c399582$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $b482f19d6c399582$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $b482f19d6c399582$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $b482f19d6c399582$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $b482f19d6c399582$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $b482f19d6c399582$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $b482f19d6c399582$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $b482f19d6c399582$var$matchOrdinalNumberPattern,
        parsePattern: $b482f19d6c399582$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $b482f19d6c399582$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b482f19d6c399582$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $b482f19d6c399582$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b482f19d6c399582$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $b482f19d6c399582$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b482f19d6c399582$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $b482f19d6c399582$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b482f19d6c399582$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $b482f19d6c399582$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b482f19d6c399582$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b482f19d6c399582$export$2e2bcd8739ae039 = $b482f19d6c399582$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $ebf3ce55e2f189fd$var$locale = {
    code: 'ja-Hira',
    formatDistance: (0, $f7a0260251986911$export$2e2bcd8739ae039),
    formatLong: (0, $eb5dbc62a9b8d002$export$2e2bcd8739ae039),
    formatRelative: (0, $84b86a69352ba33c$export$2e2bcd8739ae039),
    localize: (0, $c44faea4e0f57a00$export$2e2bcd8739ae039),
    match: (0, $b482f19d6c399582$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $ebf3ce55e2f189fd$export$2e2bcd8739ae039 = $ebf3ce55e2f189fd$var$locale;
module.exports["default"] = $ebf3ce55e2f189fd$export$2e2bcd8739ae039;

});

parcelRegister("lv9bx", function(module, exports) {
var $31f174e36b8d283e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var $31f174e36b8d283e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $31f174e36b8d283e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
var $31f174e36b8d283e$export$2e2bcd8739ae039 = $31f174e36b8d283e$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $6783483077939408$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var $6783483077939408$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $6783483077939408$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6783483077939408$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $6783483077939408$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $6783483077939408$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $6783483077939408$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6783483077939408$export$2e2bcd8739ae039 = $6783483077939408$var$formatLong;


var $e7804c6b0dbc39c5$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var $e7804c6b0dbc39c5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e7804c6b0dbc39c5$var$formatRelativeLocale[token];
};
var $e7804c6b0dbc39c5$export$2e2bcd8739ae039 = $e7804c6b0dbc39c5$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $ae228871d615bb0b$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var $ae228871d615bb0b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $ae228871d615bb0b$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var $ae228871d615bb0b$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var $ae228871d615bb0b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var $ae228871d615bb0b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var $ae228871d615bb0b$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var $ae228871d615bb0b$var$localize = {
    ordinalNumber: $ae228871d615bb0b$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $ae228871d615bb0b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $ae228871d615bb0b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $ae228871d615bb0b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $ae228871d615bb0b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $ae228871d615bb0b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ae228871d615bb0b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ae228871d615bb0b$export$2e2bcd8739ae039 = $ae228871d615bb0b$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $b77441d33d84de94$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $b77441d33d84de94$var$parseOrdinalNumberPattern = /\d+/i;
var $b77441d33d84de94$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $b77441d33d84de94$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $b77441d33d84de94$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $b77441d33d84de94$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b77441d33d84de94$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $b77441d33d84de94$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $b77441d33d84de94$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $b77441d33d84de94$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $b77441d33d84de94$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $b77441d33d84de94$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $b77441d33d84de94$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $b77441d33d84de94$var$matchOrdinalNumberPattern,
        parsePattern: $b77441d33d84de94$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $b77441d33d84de94$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b77441d33d84de94$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $b77441d33d84de94$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b77441d33d84de94$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $b77441d33d84de94$var$matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b77441d33d84de94$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $b77441d33d84de94$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b77441d33d84de94$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $b77441d33d84de94$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b77441d33d84de94$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b77441d33d84de94$export$2e2bcd8739ae039 = $b77441d33d84de94$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $fa739e2dcbb66ae6$var$locale = {
    code: 'ka',
    formatDistance: (0, $31f174e36b8d283e$export$2e2bcd8739ae039),
    formatLong: (0, $6783483077939408$export$2e2bcd8739ae039),
    formatRelative: (0, $e7804c6b0dbc39c5$export$2e2bcd8739ae039),
    localize: (0, $ae228871d615bb0b$export$2e2bcd8739ae039),
    match: (0, $b77441d33d84de94$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $fa739e2dcbb66ae6$export$2e2bcd8739ae039 = $fa739e2dcbb66ae6$var$locale;
module.exports["default"] = $fa739e2dcbb66ae6$export$2e2bcd8739ae039;

});

parcelRegister("eGEP6", function(module, exports) {
var $05ef22561477f90f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $05ef22561477f90f$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var $05ef22561477f90f$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $05ef22561477f90f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $05ef22561477f90f$var$declension(tokenValue.future, count);
            else return $05ef22561477f90f$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $05ef22561477f90f$var$declension(tokenValue.past, count);
            else return $05ef22561477f90f$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $05ef22561477f90f$var$declension(tokenValue.regular, count);
};
var $05ef22561477f90f$export$2e2bcd8739ae039 = $05ef22561477f90f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $496bb7e95808490f$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var $496bb7e95808490f$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $496bb7e95808490f$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $496bb7e95808490f$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $496bb7e95808490f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $496bb7e95808490f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $496bb7e95808490f$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $496bb7e95808490f$export$2e2bcd8739ae039 = $496bb7e95808490f$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

var $6db3f6e148512113$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $6db3f6e148512113$var$_lastWeek(day) {
    var weekday = $6db3f6e148512113$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $6db3f6e148512113$var$thisWeek(day) {
    var weekday = $6db3f6e148512113$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $6db3f6e148512113$var$_nextWeek(day) {
    var weekday = $6db3f6e148512113$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var $6db3f6e148512113$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $6db3f6e148512113$var$thisWeek(day);
        else return $6db3f6e148512113$var$_lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $6db3f6e148512113$var$thisWeek(day);
        else return $6db3f6e148512113$var$_nextWeek(day);
    },
    other: 'P'
};
var $6db3f6e148512113$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $6db3f6e148512113$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $6db3f6e148512113$export$2e2bcd8739ae039 = $6db3f6e148512113$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $b51959408987edf6$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var $b51959408987edf6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b51959408987edf6$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b51959408987edf6$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b51959408987edf6$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var $b51959408987edf6$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var $b51959408987edf6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var $b51959408987edf6$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var $b51959408987edf6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $b51959408987edf6$var$suffixes[number] || $b51959408987edf6$var$suffixes[mod10] || b && $b51959408987edf6$var$suffixes[b] || '';
    return number + suffix;
};
var $b51959408987edf6$var$localize = {
    ordinalNumber: $b51959408987edf6$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $b51959408987edf6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $b51959408987edf6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $b51959408987edf6$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b51959408987edf6$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $b51959408987edf6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $b51959408987edf6$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $b51959408987edf6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b51959408987edf6$export$2e2bcd8739ae039 = $b51959408987edf6$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $9afe689dd370b0f4$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $9afe689dd370b0f4$var$parseOrdinalNumberPattern = /\d+/i;
var $9afe689dd370b0f4$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $9afe689dd370b0f4$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $9afe689dd370b0f4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $9afe689dd370b0f4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9afe689dd370b0f4$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $9afe689dd370b0f4$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $9afe689dd370b0f4$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $9afe689dd370b0f4$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $9afe689dd370b0f4$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $9afe689dd370b0f4$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $9afe689dd370b0f4$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $9afe689dd370b0f4$var$matchOrdinalNumberPattern,
        parsePattern: $9afe689dd370b0f4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $9afe689dd370b0f4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9afe689dd370b0f4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $9afe689dd370b0f4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9afe689dd370b0f4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $9afe689dd370b0f4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9afe689dd370b0f4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $9afe689dd370b0f4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9afe689dd370b0f4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $9afe689dd370b0f4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9afe689dd370b0f4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9afe689dd370b0f4$export$2e2bcd8739ae039 = $9afe689dd370b0f4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $ab14a79616806232$var$locale = {
    code: 'kk',
    formatDistance: (0, $05ef22561477f90f$export$2e2bcd8739ae039),
    formatLong: (0, $496bb7e95808490f$export$2e2bcd8739ae039),
    formatRelative: (0, $6db3f6e148512113$export$2e2bcd8739ae039),
    localize: (0, $b51959408987edf6$export$2e2bcd8739ae039),
    match: (0, $9afe689dd370b0f4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ab14a79616806232$export$2e2bcd8739ae039 = $ab14a79616806232$var$locale;
module.exports["default"] = $ab14a79616806232$export$2e2bcd8739ae039;

});

parcelRegister("hwTSQ", function(module, exports) {
var $3483374ec424e1e2$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var $3483374ec424e1e2$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $3483374ec424e1e2$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
var $3483374ec424e1e2$export$2e2bcd8739ae039 = $3483374ec424e1e2$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $c0a40dbef743db93$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $c0a40dbef743db93$var$timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $c0a40dbef743db93$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c0a40dbef743db93$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $c0a40dbef743db93$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $c0a40dbef743db93$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $c0a40dbef743db93$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c0a40dbef743db93$export$2e2bcd8739ae039 = $c0a40dbef743db93$var$formatLong;


var $02bd07736a882bcb$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var $02bd07736a882bcb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $02bd07736a882bcb$var$formatRelativeLocale[token];
};
var $02bd07736a882bcb$export$2e2bcd8739ae039 = $02bd07736a882bcb$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $2f9c37b72a43e497$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var $2f9c37b72a43e497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var $2f9c37b72a43e497$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var $2f9c37b72a43e497$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var $2f9c37b72a43e497$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $2f9c37b72a43e497$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $2f9c37b72a43e497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $2f9c37b72a43e497$var$localize = {
    ordinalNumber: $2f9c37b72a43e497$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $2f9c37b72a43e497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $2f9c37b72a43e497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $2f9c37b72a43e497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $2f9c37b72a43e497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $2f9c37b72a43e497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2f9c37b72a43e497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2f9c37b72a43e497$export$2e2bcd8739ae039 = $2f9c37b72a43e497$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $4f8dfd493e007a30$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $4f8dfd493e007a30$var$parseOrdinalNumberPattern = /\d+/i;
var $4f8dfd493e007a30$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $4f8dfd493e007a30$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $4f8dfd493e007a30$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $4f8dfd493e007a30$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4f8dfd493e007a30$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $4f8dfd493e007a30$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $4f8dfd493e007a30$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $4f8dfd493e007a30$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $4f8dfd493e007a30$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $4f8dfd493e007a30$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $4f8dfd493e007a30$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $4f8dfd493e007a30$var$matchOrdinalNumberPattern,
        parsePattern: $4f8dfd493e007a30$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $4f8dfd493e007a30$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f8dfd493e007a30$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $4f8dfd493e007a30$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f8dfd493e007a30$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $4f8dfd493e007a30$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f8dfd493e007a30$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $4f8dfd493e007a30$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f8dfd493e007a30$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $4f8dfd493e007a30$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4f8dfd493e007a30$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4f8dfd493e007a30$export$2e2bcd8739ae039 = $4f8dfd493e007a30$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $cc30c624aad7f62f$var$locale = {
    code: 'km',
    formatDistance: (0, $3483374ec424e1e2$export$2e2bcd8739ae039),
    formatLong: (0, $c0a40dbef743db93$export$2e2bcd8739ae039),
    formatRelative: (0, $02bd07736a882bcb$export$2e2bcd8739ae039),
    localize: (0, $2f9c37b72a43e497$export$2e2bcd8739ae039),
    match: (0, $4f8dfd493e007a30$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $cc30c624aad7f62f$export$2e2bcd8739ae039 = $cc30c624aad7f62f$var$locale;
module.exports["default"] = $cc30c624aad7f62f$export$2e2bcd8739ae039;

});

parcelRegister("kH49P", function(module, exports) {
// note: no implementation for weeks
var $9505b9c126d3e77f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $9505b9c126d3e77f$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $9505b9c126d3e77f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9505b9c126d3e77f$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $9505b9c126d3e77f$var$getResultByTense(tokenValue.one, options);
    else result = $9505b9c126d3e77f$var$getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
var $9505b9c126d3e77f$export$2e2bcd8739ae039 = $9505b9c126d3e77f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $ad5df413e49b522b$var$dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var $ad5df413e49b522b$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var $ad5df413e49b522b$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var $ad5df413e49b522b$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $ad5df413e49b522b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $ad5df413e49b522b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $ad5df413e49b522b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ad5df413e49b522b$export$2e2bcd8739ae039 = $ad5df413e49b522b$var$formatLong;


var $f865bfcf10cd5951$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var $f865bfcf10cd5951$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f865bfcf10cd5951$var$formatRelativeLocale[token];
};
var $f865bfcf10cd5951$export$2e2bcd8739ae039 = $f865bfcf10cd5951$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $c8727260d73c9a44$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var $c8727260d73c9a44$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $c8727260d73c9a44$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var $c8727260d73c9a44$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var $c8727260d73c9a44$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $c8727260d73c9a44$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $c8727260d73c9a44$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var $c8727260d73c9a44$var$localize = {
    ordinalNumber: $c8727260d73c9a44$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $c8727260d73c9a44$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $c8727260d73c9a44$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $c8727260d73c9a44$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $c8727260d73c9a44$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $c8727260d73c9a44$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c8727260d73c9a44$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c8727260d73c9a44$export$2e2bcd8739ae039 = $c8727260d73c9a44$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $290b63a11f6e6fbe$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $290b63a11f6e6fbe$var$parseOrdinalNumberPattern = /\d+/i;
var $290b63a11f6e6fbe$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $290b63a11f6e6fbe$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $290b63a11f6e6fbe$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $290b63a11f6e6fbe$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $290b63a11f6e6fbe$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $290b63a11f6e6fbe$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $290b63a11f6e6fbe$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $290b63a11f6e6fbe$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $290b63a11f6e6fbe$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $290b63a11f6e6fbe$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $290b63a11f6e6fbe$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $290b63a11f6e6fbe$var$matchOrdinalNumberPattern,
        parsePattern: $290b63a11f6e6fbe$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $290b63a11f6e6fbe$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $290b63a11f6e6fbe$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $290b63a11f6e6fbe$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $290b63a11f6e6fbe$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $290b63a11f6e6fbe$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $290b63a11f6e6fbe$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $290b63a11f6e6fbe$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $290b63a11f6e6fbe$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $290b63a11f6e6fbe$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $290b63a11f6e6fbe$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $290b63a11f6e6fbe$export$2e2bcd8739ae039 = $290b63a11f6e6fbe$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $f10b0c688a2ffc76$var$locale = {
    code: 'kn',
    formatDistance: (0, $9505b9c126d3e77f$export$2e2bcd8739ae039),
    formatLong: (0, $ad5df413e49b522b$export$2e2bcd8739ae039),
    formatRelative: (0, $f865bfcf10cd5951$export$2e2bcd8739ae039),
    localize: (0, $c8727260d73c9a44$export$2e2bcd8739ae039),
    match: (0, $290b63a11f6e6fbe$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f10b0c688a2ffc76$export$2e2bcd8739ae039 = $f10b0c688a2ffc76$var$locale;
module.exports["default"] = $f10b0c688a2ffc76$export$2e2bcd8739ae039;

});

parcelRegister("imqUz", function(module, exports) {
var $8caf005a546bc110$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var $8caf005a546bc110$var$EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var $8caf005a546bc110$var$VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var $8caf005a546bc110$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $8caf005a546bc110$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $8caf005a546bc110$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($8caf005a546bc110$var$VOWELS.indexOf(firstLetter) != -1 || $8caf005a546bc110$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $8caf005a546bc110$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $8caf005a546bc110$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $8caf005a546bc110$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8caf005a546bc110$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + ($8caf005a546bc110$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + ($8caf005a546bc110$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
var $8caf005a546bc110$export$2e2bcd8739ae039 = $8caf005a546bc110$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $d6d1ee5f0ac61ffe$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var $d6d1ee5f0ac61ffe$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $d6d1ee5f0ac61ffe$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d6d1ee5f0ac61ffe$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $d6d1ee5f0ac61ffe$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $d6d1ee5f0ac61ffe$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $d6d1ee5f0ac61ffe$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d6d1ee5f0ac61ffe$export$2e2bcd8739ae039 = $d6d1ee5f0ac61ffe$var$formatLong;


var $28bf05b40fc65255$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $28bf05b40fc65255$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $28bf05b40fc65255$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $28bf05b40fc65255$export$2e2bcd8739ae039 = $28bf05b40fc65255$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $4c4dec805e4b3cac$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var $4c4dec805e4b3cac$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var $4c4dec805e4b3cac$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var $4c4dec805e4b3cac$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var $4c4dec805e4b3cac$var$dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var $4c4dec805e4b3cac$var$formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var $4c4dec805e4b3cac$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $4c4dec805e4b3cac$var$localize = {
    ordinalNumber: $4c4dec805e4b3cac$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4c4dec805e4b3cac$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4c4dec805e4b3cac$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4c4dec805e4b3cac$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4c4dec805e4b3cac$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4c4dec805e4b3cac$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4c4dec805e4b3cac$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4c4dec805e4b3cac$export$2e2bcd8739ae039 = $4c4dec805e4b3cac$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $b327d3cc99a337b5$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $b327d3cc99a337b5$var$parseOrdinalNumberPattern = /\d+/i;
var $b327d3cc99a337b5$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $b327d3cc99a337b5$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $b327d3cc99a337b5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $b327d3cc99a337b5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b327d3cc99a337b5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $b327d3cc99a337b5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b327d3cc99a337b5$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $b327d3cc99a337b5$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $b327d3cc99a337b5$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $b327d3cc99a337b5$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $b327d3cc99a337b5$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $b327d3cc99a337b5$var$matchOrdinalNumberPattern,
        parsePattern: $b327d3cc99a337b5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $b327d3cc99a337b5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b327d3cc99a337b5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $b327d3cc99a337b5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b327d3cc99a337b5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $b327d3cc99a337b5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b327d3cc99a337b5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $b327d3cc99a337b5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b327d3cc99a337b5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $b327d3cc99a337b5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b327d3cc99a337b5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b327d3cc99a337b5$export$2e2bcd8739ae039 = $b327d3cc99a337b5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $d5df2822317297db$var$locale = {
    code: 'lb',
    formatDistance: (0, $8caf005a546bc110$export$2e2bcd8739ae039),
    formatLong: (0, $d6d1ee5f0ac61ffe$export$2e2bcd8739ae039),
    formatRelative: (0, $28bf05b40fc65255$export$2e2bcd8739ae039),
    localize: (0, $4c4dec805e4b3cac$export$2e2bcd8739ae039),
    match: (0, $b327d3cc99a337b5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d5df2822317297db$export$2e2bcd8739ae039 = $d5df2822317297db$var$locale;
module.exports["default"] = $d5df2822317297db$export$2e2bcd8739ae039;

});

parcelRegister("1iKSq", function(module, exports) {
var $a4d2300d27810644$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var $a4d2300d27810644$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var $a4d2300d27810644$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $a4d2300d27810644$var$forms(key)[0] : isFuture ? $a4d2300d27810644$var$forms(key)[1] : $a4d2300d27810644$var$forms(key)[2];
};
var $a4d2300d27810644$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + $a4d2300d27810644$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($a4d2300d27810644$var$special(number) ? $a4d2300d27810644$var$forms(key)[1] : $a4d2300d27810644$var$forms(key)[0]);
    else {
        if (isFuture) return result + $a4d2300d27810644$var$forms(key)[1];
        else return result + ($a4d2300d27810644$var$special(number) ? $a4d2300d27810644$var$forms(key)[1] : $a4d2300d27810644$var$forms(key)[2]);
    }
};
function $a4d2300d27810644$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $a4d2300d27810644$var$forms(key) {
    return $a4d2300d27810644$var$translations[key].split('_');
}
var $a4d2300d27810644$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $a4d2300d27810644$var$translateSeconds,
        other: $a4d2300d27810644$var$translate
    },
    xSeconds: {
        one: $a4d2300d27810644$var$translateSeconds,
        other: $a4d2300d27810644$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xMinutes: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    aboutXHours: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xHours: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xDays: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    aboutXWeeks: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xWeeks: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    aboutXMonths: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xMonths: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    aboutXYears: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    xYears: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    overXYears: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    },
    almostXYears: {
        one: $a4d2300d27810644$var$translateSingular,
        other: $a4d2300d27810644$var$translate
    }
};
var $a4d2300d27810644$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $a4d2300d27810644$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $a4d2300d27810644$var$translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
var $a4d2300d27810644$export$2e2bcd8739ae039 = $a4d2300d27810644$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $d883d21815f0278e$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var $d883d21815f0278e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $d883d21815f0278e$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d883d21815f0278e$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $d883d21815f0278e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $d883d21815f0278e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $d883d21815f0278e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d883d21815f0278e$export$2e2bcd8739ae039 = $d883d21815f0278e$var$formatLong;


var $85c56fe27bd8007c$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var $85c56fe27bd8007c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $85c56fe27bd8007c$var$formatRelativeLocale[token];
};
var $85c56fe27bd8007c$export$2e2bcd8739ae039 = $85c56fe27bd8007c$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8fadc73a98b31115$var$eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var $8fadc73a98b31115$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $8fadc73a98b31115$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $8fadc73a98b31115$var$monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var $8fadc73a98b31115$var$formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var $8fadc73a98b31115$var$dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var $8fadc73a98b31115$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var $8fadc73a98b31115$var$dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $8fadc73a98b31115$var$formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $8fadc73a98b31115$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var $8fadc73a98b31115$var$localize = {
    ordinalNumber: $8fadc73a98b31115$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8fadc73a98b31115$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8fadc73a98b31115$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $8fadc73a98b31115$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8fadc73a98b31115$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $8fadc73a98b31115$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8fadc73a98b31115$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $8fadc73a98b31115$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8fadc73a98b31115$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8fadc73a98b31115$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8fadc73a98b31115$export$2e2bcd8739ae039 = $8fadc73a98b31115$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $a73e6f004c0140cb$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $a73e6f004c0140cb$var$parseOrdinalNumberPattern = /\d+/i;
var $a73e6f004c0140cb$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $a73e6f004c0140cb$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $a73e6f004c0140cb$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $a73e6f004c0140cb$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $a73e6f004c0140cb$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $a73e6f004c0140cb$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $a73e6f004c0140cb$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $a73e6f004c0140cb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $a73e6f004c0140cb$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $a73e6f004c0140cb$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $a73e6f004c0140cb$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $a73e6f004c0140cb$var$matchOrdinalNumberPattern,
        parsePattern: $a73e6f004c0140cb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $a73e6f004c0140cb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a73e6f004c0140cb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $a73e6f004c0140cb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a73e6f004c0140cb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $a73e6f004c0140cb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a73e6f004c0140cb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $a73e6f004c0140cb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a73e6f004c0140cb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $a73e6f004c0140cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a73e6f004c0140cb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a73e6f004c0140cb$export$2e2bcd8739ae039 = $a73e6f004c0140cb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $0f2bd5a741cddb2d$var$locale = {
    code: 'lt',
    formatDistance: (0, $a4d2300d27810644$export$2e2bcd8739ae039),
    formatLong: (0, $d883d21815f0278e$export$2e2bcd8739ae039),
    formatRelative: (0, $85c56fe27bd8007c$export$2e2bcd8739ae039),
    localize: (0, $8fadc73a98b31115$export$2e2bcd8739ae039),
    match: (0, $a73e6f004c0140cb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0f2bd5a741cddb2d$export$2e2bcd8739ae039 = $0f2bd5a741cddb2d$var$locale;
module.exports["default"] = $0f2bd5a741cddb2d$export$2e2bcd8739ae039;

});

parcelRegister("jrpVX", function(module, exports) {
function $1b930f45745aacf7$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var $1b930f45745aacf7$var$formatDistanceLocale = {
    lessThanXSeconds: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: $1b930f45745aacf7$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var $1b930f45745aacf7$var$formatDistance = function formatDistance(token, count, options) {
    var result = $1b930f45745aacf7$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
var $1b930f45745aacf7$export$2e2bcd8739ae039 = $1b930f45745aacf7$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $9395aaac1f1f895c$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var $9395aaac1f1f895c$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9395aaac1f1f895c$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9395aaac1f1f895c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $9395aaac1f1f895c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $9395aaac1f1f895c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $9395aaac1f1f895c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9395aaac1f1f895c$export$2e2bcd8739ae039 = $9395aaac1f1f895c$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

var $d65b314bec91149d$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var $d65b314bec91149d$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $c3GpY.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $d65b314bec91149d$var$weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $c3GpY.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $d65b314bec91149d$var$weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var $d65b314bec91149d$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $d65b314bec91149d$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $d65b314bec91149d$export$2e2bcd8739ae039 = $d65b314bec91149d$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $0d93761e57dc4bf8$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var $0d93761e57dc4bf8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var $0d93761e57dc4bf8$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var $0d93761e57dc4bf8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var $0d93761e57dc4bf8$var$formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var $0d93761e57dc4bf8$var$dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var $0d93761e57dc4bf8$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var $0d93761e57dc4bf8$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var $0d93761e57dc4bf8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var $0d93761e57dc4bf8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $0d93761e57dc4bf8$var$localize = {
    ordinalNumber: $0d93761e57dc4bf8$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $0d93761e57dc4bf8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $0d93761e57dc4bf8$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $0d93761e57dc4bf8$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $0d93761e57dc4bf8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $0d93761e57dc4bf8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $0d93761e57dc4bf8$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $0d93761e57dc4bf8$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $0d93761e57dc4bf8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0d93761e57dc4bf8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0d93761e57dc4bf8$export$2e2bcd8739ae039 = $0d93761e57dc4bf8$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $e484d918a7e2487f$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $e484d918a7e2487f$var$parseOrdinalNumberPattern = /\d+/i;
var $e484d918a7e2487f$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $e484d918a7e2487f$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $e484d918a7e2487f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $e484d918a7e2487f$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $e484d918a7e2487f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $e484d918a7e2487f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e484d918a7e2487f$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $e484d918a7e2487f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $e484d918a7e2487f$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $e484d918a7e2487f$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $e484d918a7e2487f$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $e484d918a7e2487f$var$matchOrdinalNumberPattern,
        parsePattern: $e484d918a7e2487f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $e484d918a7e2487f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e484d918a7e2487f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $e484d918a7e2487f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e484d918a7e2487f$var$parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $e484d918a7e2487f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e484d918a7e2487f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $e484d918a7e2487f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e484d918a7e2487f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $e484d918a7e2487f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e484d918a7e2487f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e484d918a7e2487f$export$2e2bcd8739ae039 = $e484d918a7e2487f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $e274a7d5b59bcc32$var$locale = {
    code: 'lv',
    formatDistance: (0, $1b930f45745aacf7$export$2e2bcd8739ae039),
    formatLong: (0, $9395aaac1f1f895c$export$2e2bcd8739ae039),
    formatRelative: (0, $d65b314bec91149d$export$2e2bcd8739ae039),
    localize: (0, $0d93761e57dc4bf8$export$2e2bcd8739ae039),
    match: (0, $e484d918a7e2487f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e274a7d5b59bcc32$export$2e2bcd8739ae039 = $e274a7d5b59bcc32$var$locale;
module.exports["default"] = $e274a7d5b59bcc32$export$2e2bcd8739ae039;

});

parcelRegister("dS7Bb", function(module, exports) {
var $6872bfe709abcc9a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $6872bfe709abcc9a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6872bfe709abcc9a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
var $6872bfe709abcc9a$export$2e2bcd8739ae039 = $6872bfe709abcc9a$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $4412d1ff3f54b67a$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $4412d1ff3f54b67a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $4412d1ff3f54b67a$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $4412d1ff3f54b67a$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $4412d1ff3f54b67a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $4412d1ff3f54b67a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $4412d1ff3f54b67a$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $4412d1ff3f54b67a$export$2e2bcd8739ae039 = $4412d1ff3f54b67a$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

var $830c683003567ffb$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $830c683003567ffb$var$_lastWeek(day) {
    var weekday = $830c683003567ffb$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $830c683003567ffb$var$thisWeek(day) {
    var weekday = $830c683003567ffb$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $830c683003567ffb$var$_nextWeek(day) {
    var weekday = $830c683003567ffb$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var $830c683003567ffb$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $830c683003567ffb$var$thisWeek(day);
        else return $830c683003567ffb$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $830c683003567ffb$var$thisWeek(day);
        else return $830c683003567ffb$var$_nextWeek(day);
    },
    other: 'P'
};
var $830c683003567ffb$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $830c683003567ffb$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $830c683003567ffb$export$2e2bcd8739ae039 = $830c683003567ffb$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $e393dbcfaf387816$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $e393dbcfaf387816$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $e393dbcfaf387816$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $e393dbcfaf387816$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var $e393dbcfaf387816$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var $e393dbcfaf387816$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var $e393dbcfaf387816$var$localize = {
    ordinalNumber: $e393dbcfaf387816$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $e393dbcfaf387816$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $e393dbcfaf387816$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $e393dbcfaf387816$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $e393dbcfaf387816$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $e393dbcfaf387816$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e393dbcfaf387816$export$2e2bcd8739ae039 = $e393dbcfaf387816$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2764b24e43fffc7e$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $2764b24e43fffc7e$var$parseOrdinalNumberPattern = /\d+/i;
var $2764b24e43fffc7e$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $2764b24e43fffc7e$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $2764b24e43fffc7e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $2764b24e43fffc7e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2764b24e43fffc7e$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $2764b24e43fffc7e$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $2764b24e43fffc7e$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $2764b24e43fffc7e$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $2764b24e43fffc7e$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $2764b24e43fffc7e$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $2764b24e43fffc7e$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2764b24e43fffc7e$var$matchOrdinalNumberPattern,
        parsePattern: $2764b24e43fffc7e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2764b24e43fffc7e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2764b24e43fffc7e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2764b24e43fffc7e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2764b24e43fffc7e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2764b24e43fffc7e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2764b24e43fffc7e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2764b24e43fffc7e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2764b24e43fffc7e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2764b24e43fffc7e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2764b24e43fffc7e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2764b24e43fffc7e$export$2e2bcd8739ae039 = $2764b24e43fffc7e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $a1963679f2390562$var$locale = {
    code: 'mk',
    formatDistance: (0, $6872bfe709abcc9a$export$2e2bcd8739ae039),
    formatLong: (0, $4412d1ff3f54b67a$export$2e2bcd8739ae039),
    formatRelative: (0, $830c683003567ffb$export$2e2bcd8739ae039),
    localize: (0, $e393dbcfaf387816$export$2e2bcd8739ae039),
    match: (0, $2764b24e43fffc7e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a1963679f2390562$export$2e2bcd8739ae039 = $a1963679f2390562$var$locale;
module.exports["default"] = $a1963679f2390562$export$2e2bcd8739ae039;

});

parcelRegister("8paOO", function(module, exports) {
var $cbaec907efa0d9b1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var $cbaec907efa0d9b1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cbaec907efa0d9b1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
var $cbaec907efa0d9b1$export$2e2bcd8739ae039 = $cbaec907efa0d9b1$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $1522130f39d012ae$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var $1522130f39d012ae$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $1522130f39d012ae$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $1522130f39d012ae$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $1522130f39d012ae$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $1522130f39d012ae$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $1522130f39d012ae$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1522130f39d012ae$export$2e2bcd8739ae039 = $1522130f39d012ae$var$formatLong;


var $f2998ed03822101a$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var $f2998ed03822101a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f2998ed03822101a$var$formatRelativeLocale[token];
};
var $f2998ed03822101a$export$2e2bcd8739ae039 = $f2998ed03822101a$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $356cbc6ff8082556$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var $356cbc6ff8082556$var$quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $356cbc6ff8082556$var$monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $356cbc6ff8082556$var$formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $356cbc6ff8082556$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var $356cbc6ff8082556$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var $356cbc6ff8082556$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var $356cbc6ff8082556$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $356cbc6ff8082556$var$localize = {
    ordinalNumber: $356cbc6ff8082556$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $356cbc6ff8082556$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $356cbc6ff8082556$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $356cbc6ff8082556$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $356cbc6ff8082556$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $356cbc6ff8082556$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $356cbc6ff8082556$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $356cbc6ff8082556$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $356cbc6ff8082556$export$2e2bcd8739ae039 = $356cbc6ff8082556$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $d6db8b37d87882e1$var$matchOrdinalNumberPattern = /\d+/i;
var $d6db8b37d87882e1$var$parseOrdinalNumberPattern = /\d+/i;
var $d6db8b37d87882e1$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $d6db8b37d87882e1$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $d6db8b37d87882e1$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $d6db8b37d87882e1$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $d6db8b37d87882e1$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $d6db8b37d87882e1$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $d6db8b37d87882e1$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $d6db8b37d87882e1$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $d6db8b37d87882e1$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $d6db8b37d87882e1$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $d6db8b37d87882e1$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $d6db8b37d87882e1$var$matchOrdinalNumberPattern,
        parsePattern: $d6db8b37d87882e1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $d6db8b37d87882e1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d6db8b37d87882e1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $d6db8b37d87882e1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d6db8b37d87882e1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $d6db8b37d87882e1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d6db8b37d87882e1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $d6db8b37d87882e1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d6db8b37d87882e1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $d6db8b37d87882e1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d6db8b37d87882e1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d6db8b37d87882e1$export$2e2bcd8739ae039 = $d6db8b37d87882e1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $61e90cdbd864badf$var$locale = {
    code: 'mn',
    formatDistance: (0, $cbaec907efa0d9b1$export$2e2bcd8739ae039),
    formatLong: (0, $1522130f39d012ae$export$2e2bcd8739ae039),
    formatRelative: (0, $f2998ed03822101a$export$2e2bcd8739ae039),
    localize: (0, $356cbc6ff8082556$export$2e2bcd8739ae039),
    match: (0, $d6db8b37d87882e1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $61e90cdbd864badf$export$2e2bcd8739ae039 = $61e90cdbd864badf$var$locale;
module.exports["default"] = $61e90cdbd864badf$export$2e2bcd8739ae039;

});

parcelRegister("cW6rW", function(module, exports) {
var $99cdf1a428f8157f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $99cdf1a428f8157f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $99cdf1a428f8157f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $99cdf1a428f8157f$export$2e2bcd8739ae039 = $99cdf1a428f8157f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $86b6dfc8018223c6$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $86b6dfc8018223c6$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $86b6dfc8018223c6$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $86b6dfc8018223c6$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $86b6dfc8018223c6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $86b6dfc8018223c6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $86b6dfc8018223c6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $86b6dfc8018223c6$export$2e2bcd8739ae039 = $86b6dfc8018223c6$var$formatLong;


var $b966e67c9200e39c$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var $b966e67c9200e39c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b966e67c9200e39c$var$formatRelativeLocale[token];
};
var $b966e67c9200e39c$export$2e2bcd8739ae039 = $b966e67c9200e39c$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $a0d1b07f47f222b0$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var $a0d1b07f47f222b0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a0d1b07f47f222b0$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var $a0d1b07f47f222b0$var$dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var $a0d1b07f47f222b0$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $a0d1b07f47f222b0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $a0d1b07f47f222b0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var $a0d1b07f47f222b0$var$localize = {
    ordinalNumber: $a0d1b07f47f222b0$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $a0d1b07f47f222b0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $a0d1b07f47f222b0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $a0d1b07f47f222b0$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $a0d1b07f47f222b0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $a0d1b07f47f222b0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a0d1b07f47f222b0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a0d1b07f47f222b0$export$2e2bcd8739ae039 = $a0d1b07f47f222b0$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $ba7fe65a8e3f7bb8$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $ba7fe65a8e3f7bb8$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $ba7fe65a8e3f7bb8$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $ba7fe65a8e3f7bb8$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $ba7fe65a8e3f7bb8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $ba7fe65a8e3f7bb8$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $ba7fe65a8e3f7bb8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $ba7fe65a8e3f7bb8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $ba7fe65a8e3f7bb8$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $ba7fe65a8e3f7bb8$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $ba7fe65a8e3f7bb8$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $ba7fe65a8e3f7bb8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $ba7fe65a8e3f7bb8$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $ba7fe65a8e3f7bb8$var$matchOrdinalNumberPattern,
        parsePattern: $ba7fe65a8e3f7bb8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $ba7fe65a8e3f7bb8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba7fe65a8e3f7bb8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $ba7fe65a8e3f7bb8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba7fe65a8e3f7bb8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $ba7fe65a8e3f7bb8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba7fe65a8e3f7bb8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $ba7fe65a8e3f7bb8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba7fe65a8e3f7bb8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $ba7fe65a8e3f7bb8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ba7fe65a8e3f7bb8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ba7fe65a8e3f7bb8$export$2e2bcd8739ae039 = $ba7fe65a8e3f7bb8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $96afe7914b2899ff$var$locale = {
    code: 'ms',
    formatDistance: (0, $99cdf1a428f8157f$export$2e2bcd8739ae039),
    formatLong: (0, $86b6dfc8018223c6$export$2e2bcd8739ae039),
    formatRelative: (0, $b966e67c9200e39c$export$2e2bcd8739ae039),
    localize: (0, $a0d1b07f47f222b0$export$2e2bcd8739ae039),
    match: (0, $ba7fe65a8e3f7bb8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $96afe7914b2899ff$export$2e2bcd8739ae039 = $96afe7914b2899ff$var$locale;
module.exports["default"] = $96afe7914b2899ff$export$2e2bcd8739ae039;

});

parcelRegister("biuzd", function(module, exports) {
var $ff3a5efe2576bc92$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var $ff3a5efe2576bc92$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ff3a5efe2576bc92$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
var $ff3a5efe2576bc92$export$2e2bcd8739ae039 = $ff3a5efe2576bc92$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $369125402ce09abf$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $369125402ce09abf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $369125402ce09abf$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $369125402ce09abf$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $369125402ce09abf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $369125402ce09abf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $369125402ce09abf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $369125402ce09abf$export$2e2bcd8739ae039 = $369125402ce09abf$var$formatLong;


var $418bc0f51dd66f5e$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var $418bc0f51dd66f5e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $418bc0f51dd66f5e$var$formatRelativeLocale[token];
};
var $418bc0f51dd66f5e$export$2e2bcd8739ae039 = $418bc0f51dd66f5e$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $5528d46408b38ac8$var$eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var $5528d46408b38ac8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var $5528d46408b38ac8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var $5528d46408b38ac8$var$dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var $5528d46408b38ac8$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var $5528d46408b38ac8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var $5528d46408b38ac8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $5528d46408b38ac8$var$localize = {
    ordinalNumber: $5528d46408b38ac8$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5528d46408b38ac8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5528d46408b38ac8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $5528d46408b38ac8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5528d46408b38ac8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5528d46408b38ac8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5528d46408b38ac8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5528d46408b38ac8$export$2e2bcd8739ae039 = $5528d46408b38ac8$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $57ed04e658b720c1$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $57ed04e658b720c1$var$parseOrdinalNumberPattern = /\d+/i;
var $57ed04e658b720c1$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $57ed04e658b720c1$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $57ed04e658b720c1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $57ed04e658b720c1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $57ed04e658b720c1$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $57ed04e658b720c1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $57ed04e658b720c1$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $57ed04e658b720c1$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $57ed04e658b720c1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $57ed04e658b720c1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $57ed04e658b720c1$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $57ed04e658b720c1$var$matchOrdinalNumberPattern,
        parsePattern: $57ed04e658b720c1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $57ed04e658b720c1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57ed04e658b720c1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $57ed04e658b720c1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57ed04e658b720c1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $57ed04e658b720c1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57ed04e658b720c1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $57ed04e658b720c1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57ed04e658b720c1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $57ed04e658b720c1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $57ed04e658b720c1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $57ed04e658b720c1$export$2e2bcd8739ae039 = $57ed04e658b720c1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $8399161ea3804426$var$locale = {
    code: 'mt',
    formatDistance: (0, $ff3a5efe2576bc92$export$2e2bcd8739ae039),
    formatLong: (0, $369125402ce09abf$export$2e2bcd8739ae039),
    formatRelative: (0, $418bc0f51dd66f5e$export$2e2bcd8739ae039),
    localize: (0, $5528d46408b38ac8$export$2e2bcd8739ae039),
    match: (0, $57ed04e658b720c1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8399161ea3804426$export$2e2bcd8739ae039 = $8399161ea3804426$var$locale;
module.exports["default"] = $8399161ea3804426$export$2e2bcd8739ae039;

});

parcelRegister("1WYEH", function(module, exports) {
var $34e2f8d5317b908f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $34e2f8d5317b908f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $34e2f8d5317b908f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $34e2f8d5317b908f$export$2e2bcd8739ae039 = $34e2f8d5317b908f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $29cffa3dece9919e$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $29cffa3dece9919e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $29cffa3dece9919e$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $29cffa3dece9919e$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $29cffa3dece9919e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $29cffa3dece9919e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $29cffa3dece9919e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $29cffa3dece9919e$export$2e2bcd8739ae039 = $29cffa3dece9919e$var$formatLong;


var $163d366cefa20dc5$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $163d366cefa20dc5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $163d366cefa20dc5$var$formatRelativeLocale[token];
};
var $163d366cefa20dc5$export$2e2bcd8739ae039 = $163d366cefa20dc5$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $5a46dc0844bfe221$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $5a46dc0844bfe221$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $5a46dc0844bfe221$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $5a46dc0844bfe221$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $5a46dc0844bfe221$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $5a46dc0844bfe221$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $5a46dc0844bfe221$var$localize = {
    ordinalNumber: $5a46dc0844bfe221$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5a46dc0844bfe221$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5a46dc0844bfe221$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $5a46dc0844bfe221$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5a46dc0844bfe221$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5a46dc0844bfe221$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $5a46dc0844bfe221$export$2e2bcd8739ae039 = $5a46dc0844bfe221$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $a75934f760020116$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $a75934f760020116$var$parseOrdinalNumberPattern = /\d+/i;
var $a75934f760020116$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $a75934f760020116$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $a75934f760020116$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $a75934f760020116$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a75934f760020116$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $a75934f760020116$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $a75934f760020116$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $a75934f760020116$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $a75934f760020116$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $a75934f760020116$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $a75934f760020116$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $a75934f760020116$var$matchOrdinalNumberPattern,
        parsePattern: $a75934f760020116$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $a75934f760020116$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a75934f760020116$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $a75934f760020116$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a75934f760020116$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $a75934f760020116$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a75934f760020116$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $a75934f760020116$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a75934f760020116$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $a75934f760020116$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a75934f760020116$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a75934f760020116$export$2e2bcd8739ae039 = $a75934f760020116$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $16ba421b78b585a8$var$locale = {
    code: 'nl-BE',
    formatDistance: (0, $34e2f8d5317b908f$export$2e2bcd8739ae039),
    formatLong: (0, $29cffa3dece9919e$export$2e2bcd8739ae039),
    formatRelative: (0, $163d366cefa20dc5$export$2e2bcd8739ae039),
    localize: (0, $5a46dc0844bfe221$export$2e2bcd8739ae039),
    match: (0, $a75934f760020116$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $16ba421b78b585a8$export$2e2bcd8739ae039 = $16ba421b78b585a8$var$locale;
module.exports["default"] = $16ba421b78b585a8$export$2e2bcd8739ae039;

});

parcelRegister("dDyCC", function(module, exports) {
var $7ef3dc2804205dbe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $7ef3dc2804205dbe$var$wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var $7ef3dc2804205dbe$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7ef3dc2804205dbe$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $7ef3dc2804205dbe$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
var $7ef3dc2804205dbe$export$2e2bcd8739ae039 = $7ef3dc2804205dbe$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $5b936b773ccecf1f$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $5b936b773ccecf1f$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $5b936b773ccecf1f$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $5b936b773ccecf1f$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $5b936b773ccecf1f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $5b936b773ccecf1f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $5b936b773ccecf1f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5b936b773ccecf1f$export$2e2bcd8739ae039 = $5b936b773ccecf1f$var$formatLong;


var $b62ea595f98cee48$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $b62ea595f98cee48$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b62ea595f98cee48$var$formatRelativeLocale[token];
};
var $b62ea595f98cee48$export$2e2bcd8739ae039 = $b62ea595f98cee48$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $40ac11bbcf9894ae$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $40ac11bbcf9894ae$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $40ac11bbcf9894ae$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $40ac11bbcf9894ae$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var $40ac11bbcf9894ae$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $40ac11bbcf9894ae$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $40ac11bbcf9894ae$var$localize = {
    ordinalNumber: $40ac11bbcf9894ae$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $40ac11bbcf9894ae$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $40ac11bbcf9894ae$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $40ac11bbcf9894ae$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $40ac11bbcf9894ae$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $40ac11bbcf9894ae$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $40ac11bbcf9894ae$export$2e2bcd8739ae039 = $40ac11bbcf9894ae$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2ba38be32499fe63$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $2ba38be32499fe63$var$parseOrdinalNumberPattern = /\d+/i;
var $2ba38be32499fe63$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $2ba38be32499fe63$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $2ba38be32499fe63$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $2ba38be32499fe63$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2ba38be32499fe63$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $2ba38be32499fe63$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2ba38be32499fe63$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $2ba38be32499fe63$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $2ba38be32499fe63$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $2ba38be32499fe63$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $2ba38be32499fe63$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2ba38be32499fe63$var$matchOrdinalNumberPattern,
        parsePattern: $2ba38be32499fe63$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2ba38be32499fe63$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ba38be32499fe63$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2ba38be32499fe63$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ba38be32499fe63$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2ba38be32499fe63$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ba38be32499fe63$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2ba38be32499fe63$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ba38be32499fe63$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2ba38be32499fe63$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2ba38be32499fe63$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2ba38be32499fe63$export$2e2bcd8739ae039 = $2ba38be32499fe63$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $9ed9c616a915294f$var$locale = {
    code: 'nn',
    formatDistance: (0, $7ef3dc2804205dbe$export$2e2bcd8739ae039),
    formatLong: (0, $5b936b773ccecf1f$export$2e2bcd8739ae039),
    formatRelative: (0, $b62ea595f98cee48$export$2e2bcd8739ae039),
    localize: (0, $40ac11bbcf9894ae$export$2e2bcd8739ae039),
    match: (0, $2ba38be32499fe63$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9ed9c616a915294f$export$2e2bcd8739ae039 = $9ed9c616a915294f$var$locale;
module.exports["default"] = $9ed9c616a915294f$export$2e2bcd8739ae039;

});

parcelRegister("67k4F", function(module, exports) {
var $4a647cc770a2725c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var $4a647cc770a2725c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4a647cc770a2725c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
var $4a647cc770a2725c$export$2e2bcd8739ae039 = $4a647cc770a2725c$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $88c8193b79ae025c$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $88c8193b79ae025c$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $88c8193b79ae025c$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $88c8193b79ae025c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $88c8193b79ae025c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $88c8193b79ae025c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $88c8193b79ae025c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $88c8193b79ae025c$export$2e2bcd8739ae039 = $88c8193b79ae025c$var$formatLong;


var $42e8cf403ef041cd$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var $42e8cf403ef041cd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $42e8cf403ef041cd$var$formatRelativeLocale[token];
};
var $42e8cf403ef041cd$export$2e2bcd8739ae039 = $42e8cf403ef041cd$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $f933349884607ac0$var$eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $f933349884607ac0$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $f933349884607ac0$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var $f933349884607ac0$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var $f933349884607ac0$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $f933349884607ac0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var $f933349884607ac0$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var $f933349884607ac0$var$localize = {
    ordinalNumber: $f933349884607ac0$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $f933349884607ac0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $f933349884607ac0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $f933349884607ac0$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $f933349884607ac0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $f933349884607ac0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f933349884607ac0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f933349884607ac0$export$2e2bcd8739ae039 = $f933349884607ac0$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $72f9d265fcb88041$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $72f9d265fcb88041$var$parseOrdinalNumberPattern = /\d+/i;
var $72f9d265fcb88041$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $72f9d265fcb88041$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $72f9d265fcb88041$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $72f9d265fcb88041$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $72f9d265fcb88041$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $72f9d265fcb88041$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $72f9d265fcb88041$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $72f9d265fcb88041$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $72f9d265fcb88041$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $72f9d265fcb88041$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $72f9d265fcb88041$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $72f9d265fcb88041$var$matchOrdinalNumberPattern,
        parsePattern: $72f9d265fcb88041$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $72f9d265fcb88041$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72f9d265fcb88041$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $72f9d265fcb88041$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72f9d265fcb88041$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $72f9d265fcb88041$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72f9d265fcb88041$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $72f9d265fcb88041$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72f9d265fcb88041$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $72f9d265fcb88041$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $72f9d265fcb88041$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $72f9d265fcb88041$export$2e2bcd8739ae039 = $72f9d265fcb88041$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $4742f7de445d885d$var$locale = {
    code: 'oc',
    formatDistance: (0, $4a647cc770a2725c$export$2e2bcd8739ae039),
    formatLong: (0, $88c8193b79ae025c$export$2e2bcd8739ae039),
    formatRelative: (0, $42e8cf403ef041cd$export$2e2bcd8739ae039),
    localize: (0, $f933349884607ac0$export$2e2bcd8739ae039),
    match: (0, $72f9d265fcb88041$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4742f7de445d885d$export$2e2bcd8739ae039 = $4742f7de445d885d$var$locale;
module.exports["default"] = $4742f7de445d885d$export$2e2bcd8739ae039;

});

parcelRegister("g39vH", function(module, exports) {
var $53a3233f6611dfbc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $53a3233f6611dfbc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $53a3233f6611dfbc$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $53a3233f6611dfbc$export$2e2bcd8739ae039 = $53a3233f6611dfbc$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $1d04254638cd77db$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $1d04254638cd77db$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $1d04254638cd77db$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1d04254638cd77db$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $1d04254638cd77db$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $1d04254638cd77db$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $1d04254638cd77db$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1d04254638cd77db$export$2e2bcd8739ae039 = $1d04254638cd77db$var$formatLong;


var $ec8816b18737bed1$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $ec8816b18737bed1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ec8816b18737bed1$var$formatRelativeLocale[token];
};
var $ec8816b18737bed1$export$2e2bcd8739ae039 = $ec8816b18737bed1$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $9ba985044a5dd26f$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $9ba985044a5dd26f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $9ba985044a5dd26f$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $9ba985044a5dd26f$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $9ba985044a5dd26f$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $9ba985044a5dd26f$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $9ba985044a5dd26f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $9ba985044a5dd26f$var$localize = {
    ordinalNumber: $9ba985044a5dd26f$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $9ba985044a5dd26f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $9ba985044a5dd26f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $9ba985044a5dd26f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $9ba985044a5dd26f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $9ba985044a5dd26f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9ba985044a5dd26f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9ba985044a5dd26f$export$2e2bcd8739ae039 = $9ba985044a5dd26f$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $fdd44f317ba13663$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $fdd44f317ba13663$var$parseOrdinalNumberPattern = /\d+/i;
var $fdd44f317ba13663$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $fdd44f317ba13663$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $fdd44f317ba13663$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $fdd44f317ba13663$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fdd44f317ba13663$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $fdd44f317ba13663$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fdd44f317ba13663$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $fdd44f317ba13663$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $fdd44f317ba13663$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $fdd44f317ba13663$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $fdd44f317ba13663$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $fdd44f317ba13663$var$matchOrdinalNumberPattern,
        parsePattern: $fdd44f317ba13663$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $fdd44f317ba13663$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fdd44f317ba13663$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $fdd44f317ba13663$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fdd44f317ba13663$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $fdd44f317ba13663$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fdd44f317ba13663$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $fdd44f317ba13663$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fdd44f317ba13663$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $fdd44f317ba13663$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fdd44f317ba13663$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fdd44f317ba13663$export$2e2bcd8739ae039 = $fdd44f317ba13663$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $baf44db0130ff2d0$var$locale = {
    code: 'ro',
    formatDistance: (0, $53a3233f6611dfbc$export$2e2bcd8739ae039),
    formatLong: (0, $1d04254638cd77db$export$2e2bcd8739ae039),
    formatRelative: (0, $ec8816b18737bed1$export$2e2bcd8739ae039),
    localize: (0, $9ba985044a5dd26f$export$2e2bcd8739ae039),
    match: (0, $fdd44f317ba13663$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $baf44db0130ff2d0$export$2e2bcd8739ae039 = $baf44db0130ff2d0$var$locale;
module.exports["default"] = $baf44db0130ff2d0$export$2e2bcd8739ae039;

});

parcelRegister("dsLkK", function(module, exports) {
function $51237750bace10d7$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $51237750bace10d7$var$declension(scheme, count, time) {
    var group = $51237750bace10d7$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $51237750bace10d7$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $51237750bace10d7$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $51237750bace10d7$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $51237750bace10d7$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $51237750bace10d7$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $51237750bace10d7$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $51237750bace10d7$var$extractPreposition(token) || '';
    var key = $51237750bace10d7$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $51237750bace10d7$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $51237750bace10d7$var$prefixPreposition(preposition) + $51237750bace10d7$var$suffixPreposition(preposition) + $51237750bace10d7$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $51237750bace10d7$var$prefixPreposition(preposition) + 'o ' + $51237750bace10d7$var$suffixPreposition(preposition) + $51237750bace10d7$var$declension(scheme, count, 'future');
    else return $51237750bace10d7$var$prefixPreposition(preposition) + 'pred ' + $51237750bace10d7$var$suffixPreposition(preposition) + $51237750bace10d7$var$declension(scheme, count, 'past');
};
var $51237750bace10d7$export$2e2bcd8739ae039 = $51237750bace10d7$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $5839738fd8d8971b$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $5839738fd8d8971b$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $5839738fd8d8971b$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $5839738fd8d8971b$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $5839738fd8d8971b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $5839738fd8d8971b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $5839738fd8d8971b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5839738fd8d8971b$export$2e2bcd8739ae039 = $5839738fd8d8971b$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $5f888a9385100581$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $5f888a9385100581$var$_lastWeek(day) {
    var weekday = $5f888a9385100581$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $5f888a9385100581$var$thisWeek(day) {
    var weekday = $5f888a9385100581$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $5f888a9385100581$var$_nextWeek(day) {
    var weekday = $5f888a9385100581$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $5f888a9385100581$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $5f888a9385100581$var$thisWeek(day);
        else return $5f888a9385100581$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $5f888a9385100581$var$thisWeek(day);
        else return $5f888a9385100581$var$_nextWeek(day);
    },
    other: 'P'
};
var $5f888a9385100581$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $5f888a9385100581$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $5f888a9385100581$export$2e2bcd8739ae039 = $5f888a9385100581$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $ac4a725bb3dee11a$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $ac4a725bb3dee11a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $ac4a725bb3dee11a$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $ac4a725bb3dee11a$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $ac4a725bb3dee11a$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $ac4a725bb3dee11a$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $ac4a725bb3dee11a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $ac4a725bb3dee11a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $ac4a725bb3dee11a$var$localize = {
    ordinalNumber: $ac4a725bb3dee11a$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $ac4a725bb3dee11a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $ac4a725bb3dee11a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $ac4a725bb3dee11a$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $ac4a725bb3dee11a$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $ac4a725bb3dee11a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $ac4a725bb3dee11a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ac4a725bb3dee11a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ac4a725bb3dee11a$export$2e2bcd8739ae039 = $ac4a725bb3dee11a$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $2b44fc68d08f53ff$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $2b44fc68d08f53ff$var$parseOrdinalNumberPattern = /\d+/i;
var $2b44fc68d08f53ff$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $2b44fc68d08f53ff$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $2b44fc68d08f53ff$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $2b44fc68d08f53ff$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2b44fc68d08f53ff$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $2b44fc68d08f53ff$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2b44fc68d08f53ff$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $2b44fc68d08f53ff$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $2b44fc68d08f53ff$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $2b44fc68d08f53ff$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $2b44fc68d08f53ff$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $2b44fc68d08f53ff$var$matchOrdinalNumberPattern,
        parsePattern: $2b44fc68d08f53ff$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $2b44fc68d08f53ff$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b44fc68d08f53ff$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $2b44fc68d08f53ff$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b44fc68d08f53ff$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $2b44fc68d08f53ff$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b44fc68d08f53ff$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $2b44fc68d08f53ff$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b44fc68d08f53ff$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $2b44fc68d08f53ff$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2b44fc68d08f53ff$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2b44fc68d08f53ff$export$2e2bcd8739ae039 = $2b44fc68d08f53ff$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $9cd29b56b122d218$var$locale = {
    code: 'sk',
    formatDistance: (0, $51237750bace10d7$export$2e2bcd8739ae039),
    formatLong: (0, $5839738fd8d8971b$export$2e2bcd8739ae039),
    formatRelative: (0, $5f888a9385100581$export$2e2bcd8739ae039),
    localize: (0, $ac4a725bb3dee11a$export$2e2bcd8739ae039),
    match: (0, $2b44fc68d08f53ff$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9cd29b56b122d218$export$2e2bcd8739ae039 = $9cd29b56b122d218$var$locale;
module.exports["default"] = $9cd29b56b122d218$export$2e2bcd8739ae039;

});

parcelRegister("4TLob", function(module, exports) {
function $ca3d8fa8d6ec323b$var$isPluralType(val) {
    return val.one !== undefined;
}
var $ca3d8fa8d6ec323b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function $ca3d8fa8d6ec323b$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var $ca3d8fa8d6ec323b$var$formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = $ca3d8fa8d6ec323b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = $ca3d8fa8d6ec323b$var$getFormFromCount(count);
        if ($ca3d8fa8d6ec323b$var$isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
var $ca3d8fa8d6ec323b$export$2e2bcd8739ae039 = $ca3d8fa8d6ec323b$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $a228889fb6b64126$var$dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var $a228889fb6b64126$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a228889fb6b64126$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $a228889fb6b64126$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $a228889fb6b64126$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $a228889fb6b64126$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $a228889fb6b64126$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a228889fb6b64126$export$2e2bcd8739ae039 = $a228889fb6b64126$var$formatLong;


var $7147bad4639475a6$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var $7147bad4639475a6$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $7147bad4639475a6$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $7147bad4639475a6$export$2e2bcd8739ae039 = $7147bad4639475a6$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $3379a9c306ca83df$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var $3379a9c306ca83df$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var $3379a9c306ca83df$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $3379a9c306ca83df$var$dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var $3379a9c306ca83df$var$dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var $3379a9c306ca83df$var$formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var $3379a9c306ca83df$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $3379a9c306ca83df$var$localize = {
    ordinalNumber: $3379a9c306ca83df$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $3379a9c306ca83df$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $3379a9c306ca83df$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $3379a9c306ca83df$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $3379a9c306ca83df$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $3379a9c306ca83df$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3379a9c306ca83df$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3379a9c306ca83df$export$2e2bcd8739ae039 = $3379a9c306ca83df$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $36506c3a9812de8c$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $36506c3a9812de8c$var$parseOrdinalNumberPattern = /\d+/i;
var $36506c3a9812de8c$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $36506c3a9812de8c$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $36506c3a9812de8c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $36506c3a9812de8c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $36506c3a9812de8c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $36506c3a9812de8c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $36506c3a9812de8c$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $36506c3a9812de8c$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $36506c3a9812de8c$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $36506c3a9812de8c$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $36506c3a9812de8c$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $36506c3a9812de8c$var$matchOrdinalNumberPattern,
        parsePattern: $36506c3a9812de8c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $36506c3a9812de8c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36506c3a9812de8c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $36506c3a9812de8c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36506c3a9812de8c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $36506c3a9812de8c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36506c3a9812de8c$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $36506c3a9812de8c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36506c3a9812de8c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $36506c3a9812de8c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $36506c3a9812de8c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $36506c3a9812de8c$export$2e2bcd8739ae039 = $36506c3a9812de8c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $39110ef274310733$var$locale = {
    code: 'sl',
    formatDistance: (0, $ca3d8fa8d6ec323b$export$2e2bcd8739ae039),
    formatLong: (0, $a228889fb6b64126$export$2e2bcd8739ae039),
    formatRelative: (0, $7147bad4639475a6$export$2e2bcd8739ae039),
    localize: (0, $3379a9c306ca83df$export$2e2bcd8739ae039),
    match: (0, $36506c3a9812de8c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $39110ef274310733$export$2e2bcd8739ae039 = $39110ef274310733$var$locale;
module.exports["default"] = $39110ef274310733$export$2e2bcd8739ae039;

});

parcelRegister("5Jdcc", function(module, exports) {
var $1363c8e74b45a009$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var $1363c8e74b45a009$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1363c8e74b45a009$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $1363c8e74b45a009$export$2e2bcd8739ae039 = $1363c8e74b45a009$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $d4f62d1bab55ab5d$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $d4f62d1bab55ab5d$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d4f62d1bab55ab5d$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d4f62d1bab55ab5d$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $d4f62d1bab55ab5d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $d4f62d1bab55ab5d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $d4f62d1bab55ab5d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d4f62d1bab55ab5d$export$2e2bcd8739ae039 = $d4f62d1bab55ab5d$var$formatLong;


var $d88d28a0c24a30e5$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $d88d28a0c24a30e5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d88d28a0c24a30e5$var$formatRelativeLocale[token];
};
var $d88d28a0c24a30e5$export$2e2bcd8739ae039 = $d88d28a0c24a30e5$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $385364a3bf482185$var$eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var $385364a3bf482185$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $385364a3bf482185$var$monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var $385364a3bf482185$var$dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var $385364a3bf482185$var$dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $385364a3bf482185$var$formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $385364a3bf482185$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var $385364a3bf482185$var$localize = {
    ordinalNumber: $385364a3bf482185$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $385364a3bf482185$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $385364a3bf482185$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $385364a3bf482185$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $385364a3bf482185$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $385364a3bf482185$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $385364a3bf482185$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $385364a3bf482185$export$2e2bcd8739ae039 = $385364a3bf482185$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $d08c4a71b77205bc$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $d08c4a71b77205bc$var$parseOrdinalNumberPattern = /\d+/i;
var $d08c4a71b77205bc$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $d08c4a71b77205bc$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $d08c4a71b77205bc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $d08c4a71b77205bc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d08c4a71b77205bc$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $d08c4a71b77205bc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $d08c4a71b77205bc$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $d08c4a71b77205bc$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $d08c4a71b77205bc$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $d08c4a71b77205bc$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $d08c4a71b77205bc$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $d08c4a71b77205bc$var$matchOrdinalNumberPattern,
        parsePattern: $d08c4a71b77205bc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $d08c4a71b77205bc$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d08c4a71b77205bc$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $d08c4a71b77205bc$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d08c4a71b77205bc$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $d08c4a71b77205bc$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d08c4a71b77205bc$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $d08c4a71b77205bc$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d08c4a71b77205bc$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $d08c4a71b77205bc$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d08c4a71b77205bc$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d08c4a71b77205bc$export$2e2bcd8739ae039 = $d08c4a71b77205bc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $42bb6423cebf4b9f$var$locale = {
    code: 'sq',
    formatDistance: (0, $1363c8e74b45a009$export$2e2bcd8739ae039),
    formatLong: (0, $d4f62d1bab55ab5d$export$2e2bcd8739ae039),
    formatRelative: (0, $d88d28a0c24a30e5$export$2e2bcd8739ae039),
    localize: (0, $385364a3bf482185$export$2e2bcd8739ae039),
    match: (0, $d08c4a71b77205bc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $42bb6423cebf4b9f$export$2e2bcd8739ae039 = $42bb6423cebf4b9f$var$locale;
module.exports["default"] = $42bb6423cebf4b9f$export$2e2bcd8739ae039;

});

parcelRegister("gA4BZ", function(module, exports) {
var $f8f44a763fb32f62$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var $f8f44a763fb32f62$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f8f44a763fb32f62$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
var $f8f44a763fb32f62$export$2e2bcd8739ae039 = $f8f44a763fb32f62$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $96031e721c83c8b7$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $96031e721c83c8b7$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $96031e721c83c8b7$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $96031e721c83c8b7$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $96031e721c83c8b7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $96031e721c83c8b7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $96031e721c83c8b7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $96031e721c83c8b7$export$2e2bcd8739ae039 = $96031e721c83c8b7$var$formatLong;


var $092cef0ed8dc0638$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var $092cef0ed8dc0638$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $092cef0ed8dc0638$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $092cef0ed8dc0638$export$2e2bcd8739ae039 = $092cef0ed8dc0638$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $26f409decd1da2a4$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var $26f409decd1da2a4$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $26f409decd1da2a4$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $26f409decd1da2a4$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $26f409decd1da2a4$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $26f409decd1da2a4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $26f409decd1da2a4$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $26f409decd1da2a4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $26f409decd1da2a4$var$localize = {
    ordinalNumber: $26f409decd1da2a4$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $26f409decd1da2a4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $26f409decd1da2a4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $26f409decd1da2a4$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $26f409decd1da2a4$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $26f409decd1da2a4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $26f409decd1da2a4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $26f409decd1da2a4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $26f409decd1da2a4$export$2e2bcd8739ae039 = $26f409decd1da2a4$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $83a45d33c2cb0ce0$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $83a45d33c2cb0ce0$var$parseOrdinalNumberPattern = /\d+/i;
var $83a45d33c2cb0ce0$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $83a45d33c2cb0ce0$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $83a45d33c2cb0ce0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $83a45d33c2cb0ce0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $83a45d33c2cb0ce0$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $83a45d33c2cb0ce0$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $83a45d33c2cb0ce0$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $83a45d33c2cb0ce0$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $83a45d33c2cb0ce0$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $83a45d33c2cb0ce0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $83a45d33c2cb0ce0$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $83a45d33c2cb0ce0$var$matchOrdinalNumberPattern,
        parsePattern: $83a45d33c2cb0ce0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $83a45d33c2cb0ce0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a45d33c2cb0ce0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $83a45d33c2cb0ce0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a45d33c2cb0ce0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $83a45d33c2cb0ce0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a45d33c2cb0ce0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $83a45d33c2cb0ce0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a45d33c2cb0ce0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $83a45d33c2cb0ce0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $83a45d33c2cb0ce0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $83a45d33c2cb0ce0$export$2e2bcd8739ae039 = $83a45d33c2cb0ce0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $c12395e81d34277e$var$locale = {
    code: 'sr',
    formatDistance: (0, $f8f44a763fb32f62$export$2e2bcd8739ae039),
    formatLong: (0, $96031e721c83c8b7$export$2e2bcd8739ae039),
    formatRelative: (0, $092cef0ed8dc0638$export$2e2bcd8739ae039),
    localize: (0, $26f409decd1da2a4$export$2e2bcd8739ae039),
    match: (0, $83a45d33c2cb0ce0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c12395e81d34277e$export$2e2bcd8739ae039 = $c12395e81d34277e$var$locale;
module.exports["default"] = $c12395e81d34277e$export$2e2bcd8739ae039;

});

parcelRegister("bv7hX", function(module, exports) {
var $093d1a60727f3b03$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $093d1a60727f3b03$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $093d1a60727f3b03$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
var $093d1a60727f3b03$export$2e2bcd8739ae039 = $093d1a60727f3b03$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $9d2a53d8e0527051$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $9d2a53d8e0527051$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9d2a53d8e0527051$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $9d2a53d8e0527051$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $9d2a53d8e0527051$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $9d2a53d8e0527051$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $9d2a53d8e0527051$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9d2a53d8e0527051$export$2e2bcd8739ae039 = $9d2a53d8e0527051$var$formatLong;


var $b7ab6df8d4107b18$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $b7ab6df8d4107b18$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b7ab6df8d4107b18$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $b7ab6df8d4107b18$export$2e2bcd8739ae039 = $b7ab6df8d4107b18$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $ba93350b489354d4$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var $ba93350b489354d4$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $ba93350b489354d4$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $ba93350b489354d4$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $ba93350b489354d4$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $ba93350b489354d4$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $ba93350b489354d4$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $ba93350b489354d4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $ba93350b489354d4$var$localize = {
    ordinalNumber: $ba93350b489354d4$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $ba93350b489354d4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $ba93350b489354d4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $ba93350b489354d4$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $ba93350b489354d4$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $ba93350b489354d4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $ba93350b489354d4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ba93350b489354d4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ba93350b489354d4$export$2e2bcd8739ae039 = $ba93350b489354d4$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $a2eb5c06a125d713$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $a2eb5c06a125d713$var$parseOrdinalNumberPattern = /\d+/i;
var $a2eb5c06a125d713$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $a2eb5c06a125d713$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $a2eb5c06a125d713$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $a2eb5c06a125d713$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a2eb5c06a125d713$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $a2eb5c06a125d713$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a2eb5c06a125d713$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $a2eb5c06a125d713$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a2eb5c06a125d713$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $a2eb5c06a125d713$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $a2eb5c06a125d713$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $a2eb5c06a125d713$var$matchOrdinalNumberPattern,
        parsePattern: $a2eb5c06a125d713$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $a2eb5c06a125d713$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2eb5c06a125d713$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $a2eb5c06a125d713$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2eb5c06a125d713$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $a2eb5c06a125d713$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2eb5c06a125d713$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $a2eb5c06a125d713$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2eb5c06a125d713$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $a2eb5c06a125d713$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a2eb5c06a125d713$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a2eb5c06a125d713$export$2e2bcd8739ae039 = $a2eb5c06a125d713$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $85f83e5649d57586$var$locale = {
    code: 'sr-Latn',
    formatDistance: (0, $093d1a60727f3b03$export$2e2bcd8739ae039),
    formatLong: (0, $9d2a53d8e0527051$export$2e2bcd8739ae039),
    formatRelative: (0, $b7ab6df8d4107b18$export$2e2bcd8739ae039),
    localize: (0, $ba93350b489354d4$export$2e2bcd8739ae039),
    match: (0, $a2eb5c06a125d713$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $85f83e5649d57586$export$2e2bcd8739ae039 = $85f83e5649d57586$var$locale;
module.exports["default"] = $85f83e5649d57586$export$2e2bcd8739ae039;

});

parcelRegister("02PYW", function(module, exports) {
function $ff5f849617470a59$var$isPluralType(val) {
    return val.one !== undefined;
}
var $ff5f849617470a59$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var $ff5f849617470a59$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = $ff5f849617470a59$var$formatDistanceLocale[token];
    if (!$ff5f849617470a59$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
var $ff5f849617470a59$export$2e2bcd8739ae039 = $ff5f849617470a59$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

// CLDR #1846 - #1849
var $98514a567f9fb59c$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var $98514a567f9fb59c$var$timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $98514a567f9fb59c$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $98514a567f9fb59c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $98514a567f9fb59c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $98514a567f9fb59c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $98514a567f9fb59c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $98514a567f9fb59c$export$2e2bcd8739ae039 = $98514a567f9fb59c$var$formatLong;


var $9cb48648f385ff40$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var $9cb48648f385ff40$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9cb48648f385ff40$var$formatRelativeLocale[token];
};
var $9cb48648f385ff40$export$2e2bcd8739ae039 = $9cb48648f385ff40$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8a4d3e368ca88396$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var $8a4d3e368ca88396$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var $8a4d3e368ca88396$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var $8a4d3e368ca88396$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var $8a4d3e368ca88396$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var $8a4d3e368ca88396$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var $8a4d3e368ca88396$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $8a4d3e368ca88396$var$localize = {
    ordinalNumber: $8a4d3e368ca88396$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8a4d3e368ca88396$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8a4d3e368ca88396$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8a4d3e368ca88396$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8a4d3e368ca88396$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8a4d3e368ca88396$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8a4d3e368ca88396$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8a4d3e368ca88396$export$2e2bcd8739ae039 = $8a4d3e368ca88396$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $e6954a36ff849f1a$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $e6954a36ff849f1a$var$parseOrdinalNumberPattern = /\d+/i;
var $e6954a36ff849f1a$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $e6954a36ff849f1a$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $e6954a36ff849f1a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $e6954a36ff849f1a$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $e6954a36ff849f1a$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $e6954a36ff849f1a$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $e6954a36ff849f1a$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $e6954a36ff849f1a$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $e6954a36ff849f1a$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $e6954a36ff849f1a$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $e6954a36ff849f1a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $e6954a36ff849f1a$var$matchOrdinalNumberPattern,
        parsePattern: $e6954a36ff849f1a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $e6954a36ff849f1a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e6954a36ff849f1a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $e6954a36ff849f1a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e6954a36ff849f1a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $e6954a36ff849f1a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e6954a36ff849f1a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $e6954a36ff849f1a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e6954a36ff849f1a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $e6954a36ff849f1a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e6954a36ff849f1a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e6954a36ff849f1a$export$2e2bcd8739ae039 = $e6954a36ff849f1a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $008882868980a25c$var$locale = {
    code: 'ta',
    formatDistance: (0, $ff5f849617470a59$export$2e2bcd8739ae039),
    formatLong: (0, $98514a567f9fb59c$export$2e2bcd8739ae039),
    formatRelative: (0, $9cb48648f385ff40$export$2e2bcd8739ae039),
    localize: (0, $8a4d3e368ca88396$export$2e2bcd8739ae039),
    match: (0, $e6954a36ff849f1a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $008882868980a25c$export$2e2bcd8739ae039 = $008882868980a25c$var$locale;
module.exports["default"] = $008882868980a25c$export$2e2bcd8739ae039;

});

parcelRegister("gsoQC", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $b35e6a876edf9667$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var $b35e6a876edf9667$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $b35e6a876edf9667$var$formatDistanceLocale[token].withPreposition : $b35e6a876edf9667$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
var $b35e6a876edf9667$export$2e2bcd8739ae039 = $b35e6a876edf9667$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

// CLDR #1807 - #1811
var $6351bd4fc7318263$var$dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var $6351bd4fc7318263$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var $6351bd4fc7318263$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6351bd4fc7318263$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $6351bd4fc7318263$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $6351bd4fc7318263$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $6351bd4fc7318263$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6351bd4fc7318263$export$2e2bcd8739ae039 = $6351bd4fc7318263$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $8973d702ce591095$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var $8973d702ce591095$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8973d702ce591095$var$formatRelativeLocale[token];
};
var $8973d702ce591095$export$2e2bcd8739ae039 = $8973d702ce591095$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $5fdf992ee40ee885$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var $5fdf992ee40ee885$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var $5fdf992ee40ee885$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var $5fdf992ee40ee885$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var $5fdf992ee40ee885$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $5fdf992ee40ee885$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $5fdf992ee40ee885$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var $5fdf992ee40ee885$var$localize = {
    ordinalNumber: $5fdf992ee40ee885$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5fdf992ee40ee885$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5fdf992ee40ee885$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $5fdf992ee40ee885$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5fdf992ee40ee885$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5fdf992ee40ee885$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5fdf992ee40ee885$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5fdf992ee40ee885$export$2e2bcd8739ae039 = $5fdf992ee40ee885$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $8a044188c2fa47c3$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $8a044188c2fa47c3$var$parseOrdinalNumberPattern = /\d+/i;
var $8a044188c2fa47c3$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $8a044188c2fa47c3$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $8a044188c2fa47c3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $8a044188c2fa47c3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8a044188c2fa47c3$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $8a044188c2fa47c3$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $8a044188c2fa47c3$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $8a044188c2fa47c3$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $8a044188c2fa47c3$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $8a044188c2fa47c3$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $8a044188c2fa47c3$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $8a044188c2fa47c3$var$matchOrdinalNumberPattern,
        parsePattern: $8a044188c2fa47c3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $8a044188c2fa47c3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8a044188c2fa47c3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $8a044188c2fa47c3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8a044188c2fa47c3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $8a044188c2fa47c3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8a044188c2fa47c3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $8a044188c2fa47c3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8a044188c2fa47c3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $8a044188c2fa47c3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8a044188c2fa47c3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8a044188c2fa47c3$export$2e2bcd8739ae039 = $8a044188c2fa47c3$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $bfb2891918e348bc$var$locale = {
    code: 'te',
    formatDistance: (0, $b35e6a876edf9667$export$2e2bcd8739ae039),
    formatLong: (0, $6351bd4fc7318263$export$2e2bcd8739ae039),
    formatRelative: (0, $8973d702ce591095$export$2e2bcd8739ae039),
    localize: (0, $5fdf992ee40ee885$export$2e2bcd8739ae039),
    match: (0, $8a044188c2fa47c3$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bfb2891918e348bc$export$2e2bcd8739ae039 = $bfb2891918e348bc$var$locale;
module.exports["default"] = $bfb2891918e348bc$export$2e2bcd8739ae039;

});

parcelRegister("eYfUk", function(module, exports) {
var $97578f4560edaf87$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var $97578f4560edaf87$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $97578f4560edaf87$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
var $97578f4560edaf87$export$2e2bcd8739ae039 = $97578f4560edaf87$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $8917ce8508a0b488$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $8917ce8508a0b488$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $8917ce8508a0b488$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8917ce8508a0b488$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $8917ce8508a0b488$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $8917ce8508a0b488$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $8917ce8508a0b488$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8917ce8508a0b488$export$2e2bcd8739ae039 = $8917ce8508a0b488$var$formatLong;


var $a295bc3bcc9fedcb$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var $a295bc3bcc9fedcb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a295bc3bcc9fedcb$var$formatRelativeLocale[token];
};
var $a295bc3bcc9fedcb$export$2e2bcd8739ae039 = $a295bc3bcc9fedcb$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $444aa477f90f961d$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var $444aa477f90f961d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $444aa477f90f961d$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var $444aa477f90f961d$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var $444aa477f90f961d$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var $444aa477f90f961d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var $444aa477f90f961d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $444aa477f90f961d$var$localize = {
    ordinalNumber: $444aa477f90f961d$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $444aa477f90f961d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $444aa477f90f961d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $444aa477f90f961d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $444aa477f90f961d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $444aa477f90f961d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $444aa477f90f961d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $444aa477f90f961d$export$2e2bcd8739ae039 = $444aa477f90f961d$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $3f9852fc2111f9b7$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $3f9852fc2111f9b7$var$parseOrdinalNumberPattern = /\d+/i;
var $3f9852fc2111f9b7$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $3f9852fc2111f9b7$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $3f9852fc2111f9b7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $3f9852fc2111f9b7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3f9852fc2111f9b7$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $3f9852fc2111f9b7$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $3f9852fc2111f9b7$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $3f9852fc2111f9b7$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $3f9852fc2111f9b7$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $3f9852fc2111f9b7$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $3f9852fc2111f9b7$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $3f9852fc2111f9b7$var$matchOrdinalNumberPattern,
        parsePattern: $3f9852fc2111f9b7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $3f9852fc2111f9b7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f9852fc2111f9b7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $3f9852fc2111f9b7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f9852fc2111f9b7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $3f9852fc2111f9b7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f9852fc2111f9b7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $3f9852fc2111f9b7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f9852fc2111f9b7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $3f9852fc2111f9b7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3f9852fc2111f9b7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3f9852fc2111f9b7$export$2e2bcd8739ae039 = $3f9852fc2111f9b7$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $ae63023680aa29e6$var$locale = {
    code: 'ug',
    formatDistance: (0, $97578f4560edaf87$export$2e2bcd8739ae039),
    formatLong: (0, $8917ce8508a0b488$export$2e2bcd8739ae039),
    formatRelative: (0, $a295bc3bcc9fedcb$export$2e2bcd8739ae039),
    localize: (0, $444aa477f90f961d$export$2e2bcd8739ae039),
    match: (0, $3f9852fc2111f9b7$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $ae63023680aa29e6$export$2e2bcd8739ae039 = $ae63023680aa29e6$var$locale;
module.exports["default"] = $ae63023680aa29e6$export$2e2bcd8739ae039;

});

parcelRegister("cVPxO", function(module, exports) {
var $74197ee378be483b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var $74197ee378be483b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $74197ee378be483b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
var $74197ee378be483b$export$2e2bcd8739ae039 = $74197ee378be483b$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $356982bfee95498d$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $356982bfee95498d$var$timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var $356982bfee95498d$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $356982bfee95498d$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $356982bfee95498d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $356982bfee95498d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $356982bfee95498d$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $356982bfee95498d$export$2e2bcd8739ae039 = $356982bfee95498d$var$formatLong;


var $7fef198dfca25b59$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var $7fef198dfca25b59$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7fef198dfca25b59$var$formatRelativeLocale[token];
};
var $7fef198dfca25b59$export$2e2bcd8739ae039 = $7fef198dfca25b59$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $6f5bf762df8ba634$var$eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var $6f5bf762df8ba634$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6f5bf762df8ba634$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $6f5bf762df8ba634$var$dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var $6f5bf762df8ba634$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $6f5bf762df8ba634$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $6f5bf762df8ba634$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $6f5bf762df8ba634$var$localize = {
    ordinalNumber: $6f5bf762df8ba634$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $6f5bf762df8ba634$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $6f5bf762df8ba634$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $6f5bf762df8ba634$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $6f5bf762df8ba634$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $6f5bf762df8ba634$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6f5bf762df8ba634$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6f5bf762df8ba634$export$2e2bcd8739ae039 = $6f5bf762df8ba634$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $5dcabedd869bfa59$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $5dcabedd869bfa59$var$parseOrdinalNumberPattern = /\d+/i;
var $5dcabedd869bfa59$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $5dcabedd869bfa59$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $5dcabedd869bfa59$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $5dcabedd869bfa59$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5dcabedd869bfa59$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $5dcabedd869bfa59$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $5dcabedd869bfa59$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $5dcabedd869bfa59$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $5dcabedd869bfa59$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $5dcabedd869bfa59$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $5dcabedd869bfa59$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $5dcabedd869bfa59$var$matchOrdinalNumberPattern,
        parsePattern: $5dcabedd869bfa59$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $5dcabedd869bfa59$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5dcabedd869bfa59$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $5dcabedd869bfa59$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5dcabedd869bfa59$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $5dcabedd869bfa59$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5dcabedd869bfa59$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $5dcabedd869bfa59$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5dcabedd869bfa59$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $5dcabedd869bfa59$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5dcabedd869bfa59$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5dcabedd869bfa59$export$2e2bcd8739ae039 = $5dcabedd869bfa59$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $96a2ca8fec13bfc3$var$locale = {
    code: 'uz',
    formatDistance: (0, $74197ee378be483b$export$2e2bcd8739ae039),
    formatLong: (0, $356982bfee95498d$export$2e2bcd8739ae039),
    formatRelative: (0, $7fef198dfca25b59$export$2e2bcd8739ae039),
    localize: (0, $6f5bf762df8ba634$export$2e2bcd8739ae039),
    match: (0, $5dcabedd869bfa59$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $96a2ca8fec13bfc3$export$2e2bcd8739ae039 = $96a2ca8fec13bfc3$var$locale;
module.exports["default"] = $96a2ca8fec13bfc3$export$2e2bcd8739ae039;

});

parcelRegister("kHHuH", function(module, exports) {
var $bf95f986fafeeabf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var $bf95f986fafeeabf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bf95f986fafeeabf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
var $bf95f986fafeeabf$export$2e2bcd8739ae039 = $bf95f986fafeeabf$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $679b56214ff62ec5$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $679b56214ff62ec5$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $679b56214ff62ec5$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $679b56214ff62ec5$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $679b56214ff62ec5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $679b56214ff62ec5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $679b56214ff62ec5$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $679b56214ff62ec5$export$2e2bcd8739ae039 = $679b56214ff62ec5$var$formatLong;


var $79ca760a56654998$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var $79ca760a56654998$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $79ca760a56654998$var$formatRelativeLocale[token];
};
var $79ca760a56654998$export$2e2bcd8739ae039 = $79ca760a56654998$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $95be522f904ab4fc$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var $95be522f904ab4fc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var $95be522f904ab4fc$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var $95be522f904ab4fc$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var $95be522f904ab4fc$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $95be522f904ab4fc$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $95be522f904ab4fc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $95be522f904ab4fc$var$localize = {
    ordinalNumber: $95be522f904ab4fc$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $95be522f904ab4fc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $95be522f904ab4fc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $95be522f904ab4fc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $95be522f904ab4fc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $95be522f904ab4fc$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $95be522f904ab4fc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
var $95be522f904ab4fc$export$2e2bcd8739ae039 = $95be522f904ab4fc$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $3cce390608f7f26d$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $3cce390608f7f26d$var$parseOrdinalNumberPattern = /\d+/i;
var $3cce390608f7f26d$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $3cce390608f7f26d$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $3cce390608f7f26d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $3cce390608f7f26d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3cce390608f7f26d$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $3cce390608f7f26d$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $3cce390608f7f26d$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $3cce390608f7f26d$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $3cce390608f7f26d$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $3cce390608f7f26d$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $3cce390608f7f26d$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $3cce390608f7f26d$var$matchOrdinalNumberPattern,
        parsePattern: $3cce390608f7f26d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $3cce390608f7f26d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3cce390608f7f26d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $3cce390608f7f26d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3cce390608f7f26d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $3cce390608f7f26d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3cce390608f7f26d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $3cce390608f7f26d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3cce390608f7f26d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $3cce390608f7f26d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3cce390608f7f26d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3cce390608f7f26d$export$2e2bcd8739ae039 = $3cce390608f7f26d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $f1298fd82aca4f18$var$locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, $bf95f986fafeeabf$export$2e2bcd8739ae039),
    formatLong: (0, $679b56214ff62ec5$export$2e2bcd8739ae039),
    formatRelative: (0, $79ca760a56654998$export$2e2bcd8739ae039),
    localize: (0, $95be522f904ab4fc$export$2e2bcd8739ae039),
    match: (0, $3cce390608f7f26d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f1298fd82aca4f18$export$2e2bcd8739ae039 = $f1298fd82aca4f18$var$locale;
module.exports["default"] = $f1298fd82aca4f18$export$2e2bcd8739ae039;

});

parcelRegister("aCOaX", function(module, exports) {
var $a095b12cd20d2964$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $a095b12cd20d2964$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a095b12cd20d2964$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $a095b12cd20d2964$export$2e2bcd8739ae039 = $a095b12cd20d2964$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $1ad4970b9b25ad5b$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $1ad4970b9b25ad5b$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $1ad4970b9b25ad5b$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $1ad4970b9b25ad5b$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $1ad4970b9b25ad5b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $1ad4970b9b25ad5b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $1ad4970b9b25ad5b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1ad4970b9b25ad5b$export$2e2bcd8739ae039 = $1ad4970b9b25ad5b$var$formatLong;


var $232131d79ab33ad6$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $232131d79ab33ad6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $232131d79ab33ad6$var$formatRelativeLocale[token];
};
var $232131d79ab33ad6$export$2e2bcd8739ae039 = $232131d79ab33ad6$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $60d00154bc806535$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $60d00154bc806535$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $60d00154bc806535$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $60d00154bc806535$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $60d00154bc806535$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $60d00154bc806535$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $60d00154bc806535$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $60d00154bc806535$var$localize = {
    ordinalNumber: $60d00154bc806535$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $60d00154bc806535$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $60d00154bc806535$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $60d00154bc806535$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $60d00154bc806535$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $60d00154bc806535$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $60d00154bc806535$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $60d00154bc806535$export$2e2bcd8739ae039 = $60d00154bc806535$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $98b91d94b5d7a49a$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $98b91d94b5d7a49a$var$parseOrdinalNumberPattern = /\d+/i;
var $98b91d94b5d7a49a$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $98b91d94b5d7a49a$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $98b91d94b5d7a49a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $98b91d94b5d7a49a$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $98b91d94b5d7a49a$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $98b91d94b5d7a49a$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $98b91d94b5d7a49a$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $98b91d94b5d7a49a$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $98b91d94b5d7a49a$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $98b91d94b5d7a49a$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $98b91d94b5d7a49a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $98b91d94b5d7a49a$var$matchOrdinalNumberPattern,
        parsePattern: $98b91d94b5d7a49a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $98b91d94b5d7a49a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $98b91d94b5d7a49a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $98b91d94b5d7a49a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $98b91d94b5d7a49a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $98b91d94b5d7a49a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $98b91d94b5d7a49a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $98b91d94b5d7a49a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $98b91d94b5d7a49a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $98b91d94b5d7a49a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $98b91d94b5d7a49a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $98b91d94b5d7a49a$export$2e2bcd8739ae039 = $98b91d94b5d7a49a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $7bc45fdbda7f79c8$var$locale = {
    code: 'zh-HK',
    formatDistance: (0, $a095b12cd20d2964$export$2e2bcd8739ae039),
    formatLong: (0, $1ad4970b9b25ad5b$export$2e2bcd8739ae039),
    formatRelative: (0, $232131d79ab33ad6$export$2e2bcd8739ae039),
    localize: (0, $60d00154bc806535$export$2e2bcd8739ae039),
    match: (0, $98b91d94b5d7a49a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7bc45fdbda7f79c8$export$2e2bcd8739ae039 = $7bc45fdbda7f79c8$var$locale;
module.exports["default"] = $7bc45fdbda7f79c8$export$2e2bcd8739ae039;

});

parcelRegister("gahkt", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $f71aaeec887417ef$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('helpDialogPlugin');
module.exports["pluginKey"] = $f71aaeec887417ef$export$18d4026d1ea86bb1;

});

parcelRegister("kqI1A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::681080601a94d93e230b18e8fab2b5f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf862bbd03be853$var$_react = $edf862bbd03be853$var$_interopRequireDefault((parcelRequire("42omo")));

var $edf862bbd03be853$var$_baseNew = $edf862bbd03be853$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $edf862bbd03be853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageCrop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for cropping images
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf862bbd03be853$var$ImageCropIcon = (props)=>/*#__PURE__*/ $edf862bbd03be853$var$_react.default.createElement($edf862bbd03be853$var$_baseNew.default, Object.assign({
        name: "ImageCropIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 3V0h1.5v3H11a2 2 0 0 1 2 2v6.5h3V13h-3v3h-1.5V5a.5.5 0 0 0-.5-.5H0V3zm0 8V6h1.5v5a.5.5 0 0 0 .5.5h5V13H5a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$edf862bbd03be853$var$ImageCropIcon.displayName = 'ImageCropIcon';
var $edf862bbd03be853$var$_default = module.exports.default = $edf862bbd03be853$var$ImageCropIcon;

});

parcelRegister("egUUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba10fe2c4ef1ea336b2035e8f15b8f37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a63eb45a5717c3b6$var$_react = $a63eb45a5717c3b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $a63eb45a5717c3b6$var$_baseNew = $a63eb45a5717c3b6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a63eb45a5717c3b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageAltText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for creating alt text for an image
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a63eb45a5717c3b6$var$ImageAltTextIcon = (props)=>/*#__PURE__*/ $a63eb45a5717c3b6$var$_react.default.createElement($a63eb45a5717c3b6$var$_baseNew.default, Object.assign({
        name: "ImageAltTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8h-3.5V6.5H16zm0 3.5h-3.5V10H16zm0 3.5H5v-1.5h11zM0 3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.206 5.001a.75.75 0 0 1 .55.196l3 2.75-1.013 1.106-2.43-2.228-4.245 4.915-1.136-.98 4.75-5.5A.75.75 0 0 1 7.206 5" clip-rule="evenodd"/><path fill="currentcolor" d="M5 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$a63eb45a5717c3b6$var$ImageAltTextIcon.displayName = 'ImageAltTextIcon';
var $a63eb45a5717c3b6$var$_default = module.exports.default = $a63eb45a5717c3b6$var$ImageAltTextIcon;

});

parcelRegister("afaS6", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $4b1f6f552eb89426$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('mediaPlugin');
module.exports["stateKey"] = $4b1f6f552eb89426$export$77b371d6becc8882;

});

parcelRegister("aRHMp", function(module, exports) {

var $9YoeD = parcelRequire("9YoeD");


var $h3X17 = parcelRequire("h3X17");


var $afaS6 = parcelRequire("afaS6");

const $6f6a312fe9d6d776$export$f4585563863d37bf = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    // Array#find... no IE support
    return mediaNodes.reduce((memo, nodeWithPos)=>{
        if (memo) return memo;
        const { node: node } = nodeWithPos;
        if (node.attrs.id === id) return nodeWithPos;
        return memo;
    }, null);
};
const $6f6a312fe9d6d776$export$691b82c623e6f45f = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    return mediaNodes.filter((nodeWithHandler)=>nodeWithHandler.node.attrs.id === id);
};
const $6f6a312fe9d6d776$export$d6ca4605aefeca32 = (pos, state)=>{
    const node = state.doc.nodeAt(pos);
    return node && [
        'media',
        'mediaInline'
    ].includes(node.type.name);
};
const $6f6a312fe9d6d776$export$9ab762e6df73c440 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $afaS6.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodes = $6f6a312fe9d6d776$export$691b82c623e6f45f(mediaPluginState, id);
        const validMediaNodePositions = mediaNodes.reduce((acc, { getPos: getPos })=>{
            const pos = getPos();
            if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$6f6a312fe9d6d776$export$d6ca4605aefeca32(pos, state)) return acc;
            acc.push(pos);
            return acc;
        }, []);
        if (validMediaNodePositions.length === 0) return false;
        const tr = state.tr;
        validMediaNodePositions.forEach((pos)=>tr.step(new (0, $9YoeD.SetAttrsStep)(pos, attrs)));
        tr.setMeta('addToHistory', false);
        (0, $h3X17.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $6f6a312fe9d6d776$export$fb68358a5cd1917e = (attrs, mediaNode, tintDirtyTr)=>(state, dispatch)=>{
        const pos = mediaNode.getPos();
        if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$6f6a312fe9d6d776$export$d6ca4605aefeca32(pos, state)) return false;
        const tr = state.tr;
        tr.step(new (0, $9YoeD.SetAttrsStep)(pos, attrs));
        tr.setMeta('addToHistory', false);
        if (tintDirtyTr) (0, $h3X17.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $6f6a312fe9d6d776$export$b75bb49e34d97d07 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $afaS6.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodeWithPos = $6f6a312fe9d6d776$export$f4585563863d37bf(mediaPluginState, id);
        if (!mediaNodeWithPos) return false;
        const tr = state.tr;
        const pos = mediaNodeWithPos.getPos();
        if (typeof pos !== 'number' || !$6f6a312fe9d6d776$export$d6ca4605aefeca32(pos, state)) return false;
        tr.step(new (0, $9YoeD.SetAttrsStep)(pos, attrs)).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
const $6f6a312fe9d6d776$export$8c2989a33c6f5bd5 = (pos, attrs)=>(state, dispatch)=>{
        const tr = state.tr;
        const node = tr.doc.nodeAt(pos);
        if (!node || node.type.name !== 'media') return false;
        tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
            type: 'file',
            url: null,
            ...attrs
        })).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
module.exports["findMediaNode"] = $6f6a312fe9d6d776$export$f4585563863d37bf;
module.exports["updateCurrentMediaNodeAttrs"] = $6f6a312fe9d6d776$export$fb68358a5cd1917e;
module.exports["updateMediaNodeAttrs"] = $6f6a312fe9d6d776$export$b75bb49e34d97d07;
module.exports["replaceExternalMedia"] = $6f6a312fe9d6d776$export$8c2989a33c6f5bd5;

});

parcelRegister("kjHnW", function(module, exports) {

var $l6okE = parcelRequire("l6okE");

var $adhil = parcelRequire("adhil");


var $e7tBw = parcelRequire("e7tBw");


var $astHL = parcelRequire("astHL");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $e63NX = parcelRequire("e63NX");

var $Girkv = parcelRequire("Girkv");


var $cAGd7 = parcelRequire("cAGd7");


var $j5VfV = parcelRequire("j5VfV");


var $7dSFG = parcelRequire("7dSFG");

const $41b99d7851c35fcd$var$isTemporary = (id)=>{
    return id.indexOf('temporary:') === 0;
};
const $41b99d7851c35fcd$export$2111a084b5e4465d = (attrs)=>{
    return !!(attrs && attrs.type === 'external' && (0, $Girkv.isMediaBlobUrl)(attrs.url));
};
const $41b99d7851c35fcd$export$7abbbf8335ec653 = (state)=>{
    return $41b99d7851c35fcd$export$6f3a1f1a8fe30200(state) || $41b99d7851c35fcd$var$posOfFollowingMediaGroup(state) || $41b99d7851c35fcd$export$365a04aece6dfb6(state) || $41b99d7851c35fcd$var$posOfMediaGroupNextToGapCursor(state);
};
const $41b99d7851c35fcd$export$5921300994784ec4 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type !== state.schema.nodes.media && node.isBlock;
};
const $41b99d7851c35fcd$export$e5cc26eb78c044a3 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaSingle;
};
const $41b99d7851c35fcd$var$isSelectionMediaInlineNode = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaInline;
};
const $41b99d7851c35fcd$export$365a04aece6dfb6 = (state)=>{
    if (!(0, $l6okE.atTheBeginningOfBlock)(state)) return;
    return $41b99d7851c35fcd$var$posOfMediaGroupAbove(state, state.selection.$from);
};
const $41b99d7851c35fcd$var$posOfMediaGroupNextToGapCursor = (state)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $adhil.GapCursorSelection)) {
        const $pos = state.selection.$from;
        const mediaGroupType = state.schema.nodes.mediaGroup;
        return $41b99d7851c35fcd$var$posOfImmediatePrecedingMediaGroup($pos, mediaGroupType) || $41b99d7851c35fcd$var$posOfImmediateFollowingMediaGroup($pos, mediaGroupType);
    }
};
const $41b99d7851c35fcd$var$posOfImmediatePrecedingMediaGroup = ($pos, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
mediaGroupType)=>{
    if ($pos.nodeBefore && $pos.nodeBefore.type === mediaGroupType) return $pos.pos - $pos.nodeBefore.nodeSize + 1;
};
const $41b99d7851c35fcd$var$posOfImmediateFollowingMediaGroup = ($pos, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
mediaGroupType)=>{
    if ($pos.nodeAfter && $pos.nodeAfter.type === mediaGroupType) return $pos.pos + 1;
};
const $41b99d7851c35fcd$var$posOfFollowingMediaGroup = (state)=>{
    if (!(0, $l6okE.atTheEndOfBlock)(state)) return;
    return $41b99d7851c35fcd$var$posOfMediaGroupBelow(state, state.selection.$to);
};
const $41b99d7851c35fcd$var$posOfMediaGroupAbove = (state, $pos)=>{
    let adjacentPos;
    let adjacentNode;
    if ($41b99d7851c35fcd$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeBefore;
    } else {
        adjacentPos = (0, $l6okE.startPositionOfParent)($pos) - 1;
        adjacentNode = state.doc.resolve(adjacentPos).nodeBefore;
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return adjacentPos - adjacentNode.nodeSize + 1;
    return;
};
const $41b99d7851c35fcd$export$c64712b0ea25772a = (state)=>{
    const { $from: $from } = state.selection;
    return $from.parent.type === state.schema.nodes.paragraph && (0, $l6okE.atTheBeginningOfBlock)(state) && (0, $l6okE.atTheEndOfBlock)(state);
};
const $41b99d7851c35fcd$var$posOfMediaGroupBelow = (state, $pos, prepend = true)=>{
    let adjacentPos;
    let adjacentNode;
    if ($41b99d7851c35fcd$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeAfter;
    } else {
        adjacentPos = (0, $l6okE.endPositionOfParent)($pos);
        adjacentNode = state.doc.nodeAt(adjacentPos);
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return prepend ? adjacentPos + 1 : adjacentPos + adjacentNode.nodeSize - 1;
    return;
};
const $41b99d7851c35fcd$export$6f3a1f1a8fe30200 = (state, $pos, prepend = false)=>{
    const { $from: $from } = state.selection;
    $pos = $pos || $from;
    if ($pos.parent.type === state.schema.nodes.mediaGroup) return prepend ? (0, $l6okE.startPositionOfParent)($pos) : (0, $l6okE.endPositionOfParent)($pos) - 1;
    return;
};
const $41b99d7851c35fcd$export$ddc636b287a33575 = (view, node, getPos)=>{
    const { id: id } = node.attrs;
    const { state: state } = view;
    const { tr: tr, selection: selection, doc: doc } = state;
    const currentMediaNodePos = getPos();
    if (typeof currentMediaNodePos !== 'number') return;
    tr.deleteRange(currentMediaNodePos, currentMediaNodePos + node.nodeSize);
    if ($41b99d7851c35fcd$var$isTemporary(id)) tr.setMeta('addToHistory', false);
    const $currentMediaNodePos = doc.resolve(currentMediaNodePos);
    const { nodeBefore: nodeBefore, parent: parent } = $currentMediaNodePos;
    const isLastMediaNode = $currentMediaNodePos.index() === parent.childCount - 1;
    // If deleting a selected media node, we need to tell where the cursor to go next.
    // Prosemirror didn't gave us the behaviour of moving left if the media node is not the last one.
    // So we handle it ourselves.
    if (selection.from === currentMediaNodePos && !isLastMediaNode && !(0, $l6okE.atTheBeginningOfDoc)(state) && nodeBefore && nodeBefore.type.name === 'media') {
        const nodeBefore = (0, $8m4tT.findPositionOfNodeBefore)(tr.selection);
        if (nodeBefore) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, nodeBefore));
    }
    view.dispatch(tr);
};
const $41b99d7851c35fcd$export$60aa99908f1d280f = (view)=>{
    const { selection: selection } = view.state;
    // if selection is not a media node, do nothing.
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type !== view.state.schema.nodes.media) return false;
    (0, $astHL.deleteSelection)(view.state, view.dispatch);
    if (selection.$to.nodeAfter) {
        (0, $astHL.splitBlock)(view.state, view.dispatch);
        (0, $e7tBw.createParagraphNear)(false)(view.state, view.dispatch);
    } else (0, $e7tBw.createNewParagraphBelow)(view.state, view.dispatch);
    return true;
};
const $41b99d7851c35fcd$var$isOptionalAttr = (attr)=>attr.length > 1 && attr[0] === '_' && attr[1] === '_';
const $41b99d7851c35fcd$export$21d5b3d9cf01948c = (mediaState, node)=>{
    Object.keys(node.attrs).filter($41b99d7851c35fcd$var$isOptionalAttr).forEach((key)=>{
        const mediaStateKey = key.substring(2);
        const attrValue = mediaState[mediaStateKey];
        if (attrValue !== undefined) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
        node.attrs[key] = attrValue;
    });
};
const $41b99d7851c35fcd$export$9b24cf4bc5375bda = (state)=>{
    if (!$41b99d7851c35fcd$export$e5cc26eb78c044a3(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from + 1;
    const mediaNode = tr.doc.nodeAt(pos);
    if (mediaNode && mediaNode.type === state.schema.nodes.media) return mediaNode;
    return null;
};
const $41b99d7851c35fcd$var$getMediaInlineNodeFromSelection = (state)=>{
    if (!$41b99d7851c35fcd$var$isSelectionMediaInlineNode(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from;
    const mediaNode = tr.doc.nodeAt(pos);
    return mediaNode;
};
const $41b99d7851c35fcd$export$5410c0ed8420fc75 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $j5VfV.getMediaPluginState)(state);
    return $41b99d7851c35fcd$export$e5cc26eb78c044a3(state) || allowInlineImages && $41b99d7851c35fcd$var$isSelectionMediaInlineNode(state);
};
const $41b99d7851c35fcd$export$e9f7b6e4ebb6d186 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $j5VfV.getMediaPluginState)(state);
    const mediaNode = $41b99d7851c35fcd$export$9b24cf4bc5375bda(state) || allowInlineImages && $41b99d7851c35fcd$var$getMediaInlineNodeFromSelection(state);
    return mediaNode || null;
};
const $41b99d7851c35fcd$export$a556482c8c054147 = (state)=>{
    const { node: node } = state.selection;
    // Specifically for media supported nodes, double click could have been initiated on the media caption
    if (!node) return null;
    switch(node.type){
        case node.type.schema.nodes.media:
        case node.type.schema.nodes.mediaInline:
            return node;
        case node.type.schema.nodes.mediaSingle:
        case node.type.schema.nodes.mediaGroup:
            return node.firstChild;
        default:
            return null;
    }
};
const $41b99d7851c35fcd$export$7940ab1d031fef29 = (isViewMode, node)=>{
    if (!node) return false;
    // Double Click is not supported for video nodes on both views
    if ((0, $7dSFG.isVideo)(node.attrs.__fileMimeType)) return false;
    // Double click is supported for all editor media nodes
    if (!isViewMode) return true;
    // Double Click is not supported for mediaGroup and mediaInline nodes that are file
    if (node.type === node.type.schema.nodes.mediaGroup || node.type === node.type.schema.nodes.mediaInline && node.attrs.type === 'file') return false;
    // Double Click supported for all other media nodes
    return true;
};
const $41b99d7851c35fcd$export$adb27ddab077e944 = (attrs)=>{
    if ((0, $cAGd7.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $41b99d7851c35fcd$export$a22092fc57f1d693 = (doc)=>{
    const mediaNodes = [];
    doc.descendants((node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') mediaNodes.push(node);
    });
    return mediaNodes;
};
const $41b99d7851c35fcd$export$be91ba10d8a4f435 = (mediaNodes)=>{
    const mediaIdentifierMap = new Map();
    mediaNodes.forEach((item)=>{
        const attrs = item.attrs;
        if (!attrs) return;
        if ((0, $7dSFG.isVideo)(attrs.__fileMimeType)) return;
        const identifier = $41b99d7851c35fcd$export$adb27ddab077e944(attrs);
        // Add only if not already processed
        const idKey = (0, $e63NX.isExternalImageIdentifier)(identifier) ? identifier.dataURI : identifier.id;
        if (!mediaIdentifierMap.has(idKey)) mediaIdentifierMap.set(idKey, identifier);
    });
    return [
        ...mediaIdentifierMap.values()
    ];
};
module.exports["isMediaBlobUrlFromAttrs"] = $41b99d7851c35fcd$export$2111a084b5e4465d;
module.exports["posOfMediaGroupNearby"] = $41b99d7851c35fcd$export$7abbbf8335ec653;
module.exports["posOfParentMediaGroup"] = $41b99d7851c35fcd$export$6f3a1f1a8fe30200;
module.exports["posOfPrecedingMediaGroup"] = $41b99d7851c35fcd$export$365a04aece6dfb6;
module.exports["isSelectionNonMediaBlockNode"] = $41b99d7851c35fcd$export$5921300994784ec4;
module.exports["isSelectionMediaSingleNode"] = $41b99d7851c35fcd$export$e5cc26eb78c044a3;
module.exports["isInsidePotentialEmptyParagraph"] = $41b99d7851c35fcd$export$c64712b0ea25772a;
module.exports["removeMediaNode"] = $41b99d7851c35fcd$export$ddc636b287a33575;
module.exports["splitMediaGroup"] = $41b99d7851c35fcd$export$60aa99908f1d280f;
module.exports["copyOptionalAttrsFromMediaState"] = $41b99d7851c35fcd$export$21d5b3d9cf01948c;
module.exports["isMediaSingleOrInlineNodeSelected"] = $41b99d7851c35fcd$export$5410c0ed8420fc75;
module.exports["getMediaSingleOrInlineNodeFromSelection"] = $41b99d7851c35fcd$export$e9f7b6e4ebb6d186;
module.exports["getMediaFromSupportedMediaNodesFromSelection"] = $41b99d7851c35fcd$export$a556482c8c054147;
module.exports["isNodeDoubleClickSupportedInLivePagesViewMode"] = $41b99d7851c35fcd$export$7940ab1d031fef29;
module.exports["getIdentifier"] = $41b99d7851c35fcd$export$adb27ddab077e944;
module.exports["extractMediaNodes"] = $41b99d7851c35fcd$export$a22092fc57f1d693;
module.exports["createMediaIdentifierArray"] = $41b99d7851c35fcd$export$be91ba10d8a4f435;

});

parcelRegister("7dSFG", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $d925B = parcelRequire("d925B");


var $zT4ZO = parcelRequire("zT4ZO");


var $gAARK = parcelRequire("gAARK");

var $kfJSC = parcelRequire("kfJSC");


var $l6okE = parcelRequire("l6okE");


var $l9G9n = parcelRequire("l9G9n");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $kjHnW = parcelRequire("kjHnW");


var $7WMqe = parcelRequire("7WMqe");


var $9bkD0 = parcelRequire("9bkD0");

const $1d669da49988251c$var$getInsertMediaAnalytics = (inputMethod, fileExtension, insertMediaVia)=>({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            inputMethod: inputMethod,
            insertMediaVia: insertMediaVia,
            fileExtension: fileExtension,
            type: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
function $1d669da49988251c$var$shouldAddParagraph(state) {
    return (0, $l6okE.atTheBeginningOfBlock)(state) && !(0, $l9G9n.checkNodeDown)(state.selection, state.doc, (0, $l9G9n.isEmptyParagraph));
}
function $1d669da49988251c$var$insertNodesWithOptionalParagraph({ nodes: nodes, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        if ((0, $dh538.fg)('platform_editor_introduce_insert_media_command')) {
            const updatedTr = $1d669da49988251c$var$insertNodesWithOptionalParagraphCommand({
                nodes: nodes,
                analyticsAttributes: analyticsAttributes,
                editorAnalyticsAPI: editorAnalyticsAPI,
                insertMediaVia: insertMediaVia
            })({
                tr: tr
            });
            if (updatedTr && dispatch) {
                dispatch?.(updatedTr);
                return true;
            }
            return false;
        }
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        if (state.selection.empty) {
            const insertFrom = (0, $l6okE.atTheBeginningOfBlock)(state) ? state.selection.$from.before() : state.selection.from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else updatedTr.replaceSelection(new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, openEnd));
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($1d669da49988251c$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI?.attachAnalyticsEvent((0, $7WMqe.getChangeMediaAnalytics)(previousType, newType, (0, $7WMqe.findChangeFromLocation)(state.selection)))(updatedTr);
        if (dispatch) dispatch(updatedTr);
        return true;
    };
}
function $1d669da49988251c$var$insertNodesWithOptionalParagraphCommand({ nodes: nodes, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return ({ tr: tr })=>{
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        if (tr.selection.empty) {
            const insertFrom = (0, $l6okE.selectionIsAtTheBeginningOfBlock)(tr.selection) ? tr.selection.$from.before() : tr.selection.from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else updatedTr.replaceSelection(new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, openEnd));
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($1d669da49988251c$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI?.attachAnalyticsEvent((0, $7WMqe.getChangeMediaAnalytics)(previousType, newType, (0, $7WMqe.findChangeFromLocation)(tr.selection)))(updatedTr);
        return updatedTr;
    };
}
const $1d669da49988251c$export$e5065363a261ea68 = (schema, fileMimeType)=>!!schema.nodes.mediaSingle && (0, $9bkD0.isImage)(fileMimeType);
const $1d669da49988251c$export$62e6f072fbcbc210 = (view, node, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle) return false;
    // if not an image type media node
    if (node.type !== media || !(0, $9bkD0.isImage)(node.attrs.__fileMimeType) && node.attrs.type !== 'external') return false;
    if ((0, $dh538.fg)('platform_editor_introduce_insert_media_command')) {
        const updatedTr = $1d669da49988251c$export$ad66fa9805ac027a(node.attrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing)({
            tr: state.tr
        });
        if (updatedTr && dispatch) {
            dispatch?.(updatedTr);
            return true;
        }
        return false;
    }
    const mediaSingleAttrs = allowPixelResizing ? {
        widthType: 'pixel',
        width: (0, $kfJSC.getMediaSingleInitialWidth)(node.attrs.width ?? (0, $gAARK.DEFAULT_IMAGE_WIDTH)),
        layout: 'center'
    } : {};
    const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, node);
    const nodes = [
        mediaSingleNode
    ];
    const analyticsAttributes = {
        inputMethod: inputMethod,
        fileExtension: node.attrs.__fileMimeType
    };
    return $1d669da49988251c$var$insertNodesWithOptionalParagraph({
        nodes: nodes,
        analyticsAttributes: analyticsAttributes,
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
};
const $1d669da49988251c$export$ad66fa9805ac027a = (mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing)=>{
    return ({ tr: tr })=>{
        const { mediaSingle: mediaSingle, media: media } = tr.doc.type.schema.nodes;
        if (!mediaSingle || !media) return null;
        if (mediaAttrs.type !== 'external' && !(0, $9bkD0.isImage)(mediaAttrs.__fileMimeType ?? undefined)) return null;
        const mediaSingleAttrs = allowPixelResizing ? {
            widthType: 'pixel',
            width: (0, $kfJSC.getMediaSingleInitialWidth)(mediaAttrs.width ?? (0, $gAARK.DEFAULT_IMAGE_WIDTH)),
            layout: 'center'
        } : {};
        const mediaNode = media.create(mediaAttrs);
        const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, mediaNode);
        const nodes = [
            mediaSingleNode
        ];
        const analyticsAttributes = {
            inputMethod: inputMethod,
            // External images have no file extension
            fileExtension: mediaAttrs.type !== 'external' && mediaAttrs.__fileMimeType ? mediaAttrs.__fileMimeType ?? undefined : undefined
        };
        return $1d669da49988251c$var$insertNodesWithOptionalParagraphCommand({
            nodes: nodes,
            analyticsAttributes: analyticsAttributes,
            editorAnalyticsAPI: editorAnalyticsAPI,
            insertMediaVia: insertMediaVia
        })({
            tr: tr
        });
    };
};
const $1d669da49988251c$var$getFileExtension = (fileName)=>{
    if (fileName) {
        const extensionIdx = fileName.lastIndexOf('.');
        return extensionIdx >= 0 ? fileName.substring(extensionIdx + 1) : undefined;
    }
    return undefined;
};
const $1d669da49988251c$export$653e52366db7c5b6 = (view, mediaState, inputMethod, collection, alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, onNodeInserted, insertMediaVia, allowPixelResizing)=>{
    if (collection === undefined) return false;
    const { state: state, dispatch: dispatch } = view;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = (0, $kfJSC.getMaxWidthForNestedNodeNext)(view, state.selection.$from.pos, true) || widthPluginState?.lineLength || widthPluginState?.width || undefined;
    const node = $1d669da49988251c$var$createMediaSingleNode(state.schema, collection, contentWidth, mediaState.status !== 'error' && $1d669da49988251c$export$ac5608bbe92d6fdc(mediaState.fileMimeType) ? (0, $gAARK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), alignLeftOnInsert, allowPixelResizing)(mediaState);
    let fileExtension;
    if (mediaState.fileName) {
        const extensionIdx = mediaState.fileName.lastIndexOf('.');
        fileExtension = extensionIdx >= 0 ? mediaState.fileName.substring(extensionIdx + 1) : undefined;
    }
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $zT4ZO.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) $1d669da49988251c$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            inputMethod: inputMethod
        },
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
    else {
        let tr = null;
        tr = (0, $zT4ZO.safeInsert)(node, state.selection.from)(state.tr);
        if (!tr) {
            const content = $1d669da49988251c$var$shouldAddParagraph(view.state) ? (0, $5SAOw.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $8m4tT.safeInsert)(content, undefined, true)(state.tr);
        }
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($1d669da49988251c$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(tr);
        dispatch(tr);
    }
    if (onNodeInserted) onNodeInserted(mediaState.id, view.state.selection.to);
    return true;
};
const $1d669da49988251c$export$276040c239babb42 = (view, fromNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaInline: mediaInline } = state.schema.nodes;
    if (fromNode.type !== mediaInline) return false;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = (0, $kfJSC.getMaxWidthForNestedNodeNext)(view, state.selection.$from.pos, true) || widthPluginState?.lineLength || widthPluginState?.width || undefined;
    const node = $1d669da49988251c$var$replaceWithMediaSingleNode(state.schema, contentWidth, (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), allowPixelResizing)(fromNode);
    const fileExtension = $1d669da49988251c$var$getFileExtension(fromNode.attrs.__fileName);
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $zT4ZO.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) return $1d669da49988251c$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            newType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            previousType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE
        },
        editorAnalyticsAPI: editorAnalyticsAPI
    })(state, dispatch);
    else {
        const nodePos = state.tr.doc.resolve(state.selection.from).end();
        let tr = null;
        tr = (0, $8m4tT.removeSelectedNode)(state.tr);
        tr = (0, $zT4ZO.safeInsert)(node, nodePos)(tr);
        if (!tr) {
            const content = $1d669da49988251c$var$shouldAddParagraph(view.state) ? (0, $5SAOw.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $8m4tT.safeInsert)(content, undefined, true)(state.tr);
        }
        editorAnalyticsAPI?.attachAnalyticsEvent((0, $7WMqe.getChangeMediaAnalytics)((0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $7WMqe.findChangeFromLocation)(state.selection)))(tr);
        dispatch(tr);
    }
    return true;
};
const $1d669da49988251c$var$createMediaSingleNode = (schema, collection, maxWidth, minWidth, alignLeftOnInsert, allowPixelResizing)=>(mediaState)=>{
        const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const { width: width, height: height } = dimensions || {
            height: undefined,
            width: undefined
        };
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const scaledWidth = width && Math.round(width / scaleFactor);
        const mediaNode = media.create({
            id: id,
            type: 'file',
            collection: collection,
            contextId: contextId,
            width: scaledWidth,
            height: height && Math.round(height / scaleFactor),
            ...fileName && {
                alt: fileName
            }
        });
        const mediaSingleAttrs = alignLeftOnInsert ? {
            layout: 'align-start'
        } : {};
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            ...mediaSingleAttrs,
            width: (0, $kfJSC.getMediaSingleInitialWidth)(scaledWidth, maxWidth, minWidth),
            // TODO: ED-26962 - change to use enum
            widthType: 'pixel'
        } : mediaSingleAttrs;
        (0, $kjHnW.copyOptionalAttrsFromMediaState)(mediaState, mediaNode);
        return mediaSingle.createChecked(extendedMediaSingleAttrs, mediaNode);
    };
const $1d669da49988251c$var$replaceWithMediaSingleNode = (schema, maxWidth, minWidth, allowPixelResizing)=>(mediaNode)=>{
        const { width: width } = mediaNode.attrs;
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const copiedMediaNode = media.create({
            ...mediaNode.attrs,
            type: 'file'
        }, mediaNode.content, mediaNode.marks);
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            width: (0, $kfJSC.getMediaSingleInitialWidth)(width, maxWidth, minWidth),
            widthType: 'pixel'
        } : {};
        return mediaSingle.createChecked(extendedMediaSingleAttrs, copiedMediaNode);
    };
const $1d669da49988251c$export$ac5608bbe92d6fdc = (0, $2XqLN.default)((fileType)=>{
    return !!fileType && fileType.includes('video');
});
module.exports["isMediaSingle"] = $1d669da49988251c$export$e5065363a261ea68;
module.exports["insertMediaAsMediaSingle"] = $1d669da49988251c$export$62e6f072fbcbc210;
module.exports["createInsertMediaAsMediaSingleCommand"] = $1d669da49988251c$export$ad66fa9805ac027a;
module.exports["insertMediaSingleNode"] = $1d669da49988251c$export$653e52366db7c5b6;
module.exports["isVideo"] = $1d669da49988251c$export$ac5608bbe92d6fdc;
module.exports["changeFromMediaInlineToMediaSingleNode"] = $1d669da49988251c$export$276040c239babb42;

});

parcelRegister("aR6HD", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dAtrv = parcelRequire("dAtrv");


var $kfJSC = parcelRequire("kfJSC");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7WMqe = parcelRequire("7WMqe");


var $jA06n = parcelRequire("jA06n");


var $kjHnW = parcelRequire("kjHnW");


var $7dSFG = parcelRequire("7dSFG");


var $cAGd7 = parcelRequire("cAGd7");

const $5bdc8d71653e2950$export$f54f5cacf382b9f2 = '#091e4224';
const $5bdc8d71653e2950$export$5346947b21be4717 = 2;
const $5bdc8d71653e2950$export$d168cba70360dd3d = (state)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    return (0, $kjHnW.isSelectionMediaSingleNode)(state) ? mediaSingle.name : mediaInline.name;
};
const $5bdc8d71653e2950$export$8cf8c3c101907002 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, mediaGroup: mediaGroup, paragraph: paragraph, heading: heading } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        const { id: id, type: type, collection: collection } = selectedNode.attrs;
        const mediaNode = media.createChecked({
            id: id,
            type: type,
            collection: collection
        });
        const group = mediaGroup.createChecked({}, mediaNode);
        const parent = (0, $8m4tT.findParentNodeClosestToPos)(state.selection.$from, (node)=>{
            return node.type === paragraph || node.type === heading;
        })?.node;
        let tr = state.tr;
        let insertPos;
        if (!!parent && parent.content.size === 2 && parent.content.firstChild?.type.name === 'mediaInline' && parent.content.lastChild?.type.name === 'text' && parent.content.lastChild?.text?.trim() === '') {
            /// Empty paragraph or empty heading
            /// Drop the corresponding card on the current line
            insertPos = state.tr.doc.resolve(state.selection.from).start() - 1;
            if (insertPos < 0) return false;
            tr = tr.delete(insertPos, insertPos + parent.nodeSize);
            tr = (0, $8m4tT.safeInsert)(group, insertPos, false)(tr);
        } else {
            /// Non-empty paragraph, non-empty heading, or other nodes (e.g., action, list)
            /// Drop the corresponding card underneath the current line
            insertPos = state.tr.doc.resolve(state.selection.from).end();
            tr = (0, $8m4tT.removeSelectedNode)(tr);
            tr = (0, $8m4tT.safeInsert)(group, insertPos, false)(tr);
        }
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_GROUP,
                    previousType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE
                }
            })(tr);
            const $endOfNode = tr.doc.resolve(insertPos + 1);
            const newSelection = new (0, $ks2lK.NodeSelection)($endOfNode);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.thumbnail-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $5bdc8d71653e2950$export$f1c1c33109f7b728 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
        // @ts-ignore - [unblock prosemirror bump] redundant check comparing boolean to media
        if (!selectedNode || !selectedNode.type === media) return false;
        const mediaInlineNode = mediaInline.create({
            id: selectedNode.attrs.id,
            collection: selectedNode.attrs.collection
        });
        const space = state.schema.text(' ');
        const content = (0, $5SAOw.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const nodePos = state.tr.doc.resolve(state.selection.from).start();
        let tr = (0, $cAGd7.removeMediaGroupNode)(state);
        // Minus 1 to insert the node before the media group
        tr = (0, $8m4tT.safeInsert)(node, nodePos - 1, false)(tr);
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE,
                    previousType: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_GROUP
                }
            })(tr);
            const newSelection = (0, $ks2lK.NodeSelection).create(tr.doc, nodePos);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.inline-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $5bdc8d71653e2950$export$697a66ccfb9355d9 = (editorAnalyticsAPI, widthPluginState, allowPixelResizing)=>(state, dispatch, view)=>{
        const { mediaInline: mediaInline } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        if (view) return (0, $7dSFG.changeFromMediaInlineToMediaSingleNode)(view, selectedNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing);
        return true;
    };
const $5bdc8d71653e2950$export$736937947f2887f2 = (editorAnalyticsAPI)=>{
    return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA_INLINE,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })($5bdc8d71653e2950$export$c8abec9f794b33a4);
};
const $5bdc8d71653e2950$export$c8abec9f794b33a4 = (state, dispatch)=>{
    if ((0, $8m4tT.isNodeSelection)(state.selection)) {
        if (dispatch) dispatch((0, $8m4tT.removeSelectedNode)(state.tr));
        return true;
    }
    return false;
};
const $5bdc8d71653e2950$export$422bbbda8886cfb6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const nodeWithPos = (0, $kfJSC.currentMediaNodeWithPos)(state) || (0, $jA06n.currentMediaInlineNodeWithPos)(state);
        if (!nodeWithPos) return false;
        const { node: node, pos: pos } = nodeWithPos;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(borderMark ? [] : state.schema.marks.border.create({
            color: $5bdc8d71653e2950$export$f54f5cacf382b9f2,
            size: $5bdc8d71653e2950$export$5346947b21be4717
        }));
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
        }
        if (dispatch) {
            const type = $5bdc8d71653e2950$export$d168cba70360dd3d(state);
            if (borderMark?.attrs) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    previousColor: borderMark.attrs.color,
                    previousSize: borderMark.attrs.size,
                    mediaType: node.attrs.type
                }
            })(tr);
            else editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).ADDED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    color: $5bdc8d71653e2950$export$f54f5cacf382b9f2,
                    size: $5bdc8d71653e2950$export$5346947b21be4717,
                    mediaType: node.attrs.type
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $5bdc8d71653e2950$export$40f3bc13e4908fe6 = (editorAnalyticsAPI)=>(attrs)=>(state, dispatch)=>{
            const nodeWithPos = (0, $kfJSC.currentMediaNodeWithPos)(state) || (0, $jA06n.currentMediaInlineNodeWithPos)(state);
            if (!nodeWithPos) return false;
            const { node: node, pos: pos } = nodeWithPos;
            const borderMark = node.marks.find((m)=>m.type.name === 'border')?.attrs;
            const color = attrs.color ?? borderMark?.color ?? $5bdc8d71653e2950$export$f54f5cacf382b9f2;
            const size = attrs.size ?? borderMark?.size ?? $5bdc8d71653e2950$export$5346947b21be4717;
            const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(state.schema.marks.border.create({
                color: color,
                size: size
            }));
            const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
            tr.setMeta('scrollIntoView', false);
            if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
                if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
            }
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).UPDATED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BORDER,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        type: $5bdc8d71653e2950$export$d168cba70360dd3d(state),
                        mediaType: node.attrs.type,
                        previousColor: borderMark?.color,
                        previousSize: borderMark?.size,
                        newColor: color,
                        newSize: size
                    }
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $5bdc8d71653e2950$export$2cb0367d661a3966 = (editorAnalyticsAPI, state, width, validation, inputMethod, layout)=>{
    const selectedMediaSingleNode = (0, $cAGd7.getSelectedMediaSingle)(state);
    if (!selectedMediaSingleNode) return null;
    const tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
        ...selectedMediaSingleNode.node.attrs,
        width: width,
        widthType: 'pixel',
        layout: layout
    });
    tr.setMeta('scrollIntoView', false);
    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
    const $pos = state.doc.resolve(selectedMediaSingleNode.pos);
    const parentNodeType = $pos ? $pos.parent.type.name : undefined;
    const payload = (0, $7WMqe.getMediaInputResizeAnalyticsEvent)('mediaSingle', {
        width: width,
        layout: layout,
        validation: validation,
        inputMethod: inputMethod,
        parentNode: parentNodeType
    });
    if (payload) editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    return tr;
};
const $5bdc8d71653e2950$export$c71ac81378eeb0c2 = (editorAnalyticsAPI)=>(width, validation, inputMethod, layout)=>(state, dispatch)=>{
            const tr = $5bdc8d71653e2950$export$2cb0367d661a3966(editorAnalyticsAPI, state, width, validation, inputMethod, layout);
            if (!tr) return false;
            if (dispatch) dispatch(tr);
            return true;
        };
const $5bdc8d71653e2950$export$f68bb2b466cc4cc6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const selectedNodeWithPos = (0, $cAGd7.getSelectedMediaSingle)(state);
        const { mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        if (!selectedNodeWithPos) return false;
        const mediaSingleNode = selectedNodeWithPos.node;
        const mediaNode = mediaSingleNode.firstChild;
        if (!mediaNode) return false;
        const mediaInlineNode = mediaInline.create({
            ...mediaNode.attrs,
            type: 'image'
        }, null, mediaNode.marks);
        const space = state.schema.text(' ');
        const content = (0, $5SAOw.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const { from: from } = state.selection;
        let tr = state.tr;
        tr = (0, $8m4tT.removeSelectedNode)(tr);
        tr = (0, $8m4tT.safeInsert)(node, from, false)(tr);
        // 3 accounts for  paragraph 1 + mediaInline size 1 + space 1
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, from + 3));
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent((0, $7WMqe.getChangeMediaAnalytics)((0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $7WMqe.findChangeFromLocation)(state.selection)))(tr);
            dispatch(tr);
        }
        return true;
    };
module.exports["getNodeType"] = $5bdc8d71653e2950$export$d168cba70360dd3d;
module.exports["changeInlineToMediaCard"] = $5bdc8d71653e2950$export$8cf8c3c101907002;
module.exports["changeMediaCardToInline"] = $5bdc8d71653e2950$export$f1c1c33109f7b728;
module.exports["changeMediaInlineToMediaSingle"] = $5bdc8d71653e2950$export$697a66ccfb9355d9;
module.exports["removeInlineCardWithAnalytics"] = $5bdc8d71653e2950$export$736937947f2887f2;
module.exports["toggleBorderMark"] = $5bdc8d71653e2950$export$422bbbda8886cfb6;
module.exports["setBorderMark"] = $5bdc8d71653e2950$export$40f3bc13e4908fe6;
module.exports["updateMediaSingleWidthTr"] = $5bdc8d71653e2950$export$2cb0367d661a3966;
module.exports["updateMediaSingleWidth"] = $5bdc8d71653e2950$export$c71ac81378eeb0c2;
module.exports["changeMediaSingleToMediaInline"] = $5bdc8d71653e2950$export$f68bb2b466cc4cc6;

});

parcelRegister("cZifa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc4009de593579510dac1f1a04fe71b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9749555ac70e813c$var$_react = $9749555ac70e813c$var$_interopRequireDefault((parcelRequire("42omo")));

var $9749555ac70e813c$var$_baseNew = $9749555ac70e813c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9749555ac70e813c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9749555ac70e813c$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $9749555ac70e813c$var$_react.default.createElement($9749555ac70e813c$var$_baseNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$9749555ac70e813c$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $9749555ac70e813c$var$_default = module.exports.default = $9749555ac70e813c$var$ExpandElementIcon;

});

parcelRegister("gF8oK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::718366f0455684b58aea71d9f899bda7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c216fd66503e26dc$var$_react = $c216fd66503e26dc$var$_interopRequireDefault((parcelRequire("42omo")));

var $c216fd66503e26dc$var$_baseNew = $c216fd66503e26dc$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c216fd66503e26dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c216fd66503e26dc$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $c216fd66503e26dc$var$_react.default.createElement($c216fd66503e26dc$var$_baseNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$c216fd66503e26dc$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $c216fd66503e26dc$var$_default = module.exports.default = $c216fd66503e26dc$var$LayoutFiveColumnsIcon;

});

parcelRegister("2q3lZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a5e2e2e2e660297affa5a42c34e8591>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c309c73290ae2d8$var$_react = $1c309c73290ae2d8$var$_interopRequireDefault((parcelRequire("42omo")));

var $1c309c73290ae2d8$var$_baseNew = $1c309c73290ae2d8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1c309c73290ae2d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c309c73290ae2d8$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $1c309c73290ae2d8$var$_react.default.createElement($1c309c73290ae2d8$var$_baseNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$1c309c73290ae2d8$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $1c309c73290ae2d8$var$_default = module.exports.default = $1c309c73290ae2d8$var$LayoutFourColumnsIcon;

});

parcelRegister("4ED0i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bb7f91405d2eac61849c57ae62c714b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3639272af2b0a146$var$_react = $3639272af2b0a146$var$_interopRequireDefault((parcelRequire("42omo")));

var $3639272af2b0a146$var$_baseNew = $3639272af2b0a146$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3639272af2b0a146$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $3639272af2b0a146$var$_react.default.createElement($3639272af2b0a146$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $3639272af2b0a146$var$_default = module.exports.default = $3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon;

});

parcelRegister("hLZr6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27da858e2434ed3b2bc030478f1ba16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf067b6321a11929$var$_react = $cf067b6321a11929$var$_interopRequireDefault((parcelRequire("42omo")));

var $cf067b6321a11929$var$_baseNew = $cf067b6321a11929$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cf067b6321a11929$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $cf067b6321a11929$var$_react.default.createElement($cf067b6321a11929$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $cf067b6321a11929$var$_default = module.exports.default = $cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon;

});

parcelRegister("1FOj2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e437ff979ed52fe3fc89de1b184e851d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1380a486f7d5942d$var$_react = $1380a486f7d5942d$var$_interopRequireDefault((parcelRequire("42omo")));

var $1380a486f7d5942d$var$_baseNew = $1380a486f7d5942d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1380a486f7d5942d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1380a486f7d5942d$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $1380a486f7d5942d$var$_react.default.createElement($1380a486f7d5942d$var$_baseNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$1380a486f7d5942d$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $1380a486f7d5942d$var$_default = module.exports.default = $1380a486f7d5942d$var$TextLetterCaseIcon;

});

parcelRegister("j5VfV", function(module, exports) {

var $9ir1r = parcelRequire("9ir1r");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $dQl1W = parcelRequire("dQl1W");


var $d925B = parcelRequire("d925B");


var $2YJKQ = parcelRequire("2YJKQ");


var $gAARK = parcelRequire("gAARK");

var $kfJSC = parcelRequire("kfJSC");


var $1S4f7 = parcelRequire("1S4f7");


var $d7ZU3 = parcelRequire("d7ZU3");

var $dSVmA = parcelRequire("dSVmA");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");


var $e63NX = parcelRequire("e63NX");


var $8QL6C = parcelRequire("8QL6C");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $aRHMp = parcelRequire("aRHMp");


var $kjHnW = parcelRequire("kjHnW");


var $1x9ur = parcelRequire("1x9ur");


var $8UNBX = parcelRequire("8UNBX");


var $7dSFG = parcelRequire("7dSFG");


var $dwC9L = parcelRequire("dwC9L");


var $8e2t2 = parcelRequire("8e2t2");


var $gDXoa = parcelRequire("gDXoa");


var $kG148 = parcelRequire("kG148");


var $afaS6 = parcelRequire("afaS6");

const $21033ca562135cb4$export$fcef64fdeaf6f18a = 'media-content-wrap';
const $21033ca562135cb4$export$2955196e6685aaf4 = 'mediaSinglePlugin.isResizing';
const $21033ca562135cb4$export$ea728aeacba173d1 = 'mediaSinglePlugin.resizing-width';
const $21033ca562135cb4$var$createDropPlaceholder = (intl, nodeViewPortalProviderAPI, dropPlaceholderKey, allowDropLine)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const dropPlaceholder = document.createElement('div');
    const createElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement;
    if (allowDropLine) nodeViewPortalProviderAPI.render(()=>createElement((0, $gmMgo.Provider), {
            value: intl
        }, createElement((0, $dwC9L.default), {
            type: 'single'
        })), dropPlaceholder, dropPlaceholderKey);
    else nodeViewPortalProviderAPI.render(()=>createElement((0, $gmMgo.Provider), {
            value: intl
        }, createElement((0, $dwC9L.default))), dropPlaceholder, dropPlaceholderKey);
    return dropPlaceholder;
};
const $21033ca562135cb4$var$MEDIA_RESOLVED_STATES = [
    'ready',
    'error',
    'cancelled'
];
class $21033ca562135cb4$export$a013ab53254c388d {
    clone() {
        const clonedAt = (performance || Date).now();
        // Prevent double wrapping
        // If clone is repeatedly called, we want to proxy the underlying MediaPluginStateImplementation target, rather than the proxy itself
        // If we proxy the proxy, then calling get in future will need to recursively unwrap proxies to find the original target, which causes performance issues
        // Instead, we check if there is an original target stored on "this", and if so, we use that as the proxy target instead
        return new Proxy(this.originalTarget ?? this, {
            get (target, prop, receiver) {
                if (prop === 'singletonCreatedAt') return clonedAt;
                if (prop === 'originalTarget') return target;
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    subscribeToUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions.push(fn);
    }
    unsubscribeFromUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions = this.uploadInProgressSubscriptions.filter((subscribedFn)=>subscribedFn !== fn);
    }
    async setMediaProvider(mediaProvider) {
        // Prevent someone trying to set the exact same provider twice for performance reasons
        if (this.previousMediaProvider === mediaProvider) return;
        this.previousMediaProvider = mediaProvider;
        if (!mediaProvider) {
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $afaS6.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO disable (not destroy!) pickers until mediaProvider is resolved
        try {
            if (mediaProvider instanceof Promise) this.mediaProvider = await mediaProvider;
            else this.mediaProvider = mediaProvider;
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO [MS-2038]: remove once context api is removed
            // We want to re assign the view and upload configs if they are missing for backwards compatibility
            // as currently integrators can pass context || mediaClientConfig
            if (!this.mediaProvider.viewMediaClientConfig) {
                const viewMediaClientConfig = this.mediaProvider.viewMediaClientConfig;
                if (viewMediaClientConfig) this.mediaProvider.viewMediaClientConfig = viewMediaClientConfig;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($9ir1r)))(this.mediaProvider.viewMediaClientConfig, `MediaProvider promise did not resolve to a valid instance of MediaProvider - ${this.mediaProvider}`);
        } catch (err) {
            const wrappedError = new Error(`Media functionality disabled due to rejected provider: ${err instanceof Error ? err.message : String(err)}`);
            this.errorReporter.captureException(wrappedError);
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $afaS6.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        this.mediaClientConfig = this.mediaProvider.viewMediaClientConfig;
        this.allowsUploads = !!this.mediaProvider.uploadMediaClientConfig;
        const { view: view, allowsUploads: allowsUploads } = this;
        // make sure editable DOM node is mounted
        if (!this.destroyed && view && view.dom.parentNode) // make PM plugin aware of the state change to update UI during 'apply' hook
        view.dispatch(view.state.tr.setMeta((0, $afaS6.stateKey), {
            allowsUploads: allowsUploads
        }));
        if (this.allowsUploads) {
            this.uploadMediaClientConfig = this.mediaProvider.uploadMediaClientConfig;
            if (this.mediaProvider.uploadParams && this.uploadMediaClientConfig) await this.initPickers(this.mediaProvider.uploadParams, (0, $kG148.default));
            else this.destroyPickers();
        } else this.destroyPickers();
    }
    setIsResizing(isResizing) {
        this.isResizing = isResizing;
    }
    setResizingWidth(width) {
        this.resizingWidth = width;
    }
    updateElement() {
        let newElement;
        const selectedContainer = this.selectedMediaContainerNode();
        if (selectedContainer && this.isMediaSchemaNode(selectedContainer)) {
            newElement = this.getDomElement(this.view.domAtPos.bind(this.view));
            if (selectedContainer.type === this.view.state.schema.nodes.mediaSingle) this.currentMaxWidth = (0, $kfJSC.getMaxWidthForNestedNodeNext)(this.view, this.view.state.selection.$anchor.pos) || undefined;
            else this.currentMaxWidth = undefined;
        }
        if (this.element !== newElement) this.element = newElement;
    }
    getDomElement(domAtPos) {
        const { selection: selection } = this.view.state;
        if (!(selection instanceof (0, $ks2lK.NodeSelection))) return;
        if (!this.isMediaSchemaNode(selection.node)) return;
        const node = (0, $8m4tT.findDomRefAtPos)(selection.from, domAtPos);
        if (node) {
            if (!node.childNodes.length) return node.parentNode;
            return node;
        }
        return;
    }
    get contextIdentifierProvider() {
        return this.pluginInjectionApi?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    selectLastAddedMediaNode() {
        // if preventAutoFocusOnUpload is enabled, skip auto-selection and just clear the tracking array
        if (this.mediaOptions?.preventAutoFocusOnUpload && (0, $dh538.fg)('jira_kuro-jjj_disable_auto_focus_after_img_upload')) {
            this.lastAddedMediaSingleFileIds = [];
            return;
        }
        // if lastAddedMediaSingleFileIds is empty exit because there are no added media single nodes to be selected
        if (this.lastAddedMediaSingleFileIds.length !== 0) this.waitForPendingTasks().then(()=>{
            const lastTrackedAddedNode = this.lastAddedMediaSingleFileIds[0];
            // execute selection only if selection did not change after the node has been inserted
            if (lastTrackedAddedNode?.selectionPosition === this.view.state.selection.from) {
                const lastAddedNode = this.mediaNodes.find((node)=>{
                    return node.node.attrs.id === lastTrackedAddedNode.id;
                });
                const lastAddedNodePos = lastAddedNode?.getPos();
                if (lastAddedNodePos) {
                    const { dispatch: dispatch, state: state } = this.view;
                    const tr = state.tr;
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, lastAddedNodePos));
                    if (dispatch) dispatch(tr);
                }
            }
            // reset temp constant after uploads finished
            this.lastAddedMediaSingleFileIds = [];
        });
    }
    setView(view) {
        this.view = view;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const { mediaNodes: mediaNodes } = this;
        mediaNodes.splice(0, mediaNodes.length);
        this.removeOnCloseListener();
        this.destroyPickers();
    }
    async initPickers(uploadParams, Picker) {
        if (this.destroyed || !this.uploadMediaClientConfig) return;
        const { errorReporter: errorReporter, pickers: pickers, pickerPromises: pickerPromises } = this;
        // create pickers if they don't exist, re-use otherwise
        if (!pickers.length) {
            const pickerFacadeConfig = {
                mediaClientConfig: this.uploadMediaClientConfig,
                errorReporter: errorReporter
            };
            if (this.options.customMediaPicker) {
                const customPicker = new Picker('customMediaPicker', pickerFacadeConfig, this.options.customMediaPicker).init();
                pickerPromises.push(customPicker);
                pickers.push(this.customPicker = await customPicker);
            }
            pickers.forEach((picker)=>{
                picker.onNewMedia(this.insertFile);
            });
        }
        // set new upload params for the pickers
        pickers.forEach((picker)=>picker.setUploadParams(uploadParams));
    }
    collectionFromProvider() {
        return this.mediaProvider && this.mediaProvider.uploadParams && this.mediaProvider.uploadParams.collection;
    }
    updateAndDispatch(props) {
        // update plugin state
        Object.keys(props).forEach((_key)=>{
            const key = _key;
            const value = props[key];
            if (value !== undefined) this[key] = value;
        });
        if (this.dispatch) this.dispatch((0, $afaS6.stateKey), {
            ...this
        });
    }
    constructor(_state, options, mediaOptions, _dispatch, pluginInjectionApi){
        this.allowsUploads = false;
        this.mediaClientConfig = void 0;
        this.uploadMediaClientConfig = void 0;
        this.ignoreLinks = false;
        this.waitForMediaUpload = true;
        this.allUploadsFinished = true;
        this.showDropzone = false;
        this.isFullscreen = false;
        this.element = void 0;
        this.layout = 'center';
        this.mediaNodes = [];
        this.options = void 0;
        this.mediaProvider = void 0;
        this.isResizing = false;
        this.resizingWidth = 0;
        this.currentMaxWidth = void 0;
        this.allowInlineImages = false;
        this.uploadInProgressSubscriptions = [];
        this.uploadInProgressSubscriptionsNotified = false;
        // this is only a temporary variable, which gets cleared after the last inserted node has been selected
        this.lastAddedMediaSingleFileIds = [];
        this.view = void 0;
        this.destroyed = false;
        this.errorReporter = void 0;
        // @ts-ignore: private is OK
        this.customPicker = void 0;
        this.removeOnCloseListener = ()=>{};
        this.openMediaPickerBrowser = void 0;
        this.onPopupToggleCallback = ()=>{};
        this.identifierCount = new Map();
        // This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
        // see: trackOutOfScopeIdentifier
        this.outOfEditorScopeIdentifierMap = new Map();
        this.taskManager = new (0, $gDXoa.MediaTaskManager)();
        this.pickers = [];
        this.pickerPromises = [];
        this.editingMediaSinglePos = void 0;
        this.showEditingDialog = void 0;
        this.mediaOptions = void 0;
        this.dispatch = void 0;
        this.pluginInjectionApi = void 0;
        this.singletonCreatedAt = void 0;
        this.previousMediaProvider = void 0;
        this.getMediaOptions = ()=>this.options;
        this.isMediaSchemaNode = ({ type: type })=>{
            const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = this.view.state.schema.nodes;
            if ((0, $8QL6C.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags)) return type === mediaSingle || type === media || type === mediaInline;
            return type === mediaSingle;
        };
        // callback to flag that a node has been inserted
        this.onNodeInserted = (id, selectionPosition)=>{
            this.lastAddedMediaSingleFileIds.unshift({
                id: id,
                selectionPosition: selectionPosition
            });
        };
        /**
     * we insert a new file by inserting a initial state for that file.
     *
     * called when we insert a new file via the picker (connected via pickerfacade)
     */ this.insertFile = (mediaState, onMediaStateChanged, pickerType, insertMediaVia)=>{
            const { state: state } = this.view;
            const editorAnalyticsAPI = this.pluginInjectionApi?.analytics?.actions;
            const mediaStateWithContext = {
                ...mediaState,
                contextId: this.contextIdentifierProvider ? this.contextIdentifierProvider.objectId : undefined
            };
            const collection = mediaState.collection ?? this.collectionFromProvider();
            if (collection === undefined) return;
            // We need to dispatch the change to event dispatcher only for successful files
            if (mediaState.status !== 'error') this.updateAndDispatch({
                allUploadsFinished: false
            });
            if (this.uploadInProgressSubscriptions.length > 0 && !this.uploadInProgressSubscriptionsNotified) {
                this.uploadInProgressSubscriptions.forEach((fn)=>fn(true));
                this.uploadInProgressSubscriptionsNotified = true;
            }
            switch((0, $8UNBX.getMediaNodeInsertionType)(state, this.mediaOptions, mediaStateWithContext.fileMimeType)){
                case 'inline':
                    (0, $1x9ur.insertMediaInlineNode)(editorAnalyticsAPI)(this.view, mediaStateWithContext, collection, this.allowInlineImages, this.getInputMethod(pickerType), insertMediaVia);
                    break;
                case 'block':
                    // read width state right before inserting to get up-to-date and define values
                    const widthPluginState = this.pluginInjectionApi?.width?.sharedState.currentState();
                    (0, $7dSFG.insertMediaSingleNode)(this.view, mediaStateWithContext, this.getInputMethod(pickerType), collection, this.mediaOptions && this.mediaOptions.alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, this.onNodeInserted, insertMediaVia, this.mediaOptions && this.mediaOptions.allowPixelResizing);
                    break;
                case 'group':
                    (0, $1x9ur.insertMediaGroupNode)(editorAnalyticsAPI)(this.view, [
                        mediaStateWithContext
                    ], collection, this.getInputMethod(pickerType), insertMediaVia);
                    break;
            }
            // do events when media state changes
            onMediaStateChanged(this.handleMediaState);
            // handle waiting for upload complete
            const isEndState = (state)=>state.status && $21033ca562135cb4$var$MEDIA_RESOLVED_STATES.indexOf(state.status) !== -1;
            if (!isEndState(mediaStateWithContext)) {
                const uploadingPromise = new Promise((resolve)=>{
                    onMediaStateChanged((newState)=>{
                        // When media item reaches its final state, remove listener and resolve
                        if (isEndState(newState)) resolve(newState);
                    });
                });
                this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                    this.updateAndDispatch({
                        allUploadsFinished: true
                    });
                });
            }
            // refocus the view
            const { view: view } = this;
            if (!view.hasFocus()) view.focus();
            this.waitForPendingTasks().then(()=>{
                if (this.uploadInProgressSubscriptions.length > 0 && this.uploadInProgressSubscriptionsNotified) {
                    this.uploadInProgressSubscriptions.forEach((fn)=>fn(false));
                    this.uploadInProgressSubscriptionsNotified = false;
                }
            });
            this.selectLastAddedMediaNode();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task)=>{
            this.taskManager.addPendingTask(task);
        };
        this.splitMediaGroup = ()=>(0, $kjHnW.splitMediaGroup)(this.view);
        this.onPopupPickerClose = ()=>{
            this.onPopupToggleCallback(false);
        };
        this.showMediaPicker = ()=>{
            if (this.openMediaPickerBrowser) return this.openMediaPickerBrowser();
            this.onPopupToggleCallback(true);
        };
        this.setBrowseFn = (browseFn)=>{
            this.openMediaPickerBrowser = browseFn;
        };
        this.onPopupToggle = (onPopupToggleCallback)=>{
            this.onPopupToggleCallback = onPopupToggleCallback;
        };
        /**
     * Returns a promise that is resolved after all pending operations have been finished.
     * An optional timeout will cause the promise to reject if the operation takes too long
     *
     * NOTE: The promise will resolve even if some of the media have failed to process.
     */ this.waitForPendingTasks = this.taskManager.waitForPendingTasks;
        /**
     * Called from React UI Component when user clicks on "Delete" icon
     * inside of it
     */ this.handleMediaNodeRemoval = (node, getPos)=>{
            let getNode = node;
            if (!getNode) {
                const pos = getPos();
                if (typeof pos !== 'number') return;
                getNode = this.view.state.doc.nodeAt(pos);
            }
            (0, $kjHnW.removeMediaNode)(this.view, getNode, getPos);
        };
        this.getIdentifierKey = (identifier)=>{
            if (identifier.mediaItemType === 'file') return identifier.id;
            else return identifier.dataURI;
        };
        this.trackMediaNodeAddition = (node)=>{
            const identifier = (0, $kjHnW.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 0) this.taskManager.resumePendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count + 1
            });
        };
        this.trackMediaNodeRemoval = (node)=>{
            const identifier = (0, $kjHnW.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 1) this.taskManager.cancelPendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count - 1
            });
        };
        this.isIdentifierInEditorScope = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            // rely on has instead of count > 0 because if the user cuts and pastes the same media
            // the count will temporarily be 0 but the media is still in the scope of editor.
            return !this.outOfEditorScopeIdentifierMap.has(key) && this.identifierCount.has(key);
        };
        /**
     * This is used in on Paste of media, this tracks which if the pasted media originated from a outside the editor
     * i.e. the pasted media was not uplaoded to the current editor.
     * This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
     */ this.trackOutOfScopeIdentifier = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            this.outOfEditorScopeIdentifierMap.set(key, {
                identifier: identifier
            });
        };
        /**
     * Called from React UI Component on componentDidMount
     */ this.handleMediaNodeMount = (node, getPos)=>{
            this.trackMediaNodeAddition(node);
            this.mediaNodes.unshift({
                node: node,
                getPos: getPos
            });
        };
        /**
     * Called from React UI Component on componentWillUnmount and UNSAFE_componentWillReceiveProps
     * when React component's underlying node property is replaced with a new node
     */ this.handleMediaNodeUnmount = (oldNode)=>{
            this.trackMediaNodeRemoval(oldNode);
            this.mediaNodes = this.mediaNodes.filter(({ node: node })=>oldNode !== node);
        };
        this.handleMediaGroupUpdate = (oldNodes, newNodes)=>{
            const addedNodes = newNodes.filter((node)=>oldNodes.every((oldNode)=>oldNode.attrs.id !== node.attrs.id));
            const removedNodes = oldNodes.filter((node)=>newNodes.every((newNode)=>newNode.attrs.id !== node.attrs.id));
            addedNodes.forEach((node)=>{
                this.trackMediaNodeAddition(node);
            });
            removedNodes.forEach((oldNode)=>{
                this.trackMediaNodeRemoval(oldNode);
            });
        };
        this.findMediaNode = (id)=>{
            return $aRHMp.findMediaNode(this, id);
        };
        this.destroyAllPickers = (pickers)=>{
            pickers.forEach((picker)=>picker.destroy());
            this.pickers.splice(0, this.pickers.length);
        };
        this.destroyPickers = ()=>{
            const { pickers: pickers, pickerPromises: pickerPromises } = this;
            // If pickerPromises and pickers are the same length
            // All pickers have resolved and we safely destroy them
            // Otherwise wait for them to resolve then destroy.
            if (pickerPromises.length === pickers.length) this.destroyAllPickers(this.pickers);
            else Promise.all(pickerPromises).then((resolvedPickers)=>this.destroyAllPickers(resolvedPickers));
            this.customPicker = undefined;
        };
        this.getInputMethod = (pickerType)=>{
            switch(pickerType){
                case (0, $d925B.INPUT_METHOD).PICKER_CLOUD:
                    return (0, $d925B.INPUT_METHOD).PICKER_CLOUD;
                case (0, $d925B.INPUT_METHOD).MEDIA_PICKER:
                    return (0, $d925B.INPUT_METHOD).MEDIA_PICKER;
                case 'clipboard':
                    return (0, $d925B.INPUT_METHOD).CLIPBOARD;
                case 'dropzone':
                    return (0, $d925B.INPUT_METHOD).DRAG_AND_DROP;
                case 'browser':
                    return (0, $d925B.INPUT_METHOD).BROWSER;
            }
            return;
        };
        this.updateMediaSingleNodeAttrs = (id, attrs)=>{
            const { view: view } = this;
            if (!view) return;
            return (0, $aRHMp.updateMediaNodeAttrs)(id, attrs)(view.state, view.dispatch);
        };
        this.handleMediaState = (state)=>{
            switch(state.status){
                case 'error':
                    const { uploadErrorHandler: uploadErrorHandler } = this.options;
                    if (uploadErrorHandler) uploadErrorHandler(state);
                    break;
            }
        };
        this.removeSelectedMediaContainer = ()=>{
            const { view: view } = this;
            const selectedNode = this.selectedMediaContainerNode();
            if (!selectedNode) return false;
            const { from: from } = view.state.selection;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $kjHnW.removeMediaNode)(view, selectedNode.firstChild, ()=>from + 1);
            return true;
        };
        this.selectedMediaContainerNode = ()=>{
            let selection;
            if ((0, $1oCLl.expValEquals)('platform_editor_ssr_renderer', 'isEnabled', true)) selection = this.view?.state?.selection;
            else ({ selection: selection } = this.view.state);
            if (selection instanceof (0, $ks2lK.NodeSelection) && this.isMediaSchemaNode(selection.node)) return selection.node;
            return;
        };
        this.handleDrag = (dragState)=>{
            const isActive = dragState === 'enter';
            if (this.showDropzone === isActive) return;
            this.showDropzone = isActive;
            const { dispatch: dispatch, state: state } = this.view;
            const { tr: tr, selection: selection, doc: doc } = state;
            const { media: media, mediaGroup: mediaGroup } = state.schema.nodes;
            // Workaround for wrong upload position
            // @see https://product-fabric.atlassian.net/browse/MEX-2457
            // If the media node is the last selectable item in the current cursor position and it is located within a mediaGroup,
            // we relocate the cursor to the first child of the mediaGroup.
            const pos = Math.max(0, selection.$from.pos - 1);
            const sel = (0, $ks2lK.Selection).findFrom(doc.resolve(pos), -1);
            if (sel && (0, $8m4tT.findSelectedNodeOfType)(media)(sel)) {
                const parent = (0, $8m4tT.findParentNodeOfType)(mediaGroup)(sel);
                if (parent) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, parent.start));
            }
            // Trigger state change to be able to pick it up in the decorations handler
            dispatch(tr);
        };
        this.options = options;
        this.mediaOptions = mediaOptions;
        this.dispatch = _dispatch;
        this.pluginInjectionApi = pluginInjectionApi;
        this.waitForMediaUpload = options.waitForMediaUpload === undefined ? true : options.waitForMediaUpload;
        const { nodes: nodes } = _state.schema;
        (0, (/*@__PURE__*/$parcel$interopDefault($9ir1r)))(nodes.media && (nodes.mediaGroup || nodes.mediaSingle), 'Editor: unable to init media plugin - media or mediaGroup/mediaSingle node absent in schema');
        if (mediaOptions?.syncProvider) this.setMediaProvider(mediaOptions?.syncProvider);
        else if (mediaOptions?.provider) this.setMediaProvider(mediaOptions?.provider);
        if ((0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag')) {
            if (this.mediaOptions?.allowMediaInlineImages) this.allowInlineImages = true;
        } else if ((0, $2YJKQ.mediaInlineImagesEnabled)((0, $8QL6C.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags), this.mediaOptions?.allowMediaInlineImages)) this.allowInlineImages = true;
        this.errorReporter = options.errorReporter || new (0, $dSVmA.ErrorReporter)();
        this.singletonCreatedAt = (performance || Date).now();
    }
}
const $21033ca562135cb4$export$c2bb38320d6be1f2 = (state)=>(0, $afaS6.stateKey).getState(state);
const $21033ca562135cb4$export$ae829ec7b2625219 = (_schema, options, getIntl, pluginInjectionApi, nodeViewPortalProviderAPI, dispatch, mediaOptions)=>{
    const intl = getIntl();
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init (_config, state) {
                return new $21033ca562135cb4$export$a013ab53254c388d(state, options, mediaOptions, dispatch, pluginInjectionApi);
            },
            apply (tr, pluginState) {
                const isResizing = tr.getMeta($21033ca562135cb4$export$2955196e6685aaf4);
                const resizingWidth = tr.getMeta($21033ca562135cb4$export$ea728aeacba173d1);
                const mediaProvider = tr.getMeta((0, $afaS6.stateKey))?.mediaProvider;
                // Yes, I agree with you; this approach, using the clone() fuction, below is horrifying.
                // However, we needed to implement this workaround to solve the singleton Media PluginState.
                // The entire PluginInjectionAPI relies on the following axiom: "A PluginState that reflects a new EditorState.". We can not have the mutable singleton instance for all EditorState.
                // Unfortunately, we can't implement a proper fix for this media state situation. So, we are faking a new object using a Proxy instance.
                let nextPluginState = pluginState;
                if (isResizing !== undefined) {
                    pluginState.setIsResizing(isResizing);
                    nextPluginState = nextPluginState.clone();
                }
                if (mediaProvider) pluginState.setMediaProvider(mediaProvider);
                if (resizingWidth) {
                    pluginState.setResizingWidth(resizingWidth);
                    nextPluginState = nextPluginState.clone();
                }
                // remap editing media single position if we're in collab
                if (typeof pluginState.editingMediaSinglePos === 'number') {
                    pluginState.editingMediaSinglePos = tr.mapping.map(pluginState.editingMediaSinglePos);
                    nextPluginState = nextPluginState.clone();
                }
                const meta = tr.getMeta((0, $afaS6.stateKey));
                if (meta) {
                    const { allowsUploads: allowsUploads } = meta;
                    pluginState.updateAndDispatch({
                        allowsUploads: typeof allowsUploads === 'undefined' ? pluginState.allowsUploads : allowsUploads
                    });
                    nextPluginState = nextPluginState.clone();
                }
                // ACTIONS
                switch(meta?.type){
                    case (0, $8e2t2.ACTIONS).SHOW_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = meta.mediaViewerSelectedMedia;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $8e2t2.ACTIONS).HIDE_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = undefined;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $8e2t2.ACTIONS).TRACK_MEDIA_PASTE:
                        const { identifier: identifier } = meta;
                        const isIdentifierInEditorScope = pluginState.isIdentifierInEditorScope(identifier);
                        if (!isIdentifierInEditorScope && (0, $e63NX.isFileIdentifier)(identifier)) {
                            pluginState.trackOutOfScopeIdentifier(identifier);
                            nextPluginState = pluginState.clone();
                        }
                        break;
                }
                // NOTE: We're not calling passing new state to the Editor, because we depend on the view.state reference
                //       throughout the lifetime of view. We injected the view into the plugin state, because we dispatch()
                //       transformations from within the plugin state (i.e. when adding a new file).
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            for (const transaction of transactions){
                const isSelectionOnMediaInsideMediaSingle = transaction.selectionSet && (0, $8m4tT.isNodeSelection)(transaction.selection) && transaction.selection.node.type === newState.schema.nodes.media && transaction.selection.$anchor.parent.type === newState.schema.nodes.mediaSingle;
                // Note: this causes an additional transaction when selecting a media node
                // through clicking  on it with the cursor.
                if (isSelectionOnMediaInsideMediaSingle) // If a selection has been placed on a media inside a media single,
                // we shift it to the media single parent as other code is opinionated about
                // the selection landing there. In particular the caption insertion and selection
                // action.
                return newState.tr.setSelection((0, $ks2lK.NodeSelection).create(newState.doc, transaction.selection.$from.pos - 1));
            }
            return;
        },
        key: (0, $afaS6.stateKey),
        view: (view)=>{
            const pluginState = $21033ca562135cb4$export$c2bb38320d6be1f2(view.state);
            pluginState.setView(view);
            pluginState.updateElement();
            return {
                update: ()=>{
                    pluginState.updateElement();
                }
            };
        },
        props: {
            decorations: (state)=>{
                // Use this to indicate that the media node is selected
                const mediaNodes = [];
                const { schema: schema, selection: { $anchor: $anchor }, doc: doc } = state;
                // Find any media nodes in the current selection
                if (state.selection instanceof (0, $ks2lK.TextSelection) || state.selection instanceof (0, $ks2lK.AllSelection) || state.selection instanceof (0, $7XFGZ.CellSelection)) doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
                    if (node.type === schema.nodes.media) {
                        mediaNodes.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {}, {
                            type: 'media',
                            selected: true
                        }));
                        return false;
                    }
                    return true;
                });
                else if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
                    const { node: node, $from: $from } = state.selection;
                    if (node.type === schema.nodes.mediaSingle || node.type === schema.nodes.mediaGroup) doc.nodesBetween($from.pos, $from.pos + node.nodeSize, (mediaNode, mediaPos)=>{
                        if (mediaNode.type === schema.nodes.media) {
                            mediaNodes.push((0, $ftzrq.Decoration).node(mediaPos, mediaPos + mediaNode.nodeSize, {}, {
                                type: 'media',
                                selected: true
                            }));
                            return false;
                        }
                        return true;
                    });
                }
                const pluginState = $21033ca562135cb4$export$c2bb38320d6be1f2(state);
                if (!pluginState.showDropzone) return (0, $ftzrq.DecorationSet).create(state.doc, mediaNodes);
                // When a media is already selected
                if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
                    const node = state.selection.node;
                    if (node.type === schema.nodes.mediaSingle) {
                        const deco = (0, $ftzrq.Decoration).node(state.selection.from, state.selection.to, {
                            class: 'richMedia-selected'
                        });
                        return (0, $ftzrq.DecorationSet).create(state.doc, [
                            deco,
                            ...mediaNodes
                        ]);
                    }
                    return (0, $ftzrq.DecorationSet).create(state.doc, mediaNodes);
                }
                let pos = $anchor.pos;
                if ($anchor.parent.type !== schema.nodes.paragraph && $anchor.parent.type !== schema.nodes.codeBlock) pos = (0, $aXG5V.insertPoint)(state.doc, pos, schema.nodes.mediaGroup);
                if (pos === null || pos === undefined) return (0, $ftzrq.DecorationSet).create(state.doc, mediaNodes);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const dropPlaceholderKey = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
                const dropPlaceholders = [
                    (0, $ftzrq.Decoration).widget(pos, ()=>{
                        return $21033ca562135cb4$var$createDropPlaceholder(intl, nodeViewPortalProviderAPI, dropPlaceholderKey, mediaOptions && mediaOptions.allowDropzoneDropLine);
                    }, {
                        key: 'drop-placeholder',
                        destroy: (elem)=>{
                            if (elem instanceof HTMLElement) nodeViewPortalProviderAPI.remove(dropPlaceholderKey);
                        }
                    }),
                    ...mediaNodes
                ];
                return (0, $ftzrq.DecorationSet).create(state.doc, dropPlaceholders);
            },
            nodeViews: options.nodeViews,
            handleTextInput (view, from, to, text) {
                const { selection: selection } = view.state;
                if (text === ' ' && selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'mediaSingle') {
                    const videoControlsWrapperRef = (0, $afaS6.stateKey).getState(view.state)?.element;
                    const videoControls = videoControlsWrapperRef?.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
                    if (videoControls) {
                        const isVideoControl = Array.from(videoControls).some((videoControl)=>{
                            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                            return document.activeElement === videoControl;
                        });
                        if (isVideoControl) return true;
                    }
                }
                $21033ca562135cb4$export$c2bb38320d6be1f2(view.state).splitMediaGroup();
                return false;
            },
            handleClick: (_editorView, _pos, event)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const clickedInsideCaptionPlaceholder = event.target?.closest(`[data-id="${(0, $gAARK.CAPTION_PLACEHOLDER_ID)}"]`);
                // Workaround for Chrome given a regression introduced in prosemirror-view@1.18.6
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/compare/1.18.5...1.18.6
                if (((0, $d7ZU3.browser).chrome || (0, $d7ZU3.browser).safari) && clickedInsideCaptionPlaceholder) return true;
                // Workaound for iOS 16 Caption selection issue
                // @see https://product-fabric.atlassian.net/browse/MEX-2012
                if ((0, $d7ZU3.browser).ios) // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return !!event.target?.closest(`[class="${$21033ca562135cb4$export$fcef64fdeaf6f18a}"]`);
                return false;
            },
            handleDoubleClickOn: (view)=>{
                // Check if media viewer is enabled
                const pluginState = $21033ca562135cb4$export$c2bb38320d6be1f2(view.state);
                if (!pluginState.mediaOptions?.allowImagePreview) return false;
                const isLivePagesViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Double Click support for Media Viewer Nodes
                const maybeMediaNode = (0, $kjHnW.getMediaFromSupportedMediaNodesFromSelection)(view.state);
                if (maybeMediaNode) {
                    // If media type is video, do not open media viewer
                    if (!(0, $kjHnW.isNodeDoubleClickSupportedInLivePagesViewMode)(isLivePagesViewMode, maybeMediaNode)) return false;
                    // Show media viewer
                    pluginInjectionApi?.core.actions.execute(pluginInjectionApi?.media.commands.showMediaViewer(maybeMediaNode.attrs));
                    // Call analytics event
                    pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).OPENED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA_VIEWER,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            nodeType: maybeMediaNode.type.name,
                            inputMethod: (0, $d925B.INPUT_METHOD).DOUBLE_CLICK
                        }
                    });
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                keydown: (view, event)=>{
                    const { selection: selection } = view.state;
                    if (selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'mediaSingle') // handle keydown events for video controls panel to prevent fire of rest prosemirror listeners;
                    {
                        if (event?.target instanceof HTMLElement) {
                            const a11yDefaultKeys = [
                                'Tab',
                                'Space',
                                'Enter',
                                'Shift',
                                'Esc'
                            ];
                            const targetsAndButtons = {
                                button: a11yDefaultKeys,
                                range: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ],
                                combobox: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'Esc'
                                ],
                                slider: [
                                    'Tab',
                                    'Shift',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ]
                            };
                            const targetRole = event.target.role;
                            const targetType = event.target.type;
                            const allowedTargets = targetRole || targetType;
                            // only if targeting interactive elements fe. button, slider, range, dropdown
                            if (allowedTargets && allowedTargets in targetsAndButtons) {
                                const targetRelatedA11YKeys = targetsAndButtons[allowedTargets];
                                const allowedKeys = new Set(targetRelatedA11YKeys);
                                if (allowedKeys.has(event.key) || allowedKeys.has(event.code)) // allow event to bubble to be handled by react handlers
                                return true;
                                else // otherwise focus editor to allow setting gapCursor. (e.g.: arrowRightFromMediaSingle)
                                view.focus();
                            }
                        }
                    }
                    // fire regular prosemirror listeners;
                    return false;
                }
            }
        }
    });
};
module.exports["MEDIA_CONTENT_WRAP_CLASS_NAME"] = $21033ca562135cb4$export$fcef64fdeaf6f18a;
module.exports["MEDIA_PLUGIN_IS_RESIZING_KEY"] = $21033ca562135cb4$export$2955196e6685aaf4;
module.exports["MEDIA_PLUGIN_RESIZING_WIDTH_KEY"] = $21033ca562135cb4$export$ea728aeacba173d1;
module.exports["getMediaPluginState"] = $21033ca562135cb4$export$c2bb38320d6be1f2;
module.exports["createPlugin"] = $21033ca562135cb4$export$ae829ec7b2625219;

});

parcelRegister("7WMqe", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $8m4tT = parcelRequire("8m4tT");

const $19b22c0a8166cbf5$export$d3bec2d7dfd57a94 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, widthType: widthType, layout: layout, snapType: snapType, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $d925B.ACTION_SUBJECT).EMBEDS : (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $d925B.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            widthType: widthType,
            snapType: snapType,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $19b22c0a8166cbf5$export$e861d73ef59c0864 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, layout: layout, validation: validation, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $d925B.ACTION_SUBJECT).EMBEDS : (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $d925B.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            validation: validation,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $19b22c0a8166cbf5$export$3a6429e633acb640 = (previousType, newType, changeFromLocation)=>({
        action: (0, $d925B.ACTION).CHANGED_TYPE,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newType: newType,
            previousType: previousType,
            changeFromLocation: changeFromLocation
        }
    });
function $19b22c0a8166cbf5$export$cc94f10add475df5(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    const parentNodeInfo = (0, $8m4tT.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
module.exports["getMediaResizeAnalyticsEvent"] = $19b22c0a8166cbf5$export$d3bec2d7dfd57a94;
module.exports["getMediaInputResizeAnalyticsEvent"] = $19b22c0a8166cbf5$export$e861d73ef59c0864;
module.exports["getChangeMediaAnalytics"] = $19b22c0a8166cbf5$export$3a6429e633acb640;
module.exports["findChangeFromLocation"] = $19b22c0a8166cbf5$export$cc94f10add475df5;

});

parcelRegister("jA06n", function(module, exports) {

var $kfJSC = parcelRequire("kfJSC");


var $ks2lK = parcelRequire("ks2lK");

const $c2d1b1219786b577$export$de57f5901ccaf81a = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type !== schema.nodes.mediaInline) return;
    const pos = selection.$anchor.pos;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.mediaInline) return;
    return {
        node: node,
        pos: pos
    };
};
const $c2d1b1219786b577$export$61c1b21ac50e0a02 = (editorState)=>{
    return (0, $kfJSC.currentMediaNodeWithPos)(editorState)?.node;
};
const $c2d1b1219786b577$export$948c2f536cfeec35 = (editorState)=>{
    return $c2d1b1219786b577$export$de57f5901ccaf81a(editorState)?.node;
};
const $c2d1b1219786b577$export$ab2a65138449fdc1 = (editorState)=>{
    const node = $c2d1b1219786b577$export$61c1b21ac50e0a02(editorState) || $c2d1b1219786b577$export$948c2f536cfeec35(editorState);
    if (!node) return;
    const borderMark = node.marks.find((m)=>m.type.name === 'border');
    if (!borderMark) return;
    return borderMark.attrs;
};
module.exports["currentMediaInlineNodeWithPos"] = $c2d1b1219786b577$export$de57f5901ccaf81a;
module.exports["currentMediaNode"] = $c2d1b1219786b577$export$61c1b21ac50e0a02;
module.exports["currentMediaInlineNode"] = $c2d1b1219786b577$export$948c2f536cfeec35;
module.exports["currentMediaOrInlineNodeBorderMark"] = $c2d1b1219786b577$export$ab2a65138449fdc1;

});

parcelRegister("2YJKQ", function(module, exports) {
/**
 * Enable media inline images feature based on
 * mediaOptions.featureFlags.mediaInline, mediaOptions.allowMediaInlineImages
 *
 * The reason not using mediaOption as param is because MediaOption is from editor-plugin-media
 * we want to avoid circular deps
 * @param allowMediaInline MediaOptions.featureFlags.mediaInline
 * @param allowMediaInlineImages MediaOptions.allowMediaInlineImages
 * @returns boolean
 */ const $e6c18a94afdc0bd4$export$a82bf3f59adcc8aa = (allowMediaInline, allowMediaInlineImages)=>{
    return allowMediaInline && allowMediaInlineImages;
};
module.exports["mediaInlineImagesEnabled"] = $e6c18a94afdc0bd4$export$a82bf3f59adcc8aa;

});

parcelRegister("1x9ur", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5gVJx = parcelRequire("5gVJx");


var $l6okE = parcelRequire("l6okE");


var $l9G9n = parcelRequire("l9G9n");

var $kTbzR = parcelRequire("kTbzR");

var $7iE7T = parcelRequire("7iE7T");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $9bkD0 = parcelRequire("9bkD0");


var $kjHnW = parcelRequire("kjHnW");


var $8UNBX = parcelRequire("8UNBX");

const $ea3f5008372c31de$export$bbcb7fa97854e414 = (state)=>{
    const node = state.schema.nodes.mediaInline.create({});
    return (0, $8m4tT.canInsert)(state.selection.$to, (0, $5SAOw.Fragment).from(node));
};
const $ea3f5008372c31de$var$getInsertMediaGroupAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    let media = '';
    if (mediaState.length === 1) media = mediaState[0].fileMimeType || 'unknown';
    else if (mediaState.length > 1) media = 'multiple';
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_GROUP,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $ea3f5008372c31de$var$getInsertMediaInlineAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $ea3f5008372c31de$export$226108e53ed56d7b = (mediaState, actionSubjectId, inputMethod, insertMediaVia, reason)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $d925B.ACTION).FAILED_TO_INSERT,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia,
            reason: reason
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
/**
 * Check if current editor selections is a media group or not.
 * @param state Editor state
 */ function $ea3f5008372c31de$var$isSelectionMediaGroup(state) {
    const { schema: schema } = state;
    const selectionParent = state.selection.$anchor.node();
    return selectionParent && selectionParent.type === schema.nodes.mediaGroup;
}
/**
 * Insert a paragraph after if reach the end of doc
 * and there is no media group in the front or selection is a non media block node
 * @param node Node at insertion point
 * @param state Editor state
 */ function $ea3f5008372c31de$var$shouldAppendParagraph(state, node) {
    const { schema: { nodes: { media: media } } } = state;
    const wasMediaNode = node && node.type === media;
    return ((0, $l9G9n.insideTableCell)(state) || (0, $l9G9n.isInListItem)(state) || (0, $kTbzR.isInLayoutColumn)(state) || (0, $l6okE.atTheEndOfDoc)(state) && (!(0, $kjHnW.posOfPrecedingMediaGroup)(state) || (0, $kjHnW.isSelectionNonMediaBlockNode)(state))) && !wasMediaNode;
}
/**
 * Check if node of type has been inserted successfully
 */ const $ea3f5008372c31de$var$hasInsertedNodeOfType = (tr, nodeType)=>{
    let insertPos = -1;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $aXG5V.ReplaceStep)) step.slice.content.forEach((node)=>{
            if (node.type.name === nodeType) insertPos = step.from;
        });
    });
    if (insertPos === -1 || tr.doc.nodeAt(insertPos)?.type.name !== nodeType) return false;
    return true;
};
const $ea3f5008372c31de$export$9996196b21d597d4 = (editorAnalyticsAPI)=>(view, mediaState, collection, allowInlineImages, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { schema: schema, tr: tr } = state;
        const { mediaInline: mediaInline } = schema.nodes;
        // Do nothing if no media found
        if (!mediaInline || !mediaState || collection === undefined) return false;
        const { id: id, dimensions: dimensions, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const mediaInlineAttrs = {
            id: id,
            collection: collection
        };
        if (allowInlineImages && (0, $9bkD0.isImage)(mediaState.fileMimeType)) {
            const { width: width, height: height } = dimensions || {
                width: undefined,
                height: undefined
            };
            const scaledWidth = width ? Math.round(width / scaleFactor) : (0, $5gVJx.DEFAULT_IMAGE_WIDTH);
            const scaledHeight = height ? Math.round(height / scaleFactor) : (0, $5gVJx.DEFAULT_IMAGE_HEIGHT);
            mediaInlineAttrs.width = scaledWidth;
            mediaInlineAttrs.height = scaledHeight;
            mediaInlineAttrs.type = 'image';
            mediaInlineAttrs.alt = fileName;
        }
        const mediaInlineNode = mediaInline.create(mediaInlineAttrs);
        const space = state.schema.text(' ');
        let pos = state.selection.$to.pos;
        // If the selection is inside an empty list item or panel set pos inside paragraph
        if ((0, $8UNBX.isInSupportedInlineImageParent)(state) && (0, $kjHnW.isInsidePotentialEmptyParagraph)(state)) pos = pos + 1;
        const content = (0, $5SAOw.Fragment).from([
            mediaInlineNode,
            space
        ]);
        // Delete the selection if a selection is made
        const deleteRange = $ea3f5008372c31de$var$findDeleteRange(state);
        let payload;
        try {
            if (!deleteRange) tr.insert(pos, content);
            else tr.insert(pos, content).deleteRange(deleteRange.start, deleteRange.end);
            if ($ea3f5008372c31de$var$hasInsertedNodeOfType(tr, 'mediaInline')) payload = $ea3f5008372c31de$var$getInsertMediaInlineAnalytics(mediaState, inputMethod, insertMediaVia);
            else payload = $ea3f5008372c31de$export$226108e53ed56d7b(mediaState, (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia);
        } catch (error) {
            payload = $ea3f5008372c31de$export$226108e53ed56d7b(mediaState, (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.toString());
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        dispatch(tr);
        return true;
    };
const $ea3f5008372c31de$export$9cc886ab7b992a97 = (editorAnalyticsAPI)=>(view, mediaStates, collection, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { tr: tr, schema: schema } = state;
        const { media: media, paragraph: paragraph } = schema.nodes;
        // Do nothing if no media found
        if (!media || !mediaStates.length) return;
        const mediaNodes = $ea3f5008372c31de$var$createMediaFileNodes(mediaStates, collection, media);
        const mediaInsertPos = $ea3f5008372c31de$var$findMediaInsertPos(state);
        const resolvedInsertPos = tr.doc.resolve(mediaInsertPos);
        const parent = resolvedInsertPos.parent;
        const nodeAtInsertionPoint = tr.doc.nodeAt(mediaInsertPos);
        const shouldSplit = !$ea3f5008372c31de$var$isSelectionMediaGroup(state) && (0, $7iE7T.isSupportedInParent)(state, (0, $5SAOw.Fragment).from(state.schema.nodes.mediaGroup.createChecked({}, mediaNodes)));
        const withParagraph = $ea3f5008372c31de$var$shouldAppendParagraph(state, nodeAtInsertionPoint);
        let content = parent.type === schema.nodes.mediaGroup ? mediaNodes // If parent is a mediaGroup do not wrap items again.
         : [
            schema.nodes.mediaGroup.createChecked({}, mediaNodes)
        ];
        if (shouldSplit) {
            content = withParagraph ? content.concat(paragraph.create()) : content;
            // delete the selection or empty paragraph
            const deleteRange = $ea3f5008372c31de$var$findDeleteRange(state);
            if (!deleteRange) tr.insert(mediaInsertPos, content);
            else if (mediaInsertPos <= deleteRange.start) tr.deleteRange(deleteRange.start, deleteRange.end).insert(mediaInsertPos, content);
            else tr.insert(mediaInsertPos, content).deleteRange(deleteRange.start, deleteRange.end);
            editorAnalyticsAPI?.attachAnalyticsEvent($ea3f5008372c31de$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
            dispatch(tr);
            $ea3f5008372c31de$var$setSelectionAfterMediaInsertion(view);
            return;
        }
        // Don't append new paragraph when adding media to a existing mediaGroup
        if (withParagraph && parent.type !== schema.nodes.mediaGroup) content.push(paragraph.create());
        editorAnalyticsAPI?.attachAnalyticsEvent($ea3f5008372c31de$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
        dispatch((0, $8m4tT.safeInsert)((0, $5SAOw.Fragment).fromArray(content), mediaInsertPos)(tr));
    };
const $ea3f5008372c31de$var$createMediaFileNodes = (mediaStates, collection, media)=>{
    const nodes = mediaStates.map((mediaState)=>{
        const { id: id } = mediaState;
        const node = media.create({
            id: id,
            type: 'file',
            collection: collection
        });
        (0, $kjHnW.copyOptionalAttrsFromMediaState)(mediaState, node);
        return node;
    });
    return nodes;
};
/**
 * Find root list node if exist from current selection
 * @param state Editor state
 */ const $ea3f5008372c31de$var$findRootListNode = (state)=>{
    const { schema: { nodes: { bulletList: bulletList, orderedList: orderedList } } } = state;
    return (0, $l9G9n.findFarthestParentNode)((node)=>node.type === bulletList || node.type === orderedList)(state.selection.$from);
};
const $ea3f5008372c31de$export$cbffff148fb3b8a6 = (state)=>{
    const { schema: { nodes: { mediaGroup: mediaGroup, listItem: listItem } } } = state;
    // 1. Check if I am inside a list.
    if ((0, $8m4tT.hasParentNode)((node)=>node.type === listItem)(state.selection)) {
        // 2. Get end position of root list
        const rootListNode = $ea3f5008372c31de$var$findRootListNode(state);
        if (rootListNode) {
            const pos = rootListNode.pos + rootListNode.node.nodeSize;
            // 3. Fint the first location inside the media group
            const nextNode = state.doc.nodeAt(pos);
            if (nextNode && nextNode.type === mediaGroup) return pos + 1;
            return pos;
        }
    }
    return;
};
/**
 * Find insertion point,
 * If it is in a List it will return position to the next block,
 * If there are any media group close it will return this position
 * Otherwise, It will return the respective block given selection.
 * @param content Content to be inserted
 * @param state Editor state
 */ const $ea3f5008372c31de$var$findMediaInsertPos = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    // Check if selection is inside a list.
    const posInList = $ea3f5008372c31de$export$cbffff148fb3b8a6(state);
    if (posInList) // If I have a position in lists, I should return, otherwise I am not inside a list
    return posInList;
    const nearbyMediaGroupPos = (0, $kjHnW.posOfMediaGroupNearby)(state);
    if (nearbyMediaGroupPos && (!(0, $kjHnW.isSelectionNonMediaBlockNode)(state) || $from.pos < nearbyMediaGroupPos && $to.pos < nearbyMediaGroupPos)) return nearbyMediaGroupPos;
    if ((0, $kjHnW.isSelectionNonMediaBlockNode)(state)) return $to.pos;
    if ((0, $l6okE.atTheEndOfBlock)(state)) return $to.pos + 1;
    if ((0, $l6okE.atTheBeginningOfBlock)(state)) return $from.pos - 1;
    return $to.pos;
};
const $ea3f5008372c31de$var$findDeleteRange = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ((0, $kjHnW.posOfParentMediaGroup)(state)) return;
    if (!(0, $kjHnW.isInsidePotentialEmptyParagraph)(state) || (0, $kjHnW.posOfMediaGroupNearby)(state)) return $ea3f5008372c31de$var$range($from.pos, $to.pos);
    return $ea3f5008372c31de$var$range((0, $l6okE.startPositionOfParent)($from) - 1, (0, $l6okE.endPositionOfParent)($to));
};
const $ea3f5008372c31de$var$range = (start, end = start)=>{
    return {
        start: start,
        end: end
    };
};
const $ea3f5008372c31de$var$setSelectionAfterMediaInsertion = (view)=>{
    const { state: state } = view;
    const { doc: doc } = state;
    const mediaPos = (0, $kjHnW.posOfMediaGroupNearby)(state);
    if (!mediaPos) return;
    const $mediaPos = doc.resolve(mediaPos);
    const endOfMediaGroup = (0, $l6okE.endPositionOfParent)($mediaPos);
    if (endOfMediaGroup + 1 >= doc.nodeSize - 1) // if nothing after the media group, fallback to select the newest uploaded media item
    (0, $kTbzR.setNodeSelection)(view, mediaPos);
    else (0, $kTbzR.setTextSelection)(view, endOfMediaGroup + 1);
};
module.exports["canInsertMediaInline"] = $ea3f5008372c31de$export$bbcb7fa97854e414;
module.exports["insertMediaInlineNode"] = $ea3f5008372c31de$export$9996196b21d597d4;
module.exports["insertMediaGroupNode"] = $ea3f5008372c31de$export$9cc886ab7b992a97;

});

parcelRegister("8UNBX", function(module, exports) {

var $2YJKQ = parcelRequire("2YJKQ");


var $l9G9n = parcelRequire("l9G9n");


var $8m4tT = parcelRequire("8m4tT");


var $8QL6C = parcelRequire("8QL6C");


var $dh538 = parcelRequire("dh538");


var $1x9ur = parcelRequire("1x9ur");


var $7dSFG = parcelRequire("7dSFG");


var $9bkD0 = parcelRequire("9bkD0");


var $kjHnW = parcelRequire("kjHnW");

const $81afa53e6bd28fed$export$31a926ac827892a0 = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)([
        state.schema.nodes.listItem
    ])(state.selection);
};
const $81afa53e6bd28fed$export$600118b0ad66a68c = (state, mediaOptions, fileMimeType)=>{
    if ((0, $9bkD0.isImage)(fileMimeType) && (0, $dh538.fg)('platform_editor_media_block_default')) {
        if ((0, $7dSFG.isMediaSingle)(state.schema, fileMimeType)) return 'block';
        return 'group';
    }
    const canInsertInlineNode = (0, $8QL6C.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags) && !(0, $l9G9n.isInEmptyLine)(state) && (!(0, $kjHnW.isInsidePotentialEmptyParagraph)(state) || $81afa53e6bd28fed$export$31a926ac827892a0(state)) && (0, $1x9ur.canInsertMediaInline)(state);
    if ((0, $dh538.fg)('platform_editor_remove_media_inline_feature_flag')) {
        if (mediaOptions?.allowMediaInlineImages) {
            if (canInsertInlineNode && !(0, $9bkD0.isVideo)(fileMimeType)) return 'inline';
        }
    } else if ((0, $2YJKQ.mediaInlineImagesEnabled)((0, $8QL6C.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags), mediaOptions?.allowMediaInlineImages)) {
        if (canInsertInlineNode && !(0, $9bkD0.isVideo)(fileMimeType)) return 'inline';
    }
    if ((0, $7dSFG.isMediaSingle)(state.schema, fileMimeType)) return 'block';
    else if (canInsertInlineNode) return 'inline';
    return 'group';
};
module.exports["isInSupportedInlineImageParent"] = $81afa53e6bd28fed$export$31a926ac827892a0;
module.exports["getMediaNodeInsertionType"] = $81afa53e6bd28fed$export$600118b0ad66a68c;

});

parcelRegister("dwC9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $763f4e3222b5779e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $hbMKq = parcelRequire("hbMKq");


var $8sXMa = parcelRequire("8sXMa");


var $chO1Z = parcelRequire("chO1Z");


var $6fnsQ = parcelRequire("6fnsQ");


var $ljMUG = parcelRequire("ljMUG");

const $763f4e3222b5779e$var$iconWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-icon-accent-blue, ${(0, $hbMKq.hexToRgba)((0, $6fnsQ.B400), 0.4) || (0, $6fnsQ.B400)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-accent-blue-subtle, ${(0, $hbMKq.hexToRgba)((0, $6fnsQ.B300), 0.6) || (0, $6fnsQ.B300)})`,
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-300, 24px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ljMUG.FILE_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $ljMUG.MEDIA_HEIGHT)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $763f4e3222b5779e$var$dropLineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`,
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-025, 2px)"} 0`,
    width: '100%',
    height: '2px'
});
const $763f4e3222b5779e$var$IconWrapperComponent = (props)=>{
    const { intl: intl } = props;
    const { dropPlaceholderLabel: dropPlaceholderLabel } = (0, $8sXMa.dropPlaceholderMessages);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $763f4e3222b5779e$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: intl.formatMessage(dropPlaceholderLabel)
    }));
};
const $763f4e3222b5779e$var$IntlIconWrapper = (0, $gmMgo.default)($763f4e3222b5779e$var$IconWrapperComponent);
var $763f4e3222b5779e$export$2e2bcd8739ae039 = ({ type: type = 'group' })=>type === 'single' ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $763f4e3222b5779e$var$dropLineStyles
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)($763f4e3222b5779e$var$IntlIconWrapper, null);

});

parcelRegister("8e2t2", function(module, exports) {
const $92d44ebb6b4ceb17$export$92a1a3b7554e9387 = {
    SHOW_MEDIA_VIEWER: 'SHOW_MEDIA_VIEWER',
    HIDE_MEDIA_VIEWER: 'HIDE_MEDIA_VIEWER',
    TRACK_MEDIA_PASTE: 'TRACK_MEDIA_PASTE',
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};
module.exports["ACTIONS"] = $92d44ebb6b4ceb17$export$92a1a3b7554e9387;

});

parcelRegister("gDXoa", function(module, exports) {
class $fe49b2cc6c749acc$export$8e609ae1a23dff23 {
    constructor(){
        this.pendingTask = Promise.resolve(null);
        this.taskMap = new Map();
        this.cancelPendingTask = (id)=>{
            const task = this.taskMap.get(id);
            if (task && !task.cancelController.signal.aborted) task.cancelController.abort();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.waitForPendingTasks = async (timeout, lastTask)=>{
            if (lastTask && this.pendingTask === lastTask) return lastTask;
            const chainedPromise = this.pendingTask.then(()=>// Call ourselves to make sure that no new pending tasks have been
                // added before the current promise has resolved.
                this.waitForPendingTasks(undefined, this.pendingTask));
            if (!timeout) return chainedPromise;
            let rejectTimeout;
            const timeoutPromise = new Promise((_resolve, reject)=>{
                rejectTimeout = window.setTimeout(()=>reject(new Error(`Media operations did not finish in ${timeout} ms`)), timeout);
            });
            return Promise.race([
                timeoutPromise,
                chainedPromise.then((value)=>{
                    clearTimeout(rejectTimeout);
                    return value;
                })
            ]);
        };
        this.resumePendingTask = (id)=>{
            const mediaTask = this.taskMap.get(id);
            if (mediaTask && mediaTask.cancelController.signal.aborted) this.addPendingTask(mediaTask.task, id);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task, id)=>{
            let currentTask = task;
            if (id) {
                const cancelController = new AbortController();
                const signal = cancelController.signal;
                this.taskMap.set(id, {
                    task: task,
                    cancelController: cancelController
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                currentTask = new Promise((resolve)=>{
                    task.then(resolve, resolve).finally(()=>{
                        this.taskMap.delete(id);
                    });
                    signal.onabort = ()=>{
                        resolve(null);
                    };
                });
            }
            // Chain the previous promise with a new one for this media item
            const currentPendingTask = this.pendingTask;
            const pendingPromise = ()=>currentPendingTask;
            this.pendingTask = currentTask.then(pendingPromise, pendingPromise);
            return this.pendingTask;
        };
    }
}
module.exports["MediaTaskManager"] = $fe49b2cc6c749acc$export$8e609ae1a23dff23;

});

parcelRegister("kG148", function(module, exports) {

var $6sbVq = parcelRequire("6sbVq");

class $6f80730c27df1d63$export$2e2bcd8739ae039 {
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async init() {
        let picker;
        if (this.pickerType === 'customMediaPicker') picker = this.picker = this.pickerConfig;
        if (!picker) return this;
        picker.on('upload-preview-update', this.handleUploadPreviewUpdate);
        picker.on('upload-end', this.handleReady);
        picker.on('upload-error', this.handleUploadError);
        picker.on('mobile-upload-end', this.handleMobileUploadEnd);
        return this;
    }
    get type() {
        return this.pickerType;
    }
    get mediaPicker() {
        return this.picker;
    }
    destroy() {
        const { picker: picker } = this;
        if (!picker) return;
        picker.removeAllListeners('upload-preview-update');
        picker.removeAllListeners('upload-end');
        picker.removeAllListeners('upload-error');
        this.onStartListeners = [];
        this.onDragListeners = [];
    }
    setUploadParams(params) {
        if (this.picker) this.picker.setUploadParams(params);
    }
    onNewMedia(cb) {
        this.onStartListeners.push(cb);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onDrag(cb) {
        this.onDragListeners.push(cb);
    }
    constructor(pickerType, config, pickerConfig, analyticsName){
        this.config = config;
        this.pickerConfig = pickerConfig;
        this.picker = void 0;
        this.onDragListeners = [];
        this.pickerType = void 0;
        this.onStartListeners = [];
        this.eventListeners = {};
        this.analyticsName = void 0;
        this.erroredFiles = void 0;
        this.handleUploadPreviewUpdate = (event)=>{
            const { file: file, preview: preview } = event;
            //check if upload-error was called before upload-preview-update
            const isErroredFile = this.erroredFiles.has(file.id);
            const { dimensions: dimensions, scaleFactor: scaleFactor } = (0, $6sbVq.isImagePreview)(preview) ? preview : {
                dimensions: undefined,
                scaleFactor: undefined
            };
            const state = {
                id: file.id,
                fileName: file.name,
                fileSize: file.size,
                fileMimeType: file.type,
                collection: file.collectionName,
                dimensions: dimensions,
                scaleFactor: scaleFactor,
                status: isErroredFile ? 'error' : undefined
            };
            this.eventListeners[file.id] = [];
            this.onStartListeners.forEach((cb)=>cb(state, (evt)=>this.subscribeStateChanged(file, evt), this.analyticsName || this.pickerType));
        };
        this.subscribeStateChanged = (file, onStateChanged)=>{
            const subscribers = this.eventListeners[file.id];
            if (!subscribers) return;
            subscribers.push(onStateChanged);
        };
        this.handleUploadError = ({ error: error, fileId: fileId })=>{
            const listeners = this.eventListeners[fileId];
            this.erroredFiles.add(fileId);
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: fileId,
                    status: 'error',
                    error: error && {
                        description: error.description,
                        name: error.name
                    }
                }));
            // remove listeners
            delete this.eventListeners[fileId];
        };
        this.handleMobileUploadEnd = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'mobile-upload-end',
                    fileMimeType: file.type,
                    collection: file.collectionName,
                    publicId: file.publicId
                }));
        };
        this.handleReady = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'ready'
                }));
            // remove listeners
            delete this.eventListeners[file.id];
        };
        this.pickerType = pickerType;
        this.analyticsName = analyticsName;
        this.erroredFiles = new Set();
    }
}
module.exports["default"] = $6f80730c27df1d63$export$2e2bcd8739ae039;

});

parcelRegister("8sXMa", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $e735d19800dd13eb$export$5ac810f4a4d76ba2 = (0, $cgtv4.defineMessages)({
    dropPlaceholderLabel: {
        id: "fabric.editor.dropPlaceholderLabel",
        defaultMessage: "Document"
    }
});
module.exports["dropPlaceholderMessages"] = $e735d19800dd13eb$export$5ac810f4a4d76ba2;

});

parcelRegister("ljMUG", function(module, exports) {
$parcel$export(module.exports, "default", () => $df41847392ab9baa$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $2XqLN = parcelRequire("2XqLN");


var $ffCOo = parcelRequire("ffCOo");


var $bYRk6 = parcelRequire("bYRk6");


var $iHzeA = parcelRequire("iHzeA");


var $kTbzR = parcelRequire("kTbzR");

var $8Doca = parcelRequire("8Doca");


var $7XFGZ = parcelRequire("7XFGZ");


var $1BiXn = parcelRequire("1BiXn");

var $9s7Po = parcelRequire("9s7Po");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $afaS6 = parcelRequire("afaS6");


var $6ZrgC = parcelRequire("6ZrgC");

const $df41847392ab9baa$export$c9940009a015ae53 = 125;
const $df41847392ab9baa$export$e9329f8fc8b15625 = 156;
class $df41847392ab9baa$export$56a8c4089468c01e extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps, nextState) {
        const hasNewViewMediaClientConfig = !this.state.viewMediaClientConfig && nextState.viewMediaClientConfig;
        const hasNewViewAndUploadMediaClientConfig = !this.state.viewAndUploadMediaClientConfig && nextState.viewAndUploadMediaClientConfig;
        if (this.props.selected !== nextProps.selected || this.props.node.attrs.id !== nextProps.node.attrs.id || this.props.node.attrs.collection !== nextProps.node.attrs.collection || this.props.maxDimensions.height !== nextProps.maxDimensions.height || this.props.maxDimensions.width !== nextProps.maxDimensions.width || this.props.contextIdentifierProvider !== nextProps.contextIdentifierProvider || this.props.isLoading !== nextProps.isLoading || this.props.mediaProvider !== nextProps.mediaProvider || (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) && this.props.syncProvider !== nextProps.syncProvider || hasNewViewMediaClientConfig || hasNewViewAndUploadMediaClientConfig) return true;
        return false;
    }
    async componentDidMount() {
        this.handleNewNode(this.props);
        const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
        this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        await this.setViewMediaClientConfig();
    }
    componentWillUnmount() {
        const { node: node } = this.props;
        this.mediaPluginState?.handleMediaNodeUnmount(node);
        if (this.unbindKeyDown && typeof this.unbindKeyDown === 'function') this.unbindKeyDown();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.node.attrs.id !== this.props.node.attrs.id) {
            this.mediaPluginState?.handleMediaNodeUnmount(prevProps.node);
            this.handleNewNode(this.props);
        }
        this.mediaPluginState?.updateElement();
        this.setViewMediaClientConfig();
        // this.videoControlsWrapperRef is null on componentDidMount. We need to wait until it has value
        if (this.videoControlsWrapperRef && this.videoControlsWrapperRef.current) {
            if (!this.mediaPluginState?.videoControlsWrapperRef) {
                this.bindKeydown();
                this.mediaPluginState?.updateAndDispatch({
                    videoControlsWrapperRef: this.videoControlsWrapperRef.current
                });
            }
        }
    }
    bindKeydown() {
        const onKeydown = (event)=>{
            if (event.key === 'Tab') {
                // Add focus trap for controls panel
                let firstElement;
                let lastElement;
                const focusableElements = this.videoControlsWrapperRef?.current?.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
                if (focusableElements && focusableElements.length) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    firstElement = focusableElements[0];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    lastElement = focusableElements[focusableElements.length - 1];
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement?.focus();
                    }
                }
            }
        };
        if (this.videoControlsWrapperRef?.current) this.unbindKeyDown = (0, $fFa3V.bind)(this.videoControlsWrapperRef.current, {
            type: 'keydown',
            listener: onKeydown,
            options: {
                capture: true,
                passive: false
            }
        });
    }
    render() {
        const { node: node, selected: selected, originalDimensions: originalDimensions, isLoading: isLoading, maxDimensions: maxDimensions, mediaOptions: mediaOptions } = this.props;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const { viewMediaClientConfig: viewMediaClientConfig, viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig, contextIdentifierProvider: contextIdentifierProvider } = this.state;
        const { id: id, type: type, collection: collection, url: url, alt: alt } = node.attrs;
        // Check if we have any media client config available (syncProvider, state, or upload config)
        const hasNoMediaClientConfig = !viewMediaClientConfig && ((0, $dh538.fg)('platform_media_video_captions') ? !viewAndUploadMediaClientConfig : true);
        if (isLoading || type !== 'external' && hasNoMediaClientConfig) {
            if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ZrgC.MediaCardWrapper), {
                dimensions: originalDimensions,
                borderWidth: borderMark?.attrs.size,
                selected: selected,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
                    interactionName: "editor-media-card-loading"
                })
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ZrgC.MediaCardWrapper), {
                dimensions: originalDimensions,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
                    interactionName: "editor-media-card-loading"
                })
            });
        }
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = type === 'external' ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        } : {
            id: id,
            mediaItemType: 'file',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            collectionName: collection
        };
        const resolvedViewAndUploadMediaClientConfig = (0, $dh538.fg)('platform_media_video_captions') ? viewAndUploadMediaClientConfig : undefined;
        // mediaClientConfig is not needed for "external" case. So we have to cheat here.
        // there is a possibility mediaClientConfig will be part of a identifier,
        // so this might be not an issue
        const mediaClientConfig = resolvedViewAndUploadMediaClientConfig || viewMediaClientConfig || {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            authProvider: ()=>({})
        };
        const ssr = 'client';
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ZrgC.MediaCardWrapper), {
            dimensions: originalDimensions,
            onContextMenu: this.selectMediaSingle,
            borderWidth: borderMark?.attrs.size,
            selected: selected,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: {
                    [(0, $ffCOo.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1BiXn.default), {
                    mediaClientConfig: mediaClientConfig,
                    resizeMode: "stretchy-fit",
                    dimensions: maxDimensions,
                    originalDimensions: originalDimensions,
                    identifier: identifier,
                    selectable: true,
                    selected: selected,
                    disableOverlay: true,
                    onFullscreenChange: this.onFullscreenChange,
                    onClick: this.selectMediaSingleFromCard,
                    useInlinePlayer: mediaOptions && mediaOptions.allowLazyLoading,
                    isLazy: mediaOptions && mediaOptions.allowLazyLoading,
                    featureFlags: mediaOptions && mediaOptions.featureFlags,
                    contextId: contextId,
                    alt: alt,
                    videoControlsWrapperRef: this.videoControlsWrapperRef,
                    ssr: ssr,
                    mediaSettings: this.getMediaSettings(viewAndUploadMediaClientConfig),
                    onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
                })
            })
        });
    }
    constructor(_props){
        super(_props);
        this.mediaPluginState = void 0;
        this.state = {};
        this.videoControlsWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.unbindKeyDown = null;
        this.setViewMediaClientConfig = async ()=>{
            // mediaProvider is Promise<MediaProvider>, so await it first to get the actual provider
            const mediaProvider = await this.props.mediaProvider;
            if (mediaProvider) {
                const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
                const viewAndUploadMediaClientConfig = mediaProvider.viewAndUploadMediaClientConfig;
                if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) // Only update state if new configs are available and different from current state
                {
                    if (viewMediaClientConfig && this.state.viewMediaClientConfig !== viewMediaClientConfig || viewAndUploadMediaClientConfig && this.state.viewAndUploadMediaClientConfig !== viewAndUploadMediaClientConfig) this.setState({
                        viewMediaClientConfig: viewMediaClientConfig,
                        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
                    });
                } else this.setState({
                    viewMediaClientConfig: viewMediaClientConfig,
                    viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
                });
            }
        };
        this.selectMediaSingleFromCard = ({ event: event })=>{
            this.selectMediaSingle(event);
            // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
            // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if (this.props.isViewOnly && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(this.props.pluginInjectionApi?.toolbar))) event.preventDefault();
        };
        this.selectMediaSingle = (event)=>{
            const propPos = this.props.getPos();
            if (typeof propPos !== 'number') return;
            // NOTE: This does not prevent the link navigation in the editor view mode, .preventDefault is needed (see selectMediaSingleFromCard)
            // Hence it should be removed
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'control')) event.stopPropagation();
            const { state: state } = this.props.view;
            if (event.shiftKey) {
                // don't select text if there is current selection in a table (as this would override selected cells)
                if (state.selection instanceof (0, $7XFGZ.CellSelection)) return;
                (0, $kTbzR.setTextSelection)(this.props.view, state.selection.from < propPos ? state.selection.from : propPos - 1, // + 3 needed for offset of the media inside mediaSingle and cursor to make whole mediaSingle selected
                state.selection.to > propPos ? state.selection.to : propPos + 2);
            } else (0, $kTbzR.setNodeSelection)(this.props.view, propPos - 1);
        };
        this.getMediaSettings = (0, $2XqLN.default)((viewAndUploadMediaClientConfig)=>({
                canUpdateVideoCaptions: (0, $dh538.fg)('platform_media_video_captions') ? !!viewAndUploadMediaClientConfig : false
            }));
        this.onError = (reason)=>{
            this.props.api?.media.actions.handleMediaNodeRenderError(this.props.node, reason);
        };
        this.onFullscreenChange = (fullscreen)=>{
            this.mediaPluginState?.updateAndDispatch({
                isFullscreen: fullscreen
            });
        };
        this.handleNewNode = (props)=>{
            const { node: node } = props;
            this.mediaPluginState?.handleMediaNodeMount(node, ()=>this.props.getPos());
        };
        const { view: view, syncProvider: syncProvider } = this.props;
        this.mediaPluginState = (0, $afaS6.stateKey).getState(view.state);
        // Initialize state from syncProvider (available on both server and client for SSR)
        if ((0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) && syncProvider) this.state = {
            viewMediaClientConfig: syncProvider.viewMediaClientConfig,
            viewAndUploadMediaClientConfig: syncProvider.viewAndUploadMediaClientConfig
        };
    }
}
var $df41847392ab9baa$export$2e2bcd8739ae039 = (0, $8Doca.withImageLoader)($df41847392ab9baa$export$56a8c4089468c01e);
module.exports["MEDIA_HEIGHT"] = $df41847392ab9baa$export$c9940009a015ae53;
module.exports["FILE_WIDTH"] = $df41847392ab9baa$export$e9329f8fc8b15625;

});

parcelRegister("6sbVq", function(module, exports) {
const $fdf60b814604f36e$export$5fe5572478566289 = (preview)=>!!preview.dimensions;
module.exports["isImagePreview"] = $fdf60b814604f36e$export$5fe5572478566289;

});

parcelRegister("6ZrgC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $1OLls = parcelRequire("1OLls");

function $6826f59b447420bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6826f59b447420bd$export$91aa6761f022a358 = 'media-single-node';
const $6826f59b447420bd$var$absoluteDivStyles = {
    name: "19s8nj4",
    styles: "position:absolute;width:100%;height:100%"
};
const $6826f59b447420bd$var$forcedDimensionsStyles = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $6826f59b447420bd$var$pointerCursorStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $6826f59b447420bd$export$d307b3919391b84f = ({ dimensions: dimensions, children: children, selected: selected, borderWidth: borderWidth = 0, onContextMenu: onContextMenu })=>{
    const calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "media-card-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "media-card-wrapper",
        css: $6826f59b447420bd$var$pointerCursorStyle,
        style: {
            borderColor: `var(--custom-palette-color)`,
            borderWidth: `${calculatedBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderStyle: 'solid',
            borderRadius: `${calculatedBorderWidth * 2}px`
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $6826f59b447420bd$var$forcedDimensionsStyles,
        style: {
            paddingBottom: `${dimensions.height / dimensions.width * 100}%`
        },
        onContextMenuCapture: onContextMenu
    }, borderWidth > 0 && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaBorderGapFiller), {
        borderColor: `var(--custom-palette-color)`
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $6826f59b447420bd$var$absoluteDivStyles
    }, children)));
};
module.exports["MediaSingleNodeSelector"] = $6826f59b447420bd$export$91aa6761f022a358;
module.exports["MediaCardWrapper"] = $6826f59b447420bd$export$d307b3919391b84f;

});


$parcel$global.rlb("494Zd")
//# sourceMappingURL=FullPageEditorComponent.8b54b333.js.map
